import FxxlCore             from '@fxxl/core';
import FxxlError            from '@fxxl/error';
import {fxxlLazyloadModule} from '@fxxl/lazyload_module';
import FxxlPageContext      from '@fxxl/page_context';
import {FxxlCompare}        from '@fxxl/compare';
import FxxlGTM              from '@fxxl/gtm';
import jQueryEase           from '@fxxl/jquery_ease';
import {FxxlAccordion}      from '@fxxl/fxxl_accordion';
import {FxxlSideModal}      from '@fxxl/side_modal';
import FxxlShopSuggestion   from '@fxxl/shop_suggestion';
import FxxlNewsletterPopup  from '@fxxl/fxxl_newsletter_popup';
import FxxlCmt              from '@fxxl/cmt';
import FxxlWertgarantie     from '@fxxl/wertgarantie';
/**
 * Polyfill "closest"
 * For browsers that do not support Element.closest(), but carry support for element.matches() (or a prefixed equivalent, meaning IE9+)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);

        return null;
    };
}

// polyfill for RegExp.escape
if (!RegExp.escape){
    RegExp.escape = function(s){
        return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    };
}
new FxxlCore().setDefaultEvents();

/**
 * Jquery ease (easeOutCirc)
 */
jQueryEase();

new FxxlCmt();
/*!
 * Materialize v1.0.0 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*! cash-dom 1.3.5, https://github.com/kenwheeler/cash @license MIT */
(function (factory) {
  window.cash = factory();
})(function () {
  var doc = document,
      win = window,
      ArrayProto = Array.prototype,
      slice = ArrayProto.slice,
      filter = ArrayProto.filter,
      push = ArrayProto.push;

  var noop = function () {},
      isFunction = function (item) {
    // @see https://crbug.com/568448
    return typeof item === typeof noop && item.call;
  },
      isString = function (item) {
    return typeof item === typeof "";
  };

  var idMatch = /^#[\w-]*$/,
      classMatch = /^\.[\w-]*$/,
      htmlMatch = /<.+>/,
      singlet = /^\w+$/;

  function find(selector, context) {
    context = context || doc;
    var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
    return elems;
  }

  var frag;
  function parseHTML(str) {
    if (!frag) {
      frag = doc.implementation.createHTMLDocument(null);
      var base = frag.createElement("base");
      base.href = doc.location.href;
      frag.head.appendChild(base);
    }

    frag.body.innerHTML = str;

    return frag.body.childNodes;
  }

  function onReady(fn) {
    if (doc.readyState !== "loading") {
      fn();
    } else {
      doc.addEventListener("DOMContentLoaded", fn);
    }
  }

  function Init(selector, context) {
    if (!selector) {
      return this;
    }

    // If already a cash collection, don't do any further processing
    if (selector.cash && selector !== win) {
      return selector;
    }

    var elems = selector,
        i = 0,
        length;

    if (isString(selector)) {
      elems = idMatch.test(selector) ?
      // If an ID use the faster getElementById check
      doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ?
      // If HTML, parse it into real elements
      parseHTML(selector) :
      // else use `find`
      find(selector, context);

      // If function, use as shortcut for DOM ready
    } else if (isFunction(selector)) {
      onReady(selector);return this;
    }

    if (!elems) {
      return this;
    }

    // If a single DOM element is passed in or received via ID, return the single element
    if (elems.nodeType || elems === win) {
      this[0] = elems;
      this.length = 1;
    } else {
      // Treat like an array and loop through each item.
      length = this.length = elems.length;
      for (; i < length; i++) {
        this[i] = elems[i];
      }
    }

    return this;
  }

  function cash(selector, context) {
    return new Init(selector, context);
  }

  var fn = cash.fn = cash.prototype = Init.prototype = { // jshint ignore:line
    cash: true,
    length: 0,
    push: push,
    splice: ArrayProto.splice,
    map: ArrayProto.map,
    init: Init
  };

  Object.defineProperty(fn, "constructor", { value: cash });

  cash.parseHTML = parseHTML;
  cash.noop = noop;
  cash.isFunction = isFunction;
  cash.isString = isString;

  cash.extend = fn.extend = function (target) {
    target = target || {};

    var args = slice.call(arguments),
        length = args.length,
        i = 1;

    if (args.length === 1) {
      target = this;
      i = 0;
    }

    for (; i < length; i++) {
      if (!args[i]) {
        continue;
      }
      for (var key in args[i]) {
        if (args[i].hasOwnProperty(key)) {
          target[key] = args[i][key];
        }
      }
    }

    return target;
  };

  function each(collection, callback) {
    var l = collection.length,
        i = 0;

    for (; i < l; i++) {
      if (callback.call(collection[i], collection[i], i, collection) === false) {
        break;
      }
    }
  }

  function matches(el, selector) {
    var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
    return !!m && m.call(el, selector);
  }

  function getCompareFunction(selector) {
    return (
      /* Use browser's `matches` function if string */
      isString(selector) ? matches :
      /* Match a cash element */
      selector.cash ? function (el) {
        return selector.is(el);
      } :
      /* Direct comparison */
      function (el, selector) {
        return el === selector;
      }
    );
  }

  function unique(collection) {
    return cash(slice.call(collection).filter(function (item, index, self) {
      return self.indexOf(item) === index;
    }));
  }

  cash.extend({
    merge: function (first, second) {
      var len = +second.length,
          i = first.length,
          j = 0;

      for (; j < len; i++, j++) {
        first[i] = second[j];
      }

      first.length = i;
      return first;
    },

    each: each,
    matches: matches,
    unique: unique,
    isArray: Array.isArray,
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

  });

  var uid = cash.uid = "_cash" + Date.now();

  function getDataCache(node) {
    return node[uid] = node[uid] || {};
  }

  function setData(node, key, value) {
    return getDataCache(node)[key] = value;
  }

  function getData(node, key) {
    var c = getDataCache(node);
    if (c[key] === undefined) {
      c[key] = node.dataset ? node.dataset[key] : cash(node).attr("data-" + key);
    }
    return c[key];
  }

  function removeData(node, key) {
    var c = getDataCache(node);
    if (c) {
      delete c[key];
    } else if (node.dataset) {
      delete node.dataset[key];
    } else {
      cash(node).removeAttr("data-" + name);
    }
  }

  fn.extend({
    data: function (name, value) {
      if (isString(name)) {
        return value === undefined ? getData(this[0], name) : this.each(function (v) {
          return setData(v, name, value);
        });
      }

      for (var key in name) {
        this.data(key, name[key]);
      }

      return this;
    },

    removeData: function (key) {
      return this.each(function (v) {
        return removeData(v, key);
      });
    }

  });

  var notWhiteMatch = /\S+/g;

  function getClasses(c) {
    return isString(c) && c.match(notWhiteMatch);
  }

  function hasClass(v, c) {
    return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
  }

  function addClass(v, c, spacedName) {
    if (v.classList) {
      v.classList.add(c);
    } else if (spacedName.indexOf(" " + c + " ")) {
      v.className += " " + c;
    }
  }

  function removeClass(v, c) {
    if (v.classList) {
      v.classList.remove(c);
    } else {
      v.className = v.className.replace(c, "");
    }
  }

  fn.extend({
    addClass: function (c) {
      var classes = getClasses(c);

      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";
        each(classes, function (c) {
          addClass(v, c, spacedName);
        });
      }) : this;
    },

    attr: function (name, value) {
      if (!name) {
        return undefined;
      }

      if (isString(name)) {
        if (value === undefined) {
          return this[0] ? this[0].getAttribute ? this[0].getAttribute(name) : this[0][name] : undefined;
        }

        return this.each(function (v) {
          if (v.setAttribute) {
            v.setAttribute(name, value);
          } else {
            v[name] = value;
          }
        });
      }

      for (var key in name) {
        this.attr(key, name[key]);
      }

      return this;
    },

    hasClass: function (c) {
      var check = false,
          classes = getClasses(c);
      if (classes && classes.length) {
        this.each(function (v) {
          check = hasClass(v, classes[0]);
          return !check;
        });
      }
      return check;
    },

    prop: function (name, value) {
      if (isString(name)) {
        return value === undefined ? this[0][name] : this.each(function (v) {
          v[name] = value;
        });
      }

      for (var key in name) {
        this.prop(key, name[key]);
      }

      return this;
    },

    removeAttr: function (name) {
      return this.each(function (v) {
        if (v.removeAttribute) {
          v.removeAttribute(name);
        } else {
          delete v[name];
        }
      });
    },

    removeClass: function (c) {
      if (!arguments.length) {
        return this.attr("class", "");
      }
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        each(classes, function (c) {
          removeClass(v, c);
        });
      }) : this;
    },

    removeProp: function (name) {
      return this.each(function (v) {
        delete v[name];
      });
    },

    toggleClass: function (c, state) {
      if (state !== undefined) {
        return this[state ? "addClass" : "removeClass"](c);
      }
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";
        each(classes, function (c) {
          if (hasClass(v, c)) {
            removeClass(v, c);
          } else {
            addClass(v, c, spacedName);
          }
        });
      }) : this;
    } });

  fn.extend({
    add: function (selector, context) {
      return unique(cash.merge(this, cash(selector, context)));
    },

    each: function (callback) {
      each(this, callback);
      return this;
    },

    eq: function (index) {
      return cash(this.get(index));
    },

    filter: function (selector) {
      if (!selector) {
        return this;
      }

      var comparator = isFunction(selector) ? selector : getCompareFunction(selector);

      return cash(filter.call(this, function (e) {
        return comparator(e, selector);
      }));
    },

    first: function () {
      return this.eq(0);
    },

    get: function (index) {
      if (index === undefined) {
        return slice.call(this);
      }
      return index < 0 ? this[index + this.length] : this[index];
    },

    index: function (elem) {
      var child = elem ? cash(elem)[0] : this[0],
          collection = elem ? this : cash(child).parent().children();
      return slice.call(collection).indexOf(child);
    },

    last: function () {
      return this.eq(-1);
    }

  });

  var camelCase = function () {
    var camelRegex = /(?:^\w|[A-Z]|\b\w)/g,
        whiteSpace = /[\s-_]+/g;
    return function (str) {
      return str.replace(camelRegex, function (letter, index) {
        return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
      }).replace(whiteSpace, "");
    };
  }();

  var getPrefixedProp = function () {
    var cache = {},
        doc = document,
        div = doc.createElement("div"),
        style = div.style;

    return function (prop) {
      prop = camelCase(prop);
      if (cache[prop]) {
        return cache[prop];
      }

      var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
          prefixes = ["webkit", "moz", "ms", "o"],
          props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");

      each(props, function (p) {
        if (p in style) {
          cache[p] = prop = cache[prop] = p;
          return false;
        }
      });

      return cache[prop];
    };
  }();

  cash.prefixedProp = getPrefixedProp;
  cash.camelCase = camelCase;

  fn.extend({
    css: function (prop, value) {
      if (isString(prop)) {
        prop = getPrefixedProp(prop);
        return arguments.length > 1 ? this.each(function (v) {
          return v.style[prop] = value;
        }) : win.getComputedStyle(this[0])[prop];
      }

      for (var key in prop) {
        this.css(key, prop[key]);
      }

      return this;
    }

  });

  function compute(el, prop) {
    return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
  }

  each(["Width", "Height"], function (v) {
    var lower = v.toLowerCase();

    fn[lower] = function () {
      return this[0].getBoundingClientRect()[lower];
    };

    fn["inner" + v] = function () {
      return this[0]["client" + v];
    };

    fn["outer" + v] = function (margins) {
      return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
    };
  });

  function registerEvent(node, eventName, callback) {
    var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
    eventCache[eventName] = eventCache[eventName] || [];
    eventCache[eventName].push(callback);
    node.addEventListener(eventName, callback);
  }

  function removeEvent(node, eventName, callback) {
    var events = getData(node, "_cashEvents"),
        eventCache = events && events[eventName],
        index;

    if (!eventCache) {
      return;
    }

    if (callback) {
      node.removeEventListener(eventName, callback);
      index = eventCache.indexOf(callback);
      if (index >= 0) {
        eventCache.splice(index, 1);
      }
    } else {
      each(eventCache, function (event) {
        node.removeEventListener(eventName, event);
      });
      eventCache = [];
    }
  }

  fn.extend({
    off: function (eventName, callback) {
      return this.each(function (v) {
        return removeEvent(v, eventName, callback);
      });
    },

    on: function (eventName, delegate, callback, runOnce) {
      // jshint ignore:line
      var originalCallback;
      if (!isString(eventName)) {
        for (var key in eventName) {
          this.on(key, delegate, eventName[key]);
        }
        return this;
      }

      if (isFunction(delegate)) {
        callback = delegate;
        delegate = null;
      }

      if (eventName === "ready") {
        onReady(callback);
        return this;
      }

      if (delegate) {
        originalCallback = callback;
        callback = function (e) {
          var t = e.target;
          while (!matches(t, delegate)) {
            if (t === this || t === null) {
              return t = false;
            }

            t = t.parentNode;
          }

          if (t) {
            originalCallback.call(t, e);
          }
        };
      }

      return this.each(function (v) {
        var finalCallback = callback;
        if (runOnce) {
          finalCallback = function () {
            callback.apply(this, arguments);
            removeEvent(v, eventName, finalCallback);
          };
        }
        registerEvent(v, eventName, finalCallback);
      });
    },

    one: function (eventName, delegate, callback) {
      return this.on(eventName, delegate, callback, true);
    },

    ready: onReady,

    /**
     * Modified
     * Triggers browser event
     * @param String eventName
     * @param Object data - Add properties to event object
     */
    trigger: function (eventName, data) {
      if (document.createEvent) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent(eventName, true, false);
        evt = this.extend(evt, data);
        return this.each(function (v) {
          return v.dispatchEvent(evt);
        });
      }
    }

  });

  function encode(name, value) {
    return "&" + encodeURIComponent(name) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
  }

  function getSelectMultiple_(el) {
    var values = [];
    each(el.options, function (o) {
      if (o.selected) {
        values.push(o.value);
      }
    });
    return values.length ? values : null;
  }

  function getSelectSingle_(el) {
    var selectedIndex = el.selectedIndex;
    return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
  }

  function getValue(el) {
    var type = el.type;
    if (!type) {
      return null;
    }
    switch (type.toLowerCase()) {
      case "select-one":
        return getSelectSingle_(el);
      case "select-multiple":
        return getSelectMultiple_(el);
      case "radio":
        return el.checked ? el.value : null;
      case "checkbox":
        return el.checked ? el.value : null;
      default:
        return el.value ? el.value : null;
    }
  }

  fn.extend({
    serialize: function () {
      var query = "";

      each(this[0].elements || this, function (el) {
        if (el.disabled || el.tagName === "FIELDSET") {
          return;
        }
        var name = el.name;
        switch (el.type.toLowerCase()) {
          case "file":
          case "reset":
          case "submit":
          case "button":
            break;
          case "select-multiple":
            var values = getValue(el);
            if (values !== null) {
              each(values, function (value) {
                query += encode(name, value);
              });
            }
            break;
          default:
            var value = getValue(el);
            if (value !== null) {
              query += encode(name, value);
            }
        }
      });

      return query.substr(1);
    },

    val: function (value) {
      if (value === undefined) {
        return getValue(this[0]);
      }

      return this.each(function (v) {
        return v.value = value;
      });
    }

  });

  function insertElement(el, child, prepend) {
    if (prepend) {
      var first = el.childNodes[0];
      el.insertBefore(child, first);
    } else {
      el.appendChild(child);
    }
  }

  function insertContent(parent, child, prepend) {
    var str = isString(child);

    if (!str && child.length) {
      each(child, function (v) {
        return insertContent(parent, v, prepend);
      });
      return;
    }

    each(parent, str ? function (v) {
      return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
    } : function (v, i) {
      return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
    });
  }

  fn.extend({
    after: function (selector) {
      cash(selector).insertAfter(this);
      return this;
    },

    append: function (content) {
      insertContent(this, content);
      return this;
    },

    appendTo: function (parent) {
      insertContent(cash(parent), this);
      return this;
    },

    before: function (selector) {
      cash(selector).insertBefore(this);
      return this;
    },

    clone: function () {
      return cash(this.map(function (v) {
        return v.cloneNode(true);
      }));
    },

    empty: function () {
      this.html("");
      return this;
    },

    html: function (content) {
      if (content === undefined) {
        return this[0].innerHTML;
      }
      var source = content.nodeType ? content[0].outerHTML : content;
      return this.each(function (v) {
        return v.innerHTML = source;
      });
    },

    insertAfter: function (selector) {
      var _this = this;

      cash(selector).each(function (el, i) {
        var parent = el.parentNode,
            sibling = el.nextSibling;
        _this.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
        });
      });

      return this;
    },

    insertBefore: function (selector) {
      var _this2 = this;
      cash(selector).each(function (el, i) {
        var parent = el.parentNode;
        _this2.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
        });
      });
      return this;
    },

    prepend: function (content) {
      insertContent(this, content, true);
      return this;
    },

    prependTo: function (parent) {
      insertContent(cash(parent), this, true);
      return this;
    },

    remove: function () {
      return this.each(function (v) {
        if (!!v.parentNode) {
          return v.parentNode.removeChild(v);
        }
      });
    },

    text: function (content) {
      if (content === undefined) {
        return this[0].textContent;
      }
      return this.each(function (v) {
        return v.textContent = content;
      });
    }

  });

  var docEl = doc.documentElement;

  fn.extend({
    position: function () {
      var el = this[0];
      return {
        left: el.offsetLeft,
        top: el.offsetTop
      };
    },

    offset: function () {
      var rect = this[0].getBoundingClientRect();
      return {
        top: rect.top + win.pageYOffset - docEl.clientTop,
        left: rect.left + win.pageXOffset - docEl.clientLeft
      };
    },

    offsetParent: function () {
      return cash(this[0].offsetParent);
    }

  });

  fn.extend({
    children: function (selector) {
      var elems = [];
      this.each(function (el) {
        push.apply(elems, el.children);
      });
      elems = unique(elems);

      return !selector ? elems : elems.filter(function (v) {
        return matches(v, selector);
      });
    },

    closest: function (selector) {
      if (!selector || this.length < 1) {
        return cash();
      }
      if (this.is(selector)) {
        return this.filter(selector);
      }
      return this.parent().closest(selector);
    },

    is: function (selector) {
      if (!selector) {
        return false;
      }

      var match = false,
          comparator = getCompareFunction(selector);

      this.each(function (el) {
        match = comparator(el, selector);
        return !match;
      });

      return match;
    },

    find: function (selector) {
      if (!selector || selector.nodeType) {
        return cash(selector && this.has(selector).length ? selector : null);
      }

      var elems = [];
      this.each(function (el) {
        push.apply(elems, find(selector, el));
      });

      return unique(elems);
    },

    has: function (selector) {
      var comparator = isString(selector) ? function (el) {
        return find(selector, el).length !== 0;
      } : function (el) {
        return el.contains(selector);
      };

      return this.filter(comparator);
    },

    next: function () {
      return cash(this[0].nextElementSibling);
    },

    not: function (selector) {
      if (!selector) {
        return this;
      }

      var comparator = getCompareFunction(selector);

      return this.filter(function (el) {
        return !comparator(el, selector);
      });
    },

    parent: function () {
      var result = [];

      this.each(function (item) {
        if (item && item.parentNode) {
          result.push(item.parentNode);
        }
      });

      return unique(result);
    },

    parents: function (selector) {
      var last,
          result = [];

      this.each(function (item) {
        last = item;

        while (last && last.parentNode && last !== doc.body.parentNode) {
          last = last.parentNode;

          if (!selector || selector && matches(last, selector)) {
            result.push(last);
          }
        }
      });

      return unique(result);
    },

    prev: function () {
      return cash(this[0].previousElementSibling);
    },

    siblings: function (selector) {
      var collection = this.parent().children(selector),
          el = this[0];

      return collection.filter(function (i) {
        return i !== el;
      });
    }

  });

  return cash;
});
;
var Component = function () {
  /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} el
   * @param {Object} options
   */
  function Component(classDef, el, options) {
    _classCallCheck(this, Component);

    // Display error if el is valid HTML Element
    if (!(el instanceof Element)) {
      console.error(Error(el + ' is not an HTML Element'));
    }

    // If exists, destroy and reinitialize in child
    var ins = classDef.getInstance(el);
    if (!!ins) {
      ins.destroy();
    }

    this.el = el;
    this.$el = cash(el);
  }

  /**
   * Initializes components
   * @param {class} classDef
   * @param {Element | NodeList | jQuery} els
   * @param {Object} options
   */


  _createClass(Component, null, [{
    key: "init",
    value: function init(classDef, els, options) {
      var instances = null;
      if (els instanceof Element) {
        instances = new classDef(els, options);
      } else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
        var instancesArr = [];
        for (var i = 0; i < els.length; i++) {
          instancesArr.push(new classDef(els[i], options));
        }
        instances = instancesArr;
      }

      return instances;
    }
  }]);

  return Component;
}();

; // Required for Meteor package, the use of window prevents export by Meteor
(function (window) {
  if (window.Package) {
    M = {};
  } else {
    window.M = {};
  }

  // Check for jQuery
  M.jQueryLoaded = !!window.jQuery;
})(window);

// AMD
if (typeof define === 'function' && define.amd) {
  define('M', [], function () {
    return M;
  });

  // Common JS
} else if (typeof exports !== 'undefined' && !exports.nodeType) {
  if (typeof module !== 'undefined' && !module.nodeType && module.exports) {
    exports = module.exports = M;
  }
  exports.default = M;
}

M.version = '1.0.0';

M.keys = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};

/**
 * TabPress Keydown handler
 */
M.tabPressed = false;
M.keyDown = false;
var docHandleKeydown = function (e) {
  M.keyDown = true;
  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = true;
  }
};
var docHandleKeyup = function (e) {
  M.keyDown = false;
  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = false;
  }
};
var docHandleFocus = function (e) {
  if (M.keyDown) {
    document.body.classList.add('keyboard-focused');
  }
};
var docHandleBlur = function (e) {
  document.body.classList.remove('keyboard-focused');
};
document.addEventListener('keydown', docHandleKeydown, true);
document.addEventListener('keyup', docHandleKeyup, true);
document.addEventListener('focus', docHandleFocus, true);
document.addEventListener('blur', docHandleBlur, true);

/**
 * Initialize jQuery wrapper for plugin
 * @param {Class} plugin  javascript class
 * @param {string} pluginName  jQuery plugin name
 * @param {string} classRef  Class reference name
 */
M.initializeJqueryWrapper = function (plugin, pluginName, classRef) {
  jQuery.fn[pluginName] = function (methodOrOptions) {
    // Call plugin method if valid method name is passed in
    if (plugin.prototype[methodOrOptions]) {
      var params = Array.prototype.slice.call(arguments, 1);

      // Getter methods
      if (methodOrOptions.slice(0, 3) === 'get') {
        var instance = this.first()[0][classRef];
        return instance[methodOrOptions].apply(instance, params);
      }

      // Void methods
      return this.each(function () {
        var instance = this[classRef];
        instance[methodOrOptions].apply(instance, params);
      });

      // Initialize plugin if options or no argument is passed in
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      plugin.init(this, arguments[0]);
      return this;
    }

    // Return error if an unrecognized  method name is passed in
    jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
  };
};

/**
 * Automatically initialize components
 * @param {Element} context  DOM Element to search within for components
 */
M.AutoInit = function (context) {
  // Use document.body if no context is given
  var root = !!context ? context : document.body;

  var registry = {
    Autocomplete: root.querySelectorAll('.autocomplete:not(.no-autoinit)'),
    Carousel: root.querySelectorAll('.carousel:not(.no-autoinit)'),
    Chips: root.querySelectorAll('.chips:not(.no-autoinit)'),
    Collapsible: root.querySelectorAll('.collapsible:not(.no-autoinit)'),
    Datepicker: root.querySelectorAll('.datepicker:not(.no-autoinit)'),
    Dropdown: root.querySelectorAll('.dropdown-trigger:not(.no-autoinit)'),
    Materialbox: root.querySelectorAll('.materialboxed:not(.no-autoinit)'),
    Modal: root.querySelectorAll('.modal:not(.no-autoinit)'),
    Parallax: root.querySelectorAll('.parallax:not(.no-autoinit)'),
    Pushpin: root.querySelectorAll('.pushpin:not(.no-autoinit)'),
    ScrollSpy: root.querySelectorAll('.scrollspy:not(.no-autoinit)'),
    FormSelect: root.querySelectorAll('select:not(.no-autoinit)'),
    Sidenav: root.querySelectorAll('.sidenav:not(.no-autoinit)'),
    Tabs: root.querySelectorAll('.tabs:not(.no-autoinit)'),
    TapTarget: root.querySelectorAll('.tap-target:not(.no-autoinit)'),
    Timepicker: root.querySelectorAll('.timepicker:not(.no-autoinit)'),
    Tooltip: root.querySelectorAll('.tooltipped:not(.no-autoinit)'),
    FloatingActionButton: root.querySelectorAll('.fixed-action-btn:not(.no-autoinit)')
  };

  for (var pluginName in registry) {
    var plugin = M[pluginName];
    plugin.init(registry[pluginName]);
  }
};

/**
 * Generate approximated selector string for a jQuery object
 * @param {jQuery} obj  jQuery object to be parsed
 * @returns {string}
 */
M.objectSelectorString = function (obj) {
  var tagStr = obj.prop('tagName') || '';
  var idStr = obj.attr('id') || '';
  var classStr = obj.attr('class') || '';
  return (tagStr + idStr + classStr).replace(/\s/g, '');
};

// Unique Random ID
M.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}();

/**
 * Escapes hash from special characters
 * @param {string} hash  String returned from this.hash
 * @returns {string}
 */
M.escapeHash = function (hash) {
  return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, '\\$1');
};

M.elementOrParentIsFixed = function (element) {
  var $element = $(element);
  var $checkElements = $element.add($element.parents());
  var isFixed = false;
  $checkElements.each(function () {
    if ($(this).css('position') === 'fixed') {
      isFixed = true;
      return false;
    }
  });
  return isFixed;
};

/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Escapes hash from special characters
 * @param {Element} container  Container element that acts as the boundary
 * @param {Bounding} bounding  element bounding that is being checked
 * @param {Number} offset  offset from edge that counts as exceeding
 * @returns {Edges}
 */
M.checkWithinContainer = function (container, bounding, offset) {
  var edges = {
    top: false,
    right: false,
    bottom: false,
    left: false
  };

  var containerRect = container.getBoundingClientRect();
  // If body element is smaller than viewport, use viewport height instead.
  var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;

  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;

  var scrolledX = bounding.left - scrollLeft;
  var scrolledY = bounding.top - scrollTop;

  // Check for container and viewport for each edge
  if (scrolledX < containerRect.left + offset || scrolledX < offset) {
    edges.left = true;
  }

  if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) {
    edges.right = true;
  }

  if (scrolledY < containerRect.top + offset || scrolledY < offset) {
    edges.top = true;
  }

  if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) {
    edges.bottom = true;
  }

  return edges;
};

M.checkPossibleAlignments = function (el, container, bounding, offset) {
  var canAlign = {
    top: true,
    right: true,
    bottom: true,
    left: true,
    spaceOnTop: null,
    spaceOnRight: null,
    spaceOnBottom: null,
    spaceOnLeft: null
  };

  var containerAllowsOverflow = getComputedStyle(container).overflow === 'visible';
  var containerRect = container.getBoundingClientRect();
  var containerHeight = Math.min(containerRect.height, window.innerHeight);
  var containerWidth = Math.min(containerRect.width, window.innerWidth);
  var elOffsetRect = el.getBoundingClientRect();

  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;

  var scrolledX = bounding.left - scrollLeft;
  var scrolledYTopEdge = bounding.top - scrollTop;
  var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop;

  // Check for container and viewport for left
  canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);
  if (canAlign.spaceOnRight < 0) {
    canAlign.left = false;
  }

  // Check for container and viewport for Right
  canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;
  if (canAlign.spaceOnLeft < 0) {
    canAlign.right = false;
  }

  // Check for container and viewport for Top
  canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);
  if (canAlign.spaceOnBottom < 0) {
    canAlign.top = false;
  }

  // Check for container and viewport for Bottom
  canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);
  if (canAlign.spaceOnTop < 0) {
    canAlign.bottom = false;
  }

  return canAlign;
};

M.getOverflowParent = function (element) {
  if (element == null) {
    return null;
  }

  if (element === document.body || getComputedStyle(element).overflow !== 'visible') {
    return element;
  }

  return M.getOverflowParent(element.parentElement);
};

/**
 * Gets id of component from a trigger
 * @param {Element} trigger  trigger
 * @returns {string}
 */
M.getIdFromTrigger = function (trigger) {
  var id = trigger.getAttribute('data-target');
  if (!id) {
    id = trigger.getAttribute('href');
    if (id) {
      id = id.slice(1);
    } else {
      id = '';
    }
  }
  return id;
};

/**
 * Multi browser support for document scroll top
 * @returns {Number}
 */
M.getDocumentScrollTop = function () {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};

/**
 * Multi browser support for document scroll left
 * @returns {Number}
 */
M.getDocumentScrollLeft = function () {
  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
};

/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Get time in ms
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @type {function}
 * @return {number}
 */
var getTime = Date.now || function () {
  return new Date().getTime();
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 * `{leading: false}`. To disable execution on the trailing edge, ditto.
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @param {function} func
 * @param {number} wait
 * @param {Object=} options
 * @returns {Function}
 */
M.throttle = function (func, wait, options) {
  var context = void 0,
      args = void 0,
      result = void 0;
  var timeout = null;
  var previous = 0;
  options || (options = {});
  var later = function () {
    previous = options.leading === false ? 0 : getTime();
    timeout = null;
    result = func.apply(context, args);
    context = args = null;
  };
  return function () {
    var now = getTime();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
      context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};
; /*
  v2.2.0
  2017 Julian Garnier
  Released under the MIT license
  */
var $jscomp = { scope: {} };$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, r, p) {
  if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");e != Array.prototype && e != Object.prototype && (e[r] = p.value);
};$jscomp.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : "undefined" != typeof global && null != global ? global : e;
};$jscomp.global = $jscomp.getGlobal(this);$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
$jscomp.initSymbol = function () {
  $jscomp.initSymbol = function () {};$jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
};$jscomp.symbolCounter_ = 0;$jscomp.Symbol = function (e) {
  return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
};
$jscomp.initSymbolIterator = function () {
  $jscomp.initSymbol();var e = $jscomp.global.Symbol.iterator;e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));"function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, { configurable: !0, writable: !0, value: function () {
      return $jscomp.arrayIterator(this);
    } });$jscomp.initSymbolIterator = function () {};
};$jscomp.arrayIterator = function (e) {
  var r = 0;return $jscomp.iteratorPrototype(function () {
    return r < e.length ? { done: !1, value: e[r++] } : { done: !0 };
  });
};
$jscomp.iteratorPrototype = function (e) {
  $jscomp.initSymbolIterator();e = { next: e };e[$jscomp.global.Symbol.iterator] = function () {
    return this;
  };return e;
};$jscomp.array = $jscomp.array || {};$jscomp.iteratorFromArray = function (e, r) {
  $jscomp.initSymbolIterator();e instanceof String && (e += "");var p = 0,
      m = { next: function () {
      if (p < e.length) {
        var u = p++;return { value: r(u, e[u]), done: !1 };
      }m.next = function () {
        return { done: !0, value: void 0 };
      };return m.next();
    } };m[Symbol.iterator] = function () {
    return m;
  };return m;
};
$jscomp.polyfill = function (e, r, p, m) {
  if (r) {
    p = $jscomp.global;e = e.split(".");for (m = 0; m < e.length - 1; m++) {
      var u = e[m];u in p || (p[u] = {});p = p[u];
    }e = e[e.length - 1];m = p[e];r = r(m);r != m && null != r && $jscomp.defineProperty(p, e, { configurable: !0, writable: !0, value: r });
  }
};$jscomp.polyfill("Array.prototype.keys", function (e) {
  return e ? e : function () {
    return $jscomp.iteratorFromArray(this, function (e) {
      return e;
    });
  };
}, "es6-impl", "es3");var $jscomp$this = this;
(function (r) {
  M.anime = r();
})(function () {
  function e(a) {
    if (!h.col(a)) try {
      return document.querySelectorAll(a);
    } catch (c) {}
  }function r(a, c) {
    for (var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++) {
      if (n in a) {
        var k = a[n];c.call(b, k, n, a) && f.push(k);
      }
    }return f;
  }function p(a) {
    return a.reduce(function (a, d) {
      return a.concat(h.arr(d) ? p(d) : d);
    }, []);
  }function m(a) {
    if (h.arr(a)) return a;
    h.str(a) && (a = e(a) || a);return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [a];
  }function u(a, c) {
    return a.some(function (a) {
      return a === c;
    });
  }function C(a) {
    var c = {},
        d;for (d in a) {
      c[d] = a[d];
    }return c;
  }function D(a, c) {
    var d = C(a),
        b;for (b in a) {
      d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
    }return d;
  }function z(a, c) {
    var d = C(a),
        b;for (b in c) {
      d[b] = h.und(a[b]) ? c[b] : a[b];
    }return d;
  }function T(a) {
    a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (a, c, d, k) {
      return c + c + d + d + k + k;
    });var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
    a = parseInt(c[1], 16);var d = parseInt(c[2], 16),
        c = parseInt(c[3], 16);return "rgba(" + a + "," + d + "," + c + ",1)";
  }function U(a) {
    function c(a, c, b) {
      0 > b && (b += 1);1 < b && --b;return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
    }var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a = parseInt(d[1]) / 360;var b = parseInt(d[2]) / 100,
        f = parseInt(d[3]) / 100,
        d = d[4] || 1;if (0 == b) f = b = a = f;else {
      var n = .5 > f ? f * (1 + b) : f + b - f * b,
          k = 2 * f - n,
          f = c(k, n, a + 1 / 3),
          b = c(k, n, a);a = c(k, n, a - 1 / 3);
    }return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
  }function y(a) {
    if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
  }function V(a) {
    if (-1 < a.indexOf("translate") || "perspective" === a) return "px";if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
  }function I(a, c) {
    return h.fnc(a) ? a(c.target, c.id, c.total) : a;
  }function E(a, c) {
    if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
  }function J(a, c) {
    if (h.dom(a) && u(W, c)) return "transform";if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";if (h.dom(a) && "transform" !== c && E(a, c)) return "css";if (null != a[c]) return "object";
  }function X(a, c) {
    var d = V(c),
        d = -1 < c.indexOf("scale") ? 1 : 0 + d;a = a.style.transform;if (!a) return d;for (var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);) {
      f.push(b[1]), n.push(b[2]);
    }a = r(n, function (a, b) {
      return f[b] === c;
    });return a.length ? a[0] : d;
  }function K(a, c) {
    switch (J(a, c)) {case "transform":
        return X(a, c);case "css":
        return E(a, c);case "attribute":
        return a.getAttribute(c);}return a[c] || 0;
  }function L(a, c) {
    var d = /^(\*=|\+=|-=)/.exec(a);if (!d) return a;var b = y(a) || 0;c = parseFloat(c);a = parseFloat(a.replace(d[0], ""));switch (d[0][0]) {case "+":
        return c + a + b;case "-":
        return c - a + b;case "*":
        return c * a + b;}
  }function F(a, c) {
    return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
  }function M(a) {
    a = a.points;for (var c = 0, d, b = 0; b < a.numberOfItems; b++) {
      var f = a.getItem(b);0 < b && (c += F(d, f));d = f;
    }return c;
  }function N(a) {
    if (a.getTotalLength) return a.getTotalLength();switch (a.tagName.toLowerCase()) {case "circle":
        return 2 * Math.PI * a.getAttribute("r");case "rect":
        return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");case "line":
        return F({ x: a.getAttribute("x1"), y: a.getAttribute("y1") }, { x: a.getAttribute("x2"), y: a.getAttribute("y2") });case "polyline":
        return M(a);case "polygon":
        var c = a.points;return M(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));}
  }function Y(a, c) {
    function d(b) {
      b = void 0 === b ? 0 : b;return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
    }var b = d(),
        f = d(-1),
        n = d(1);switch (a.property) {case "x":
        return b.x;case "y":
        return b.y;
      case "angle":
        return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;}
  }function O(a, c) {
    var d = /-?\d*\.?\d+/g,
        b;b = h.pth(a) ? a.totalLength : a;if (h.col(b)) {
      if (h.rgb(b)) {
        var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b = f ? "rgba(" + f[1] + ",1)" : b;
      } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
    } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;b += "";return { original: b, numbers: b.match(d) ? b.match(d).map(Number) : [0], strings: h.str(a) || c ? b.split(d) : [] };
  }function P(a) {
    a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];return r(a, function (a, d, b) {
      return b.indexOf(a) === d;
    });
  }function Z(a) {
    var c = P(a);return c.map(function (a, b) {
      return { target: a, id: b, total: c.length };
    });
  }function aa(a, c) {
    var d = C(c);if (h.arr(a)) {
      var b = a.length;2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = { value: a };
    }return m(a).map(function (a, b) {
      b = b ? 0 : c.delay;a = h.obj(a) && !h.pth(a) ? a : { value: a };h.und(a.delay) && (a.delay = b);return a;
    }).map(function (a) {
      return z(a, d);
    });
  }function ba(a, c) {
    var d = {},
        b;for (b in a) {
      var f = I(a[b], c);h.arr(f) && (f = f.map(function (a) {
        return I(a, c);
      }), 1 === f.length && (f = f[0]));d[b] = f;
    }d.duration = parseFloat(d.duration);d.delay = parseFloat(d.delay);return d;
  }function ca(a) {
    return h.arr(a) ? A.apply(this, a) : Q[a];
  }function da(a, c) {
    var d;return a.tweens.map(function (b) {
      b = ba(b, c);var f = b.value,
          e = K(c.target, a.name),
          k = d ? d.to.original : e,
          k = h.arr(f) ? f[0] : k,
          w = L(h.arr(f) ? f[1] : f, k),
          e = y(w) || y(k) || y(e);b.from = O(k, e);b.to = O(w, e);b.start = d ? d.end : a.offset;b.end = b.start + b.delay + b.duration;b.easing = ca(b.easing);b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;b.isPath = h.pth(f);b.isColor = h.col(b.from.original);b.isColor && (b.round = 1);return d = b;
    });
  }function ea(a, c) {
    return r(p(a.map(function (a) {
      return c.map(function (b) {
        var c = J(a.target, b.name);if (c) {
          var d = da(b, a);b = { type: c, property: b.name, animatable: a, tweens: d, duration: d[d.length - 1].end, delay: d[0].delay };
        } else b = void 0;return b;
      });
    })), function (a) {
      return !h.und(a);
    });
  }function R(a, c, d, b) {
    var f = "delay" === a;return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function (b) {
      return b[a];
    })) : f ? b.delay : d.offset + b.delay + b.duration;
  }function fa(a) {
    var c = D(ga, a),
        d = D(S, a),
        b = Z(a.targets),
        f = [],
        e = z(c, d),
        k;for (k in a) {
      e.hasOwnProperty(k) || "targets" === k || f.push({ name: k, offset: e.offset, tweens: aa(a[k], d) });
    }a = ea(b, f);return z(c, { children: [], animatables: b, animations: a, duration: R("duration", a, c, d), delay: R("delay", a, c, d) });
  }function q(a) {
    function c() {
      return window.Promise && new Promise(function (a) {
        return p = a;
      });
    }function d(a) {
      return g.reversed ? g.duration - a : a;
    }function b(a) {
      for (var b = 0, c = {}, d = g.animations, f = d.length; b < f;) {
        var e = d[b],
            k = e.animatable,
            h = e.tweens,
            n = h.length - 1,
            l = h[n];n && (l = r(h, function (b) {
          return a < b.end;
        })[0] || l);for (var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++) {
          var x = void 0,
              x = l.to.numbers[t],
              q = l.from.numbers[t],
              x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));n.push(x);
        }if (l = h.length) for (m = h[0], w = 0; w < l; w++) {
          p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
        } else m = n[0];ha[e.type](k.target, e.property, m, c, k.id);e.currentValue = m;b++;
      }if (b = Object.keys(c).length) for (d = 0; d < b; d++) {
        H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
      }g.currentTime = a;g.progress = a / g.duration * 100;
    }function f(a) {
      if (g[a]) g[a](g);
    }function e() {
      g.remaining && !0 !== g.remaining && g.remaining--;
    }function k(a) {
      var k = g.duration,
          n = g.offset,
          w = n + g.delay,
          r = g.currentTime,
          x = g.reversed,
          q = d(a);if (g.children.length) {
        var u = g.children,
            v = u.length;
        if (q >= g.currentTime) for (var G = 0; G < v; G++) {
          u[G].seek(q);
        } else for (; v--;) {
          u[v].seek(q);
        }
      }if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");if (q > n && q < k) b(q);else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();f("update");a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
    }a = void 0 === a ? {} : a;var h,
        t,
        l = 0,
        p = null,
        m = c(),
        g = fa(a);g.reset = function () {
      var a = g.direction,
          c = g.loop;g.currentTime = 0;g.progress = 0;g.paused = !0;g.began = !1;g.completed = !1;g.reversed = "reverse" === a;g.remaining = "alternate" === a && 1 === c ? 2 : c;b(0);for (a = g.children.length; a--;) {
        g.children[a].reset();
      }
    };g.tick = function (a) {
      h = a;t || (t = h);k((l + h - t) * q.speed);
    };g.seek = function (a) {
      k(d(a));
    };g.pause = function () {
      var a = v.indexOf(g);-1 < a && v.splice(a, 1);g.paused = !0;
    };g.play = function () {
      g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
    };g.reverse = function () {
      g.reversed = !g.reversed;t = 0;l = d(g.currentTime);
    };g.restart = function () {
      g.pause();
      g.reset();g.play();
    };g.finished = m;g.reset();g.autoplay && g.play();return g;
  }var ga = { update: void 0, begin: void 0, run: void 0, complete: void 0, loop: 1, direction: "normal", autoplay: !0, offset: 0 },
      S = { duration: 1E3, delay: 0, easing: "easeOutElastic", elasticity: 500, round: 0 },
      W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
      H,
      h = { arr: function (a) {
      return Array.isArray(a);
    }, obj: function (a) {
      return -1 < Object.prototype.toString.call(a).indexOf("Object");
    },
    pth: function (a) {
      return h.obj(a) && a.hasOwnProperty("totalLength");
    }, svg: function (a) {
      return a instanceof SVGElement;
    }, dom: function (a) {
      return a.nodeType || h.svg(a);
    }, str: function (a) {
      return "string" === typeof a;
    }, fnc: function (a) {
      return "function" === typeof a;
    }, und: function (a) {
      return "undefined" === typeof a;
    }, hex: function (a) {
      return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)
      );
    }, rgb: function (a) {
      return (/^rgb/.test(a)
      );
    }, hsl: function (a) {
      return (/^hsl/.test(a)
      );
    }, col: function (a) {
      return h.hex(a) || h.rgb(a) || h.hsl(a);
    } },
      A = function () {
    function a(a, d, b) {
      return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
    }return function (c, d, b, f) {
      if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
        var e = new Float32Array(11);if (c !== d || b !== f) for (var k = 0; 11 > k; ++k) {
          e[k] = a(.1 * k, c, b);
        }return function (k) {
          if (c === d && b === f) return k;if (0 === k) return 0;if (1 === k) return 1;for (var h = 0, l = 1; 10 !== l && e[l] <= k; ++l) {
            h += .1;
          }--l;var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1,
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (.001 <= n) {
            for (h = 0; 4 > h; ++h) {
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (0 === n) break;var m = a(l, c, b) - k,
                  l = l - m / n;
            }k = l;
          } else if (0 === n) k = l;else {
            var l = h,
                h = h + .1,
                g = 0;do {
              m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
            } while (1e-7 < Math.abs(n) && 10 > ++g);k = m;
          }return a(k, d, f);
        };
      }
    };
  }(),
      Q = function () {
    function a(a, b) {
      return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
    }var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
        d = { In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], a], Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (b, c) {
        return 1 - a(1 - b, c);
      }], InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (b, c) {
        return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
      }] },
        b = { linear: A(.25, .25, .75, .75) },
        f = {},
        e;for (e in d) {
      f.type = e, d[f.type].forEach(function (a) {
        return function (d, f) {
          b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
        };
      }(f)), f = { type: f.type };
    }return b;
  }(),
      ha = { css: function (a, c, d) {
      return a.style[c] = d;
    }, attribute: function (a, c, d) {
      return a.setAttribute(c, d);
    }, object: function (a, c, d) {
      return a[c] = d;
    }, transform: function (a, c, d, b, f) {
      b[f] || (b[f] = []);b[f].push(c + "(" + d + ")");
    } },
      v = [],
      B = 0,
      ia = function () {
    function a() {
      B = requestAnimationFrame(c);
    }function c(c) {
      var b = v.length;if (b) {
        for (var d = 0; d < b;) {
          v[d] && v[d].tick(c), d++;
        }a();
      } else cancelAnimationFrame(B), B = 0;
    }return a;
  }();q.version = "2.2.0";q.speed = 1;q.running = v;q.remove = function (a) {
    a = P(a);for (var c = v.length; c--;) {
      for (var d = v[c], b = d.animations, f = b.length; f--;) {
        u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
      }
    }
  };q.getValue = K;q.path = function (a, c) {
    var d = h.str(a) ? e(a)[0] : a,
        b = c || 100;return function (a) {
      return { el: d, property: a, totalLength: N(d) * (b / 100) };
    };
  };q.setDashoffset = function (a) {
    var c = N(a);a.setAttribute("stroke-dasharray", c);return c;
  };q.bezier = A;q.easings = Q;q.timeline = function (a) {
    var c = q(a);c.pause();c.duration = 0;c.add = function (d) {
      c.children.forEach(function (a) {
        a.began = !0;a.completed = !0;
      });m(d).forEach(function (b) {
        var d = z(b, D(S, a || {}));d.targets = d.targets || a.targets;b = c.duration;var e = d.offset;d.autoplay = !1;d.direction = c.direction;d.offset = h.und(e) ? b : L(e, b);c.began = !0;c.completed = !0;c.seek(d.offset);d = q(d);d.began = !0;d.completed = !0;d.duration > b && (c.duration = d.duration);c.children.push(d);
      });c.seek(0);c.reset();c.autoplay && c.restart();return c;
    };return c;
  };q.random = function (a, c) {
    return Math.floor(Math.random() * (c - a + 1)) + a;
  };return q;
});
;(function ($, anim) {
  'use strict';

  var _defaults = {
    accordion: true,
    onOpenStart: undefined,
    onOpenEnd: undefined,
    onCloseStart: undefined,
    onCloseEnd: undefined,
    inDuration: 300,
    outDuration: 300
  };

  /**
   * @class
   *
   */

  var Collapsible = function (_Component) {
    _inherits(Collapsible, _Component);

    /**
     * Construct Collapsible instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Collapsible(el, options) {
      _classCallCheck(this, Collapsible);

      var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));

      _this3.el.M_Collapsible = _this3;

      /**
       * Options for the collapsible
       * @member Collapsible#options
       * @prop {Boolean} [accordion=false] - Type of the collapsible
       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
       * @prop {Number} inDuration - Transition in duration in milliseconds.
       * @prop {Number} outDuration - Transition duration in milliseconds.
       */
      _this3.options = $.extend({}, Collapsible.defaults, options);

      // Setup tab indices
      _this3.$headers = _this3.$el.children('li').children('.collapsible-header');
      _this3.$headers.attr('tabindex', 0);

      _this3._setupEventHandlers();

      // Open first active
      var $activeBodies = _this3.$el.children('li.active').children('.collapsible-body');
      if (_this3.options.accordion) {
        // Handle Accordion
        $activeBodies.first().css('display', 'block');
      } else {
        // Handle Expandables
        $activeBodies.css('display', 'block');
      }
      return _this3;
    }

    _createClass(Collapsible, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Collapsible = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this4 = this;

        this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
        this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
        this.el.addEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.addEventListener('keydown', _this4._handleCollapsibleKeydownBound);
        });
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this5 = this;

        this.el.removeEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.removeEventListener('keydown', _this5._handleCollapsibleKeydownBound);
        });
      }

      /**
       * Handle Collapsible Click
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleClick",
      value: function _handleCollapsibleClick(e) {
        var $header = $(e.target).closest('.collapsible-header');
        if (e.target && $header.length) {
          var $collapsible = $header.closest('.collapsible');
          if ($collapsible[0] === this.el) {
            var $collapsibleLi = $header.closest('li');
            var $collapsibleLis = $collapsible.children('li');
            var isActive = $collapsibleLi[0].classList.contains('active');
            var index = $collapsibleLis.index($collapsibleLi);

            if (isActive) {
              this.close(index);
            } else {
              this.open(index);
            }
          }
        }
      }

      /**
       * Handle Collapsible Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleKeydown",
      value: function _handleCollapsibleKeydown(e) {
        if (e.keyCode === 13) {
          this._handleCollapsibleClickBound(e);
        }
      }

      /**
       * Animate in collapsible slide
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "_animateIn",
      value: function _animateIn(index) {
        var _this6 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.collapsible-body');

          anim.remove($body[0]);
          $body.css({
            display: 'block',
            overflow: 'hidden',
            height: 0,
            paddingTop: '',
            paddingBottom: ''
          });

          var pTop = $body.css('padding-top');
          var pBottom = $body.css('padding-bottom');
          var finalHeight = $body[0].scrollHeight;
          $body.css({
            paddingTop: 0,
            paddingBottom: 0
          });

          anim({
            targets: $body[0],
            height: finalHeight,
            paddingTop: pTop,
            paddingBottom: pBottom,
            duration: this.options.inDuration,
            easing: 'easeInOutCubic',
            complete: function (anim) {
              $body.css({
                overflow: '',
                paddingTop: '',
                paddingBottom: '',
                height: ''
              });

              // onOpenEnd callback
              if (typeof _this6.options.onOpenEnd === 'function') {
                _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
              }
            }
          });
        }
      }

      /**
       * Animate out collapsible slide
       * @param {Number} index - 0th index of slide to open
       */

    }, {
      key: "_animateOut",
      value: function _animateOut(index) {
        var _this7 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.collapsible-body');
          anim.remove($body[0]);
          $body.css('overflow', 'hidden');
          anim({
            targets: $body[0],
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            duration: this.options.outDuration,
            easing: 'easeInOutCubic',
            complete: function () {
              $body.css({
                height: '',
                overflow: '',
                padding: '',
                display: ''
              });

              // onCloseEnd callback
              if (typeof _this7.options.onCloseEnd === 'function') {
                _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
              }
            }
          });
        }
      }

      /**
       * Open Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "open",
      value: function open(index) {
        var _this8 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains('active')) {
          // onOpenStart callback
          if (typeof this.options.onOpenStart === 'function') {
            this.options.onOpenStart.call(this, $collapsibleLi[0]);
          }

          // Handle accordion behavior
          if (this.options.accordion) {
            var $collapsibleLis = this.$el.children('li');
            var $activeLis = this.$el.children('li.active');
            $activeLis.each(function (el) {
              var index = $collapsibleLis.index($(el));
              _this8.close(index);
            });
          }

          // Animate in
          $collapsibleLi[0].classList.add('active');
          this._animateIn(index);
        }
      }

      /**
       * Close Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "close",
      value: function close(index) {
        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length && $collapsibleLi[0].classList.contains('active')) {
          // onCloseStart callback
          if (typeof this.options.onCloseStart === 'function') {
            this.options.onCloseStart.call(this, $collapsibleLi[0]);
          }

          // Animate out
          $collapsibleLi[0].classList.remove('active');
          this._animateOut(index);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Collapsible;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Collapsible;
  }(Component);
  M.Collapsible = Collapsible;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Collapsible, 'collapsible', 'M_Collapsible');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    alignment: 'left',
    autoFocus: true,
    constrainWidth: true,
    container: null,
    coverTrigger: true,
    closeOnClick: true,
    hover: false,
    inDuration: 150,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onItemClick: null
  };

  /**
   * @class
   */

  var Dropdown = function (_Component2) {
    _inherits(Dropdown, _Component2);

    function Dropdown(el, options) {
      _classCallCheck(this, Dropdown);

      var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));

      _this9.el.M_Dropdown = _this9;
      Dropdown._dropdowns.push(_this9);

      _this9.id = M.getIdFromTrigger(el);
      _this9.dropdownEl = document.getElementById(_this9.id);
      _this9.$dropdownEl = $(_this9.dropdownEl);

      /**
       * Options for the dropdown
       * @member Dropdown#options
       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
       * @prop {Element} container - Container element to attach dropdown to (optional)
       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
       * @prop {Boolean} [hover=false] - Open dropdown on hover
       * @prop {Number} [inDuration=150] - Duration of open animation in ms
       * @prop {Number} [outDuration=250] - Duration of close animation in ms
       * @prop {Function} onOpenStart - Function called when dropdown starts opening
       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
       * @prop {Function} onCloseStart - Function called when dropdown starts closing
       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
       */
      _this9.options = $.extend({}, Dropdown.defaults, options);

      /**
       * Describes open/close state of dropdown
       * @type {Boolean}
       */
      _this9.isOpen = false;

      /**
       * Describes if dropdown content is scrollable
       * @type {Boolean}
       */
      _this9.isScrollable = false;

      /**
       * Describes if touch moving on dropdown content
       * @type {Boolean}
       */
      _this9.isTouchMoving = false;

      _this9.focusedIndex = -1;
      _this9.filterQuery = [];

      // Move dropdown-content after dropdown-trigger
      if (!!_this9.options.container) {
        $(_this9.options.container).append(_this9.dropdownEl);
      } else {
        _this9.$el.after(_this9.dropdownEl);
      }

      _this9._makeDropdownFocusable();
      _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
      _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
      _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
      _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
      _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
      _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);
      _this9._setupEventHandlers();
      return _this9;
    }

    _createClass(Dropdown, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._resetDropdownStyles();
        this._removeEventHandlers();
        Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);
        this.el.M_Dropdown = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        // Trigger keydown handler
        this.el.addEventListener('keydown', this._handleTriggerKeydownBound);

        // Item click handler
        this.dropdownEl.addEventListener('click', this._handleDropdownClickBound);

        // Hover event handlers
        if (this.options.hover) {
          this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
          this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
          this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
          this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.addEventListener('mouseleave', this._handleMouseLeaveBound);

          // Click event handlers
        } else {
          this._handleClickBound = this._handleClick.bind(this);
          this.el.addEventListener('click', this._handleClickBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('keydown', this._handleTriggerKeydownBound);
        this.dropdownEl.removeEventListener('click', this._handleDropdownClickBound);

        if (this.options.hover) {
          this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
          this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        } else {
          this.el.removeEventListener('click', this._handleClickBound);
        }
      }
    }, {
      key: "_setupTemporaryEventHandlers",
      value: function _setupTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
        document.body.addEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.addEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_removeTemporaryEventHandlers",
      value: function _removeTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
        document.body.removeEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.removeEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_handleClick",
      value: function _handleClick(e) {
        e.preventDefault();
        this.open();
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.open();
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave(e) {
        var toEl = e.toElement || e.relatedTarget;
        var leaveToDropdownContent = !!$(toEl).closest('.dropdown-content').length;
        var leaveToActiveDropdownTrigger = false;

        var $closestTrigger = $(toEl).closest('.dropdown-trigger');
        if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) {
          leaveToActiveDropdownTrigger = true;
        }

        // Close hover dropdown if mouse did not leave to either active dropdown-trigger or dropdown-content
        if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) {
          this.close();
        }
      }
    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        var _this10 = this;

        var $target = $(e.target);
        if (this.options.closeOnClick && $target.closest('.dropdown-content').length && !this.isTouchMoving) {
          // isTouchMoving to check if scrolling on mobile.
          setTimeout(function () {
            _this10.close();
          }, 0);
        } else if ($target.closest('.dropdown-trigger').length || !$target.closest('.dropdown-content').length) {
          setTimeout(function () {
            _this10.close();
          }, 0);
        }
        this.isTouchMoving = false;
      }
    }, {
      key: "_handleTriggerKeydown",
      value: function _handleTriggerKeydown(e) {
        // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
        if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
          e.preventDefault();
          this.open();
        }
      }

      /**
       * Handle Document Touchmove
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentTouchmove",
      value: function _handleDocumentTouchmove(e) {
        var $target = $(e.target);
        if ($target.closest('.dropdown-content').length) {
          this.isTouchMoving = true;
        }
      }

      /**
       * Handle Dropdown Click
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownClick",
      value: function _handleDropdownClick(e) {
        // onItemClick callback
        if (typeof this.options.onItemClick === 'function') {
          var itemEl = $(e.target).closest('li')[0];
          this.options.onItemClick.call(this, itemEl);
        }
      }

      /**
       * Handle Dropdown Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownKeydown",
      value: function _handleDropdownKeydown(e) {
        if (e.which === M.keys.TAB) {
          e.preventDefault();
          this.close();

          // Navigate down dropdown list
        } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
          e.preventDefault();
          var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
          var newFocusedIndex = this.focusedIndex;
          var foundNewIndex = false;
          do {
            newFocusedIndex = newFocusedIndex + direction;

            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
              foundNewIndex = true;
              break;
            }
          } while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);

          if (foundNewIndex) {
            this.focusedIndex = newFocusedIndex;
            this._focusFocusedItem();
          }

          // ENTER selects choice on focused item
        } else if (e.which === M.keys.ENTER && this.isOpen) {
          // Search for <a> and <button>
          var focusedElement = this.dropdownEl.children[this.focusedIndex];
          var $activatableElement = $(focusedElement).find('a, button').first();

          // Click a or button tag if exists, otherwise click li tag
          if (!!$activatableElement.length) {
            $activatableElement[0].click();
          } else if (!!focusedElement) {
            focusedElement.click();
          }

          // Close dropdown on ESC
        } else if (e.which === M.keys.ESC && this.isOpen) {
          e.preventDefault();
          this.close();
        }

        // CASE WHEN USER TYPE LETTERS
        var letter = String.fromCharCode(e.which).toLowerCase(),
            nonLetters = [9, 13, 27, 38, 40];
        if (letter && nonLetters.indexOf(e.which) === -1) {
          this.filterQuery.push(letter);

          var string = this.filterQuery.join(''),
              newOptionEl = $(this.dropdownEl).find('li').filter(function (el) {
            return $(el).text().toLowerCase().indexOf(string) === 0;
          })[0];

          if (newOptionEl) {
            this.focusedIndex = $(newOptionEl).index();
            this._focusFocusedItem();
          }
        }

        this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_resetFilterQuery",
      value: function _resetFilterQuery() {
        this.filterQuery = [];
      }
    }, {
      key: "_resetDropdownStyles",
      value: function _resetDropdownStyles() {
        this.$dropdownEl.css({
          display: '',
          width: '',
          height: '',
          left: '',
          top: '',
          'transform-origin': '',
          transform: '',
          opacity: ''
        });
      }
    }, {
      key: "_makeDropdownFocusable",
      value: function _makeDropdownFocusable() {
        // Needed for arrow key navigation
        this.dropdownEl.tabIndex = 0;

        // Only set tabindex if it hasn't been set by user
        $(this.dropdownEl).children().each(function (el) {
          if (!el.getAttribute('tabindex')) {
            el.setAttribute('tabindex', 0);
          }
        });
      }
    }, {
      key: "_focusFocusedItem",
      value: function _focusFocusedItem() {
        if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) {
          this.dropdownEl.children[this.focusedIndex].focus();
        }
      }
    }, {
      key: "_getDropdownPosition",
      value: function _getDropdownPosition() {
        var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
        var triggerBRect = this.el.getBoundingClientRect();
        var dropdownBRect = this.dropdownEl.getBoundingClientRect();

        var idealHeight = dropdownBRect.height;
        var idealWidth = dropdownBRect.width;
        var idealXPos = triggerBRect.left - dropdownBRect.left;
        var idealYPos = triggerBRect.top - dropdownBRect.top;

        var dropdownBounds = {
          left: idealXPos,
          top: idealYPos,
          height: idealHeight,
          width: idealWidth
        };

        // Countainer here will be closest ancestor with overflow: hidden
        var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;

        var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);

        var verticalAlignment = 'top';
        var horizontalAlignment = this.options.alignment;
        idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height;

        // Reset isScrollable
        this.isScrollable = false;

        if (!alignments.top) {
          if (alignments.bottom) {
            verticalAlignment = 'bottom';
          } else {
            this.isScrollable = true;

            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
              verticalAlignment = 'bottom';
              idealHeight += alignments.spaceOnTop;
              idealYPos -= alignments.spaceOnTop;
            } else {
              idealHeight += alignments.spaceOnBottom;
            }
          }
        }

        // If preferred horizontal alignment is possible
        if (!alignments[horizontalAlignment]) {
          var oppositeAlignment = horizontalAlignment === 'left' ? 'right' : 'left';
          if (alignments[oppositeAlignment]) {
            horizontalAlignment = oppositeAlignment;
          } else {
            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnLeft > alignments.spaceOnRight) {
              horizontalAlignment = 'right';
              idealWidth += alignments.spaceOnLeft;
              idealXPos -= alignments.spaceOnLeft;
            } else {
              horizontalAlignment = 'left';
              idealWidth += alignments.spaceOnRight;
            }
          }
        }

        if (verticalAlignment === 'bottom') {
          idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
        }
        if (horizontalAlignment === 'right') {
          idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
        }
        return {
          x: idealXPos,
          y: idealYPos,
          verticalAlignment: verticalAlignment,
          horizontalAlignment: horizontalAlignment,
          height: idealHeight,
          width: idealWidth
        };
      }

      /**
       * Animate in dropdown
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this11 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: [0, 1],
            easing: 'easeOutQuad'
          },
          scaleX: [0.3, 1],
          scaleY: [0.3, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuint',
          complete: function (anim) {
            if (_this11.options.autoFocus) {
              _this11.dropdownEl.focus();
            }

            // onOpenEnd callback
            if (typeof _this11.options.onOpenEnd === 'function') {
              _this11.options.onOpenEnd.call(_this11, _this11.el);
            }
          }
        });
      }

      /**
       * Animate out dropdown
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this12 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: 0,
            easing: 'easeOutQuint'
          },
          scaleX: 0.3,
          scaleY: 0.3,
          duration: this.options.outDuration,
          easing: 'easeOutQuint',
          complete: function (anim) {
            _this12._resetDropdownStyles();

            // onCloseEnd callback
            if (typeof _this12.options.onCloseEnd === 'function') {
              _this12.options.onCloseEnd.call(_this12, _this12.el);
            }
          }
        });
      }

      /**
       * Place dropdown
       */

    }, {
      key: "_placeDropdown",
      value: function _placeDropdown() {
        // Set width before calculating positionInfo
        var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
        this.dropdownEl.style.width = idealWidth + 'px';

        var positionInfo = this._getDropdownPosition();
        this.dropdownEl.style.left = positionInfo.x + 'px';
        this.dropdownEl.style.top = positionInfo.y + 'px';
        this.dropdownEl.style.height = positionInfo.height + 'px';
        this.dropdownEl.style.width = positionInfo.width + 'px';
        this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === 'left' ? '0' : '100%') + " " + (positionInfo.verticalAlignment === 'top' ? '0' : '100%');
      }

      /**
       * Open Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }
        this.isOpen = true;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Reset styles
        this._resetDropdownStyles();
        this.dropdownEl.style.display = 'block';

        this._placeDropdown();
        this._animateIn();
        this._setupTemporaryEventHandlers();
      }

      /**
       * Close Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }
        this.isOpen = false;
        this.focusedIndex = -1;

        // onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this._animateOut();
        this._removeTemporaryEventHandlers();

        if (this.options.autoFocus) {
          this.el.focus();
        }
      }

      /**
       * Recalculate dimensions
       */

    }, {
      key: "recalculateDimensions",
      value: function recalculateDimensions() {
        if (this.isOpen) {
          this.$dropdownEl.css({
            width: '',
            height: '',
            left: '',
            top: '',
            'transform-origin': ''
          });
          this._placeDropdown();
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Dropdown;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Dropdown;
  }(Component);

  /**
   * @static
   * @memberof Dropdown
   */


  Dropdown._dropdowns = [];

  M.Dropdown = Dropdown;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Dropdown, 'dropdown', 'M_Dropdown');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    opacity: 0.5,
    inDuration: 250,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true,
    dismissible: true,
    startingTop: '4%',
    endingTop: '10%'
  };

  /**
   * @class
   *
   */

  var Modal = function (_Component3) {
    _inherits(Modal, _Component3);

    /**
     * Construct Modal instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Modal(el, options) {
      _classCallCheck(this, Modal);

      var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));

      _this13.el.M_Modal = _this13;

      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=250] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before modal is opened
       * @prop {Function} onOpenEnd - Callback function called after modal is opened
       * @prop {Function} onCloseStart - Callback function called before modal is closed
       * @prop {Function} onCloseEnd - Callback function called after modal is closed
       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
       * @prop {String} [startingTop='4%'] - startingTop
       * @prop {String} [endingTop='10%'] - endingTop
       */
      _this13.options = $.extend({}, Modal.defaults, options);

      /**
       * Describes open/close state of modal
       * @type {Boolean}
       */
      _this13.isOpen = false;

      _this13.id = _this13.$el.attr('id');
      _this13._openingTrigger = undefined;
      _this13.$overlay = $('<div class="modal-overlay"></div>');
      _this13.el.tabIndex = 0;
      _this13._nthModalOpened = 0;

      Modal._count++;
      _this13._setupEventHandlers();
      return _this13;
    }

    _createClass(Modal, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        Modal._count--;
        this._removeEventHandlers();
        this.el.removeAttribute('style');
        this.$overlay.remove();
        this.el.M_Modal = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
        this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);

        if (Modal._count === 1) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }
        this.$overlay[0].addEventListener('click', this._handleOverlayClickBound);
        this.el.addEventListener('click', this._handleModalCloseClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Modal._count === 0) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
        this.$overlay[0].removeEventListener('click', this._handleOverlayClickBound);
        this.el.removeEventListener('click', this._handleModalCloseClickBound);
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.modal-trigger');
        if ($trigger.length) {
          var modalId = M.getIdFromTrigger($trigger[0]);
          var modalInstance = document.getElementById(modalId).M_Modal;
          if (modalInstance) {
            modalInstance.open($trigger);
          }
          e.preventDefault();
        }
      }

      /**
       * Handle Overlay Click
       */

    }, {
      key: "_handleOverlayClick",
      value: function _handleOverlayClick() {
        if (this.options.dismissible) {
          this.close();
        }
      }

      /**
       * Handle Modal Close Click
       * @param {Event} e
       */

    }, {
      key: "_handleModalCloseClick",
      value: function _handleModalCloseClick(e) {
        var $closeTrigger = $(e.target).closest('.modal-close');
        if ($closeTrigger.length) {
          this.close();
        }
      }

      /**
       * Handle Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleKeydown",
      value: function _handleKeydown(e) {
        // ESC key
        if (e.keyCode === 27 && this.options.dismissible) {
          this.close();
        }
      }

      /**
       * Handle Focus
       * @param {Event} e
       */

    }, {
      key: "_handleFocus",
      value: function _handleFocus(e) {
        // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
        if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) {
          this.el.focus();
        }
      }

      /**
       * Animate in modal
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this14 = this;

        // Set initial styles
        $.extend(this.el.style, {
          display: 'block',
          opacity: 0
        });
        $.extend(this.$overlay[0].style, {
          display: 'block',
          opacity: 0
        });

        // Animate overlay
        anim({
          targets: this.$overlay[0],
          opacity: this.options.opacity,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });

        // Define modal animation options
        var enterAnimOptions = {
          targets: this.el,
          duration: this.options.inDuration,
          easing: 'easeOutCubic',
          // Handle modal onOpenEnd callback
          complete: function () {
            if (typeof _this14.options.onOpenEnd === 'function') {
              _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
            }
          }
        };

        // Bottom sheet animation
        if (this.el.classList.contains('bottom-sheet')) {
          $.extend(enterAnimOptions, {
            bottom: 0,
            opacity: 1
          });
          anim(enterAnimOptions);

          // Normal modal animation
        } else {
          $.extend(enterAnimOptions, {
            top: [this.options.startingTop, this.options.endingTop],
            opacity: 1,
            scaleX: [0.8, 1],
            scaleY: [0.8, 1]
          });
          anim(enterAnimOptions);
        }
      }

      /**
       * Animate out modal
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this15 = this;

        // Animate overlay
        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuart'
        });

        // Define modal animation options
        var exitAnimOptions = {
          targets: this.el,
          duration: this.options.outDuration,
          easing: 'easeOutCubic',
          // Handle modal ready callback
          complete: function () {
            _this15.el.style.display = 'none';
            _this15.$overlay.remove();

            // Call onCloseEnd callback
            if (typeof _this15.options.onCloseEnd === 'function') {
              _this15.options.onCloseEnd.call(_this15, _this15.el);
            }
          }
        };

        // Bottom sheet animation
        if (this.el.classList.contains('bottom-sheet')) {
          $.extend(exitAnimOptions, {
            bottom: '-100%',
            opacity: 0
          });
          anim(exitAnimOptions);

          // Normal modal animation
        } else {
          $.extend(exitAnimOptions, {
            top: [this.options.endingTop, this.options.startingTop],
            opacity: 0,
            scaleX: 0.8,
            scaleY: 0.8
          });
          anim(exitAnimOptions);
        }
      }

      /**
       * Open Modal
       * @param {cash} [$trigger]
       */

    }, {
      key: "open",
      value: function open($trigger) {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        Modal._modalsOpen++;
        this._nthModalOpened = Modal._modalsOpen;

        // Set Z-Index based on number of currently open modals
        this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
        this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1;

        // Set opening trigger, undefined indicates modal was opened by javascript
        this._openingTrigger = !!$trigger ? $trigger[0] : undefined;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el, this._openingTrigger);
        }

        if (this.options.preventScrolling) {
          if (document.body && document.body.clientWidth && document.documentElement && document.documentElement.clientWidth) {
            var scrollbarwidth = window.innerWidth - document.documentElement.clientWidth;
            if (scrollbarwidth) {
              document.body.style.paddingRight = scrollbarwidth + 'px';
            }
          }
          document.body.style.overflow = 'hidden';
        }

        this.el.classList.add('open');
        this.el.insertAdjacentElement('afterend', this.$overlay[0]);

        if (this.options.dismissible) {
          this._handleKeydownBound = this._handleKeydown.bind(this);
          this._handleFocusBound = this._handleFocus.bind(this);
          document.addEventListener('keydown', this._handleKeydownBound);
          document.addEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);
        this._animateIn();

        // Focus modal
        this.el.focus();

        return this;
      }

      /**
       * Close Modal
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        Modal._modalsOpen--;
        this._nthModalOpened = 0;

        // Call onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this.el.classList.remove('open');

        // Enable body scrolling only if there are no more modals open.
        if (Modal._modalsOpen === 0) {
          document.body.style.paddingRight = '';
          document.body.style.overflow = '';
        }

        if (this.options.dismissible) {
          document.removeEventListener('keydown', this._handleKeydownBound);
          document.removeEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);
        this._animateOut();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Modal;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Modal;
  }(Component);

  /**
   * @static
   * @memberof Modal
   */


  Modal._modalsOpen = 0;

  /**
   * @static
   * @memberof Modal
   */
  Modal._count = 0;

  M.Modal = Modal;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Modal, 'modal', 'M_Modal');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    inDuration: 275,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null
  };

  /**
   * @class
   *
   */

  var Materialbox = function (_Component4) {
    _inherits(Materialbox, _Component4);

    /**
     * Construct Materialbox instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Materialbox(el, options) {
      _classCallCheck(this, Materialbox);

      var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));

      _this16.el.M_Materialbox = _this16;

      /**
       * Options for the modal
       * @member Materialbox#options
       * @prop {Number} [inDuration=275] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
       */
      _this16.options = $.extend({}, Materialbox.defaults, options);

      _this16.overlayActive = false;
      _this16.doneAnimating = true;
      _this16.placeholder = $('<div></div>').addClass('material-placeholder');
      _this16.originalWidth = 0;
      _this16.originalHeight = 0;
      _this16.originInlineStyles = _this16.$el.attr('style');
      _this16.caption = _this16.el.getAttribute('data-caption') || '';

      // Wrap
      _this16.$el.before(_this16.placeholder);
      _this16.placeholder.append(_this16.$el);

      _this16._setupEventHandlers();
      return _this16;
    }

    _createClass(Materialbox, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Materialbox = undefined;

        // Unwrap image
        $(this.placeholder).after(this.el).remove();

        this.$el.removeAttr('style');
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
        this.el.addEventListener('click', this._handleMaterialboxClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleMaterialboxClickBound);
      }

      /**
       * Handle Materialbox Click
       * @param {Event} e
       */

    }, {
      key: "_handleMaterialboxClick",
      value: function _handleMaterialboxClick(e) {
        // If already modal, return to original
        if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        if (this.overlayActive) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        if (this.overlayActive) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       * @param {Event} e
       */

    }, {
      key: "_handleWindowEscape",
      value: function _handleWindowEscape(e) {
        // ESC key
        if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) {
          this.close();
        }
      }

      /**
       * Find ancestors with overflow: hidden; and make visible
       */

    }, {
      key: "_makeAncestorsOverflowVisible",
      value: function _makeAncestorsOverflowVisible() {
        this.ancestorsChanged = $();
        var ancestor = this.placeholder[0].parentNode;
        while (ancestor !== null && !$(ancestor).is(document)) {
          var curr = $(ancestor);
          if (curr.css('overflow') !== 'visible') {
            curr.css('overflow', 'visible');
            if (this.ancestorsChanged === undefined) {
              this.ancestorsChanged = curr;
            } else {
              this.ancestorsChanged = this.ancestorsChanged.add(curr);
            }
          }
          ancestor = ancestor.parentNode;
        }
      }

      /**
       * Animate image in
       */

    }, {
      key: "_animateImageIn",
      value: function _animateImageIn() {
        var _this17 = this;

        var animOptions = {
          targets: this.el,
          height: [this.originalHeight, this.newHeight],
          width: [this.originalWidth, this.newWidth],
          left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
          top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this17.doneAnimating = true;

            // onOpenEnd callback
            if (typeof _this17.options.onOpenEnd === 'function') {
              _this17.options.onOpenEnd.call(_this17, _this17.el);
            }
          }
        };

        // Override max-width or max-height if needed
        this.maxWidth = this.$el.css('max-width');
        this.maxHeight = this.$el.css('max-height');
        if (this.maxWidth !== 'none') {
          animOptions.maxWidth = this.newWidth;
        }
        if (this.maxHeight !== 'none') {
          animOptions.maxHeight = this.newHeight;
        }

        anim(animOptions);
      }

      /**
       * Animate image out
       */

    }, {
      key: "_animateImageOut",
      value: function _animateImageOut() {
        var _this18 = this;

        var animOptions = {
          targets: this.el,
          width: this.originalWidth,
          height: this.originalHeight,
          left: 0,
          top: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this18.placeholder.css({
              height: '',
              width: '',
              position: '',
              top: '',
              left: ''
            });

            // Revert to width or height attribute
            if (_this18.attrWidth) {
              _this18.$el.attr('width', _this18.attrWidth);
            }
            if (_this18.attrHeight) {
              _this18.$el.attr('height', _this18.attrHeight);
            }

            _this18.$el.removeAttr('style');
            _this18.originInlineStyles && _this18.$el.attr('style', _this18.originInlineStyles);

            // Remove class
            _this18.$el.removeClass('active');
            _this18.doneAnimating = true;

            // Remove overflow overrides on ancestors
            if (_this18.ancestorsChanged.length) {
              _this18.ancestorsChanged.css('overflow', '');
            }

            // onCloseEnd callback
            if (typeof _this18.options.onCloseEnd === 'function') {
              _this18.options.onCloseEnd.call(_this18, _this18.el);
            }
          }
        };

        anim(animOptions);
      }

      /**
       * Update open and close vars
       */

    }, {
      key: "_updateVars",
      value: function _updateVars() {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.caption = this.el.getAttribute('data-caption') || '';
      }

      /**
       * Open Materialbox
       */

    }, {
      key: "open",
      value: function open() {
        var _this19 = this;

        this._updateVars();
        this.originalWidth = this.el.getBoundingClientRect().width;
        this.originalHeight = this.el.getBoundingClientRect().height;

        // Set states
        this.doneAnimating = false;
        this.$el.addClass('active');
        this.overlayActive = true;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Set positioning for placeholder
        this.placeholder.css({
          width: this.placeholder[0].getBoundingClientRect().width + 'px',
          height: this.placeholder[0].getBoundingClientRect().height + 'px',
          position: 'relative',
          top: 0,
          left: 0
        });

        this._makeAncestorsOverflowVisible();

        // Set css on origin
        this.$el.css({
          position: 'absolute',
          'z-index': 1000,
          'will-change': 'left, top, width, height'
        });

        // Change from width or height attribute to css
        this.attrWidth = this.$el.attr('width');
        this.attrHeight = this.$el.attr('height');
        if (this.attrWidth) {
          this.$el.css('width', this.attrWidth + 'px');
          this.$el.removeAttr('width');
        }
        if (this.attrHeight) {
          this.$el.css('width', this.attrHeight + 'px');
          this.$el.removeAttr('height');
        }

        // Add overlay
        this.$overlay = $('<div id="materialbox-overlay"></div>').css({
          opacity: 0
        }).one('click', function () {
          if (_this19.doneAnimating) {
            _this19.close();
          }
        });

        // Put before in origin image to preserve z-index layering.
        this.$el.before(this.$overlay);

        // Set dimensions if needed
        var overlayOffset = this.$overlay[0].getBoundingClientRect();
        this.$overlay.css({
          width: this.windowWidth + 'px',
          height: this.windowHeight + 'px',
          left: -1 * overlayOffset.left + 'px',
          top: -1 * overlayOffset.top + 'px'
        });

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        // Animate Overlay
        anim({
          targets: this.$overlay[0],
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });

        // Add and animate caption if it exists
        if (this.caption !== '') {
          if (this.$photocaption) {
            anim.remove(this.$photoCaption[0]);
          }
          this.$photoCaption = $('<div class="materialbox-caption"></div>');
          this.$photoCaption.text(this.caption);
          $('body').append(this.$photoCaption);
          this.$photoCaption.css({ display: 'inline' });

          anim({
            targets: this.$photoCaption[0],
            opacity: 1,
            duration: this.options.inDuration,
            easing: 'easeOutQuad'
          });
        }

        // Resize Image
        var ratio = 0;
        var widthPercent = this.originalWidth / this.windowWidth;
        var heightPercent = this.originalHeight / this.windowHeight;
        this.newWidth = 0;
        this.newHeight = 0;

        if (widthPercent > heightPercent) {
          ratio = this.originalHeight / this.originalWidth;
          this.newWidth = this.windowWidth * 0.9;
          this.newHeight = this.windowWidth * 0.9 * ratio;
        } else {
          ratio = this.originalWidth / this.originalHeight;
          this.newWidth = this.windowHeight * 0.9 * ratio;
          this.newHeight = this.windowHeight * 0.9;
        }

        this._animateImageIn();

        // Handle Exit triggers
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);

        window.addEventListener('scroll', this._handleWindowScrollBound);
        window.addEventListener('resize', this._handleWindowResizeBound);
        window.addEventListener('keyup', this._handleWindowEscapeBound);
      }

      /**
       * Close Materialbox
       */

    }, {
      key: "close",
      value: function close() {
        var _this20 = this;

        this._updateVars();
        this.doneAnimating = false;

        // onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        if (this.caption !== '') {
          anim.remove(this.$photoCaption[0]);
        }

        // disable exit handlers
        window.removeEventListener('scroll', this._handleWindowScrollBound);
        window.removeEventListener('resize', this._handleWindowResizeBound);
        window.removeEventListener('keyup', this._handleWindowEscapeBound);

        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this20.overlayActive = false;
            _this20.$overlay.remove();
          }
        });

        this._animateImageOut();

        // Remove Caption + reset css settings on image
        if (this.caption !== '') {
          anim({
            targets: this.$photoCaption[0],
            opacity: 0,
            duration: this.options.outDuration,
            easing: 'easeOutQuad',
            complete: function () {
              _this20.$photoCaption.remove();
            }
          });
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Materialbox;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Materialbox;
  }(Component);

  M.Materialbox = Materialbox;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Materialbox, 'materialbox', 'M_Materialbox');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    responsiveThreshold: 0 // breakpoint for swipeable
  };

  var Parallax = function (_Component5) {
    _inherits(Parallax, _Component5);

    function Parallax(el, options) {
      _classCallCheck(this, Parallax);

      var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));

      _this21.el.M_Parallax = _this21;

      /**
       * Options for the Parallax
       * @member Parallax#options
       * @prop {Number} responsiveThreshold
       */
      _this21.options = $.extend({}, Parallax.defaults, options);
      _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;

      _this21.$img = _this21.$el.find('img').first();
      _this21.$img.each(function () {
        var el = this;
        if (el.complete) $(el).trigger('load');
      });

      _this21._updateParallax();
      _this21._setupEventHandlers();
      _this21._setupStyles();

      Parallax._parallaxes.push(_this21);
      return _this21;
    }

    _createClass(Parallax, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);
        this.$img[0].style.transform = '';
        this._removeEventHandlers();

        this.$el[0].M_Parallax = undefined;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleImageLoadBound = this._handleImageLoad.bind(this);
        this.$img[0].addEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
          window.addEventListener('scroll', Parallax._handleScrollThrottled);

          Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
          window.addEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.$img[0].removeEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          window.removeEventListener('scroll', Parallax._handleScrollThrottled);
          window.removeEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_setupStyles",
      value: function _setupStyles() {
        this.$img[0].style.opacity = 1;
      }
    }, {
      key: "_handleImageLoad",
      value: function _handleImageLoad() {
        this._updateParallax();
      }
    }, {
      key: "_updateParallax",
      value: function _updateParallax() {
        var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
        var imgHeight = this.$img[0].offsetHeight;
        var parallaxDist = imgHeight - containerHeight;
        var bottom = this.$el.offset().top + containerHeight;
        var top = this.$el.offset().top;
        var scrollTop = M.getDocumentScrollTop();
        var windowHeight = window.innerHeight;
        var windowBottom = scrollTop + windowHeight;
        var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
        var parallax = parallaxDist * percentScrolled;

        if (!this._enabled) {
          this.$img[0].style.transform = '';
        } else if (bottom > scrollTop && top < scrollTop + windowHeight) {
          this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Parallax;
      }
    }, {
      key: "_handleScroll",
      value: function _handleScroll() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._updateParallax.call(parallaxInstance);
        }
      }
    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Parallax;
  }(Component);

  /**
   * @static
   * @memberof Parallax
   */


  Parallax._parallaxes = [];

  M.Parallax = Parallax;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Parallax, 'parallax', 'M_Parallax');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    duration: 300,
    onShow: null,
    swipeable: false,
    responsiveThreshold: Infinity // breakpoint for swipeable
  };

  /**
   * @class
   *
   */

  var Tabs = function (_Component6) {
    _inherits(Tabs, _Component6);

    /**
     * Construct Tabs instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Tabs(el, options) {
      _classCallCheck(this, Tabs);

      var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));

      _this22.el.M_Tabs = _this22;

      /**
       * Options for the Tabs
       * @member Tabs#options
       * @prop {Number} duration
       * @prop {Function} onShow
       * @prop {Boolean} swipeable
       * @prop {Number} responsiveThreshold
       */
      _this22.options = $.extend({}, Tabs.defaults, options);

      // Setup
      _this22.$tabLinks = _this22.$el.children('li.tab').children('a');
      _this22.index = 0;
      _this22._setupActiveTabLink();

      // Setup tabs content
      if (_this22.options.swipeable) {
        _this22._setupSwipeableTabs();
      } else {
        _this22._setupNormalTabs();
      }

      // Setup tabs indicator after content to ensure accurate widths
      _this22._setTabsAndTabWidth();
      _this22._createIndicator();

      _this22._setupEventHandlers();
      return _this22;
    }

    _createClass(Tabs, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._indicator.parentNode.removeChild(this._indicator);

        if (this.options.swipeable) {
          this._teardownSwipeableTabs();
        } else {
          this._teardownNormalTabs();
        }

        this.$el[0].M_Tabs = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        window.addEventListener('resize', this._handleWindowResizeBound);

        this._handleTabClickBound = this._handleTabClick.bind(this);
        this.el.addEventListener('click', this._handleTabClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        window.removeEventListener('resize', this._handleWindowResizeBound);
        this.el.removeEventListener('click', this._handleTabClickBound);
      }

      /**
       * Handle window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        this._setTabsAndTabWidth();

        if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
          this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + 'px';
          this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + 'px';
        }
      }

      /**
       * Handle tab click
       * @param {Event} e
       */

    }, {
      key: "_handleTabClick",
      value: function _handleTabClick(e) {
        var _this23 = this;
        var anchorClass = 'fxxl-tabs--anchor';

        var tab = $(e.target).closest('li.tab');
        var tabLink = $(e.target).closest('a');

        // Handle click on tab link only
        if (!tabLink.length || !tabLink.parent().hasClass('tab')) {
          return;
        }

        if (tab.hasClass('disabled')) {
          e.preventDefault();
          return;
        }

        // Act as regular link if target attribute is specified.
        if (!!tabLink.attr('target')) {
          return;
        }

        // Make the old tab inactive.
        this.$activeTabLink.removeClass('active');
        var $oldContent = this.$content;

        // Update the variables with the new link and content
        this.$activeTabLink = tabLink;
        this.$content = $(M.escapeHash(tabLink[0].hash));
        this.$tabLinks = this.$el.children('li.tab').children('a');

        // Make the tab active.
        this.$activeTabLink.addClass('active');
        var prevIndex = this.index;
        this.index = Math.max(this.$tabLinks.index(tabLink), 0);

        // Swap content
        if (this.options.swipeable) {
          if (this._tabsCarousel) {
            this._tabsCarousel.set(this.index, function () {
              if (typeof _this23.options.onShow === 'function') {
                _this23.options.onShow.call(_this23, _this23.$content[0]);
              }
            });
          }
        } else {
          if (this.$content.length) {
            if (this.el.classList.contains(anchorClass) === false) {
              this.$content[0].style.display = 'block';
            }
            this.$content.addClass('active');
            if (typeof this.options.onShow === 'function') {
              this.options.onShow.call(this, this.$content[0]);
            }

            if ($oldContent.length && !$oldContent.is(this.$content)) {
              if (this.el.classList.contains(anchorClass) === false) {
                $oldContent[0].style.display = 'none';
              }
              $oldContent.removeClass('active');
            }
          }
        }

        // Update widths after content is swapped (scrollbar bugfix)
        this._setTabsAndTabWidth();

        // Update indicator
        this._animateIndicator(prevIndex);

        // Prevent the anchor's default click action
        e.preventDefault();
      }

      /**
       * Generate elements for tab indicator.
       */

    }, {
      key: "_createIndicator",
      value: function _createIndicator() {
        var _this24 = this;

        var indicator = document.createElement('li');
        indicator.classList.add('indicator');

        this.el.appendChild(indicator);
        this._indicator = indicator;

        setTimeout(function () {
          _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + 'px';
          _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + 'px';
        }, 0);
      }

      /**
       * Setup first active tab link.
       */

    }, {
      key: "_setupActiveTabLink",
      value: function _setupActiveTabLink() {
        // If the location.hash matches one of the links, use that as the active tab.
        this.$activeTabLink = $(this.$tabLinks.filter('[href="' + location.hash + '"]'));

        // If no match is found, use the first link or any with class 'active' as the initial active tab.
        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.tab').children('a.active').first();
        }
        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.tab').children('a').first();
        }

        this.$tabLinks.removeClass('active');
        this.$activeTabLink[0].classList.add('active');

        this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);

        if (this.$activeTabLink.length) {
          this.$content = $(M.escapeHash(this.$activeTabLink[0].hash));
          this.$content.addClass('active');
        }
      }

      /**
       * Setup swipeable tabs
       */

    }, {
      key: "_setupSwipeableTabs",
      value: function _setupSwipeableTabs() {
        var _this25 = this;

        // Change swipeable according to responsive threshold
        if (window.innerWidth > this.options.responsiveThreshold) {
          this.options.swipeable = false;
        }

        var $tabsContent = $();
        this.$tabLinks.each(function (link) {
          var $currContent = $(M.escapeHash(link.hash));
          $currContent.addClass('carousel-item');
          $tabsContent = $tabsContent.add($currContent);
        });

        var $tabsWrapper = $('<div class="tabs-content carousel carousel-slider"></div>');
        $tabsContent.first().before($tabsWrapper);
        $tabsWrapper.append($tabsContent);
        $tabsContent[0].style.display = '';

        // Keep active tab index to set initial carousel slide
        var activeTabIndex = this.$activeTabLink.closest('.tab').index();

        this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
          fullWidth: true,
          noWrap: true,
          onCycleTo: function (item) {
            var prevIndex = _this25.index;
            _this25.index = $(item).index();
            _this25.$activeTabLink.removeClass('active');
            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);
            _this25.$activeTabLink.addClass('active');
            _this25._animateIndicator(prevIndex);
            if (typeof _this25.options.onShow === 'function') {
              _this25.options.onShow.call(_this25, _this25.$content[0]);
            }
          }
        });

        // Set initial carousel slide to active tab
        this._tabsCarousel.set(activeTabIndex);
      }

      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownSwipeableTabs",
      value: function _teardownSwipeableTabs() {
        var $tabsWrapper = this._tabsCarousel.$el;
        this._tabsCarousel.destroy();

        // Unwrap
        $tabsWrapper.after($tabsWrapper.children());
        $tabsWrapper.remove();
      }

      /**
       * Setup normal tabs.
       */

    }, {
      key: "_setupNormalTabs",
      value: function _setupNormalTabs() {
        var anchorClass = 'fxxl-tabs--anchor';
        var isAnchor = this.el.classList.contains(anchorClass);
        // Hide Tabs Content
        this.$tabLinks.not(this.$activeTabLink).each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));
            if ($currContent.length && isAnchor === false) {
              $currContent[0].style.display = 'none';
            }
          }
        });
      }

      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownNormalTabs",
      value: function _teardownNormalTabs() {
        // show Tabs Content
        this.$tabLinks.each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));
            if ($currContent.length) {
              $currContent[0].style.display = '';
            }
          }
        });
      }

      /**
       * set tabs and tab width
       */

    }, {
      key: "_setTabsAndTabWidth",
      value: function _setTabsAndTabWidth() {
        this.tabsWidth = this.$el.width();
        this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
      }

      /**
       * Finds right attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcRightPos",
      value: function _calcRightPos(el) {
        return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
      }

      /**
       * Finds left attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcLeftPos",
      value: function _calcLeftPos(el) {
        return Math.floor(el.position().left);
      }
    }, {
      key: "updateTabIndicator",
      value: function updateTabIndicator() {
        this._setTabsAndTabWidth();
        this._animateIndicator(this.index);
      }

      /**
       * Animates Indicator to active tab.
       * @param {Number} prevIndex
       */

    }, {
      key: "_animateIndicator",
      value: function _animateIndicator(prevIndex) {
        var leftDelay = 0,
            rightDelay = 0;

        if (this.index - prevIndex >= 0) {
          leftDelay = 90;
        } else {
          rightDelay = 90;
        }

        // Animate
        var animOptions = {
          targets: this._indicator,
          left: {
            value: this._calcLeftPos(this.$activeTabLink),
            delay: leftDelay
          },
          right: {
            value: this._calcRightPos(this.$activeTabLink),
            delay: rightDelay
          },
          duration: this.options.duration,
          easing: 'easeOutQuad'
        };
        anim.remove(this._indicator);
        anim(animOptions);
      }

      /**
       * Select tab.
       * @param {String} tabId
       */

    }, {
      key: "select",
      value: function select(tabId) {
        var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');
        if (tab.length) {
          tab.trigger('click');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tabs;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Tabs;
  }(Component);

  M.Tabs = Tabs;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tabs, 'tabs', 'M_Tabs');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    exitDelay: 200,
    enterDelay: 0,
    html: null,
    margin: 5,
    inDuration: 250,
    outDuration: 200,
    position: 'bottom',
    transitionMovement: 10
  };

  /**
   * @class
   *
   */

  var Tooltip = function (_Component7) {
    _inherits(Tooltip, _Component7);

    /**
     * Construct Tooltip instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Tooltip(el, options) {
      _classCallCheck(this, Tooltip);

      var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));

      _this26.el.M_Tooltip = _this26;
      _this26.options = $.extend({}, Tooltip.defaults, options);

      _this26.isOpen = false;
      _this26.isHovered = false;
      _this26.isFocused = false;
      _this26._appendTooltipEl();
      _this26._setupEventHandlers();
      return _this26;
    }

    _createClass(Tooltip, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        $(this.tooltipEl).remove();
        this._removeEventHandlers();
        this.el.M_Tooltip = undefined;
      }
    }, {
      key: "_appendTooltipEl",
      value: function _appendTooltipEl() {
        var tooltipEl = document.createElement('div');
        tooltipEl.classList.add('material-tooltip');
        this.tooltipEl = tooltipEl;

        var tooltipContentEl = document.createElement('div');
        tooltipContentEl.classList.add('tooltip-content');
        tooltipContentEl.innerHTML = this.options.html;
        tooltipEl.appendChild(tooltipContentEl);
        document.body.appendChild(tooltipEl);
      }
    }, {
      key: "_updateTooltipContent",
      value: function _updateTooltipContent() {
        this.tooltipEl.querySelector('.tooltip-content').innerHTML = this.options.html;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
        this._handleFocusBound = this._handleFocus.bind(this);
        this._handleBlurBound = this._handleBlur.bind(this);
        this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.addEventListener('focus', this._handleFocusBound, true);
        this.el.addEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.removeEventListener('focus', this._handleFocusBound, true);
        this.el.removeEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "open",
      value: function open(isManual) {
        if (this.isOpen) {
          return;
        }
        isManual = isManual === undefined ? true : undefined; // Default value true
        this.isOpen = true;
        // Update tooltip content with HTML attribute options
        this.options = $.extend({}, this.options, this._getAttributeOptions());
        this._updateTooltipContent();
        this._setEnterDelayTimeout(isManual);
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isHovered = false;
        this.isFocused = false;
        this.isOpen = false;
        this._setExitDelayTimeout();
      }

      /**
       * Create timeout which delays when the tooltip closes
       */

    }, {
      key: "_setExitDelayTimeout",
      value: function _setExitDelayTimeout() {
        var _this27 = this;

        clearTimeout(this._exitDelayTimeout);

        this._exitDelayTimeout = setTimeout(function () {
          if (_this27.isHovered || _this27.isFocused) {
            return;
          }

          _this27._animateOut();
        }, this.options.exitDelay);
      }

      /**
       * Create timeout which delays when the toast closes
       */

    }, {
      key: "_setEnterDelayTimeout",
      value: function _setEnterDelayTimeout(isManual) {
        var _this28 = this;

        clearTimeout(this._enterDelayTimeout);

        this._enterDelayTimeout = setTimeout(function () {
          if (!_this28.isHovered && !_this28.isFocused && !isManual) {
            return;
          }

          _this28._animateIn();
        }, this.options.enterDelay);
      }
    }, {
      key: "_positionTooltip",
      value: function _positionTooltip() {
        var origin = this.el,
            tooltip = this.tooltipEl,
            originHeight = origin.offsetHeight,
            originWidth = origin.offsetWidth,
            tooltipHeight = tooltip.offsetHeight,
            tooltipWidth = tooltip.offsetWidth,
            newCoordinates = void 0,
            margin = this.options.margin,
            targetTop = void 0,
            targetLeft = void 0;

        this.xMovement = 0, this.yMovement = 0;

        targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
        targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();

        if (this.options.position === 'top') {
          targetTop += -tooltipHeight - margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = -this.options.transitionMovement;
        } else if (this.options.position === 'right') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += originWidth + margin;
          this.xMovement = this.options.transitionMovement;
        } else if (this.options.position === 'left') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += -tooltipWidth - margin;
          this.xMovement = -this.options.transitionMovement;
        } else {
          targetTop += originHeight + margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = this.options.transitionMovement;
        }

        newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
        $(tooltip).css({
          top: newCoordinates.y + 'px',
          left: newCoordinates.x + 'px'
        });
      }
    }, {
      key: "_repositionWithinScreen",
      value: function _repositionWithinScreen(x, y, width, height) {
        var scrollLeft = M.getDocumentScrollLeft();
        var scrollTop = M.getDocumentScrollTop();
        var newX = x - scrollLeft;
        var newY = y - scrollTop;

        var bounding = {
          left: newX,
          top: newY,
          width: width,
          height: height
        };

        var offset = this.options.margin + this.options.transitionMovement;
        var edges = M.checkWithinContainer(document.body, bounding, offset);

        if (edges.left) {
          newX = offset;
        } else if (edges.right) {
          newX -= newX + width - window.innerWidth;
        }

        if (edges.top) {
          newY = offset;
        } else if (edges.bottom) {
          newY -= newY + height - window.innerHeight;
        }

        return {
          x: newX + scrollLeft,
          y: newY + scrollTop
        };
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._positionTooltip();
        this.tooltipEl.style.visibility = 'visible';
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 1,
          translateX: this.xMovement,
          translateY: this.yMovement,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 0,
          translateX: 0,
          translateY: 0,
          duration: this.options.outDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.isHovered = true;
        this.isFocused = false; // Allows close of tooltip when opened by focus.
        this.open(false);
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave() {
        this.isHovered = false;
        this.isFocused = false; // Allows close of tooltip when opened by focus.
        this.close();
      }
    }, {
      key: "_handleFocus",
      value: function _handleFocus() {
        if (M.tabPressed) {
          this.isFocused = true;
          this.open(false);
        }
      }
    }, {
      key: "_handleBlur",
      value: function _handleBlur() {
        this.isFocused = false;
        this.close();
      }
    }, {
      key: "_getAttributeOptions",
      value: function _getAttributeOptions() {
        var attributeOptions = {};
        var tooltipTextOption = this.el.getAttribute('data-tooltip');
        var positionOption = this.el.getAttribute('data-position');

        if (tooltipTextOption) {
          attributeOptions.html = tooltipTextOption;
        }

        if (positionOption) {
          attributeOptions.position = positionOption;
        }
        return attributeOptions;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tooltip;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Tooltip;
  }(Component);

  M.Tooltip = Tooltip;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tooltip, 'tooltip', 'M_Tooltip');
  }
})(cash, M.anime);
; /*!
  * Waves v0.6.4
  * http://fian.my.id/Waves
  *
  * Copyright 2014 Alfiana E. Sibuea and other contributors
  * Released under the MIT license
  * https://github.com/fians/Waves/blob/master/LICENSE
  */

;(function (window) {
  'use strict';

  var Waves = Waves || {};
  var $$ = document.querySelectorAll.bind(document);

  // Find exact position of element
  function isWindow(obj) {
    return obj !== null && obj === obj.window;
  }

  function getWindow(elem) {
    return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
  }

  function offset(elem) {
    var docElem,
        win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;

    docElem = doc.documentElement;

    if (typeof elem.getBoundingClientRect !== typeof undefined) {
      box = elem.getBoundingClientRect();
    }
    win = getWindow(doc);
    return {
      top: box.top + win.pageYOffset - docElem.clientTop,
      left: box.left + win.pageXOffset - docElem.clientLeft
    };
  }

  function convertStyle(obj) {
    var style = '';

    for (var a in obj) {
      if (obj.hasOwnProperty(a)) {
        style += a + ':' + obj[a] + ';';
      }
    }

    return style;
  }

  var Effect = {

    // Effect delay
    duration: 750,

    show: function (e, element) {

      // Disable right click
      if (e.button === 2) {
        return false;
      }

      var el = element || this;

      // Create ripple
      var ripple = document.createElement('div');
      ripple.className = 'waves-ripple';
      el.appendChild(ripple);

      // Get click coordinate and element witdh
      var pos = offset(el);
      var relativeY = e.pageY - pos.top;
      var relativeX = e.pageX - pos.left;
      var scale = 'scale(' + el.clientWidth / 100 * 10 + ')';

      // Support for touch devices
      if ('touches' in e) {
        relativeY = e.touches[0].pageY - pos.top;
        relativeX = e.touches[0].pageX - pos.left;
      }

      // Attach data to element
      ripple.setAttribute('data-hold', Date.now());
      ripple.setAttribute('data-scale', scale);
      ripple.setAttribute('data-x', relativeX);
      ripple.setAttribute('data-y', relativeY);

      // Set ripple position
      var rippleStyle = {
        'top': relativeY + 'px',
        'left': relativeX + 'px'
      };

      ripple.className = ripple.className + ' waves-notransition';
      ripple.setAttribute('style', convertStyle(rippleStyle));
      ripple.className = ripple.className.replace('waves-notransition', '');

      // Scale the ripple
      rippleStyle['-webkit-transform'] = scale;
      rippleStyle['-moz-transform'] = scale;
      rippleStyle['-ms-transform'] = scale;
      rippleStyle['-o-transform'] = scale;
      rippleStyle.transform = scale;
      rippleStyle.opacity = '1';

      rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['transition-duration'] = Effect.duration + 'ms';

      rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';

      ripple.setAttribute('style', convertStyle(rippleStyle));
    },

    hide: function (e) {
      TouchHandler.touchup(e);

      var el = this;
      var width = el.clientWidth * 1.4;

      // Get first ripple
      var ripple = null;
      var ripples = el.getElementsByClassName('waves-ripple');
      if (ripples.length > 0) {
        ripple = ripples[ripples.length - 1];
      } else {
        return false;
      }

      var relativeX = ripple.getAttribute('data-x');
      var relativeY = ripple.getAttribute('data-y');
      var scale = ripple.getAttribute('data-scale');

      // Get delay beetween mousedown and mouse leave
      var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
      var delay = 350 - diff;

      if (delay < 0) {
        delay = 0;
      }

      // Fade out ripple after delay
      setTimeout(function () {
        var style = {
          'top': relativeY + 'px',
          'left': relativeX + 'px',
          'opacity': '0',

          // Duration
          '-webkit-transition-duration': Effect.duration + 'ms',
          '-moz-transition-duration': Effect.duration + 'ms',
          '-o-transition-duration': Effect.duration + 'ms',
          'transition-duration': Effect.duration + 'ms',
          '-webkit-transform': scale,
          '-moz-transform': scale,
          '-ms-transform': scale,
          '-o-transform': scale,
          'transform': scale
        };

        ripple.setAttribute('style', convertStyle(style));

        setTimeout(function () {
          try {
            el.removeChild(ripple);
          } catch (e) {
            return false;
          }
        }, Effect.duration);
      }, delay);
    },

    // Little hack to make <input> can perform waves effect
    wrapInput: function (elements) {
      for (var a = 0; a < elements.length; a++) {
        var el = elements[a];

        if (el.tagName.toLowerCase() === 'input') {
          var parent = el.parentNode;

          // If input already have parent just pass through
          if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
            continue;
          }

          // Put element class and style to the specified parent
          var wrapper = document.createElement('i');
          wrapper.className = el.className + ' waves-input-wrapper';

          var elementStyle = el.getAttribute('style');

          if (!elementStyle) {
            elementStyle = '';
          }

          wrapper.setAttribute('style', elementStyle);

          el.className = 'waves-button-input';
          el.removeAttribute('style');

          // Put element as child
          parent.replaceChild(wrapper, el);
          wrapper.appendChild(el);
        }
      }
    }
  };

  /**
   * Disable mousedown event for 500ms during and after touch
   */
  var TouchHandler = {
    /* uses an integer rather than bool so there's no issues with
     * needing to clear timeouts if another touch event occurred
     * within the 500ms. Cannot mouseup between touchstart and
     * touchend, nor in the 500ms after touchend. */
    touches: 0,
    allowEvent: function (e) {
      var allow = true;

      if (e.type === 'touchstart') {
        TouchHandler.touches += 1; //push
      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
        setTimeout(function () {
          if (TouchHandler.touches > 0) {
            TouchHandler.touches -= 1; //pop after 500ms
          }
        }, 500);
      } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
        allow = false;
      }

      return allow;
    },
    touchup: function (e) {
      TouchHandler.allowEvent(e);
    }
  };

  /**
   * Delegated click handler for .waves-effect element.
   * returns null when .waves-effect element not in "click tree"
   */
  function getWavesEffectElement(e) {
    if (TouchHandler.allowEvent(e) === false) {
      return null;
    }

    var element = null;
    var target = e.target || e.srcElement;

    while (target.parentNode !== null) {
      if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
        element = target;
        break;
      }
      target = target.parentNode;
    }
    return element;
  }

  /**
   * Bubble the click and show effect if .waves-effect elem was found
   */
  function showEffect(e) {
    var element = getWavesEffectElement(e);

    if (element !== null) {
      Effect.show(e, element);

      if ('ontouchstart' in window) {
        element.addEventListener('touchend', Effect.hide, false);
        element.addEventListener('touchcancel', Effect.hide, false);
      }

      element.addEventListener('mouseup', Effect.hide, false);
      element.addEventListener('mouseleave', Effect.hide, false);
      element.addEventListener('dragend', Effect.hide, false);
    }
  }

  Waves.displayEffect = function (options) {
    options = options || {};

    if ('duration' in options) {
      Effect.duration = options.duration;
    }

    //Wrap input inside <i> tag
    Effect.wrapInput($$('.waves-effect'));

    if ('ontouchstart' in window) {
      document.body.addEventListener('touchstart', showEffect, false);
    }

    document.body.addEventListener('mousedown', showEffect, false);
  };

  /**
   * Attach Waves to an input element (or any element which doesn't
   * bubble mouseup/mousedown events).
   *   Intended to be used with dynamically loaded forms/inputs, or
   * where the user doesn't want a delegated click handler.
   */
  Waves.attach = function (element) {
    //FUTURE: automatically add waves classes and allow users
    // to specify them with an options param? Eg. light/classic/button
    if (element.tagName.toLowerCase() === 'input') {
      Effect.wrapInput([element]);
      element = element.parentNode;
    }

    if ('ontouchstart' in window) {
      element.addEventListener('touchstart', showEffect, false);
    }

    element.addEventListener('mousedown', showEffect, false);
  };

  window.Waves = Waves;

  document.addEventListener('DOMContentLoaded', function () {
    Waves.displayEffect();
  }, false);
})(window);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    html: '',
    displayLength: 4000,
    inDuration: 300,
    outDuration: 375,
    classes: '',
    completeCallback: null,
    activationPercent: 0.8
  };

  var Toast = function () {
    function Toast(options) {
      _classCallCheck(this, Toast);

      /**
       * Options for the toast
       * @member Toast#options
       */
      this.options = $.extend({}, Toast.defaults, options);
      this.message = this.options.html;

      /**
       * Describes current pan state toast
       * @type {Boolean}
       */
      this.panning = false;

      /**
       * Time remaining until toast is removed
       */
      this.timeRemaining = this.options.displayLength;

      if (Toast._toasts.length === 0) {
        Toast._createContainer();
      }

      // Create new toast
      Toast._toasts.push(this);
      var toastElement = this._createToast();
      toastElement.M_Toast = this;
      this.el = toastElement;
      this.$el = $(toastElement);
      this._animateIn();
      this._setTimer();
    }

    _createClass(Toast, [{
      key: "_createToast",


      /**
       * Create toast and append it to toast container
       */
      value: function _createToast() {
        var toast = document.createElement('div');
        toast.classList.add('toast');

        // Add custom classes onto toast
        if (!!this.options.classes.length) {
          $(toast).addClass(this.options.classes);
        }

        // Set content
        if (typeof HTMLElement === 'object' ? this.message instanceof HTMLElement : this.message && typeof this.message === 'object' && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === 'string') {
          toast.appendChild(this.message);

          // Check if it is jQuery object
        } else if (!!this.message.jquery) {
          $(toast).append(this.message[0]);

          // Insert as html;
        } else {
          toast.innerHTML = this.message;
        }

        // Append toasft
        Toast._container.appendChild(toast);
        return toast;
      }

      /**
       * Animate in toast
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        // Animate toast in
        anim({
          targets: this.el,
          top: 0,
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }

      /**
       * Create setInterval which automatically removes toast when timeRemaining >= 0
       * has been reached
       */

    }, {
      key: "_setTimer",
      value: function _setTimer() {
        var _this29 = this;

        if (this.timeRemaining !== Infinity) {
          this.counterInterval = setInterval(function () {
            // If toast is not being dragged, decrease its time remaining
            if (!_this29.panning) {
              _this29.timeRemaining -= 20;
            }

            // Animate toast out
            if (_this29.timeRemaining <= 0) {
              _this29.dismiss();
            }
          }, 20);
        }
      }

      /**
       * Dismiss toast with animation
       */

    }, {
      key: "dismiss",
      value: function dismiss() {
        var _this30 = this;

        window.clearInterval(this.counterInterval);
        var activationDistance = this.el.offsetWidth * this.options.activationPercent;

        if (this.wasSwiped) {
          this.el.style.transition = 'transform .05s, opacity .05s';
          this.el.style.transform = "translateX(" + activationDistance + "px)";
          this.el.style.opacity = 0;
        }

        anim({
          targets: this.el,
          opacity: 0,
          marginTop: -40,
          duration: this.options.outDuration,
          easing: 'easeOutExpo',
          complete: function () {
            // Call the optional callback
            if (typeof _this30.options.completeCallback === 'function') {
              _this30.options.completeCallback();
            }
            // Remove toast from DOM
            _this30.$el.remove();
            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);
            if (Toast._toasts.length === 0) {
              Toast._removeContainer();
            }
          }
        });
      }
    }], [{
      key: "getInstance",


      /**
       * Get Instance
       */
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Toast;
      }

      /**
       * Append toast container and add event handlers
       */

    }, {
      key: "_createContainer",
      value: function _createContainer() {
        var container = document.createElement('div');
        container.setAttribute('id', 'toast-container');

        // Add event handler
        container.addEventListener('touchstart', Toast._onDragStart);
        container.addEventListener('touchmove', Toast._onDragMove);
        container.addEventListener('touchend', Toast._onDragEnd);

        container.addEventListener('mousedown', Toast._onDragStart);
        document.addEventListener('mousemove', Toast._onDragMove);
        document.addEventListener('mouseup', Toast._onDragEnd);

        document.body.appendChild(container);
        Toast._container = container;
      }

      /**
       * Remove toast container and event handlers
       */

    }, {
      key: "_removeContainer",
      value: function _removeContainer() {
        // Add event handler
        document.removeEventListener('mousemove', Toast._onDragMove);
        document.removeEventListener('mouseup', Toast._onDragEnd);

        $(Toast._container).remove();
        Toast._container = null;
      }

      /**
       * Begin drag handler
       * @param {Event} e
       */

    }, {
      key: "_onDragStart",
      value: function _onDragStart(e) {
        if (e.target && $(e.target).closest('.toast').length) {
          var $toast = $(e.target).closest('.toast');
          var toast = $toast[0].M_Toast;
          toast.panning = true;
          Toast._draggedToast = toast;
          toast.el.classList.add('panning');
          toast.el.style.transition = '';
          toast.startingXPos = Toast._xPos(e);
          toast.time = Date.now();
          toast.xPos = Toast._xPos(e);
        }
      }

      /**
       * Drag move handler
       * @param {Event} e
       */

    }, {
      key: "_onDragMove",
      value: function _onDragMove(e) {
        if (!!Toast._draggedToast) {
          e.preventDefault();
          var toast = Toast._draggedToast;
          toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
          toast.xPos = Toast._xPos(e);
          toast.velocityX = toast.deltaX / (Date.now() - toast.time);
          toast.time = Date.now();

          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
          toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
        }
      }

      /**
       * End drag handler
       */

    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        if (!!Toast._draggedToast) {
          var toast = Toast._draggedToast;
          toast.panning = false;
          toast.el.classList.remove('panning');

          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1;

          // Remove toast
          if (shouldBeDismissed) {
            toast.wasSwiped = true;
            toast.dismiss();

            // Animate toast back to original position
          } else {
            toast.el.style.transition = 'transform .2s, opacity .2s';
            toast.el.style.transform = '';
            toast.el.style.opacity = '';
          }
          Toast._draggedToast = null;
        }
      }

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       */

    }, {
      key: "_xPos",
      value: function _xPos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        }
        // mouse event
        return e.clientX;
      }

      /**
       * Remove all toasts
       */

    }, {
      key: "dismissAll",
      value: function dismissAll() {
        for (var toastIndex in Toast._toasts) {
          Toast._toasts[toastIndex].dismiss();
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Toast;
  }();

  /**
   * @static
   * @memberof Toast
   * @type {Array.<Toast>}
   */


  Toast._toasts = [];

  /**
   * @static
   * @memberof Toast
   */
  Toast._container = null;

  /**
   * @static
   * @memberof Toast
   * @type {Toast}
   */
  Toast._draggedToast = null;

  M.Toast = Toast;
  M.toast = function (options) {
    return new Toast(options);
  };
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    edge: 'left',
    draggable: true,
    inDuration: 250,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true
  };

  /**
   * @class
   */

  var Sidenav = function (_Component8) {
    _inherits(Sidenav, _Component8);

    /**
     * Construct Sidenav instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Sidenav(el, options) {
      _classCallCheck(this, Sidenav);

      var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));

      _this31.el.M_Sidenav = _this31;
      _this31.id = _this31.$el.attr('id');

      /**
       * Options for the Sidenav
       * @member Sidenav#options
       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Function called when sidenav starts entering
       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
       */
      _this31.options = $.extend({}, Sidenav.defaults, options);

      /**
       * Describes open/close state of Sidenav
       * @type {Boolean}
       */
      _this31.isOpen = false;

      /**
       * Describes if Sidenav is fixed
       * @type {Boolean}
       */
      _this31.isFixed = _this31.el.classList.contains('sidenav-fixed');

      /**
       * Describes if Sidenav is being draggeed
       * @type {Boolean}
       */
      _this31.isDragged = false;

      // Window size variables for window resize checks
      _this31.lastWindowWidth = window.innerWidth;
      _this31.lastWindowHeight = window.innerHeight;

      _this31._createOverlay();
      _this31._createDragTarget();
      _this31._setupEventHandlers();
      _this31._setupClasses();
      _this31._setupFixed();

      Sidenav._sidenavs.push(_this31);
      return _this31;
    }

    _createClass(Sidenav, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._enableBodyScrolling();
        this._overlay.parentNode.removeChild(this._overlay);
        this.dragTarget.parentNode.removeChild(this.dragTarget);
        this.el.M_Sidenav = undefined;
        this.el.style.transform = '';

        var index = Sidenav._sidenavs.indexOf(this);
        if (index >= 0) {
          Sidenav._sidenavs.splice(index, 1);
        }
      }
    }, {
      key: "_createOverlay",
      value: function _createOverlay() {
        var overlay = document.createElement('div');
        this._closeBound = this.close.bind(this);
        overlay.classList.add('sidenav-overlay');

        overlay.addEventListener('click', this._closeBound);

        document.body.appendChild(overlay);
        this._overlay = overlay;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        if (Sidenav._sidenavs.length === 0) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }

        this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
        this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
        this._handleCloseDragBound = this._handleCloseDrag.bind(this);
        this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
        this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);

        this.dragTarget.addEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.addEventListener('touchend', this._handleDragTargetReleaseBound);
        this._overlay.addEventListener('touchmove', this._handleCloseDragBound);
        this._overlay.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('touchmove', this._handleCloseDragBound);
        this.el.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('click', this._handleCloseTriggerClickBound);

        // Add resize for side nav fixed
        if (this.isFixed) {
          this._handleWindowResizeBound = this._handleWindowResize.bind(this);
          window.addEventListener('resize', this._handleWindowResizeBound);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Sidenav._sidenavs.length === 1) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }

        this.dragTarget.removeEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.removeEventListener('touchend', this._handleDragTargetReleaseBound);
        this._overlay.removeEventListener('touchmove', this._handleCloseDragBound);
        this._overlay.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('touchmove', this._handleCloseDragBound);
        this.el.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('click', this._handleCloseTriggerClickBound);

        // Remove resize for side nav fixed
        if (this.isFixed) {
          window.removeEventListener('resize', this._handleWindowResizeBound);
        }
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.sidenav-trigger');
        if (e.target && $trigger.length) {
          var sidenavId = M.getIdFromTrigger($trigger[0]);

          var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;
          if (sidenavInstance) {
            sidenavInstance.open($trigger);
          }
          e.preventDefault();
        }
      }

      /**
       * Set variables needed at the beggining of drag
       * and stop any current transition.
       * @param {Event} e
       */

    }, {
      key: "_startDrag",
      value: function _startDrag(e) {
        var clientX = e.targetTouches[0].clientX;
        this.isDragged = true;
        this._startingXpos = clientX;
        this._xPos = this._startingXpos;
        this._time = Date.now();
        this._width = this.el.getBoundingClientRect().width;
        this._overlay.style.display = 'block';
        this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this._verticallyScrolling = false;
        anim.remove(this.el);
        anim.remove(this._overlay);
      }

      /**
       * Set variables needed at each drag move update tick
       * @param {Event} e
       */

    }, {
      key: "_dragMoveUpdate",
      value: function _dragMoveUpdate(e) {
        var clientX = e.targetTouches[0].clientX;
        var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this.deltaX = Math.abs(this._xPos - clientX);
        this._xPos = clientX;
        this.velocityX = this.deltaX / (Date.now() - this._time);
        this._time = Date.now();
        if (this._initialScrollTop !== currentScrollTop) {
          this._verticallyScrolling = true;
        }
      }

      /**
       * Handles Dragging of Sidenav
       * @param {Event} e
       */

    }, {
      key: "_handleDragTargetDrag",
      value: function _handleDragTargetDrag(e) {
        // Check if draggable
        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
          return;
        }

        // If not being dragged, set initial drag start variables
        if (!this.isDragged) {
          this._startDrag(e);
        }

        // Run touchmove updates
        this._dragMoveUpdate(e);

        // Calculate raw deltaX
        var totalDeltaX = this._xPos - this._startingXpos;

        // dragDirection is the attempted user drag direction
        var dragDirection = totalDeltaX > 0 ? 'right' : 'left';

        // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
        if (this.options.edge === dragDirection) {
          totalDeltaX = 0;
        }

        /**
         * transformX is the drag displacement
         * transformPrefix is the initial transform placement
         * Invert values if Sidenav is right edge
         */
        var transformX = totalDeltaX;
        var transformPrefix = 'translateX(-100%)';
        if (this.options.edge === 'right') {
          transformPrefix = 'translateX(100%)';
          transformX = -transformX;
        }

        // Calculate open/close percentage of sidenav, with open = 1 and close = 0
        this.percentOpen = Math.min(1, totalDeltaX / this._width);

        // Set transform and opacity styles
        this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
        this._overlay.style.opacity = this.percentOpen;
      }

      /**
       * Handle Drag Target Release
       */

    }, {
      key: "_handleDragTargetRelease",
      value: function _handleDragTargetRelease() {
        if (this.isDragged) {
          if (this.percentOpen > 0.2) {
            this.open();
          } else {
            this._animateOut();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }

      /**
       * Handle Close Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCloseDrag",
      value: function _handleCloseDrag(e) {
        if (this.isOpen) {
          // Check if draggable
          if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
            return;
          }

          // If not being dragged, set initial drag start variables
          if (!this.isDragged) {
            this._startDrag(e);
          }

          // Run touchmove updates
          this._dragMoveUpdate(e);

          // Calculate raw deltaX
          var totalDeltaX = this._xPos - this._startingXpos;

          // dragDirection is the attempted user drag direction
          var dragDirection = totalDeltaX > 0 ? 'right' : 'left';

          // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
          totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
          if (this.options.edge !== dragDirection) {
            totalDeltaX = 0;
          }

          var transformX = -totalDeltaX;
          if (this.options.edge === 'right') {
            transformX = -transformX;
          }

          // Calculate open/close percentage of sidenav, with open = 1 and close = 0
          this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width);

          // Set transform and opacity styles
          this.el.style.transform = "translateX(" + transformX + "px)";
          this._overlay.style.opacity = this.percentOpen;
        }
      }

      /**
       * Handle Close Release
       */

    }, {
      key: "_handleCloseRelease",
      value: function _handleCloseRelease() {
        if (this.isOpen && this.isDragged) {
          if (this.percentOpen > 0.8) {
            this._animateIn();
          } else {
            this.close();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }

      /**
       * Handles closing of Sidenav when element with class .sidenav-close
       */

    }, {
      key: "_handleCloseTriggerClick",
      value: function _handleCloseTriggerClick(e) {
        var $closeTrigger = $(e.target).closest('.sidenav-close');
        if ($closeTrigger.length && !this._isCurrentlyFixed()) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        // Only handle horizontal resizes
        if (this.lastWindowWidth !== window.innerWidth) {
          if (window.innerWidth > 992) {
            this.open();
          } else {
            this.close();
          }
        }

        this.lastWindowWidth = window.innerWidth;
        this.lastWindowHeight = window.innerHeight;
      }
    }, {
      key: "_setupClasses",
      value: function _setupClasses() {
        if (this.options.edge === 'right') {
          this.el.classList.add('right-aligned');
          this.dragTarget.classList.add('right-aligned');
        }
      }
    }, {
      key: "_removeClasses",
      value: function _removeClasses() {
        this.el.classList.remove('right-aligned');
        this.dragTarget.classList.remove('right-aligned');
      }
    }, {
      key: "_setupFixed",
      value: function _setupFixed() {
        if (this._isCurrentlyFixed()) {
          this.open();
        }
      }
    }, {
      key: "_isCurrentlyFixed",
      value: function _isCurrentlyFixed() {
        return this.isFixed && window.innerWidth > 992;
      }
    }, {
      key: "_createDragTarget",
      value: function _createDragTarget() {
        var dragTarget = document.createElement('div');
        dragTarget.classList.add('drag-target');
        document.body.appendChild(dragTarget);
        this.dragTarget = dragTarget;
      }
    }, {
      key: "_preventBodyScrolling",
      value: function _preventBodyScrolling() {
        var body = document.body;
        body.style.overflow = 'hidden';
      }
    }, {
      key: "_enableBodyScrolling",
      value: function _enableBodyScrolling() {
        var body = document.body;
        body.style.overflow = '';
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen === true) {
          return;
        }

        this.isOpen = true;

        // Run onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Handle fixed Sidenav
        if (this._isCurrentlyFixed()) {
          anim.remove(this.el);
          anim({
            targets: this.el,
            translateX: 0,
            duration: 0,
            easing: 'easeOutQuad'
          });
          this._enableBodyScrolling();
          this._overlay.style.display = 'none';

          // Handle non-fixed Sidenav
        } else {
          if (this.options.preventScrolling) {
            this._preventBodyScrolling();
          }

          if (!this.isDragged || this.percentOpen != 1) {
            this._animateIn();
          }
        }
      }
    }, {
      key: "close",
      value: function close() {
        if (this.isOpen === false) {
          return;
        }

        this.isOpen = false;

        // Run onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        // Handle fixed Sidenav
        if (this._isCurrentlyFixed()) {
          var transformX = this.options.edge === 'left' ? '-105%' : '105%';
          this.el.style.transform = "translateX(" + transformX + ")";

          // Handle non-fixed Sidenav
        } else {
          this._enableBodyScrolling();

          if (!this.isDragged || this.percentOpen != 0) {
            this._animateOut();
          } else {
            this._overlay.style.display = 'none';
          }
        }
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._animateSidenavIn();
        this._animateOverlayIn();
      }
    }, {
      key: "_animateSidenavIn",
      value: function _animateSidenavIn() {
        var _this32 = this;

        var slideOutPercent = this.options.edge === 'left' ? -1 : 1;
        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", 0],
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function () {
            // Run onOpenEnd callback
            if (typeof _this32.options.onOpenEnd === 'function') {
              _this32.options.onOpenEnd.call(_this32, _this32.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayIn",
      value: function _animateOverlayIn() {
        var start = 0;
        if (this.isDragged) {
          start = this.percentOpen;
        } else {
          $(this._overlay).css({
            display: 'block'
          });
        }

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: [start, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        this._animateSidenavOut();
        this._animateOverlayOut();
      }
    }, {
      key: "_animateSidenavOut",
      value: function _animateSidenavOut() {
        var _this33 = this;

        var endPercent = this.options.edge === 'left' ? -1 : 1;
        var slideOutPercent = 0;
        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? endPercent + this.percentOpen : endPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", endPercent * 105 + "%"],
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            // Run onOpenEnd callback
            if (typeof _this33.options.onCloseEnd === 'function') {
              _this33.options.onCloseEnd.call(_this33, _this33.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayOut",
      value: function _animateOverlayOut() {
        var _this34 = this;

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            $(_this34._overlay).css('display', 'none');
          }
        });
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Sidenav;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Sidenav;
  }(Component);

  /**
   * @static
   * @memberof Sidenav
   * @type {Array.<Sidenav>}
   */


  Sidenav._sidenavs = [];

  M.Sidenav = Sidenav;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Sidenav, 'sidenav', 'M_Sidenav');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    throttle: 100,
    scrollOffset: 200, // offset - 200 allows elements near bottom of page to scroll
    activeClass: 'active',
    getActiveElement: function (id) {
      return 'a[href="#' + id + '"]';
    }
  };

  /**
   * @class
   *
   */

  var ScrollSpy = function (_Component9) {
    _inherits(ScrollSpy, _Component9);

    /**
     * Construct ScrollSpy instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function ScrollSpy(el, options) {
      _classCallCheck(this, ScrollSpy);

      var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));

      _this35.el.M_ScrollSpy = _this35;

      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [throttle=100] - Throttle of scroll handler
       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
       * @prop {String} [activeClass='active'] - Class applied to active elements
       * @prop {Function} [getActiveElement] - Used to find active element
       */
      _this35.options = $.extend({}, ScrollSpy.defaults, options);

      // setup
      ScrollSpy._elements.push(_this35);
      ScrollSpy._count++;
      ScrollSpy._increment++;
      _this35.tickId = -1;
      _this35.id = ScrollSpy._increment;
      _this35._setupEventHandlers();
      _this35._handleWindowScroll();
      return _this35;
    }

    _createClass(ScrollSpy, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);
        ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);
        ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);
        ScrollSpy._count--;
        this._removeEventHandlers();
        $(this.options.getActiveElement(this.$el.attr('id'))).removeClass(this.options.activeClass);
        this.el.M_ScrollSpy = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var throttledResize = M.throttle(this._handleWindowScroll, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        if (ScrollSpy._count === 1) {
          window.addEventListener('scroll', this._handleWindowScrollBound);
          window.addEventListener('resize', this._handleThrottledResizeBound);
          document.body.addEventListener('click', this._handleTriggerClick);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (ScrollSpy._count === 0) {
          window.removeEventListener('scroll', this._handleWindowScrollBound);
          window.removeEventListener('resize', this._handleThrottledResizeBound);
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target);
        for (var i = ScrollSpy._elements.length - 1; i >= 0; i--) {
          var scrollspy = ScrollSpy._elements[i];
          if ($trigger.is('a[href="#' + scrollspy.$el.attr('id') + '"]')) {
            e.preventDefault();
            var offset = scrollspy.$el.offset().top + 1;

            anim({
              targets: [document.documentElement, document.body],
              scrollTop: offset - scrollspy.options.scrollOffset,
              duration: 400,
              easing: 'easeOutCubic'
            });
            break;
          }
        }
      }

      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        // unique tick id
        ScrollSpy._ticks++;

        // viewport rectangle
        var top = M.getDocumentScrollTop(),
            left = M.getDocumentScrollLeft(),
            right = left + window.innerWidth,
            bottom = top + window.innerHeight;

        // determine which elements are in view
        var intersections = ScrollSpy._findElements(top, right, bottom, left);
        for (var i = 0; i < intersections.length; i++) {
          var scrollspy = intersections[i];
          var lastTick = scrollspy.tickId;
          if (lastTick < 0) {
            // entered into view
            scrollspy._enter();
          }

          // update tick id
          scrollspy.tickId = ScrollSpy._ticks;
        }

        for (var _i = 0; _i < ScrollSpy._elementsInView.length; _i++) {
          var _scrollspy = ScrollSpy._elementsInView[_i];
          var _lastTick = _scrollspy.tickId;
          if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
            // exited from view
            _scrollspy._exit();
            _scrollspy.tickId = -1;
          }
        }

        // remember elements in view for next tick
        ScrollSpy._elementsInView = intersections;
      }

      /**
       * Find elements that are within the boundary
       * @param {number} top
       * @param {number} right
       * @param {number} bottom
       * @param {number} left
       * @return {Array.<ScrollSpy>}   A collection of elements
       */

    }, {
      key: "_enter",
      value: function _enter() {
        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
          if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) {
            ScrollSpy._visibleElements.unshift(this.$el);
          } else {
            ScrollSpy._visibleElements.push(this.$el);
          }
        } else {
          ScrollSpy._visibleElements.push(this.$el);
        }

        $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
      }
    }, {
      key: "_exit",
      value: function _exit() {
        var _this36 = this;

        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);

          ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (el) {
            return el.attr('id') != _this36.$el.attr('id');
          });
          if (ScrollSpy._visibleElements[0]) {
            // Check if empty
            $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
          }
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_ScrollSpy;
      }
    }, {
      key: "_findElements",
      value: function _findElements(top, right, bottom, left) {
        var hits = [];
        for (var i = 0; i < ScrollSpy._elements.length; i++) {
          var scrollspy = ScrollSpy._elements[i];
          var currTop = top + scrollspy.options.scrollOffset || 200;

          if (scrollspy.$el.height() > 0) {
            var elTop = scrollspy.$el.offset().top,
                elLeft = scrollspy.$el.offset().left,
                elRight = elLeft + scrollspy.$el.width(),
                elBottom = elTop + scrollspy.$el.height();

            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);

            if (isIntersect) {
              hits.push(scrollspy);
            }
          }
        }
        return hits;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return ScrollSpy;
  }(Component);

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */


  ScrollSpy._elements = [];

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */
  ScrollSpy._elementsInView = [];

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<cash>}
   */
  ScrollSpy._visibleElements = [];

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._count = 0;

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._increment = 0;

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._ticks = 0;

  M.ScrollSpy = ScrollSpy;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(ScrollSpy, 'scrollSpy', 'M_ScrollSpy');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    data: {}, // Autocomplete data set
    limit: Infinity, // Limit of results the autocomplete shows
    onAutocomplete: null, // Callback for when autocompleted
    minLength: 1, // Min characters before autocomplete starts
    sortFunction: function (a, b, inputString) {
      // Sort function for sorting autocomplete results
      return a.indexOf(inputString) - b.indexOf(inputString);
    }
  };

  /**
   * @class
   *
   */

  var Autocomplete = function (_Component10) {
    _inherits(Autocomplete, _Component10);

    /**
     * Construct Autocomplete instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Autocomplete(el, options) {
      _classCallCheck(this, Autocomplete);

      var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));

      _this37.el.M_Autocomplete = _this37;

      /**
       * Options for the autocomplete
       * @member Autocomplete#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {number} shift
       * @prop {number} padding
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */
      _this37.options = $.extend({}, Autocomplete.defaults, options);

      // Setup
      _this37.isOpen = false;
      _this37.count = 0;
      _this37.activeIndex = -1;
      _this37.oldVal;
      _this37.$inputField = _this37.$el.closest('.input-field');
      _this37.$active = $();
      _this37._mousedown = false;
      _this37._setupDropdown();

      _this37._setupEventHandlers();
      return _this37;
    }

    _createClass(Autocomplete, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeDropdown();
        this.el.M_Autocomplete = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputBlurBound = this._handleInputBlur.bind(this);
        this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
        this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);

        this.el.addEventListener('blur', this._handleInputBlurBound);
        this.el.addEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('click', this._handleInputClickBound);
        this.container.addEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.addEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.addEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.addEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('blur', this._handleInputBlurBound);
        this.el.removeEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.container.removeEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.removeEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.removeEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.removeEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this38 = this;

        this.container = document.createElement('ul');
        this.container.id = "autocomplete-options-" + M.guid();
        $(this.container).addClass('autocomplete-content dropdown-content');
        this.$inputField.append(this.container);
        this.el.setAttribute('data-target', this.container.id);

        this.dropdown = M.Dropdown.init(this.el, {
          autoFocus: false,
          closeOnClick: false,
          coverTrigger: false,
          onItemClick: function (itemEl) {
            _this38.selectOption($(itemEl));
          }
        });

        // Sketchy removal of dropdown click handler
        this.el.removeEventListener('click', this.dropdown._handleClickBound);
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        this.container.parentNode.removeChild(this.container);
      }

      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        if (!this._mousedown) {
          this.close();
          this._resetAutocomplete();
        }
      }

      /**
       * Handle Input Keyup and Focus
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeyupAndFocus",
      value: function _handleInputKeyupAndFocus(e) {
        if (e.type === 'keyup') {
          Autocomplete._keydown = false;
        }

        this.count = 0;
        var val = this.el.value.toLowerCase();

        // Don't capture enter or arrow key usage.
        if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
          return;
        }

        // Check if the input isn't empty
        // Check if focus triggered by tab
        if (this.oldVal !== val && (M.tabPressed || e.type !== 'focus')) {
          this.open();
        }

        // Update oldVal
        this.oldVal = val;
      }

      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Autocomplete._keydown = true;

        // Arrow keys and enter key usage
        var keyCode = e.keyCode,
            liElement = void 0,
            numItems = $(this.container).children('li').length;

        // select element on Enter
        if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
          liElement = $(this.container).children('li').eq(this.activeIndex);
          if (liElement.length) {
            this.selectOption(liElement);
            e.preventDefault();
          }
          return;
        }

        // Capture up and down key
        if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
          e.preventDefault();

          if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) {
            this.activeIndex--;
          }

          if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) {
            this.activeIndex++;
          }

          this.$active.removeClass('active');
          if (this.activeIndex >= 0) {
            this.$active = $(this.container).children('li').eq(this.activeIndex);
            this.$active.addClass('active');
          }
        }
      }

      /**
       * Handle Input Click
       * @param {Event} e
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick(e) {
        this.open();
      }

      /**
       * Handle Container Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMousedownAndTouchstart",
      value: function _handleContainerMousedownAndTouchstart(e) {
        this._mousedown = true;
      }

      /**
       * Handle Container Mouseup and Touchend
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMouseupAndTouchend",
      value: function _handleContainerMouseupAndTouchend(e) {
        this._mousedown = false;
      }

      /**
       * Highlight partial match
       */

    }, {
      key: "_highlight",
      value: function _highlight(string, $el) {
        var img = $el.find('img');
        var matchStart = $el.text().toLowerCase().indexOf('' + string.toLowerCase() + ''),
            matchEnd = matchStart + string.length - 1,
            beforeMatch = $el.text().slice(0, matchStart),
            matchText = $el.text().slice(matchStart, matchEnd + 1),
            afterMatch = $el.text().slice(matchEnd + 1);
        $el.html("<span>" + beforeMatch + "<span class='highlight'>" + matchText + "</span>" + afterMatch + "</span>");
        if (img.length) {
          $el.prepend(img);
        }
      }

      /**
       * Reset current element position
       */

    }, {
      key: "_resetCurrentElement",
      value: function _resetCurrentElement() {
        this.activeIndex = -1;
        this.$active.removeClass('active');
      }

      /**
       * Reset autocomplete elements
       */

    }, {
      key: "_resetAutocomplete",
      value: function _resetAutocomplete() {
        $(this.container).empty();
        this._resetCurrentElement();
        this.oldVal = null;
        this.isOpen = false;
        this._mousedown = false;
      }

      /**
       * Select autocomplete option
       * @param {Element} el  Autocomplete option list item element
       */

    }, {
      key: "selectOption",
      value: function selectOption(el) {
        var text = el.text().trim();
        this.el.value = text;
        this.$el.trigger('change');
        this._resetAutocomplete();
        this.close();

        // Handle onAutocomplete callback.
        if (typeof this.options.onAutocomplete === 'function') {
          this.options.onAutocomplete.call(this, text);
        }
      }

      /**
       * Render dropdown content
       * @param {Object} data  data set
       * @param {String} val  current input value
       */

    }, {
      key: "_renderDropdown",
      value: function _renderDropdown(data, val) {
        var _this39 = this;

        this._resetAutocomplete();

        var matchingData = [];

        // Gather all matching data
        for (var key in data) {
          if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
            // Break if past limit
            if (this.count >= this.options.limit) {
              break;
            }

            var entry = {
              data: data[key],
              key: key
            };
            matchingData.push(entry);

            this.count++;
          }
        }

        // Sort
        if (this.options.sortFunction) {
          var sortFunctionBound = function (a, b) {
            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
          };
          matchingData.sort(sortFunctionBound);
        }

        // Render
        for (var i = 0; i < matchingData.length; i++) {
          var _entry = matchingData[i];
          var $autocompleteOption = $('<li></li>');
          if (!!_entry.data) {
            $autocompleteOption.append("<img src=\"" + _entry.data + "\" class=\"right circle\"><span>" + _entry.key + "</span>");
          } else {
            $autocompleteOption.append('<span>' + _entry.key + '</span>');
          }

          $(this.container).append($autocompleteOption);
          this._highlight(val, $autocompleteOption);
        }
      }

      /**
       * Open Autocomplete Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        var val = this.el.value.toLowerCase();

        this._resetAutocomplete();

        if (val.length >= this.options.minLength) {
          this.isOpen = true;
          this._renderDropdown(this.options.data, val);
        }

        // Open dropdown
        if (!this.dropdown.isOpen) {
          this.dropdown.open();
        } else {
          // Recalculate dropdown when its already open
          this.dropdown.recalculateDimensions();
        }
      }

      /**
       * Close Autocomplete Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        this.dropdown.close();
      }

      /**
       * Update Data
       * @param {Object} data
       */

    }, {
      key: "updateData",
      value: function updateData(data) {
        var val = this.el.value.toLowerCase();
        this.options.data = data;

        if (this.isOpen) {
          this._renderDropdown(data, val);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Autocomplete;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Autocomplete;
  }(Component);

  /**
   * @static
   * @memberof Autocomplete
   */


  Autocomplete._keydown = false;

  M.Autocomplete = Autocomplete;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Autocomplete, 'autocomplete', 'M_Autocomplete');
  }
})(cash);
;(function ($) {
  // Function to update labels of text fields
  M.updateTextFields = function () {
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
    $(input_selector).each(function (element, index) {
      var $this = $(this);
      if (element.value.length > 0 || $(element).is(':focus') || element.autofocus || $this.attr('placeholder') !== null) {
        $this.siblings('label').addClass('active');
      } else if (element.validity) {
        $this.siblings('label').toggleClass('active', element.validity.badInput === true);
      } else {
        $this.siblings('label').removeClass('active');
      }
    });
  };

  M.validate_field = function (object) {
    var hasLength = object.attr('data-length') !== null;
    var lenAttr = parseInt(object.attr('data-length'));
    var len = object[0].value.length;

    if (len === 0 && object[0].validity.badInput === false && !object.is(':required')) {
      if (object.hasClass('validate')) {
        object.removeClass('valid');
        object.removeClass('invalid');
      }
    } else {
      if (object.hasClass('validate')) {
        // Check for character counter attributes
        if (object.is(':valid') && hasLength && len <= lenAttr || object.is(':valid') && !hasLength) {
          object.removeClass('invalid');
          object.addClass('valid');
        } else {
          object.removeClass('valid');
          object.addClass('invalid');
        }
      }
    }
  };

  M.textareaAutoResize = function ($textarea) {
    // Wrap if native element
    if ($textarea instanceof Element) {
      $textarea = $($textarea);
    }

    if (!$textarea.length) {
      console.error('No textarea element found');
      return;
    }

    // Textarea Auto Resize
    var hiddenDiv = $('.hiddendiv').first();
    if (!hiddenDiv.length) {
      hiddenDiv = $('<div class="hiddendiv common"></div>');
      $('body').append(hiddenDiv);
    }

    // Set font properties of hiddenDiv
    var fontFamily = $textarea.css('font-family');
    var fontSize = $textarea.css('font-size');
    var lineHeight = $textarea.css('line-height');

    // Firefox can't handle padding shorthand.
    var paddingTop = $textarea.css('padding-top');
    var paddingRight = $textarea.css('padding-right');
    var paddingBottom = $textarea.css('padding-bottom');
    var paddingLeft = $textarea.css('padding-left');

    if (fontSize) {
      hiddenDiv.css('font-size', fontSize);
    }
    if (fontFamily) {
      hiddenDiv.css('font-family', fontFamily);
    }
    if (lineHeight) {
      hiddenDiv.css('line-height', lineHeight);
    }
    if (paddingTop) {
      hiddenDiv.css('padding-top', paddingTop);
    }
    if (paddingRight) {
      hiddenDiv.css('padding-right', paddingRight);
    }
    if (paddingBottom) {
      hiddenDiv.css('padding-bottom', paddingBottom);
    }
    if (paddingLeft) {
      hiddenDiv.css('padding-left', paddingLeft);
    }

    // Set original-height, if none
    if (!$textarea.data('original-height')) {
      $textarea.data('original-height', $textarea.height());
    }

    if ($textarea.attr('wrap') === 'off') {
      hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
    }

    hiddenDiv.text($textarea[0].value + '\n');
    var content = hiddenDiv.html().replace(/\n/g, '<br>');
    hiddenDiv.html(content);

    // When textarea is hidden, width goes crazy.
    // Approximate with half of window size

    if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) {
      hiddenDiv.css('width', $textarea.width() + 'px');
    } else {
      hiddenDiv.css('width', window.innerWidth / 2 + 'px');
    }

    /**
     * Resize if the new height is greater than the
     * original height of the textarea
     */
    if ($textarea.data('original-height') <= hiddenDiv.innerHeight()) {
      $textarea.css('height', hiddenDiv.innerHeight() + 'px');
    } else if ($textarea[0].value.length < $textarea.data('previous-length')) {
      /**
       * In case the new height is less than original height, it
       * means the textarea has less text than before
       * So we set the height to the original one
       */
      $textarea.css('height', $textarea.data('original-height') + 'px');
    }
    $textarea.data('previous-length', $textarea[0].value.length);
  };

  $(document).ready(function () {
    // Text based inputs
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';

    // Add active if form auto complete
    $(document).on('change', input_selector, function () {
      if (this.value.length !== 0 || $(this).attr('placeholder') !== null) {
        $(this).siblings('label').addClass('active');
      }
      M.validate_field($(this));
    });

    // Add active if input element has been pre-populated on document ready
    $(document).ready(function () {
      M.updateTextFields();
    });

    // HTML DOM FORM RESET handling
    $(document).on('reset', function (e) {
      var formReset = $(e.target);
      if (formReset.is('form')) {
        formReset.find(input_selector).removeClass('valid').removeClass('invalid');
        formReset.find(input_selector).each(function (e) {
          if (this.value.length) {
            $(this).siblings('label').removeClass('active');
          }
        });

        // Reset select (after native reset)
        setTimeout(function () {
          formReset.find('select').each(function () {
            // check if initialized
            if (this.M_FormSelect) {
              $(this).trigger('change');
            }
          });
        }, 0);
      }
    });

    /**
     * Add active when element has focus
     * @param {Event} e
     */
    document.addEventListener('focus', function (e) {
      if ($(e.target).is(input_selector)) {
        $(e.target).siblings('label, .prefix').addClass('active');
      }
    }, true);

    /**
     * Remove active when element is blurred
     * @param {Event} e
     */
    document.addEventListener('blur', function (e) {
      var $inputElement = $(e.target);
      if ($inputElement.is(input_selector)) {
        var selector = '.prefix';

        if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === null) {
          selector += ', label';
        }
        $inputElement.siblings(selector).removeClass('active');
        M.validate_field($inputElement);
      }
    }, true);

    // Radio and Checkbox focus class
    var radio_checkbox = 'input[type=radio], input[type=checkbox]';
    $(document).on('keyup', radio_checkbox, function (e) {
      // TAB, check if tabbing to radio or checkbox.
      if (e.which === M.keys.TAB) {
        $(this).addClass('tabbed');
        var $this = $(this);
        $this.one('blur', function (e) {
          $(this).removeClass('tabbed');
        });
        return;
      }
    });

    var text_area_selector = '.materialize-textarea';
    $(text_area_selector).each(function () {
      var $textarea = $(this);
      /**
       * Resize textarea on document load after storing
       * the original height and the original length
       */
      $textarea.data('original-height', $textarea.height());
      $textarea.data('previous-length', this.value.length);
      M.textareaAutoResize($textarea);
    });

    $(document).on('keyup', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });
    $(document).on('keydown', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });

    // File Input Path
    $(document).on('change', '.file-field input[type="file"]', function () {
      var file_field = $(this).closest('.file-field');
      var path_input = file_field.find('input.file-path');
      var files = $(this)[0].files;
      var file_names = [];
      for (var i = 0; i < files.length; i++) {
        file_names.push(files[i].name);
      }
      path_input[0].value = file_names.join(', ');
      path_input.trigger('change');
    });
  }); // End of $(document).ready
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    indicators: true,
    height: 400,
    duration: 500,
    interval: 6000
  };

  /**
   * @class
   *
   */

  var Slider = function (_Component11) {
    _inherits(Slider, _Component11);

    /**
     * Construct Slider instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Slider(el, options) {
      _classCallCheck(this, Slider);

      var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));

      _this40.el.M_Slider = _this40;

      /**
       * Options for the modal
       * @member Slider#options
       * @prop {Boolean} [indicators=true] - Show indicators
       * @prop {Number} [height=400] - height of slider
       * @prop {Number} [duration=500] - Length in ms of slide transition
       * @prop {Number} [interval=6000] - Length in ms of slide interval
       */
      _this40.options = $.extend({}, Slider.defaults, options);

      // setup
      _this40.$slider = _this40.$el.find('.slides');
      _this40.$slides = _this40.$slider.children('li');
      _this40.activeIndex = _this40.$slides.filter(function (item) {
        return $(item).hasClass('active');
      }).first().index();
      if (_this40.activeIndex != -1) {
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);
      }

      _this40._setSliderHeight();

      // Set initial positions of captions
      _this40.$slides.find('.caption').each(function (el) {
        _this40._animateCaptionIn(el, 0);
      });

      // Move img src into background-image
      _this40.$slides.find('img').each(function (el) {
        var placeholderBase64 = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        if ($(el).attr('src') !== placeholderBase64) {
          $(el).css('background-image', 'url("' + $(el).attr('src') + '")');
          $(el).attr('src', placeholderBase64);
        }
      });

      _this40._setupIndicators();

      // Show active slide
      if (_this40.$active) {
        _this40.$active.css('display', 'block');
      } else {
        _this40.$slides.first().addClass('active');
        anim({
          targets: _this40.$slides.first()[0],
          opacity: 1,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });

        _this40.activeIndex = 0;
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);

        // Update indicators
        if (_this40.options.indicators) {
          _this40.$indicators.eq(_this40.activeIndex).addClass('active');
        }
      }

      // Adjust height to current slide
      _this40.$active.find('img').each(function (el) {
        anim({
          targets: _this40.$active.find('.caption')[0],
          opacity: 1,
          translateX: 0,
          translateY: 0,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });
      });

      _this40._setupEventHandlers();

      // auto scroll
      _this40.start();
      return _this40;
    }

    _createClass(Slider, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this.pause();
        this._removeIndicators();
        this._removeEventHandlers();
        this.el.M_Slider = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this41 = this;

        this._handleIntervalBound = this._handleInterval.bind(this);
        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.addEventListener('click', _this41._handleIndicatorClickBound);
          });
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this42 = this;

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.removeEventListener('click', _this42._handleIndicatorClickBound);
          });
        }
      }

      /**
       * Handle indicator click
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        var currIndex = $(e.target).index();
        this.set(currIndex);
      }

      /**
       * Handle Interval
       */

    }, {
      key: "_handleInterval",
      value: function _handleInterval() {
        var newActiveIndex = this.$slider.find('.active').index();
        if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0;
        // loop to start
        else newActiveIndex += 1;

        this.set(newActiveIndex);
      }

      /**
       * Animate in caption
       * @param {Element} caption
       * @param {Number} duration
       */

    }, {
      key: "_animateCaptionIn",
      value: function _animateCaptionIn(caption, duration) {
        var animOptions = {
          targets: caption,
          opacity: 0,
          duration: duration,
          easing: 'easeOutQuad'
        };

        if ($(caption).hasClass('center-align')) {
          animOptions.translateY = -100;
        } else if ($(caption).hasClass('right-align')) {
          animOptions.translateX = 100;
        } else if ($(caption).hasClass('left-align')) {
          animOptions.translateX = -100;
        }

        anim(animOptions);
      }

      /**
       * Set height of slider
       */

    }, {
      key: "_setSliderHeight",
      value: function _setSliderHeight() {
        // If fullscreen, do nothing
        if (!this.$el.hasClass('fullscreen')) {
          if (this.options.indicators) {
            // Add height if indicators are present
            this.$el.css('height', this.options.height + 40 + 'px');
          } else {
            this.$el.css('height', this.options.height + 'px');
          }
          this.$slider.css('height', this.options.height + 'px');
        }
      }

      /**
       * Setup indicators
       */

    }, {
      key: "_setupIndicators",
      value: function _setupIndicators() {
        var _this43 = this;

        if (this.options.indicators) {
          this.$indicators = $('<ul class="indicators"></ul>');
          this.$slides.each(function (el, index) {
            var $indicator = $('<li class="indicator-item"></li>');
            _this43.$indicators.append($indicator[0]);
          });
          this.$el.append(this.$indicators[0]);
          this.$indicators = this.$indicators.children('li.indicator-item');
        }
      }

      /**
       * Remove indicators
       */

    }, {
      key: "_removeIndicators",
      value: function _removeIndicators() {
        this.$el.find('ul.indicators').remove();
      }

      /**
       * Cycle to nth item
       * @param {Number} index
       */

    }, {
      key: "set",
      value: function set(index) {
        var _this44 = this;

        // Wrap around indices.
        if (index >= this.$slides.length) index = 0;else if (index < 0) index = this.$slides.length - 1;

        // Only do if index changes
        if (this.activeIndex != index) {
          this.$active = this.$slides.eq(this.activeIndex);
          var $caption = this.$active.find('.caption');
          this.$active.removeClass('active');

          anim({
            targets: this.$active[0],
            opacity: 0,
            duration: this.options.duration,
            easing: 'easeOutQuad',
            complete: function () {
              _this44.$slides.not('.active').each(function (el) {
                anim({
                  targets: el,
                  opacity: 0,
                  translateX: 0,
                  translateY: 0,
                  duration: 0,
                  easing: 'easeOutQuad'
                });
              });
            }
          });

          this._animateCaptionIn($caption[0], this.options.duration);

          // Update indicators
          if (this.options.indicators) {
            this.$indicators.eq(this.activeIndex).removeClass('active');
            this.$indicators.eq(index).addClass('active');
          }

          anim({
            targets: this.$slides.eq(index)[0],
            opacity: 1,
            duration: this.options.duration,
            easing: 'easeOutQuad'
          });

          anim({
            targets: this.$slides.eq(index).find('.caption')[0],
            opacity: 1,
            translateX: 0,
            translateY: 0,
            duration: this.options.duration,
            delay: this.options.duration,
            easing: 'easeOutQuad'
          });

          this.$slides.eq(index).addClass('active');
          this.activeIndex = index;

          // Reset interval
          this.start();
        }
      }

      /**
       * Pause slider interval
       */

    }, {
      key: "pause",
      value: function pause() {
        clearInterval(this.interval);
      }

      /**
       * Start slider interval
       */

    }, {
      key: "start",
      value: function start() {
        clearInterval(this.interval);
        this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
      }

      /**
       * Move to next slide
       */

    }, {
      key: "next",
      value: function next() {
        var newIndex = this.activeIndex + 1;

        // Wrap around indices.
        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;

        this.set(newIndex);
      }

      /**
       * Move to previous slide
       */

    }, {
      key: "prev",
      value: function prev() {
        var newIndex = this.activeIndex - 1;

        // Wrap around indices.
        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;

        this.set(newIndex);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Slider;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Slider;
  }(Component);

  M.Slider = Slider;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Slider, 'slider', 'M_Slider');
  }
})(cash, M.anime);
;(function ($, anim) {
  $(document).on('click', '.card', function (e) {
    if ($(this).children('.card-reveal').length) {
      var $card = $(e.target).closest('.card');
      if ($card.data('initialOverflow') === undefined) {
        $card.data('initialOverflow', $card.css('overflow') === undefined ? '' : $card.css('overflow'));
      }
      var $cardReveal = $(this).find('.card-reveal');
      if ($(e.target).is($('.card-reveal .card-title')) || $(e.target).is($('.card-reveal .card-title i'))) {
        // Make Reveal animate down and display none
        anim({
          targets: $cardReveal[0],
          translateY: 0,
          duration: 225,
          easing: 'easeInOutQuad',
          complete: function (anim) {
            var el = anim.animatables[0].target;
            $(el).css({ display: 'none' });
            $card.css('overflow', $card.data('initialOverflow'));
          }
        });
      } else if ($(e.target).is($('.card .activator')) || $(e.target).is($('.card .activator i'))) {
        $card.css('overflow', 'hidden');
        $cardReveal.css({ display: 'block' });
        anim({
          targets: $cardReveal[0],
          translateY: '-100%',
          duration: 300,
          easing: 'easeInOutQuad'
        });
      }
    }
  });
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    data: [],
    placeholder: '',
    secondaryPlaceholder: '',
    autocompleteOptions: {},
    limit: Infinity,
    onChipAdd: null,
    onChipSelect: null,
    onChipDelete: null
  };

  /**
   * @typedef {Object} chip
   * @property {String} tag  chip tag string
   * @property {String} [image]  chip avatar image string
   */

  /**
   * @class
   *
   */

  var Chips = function (_Component12) {
    _inherits(Chips, _Component12);

    /**
     * Construct Chips instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Chips(el, options) {
      _classCallCheck(this, Chips);

      var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));

      _this45.el.M_Chips = _this45;

      /**
       * Options for the modal
       * @member Chips#options
       * @prop {Array} data
       * @prop {String} placeholder
       * @prop {String} secondaryPlaceholder
       * @prop {Object} autocompleteOptions
       */
      _this45.options = $.extend({}, Chips.defaults, options);

      _this45.$el.addClass('chips input-field');
      _this45.chipsData = [];
      _this45.$chips = $();
      _this45._setupInput();
      _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0;

      // Set input id
      if (!_this45.$input.attr('id')) {
        _this45.$input.attr('id', M.guid());
      }

      // Render initial chips
      if (_this45.options.data.length) {
        _this45.chipsData = _this45.options.data;
        _this45._renderChips(_this45.chipsData);
      }

      // Setup autocomplete if needed
      if (_this45.hasAutocomplete) {
        _this45._setupAutocomplete();
      }

      _this45._setPlaceholder();
      _this45._setupLabel();
      _this45._setupEventHandlers();
      return _this45;
    }

    _createClass(Chips, [{
      key: "getData",


      /**
       * Get Chips Data
       */
      value: function getData() {
        return this.chipsData;
      }

      /**
       * Teardown component
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._removeEventHandlers();
        this.$chips.remove();
        this.el.M_Chips = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleChipClickBound = this._handleChipClick.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputFocusBound = this._handleInputFocus.bind(this);
        this._handleInputBlurBound = this._handleInputBlur.bind(this);

        this.el.addEventListener('click', this._handleChipClickBound);
        document.addEventListener('keydown', Chips._handleChipsKeydown);
        document.addEventListener('keyup', Chips._handleChipsKeyup);
        this.el.addEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].addEventListener('focus', this._handleInputFocusBound);
        this.$input[0].addEventListener('blur', this._handleInputBlurBound);
        this.$input[0].addEventListener('keydown', this._handleInputKeydownBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleChipClickBound);
        document.removeEventListener('keydown', Chips._handleChipsKeydown);
        document.removeEventListener('keyup', Chips._handleChipsKeyup);
        this.el.removeEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].removeEventListener('focus', this._handleInputFocusBound);
        this.$input[0].removeEventListener('blur', this._handleInputBlurBound);
        this.$input[0].removeEventListener('keydown', this._handleInputKeydownBound);
      }

      /**
       * Handle Chip Click
       * @param {Event} e
       */

    }, {
      key: "_handleChipClick",
      value: function _handleChipClick(e) {
        var $chip = $(e.target).closest('.chip');
        var clickedClose = $(e.target).is('.close');
        if ($chip.length) {
          var index = $chip.index();
          if (clickedClose) {
            // delete chip
            this.deleteChip(index);
            this.$input[0].focus();
          } else {
            // select chip
            this.selectChip(index);
          }

          // Default handle click to focus on input
        } else {
          this.$input[0].focus();
        }
      }

      /**
       * Handle Chips Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputFocus",


      /**
       * Handle Input Focus
       */
      value: function _handleInputFocus() {
        this.$el.addClass('focus');
      }

      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        this.$el.removeClass('focus');
      }

      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Chips._keydown = true;

        // enter
        if (e.keyCode === 13) {
          // Override enter if autocompleting.
          if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) {
            return;
          }

          e.preventDefault();
          this.addChip({
            tag: this.$input[0].value
          });
          this.$input[0].value = '';

          // delete or left
        } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === '' && this.chipsData.length) {
          e.preventDefault();
          this.selectChip(this.chipsData.length - 1);
        }
      }

      /**
       * Render Chip
       * @param {chip} chip
       * @return {Element}
       */

    }, {
      key: "_renderChip",
      value: function _renderChip(chip) {
        if (!chip.tag) {
          return;
        }

        var renderedChip = document.createElement('div');
        var closeIcon = document.createElement('i');
        renderedChip.classList.add('chip');
        renderedChip.textContent = chip.tag;
        renderedChip.setAttribute('tabindex', 0);
        $(closeIcon).addClass('material-icons close');
        closeIcon.textContent = 'close';

        // attach image if needed
        if (chip.image) {
          var img = document.createElement('img');
          img.setAttribute('src', chip.image);
          renderedChip.insertBefore(img, renderedChip.firstChild);
        }

        renderedChip.appendChild(closeIcon);
        return renderedChip;
      }

      /**
       * Render Chips
       */

    }, {
      key: "_renderChips",
      value: function _renderChips() {
        this.$chips.remove();
        for (var i = 0; i < this.chipsData.length; i++) {
          var chipEl = this._renderChip(this.chipsData[i]);
          this.$el.append(chipEl);
          this.$chips.add(chipEl);
        }

        // move input to end
        this.$el.append(this.$input[0]);
      }

      /**
       * Setup Autocomplete
       */

    }, {
      key: "_setupAutocomplete",
      value: function _setupAutocomplete() {
        var _this46 = this;

        this.options.autocompleteOptions.onAutocomplete = function (val) {
          _this46.addChip({
            tag: val
          });
          _this46.$input[0].value = '';
          _this46.$input[0].focus();
        };

        this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
      }

      /**
       * Setup Input
       */

    }, {
      key: "_setupInput",
      value: function _setupInput() {
        this.$input = this.$el.find('input');
        if (!this.$input.length) {
          this.$input = $('<input></input>');
          this.$el.append(this.$input);
        }

        this.$input.addClass('input');
      }

      /**
       * Setup Label
       */

    }, {
      key: "_setupLabel",
      value: function _setupLabel() {
        this.$label = this.$el.find('label');
        if (this.$label.length) {
          this.$label.setAttribute('for', this.$input.attr('id'));
        }
      }

      /**
       * Set placeholder
       */

    }, {
      key: "_setPlaceholder",
      value: function _setPlaceholder() {
        if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) {
          $(this.$input).prop('placeholder', this.options.placeholder);
        } else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) {
          $(this.$input).prop('placeholder', this.options.secondaryPlaceholder);
        }
      }

      /**
       * Check if chip is valid
       * @param {chip} chip
       */

    }, {
      key: "_isValid",
      value: function _isValid(chip) {
        if (chip.hasOwnProperty('tag') && chip.tag !== '') {
          var exists = false;
          for (var i = 0; i < this.chipsData.length; i++) {
            if (this.chipsData[i].tag === chip.tag) {
              exists = true;
              break;
            }
          }
          return !exists;
        }

        return false;
      }

      /**
       * Add chip
       * @param {chip} chip
       */

    }, {
      key: "addChip",
      value: function addChip(chip) {
        if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) {
          return;
        }

        var renderedChip = this._renderChip(chip);
        this.$chips.add(renderedChip);
        this.chipsData.push(chip);
        $(this.$input).before(renderedChip);
        this._setPlaceholder();

        // fire chipAdd callback
        if (typeof this.options.onChipAdd === 'function') {
          this.options.onChipAdd.call(this, this.$el, renderedChip);
        }
      }

      /**
       * Delete chip
       * @param {Number} chip
       */

    }, {
      key: "deleteChip",
      value: function deleteChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this.$chips.eq(chipIndex).remove();
        this.$chips = this.$chips.filter(function (el) {
          return $(el).index() >= 0;
        });
        this.chipsData.splice(chipIndex, 1);
        this._setPlaceholder();

        // fire chipDelete callback
        if (typeof this.options.onChipDelete === 'function') {
          this.options.onChipDelete.call(this, this.$el, $chip[0]);
        }
      }

      /**
       * Select chip
       * @param {Number} chip
       */

    }, {
      key: "selectChip",
      value: function selectChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this._selectedChip = $chip;
        $chip[0].focus();

        // fire chipSelect callback
        if (typeof this.options.onChipSelect === 'function') {
          this.options.onChipSelect.call(this, this.$el, $chip[0]);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Chips;
      }
    }, {
      key: "_handleChipsKeydown",
      value: function _handleChipsKeydown(e) {
        Chips._keydown = true;

        var $chips = $(e.target).closest('.chips');
        var chipsKeydown = e.target && $chips.length;

        // Don't handle keydown inputs on input and textarea
        if ($(e.target).is('input, textarea') || !chipsKeydown) {
          return;
        }

        var currChips = $chips[0].M_Chips;

        // backspace and delete
        if (e.keyCode === 8 || e.keyCode === 46) {
          e.preventDefault();

          var selectIndex = currChips.chipsData.length;
          if (currChips._selectedChip) {
            var index = currChips._selectedChip.index();
            currChips.deleteChip(index);
            currChips._selectedChip = null;

            // Make sure selectIndex doesn't go negative
            selectIndex = Math.max(index - 1, 0);
          }

          if (currChips.chipsData.length) {
            currChips.selectChip(selectIndex);
          }

          // left arrow key
        } else if (e.keyCode === 37) {
          if (currChips._selectedChip) {
            var _selectIndex = currChips._selectedChip.index() - 1;
            if (_selectIndex < 0) {
              return;
            }
            currChips.selectChip(_selectIndex);
          }

          // right arrow key
        } else if (e.keyCode === 39) {
          if (currChips._selectedChip) {
            var _selectIndex2 = currChips._selectedChip.index() + 1;

            if (_selectIndex2 >= currChips.chipsData.length) {
              currChips.$input[0].focus();
            } else {
              currChips.selectChip(_selectIndex2);
            }
          }
        }
      }

      /**
       * Handle Chips Keyup
       * @param {Event} e
       */

    }, {
      key: "_handleChipsKeyup",
      value: function _handleChipsKeyup(e) {
        Chips._keydown = false;
      }

      /**
       * Handle Chips Blur
       * @param {Event} e
       */

    }, {
      key: "_handleChipsBlur",
      value: function _handleChipsBlur(e) {
        if (!Chips._keydown) {
          var $chips = $(e.target).closest('.chips');
          var currChips = $chips[0].M_Chips;

          currChips._selectedChip = null;
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Chips;
  }(Component);

  /**
   * @static
   * @memberof Chips
   */


  Chips._keydown = false;

  M.Chips = Chips;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Chips, 'chips', 'M_Chips');
  }

  $(document).ready(function () {
    // Handle removal of static chips.
    $(document.body).on('click', '.chip .close', function () {
      var $chips = $(this).closest('.chips');
      if ($chips.length && $chips[0].M_Chips) {
        return;
      }
      $(this).closest('.chip').remove();
    });
  });
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    top: 0,
    bottom: Infinity,
    offset: 0,
    onPositionChange: null
  };

  /**
   * @class
   *
   */

  var Pushpin = function (_Component13) {
    _inherits(Pushpin, _Component13);

    /**
     * Construct Pushpin instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Pushpin(el, options) {
      _classCallCheck(this, Pushpin);

      var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));

      _this47.el.M_Pushpin = _this47;

      /**
       * Options for the modal
       * @member Pushpin#options
       */
      _this47.options = $.extend({}, Pushpin.defaults, options);

      _this47.originalOffset = _this47.el.offsetTop;
      Pushpin._pushpins.push(_this47);
      _this47._setupEventHandlers();
      _this47._updatePosition();
      return _this47;
    }

    _createClass(Pushpin, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this.el.style.top = null;
        this._removePinClasses();
        this._removeEventHandlers();

        // Remove pushpin Inst
        var index = Pushpin._pushpins.indexOf(this);
        Pushpin._pushpins.splice(index, 1);
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        document.addEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        document.removeEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_updatePosition",
      value: function _updatePosition() {
        var scrolled = M.getDocumentScrollTop() + this.options.offset;

        if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains('pinned')) {
          this._removePinClasses();
          this.el.style.top = this.options.offset + "px";
          this.el.classList.add('pinned');

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pinned');
          }
        }

        // Add pin-top (when scrolled position is above top)
        if (scrolled < this.options.top && !this.el.classList.contains('pin-top')) {
          this._removePinClasses();
          this.el.style.top = 0;
          this.el.classList.add('pin-top');

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pin-top');
          }
        }

        // Add pin-bottom (when scrolled position is below bottom)
        if (scrolled > this.options.bottom && !this.el.classList.contains('pin-bottom')) {
          this._removePinClasses();
          this.el.classList.add('pin-bottom');
          this.el.style.top = this.options.bottom - this.originalOffset + "px";

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pin-bottom');
          }
        }
      }
    }, {
      key: "_removePinClasses",
      value: function _removePinClasses() {
        // IE 11 bug (can't remove multiple classes in one line)
        this.el.classList.remove('pin-top');
        this.el.classList.remove('pinned');
        this.el.classList.remove('pin-bottom');
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Pushpin;
      }
    }, {
      key: "_updateElements",
      value: function _updateElements() {
        for (var elIndex in Pushpin._pushpins) {
          var pInstance = Pushpin._pushpins[elIndex];
          pInstance._updatePosition();
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Pushpin;
  }(Component);

  /**
   * @static
   * @memberof Pushpin
   */


  Pushpin._pushpins = [];

  M.Pushpin = Pushpin;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Pushpin, 'pushpin', 'M_Pushpin');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    direction: 'top',
    hoverEnabled: true,
    toolbarEnabled: false
  };

  $.fn.reverse = [].reverse;

  /**
   * @class
   *
   */

  var FloatingActionButton = function (_Component14) {
    _inherits(FloatingActionButton, _Component14);

    /**
     * Construct FloatingActionButton instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function FloatingActionButton(el, options) {
      _classCallCheck(this, FloatingActionButton);

      var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));

      _this48.el.M_FloatingActionButton = _this48;

      /**
       * Options for the fab
       * @member FloatingActionButton#options
       * @prop {Boolean} [direction] - Direction fab menu opens
       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
       */
      _this48.options = $.extend({}, FloatingActionButton.defaults, options);

      _this48.isOpen = false;
      _this48.$anchor = _this48.$el.children('a').first();
      _this48.$menu = _this48.$el.children('ul').first();
      _this48.$floatingBtns = _this48.$el.find('ul .btn-floating');
      _this48.$floatingBtnsReverse = _this48.$el.find('ul .btn-floating').reverse();
      _this48.offsetY = 0;
      _this48.offsetX = 0;

      _this48.$el.addClass("direction-" + _this48.options.direction);
      if (_this48.options.direction === 'top') {
        _this48.offsetY = 40;
      } else if (_this48.options.direction === 'right') {
        _this48.offsetX = -40;
      } else if (_this48.options.direction === 'bottom') {
        _this48.offsetY = -40;
      } else {
        _this48.offsetX = 40;
      }
      _this48._setupEventHandlers();
      return _this48;
    }

    _createClass(FloatingActionButton, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_FloatingActionButton = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleFABClickBound = this._handleFABClick.bind(this);
        this._handleOpenBound = this.open.bind(this);
        this._handleCloseBound = this.close.bind(this);

        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.addEventListener('mouseenter', this._handleOpenBound);
          this.el.addEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.addEventListener('click', this._handleFABClickBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.removeEventListener('mouseenter', this._handleOpenBound);
          this.el.removeEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.removeEventListener('click', this._handleFABClickBound);
        }
      }

      /**
       * Handle FAB Click
       */

    }, {
      key: "_handleFABClick",
      value: function _handleFABClick() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handle Document Click
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest(this.$menu).length) {
          this.close();
        }
      }

      /**
       * Open FAB
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          this._animateInToolbar();
        } else {
          this._animateInFAB();
        }
        this.isOpen = true;
      }

      /**
       * Close FAB
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          window.removeEventListener('scroll', this._handleCloseBound, true);
          document.body.removeEventListener('click', this._handleDocumentClickBound, true);
          this._animateOutToolbar();
        } else {
          this._animateOutFAB();
        }
        this.isOpen = false;
      }

      /**
       * Classic FAB Menu open
       */

    }, {
      key: "_animateInFAB",
      value: function _animateInFAB() {
        var _this49 = this;

        this.$el.addClass('active');

        var time = 0;
        this.$floatingBtnsReverse.each(function (el) {
          anim({
            targets: el,
            opacity: 1,
            scale: [0.4, 1],
            translateY: [_this49.offsetY, 0],
            translateX: [_this49.offsetX, 0],
            duration: 275,
            delay: time,
            easing: 'easeInOutQuad'
          });
          time += 40;
        });
      }

      /**
       * Classic FAB Menu close
       */

    }, {
      key: "_animateOutFAB",
      value: function _animateOutFAB() {
        var _this50 = this;

        this.$floatingBtnsReverse.each(function (el) {
          anim.remove(el);
          anim({
            targets: el,
            opacity: 0,
            scale: 0.4,
            translateY: _this50.offsetY,
            translateX: _this50.offsetX,
            duration: 175,
            easing: 'easeOutQuad',
            complete: function () {
              _this50.$el.removeClass('active');
            }
          });
        });
      }

      /**
       * Toolbar transition Menu open
       */

    }, {
      key: "_animateInToolbar",
      value: function _animateInToolbar() {
        var _this51 = this;

        var scaleFactor = void 0;
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var btnRect = this.el.getBoundingClientRect();
        var backdrop = $('<div class="fab-backdrop"></div>');
        var fabColor = this.$anchor.css('background-color');
        this.$anchor.append(backdrop);

        this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
        this.offsetY = windowHeight - btnRect.bottom;
        scaleFactor = windowWidth / backdrop[0].clientWidth;
        this.btnBottom = btnRect.bottom;
        this.btnLeft = btnRect.left;
        this.btnWidth = btnRect.width;

        // Set initial state
        this.$el.addClass('active');
        this.$el.css({
          'text-align': 'center',
          width: '100%',
          bottom: 0,
          left: 0,
          transform: 'translateX(' + this.offsetX + 'px)',
          transition: 'none'
        });
        this.$anchor.css({
          transform: 'translateY(' + -this.offsetY + 'px)',
          transition: 'none'
        });
        backdrop.css({
          'background-color': fabColor
        });

        setTimeout(function () {
          _this51.$el.css({
            transform: '',
            transition: 'transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s'
          });
          _this51.$anchor.css({
            overflow: 'visible',
            transform: '',
            transition: 'transform .2s'
          });

          setTimeout(function () {
            _this51.$el.css({
              overflow: 'hidden',
              'background-color': fabColor
            });
            backdrop.css({
              transform: 'scale(' + scaleFactor + ')',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
            _this51.$menu.children('li').children('a').css({
              opacity: 1
            });

            // Scroll to close.
            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
            window.addEventListener('scroll', _this51._handleCloseBound, true);
            document.body.addEventListener('click', _this51._handleDocumentClickBound, true);
          }, 100);
        }, 0);
      }

      /**
       * Toolbar transition Menu close
       */

    }, {
      key: "_animateOutToolbar",
      value: function _animateOutToolbar() {
        var _this52 = this;

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var backdrop = this.$el.find('.fab-backdrop');
        var fabColor = this.$anchor.css('background-color');

        this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
        this.offsetY = windowHeight - this.btnBottom;

        // Hide backdrop
        this.$el.removeClass('active');
        this.$el.css({
          'background-color': 'transparent',
          transition: 'none'
        });
        this.$anchor.css({
          transition: 'none'
        });
        backdrop.css({
          transform: 'scale(0)',
          'background-color': fabColor
        });
        this.$menu.children('li').children('a').css({
          opacity: ''
        });

        setTimeout(function () {
          backdrop.remove();

          // Set initial state.
          _this52.$el.css({
            'text-align': '',
            width: '',
            bottom: '',
            left: '',
            overflow: '',
            'background-color': '',
            transform: 'translate3d(' + -_this52.offsetX + 'px,0,0)'
          });
          _this52.$anchor.css({
            overflow: '',
            transform: 'translate3d(0,' + _this52.offsetY + 'px,0)'
          });

          setTimeout(function () {
            _this52.$el.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s'
            });
            _this52.$anchor.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
          }, 20);
        }, 200);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FloatingActionButton;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return FloatingActionButton;
  }(Component);

  M.FloatingActionButton = FloatingActionButton;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FloatingActionButton, 'floatingActionButton', 'M_FloatingActionButton');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    // Close when date is selected
    autoClose: false,

    // the default output format for the input field value
    format: 'mmm dd, yyyy',

    // Used to create date object from current input string
    parse: null,

    // The initial date to view when first opened
    defaultDate: null,

    // Make the `defaultDate` the initial selected value
    setDefaultDate: false,

    disableWeekends: false,

    disableDayFn: null,

    // First day of week (0: Sunday, 1: Monday etc)
    firstDay: 0,

    // The earliest date that can be selected
    minDate: null,
    // Thelatest date that can be selected
    maxDate: null,

    // Number of years either side, or array of upper/lower range
    yearRange: 10,

    // used internally (don't config outside)
    minYear: 0,
    maxYear: 9999,
    minMonth: undefined,
    maxMonth: undefined,

    startRange: null,
    endRange: null,

    isRTL: false,

    // Render the month after year in the calendar title
    showMonthAfterYear: false,

    // Render days of the calendar grid that fall in the next or previous month
    showDaysInNextAndPreviousMonths: false,

    // Specify a DOM element to render the calendar in
    container: null,

    // Show clear button
    showClearBtn: false,

    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok',
      previousMonth: '‹',
      nextMonth: '›',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },

    // events array
    events: [],

    // callback function
    onSelect: null,
    onOpen: null,
    onClose: null,
    onDraw: null
  };

  /**
   * @class
   *
   */

  var Datepicker = function (_Component15) {
    _inherits(Datepicker, _Component15);

    /**
     * Construct Datepicker instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Datepicker(el, options) {
      _classCallCheck(this, Datepicker);

      var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));

      _this53.el.M_Datepicker = _this53;

      _this53.options = $.extend({}, Datepicker.defaults, options);

      // make sure i18n defaults are not lost when only few i18n option properties are passed
      if (!!options && options.hasOwnProperty('i18n') && typeof options.i18n === 'object') {
        _this53.options.i18n = $.extend({}, Datepicker.defaults.i18n, options.i18n);
      }

      // Remove time component from minDate and maxDate options
      if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
      if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);

      _this53.id = M.guid();

      _this53._setupVariables();
      _this53._insertHTMLIntoDOM();
      _this53._setupModal();

      _this53._setupEventHandlers();

      if (!_this53.options.defaultDate) {
        _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
      }

      var defDate = _this53.options.defaultDate;
      if (Datepicker._isDate(defDate)) {
        if (_this53.options.setDefaultDate) {
          _this53.setDate(defDate, true);
          _this53.setInputValue();
        } else {
          _this53.gotoDate(defDate);
        }
      } else {
        _this53.gotoDate(new Date());
      }

      /**
       * Describes open/close state of datepicker
       * @type {Boolean}
       */
      _this53.isOpen = false;
      return _this53;
    }

    _createClass(Datepicker, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.modal.destroy();
        $(this.modalEl).remove();
        this.destroySelects();
        this.el.M_Datepicker = undefined;
      }
    }, {
      key: "destroySelects",
      value: function destroySelects() {
        var oldYearSelect = this.calendarEl.querySelector('.orig-select-year');
        if (oldYearSelect) {
          M.FormSelect.getInstance(oldYearSelect).destroy();
        }
        var oldMonthSelect = this.calendarEl.querySelector('.orig-select-month');
        if (oldMonthSelect) {
          M.FormSelect.getInstance(oldMonthSelect).destroy();
        }
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        if (this.options.showClearBtn) {
          $(this.clearBtn).css({ visibility: '' });
          this.clearBtn.innerHTML = this.options.i18n.clear;
        }

        this.doneBtn.innerHTML = this.options.i18n.done;
        this.cancelBtn.innerHTML = this.options.i18n.cancel;

        if (this.options.container) {
          this.$modalEl.appendTo(this.options.container);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this54 = this;

        this.modalEl.id = 'modal-' + this.id;
        this.modal = M.Modal.init(this.modalEl, {
          onCloseEnd: function () {
            _this54.isOpen = false;
          }
        });
      }
    }, {
      key: "toString",
      value: function toString(format) {
        var _this55 = this;

        format = format || this.options.format;
        if (!Datepicker._isDate(this.date)) {
          return '';
        }

        var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
        var formattedDate = formatArray.map(function (label) {
          if (_this55.formats[label]) {
            return _this55.formats[label]();
          }

          return label;
        }).join('');
        return formattedDate;
      }
    }, {
      key: "setDate",
      value: function setDate(date, preventOnSelect) {
        if (!date) {
          this.date = null;
          this._renderDateDisplay();
          return this.draw();
        }
        if (typeof date === 'string') {
          date = new Date(Date.parse(date));
        }
        if (!Datepicker._isDate(date)) {
          return;
        }

        var min = this.options.minDate,
            max = this.options.maxDate;

        if (Datepicker._isDate(min) && date < min) {
          date = min;
        } else if (Datepicker._isDate(max) && date > max) {
          date = max;
        }

        this.date = new Date(date.getTime());

        this._renderDateDisplay();

        Datepicker._setToStartOfDay(this.date);
        this.gotoDate(this.date);

        if (!preventOnSelect && typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.date);
        }
      }
    }, {
      key: "setInputValue",
      value: function setInputValue() {
        this.el.value = this.toString();
        this.$el.trigger('change', { firedBy: this });
      }
    }, {
      key: "_renderDateDisplay",
      value: function _renderDateDisplay() {
        var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
        var i18n = this.options.i18n;
        var day = i18n.weekdaysShort[displayDate.getDay()];
        var month = i18n.monthsShort[displayDate.getMonth()];
        var date = displayDate.getDate();
        this.yearTextEl.innerHTML = displayDate.getFullYear();
        this.dateTextEl.innerHTML = day + ", " + month + " " + date;
      }

      /**
       * change view to a specific date
       */

    }, {
      key: "gotoDate",
      value: function gotoDate(date) {
        var newCalendar = true;

        if (!Datepicker._isDate(date)) {
          return;
        }

        if (this.calendars) {
          var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
              lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
              visibleDate = date.getTime();
          // get the end of the month
          lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
          lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
          newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
        }

        if (newCalendar) {
          this.calendars = [{
            month: date.getMonth(),
            year: date.getFullYear()
          }];
        }

        this.adjustCalendars();
      }
    }, {
      key: "adjustCalendars",
      value: function adjustCalendars() {
        this.calendars[0] = this.adjustCalendar(this.calendars[0]);
        this.draw();
      }
    }, {
      key: "adjustCalendar",
      value: function adjustCalendar(calendar) {
        if (calendar.month < 0) {
          calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
          calendar.month += 12;
        }
        if (calendar.month > 11) {
          calendar.year += Math.floor(Math.abs(calendar.month) / 12);
          calendar.month -= 12;
        }
        return calendar;
      }
    }, {
      key: "nextMonth",
      value: function nextMonth() {
        this.calendars[0].month++;
        this.adjustCalendars();
      }
    }, {
      key: "prevMonth",
      value: function prevMonth() {
        this.calendars[0].month--;
        this.adjustCalendars();
      }
    }, {
      key: "render",
      value: function render(year, month, randId) {
        var opts = this.options,
            now = new Date(),
            days = Datepicker._getDaysInMonth(year, month),
            before = new Date(year, month, 1).getDay(),
            data = [],
            row = [];
        Datepicker._setToStartOfDay(now);
        if (opts.firstDay > 0) {
          before -= opts.firstDay;
          if (before < 0) {
            before += 7;
          }
        }
        var previousMonth = month === 0 ? 11 : month - 1,
            nextMonth = month === 11 ? 0 : month + 1,
            yearOfPreviousMonth = month === 0 ? year - 1 : year,
            yearOfNextMonth = month === 11 ? year + 1 : year,
            daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);
        var cells = days + before,
            after = cells;
        while (after > 7) {
          after -= 7;
        }
        cells += 7 - after;
        var isWeekSelected = false;
        for (var i = 0, r = 0; i < cells; i++) {
          var day = new Date(year, month, 1 + (i - before)),
              isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false,
              isToday = Datepicker._compareDates(day, now),
              hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
              isEmpty = i < before || i >= days + before,
              dayNumber = 1 + (i - before),
              monthNumber = month,
              yearNumber = year,
              isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day),
              isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day),
              isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
              isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);

          if (isEmpty) {
            if (i < before) {
              dayNumber = daysInPreviousMonth + dayNumber;
              monthNumber = previousMonth;
              yearNumber = yearOfPreviousMonth;
            } else {
              dayNumber = dayNumber - days;
              monthNumber = nextMonth;
              yearNumber = yearOfNextMonth;
            }
          }

          var dayConfig = {
            day: dayNumber,
            month: monthNumber,
            year: yearNumber,
            hasEvent: hasEvent,
            isSelected: isSelected,
            isToday: isToday,
            isDisabled: isDisabled,
            isEmpty: isEmpty,
            isStartRange: isStartRange,
            isEndRange: isEndRange,
            isInRange: isInRange,
            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
          };

          row.push(this.renderDay(dayConfig));

          if (++r === 7) {
            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
            row = [];
            r = 0;
            isWeekSelected = false;
          }
        }
        return this.renderTable(opts, data, randId);
      }
    }, {
      key: "renderDay",
      value: function renderDay(opts) {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
          if (opts.showDaysInNextAndPreviousMonths) {
            arr.push('is-outside-current-month');
            arr.push('is-selection-disabled');
          } else {
            return '<td class="is-empty"></td>';
          }
        }
        if (opts.isDisabled) {
          arr.push('is-disabled');
        }

        if (opts.isToday) {
          arr.push('is-today');
        }
        if (opts.isSelected) {
          arr.push('is-selected');
          ariaSelected = 'true';
        }
        if (opts.hasEvent) {
          arr.push('has-event');
        }
        if (opts.isInRange) {
          arr.push('is-inrange');
        }
        if (opts.isStartRange) {
          arr.push('is-startrange');
        }
        if (opts.isEndRange) {
          arr.push('is-endrange');
        }
        return "<td data-day=\"" + opts.day + "\" class=\"" + arr.join(' ') + "\" aria-selected=\"" + ariaSelected + "\">" + ("<button class=\"datepicker-day-button\" type=\"button\" data-year=\"" + opts.year + "\" data-month=\"" + opts.month + "\" data-day=\"" + opts.day + "\">" + opts.day + "</button>") + '</td>';
      }
    }, {
      key: "renderRow",
      value: function renderRow(days, isRTL, isRowSelected) {
        return '<tr class="datepicker-row' + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
      }
    }, {
      key: "renderTable",
      value: function renderTable(opts, data, randId) {
        return '<div class="datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + '</table></div>';
      }
    }, {
      key: "renderHead",
      value: function renderHead(opts) {
        var i = void 0,
            arr = [];
        for (i = 0; i < 7; i++) {
          arr.push("<th scope=\"col\"><abbr title=\"" + this.renderDayName(opts, i) + "\">" + this.renderDayName(opts, i, true) + "</abbr></th>");
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
      }
    }, {
      key: "renderBody",
      value: function renderBody(rows) {
        return '<tbody>' + rows.join('') + '</tbody>';
      }
    }, {
      key: "renderTitle",
      value: function renderTitle(instance, c, year, month, refYear, randId) {
        var i = void 0,
            j = void 0,
            arr = void 0,
            opts = this.options,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="datepicker-controls" role="heading" aria-live="assertive">',
            monthHtml = void 0,
            yearHtml = void 0,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
          arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<select class="datepicker-select orig-select-month" tabindex="-1">' + arr.join('') + '</select>';

        if ($.isArray(opts.yearRange)) {
          i = opts.yearRange[0];
          j = opts.yearRange[1] + 1;
        } else {
          i = year - opts.yearRange;
          j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
          if (i >= opts.minYear) {
            arr.push("<option value=\"" + i + "\" " + (i === year ? 'selected="selected"' : '') + ">" + i + "</option>");
          }
        }

        yearHtml = "<select class=\"datepicker-select orig-select-year\" tabindex=\"-1\">" + arr.join('') + "</select>";

        var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"month-prev" + (prev ? '' : ' is-disabled') + "\" type=\"button\">" + leftArrow + "</button>";

        html += '<div class="selects-container">';
        if (opts.showMonthAfterYear) {
          html += yearHtml + monthHtml;
        } else {
          html += monthHtml + yearHtml;
        }
        html += '</div>';

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
          prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
          next = false;
        }

        var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"month-next" + (next ? '' : ' is-disabled') + "\" type=\"button\">" + rightArrow + "</button>";

        return html += '</div>';
      }

      /**
       * refresh the HTML
       */

    }, {
      key: "draw",
      value: function draw(force) {
        if (!this.isOpen && !force) {
          return;
        }
        var opts = this.options,
            minYear = opts.minYear,
            maxYear = opts.maxYear,
            minMonth = opts.minMonth,
            maxMonth = opts.maxMonth,
            html = '',
            randId = void 0;

        if (this._y <= minYear) {
          this._y = minYear;
          if (!isNaN(minMonth) && this._m < minMonth) {
            this._m = minMonth;
          }
        }
        if (this._y >= maxYear) {
          this._y = maxYear;
          if (!isNaN(maxMonth) && this._m > maxMonth) {
            this._m = maxMonth;
          }
        }

        randId = 'datepicker-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

        for (var c = 0; c < 1; c++) {
          this._renderDateDisplay();
          html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
        }

        this.destroySelects();

        this.calendarEl.innerHTML = html;

        // Init Materialize Select
        var yearSelect = this.calendarEl.querySelector('.orig-select-year');
        var monthSelect = this.calendarEl.querySelector('.orig-select-month');
        M.FormSelect.init(yearSelect, {
          classes: 'select-year',
          dropdownOptions: { container: document.body, constrainWidth: false }
        });
        M.FormSelect.init(monthSelect, {
          classes: 'select-month',
          dropdownOptions: { container: document.body, constrainWidth: false }
        });

        // Add change handlers for select
        yearSelect.addEventListener('change', this._handleYearChange.bind(this));
        monthSelect.addEventListener('change', this._handleMonthChange.bind(this));

        if (typeof this.options.onDraw === 'function') {
          this.options.onDraw(this);
        }
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleInputChangeBound = this._handleInputChange.bind(this);
        this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
        this._finishSelectionBound = this._finishSelection.bind(this);
        this._handleMonthChange = this._handleMonthChange.bind(this);
        this._closeBound = this.close.bind(this);

        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('change', this._handleInputChangeBound);
        this.calendarEl.addEventListener('click', this._handleCalendarClickBound);
        this.doneBtn.addEventListener('click', this._finishSelectionBound);
        this.cancelBtn.addEventListener('click', this._closeBound);

        if (this.options.showClearBtn) {
          this._handleClearClickBound = this._handleClearClick.bind(this);
          this.clearBtn.addEventListener('click', this._handleClearClickBound);
        }
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        var _this56 = this;

        this.$modalEl = $(Datepicker._template);
        this.modalEl = this.$modalEl[0];

        this.calendarEl = this.modalEl.querySelector('.datepicker-calendar');

        this.yearTextEl = this.modalEl.querySelector('.year-text');
        this.dateTextEl = this.modalEl.querySelector('.date-text');
        if (this.options.showClearBtn) {
          this.clearBtn = this.modalEl.querySelector('.datepicker-clear');
        }
        this.doneBtn = this.modalEl.querySelector('.datepicker-done');
        this.cancelBtn = this.modalEl.querySelector('.datepicker-cancel');

        this.formats = {
          d: function () {
            return _this56.date.getDate();
          },
          dd: function () {
            var d = _this56.date.getDate();
            return (d < 10 ? '0' : '') + d;
          },
          ddd: function () {
            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
          },
          dddd: function () {
            return _this56.options.i18n.weekdays[_this56.date.getDay()];
          },
          m: function () {
            return _this56.date.getMonth() + 1;
          },
          mm: function () {
            var m = _this56.date.getMonth() + 1;
            return (m < 10 ? '0' : '') + m;
          },
          mmm: function () {
            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
          },
          mmmm: function () {
            return _this56.options.i18n.months[_this56.date.getMonth()];
          },
          yy: function () {
            return ('' + _this56.date.getFullYear()).slice(2);
          },
          yyyy: function () {
            return _this56.date.getFullYear();
          }
        };
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('change', this._handleInputChangeBound);
        this.calendarEl.removeEventListener('click', this._handleCalendarClickBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleCalendarClick",
      value: function _handleCalendarClick(e) {
        if (!this.isOpen) {
          return;
        }

        var $target = $(e.target);
        if (!$target.hasClass('is-disabled')) {
          if ($target.hasClass('datepicker-day-button') && !$target.hasClass('is-empty') && !$target.parent().hasClass('is-disabled')) {
            this.setDate(new Date(e.target.getAttribute('data-year'), e.target.getAttribute('data-month'), e.target.getAttribute('data-day')));
            if (this.options.autoClose) {
              this._finishSelection();
            }
          } else if ($target.closest('.month-prev').length) {
            this.prevMonth();
          } else if ($target.closest('.month-next').length) {
            this.nextMonth();
          }
        }
      }
    }, {
      key: "_handleClearClick",
      value: function _handleClearClick() {
        this.date = null;
        this.setInputValue();
        this.close();
      }
    }, {
      key: "_handleMonthChange",
      value: function _handleMonthChange(e) {
        this.gotoMonth(e.target.value);
      }
    }, {
      key: "_handleYearChange",
      value: function _handleYearChange(e) {
        this.gotoYear(e.target.value);
      }

      /**
       * change view to a specific month (zero-index, e.g. 0: January)
       */

    }, {
      key: "gotoMonth",
      value: function gotoMonth(month) {
        if (!isNaN(month)) {
          this.calendars[0].month = parseInt(month, 10);
          this.adjustCalendars();
        }
      }

      /**
       * change view to a specific full year (e.g. "2012")
       */

    }, {
      key: "gotoYear",
      value: function gotoYear(year) {
        if (!isNaN(year)) {
          this.calendars[0].year = parseInt(year, 10);
          this.adjustCalendars();
        }
      }
    }, {
      key: "_handleInputChange",
      value: function _handleInputChange(e) {
        var date = void 0;

        // Prevent change event from being fired when triggered by the plugin
        if (e.firedBy === this) {
          return;
        }
        if (this.options.parse) {
          date = this.options.parse(this.el.value, this.options.format);
        } else {
          date = new Date(Date.parse(this.el.value));
        }

        if (Datepicker._isDate(date)) {
          this.setDate(date);
        }
      }
    }, {
      key: "renderDayName",
      value: function renderDayName(opts, day, abbr) {
        day += opts.firstDay;
        while (day >= 7) {
          day -= 7;
        }
        return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
      }

      /**
       * Set input value to the selected date and close Datepicker
       */

    }, {
      key: "_finishSelection",
      value: function _finishSelection() {
        this.setInputValue();
        this.close();
      }

      /**
       * Open Datepicker
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this);
        }
        this.draw();
        this.modal.open();
        return this;
      }

      /**
       * Close Datepicker
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this);
        }
        this.modal.close();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_isDate",
      value: function _isDate(obj) {
        return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
        );
      }
    }, {
      key: "_isWeekend",
      value: function _isWeekend(date) {
        var day = date.getDay();
        return day === 0 || day === 6;
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }
    }, {
      key: "_getDaysInMonth",
      value: function _getDaysInMonth(year, month) {
        return [31, Datepicker._isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
      }
    }, {
      key: "_isLeapYear",
      value: function _isLeapYear(year) {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }
    }, {
      key: "_compareDates",
      value: function _compareDates(a, b) {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Datepicker;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Datepicker;
  }(Component);

  Datepicker._template = ['<div class= "modal datepicker-modal">', '<div class="modal-content datepicker-container">', '<div class="datepicker-date-display">', '<span class="year-text"></span>', '<span class="date-text"></span>', '</div>', '<div class="datepicker-calendar-container">', '<div class="datepicker-calendar"></div>', '<div class="datepicker-footer">', '<button class="btn-flat datepicker-clear waves-effect" style="visibility: hidden;" type="button"></button>', '<div class="confirmation-btns">', '<button class="btn-flat datepicker-cancel waves-effect" type="button"></button>', '<button class="btn-flat datepicker-done waves-effect" type="button"></button>', '</div>', '</div>', '</div>', '</div>', '</div>'].join('');

  M.Datepicker = Datepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Datepicker, 'datepicker', 'M_Datepicker');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    dialRadius: 135,
    outerRadius: 105,
    innerRadius: 70,
    tickRadius: 20,
    duration: 350,
    container: null,
    defaultTime: 'now', // default time, 'now' or '13:14' e.g.
    fromNow: 0, // Millisecond offset from the defaultTime
    showClearBtn: false,

    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok'
    },

    autoClose: false, // auto close when minute is selected
    twelveHour: true, // change to 12 hour AM/PM clock from 24 hour
    vibrate: true, // vibrate the device when dragging clock hand

    // Callbacks
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onSelect: null
  };

  /**
   * @class
   *
   */

  var Timepicker = function (_Component16) {
    _inherits(Timepicker, _Component16);

    function Timepicker(el, options) {
      _classCallCheck(this, Timepicker);

      var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));

      _this57.el.M_Timepicker = _this57;

      _this57.options = $.extend({}, Timepicker.defaults, options);

      _this57.id = M.guid();
      _this57._insertHTMLIntoDOM();
      _this57._setupModal();
      _this57._setupVariables();
      _this57._setupEventHandlers();

      _this57._clockSetup();
      _this57._pickerSetup();
      return _this57;
    }

    _createClass(Timepicker, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.modal.destroy();
        $(this.modalEl).remove();
        this.el.M_Timepicker = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
        this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
        this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);

        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.plate.addEventListener('mousedown', this._handleClockClickStartBound);
        this.plate.addEventListener('touchstart', this._handleClockClickStartBound);

        $(this.spanHours).on('click', this.showView.bind(this, 'hours'));
        $(this.spanMinutes).on('click', this.showView.bind(this, 'minutes'));
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleClockClickStart",
      value: function _handleClockClickStart(e) {
        e.preventDefault();
        var clockPlateBR = this.plate.getBoundingClientRect();
        var offset = { x: clockPlateBR.left, y: clockPlateBR.top };

        this.x0 = offset.x + this.options.dialRadius;
        this.y0 = offset.y + this.options.dialRadius;
        this.moved = false;
        var clickPos = Timepicker._Pos(e);
        this.dx = clickPos.x - this.x0;
        this.dy = clickPos.y - this.y0;

        // Set clock hands
        this.setHand(this.dx, this.dy, false);

        // Mousemove on document
        document.addEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.addEventListener('touchmove', this._handleDocumentClickMoveBound);

        // Mouseup on document
        document.addEventListener('mouseup', this._handleDocumentClickEndBound);
        document.addEventListener('touchend', this._handleDocumentClickEndBound);
      }
    }, {
      key: "_handleDocumentClickMove",
      value: function _handleDocumentClickMove(e) {
        e.preventDefault();
        var clickPos = Timepicker._Pos(e);
        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        this.moved = true;
        this.setHand(x, y, false, true);
      }
    }, {
      key: "_handleDocumentClickEnd",
      value: function _handleDocumentClickEnd(e) {
        var _this58 = this;

        e.preventDefault();
        document.removeEventListener('mouseup', this._handleDocumentClickEndBound);
        document.removeEventListener('touchend', this._handleDocumentClickEndBound);
        var clickPos = Timepicker._Pos(e);
        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        if (this.moved && x === this.dx && y === this.dy) {
          this.setHand(x, y);
        }

        if (this.currentView === 'hours') {
          this.showView('minutes', this.options.duration / 2);
        } else if (this.options.autoClose) {
          $(this.minutesView).addClass('timepicker-dial-out');
          setTimeout(function () {
            _this58.done();
          }, this.options.duration / 2);
        }

        if (typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.hours, this.minutes);
        }

        // Unbind mousemove event
        document.removeEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.removeEventListener('touchmove', this._handleDocumentClickMoveBound);
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        this.$modalEl = $(Timepicker._template);
        this.modalEl = this.$modalEl[0];
        this.modalEl.id = 'modal-' + this.id;

        // Append popover to input by default
        var containerEl = document.querySelector(this.options.container);
        if (this.options.container && !!containerEl) {
          this.$modalEl.appendTo(containerEl);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this59 = this;

        this.modal = M.Modal.init(this.modalEl, {
          onOpenStart: this.options.onOpenStart,
          onOpenEnd: this.options.onOpenEnd,
          onCloseStart: this.options.onCloseStart,
          onCloseEnd: function () {
            if (typeof _this59.options.onCloseEnd === 'function') {
              _this59.options.onCloseEnd.call(_this59);
            }
            _this59.isOpen = false;
          }
        });
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        this.currentView = 'hours';
        this.vibrate = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null;

        this._canvas = this.modalEl.querySelector('.timepicker-canvas');
        this.plate = this.modalEl.querySelector('.timepicker-plate');

        this.hoursView = this.modalEl.querySelector('.timepicker-hours');
        this.minutesView = this.modalEl.querySelector('.timepicker-minutes');
        this.spanHours = this.modalEl.querySelector('.timepicker-span-hours');
        this.spanMinutes = this.modalEl.querySelector('.timepicker-span-minutes');
        this.spanAmPm = this.modalEl.querySelector('.timepicker-span-am-pm');
        this.footer = this.modalEl.querySelector('.timepicker-footer');
        this.amOrPm = 'PM';
      }
    }, {
      key: "_pickerSetup",
      value: function _pickerSetup() {
        var $clearBtn = $("<button class=\"btn-flat timepicker-clear waves-effect\" style=\"visibility: hidden;\" type=\"button\" tabindex=\"" + (this.options.twelveHour ? '3' : '1') + "\">" + this.options.i18n.clear + "</button>").appendTo(this.footer).on('click', this.clear.bind(this));
        if (this.options.showClearBtn) {
          $clearBtn.css({ visibility: '' });
        }

        var confirmationBtnsContainer = $('<div class="confirmation-btns"></div>');
        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.cancel + '</button>').appendTo(confirmationBtnsContainer).on('click', this.close.bind(this));
        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.done + '</button>').appendTo(confirmationBtnsContainer).on('click', this.done.bind(this));
        confirmationBtnsContainer.appendTo(this.footer);
      }
    }, {
      key: "_clockSetup",
      value: function _clockSetup() {
        if (this.options.twelveHour) {
          this.$amBtn = $('<div class="am-btn">AM</div>');
          this.$pmBtn = $('<div class="pm-btn">PM</div>');
          this.$amBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
          this.$pmBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
        }

        this._buildHoursView();
        this._buildMinutesView();
        this._buildSVGClock();
      }
    }, {
      key: "_buildSVGClock",
      value: function _buildSVGClock() {
        // Draw clock hands and others
        var dialRadius = this.options.dialRadius;
        var tickRadius = this.options.tickRadius;
        var diameter = dialRadius * 2;

        var svg = Timepicker._createSVGEl('svg');
        svg.setAttribute('class', 'timepicker-svg');
        svg.setAttribute('width', diameter);
        svg.setAttribute('height', diameter);
        var g = Timepicker._createSVGEl('g');
        g.setAttribute('transform', 'translate(' + dialRadius + ',' + dialRadius + ')');
        var bearing = Timepicker._createSVGEl('circle');
        bearing.setAttribute('class', 'timepicker-canvas-bearing');
        bearing.setAttribute('cx', 0);
        bearing.setAttribute('cy', 0);
        bearing.setAttribute('r', 4);
        var hand = Timepicker._createSVGEl('line');
        hand.setAttribute('x1', 0);
        hand.setAttribute('y1', 0);
        var bg = Timepicker._createSVGEl('circle');
        bg.setAttribute('class', 'timepicker-canvas-bg');
        bg.setAttribute('r', tickRadius);
        g.appendChild(hand);
        g.appendChild(bg);
        g.appendChild(bearing);
        svg.appendChild(g);
        this._canvas.appendChild(svg);

        this.hand = hand;
        this.bg = bg;
        this.bearing = bearing;
        this.g = g;
      }
    }, {
      key: "_buildHoursView",
      value: function _buildHoursView() {
        var $tick = $('<div class="timepicker-tick"></div>');
        // Hours view
        if (this.options.twelveHour) {
          for (var i = 1; i < 13; i += 1) {
            var tick = $tick.clone();
            var radian = i / 6 * Math.PI;
            var radius = this.options.outerRadius;
            tick.css({
              left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + 'px'
            });
            tick.html(i === 0 ? '00' : i);
            this.hoursView.appendChild(tick[0]);
            // tick.on(mousedownEvent, mousedown);
          }
        } else {
          for (var _i2 = 0; _i2 < 24; _i2 += 1) {
            var _tick = $tick.clone();
            var _radian = _i2 / 6 * Math.PI;
            var inner = _i2 > 0 && _i2 < 13;
            var _radius = inner ? this.options.innerRadius : this.options.outerRadius;
            _tick.css({
              left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + 'px'
            });
            _tick.html(_i2 === 0 ? '00' : _i2);
            this.hoursView.appendChild(_tick[0]);
            // tick.on(mousedownEvent, mousedown);
          }
        }
      }
    }, {
      key: "_buildMinutesView",
      value: function _buildMinutesView() {
        var $tick = $('<div class="timepicker-tick"></div>');
        // Minutes view
        for (var i = 0; i < 60; i += 5) {
          var tick = $tick.clone();
          var radian = i / 30 * Math.PI;
          tick.css({
            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + 'px',
            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + 'px'
          });
          tick.html(Timepicker._addLeadingZero(i));
          this.minutesView.appendChild(tick[0]);
        }
      }
    }, {
      key: "_handleAmPmClick",
      value: function _handleAmPmClick(e) {
        var $btnClicked = $(e.target);
        this.amOrPm = $btnClicked.hasClass('am-btn') ? 'AM' : 'PM';
        this._updateAmPmView();
      }
    }, {
      key: "_updateAmPmView",
      value: function _updateAmPmView() {
        if (this.options.twelveHour) {
          this.$amBtn.toggleClass('text-primary', this.amOrPm === 'AM');
          this.$pmBtn.toggleClass('text-primary', this.amOrPm === 'PM');
        }
      }
    }, {
      key: "_updateTimeFromInput",
      value: function _updateTimeFromInput() {
        // Get the time
        var value = ((this.el.value || this.options.defaultTime || '') + '').split(':');
        if (this.options.twelveHour && !(typeof value[1] === 'undefined')) {
          if (value[1].toUpperCase().indexOf('AM') > 0) {
            this.amOrPm = 'AM';
          } else {
            this.amOrPm = 'PM';
          }
          value[1] = value[1].replace('AM', '').replace('PM', '');
        }
        if (value[0] === 'now') {
          var now = new Date(+new Date() + this.options.fromNow);
          value = [now.getHours(), now.getMinutes()];
          if (this.options.twelveHour) {
            this.amOrPm = value[0] >= 12 && value[0] < 24 ? 'PM' : 'AM';
          }
        }
        this.hours = +value[0] || 0;
        this.minutes = +value[1] || 0;
        this.spanHours.innerHTML = this.hours;
        this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);

        this._updateAmPmView();
      }
    }, {
      key: "showView",
      value: function showView(view, delay) {
        if (view === 'minutes' && $(this.hoursView).css('visibility') === 'visible') {
          // raiseCallback(this.options.beforeHourSelect);
        }
        var isHours = view === 'hours',
            nextView = isHours ? this.hoursView : this.minutesView,
            hideView = isHours ? this.minutesView : this.hoursView;
        this.currentView = view;

        $(this.spanHours).toggleClass('text-primary', isHours);
        $(this.spanMinutes).toggleClass('text-primary', !isHours);

        // Transition view
        hideView.classList.add('timepicker-dial-out');
        $(nextView).css('visibility', 'visible').removeClass('timepicker-dial-out');

        // Reset clock hand
        this.resetClock(delay);

        // After transitions ended
        clearTimeout(this.toggleViewTimer);
        this.toggleViewTimer = setTimeout(function () {
          $(hideView).css('visibility', 'hidden');
        }, this.options.duration);
      }
    }, {
      key: "resetClock",
      value: function resetClock(delay) {
        var view = this.currentView,
            value = this[view],
            isHours = view === 'hours',
            unit = Math.PI / (isHours ? 6 : 30),
            radian = value * unit,
            radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius,
            x = Math.sin(radian) * radius,
            y = -Math.cos(radian) * radius,
            self = this;

        if (delay) {
          $(this.canvas).addClass('timepicker-canvas-out');
          setTimeout(function () {
            $(self.canvas).removeClass('timepicker-canvas-out');
            self.setHand(x, y);
          }, delay);
        } else {
          this.setHand(x, y);
        }
      }
    }, {
      key: "setHand",
      value: function setHand(x, y, roundBy5) {
        var _this60 = this;

        var radian = Math.atan2(x, -y),
            isHours = this.currentView === 'hours',
            unit = Math.PI / (isHours || roundBy5 ? 6 : 30),
            z = Math.sqrt(x * x + y * y),
            inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2,
            radius = inner ? this.options.innerRadius : this.options.outerRadius;

        if (this.options.twelveHour) {
          radius = this.options.outerRadius;
        }

        // Radian should in range [0, 2PI]
        if (radian < 0) {
          radian = Math.PI * 2 + radian;
        }

        // Get the round value
        var value = Math.round(radian / unit);

        // Get the round radian
        radian = value * unit;

        // Correct the hours or minutes
        if (this.options.twelveHour) {
          if (isHours) {
            if (value === 0) value = 12;
          } else {
            if (roundBy5) value *= 5;
            if (value === 60) value = 0;
          }
        } else {
          if (isHours) {
            if (value === 12) {
              value = 0;
            }
            value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
          } else {
            if (roundBy5) {
              value *= 5;
            }
            if (value === 60) {
              value = 0;
            }
          }
        }

        // Once hours or minutes changed, vibrate the device
        if (this[this.currentView] !== value) {
          if (this.vibrate && this.options.vibrate) {
            // Do not vibrate too frequently
            if (!this.vibrateTimer) {
              navigator[this.vibrate](10);
              this.vibrateTimer = setTimeout(function () {
                _this60.vibrateTimer = null;
              }, 100);
            }
          }
        }

        this[this.currentView] = value;
        if (isHours) {
          this['spanHours'].innerHTML = value;
        } else {
          this['spanMinutes'].innerHTML = Timepicker._addLeadingZero(value);
        }

        // Set clock hand and others' position
        var cx1 = Math.sin(radian) * (radius - this.options.tickRadius),
            cy1 = -Math.cos(radian) * (radius - this.options.tickRadius),
            cx2 = Math.sin(radian) * radius,
            cy2 = -Math.cos(radian) * radius;
        this.hand.setAttribute('x2', cx1);
        this.hand.setAttribute('y2', cy1);
        this.bg.setAttribute('cx', cx2);
        this.bg.setAttribute('cy', cy2);
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        this._updateTimeFromInput();
        this.showView('hours');

        this.modal.open();
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        this.modal.close();
      }

      /**
       * Finish timepicker selection.
       */

    }, {
      key: "done",
      value: function done(e, clearValue) {
        // Set input value
        var last = this.el.value;
        var value = clearValue ? '' : Timepicker._addLeadingZero(this.hours) + ':' + Timepicker._addLeadingZero(this.minutes);
        this.time = value;
        if (!clearValue && this.options.twelveHour) {
          value = value + " " + this.amOrPm;
        }
        this.el.value = value;

        // Trigger change event
        if (value !== last) {
          this.$el.trigger('change');
        }

        this.close();
        this.el.focus();
      }
    }, {
      key: "clear",
      value: function clear() {
        this.done(null, true);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_addLeadingZero",
      value: function _addLeadingZero(num) {
        return (num < 10 ? '0' : '') + num;
      }
    }, {
      key: "_createSVGEl",
      value: function _createSVGEl(name) {
        var svgNS = 'http://www.w3.org/2000/svg';
        return document.createElementNS(svgNS, name);
      }

      /**
       * @typedef {Object} Point
       * @property {number} x The X Coordinate
       * @property {number} y The Y Coordinate
       */

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       * @return {Point} x and y location
       */

    }, {
      key: "_Pos",
      value: function _Pos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return { x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY };
        }
        // mouse event
        return { x: e.clientX, y: e.clientY };
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Timepicker;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Timepicker;
  }(Component);

  Timepicker._template = ['<div class= "modal timepicker-modal">', '<div class="modal-content timepicker-container">', '<div class="timepicker-digital-display">', '<div class="timepicker-text-container">', '<div class="timepicker-display-column">', '<span class="timepicker-span-hours text-primary"></span>', ':', '<span class="timepicker-span-minutes"></span>', '</div>', '<div class="timepicker-display-column timepicker-display-am-pm">', '<div class="timepicker-span-am-pm"></div>', '</div>', '</div>', '</div>', '<div class="timepicker-analog-display">', '<div class="timepicker-plate">', '<div class="timepicker-canvas"></div>', '<div class="timepicker-dial timepicker-hours"></div>', '<div class="timepicker-dial timepicker-minutes timepicker-dial-out"></div>', '</div>', '<div class="timepicker-footer"></div>', '</div>', '</div>', '</div>'].join('');

  M.Timepicker = Timepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Timepicker, 'timepicker', 'M_Timepicker');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {};

  /**
   * @class
   *
   */

  var CharacterCounter = function (_Component17) {
    _inherits(CharacterCounter, _Component17);

    /**
     * Construct CharacterCounter instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function CharacterCounter(el, options) {
      _classCallCheck(this, CharacterCounter);

      var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));

      _this61.el.M_CharacterCounter = _this61;

      /**
       * Options for the character counter
       */
      _this61.options = $.extend({}, CharacterCounter.defaults, options);

      _this61.isInvalid = false;
      _this61.isValidLength = false;
      _this61._setupCounter();
      _this61._setupEventHandlers();
      return _this61;
    }

    _createClass(CharacterCounter, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.CharacterCounter = undefined;
        this._removeCounter();
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleUpdateCounterBound = this.updateCounter.bind(this);

        this.el.addEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.addEventListener('input', this._handleUpdateCounterBound, true);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.removeEventListener('input', this._handleUpdateCounterBound, true);
      }

      /**
       * Setup counter element
       */

    }, {
      key: "_setupCounter",
      value: function _setupCounter() {
        this.counterEl = document.createElement('span');
        $(this.counterEl).addClass('character-counter').css({
          float: 'right',
          'font-size': '12px',
          height: 1
        });

        this.$el.parent().append(this.counterEl);
      }

      /**
       * Remove counter element
       */

    }, {
      key: "_removeCounter",
      value: function _removeCounter() {
        $(this.counterEl).remove();
      }

      /**
       * Update counter
       */

    }, {
      key: "updateCounter",
      value: function updateCounter() {
        var maxLength = +this.$el.attr('data-length'),
            actualLength = this.el.value.length;
        this.isValidLength = actualLength <= maxLength;
        var counterString = actualLength;

        if (maxLength) {
          counterString += '/' + maxLength;
          this._validateInput();
        }

        $(this.counterEl).html(counterString);
      }

      /**
       * Add validation classes
       */

    }, {
      key: "_validateInput",
      value: function _validateInput() {
        if (this.isValidLength && this.isInvalid) {
          this.isInvalid = false;
          this.$el.removeClass('invalid');
        } else if (!this.isValidLength && !this.isInvalid) {
          this.isInvalid = true;
          this.$el.removeClass('valid');
          this.$el.addClass('invalid');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_CharacterCounter;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return CharacterCounter;
  }(Component);

  M.CharacterCounter = CharacterCounter;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(CharacterCounter, 'characterCounter', 'M_CharacterCounter');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    duration: 200, // ms
    dist: -100, // zoom scale TODO: make this more intuitive as an option
    shift: 0, // spacing for center image
    padding: 0, // Padding between non center items
    numVisible: 5, // Number of visible items in carousel
    fullWidth: false, // Change to full width styles
    indicators: false, // Toggle indicators
    noWrap: false, // Don't wrap around and cycle through items.
    onCycleTo: null // Callback for when a new slide is cycled to.
  };

  /**
   * @class
   *
   */

  var Carousel = function (_Component18) {
    _inherits(Carousel, _Component18);

    /**
     * Construct Carousel instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Carousel(el, options) {
      _classCallCheck(this, Carousel);

      var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));

      _this62.el.M_Carousel = _this62;

      /**
       * Options for the carousel
       * @member Carousel#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {Number} shift
       * @prop {Number} padding
       * @prop {Number} numVisible
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */
      _this62.options = $.extend({}, Carousel.defaults, options);

      // Setup
      _this62.hasMultipleSlides = _this62.$el.find('.carousel-item').length > 1;
      _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
      _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
      _this62.pressed = false;
      _this62.dragged = false;
      _this62.offset = _this62.target = 0;
      _this62.images = [];
      _this62.itemWidth = _this62.$el.find('.carousel-item').first().innerWidth();
      _this62.itemHeight = _this62.$el.find('.carousel-item').first().innerHeight();
      _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.
      _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
      _this62._trackBound = _this62._track.bind(_this62);

      // Full Width carousel setup
      if (_this62.options.fullWidth) {
        _this62.options.dist = 0;
        _this62._setCarouselHeight();

        // Offset fixed items when indicators.
        if (_this62.showIndicators) {
          _this62.$el.find('.carousel-fixed-item').addClass('with-indicators');
        }
      }

      // Iterate through slides
      _this62.$indicators = $('<ul class="indicators"></ul>');
      _this62.$el.find('.carousel-item').each(function (el, i) {
        _this62.images.push(el);
        if (_this62.showIndicators) {
          var $indicator = $('<li class="indicator-item"></li>');

          // Add active to first by default.
          if (i === 0) {
            $indicator[0].classList.add('active');
          }

          _this62.$indicators.append($indicator);
        }
      });
      if (_this62.showIndicators) {
        _this62.$el.append(_this62.$indicators);
      }
      _this62.count = _this62.images.length;

      // Cap numVisible at count
      _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible);

      // Setup cross browser string
      _this62.xform = 'transform';
      ['webkit', 'Moz', 'O', 'ms'].every(function (prefix) {
        var e = prefix + 'Transform';
        if (typeof document.body.style[e] !== 'undefined') {
          _this62.xform = e;
          return false;
        }
        return true;
      });

      _this62._setupEventHandlers();
      _this62._scroll(_this62.offset);
      return _this62;
    }

    _createClass(Carousel, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Carousel = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this63 = this;

        this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
        this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
        this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
        this._handleCarouselClickBound = this._handleCarouselClick.bind(this);

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.addEventListener('touchstart', this._handleCarouselTapBound);
          this.el.addEventListener('touchmove', this._handleCarouselDragBound);
          this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
        }

        this.el.addEventListener('mousedown', this._handleCarouselTapBound);
        this.el.addEventListener('mousemove', this._handleCarouselDragBound);
        this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.addEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
          this.$indicators.find('.indicator-item').each(function (el, i) {
            el.addEventListener('click', _this63._handleIndicatorClickBound);
          });
        }

        // Resize
        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);

        window.addEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this64 = this;

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
          this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
          this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
        }
        this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
        this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
        this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.removeEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this.$indicators.find('.indicator-item').each(function (el, i) {
            el.removeEventListener('click', _this64._handleIndicatorClickBound);
          });
        }

        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Handle Carousel Tap
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselTap",
      value: function _handleCarouselTap(e) {
        // Fixes firefox draggable image bug
        if (e.type === 'mousedown' && $(e.target).is('img')) {
          e.preventDefault();
        }
        this.pressed = true;
        this.dragged = false;
        this.verticalDragged = false;
        this.reference = this._xpos(e);
        this.referenceY = this._ypos(e);

        this.velocity = this.amplitude = 0;
        this.frame = this.offset;
        this.timestamp = Date.now();
        clearInterval(this.ticker);
        this.ticker = setInterval(this._trackBound, 100);
      }

      /**
       * Handle Carousel Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselDrag",
      value: function _handleCarouselDrag(e) {
        var x = void 0,
            y = void 0,
            delta = void 0,
            deltaY = void 0;
        if (this.pressed) {
          x = this._xpos(e);
          y = this._ypos(e);
          delta = this.reference - x;
          deltaY = Math.abs(this.referenceY - y);
          if (deltaY < 30 && !this.verticalDragged) {
            // If vertical scrolling don't allow dragging.
            if (delta > 2 || delta < -2) {
              this.dragged = true;
              this.reference = x;
              this._scroll(this.offset + delta);
            }
          } else if (this.dragged) {
            // If dragging don't allow vertical scroll.
            e.preventDefault();
            e.stopPropagation();
            return false;
          } else {
            // Vertical scrolling.
            this.verticalDragged = true;
          }
        }

        if (this.dragged) {
          // If dragging don't allow vertical scroll.
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }

      /**
       * Handle Carousel Release
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselRelease",
      value: function _handleCarouselRelease(e) {
        if (this.pressed) {
          this.pressed = false;
        } else {
          return;
        }

        clearInterval(this.ticker);
        this.target = this.offset;
        if (this.velocity > 10 || this.velocity < -10) {
          this.amplitude = 0.9 * this.velocity;
          this.target = this.offset + this.amplitude;
        }
        this.target = Math.round(this.target / this.dim) * this.dim;

        // No wrap of items.
        if (this.noWrap) {
          if (this.target >= this.dim * (this.count - 1)) {
            this.target = this.dim * (this.count - 1);
          } else if (this.target < 0) {
            this.target = 0;
          }
        }
        this.amplitude = this.target - this.offset;
        this.timestamp = Date.now();
        requestAnimationFrame(this._autoScrollBound);

        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
        return false;
      }

      /**
       * Handle Carousel CLick
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselClick",
      value: function _handleCarouselClick(e) {
        // Disable clicks if carousel was dragged.
        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        } else if (!this.options.fullWidth) {
          var clickedIndex = $(e.target).closest('.carousel-item').index();
          var diff = this._wrap(this.center) - clickedIndex;

          // Disable clicks if carousel was shifted by click
          if (diff !== 0) {
            e.preventDefault();
            e.stopPropagation();
          }
          this._cycleTo(clickedIndex);
        }
      }

      /**
       * Handle Indicator CLick
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        e.stopPropagation();

        var indicator = $(e.target).closest('.indicator-item');
        if (indicator.length) {
          this._cycleTo(indicator.index());
        }
      }

      /**
       * Handle Throttle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        if (this.options.fullWidth) {
          this.itemWidth = this.$el.find('.carousel-item').first().innerWidth();
          this.imageHeight = this.$el.find('.carousel-item.active').height();
          this.dim = this.itemWidth * 2 + this.options.padding;
          this.offset = this.center * 2 * this.itemWidth;
          this.target = this.offset;
          this._setCarouselHeight(true);
        } else {
          this._scroll();
        }
      }

      /**
       * Set carousel height based on first slide
       * @param {Booleam} imageOnly - true for image slides
       */

    }, {
      key: "_setCarouselHeight",
      value: function _setCarouselHeight(imageOnly) {
        var _this65 = this;

        var firstSlide = this.$el.find('.carousel-item.active').length ? this.$el.find('.carousel-item.active').first() : this.$el.find('.carousel-item').first();
        var firstImage = firstSlide.find('img').first();
        if (firstImage.length) {
          if (firstImage[0].complete) {
            // If image won't trigger the load event
            var imageHeight = firstImage.height();
            if (imageHeight > 0) {
              this.$el.css('height', imageHeight + 'px');
            } else {
              // If image still has no height, use the natural dimensions to calculate
              var naturalWidth = firstImage[0].naturalWidth;
              var naturalHeight = firstImage[0].naturalHeight;
              var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
              this.$el.css('height', adjustedHeight + 'px');
            }
          } else {
            // Get height when image is loaded normally
            firstImage.one('load', function (el, i) {
              _this65.$el.css('height', el.offsetHeight + 'px');
            });
          }
        } else if (!imageOnly) {
          var slideHeight = firstSlide.height();
          this.$el.css('height', slideHeight + 'px');
        }
      }

      /**
       * Get x position from event
       * @param {Event} e
       */

    }, {
      key: "_xpos",
      value: function _xpos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        }

        // mouse event
        return e.clientX;
      }

      /**
       * Get y position from event
       * @param {Event} e
       */

    }, {
      key: "_ypos",
      value: function _ypos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientY;
        }

        // mouse event
        return e.clientY;
      }

      /**
       * Wrap index
       * @param {Number} x
       */

    }, {
      key: "_wrap",
      value: function _wrap(x) {
        return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
      }

      /**
       * Tracks scrolling information
       */

    }, {
      key: "_track",
      value: function _track() {
        var now = void 0,
            elapsed = void 0,
            delta = void 0,
            v = void 0;

        now = Date.now();
        elapsed = now - this.timestamp;
        this.timestamp = now;
        delta = this.offset - this.frame;
        this.frame = this.offset;

        v = 1000 * delta / (1 + elapsed);
        this.velocity = 0.8 * v + 0.2 * this.velocity;
      }

      /**
       * Auto scrolls to nearest carousel item.
       */

    }, {
      key: "_autoScroll",
      value: function _autoScroll() {
        var elapsed = void 0,
            delta = void 0;

        if (this.amplitude) {
          elapsed = Date.now() - this.timestamp;
          delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
          if (delta > 2 || delta < -2) {
            this._scroll(this.target - delta);
            requestAnimationFrame(this._autoScrollBound);
          } else {
            this._scroll(this.target);
          }
        }
      }

      /**
       * Scroll to target
       * @param {Number} x
       */

    }, {
      key: "_scroll",
      value: function _scroll(x) {
        var _this66 = this;

        // Track scrolling state
        if (!this.$el.hasClass('scrolling')) {
          this.el.classList.add('scrolling');
        }
        if (this.scrollingTimeout != null) {
          window.clearTimeout(this.scrollingTimeout);
        }
        this.scrollingTimeout = window.setTimeout(function () {
          _this66.$el.removeClass('scrolling');
        }, this.options.duration);

        // Start actual scroll
        var i = void 0,
            half = void 0,
            delta = void 0,
            dir = void 0,
            tween = void 0,
            el = void 0,
            alignment = void 0,
            zTranslation = void 0,
            tweenedOpacity = void 0,
            centerTweenedOpacity = void 0;
        var lastCenter = this.center;
        var numVisibleOffset = 1 / this.options.numVisible;

        this.offset = typeof x === 'number' ? x : this.offset;
        this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
        delta = this.offset - this.center * this.dim;
        dir = delta < 0 ? 1 : -1;
        tween = -dir * delta * 2 / this.dim;
        half = this.count >> 1;

        if (this.options.fullWidth) {
          alignment = 'translateX(0)';
          centerTweenedOpacity = 1;
        } else {
          alignment = 'translateX(' + (this.el.clientWidth - this.itemWidth) / 2 + 'px) ';
          alignment += 'translateY(' + (this.el.clientHeight - this.itemHeight) / 2 + 'px)';
          centerTweenedOpacity = 1 - numVisibleOffset * tween;
        }

        // Set indicator active
        if (this.showIndicators) {
          var diff = this.center % this.count;
          var activeIndicator = this.$indicators.find('.indicator-item.active');
          if (activeIndicator.index() !== diff) {
            activeIndicator.removeClass('active');
            this.$indicators.find('.indicator-item').eq(diff)[0].classList.add('active');
          }
        }

        // center
        // Don't show wrapped items.
        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];

          // Add active class to center item.
          if (!$(el).hasClass('active')) {
            this.$el.find('.carousel-item').removeClass('active');
            el.classList.add('active');
          }
          var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";
          this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
        }

        for (i = 1; i <= half; ++i) {
          // right side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 + tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
          }
          // Don't show wrapped items.
          if (!this.noWrap || this.center + i < this.count) {
            el = this.images[this._wrap(this.center + i)];
            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
          }

          // left side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 - tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
          }
          // Don't show wrapped items.
          if (!this.noWrap || this.center - i >= 0) {
            el = this.images[this._wrap(this.center - i)];
            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
          }
        }

        // center
        // Don't show wrapped items.
        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];
          var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";
          this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
        }

        // onCycleTo callback
        var $currItem = this.$el.find('.carousel-item').eq(this._wrap(this.center));
        if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function') {
          this.options.onCycleTo.call(this, $currItem[0], this.dragged);
        }

        // One time callback
        if (typeof this.oneTimeCallback === 'function') {
          this.oneTimeCallback.call(this, $currItem[0], this.dragged);
          this.oneTimeCallback = null;
        }
      }

      /**
       * Cycle to target
       * @param {Element} el
       * @param {Number} opacity
       * @param {Number} zIndex
       * @param {String} transform
       */

    }, {
      key: "_updateItemStyle",
      value: function _updateItemStyle(el, opacity, zIndex, transform) {
        el.style[this.xform] = transform;
        el.style.zIndex = zIndex;
        el.style.opacity = opacity;
        el.style.visibility = 'visible';
      }

      /**
       * Cycle to target
       * @param {Number} n
       * @param {Function} callback
       */

    }, {
      key: "_cycleTo",
      value: function _cycleTo(n, callback) {
        var diff = this.center % this.count - n;

        // Account for wraparound.
        if (!this.noWrap) {
          if (diff < 0) {
            if (Math.abs(diff + this.count) < Math.abs(diff)) {
              diff += this.count;
            }
          } else if (diff > 0) {
            if (Math.abs(diff - this.count) < diff) {
              diff -= this.count;
            }
          }
        }

        this.target = this.dim * Math.round(this.offset / this.dim);
        // Next
        if (diff < 0) {
          this.target += this.dim * Math.abs(diff);

          // Prev
        } else if (diff > 0) {
          this.target -= this.dim * diff;
        }

        // Set one time callback
        if (typeof callback === 'function') {
          this.oneTimeCallback = callback;
        }

        // Scroll
        if (this.offset !== this.target) {
          this.amplitude = this.target - this.offset;
          this.timestamp = Date.now();
          requestAnimationFrame(this._autoScrollBound);
        }
      }

      /**
       * Cycle to next item
       * @param {Number} [n]
       */

    }, {
      key: "next",
      value: function next(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center + n;
        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }
        this._cycleTo(index);
      }

      /**
       * Cycle to previous item
       * @param {Number} [n]
       */

    }, {
      key: "prev",
      value: function prev(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center - n;
        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }

        this._cycleTo(index);
      }

      /**
       * Cycle to nth item
       * @param {Number} [n]
       * @param {Function} callback
       */

    }, {
      key: "set",
      value: function set(n, callback) {
        if (n === undefined || isNaN(n)) {
          n = 0;
        }

        if (n > this.count || n < 0) {
          if (this.noWrap) {
            return;
          }

          n = this._wrap(n);
        }

        this._cycleTo(n, callback);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Carousel;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Carousel;
  }(Component);

  M.Carousel = Carousel;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Carousel, 'carousel', 'M_Carousel');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    onOpen: undefined,
    onClose: undefined
  };

  /**
   * @class
   *
   */

  var TapTarget = function (_Component19) {
    _inherits(TapTarget, _Component19);

    /**
     * Construct TapTarget instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function TapTarget(el, options) {
      _classCallCheck(this, TapTarget);

      var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));

      _this67.el.M_TapTarget = _this67;

      /**
       * Options for the select
       * @member TapTarget#options
       * @prop {Function} onOpen - Callback function called when feature discovery is opened
       * @prop {Function} onClose - Callback function called when feature discovery is closed
       */
      _this67.options = $.extend({}, TapTarget.defaults, options);

      _this67.isOpen = false;

      // setup
      _this67.$origin = $('#' + _this67.$el.attr('data-target'));
      _this67._setup();

      _this67._calculatePositioning();
      _this67._setupEventHandlers();
      return _this67;
    }

    _createClass(TapTarget, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.TapTarget = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
        this._handleTargetClickBound = this._handleTargetClick.bind(this);
        this._handleOriginClickBound = this._handleOriginClick.bind(this);

        this.el.addEventListener('click', this._handleTargetClickBound);
        this.originEl.addEventListener('click', this._handleOriginClickBound);

        // Resize
        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);

        window.addEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleTargetClickBound);
        this.originEl.removeEventListener('click', this._handleOriginClickBound);
        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Handle Target Click
       * @param {Event} e
       */

    }, {
      key: "_handleTargetClick",
      value: function _handleTargetClick(e) {
        this.open();
      }

      /**
       * Handle Origin Click
       * @param {Event} e
       */

    }, {
      key: "_handleOriginClick",
      value: function _handleOriginClick(e) {
        this.close();
      }

      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        this._calculatePositioning();
      }

      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest('.tap-target-wrapper').length) {
          this.close();
          e.preventDefault();
          e.stopPropagation();
        }
      }

      /**
       * Setup Tap Target
       */

    }, {
      key: "_setup",
      value: function _setup() {
        // Creating tap target
        this.wrapper = this.$el.parent()[0];
        this.waveEl = $(this.wrapper).find('.tap-target-wave')[0];
        this.originEl = $(this.wrapper).find('.tap-target-origin')[0];
        this.contentEl = this.$el.find('.tap-target-content')[0];

        // Creating wrapper
        if (!$(this.wrapper).hasClass('.tap-target-wrapper')) {
          this.wrapper = document.createElement('div');
          this.wrapper.classList.add('tap-target-wrapper');
          this.$el.before($(this.wrapper));
          this.wrapper.append(this.el);
        }

        // Creating content
        if (!this.contentEl) {
          this.contentEl = document.createElement('div');
          this.contentEl.classList.add('tap-target-content');
          this.$el.append(this.contentEl);
        }

        // Creating foreground wave
        if (!this.waveEl) {
          this.waveEl = document.createElement('div');
          this.waveEl.classList.add('tap-target-wave');

          // Creating origin
          if (!this.originEl) {
            this.originEl = this.$origin.clone(true, true);
            this.originEl.addClass('tap-target-origin');
            this.originEl.removeAttr('id');
            this.originEl.removeAttr('style');
            this.originEl = this.originEl[0];
            this.waveEl.append(this.originEl);
          }

          this.wrapper.append(this.waveEl);
        }
      }

      /**
       * Calculate positioning
       */

    }, {
      key: "_calculatePositioning",
      value: function _calculatePositioning() {
        // Element or parent is fixed position?
        var isFixed = this.$origin.css('position') === 'fixed';
        if (!isFixed) {
          var parents = this.$origin.parents();
          for (var i = 0; i < parents.length; i++) {
            isFixed = $(parents[i]).css('position') == 'fixed';
            if (isFixed) {
              break;
            }
          }
        }

        // Calculating origin
        var originWidth = this.$origin.outerWidth();
        var originHeight = this.$origin.outerHeight();
        var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
        var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left;

        // Calculating screen
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var centerX = windowWidth / 2;
        var centerY = windowHeight / 2;
        var isLeft = originLeft <= centerX;
        var isRight = originLeft > centerX;
        var isTop = originTop <= centerY;
        var isBottom = originTop > centerY;
        var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75;

        // Calculating tap target
        var tapTargetWidth = this.$el.outerWidth();
        var tapTargetHeight = this.$el.outerHeight();
        var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
        var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
        var tapTargetPosition = isFixed ? 'fixed' : 'absolute';

        // Calculating content
        var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
        var tapTargetTextHeight = tapTargetHeight / 2;
        var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
        var tapTargetTextBottom = 0;
        var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
        var tapTargetTextRight = 0;
        var tapTargetTextPadding = originWidth;
        var tapTargetTextAlign = isBottom ? 'bottom' : 'top';

        // Calculating wave
        var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
        var tapTargetWaveHeight = tapTargetWaveWidth;
        var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
        var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2;

        // Setting tap target
        var tapTargetWrapperCssObj = {};
        tapTargetWrapperCssObj.top = isTop ? tapTargetTop + 'px' : '';
        tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + 'px' : '';
        tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + 'px' : '';
        tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + 'px' : '';
        tapTargetWrapperCssObj.position = tapTargetPosition;
        $(this.wrapper).css(tapTargetWrapperCssObj);

        // Setting content
        $(this.contentEl).css({
          width: tapTargetTextWidth + 'px',
          height: tapTargetTextHeight + 'px',
          top: tapTargetTextTop + 'px',
          right: tapTargetTextRight + 'px',
          bottom: tapTargetTextBottom + 'px',
          left: tapTargetTextLeft + 'px',
          padding: tapTargetTextPadding + 'px',
          verticalAlign: tapTargetTextAlign
        });

        // Setting wave
        $(this.waveEl).css({
          top: tapTargetWaveTop + 'px',
          left: tapTargetWaveLeft + 'px',
          width: tapTargetWaveWidth + 'px',
          height: tapTargetWaveHeight + 'px'
        });
      }

      /**
       * Open TapTarget
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        // onOpen callback
        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this, this.$origin[0]);
        }

        this.isOpen = true;
        this.wrapper.classList.add('open');

        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
      }

      /**
       * Close Tap Target
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        // onClose callback
        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this, this.$origin[0]);
        }

        this.isOpen = false;
        this.wrapper.classList.remove('open');

        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_TapTarget;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return TapTarget;
  }(Component);

  M.TapTarget = TapTarget;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(TapTarget, 'tapTarget', 'M_TapTarget');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    classes: '',
    dropdownOptions: {}
  };

  /**
   * @class
   *
   */

  var FormSelect = function (_Component20) {
    _inherits(FormSelect, _Component20);

    /**
     * Construct FormSelect instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function FormSelect(el, options) {
      _classCallCheck(this, FormSelect);

      // Don't init if browser default version
      var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));

      if (_this68.$el.hasClass('browser-default')) {
        return _possibleConstructorReturn(_this68);
      }

      _this68.el.M_FormSelect = _this68;

      /**
       * Options for the select
       * @member FormSelect#options
       */
      _this68.options = $.extend({}, FormSelect.defaults, options);

      _this68.isMultiple = _this68.$el.prop('multiple');

      // Setup
      _this68.el.tabIndex = -1;
      _this68._keysSelected = {};
      _this68._valueDict = {}; // Maps key to original and generated option element.
      _this68._setupDropdown();

      _this68._setupEventHandlers();
      return _this68;
    }

    _createClass(FormSelect, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeDropdown();
        this.el.M_FormSelect = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this69 = this;

        this._handleSelectChangeBound = this._handleSelectChange.bind(this);
        this._handleOptionClickBound = this._handleOptionClick.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.addEventListener('click', _this69._handleOptionClickBound);
        });
        this.el.addEventListener('change', this._handleSelectChangeBound);
        this.input.addEventListener('click', this._handleInputClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this70 = this;

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.removeEventListener('click', _this70._handleOptionClickBound);
        });
        this.el.removeEventListener('change', this._handleSelectChangeBound);
        this.input.removeEventListener('click', this._handleInputClickBound);
      }

      /**
       * Handle Select Change
       * @param {Event} e
       */

    }, {
      key: "_handleSelectChange",
      value: function _handleSelectChange(e) {
        this._setValueToInput();
      }

      /**
       * Handle Option Click
       * @param {Event} e
       */

    }, {
      key: "_handleOptionClick",
      value: function _handleOptionClick(e) {
        e.preventDefault();
        var option = $(e.target).closest('li')[0];
        var key = option.id;
        if (!$(option).hasClass('disabled') && !$(option).hasClass('optgroup') && key.length) {
          var selected = true;

          if (this.isMultiple) {
            // Deselect placeholder option if still selected.
            var placeholderOption = $(this.dropdownOptions).find('li.disabled.selected');
            if (placeholderOption.length) {
              placeholderOption.removeClass('selected');
              placeholderOption.find('input[type="checkbox"]').prop('checked', false);
              this._toggleEntryFromArray(placeholderOption[0].id);
            }
            selected = this._toggleEntryFromArray(key);
          } else {
            $(this.dropdownOptions).find('li').removeClass('selected');
            $(option).toggleClass('selected', selected);
          }

          // Set selected on original select option
          // Only trigger if selected state changed
          var prevSelected = $(this._valueDict[key].el).prop('selected');
          if (prevSelected !== selected) {
            $(this._valueDict[key].el).prop('selected', selected);
            this.$el.trigger('change');
          }
        }

        e.stopPropagation();
      }

      /**
       * Handle Input Click
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        if (this.dropdown && this.dropdown.isOpen) {
          this._setValueToInput();
          this._setSelectedStates();
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this71 = this;

        this.wrapper = document.createElement('div');
        $(this.wrapper).addClass('select-wrapper ' + this.options.classes);
        this.$el.before($(this.wrapper));
        this.wrapper.appendChild(this.el);

        if (this.el.disabled) {
          this.wrapper.classList.add('disabled');
        }

        // Create dropdown
        this.$selectOptions = this.$el.children('option, optgroup');
        this.dropdownOptions = document.createElement('ul');
        this.dropdownOptions.id = "select-options-" + M.guid();
        $(this.dropdownOptions).addClass('dropdown-content select-dropdown ' + (this.isMultiple ? 'multiple-select-dropdown' : ''));

        // Create dropdown structure.
        if (this.$selectOptions.length) {
          this.$selectOptions.each(function (el) {
            if ($(el).is('option')) {
              // Direct descendant option.
              var optionEl = void 0;
              if (_this71.isMultiple) {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'multiple');
              } else {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
              }

              _this71._addOptionToValueDict(el, optionEl);
            } else if ($(el).is('optgroup')) {
              // Optgroup.
              var selectOptions = $(el).children('option');
              $(_this71.dropdownOptions).append($('<li class="optgroup"><span>' + el.getAttribute('label') + '</span></li>')[0]);

              selectOptions.each(function (el) {
                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'optgroup-option');
                _this71._addOptionToValueDict(el, optionEl);
              });
            }
          });
        }

        this.$el.after(this.dropdownOptions);

        // Add input dropdown
        this.input = document.createElement('input');
        $(this.input).addClass('select-dropdown dropdown-trigger');
        this.input.setAttribute('type', 'text');
        this.input.setAttribute('readonly', 'true');
        this.input.setAttribute('data-target', this.dropdownOptions.id);
        if (this.el.disabled) {
          $(this.input).prop('disabled', 'true');
        }

        this.$el.before(this.input);
        this._setValueToInput();

        // Add caret
        var dropdownIcon = $('<svg class="caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
        this.$el.before(dropdownIcon[0]);

        // Initialize dropdown
        if (!this.el.disabled) {
          var dropdownOptions = $.extend({}, this.options.dropdownOptions);

          // Add callback for centering selected option when dropdown content is scrollable
          dropdownOptions.onOpenEnd = function (el) {
            var selectedOption = $(_this71.dropdownOptions).find('.selected').first();

            if (selectedOption.length) {
              // Focus selected option in dropdown
              M.keyDown = true;
              _this71.dropdown.focusedIndex = selectedOption.index();
              _this71.dropdown._focusFocusedItem();
              M.keyDown = false;

              // Handle scrolling to selected option
              if (_this71.dropdown.isScrollable) {
                var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option
                scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown
                _this71.dropdownOptions.scrollTop = scrollOffset;
              }
            }
          };

          if (this.isMultiple) {
            dropdownOptions.closeOnClick = false;
          }
          this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
        }

        // Add initial selections
        this._setSelectedStates();
      }

      /**
       * Add option to value dict
       * @param {Element} el  original option element
       * @param {Element} optionEl  generated option element
       */

    }, {
      key: "_addOptionToValueDict",
      value: function _addOptionToValueDict(el, optionEl) {
        var index = Object.keys(this._valueDict).length;
        var key = this.dropdownOptions.id + index;
        var obj = {};
        optionEl.id = key;

        obj.el = el;
        obj.optionEl = optionEl;
        this._valueDict[key] = obj;
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        $(this.wrapper).find('.caret').remove();
        $(this.input).remove();
        $(this.dropdownOptions).remove();
        $(this.wrapper).before(this.$el);
        $(this.wrapper).remove();
      }

      /**
       * Setup dropdown
       * @param {Element} select  select element
       * @param {Element} option  option element from select
       * @param {String} type
       * @return {Element}  option element added
       */

    }, {
      key: "_appendOptionWithIcon",
      value: function _appendOptionWithIcon(select, option, type) {
        // Add disabled attr if disabled
        var disabledClass = option.disabled ? 'disabled ' : '';
        var optgroupClass = type === 'optgroup-option' ? 'optgroup-option ' : '';
        var multipleCheckbox = this.isMultiple ? "<label><input type=\"checkbox\"" + disabledClass + "\"/><span>" + option.innerHTML + "</span></label>" : option.innerHTML;
        var liEl = $('<li></li>');
        var spanEl = $('<span></span>');
        spanEl.html(multipleCheckbox);
        liEl.addClass(disabledClass + " " + optgroupClass);
        liEl.append(spanEl);

        // add icons
        var iconUrl = option.getAttribute('data-icon');
        if (!!iconUrl) {
          var imgEl = $("<img alt=\"\" src=\"" + iconUrl + "\">");
          liEl.prepend(imgEl);
        }

        // Check for multiple type.
        $(this.dropdownOptions).append(liEl[0]);
        return liEl[0];
      }

      /**
       * Toggle entry from option
       * @param {String} key  Option key
       * @return {Boolean}  if entry was added or removed
       */

    }, {
      key: "_toggleEntryFromArray",
      value: function _toggleEntryFromArray(key) {
        var notAdded = !this._keysSelected.hasOwnProperty(key);
        var $optionLi = $(this._valueDict[key].optionEl);

        if (notAdded) {
          this._keysSelected[key] = true;
        } else {
          delete this._keysSelected[key];
        }

        $optionLi.toggleClass('selected', notAdded);

        // Set checkbox checked value
        $optionLi.find('input[type="checkbox"]').prop('checked', notAdded);

        // use notAdded instead of true (to detect if the option is selected or not)
        $optionLi.prop('selected', notAdded);

        return notAdded;
      }

      /**
       * Set text value to input
       */

    }, {
      key: "_setValueToInput",
      value: function _setValueToInput() {
        var values = [];
        var options = this.$el.find('option');

        options.each(function (el) {
          if ($(el).prop('selected')) {
            var text = $(el).text();
            values.push(text);
          }
        });

        if (!values.length) {
          var firstDisabled = this.$el.find('option:disabled').eq(0);
          if (firstDisabled.length && firstDisabled[0].value === '') {
            values.push(firstDisabled.text());
          }
        }

        this.input.value = values.join(', ');
      }

      /**
       * Set selected state of dropdown to match actual select element
       */

    }, {
      key: "_setSelectedStates",
      value: function _setSelectedStates() {
        this._keysSelected = {};

        for (var key in this._valueDict) {
          var option = this._valueDict[key];
          var optionIsSelected = $(option.el).prop('selected');
          $(option.optionEl).find('input[type="checkbox"]').prop('checked', optionIsSelected);
          if (optionIsSelected) {
            this._activateOption($(this.dropdownOptions), $(option.optionEl));
            this._keysSelected[key] = true;
          } else {
            $(option.optionEl).removeClass('selected');
          }
        }
      }

      /**
       * Make option as selected and scroll to selected position
       * @param {jQuery} collection  Select options jQuery element
       * @param {Element} newOption  element of the new option
       */

    }, {
      key: "_activateOption",
      value: function _activateOption(collection, newOption) {
        if (newOption) {
          if (!this.isMultiple) {
            collection.find('li.selected').removeClass('selected');
          }
          var option = $(newOption);
          option.addClass('selected');
        }
      }

      /**
       * Get Selected Values
       * @return {Array}  Array of selected values
       */

    }, {
      key: "getSelectedValues",
      value: function getSelectedValues() {
        var selectedValues = [];
        for (var key in this._keysSelected) {
          selectedValues.push(this._valueDict[key].el.value);
        }
        return selectedValues;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FormSelect;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return FormSelect;
  }(Component);

  M.FormSelect = FormSelect;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FormSelect, 'formSelect', 'M_FormSelect');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {};

  /**
   * @class
   *
   */

  var Range = function (_Component21) {
    _inherits(Range, _Component21);

    /**
     * Construct Range instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Range(el, options) {
      _classCallCheck(this, Range);

      var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));

      _this72.el.M_Range = _this72;

      /**
       * Options for the range
       * @member Range#options
       */
      _this72.options = $.extend({}, Range.defaults, options);

      _this72._mousedown = false;

      // Setup
      _this72._setupThumb();

      _this72._setupEventHandlers();
      return _this72;
    }

    _createClass(Range, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeThumb();
        this.el.M_Range = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleRangeChangeBound = this._handleRangeChange.bind(this);
        this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
        this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
        this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
        this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);

        this.el.addEventListener('change', this._handleRangeChangeBound);

        this.el.addEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.addEventListener('touchstart', this._handleRangeMousedownTouchstartBound);

        this.el.addEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);

        this.el.addEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.addEventListener('touchend', this._handleRangeMouseupTouchendBound);

        this.el.addEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('change', this._handleRangeChangeBound);

        this.el.removeEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.removeEventListener('touchstart', this._handleRangeMousedownTouchstartBound);

        this.el.removeEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);

        this.el.removeEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.removeEventListener('touchend', this._handleRangeMouseupTouchendBound);

        this.el.removeEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }

      /**
       * Handle Range Change
       * @param {Event} e
       */

    }, {
      key: "_handleRangeChange",
      value: function _handleRangeChange() {
        $(this.value).html(this.$el.val());

        if (!$(this.thumb).hasClass('active')) {
          this._showRangeBubble();
        }

        var offsetLeft = this._calcRangeOffset();
        $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
      }

      /**
       * Handle Range Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleRangeMousedownTouchstart",
      value: function _handleRangeMousedownTouchstart(e) {
        // Set indicator value
        $(this.value).html(this.$el.val());

        this._mousedown = true;
        this.$el.addClass('active');

        if (!$(this.thumb).hasClass('active')) {
          this._showRangeBubble();
        }

        if (e.type !== 'input') {
          var offsetLeft = this._calcRangeOffset();
          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
        }
      }

      /**
       * Handle Range Input, Mousemove and Touchmove
       */

    }, {
      key: "_handleRangeInputMousemoveTouchmove",
      value: function _handleRangeInputMousemoveTouchmove() {
        if (this._mousedown) {
          if (!$(this.thumb).hasClass('active')) {
            this._showRangeBubble();
          }

          var offsetLeft = this._calcRangeOffset();
          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
          $(this.value).html(this.$el.val());
        }
      }

      /**
       * Handle Range Mouseup and Touchend
       */

    }, {
      key: "_handleRangeMouseupTouchend",
      value: function _handleRangeMouseupTouchend() {
        this._mousedown = false;
        this.$el.removeClass('active');
      }

      /**
       * Handle Range Blur, Mouseout and Touchleave
       */

    }, {
      key: "_handleRangeBlurMouseoutTouchleave",
      value: function _handleRangeBlurMouseoutTouchleave() {
        if (!this._mousedown) {
          var paddingLeft = parseInt(this.$el.css('padding-left'));
          var marginLeft = 7 + paddingLeft + 'px';

          if ($(this.thumb).hasClass('active')) {
            anim.remove(this.thumb);
            anim({
              targets: this.thumb,
              height: 0,
              width: 0,
              top: 10,
              easing: 'easeOutQuad',
              marginLeft: marginLeft,
              duration: 100
            });
          }
          $(this.thumb).removeClass('active');
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupThumb",
      value: function _setupThumb() {
        this.thumb = document.createElement('span');
        this.value = document.createElement('span');
        $(this.thumb).addClass('thumb');
        $(this.value).addClass('value');
        $(this.thumb).append(this.value);
        this.$el.after(this.thumb);
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeThumb",
      value: function _removeThumb() {
        $(this.thumb).remove();
      }

      /**
       * morph thumb into bubble
       */

    }, {
      key: "_showRangeBubble",
      value: function _showRangeBubble() {
        var paddingLeft = parseInt($(this.thumb).parent().css('padding-left'));
        var marginLeft = -7 + paddingLeft + 'px'; // TODO: fix magic number?
        anim.remove(this.thumb);
        anim({
          targets: this.thumb,
          height: 30,
          width: 30,
          top: -30,
          marginLeft: marginLeft,
          duration: 300,
          easing: 'easeOutQuint'
        });
      }

      /**
       * Calculate the offset of the thumb
       * @return {Number}  offset in pixels
       */

    }, {
      key: "_calcRangeOffset",
      value: function _calcRangeOffset() {
        var width = this.$el.width() - 15;
        var max = parseFloat(this.$el.attr('max')) || 100; // Range default max
        var min = parseFloat(this.$el.attr('min')) || 0; // Range default min
        var percent = (parseFloat(this.$el.val()) - min) / (max - min);
        return percent * width;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Range;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Range;
  }(Component);

  M.Range = Range;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Range, 'range', 'M_Range');
  }

  Range.init($('input[type=range]'));
})(cash, M.anime);

// Init PageContext & start react
new FxxlPageContext().react();
var FxxlAdditionalAttributes = function FxxlAdditionalAttributes() {
    function FxxlAdditionalAttributes(element) {
        this.element = element;
        this.contents = null;
        this.contentItems = null;
        this.contentClass = 'fxxl-element-artikel-additional-attributes__content';
        this.itemClass = 'fxxl-element-artikel-additional-attributes__item';
        this.itemTitleClass = 'fxxl-element-artikel-additional-attributes__item-title';
        this.titles = [];
        this.allTitleElements = [];
        this.init();
    }

    FxxlAdditionalAttributes.prototype.init = function init() {
        var __this = this;
        this.contents = this.element.getElementsByClassName(this.contentClass);
        requestAnimationFrame(function () {
            __this.setupEmptyFields();
        });
    };

    FxxlAdditionalAttributes.prototype.getItems = function getItems(content) {
        return content.getElementsByClassName(this.itemClass);
    };

    FxxlAdditionalAttributes.prototype.getTitleByIndex = function getTitleByIndex(index) {
        var result = false,
            titleIndex;
        Array.prototype.forEach.call(this.titles, function (title) {
            titleIndex = title.index;
            if (titleIndex === index) {
                result = title;
                return false;
            }
        });
        return result;
    };

    FxxlAdditionalAttributes.prototype.setupEmptyFields = function setupEmptyFields() {
        var __this = this,
            titleElement,
            title;
        Array.prototype.forEach.call(this.contents, function (content) {
            Array.prototype.forEach.call(__this.getItems(content), function (item, index) {
                titleElement = item.getElementsByClassName(__this.itemTitleClass);
                if (titleElement.length > 0) {
                    titleElement = titleElement[0];
                    titleElement.titleIndex = index;
                    title = titleElement.getAttribute('data-title');
                    if (title !== null) {
                        if (__this.getTitleByIndex(index) === false) {
                            __this.titles.push({'index': index, 'title': title});
                        }
                    }
                    __this.allTitleElements.push(titleElement);
                }
            });
        });

        Array.prototype.forEach.call(this.allTitleElements, function (element) {
            titleElement = __this.getTitleByIndex(element.titleIndex);
            if (titleElement !== false) {
                if (element.getAttribute('data-title') === null) {
                    element.innerText = titleElement.title;
                }
            } else {
                element.parentElement.remove();
            }
        });
    };
    return FxxlAdditionalAttributes;
}();
var fxxlActiveValidationTest = true,
    fxxlLastValidationResult = null;

var FxxlFormValidation = (function FxxlFormValidation() {

    function FxxlFormValidation(element, errorEffectClass) {
        this.element = element;
        this.type = null;
        this.typeSplitted = null;
        this.value = null;
        this.errorTargets = null;
        this.errorFields = null;
        this.form = null;
        this.validationDisabled = false;
        if (errorEffectClass === undefined) {
            this.errorEffectClass = 'fxxl-validation-error-effect';
        } else {
            this.errorEffectClass = errorEffectClass;
        }

        this.element[0].fxxl_form_validation_object = this;
        this.init();
    }

    FxxlFormValidation.prototype.init = function init() {
        this.type = this.element.attr('data-validation') || '';
        this.typeSplitted = this.type.split('|');
        this.errorTargets = fxxlGetFormValidationErrorTargets(this.element);
        this.errorFields = fxxlGetFormValidationErrorFields.apply(this, [this.element]);
        this.form = this.element.closest('form');
        this.form.attr('data-form_validation',true);
        this.setup();
    };

    FxxlFormValidation.prototype.setValue = function setValue() {
        var elementName;
        if (this.element.attr('type') === 'radio' || this.element.attr('type') === 'checkbox') {
            elementName = this.element.attr('name');
            this.value = $('input[name="' + elementName + '"]:checked').val() || '';
        } else {
            this.value = this.element.val() || '';
        }
    };

    FxxlFormValidation.prototype.setup = function setup() {
        var __this = this;
        this.form.on('submit', function () {
            return __this.test();
        });

        this.form[0]?.addEventListener(FxxlCore.getConfig()?.eventNames?.formValidation, () => {
            return __this.test();
        });

        this.element.on('change', function () {
            __this.test();
        });
    };

    FxxlFormValidation.prototype.test = function test() {
        var i, l;
        l = this.typeSplitted.length;

        if (this.validationDisabled === true) {
            return true;
        }

        if (this.errorTargets !== false) {
            $(this.errorTargets.join(',')).hide();
        }
        if (this.errorFields !== false) {
            $(this.errorFields.join(',')).removeClass(this.errorEffectClass);
        }
        this.setValue();

        for (i = 0; i < l; i += 1) {
            if (fxxlDoFormValidation(this.element, this.value, this.typeSplitted[i]) === false) {
                if (this.errorTargets !== false) {
                    $(this.errorTargets[i]).show();
                }
                if (this.errorFields !== false) {
                    $(this.errorFields.join(',')).addClass(this.errorEffectClass);
                }
                return false;
            }
        }
        return true;
    };

    return FxxlFormValidation;
})();

function fxxlGetFormValidationErrorTargets(element) {
    var errorTargets;
    errorTargets = element.attr('data-validation-error-targets');
    if (errorTargets !== undefined) {
        errorTargets = errorTargets.toString().split('|');
        $(errorTargets.join(',')).hide();
        return errorTargets;
    }
    return false;
}

function fxxlGetFormValidationErrorFields(element) {
    var errorFields;
    errorFields = element.attr('data-validation-error-effect-targets');
    if (errorFields !== undefined) {
        errorFields = errorFields.toString().split('|');
        $(errorFields.join(',')).removeClass(this.errorEffectClass);
        return errorFields;
    }
    return false;
}

function fxxlSetFormValidationFieldResult(element,res) {
    fxxlLastValidationResult = res;
    element.attr('data-form-validation-result', res);
}

function fxxlGetFormValidationFieldResult(element) {
    if (new FXXLIsElementVisible(element[0]).check()) {
        if (element.attr('data-validation') && element.attr('data-form-validation-result')) {
            return (element.attr('data-form-validation-result') === 'true');
        } else {
            return true; //nur attr die auch grprüft wurden
        }
    } else {
        return true;// unsichtbare werden nicht geprüft
    }
}

function fxxlDoFormValidation(element, value, type) {
    var tempObject,
        pattern = false,
        typeSplitted = type.split(':'),
        result,
        filePath,
        fileExtension,
        acceptedFileExtensions,
        fileSize,
        allowedFileSize,
        helpElement = element,
        validationType,
        form;

    if (element.prop("tagName") === 'SELECT') {
        helpElement = element.parent().parent();
    }

    if (fxxlActiveValidationTest === false || new FXXLIsElementVisible(helpElement[0]).check() === false) {
        fxxlLastValidationResult = true;
        fxxlSetFormValidationFieldResult(element,true);
        return true;
    }

    if(element[0].hasAttribute('data-required') && element.attr('data-required') === '0') {
        if (typeSplitted[0].substr(-1) !== '*') {
            return true;
        }
    }

    validationType = typeSplitted[0].replace('*', '');
    switch (validationType) {
        case 'email':
            if (value != "") {
                pattern = new RegExp("(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])");
            }
            break;
        case 'zip':
            pattern = /^\d{5}$/;
            break;
        case 'date_full':
            pattern = /(^(3[01]|[12][0-9]|0[1-9])\.(1[012]|0[1-9])\.\d{4}$|^$)/;
            break;
        case 'date_day':
        case 'date_month':
            pattern = /\d{2}/;
            break;
        case 'date_year':
            pattern = /\d{4}/;
            break;
        case 'date_exists':
            // Check for things like 31.02.2020

            if (value != '') {
                const { 0: day, 1: month, 2: year } = value.split('.');
                const date = new Date(year, month - 1, day);

                if (date.getFullYear() != year || date.getMonth() != (month - 1) || date.getDate() != day) {
                    result = false;
                }
            }
            break;
        case 'birthday_realistic':
            if (value != '') {
                const youngestAge   = 0;
                const oldestAge     = 110;
                const valueSplitted = value.split('.');
                const youngestDate  = new Date();
                const oldestDate    = new Date();
                const birthday      = new Date(valueSplitted[2], valueSplitted[1] - 1, valueSplitted[0]);

                youngestDate.setHours(0,0,0,0);
                oldestDate.setHours(0,0,0,0);
                youngestDate.setFullYear( youngestDate.getFullYear() - youngestAge );
                oldestDate.setFullYear( oldestDate.getFullYear() - oldestAge );

                result = (birthday < youngestDate && birthday > oldestDate) ? true : false;
            }
            break;
        case 'iban':
            pattern = new RegExp("DE[0-9]{2}\\s?[0-9]{4}\\s?[0-9]{4}\\s?[0-9]{4}\\s?[0-9]{4}\\s?[0-9]{2}");
            break;
        case 'ibanAll':
            pattern = new RegExp("[A-Z]{2}[0-9]{2}(\\s[A-Z0-9]{4}){2}((\\s[A-Z0-9]{4}){1,4})?(\\s[A-Z0-9]{1,4})$");
            break;
        case 'city':
        case 'firstname':
        case 'lastname':
            pattern = /.{2}/;
            break;
        case 'firmname':
        case 'street':
            pattern = /.{3}/;
            break;
        case 'phonenumber':
            if (value != "") {
                pattern = /^(\+|0)\d{7,}$/;
            }
            break;
        case 'number':
            value = value.trim();
            pattern = /^(\d+|)$/;
            break;
        case 'length':
            if (value != "") {
                pattern = new RegExp('^.{' + typeSplitted[1] + '}$', 's');
            }
            break;
        case 'length_min':
            if (value != "") {
                pattern = new RegExp('^.{' + typeSplitted[1] + ',}$', 's');
            }
            break;
        case 'length_max':
            if (value != "") {
                pattern = new RegExp('^.{0,' + typeSplitted[1] + '}$', 's');
            }
            break;
        case 'compare':
            if (typeSplitted[1] === 'name') {
                tempObject = $('[name="' + typeSplitted[2] + '"]').first();
            } else if (typeSplitted[1] === 'id') {
                tempObject = $('#' + typeSplitted[2]);
            }
            result = (value.trim() === tempObject[0].value.trim());
            pattern = false;
            break;
        case 'match':
            const regex = element[0].getAttribute('data-validation-pattern');
            if (regex != null) {
                pattern = new RegExp(regex, 's');
            } else {
                pattern = false;
            }
            break;
        case 'empty_php':
            pattern = /[^0\s]{1}/;
            break;
        case 'housenumber':
            value = value.trim();
            if (typeSplitted[1] === 'name') {
                tempObject = $('[name="' + typeSplitted[2] + '"]').first();
            } else if (typeSplitted[1] === 'id') {
                tempObject = $('#' + typeSplitted[2]);
            }

            var referenceFieldValue = tempObject.val().trim();
            let tempPattern;
            tempPattern = new RegExp('[a-uA-U]\\s[0-9]', 'gi');

            if (tempPattern.test(referenceFieldValue)) {
                pattern = new RegExp('^\\d{1,12}');
            } else {
                tempPattern = new RegExp(RegExp.escape(value), 'gi');
                if (tempPattern.test(referenceFieldValue)) {
                    result = false;
                } else {
                    result = true;
                }
            }

            break;
        case 'password':
                pattern = /.{8,}/;
            break;
        case 'filetype':
                if ($(element[0])[0].value !== '') {
                    filePath = $(element[0].files[0])[0].name;
                    fileExtension = filePath.split('.').pop().toLowerCase();

                    if (typeof element.attr('data-valid-type') === 'undefined') {
                        acceptedFileExtensions = ['pdf', 'jpg', 'png', 'gif', 'jpeg', 'webp'];
                    } else {
                        acceptedFileExtensions = element.attr('data-valid-type').split('|').map(function (elem) { return elem.trim().toLowerCase(); });
                    }

                    if ($.inArray(fileExtension, acceptedFileExtensions) > -1) {
                        result = true;
                    } else {
                        result = false;
                    }
                } else {
                    result = false;
                }
                pattern = false;
                break;
        case 'filesize':
                if (element[0].files[0] !== undefined) {
                    if (typeof element.attr('data-max-file-size') === 'undefined') {
                        allowedFileSize = 5;
                    } else {
                        allowedFileSize = parseInt(element.attr('data-max-file-size'));
                    }

                    fileSize = (element[0].files[0].size / 1024 / 1024).toFixed(2);

                    if (fileSize <= parseInt(allowedFileSize)) {
                        result = true;
                    } else {
                        result = false;
                    }
                } else {
                    result = false;
                }
                pattern = false;
                break;
        case 'empty':
        case 'voucher':
        default:
            pattern = /./;
    }

    if (pattern !== false) {
        result = pattern.test(value);
    } else if (result === undefined) {
        result = true;
    }

    form = element[0].closest('form');
    if (form !== null) {
        if (form?.fxxlValidation === undefined || form.fxxlValidation.expire < Date.now())  {
            form.fxxlValidation = {
                valid: true,
                expire: Date.now() + 500
            };
        }

        if (result === false) {
            form.fxxlValidation.valid = false;
        }
    }

    fxxlLastValidationResult = result;
    fxxlSetFormValidationFieldResult(element,result);
    return result;
}
/**
 * General
 *
 * Filename: 400_functions_and_variables.js
 *
 * @category  Applicas
 * @author    Oliver Schwanz <oliver.schwanz@etailer.de>
 *            Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 * @copyright 2019 onlinekauf Internet Service GmbH
 */

window.largViewportSize = 980;
window.headerSizeBreakpoint = 1536;
window.fxxlScrollTopStart = 100;
window.fxxlScrollTopActivate = true;
window.WindowIsLoaded = false;
window.documentIsReady = false;
window.fxxlLoadPersonalDataTimer = undefined;
window.FxxlRatenRechnerData = {};
window.FxxlPersonalData = {};
window.fxxlBrowserName = fxxlGetBrowser();
window.fxxlCurrentUrl = undefined;
window.fxxlOriginalViewport = $('meta[name="viewport"]');
window.fxxlOriginalViewportContent = fxxlOriginalViewport.attr('content');
window.fxxlTotopTimer = null;
window.fxxlViewportWidthCache = null;
window.fxxlBodyWidth = document.body.offsetWidth;
window.fxxlBodyHeight = document.body.offsetHeight;
window.fxxlVisualViewportScale = 1;
window.currentRunningFxxlGetAJAXContent = 0;
window.fxxlCompareToast = 0;

window.site_type = document.documentElement.dataset.vwtype || 'default';
window.site_name = document.documentElement.dataset.vwname || 'default';
window.site_vwid = document.documentElement.dataset.vwid || 'default';

/**
 * GTM Variables
 */
window.marketing = {"marketing": {}};
window.aff_cookie = '';
window.mediacode = undefined;
window.aktionsnr = undefined;

/**
 * Check if element exist
 */
function existElementById(id) {
    var element = document.getElementById(id);
    if (typeof (element) !== undefined && element !== null) {
        return true;
    }
    return false;
}

/**
 * Resized event
 */
var FxxlResizedEvent = (function FxxlResizedEvent() {
    function FxxlResizedEvent(callback) {
        this.resizeEventTimer = null;
        this.callback = callback;
        this.lastWidth = fxxlBodyWidth;
        this.lastHeight = fxxlBodyHeight;
        this.setup();
    }

    FxxlResizedEvent.prototype.setup = function setup() {
        var __this = this;
        window.addEventListener('resize', function () {
            if (__this.lastWidth !== document.body.offsetWidth || __this.lastHeight !== document.body.offsetHeight) {
                requestAnimationFrame(function () {
                    __this.call();
                });
            }
        });
    };

    FxxlResizedEvent.prototype.call = function call() {
        var __this = this;
        if (this.resizeEventTimer !== null) {
            clearTimeout(this.resizeEventTimer);
        }
        this.resizeEventTimer = setTimeout(function () {
            __this.callback();
        }, 500);
        this.lastWidth = document.body.offsetWidth;
        this.lastHeight = document.body.offsetHeight;
    };
    return FxxlResizedEvent;
}());

function fxxlGetViewportWidth() {
    if (fxxlViewportWidthCache === null) {
        fxxlViewportWidthCache = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return fxxlViewportWidthCache;
}

/**
 * Check if is large Device
 */
function isLargeViewport() {
    return largViewportSize <= fxxlGetViewportWidth();
}

function isOverHeaderSizeBreakpoint() {
    return headerSizeBreakpoint <= fxxlGetViewportWidth();
}

new FxxlResizedEvent(function () {
    fxxlViewportWidthCache = null;
});

function fxxlFixModalZindex(active) {
    if (isLargeViewport() === false) {
        let fixClass = 'fxxl-fix-modal-zindex';
        let mainContentSelector = '.fxxl-base-container';
        let elements = document.querySelectorAll(mainContentSelector);
        elements.forEach((element) => {
            if (active === true) {
                requestAnimationFrame(() => {
                    element.classList.add(fixClass);
                });
            } else {
                requestAnimationFrame(() => {
                    element.classList.remove(fixClass);
                });
            }
        });
    }
}


/**
 * decodeURI without Exception
 */
function fxxlDecodeURI(string) {
    let result;
    try {
        result = decodeURIComponent(string);
    } catch (e) {
        result = false;
    }
    return result;
}


/**
 * Setup Next-Prev for slider
 */
var FxxlSetupNextPrevButton = (function FxxlSetupNextPrevButton() {

    function FxxlSetupNextPrevButton(slider) {
        this.slider = slider;
        return this.get();
    }

    FxxlSetupNextPrevButton.prototype.get = function get() {
        var elementOffsets = this.slider.element.getBoundingClientRect(),
            firstElement,
            lastElement,
            firstItemOffsets,
            lastItemOffsets,
            nextBtn = [],
            prevBtn = [],
            output = [],
            tempLeft = 0,
            tempTop = 0;

        this.slider.checkPrevNextActive();

        if (this.slider.isPrevActive === true) {
            lastElement = this.slider.getLastItem();
            lastItemOffsets = lastElement.getBoundingClientRect();
            if (elementOffsets.right - lastItemOffsets.left < this.slider.itemGap * 2) {
                lastItemOffsets = lastElement.previousSibling.getBoundingClientRect();
            }
            tempLeft = (lastItemOffsets.left - elementOffsets.left - (this.slider.itemGap / 2.5));
            tempTop = (lastItemOffsets.top - elementOffsets.top) + (lastItemOffsets.height / 2);
            prevBtn.left = tempLeft;
            prevBtn.top = tempTop;
        }

        if (this.slider.isNextActive === true) {
            firstElement = this.slider.getFirstItem();
            firstItemOffsets = firstElement.getBoundingClientRect();
            if (firstItemOffsets.right - elementOffsets.left < this.slider.itemGap * 2) {
                firstItemOffsets = firstElement.nextSibling.getBoundingClientRect();
            }
            tempLeft = (firstItemOffsets.right - elementOffsets.left + (this.slider.itemGap / 2.5));
            tempTop = (firstItemOffsets.top - elementOffsets.top) + (firstItemOffsets.height / 2);
            nextBtn.left = tempLeft;
            nextBtn.top = tempTop;
        }

        output.next = nextBtn;
        output.prev = prevBtn;
        return output;
    };

    return FxxlSetupNextPrevButton;
}());

/**
 * Control Layout Version
 *
 * Usage note: FxxlElementVersionControl inserts a fresh CLONE of the nodes matched
 * by the selector. In the callback, you therefore have to make sure to retrieve the
 * copy that is currently attached to the DOM (i.e., assuming `element` is passed in
 * from the outside, write something like `doStuff(document.getELementById(element.id))`
 * rather than `doStuff(element)`.
 */
var FxxlElementVersionControl = (function FxxlElementVersionControl() {

    function FxxlElementVersionControl(selector, largViewportSize, callback, beforeClean, delay) {
        this.selector = selector;
        this.callback = callback;
        this.clones = null;
        this.largViewportSize = largViewportSize;
        this.lastVersion = null;
        this.callTimer = null;
        if (typeof beforeClean === 'undefined' || beforeClean === null) {
            this.beforeClean = function () {
            };
        } else {
            this.beforeClean = beforeClean;
        }
        if (typeof delay === 'undefined' || typeof delay === null) {
            this.delay = 0;
        } else {
            this.delay = delay;
        }
        this.init();
    }

    FxxlElementVersionControl.prototype.init = function init() {
        this.clones = this.makeClone(document.querySelectorAll(this.selector));
        this.lastVersion = document.documentElement.clientWidth < this.largViewportSize;
        this.callback(0);
        this.controlViewport();
    };

    FxxlElementVersionControl.prototype.controlViewport = function controlViewport() {
        var __this = this,
            version;

        new FxxlResizedEvent(function () {
            version = document.documentElement.clientWidth < __this.largViewportSize;
            if (version !== __this.lastVersion) {
                __this.lastVersion = version;
                __this.beforeClean();
                __this.clean();
                if (__this.delay === 0) {
                    __this.callback(1);
                } else {
                    if (__this.callTimer !== null) {
                        clearTimeout(__this.callTimer);
                    }
                    __this.callTimer = setTimeout(function () {
                        __this.callback(1);
                    }, __this.delay);
                }
            }
        });
    };

    FxxlElementVersionControl.prototype.clean = function clean() {
        var elements = document.querySelectorAll(this.selector),
            i,
            l = elements.length - 1,
            parentElm;

        for (i = 0; i <= l; i += 1) {
            parentElm = elements[i].parentElement;
            elements[i].parentElement.removeChild(elements[i]);
            parentElm.insertBefore(this.makeClone(this.clones[i]), parentElm.childNodes[0]);
        }
    };

    FxxlElementVersionControl.prototype.makeClone = function clone(elements) {
        var i,
            l = elements.length - 1,
            clones = [];

        if (NodeList.prototype.isPrototypeOf(elements) === true) {
            for (i = 0; i <= l; i += 1) {
                clones[i] = elements[i].cloneNode(true);
            }
            return clones;
        } else {
            return elements.cloneNode(true);
        }
    };

    return FxxlElementVersionControl;
}());

/**
 * Youtube Modal
 */
function openYoutubeModal(title, url) {
    var youtubeModalContainer,
        instance;

    if (url.indexOf('/embed/') < 0) {
        var regex = /\/([^\/]{5,})(\?|$)/g,
            match = regex.exec(url);

        if (match !== null) {
            url = 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1';
        }
    }

    if (existElementById('youtube-modal-container') === false) {
        youtubeModalContainer = $('<div id="youtube-modal-container" class="modal">' +
            '<div class="modal-content">' +
            '<div class="video-container">' +
            '<iframe width="853" height="480" src="" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"  allowfullscreen></iframe>' +
            '</div>' +
            '</div>' +
            '<div class="modal-footer"></div>' +
            '</div>');
        $('body').append(youtubeModalContainer);
    } else {
        youtubeModalContainer = $('#youtube-modal-container');
    }
    youtubeModalContainer.find('.modal-footer').text(title);
    youtubeModalContainer.find('.video-container > iframe').attr('src', url);
    instance = M.Modal.init(youtubeModalContainer[0], {
        'onCloseEnd': function () {
            youtubeModalContainer.find('.video-container > iframe').attr('src', '');
        }
    });
    instance.open();
}

/**
 * Check if Youtube-Image is valid
 */
var FxxlValidYoutubeImage = (function FxxlValidYoutubeImage() {
    function FxxlValidYoutubeImage(element, callBack) {
        this.element = element;
        this.callBack = callBack;
        this.img = new Image();
        this.setup();
    }

    FxxlValidYoutubeImage.prototype.setup = function setup() {
        var __this = this;
        this.img.onload = function () {
            if (this.width < 150 || this.height < 100) {
                __this.callBack(false);
            } else {
                __this.callBack(true);
            }
        };
        if (this.element.getAttribute('data-src') !== null) {
            this.img.src = this.element.getAttribute('data-src');
        } else {
            this.img.src = this.element.getAttribute('src');
        }
    };

    return FxxlValidYoutubeImage;
}());

var FXXLIsElementVisible = (function FXXLIsElementVisible() {

    function FXXLIsElementVisible(element) {
        this.element = element;
    }

    FXXLIsElementVisible.prototype.check = function check() {
        var parentElement,
            result = true;

        if (this.element.type !== 'checkbox' && this.element.type !== 'radio' && this.element.type !== 'file' && this.isVisible(this.element) === false) {
            return false;
        }
        parentElement = this.element.parentNode;
        while (typeof (parentElement) === 'object' && parentElement instanceof HTMLElement) {
            if (this.isVisible(parentElement) === false) {
                result = false;
                break;
            }
            parentElement = parentElement.parentNode;
        }
        return result;
    };

    FXXLIsElementVisible.prototype.isVisible = function isVisible(element) {
        var computedStyle = getComputedStyle(element);
        return !(parseInt(computedStyle['opacity']) === 0 || computedStyle['visibility'] === 'hidden' || computedStyle['display'] === 'none');
    };
    return FXXLIsElementVisible;
}());

/**
 * Change of element event
 */
var FxxlElementObserver = (function FxxlElementObserver() {

    function FxxlElementObserver(element, callback) {
        this.element = element;
        this.callback = callback;
        this.init();
    }

    FxxlElementObserver.prototype.init = function init() {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
            __this = this,
            observer = new MutationObserver(function (mutations, observer) {
                __this.callback(mutations);
            });

        observer.observe(this.element, {
            attributes: true, subtree: false
        });
    };

    return FxxlElementObserver;
}());

/**
 * Generate Random Id
 */
function generateRandomId() {
    return Math.random().toString(36).substr(2, 9);
}

/**
 * Auto scroll to selected tab
 */
var FxxlAutoScrollToSelectedTab = (function FxxlAutoScrollToSelectedTab() {

    function FxxlAutoScrollToSelectedTab(element) {
        this.element = element;
        this.selectedTab = null;
        this.scrollToSelectedTab();
    }

    FxxlAutoScrollToSelectedTab.prototype.scrollToSelectedTab = function scrollToSelectedTab() {
        let scrollLeft,
            ulWidth = this.element.width(),
            center = (ulWidth / 2),
            currentScrollLeft = this.element.scrollLeft(),
            lastChild = this.element.find('li:not(.indicator):last');

        this.setSelectedTab();
        if (this.selectedTab.length === 0) {
            return false;
        }

        let positionCenterElement = this.selectedTab.position().left + (this.selectedTab.width() / 2);

        if (positionCenterElement > center) {
            scrollLeft = positionCenterElement + currentScrollLeft - center;
        } else {
            scrollLeft = currentScrollLeft - (center - positionCenterElement);
        }

        this.element.animate({'scrollLeft': scrollLeft}, 250, 'easeOutCirc');

        return true;
    };

    FxxlAutoScrollToSelectedTab.prototype.setSelectedTab = function setSelectedTab() {
        this.selectedTab = this.element.find('li>a.active').parent('li');
    };

    return FxxlAutoScrollToSelectedTab;
}());

/**
 * Slider-Modal
 */
function fxxlSetupSliderModal(element) {
    var targetId = element.data('target'),
        modalClass = 'fxxl-base-card__inline-modal',
        activeModalClass = 'fxxl-base-card__inline-modal--active',
        moveInModalClass = 'fxxl-base-card__inline-modal--move-in',
        moveOutModalClass = 'fxxl-base-card__inline-modal--move-out',
        modals = $('.' + modalClass),
        closeButton = $('.fxxl-base-card__inline-modal-button'),

        fxxlMoveInSliderModal = function fxxlMoveInSliderModal() {
            modals.removeClass(moveOutModalClass).addClass(moveInModalClass);
            if (isLargeViewport() !== true) {
                modals.css({'height': window.innerHeight + 'px'});
            }
        },

        fxxlMoveOutSliderModal = function fxxlMoveOutSliderModal() {
            modals.addClass(moveOutModalClass);
            setTimeout(function () {
                modals.removeClass(activeModalClass);
            }, 230);

            modals.css({'max-height': ''});
        };

    element.on('click', function () {
        fxxlMoveInSliderModal();
        modals.removeClass(activeModalClass);
        $('#' + targetId).addClass(activeModalClass);
        return false;
    });

    closeButton.on('click', function () {
        fxxlMoveOutSliderModal();
    });

    $('.fxxl-base-card__inline-modal').each(function () {
        new FxxlTouchScroller(this);
    });
}

class FxxlSmoothScrollToElement {
    static scrollToElement(element, offset = 0, speed = 250) {
        var top = (element.getBoundingClientRect().top + window.scrollY) - offset;
        new FxxlSmoothGoToScrollPosition(top, speed);
    }
}

/**
 * Smooth Scroll
 * @type {FxxlSmoothScroll}
 */
var FxxlSmoothScroll = (function () {

    function FxxlSmoothScroll(element) {
        this.element = element;
        this.targetId = '';
        this.init();
    }

    FxxlSmoothScroll.prototype.init = function init() {
        var __this = this,
            href = this.element.attr('href');

        if (href === undefined) {
            return false;
        }

        this.targetId = href.replace(/#/g, '');

        this.element.on('click', function () {

            if (this.fxxlSmoothScrollActive === false) {
                return true;
            }

            var target = $('#' + __this.targetId),
                stickyTabs = $('.fxxl-tabs--sticky'),
                stickyHeader = $('.fxxl-base-header--sticky'),
                marketingSpot = $('.fxxl-marketingspot-popup'),
                stickyMobileHeight = 55,
                stickyDesktopHeight = 170,
                stickyHeight = 0,
                stickyTabsHeight = 0,
                baseHeaderHeight = 0,
                marketingSpotHeight = 0,
                minimumScroll = 50;

            if (stickyHeader.length > 0) {
                stickyHeight = stickyHeader[0].getBoundingClientRect().height;
            } else if (isLargeViewport() === true) {
                stickyHeight = stickyDesktopHeight;
            } else {
                stickyHeight = stickyMobileHeight;
            }

            if (marketingSpot.length > 0 && stickyHeader.length === 0) {
                marketingSpotHeight = marketingSpot[0].getBoundingClientRect().height;
            }

            if (stickyTabs.length > 0 && stickyTabs[0].clientHeight > 0) {
                stickyTabsHeight = stickyTabs[0].getBoundingClientRect().height;
            }

            if ((target.offset().top - document.documentElement.scrollTop) > minimumScroll || target.offset().top > minimumScroll) {
                baseHeaderHeight = stickyHeight + marketingSpotHeight + stickyTabsHeight;
            }

            if (target.length > 0) {
                new FxxlSmoothGoToScrollPosition((target.offset().top) - baseHeaderHeight);
                return __this.element.data('smooth-scroll-return') === true;
            } else {
                return true;
            }
        });
    };

    return FxxlSmoothScroll;
}());

/**
 * @type {FxxlSmoothGoToScrollPosition}
 */
var FxxlSmoothGoToScrollPosition = (function FxxlSmoothGoToScrollPosition() {
    function FxxlSmoothGoToScrollPosition(newPosition, speed, direction) {
        this.bodyElement = $('html, body');
        this.newPosition = parseInt(newPosition);
        this.speed = speed;
        this.direction = direction;
        this.script = {};
        this.init();
    }

    FxxlSmoothGoToScrollPosition.prototype.init = function init() {
        if (typeof this.speed === 'undefined') {
            this.speed = 250;
        } else {
            this.speed = parseInt(this.speed);
        }

        if (typeof this.direction === 'undefined') {
            this.direction = 'scrollTop';
        }

        if (this.direction === 'scrollTop') {
            this.script = {scrollTop: this.newPosition};
        } else if (this.direction === 'scrollLeft') {
            this.script = {scrollLeft: this.newPosition};
        }

        this.scroll();
    };

    FxxlSmoothGoToScrollPosition.prototype.scroll = function scroll() {
        this.bodyElement.animate(this.script, this.speed, 'easeOutCirc');
    };

    return FxxlSmoothGoToScrollPosition;
}());

/**
 * Touch Scroller
 */
var FxxlTouchScroller = (function FxxlTouchScroller() {

    function FxxlTouchScroller(element, scrollMode) {
        this.element = element;
        this.jQueryElement = $(element);
        this.args = [];
        this.direction = null;
        this.ease = 'easeOutCirc';
        if (scrollMode === undefined) {
            scrollMode = 'both';
        }
        this.scrollMode = scrollMode;
        this.onScrollBottom = function onScrollBottom() {
        };
        this.onScrollTop = function onScrollTop() {
        };
        this.onScrollLeft = function onScrollLeft() {
        };
        this.onScrollRight = function onScrollRight() {
        };
        this.onScrollFastTop = function onScrollFastTop() {
        };
        this.onScroll = function onScroll() {
        };
        this.onTouchStart = function onTouchStart() {
        };
        this.onTouchEnd = function onTouchEnd() {
        };

        if (this.isTouchDevice() === true) {
            this.events();
        }
    }

    FxxlTouchScroller.prototype.isTouchDevice = function isTouchDevice() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    };

    FxxlTouchScroller.prototype.events = function events() {
        var __this = this;

        this.element.addEventListener('touchstart', function (e) {
            __this.onTouchStart();
            __this.direction = null;
            __this.args.startX = e.touches[0].pageX;
            __this.args.startY = e.touches[0].pageY;
            __this.args.startScrollTop = __this.element.scrollTop;
            __this.args.startScrollLeft = __this.element.scrollLeft;
            __this.args.times = [];
            __this.args.moveIndex = 0;
            __this.jQueryElement.stop();
        }, true);

        this.element.addEventListener('touchend', function () {
            var timesLen = __this.args.times.length,
                tempValue,
                deltaMove,
                deltaTime,
                push = 150,
                pushSpeed = 500,
                speed,
                moveDiff = 2, // Last Move Positions
                maxScrollLeft,
                callBack = function () {
                };

            __this.onTouchEnd();

            if (timesLen > moveDiff) {
                deltaTime = __this.args.times[timesLen - 1].time - __this.args.times[timesLen - moveDiff].time;

                if (__this.direction === true) {
                    deltaMove = Math.abs(__this.args.times[timesLen - 1].x - __this.args.times[timesLen - moveDiff].x);
                } else {
                    deltaMove = Math.abs(__this.args.times[timesLen - 1].y - __this.args.times[timesLen - moveDiff].y);
                }

                speed = (deltaMove / deltaTime);

                if (speed > 0) {
                    if (__this.direction !== true && __this.args.times[timesLen - 1].y < __this.args.times[timesLen - moveDiff].y
                        && ((__this.scrollMode === 'both' || __this.scrollMode === 'top'))) {
                        tempValue = __this.element.scrollTop + (speed * push);
                        __this.onScrollBottom(tempValue, pushSpeed, __this.ease);
                        __this.jQueryElement.animate({'scrollTop': tempValue}, pushSpeed, __this.ease, callBack);
                    } else if (__this.direction !== true && __this.args.times[timesLen - 1].y > __this.args.times[timesLen - moveDiff].y
                        && (__this.scrollMode === 'both' || __this.scrollMode === 'top')) {
                        if (speed > 1.5) {
                            __this.onScrollFastTop();
                        }
                        tempValue = __this.element.scrollTop - (speed * push);
                        __this.onScrollTop(tempValue, pushSpeed, __this.ease);
                        __this.jQueryElement.animate({'scrollTop': tempValue}, pushSpeed, __this.ease, callBack);
                    } else if (__this.direction === true && __this.args.times[timesLen - 1].x < __this.args.times[timesLen - moveDiff].x
                        && (__this.scrollMode === 'both' || __this.scrollMode === 'left')) {
                        tempValue = __this.element.scrollLeft + (speed * push);
                        maxScrollLeft = __this.element.scrollWidth - __this.element.clientWidth
                        if (tempValue > maxScrollLeft) {
                            tempValue = maxScrollLeft;
                        }
                        __this.onScrollRight(tempValue, pushSpeed, __this.ease);
                        __this.jQueryElement.animate({'scrollLeft': tempValue}, pushSpeed, __this.ease, callBack);
                    } else if (__this.direction === true && __this.args.times[timesLen - 1].x > __this.args.times[timesLen - moveDiff].x
                        && (__this.scrollMode === 'both' || __this.scrollMode === 'left')) {
                        tempValue = __this.element.scrollLeft - (speed * push);
                        if (tempValue < 0) {
                            tempValue = 0;
                        }
                        __this.onScrollLeft(tempValue, pushSpeed, __this.ease);
                        __this.jQueryElement.animate({'scrollLeft': tempValue}, pushSpeed, __this.ease, callBack);
                    }
                }
            }

            __this.direction = null;
        }, true);

        this.element.addEventListener('touchmove', function (e) {
            var returnFalse = function (e) {
                if (e.cancelable === true) {
                    e.preventDefault();
                }
            };
            __this.args.moveIndex += 1;
            __this.args.newX = e.changedTouches[0].pageX;
            __this.args.newY = e.changedTouches[0].pageY;
            __this.args.times[__this.args.moveIndex] = {time: new Date(), x: __this.args.newX, y: __this.args.newY};

            if (__this.direction === null) {
                __this.direction = Math.abs(__this.args.startX - __this.args.newX) > Math.abs(__this.args.startY - __this.args.newY);
            }

            if (__this.direction !== true && (__this.scrollMode === 'both' || __this.scrollMode === 'top')) {
                __this.element.scrollTop = (__this.args.startScrollTop + (__this.args.startY - __this.args.newY));
            } else if (__this.scrollMode === 'both' || __this.scrollMode === 'left') {
                __this.element.scrollLeft = (__this.args.startScrollLeft + (__this.args.startX - __this.args.newX));
            }

            if (__this.scrollMode === 'both') {
                returnFalse(e);
            } else if (__this.scrollMode === 'top' && __this.direction === false) {
                returnFalse(e);
            } else if (__this.scrollMode === 'left' && __this.direction === true) {
                returnFalse(e);
            }
        }, true);

        this.element.addEventListener('scroll', function (e) {
            __this.onScroll(e, this);
        }, true);

    };

    return FxxlTouchScroller;
}());

function getURLParam(name, source) {
    return decodeURIComponent((new RegExp('[?|&|#]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(source) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

/**
 * fxxlLoadPersonalData
 */
function fxxlLoadPersonalData() {
    var data_content = {},
        affiliate_id,
        belboon_id;
    affiliate_id = getURLParam('aff', window.location.href);
    if (affiliate_id !== null) {
        data_content['aff'] = affiliate_id;
    }

    belboon_id = getURLParam('belboon', window.location.href);
    if (belboon_id !== null) {
        data_content['belboon'] = belboon_id;
    }

    $.ajax({
        url: '/personal.json?vw_type=' + site_type + '&vw_name=' + site_name + '&vw_id=' + site_vwid,
        type: 'GET',
        data: data_content,
        dataType: 'json',
        success: function (response) {
            FxxlPersonalData = response;
            if ($('.js_counter_cart').length !== 0) {
                fxxlShowPersonalData();
            }
            if (typeof gtmCustomerData === "function") {
                gtmCustomerData(FxxlPersonalData);
            }

            /**
             * Base
             */
            setFlyoutMenuLogout();

            /**
             * Set Vergleich-Checkboxs
             */
            fxxlSetCompareCheckbox();

            /**
             * Set Warengruppe-Branch-Filter
             */
            fxxlSetInitialWarengruppeBranchFilter();
            fxxlSetInitialMeineFilialeSettings();

            /**
             * Warengruppe-Branch-Availability-Info
             */
            fxxlGetArtikelStockFromBranchId();

            /**
             * Warengruppe-Banners
             */
            fxxlSetWarengruppeBanners();
            /**
             * fxxl Set Initial Compare Icon Counter
             */
            fxxlSetInitialComparisonWidgetCounter();
        }
    });
}

function fxxlShowPersonalData() {
    if (FxxlPersonalData.cart && FxxlPersonalData.cart.numItems) {
        setBadgeContent('cart', FxxlPersonalData.cart.numItems);
    }
    if (FxxlPersonalData.wishlist && FxxlPersonalData.wishlist.numItems) {
        setBadgeContent('wishlist', FxxlPersonalData.wishlist.numItems);
        FxxlWishlist.productsSetChecked();
    }
    if (FxxlPersonalData.notRatedProductCount) {
        setBadgeContent('bewertung', FxxlPersonalData.notRatedProductCount);
    }
    for (var prop in FxxlPersonalData.dom) {
        var o = $('#' + prop);
        if (o.length > 0) {
            var data = FxxlPersonalData.dom[prop];
            if (typeof data.html !== 'undefined') {
                $(o).html(data.html);
            }
            if (typeof data.attributes !== 'undefined') {
                for (var attrib in data.attributes) {
                    $(o).attr(attrib, data.attributes[attrib]);
                }
            }
        }
    }
}

function setFlyoutMenuLogout () {
    const isLoggedIn = FxxlPersonalData?.user?.loggedIn;
    const isNotOnSitetype = site_type !== 'warenkorb';

    if (!isLargeViewport() && isLoggedIn && isNotOnSitetype) {
        const logoutLink = document.getElementsByClassName('js-fxxl-logout')[0].href;
        const logoutHtml = `
            <div><hr class="fxxl-side-menu__separator fxxl-side-menu__separator--footer"></div>
            <a class="fxxl-side-menu__link fxxl-side-menu__link--icon" data-uid="-1" href="${logoutLink}" style="padding-top: 15px;">
                <svg class="fxxl-side-menu__icon" name="Abmelden" ><use xlink:href="#sprite_icon_logout" /></svg>
                Abmelden
            </a>
        `.trim();

        const menuFooterLinkElements = fxxlMobileMenuFooter.querySelectorAll('.fxxl-side-menu__link');
        const lastLinkElement = menuFooterLinkElements[menuFooterLinkElements.length - 1];
        const logoutElement = document.createElement('div');
        logoutElement.innerHTML = logoutHtml;
        lastLinkElement.parentNode.insertBefore(logoutElement, lastLinkElement.nextSibling);
    }
}


function setBadgeContent(counter, response) {
    var $counter = $('.js_counter_' + counter),
        count = 0;

    if ($counter.length) {
        if (typeof response === 'object') {
            count = Number(response.count) || 0;
        } else {
            count = Number(response) || 0;
        }

        $counter.attr('data-counter', count === 0 ? '' : count);
    }
}

/**
 * Rot47 PRG
 */
function rotN(text, map) {
    var result = new String(),
        i, j, c,
        len = map.length;

    for (i = 0; i < text.length; i++) {
        c = text.charAt(i);
        j = map.indexOf(c);
        if (j >= 0) {
            c = map.charAt((j + len / 2) % len);
        }
        result = result + c;
    }
    return result;
}

function rot47(text) {
    return rotN(text,
        '!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~'
    );
}

/**
 * Set Compare-Checkboxs
 */
function fxxlSetCompareCheckbox() {
    if (FxxlPersonalData !== undefined) {
        $('.js-fxxl-compare-checkbox').each(function () {
            var element = $(this),
                productId = element.data('product-id'),
                value;
            element.prop('checked', false);
            if (FxxlPersonalData.productcomparelist !== undefined && FxxlPersonalData.productcomparelist.items !== undefined) {
                Object.keys(FxxlPersonalData.productcomparelist.items).forEach(function (key) {
                    value = FxxlPersonalData.productcomparelist.items[key];
                    if (productId === value) {
                        element.prop('checked', true);
                        return true;
                    }
                });
            }
        });
    }
    return false;
}

/**
 * Close Header Notification
 */
function fxxlHeaderNotificationClose(element) {
    element.parentNode.parentNode.style.display = 'none';
}

/**
 * Set Invert Color
 * @param element
 * @param property
 */
function fxxlSetInvertColor(element, getProperty, property) {
    var color, invertedColor, r, g, b;
    if (element instanceof jQuery !== true) {
        element = $(element);
    }
    color = element.css(getProperty).match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    r = color[1];
    g = color[2];
    b = color[3];

    if ((r * 0.299 + g * 0.587 + b * 0.114) > 140) {
        invertedColor = '#000000';
    } else {
        invertedColor = '#ffffff';
    }

    element.css(property, invertedColor);
    return true;
}

/**
 * Go Back Button
 */
function fxxlGoBack() {
    var regex = /(fahrrad-xxl|fahrradxxl)/g;
    if (regex.test(document.referrer) === true) {
        window.history.back();
    } else {
        window.location.href = '/';
    }
}

/**
 * Get Browser Name
 * @returns {string}
 */
function fxxlGetBrowser() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) !== -1) {
        return 'Opera';
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
        return 'Chrome';
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
        return 'Safari';
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        return 'Firefox';
    } else if ((navigator.userAgent.indexOf("MSIE") !== -1) || (!!document.documentMode === true)) {
        return 'IE';
    } else {
        return 'unknown';
    }
}

/**
 * set Browser Fixes
 */
function setBrowserFixes(element) {
    // data-browser-fix="Safari[[transform: translate(0, -100%)]]"
    var data = element.data('browser-fix'),
        re = /(?:^|\]\])(.+?)\[\[(.+?)(?=\]\])/g,
        match = re.exec(data),
        browser,
        style;

    while (match != null) {
        browser = match[1];
        style = match[2];
        if (browser === fxxlBrowserName) {
            if (element.attr('style') !== undefined) {
                style += element.attr('style');
            }
            element.attr('style', style);
        }
        match = re.exec(data);
    }
}

function etJS_getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        var c = $.trim(ca[i]);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }

    return "";
}

function etJS_setCookie(cname, cvalue, exdays) {
    var s = cname + "=" + cvalue;

    if (exdays > 0) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        s = s + '; ' + "expires=" + d.toGMTString();
    }

    s = s + '; path=/';

    document.cookie = s;
}

function etJS_deleteCookie(cname, cvalue) {
    var s = cname + '=' + cvalue;
    var d = new Date();
    d.setTime(d.getTime() - 100);
    s = s + '; ' + 'expires=' + d.toUTCString();
    s = s + '; path=/';
    document.cookie = s;
}

function etJS_empty(data) {
    if (typeof (data) == 'number' || typeof (data) == 'boolean') {
        return false;
    }
    if (typeof (data) == 'undefined' || data === null) {
        return true;
    }
    if (typeof (data.length) != 'undefined') {
        return data.length == 0;
    }
    var count = 0;
    for (var i in data) {
        if (data.hasOwnProperty(i)) {
            count++;
        }
    }
    return count == 0;
}

var $resultHtmlGlobal;

/**
 * setup json handler
 */
function setupJsonHandler(element) {
    if (typeof element === 'undefined') {
        element = document.body;
    }

    $(element).find('.ajax[data-template],.json[data-template]').each(function () {
        if ('disabled' in this) {
            this.disabled = false;
        }

        if (!this.dataset.jsonHandler) {
            if (!('jsonHandlerCallNo' in et.data)) {
                et.data.jsonHandlerCallNo = 0;
            }
            this.dataset.jsonHandler = ++et.data.jsonHandlerCallNo;

            var eventType = 'click';
            if (this.tagName === 'FORM') {
                eventType = 'submit';
            }

            this.addEventListener(eventType, fxxlJsonHandler);
        }
    });
}

function setupJsonActionHandler() {
    $('.ajax-action[data-ac_type],.json-action[data-ac_type]').each(function () {
        if ('disabled' in this) {
            this.disabled = false;
        }
        if (!this.dataset.jsonHandler) {
            if (!('jsonHandlerCallNo' in et.data)) {
                et.data.jsonHandlerCallNo = 0;
            }
            this.dataset.jsonHandler = ++et.data.jsonHandlerCallNo;

            var eventType = 'click';
            if (this.tagName === 'FORM') {
                eventType = 'submit';
            }

            this.addEventListener(eventType, fxxlCallActionJsonHandler);
        }
    });
}

function fxxlJsonHandler(event) {
    if (arguments[1] !== undefined) {
        var clickedElement = arguments[1];
        var $clickedElement = $(arguments[1]);
    } else {
        event.preventDefault();
        var clickedElement = this;
        var $clickedElement = $(this);
    }

    var wait = $clickedElement.attr('data-wait');
    wait = (wait === '1' || wait === 'true');

    var beforeJsonResult = true;
    if ('before_json' in clickedElement.dataset) {
        beforeJsonResult = window[clickedElement.dataset.before_json](this);
    }

    if (clickedElement.dataset.lockedByAjaxHandler !== 'true' && beforeJsonResult) {
        clickedElement.dataset.lockedByAjaxHandler = 'true';
        var url = '';
        var template = clickedElement.dataset.template || '';
        var formData = null;
        var formMethod = null;
        const scrollTarget = clickedElement.dataset.scrollTarget;

        if (clickedElement.tagName === 'FORM') {
            url = clickedElement.action || clickedElement.dataset.action || clickedElement.dataset.url || '';
            formData = $clickedElement.serialize();
            formMethod = clickedElement.method;
            // TODO payload
            // TODO method GET/POST
        } else if (clickedElement.tagName === 'BUTTON') {
            url = clickedElement.dataset.url || '';
            if (url === '' && clickedElement.form) {
                url = clickedElement.form.action || clickedElement.form.dataset.action || clickedElement.form.dataset.url || '';
                formData = $(clickedElement.form).serialize();
                formMethod = clickedElement.method;
            }
        } else if (clickedElement.tagName === 'A') {
            url = clickedElement.href || clickedElement.dataset.href || clickedElement.dataset.url || '';
        } else {
            url = clickedElement.dataset.url || '';
        }

        if (typeof url === 'string'
            && typeof template === 'string'
            && url.length
            && template.length
        ) {
            var counter = clickedElement.dataset.counter;
            var requestUrl = '/json.php?service=getViewContent'
                + '&praesenz=' + _presence_id
                + '&templateset=' + encodeURIComponent(_templateset || 'fxxl3')
                + '&template=' + encodeURIComponent(template)
                + '&url=' + encodeURIComponent(url);

            if (wait) {
                showSpinner();
                clickedElement.classList.add('waiting');
                if ('disabled' in clickedElement) {
                    clickedElement.disabled = true;
                }
            }

            formMethod = String(formMethod).toUpperCase();
            if (formData !== null && formData.length) {
                formMethod = 'POST';
            }
            if (formMethod !== 'POST') {
                formMethod = 'GET';
            }

            $.ajax({
                dataType: "json",
                url: requestUrl,
                data: formData,
                method: formMethod,
                success: function (response) {
                    // hideSpinner();
                    if (response.data) {
                        if (counter) {
                            setBadgeContent(counter, response);
                        }
                        const previousModal = clickedElement.closest('.fxxl-modal');
                        const modals = document.querySelectorAll('.fxxl-modal');
                        const modalCookieMain = Array.from(modals).find(modal => modal?.classList?.contains('fxxl-cookie-mainmodal'));
                        const modalCookieSettings = Array.from(modals).find(modal => modal?.classList?.contains('fxxl-cookie-modal'));

                        /*
                            Ist da um vorherige Modals zu schließen damit sie nicht hintereinanderstehen

                            Eine Exception wird bei der Kombination aus zwei vorher aufgerufenen Modale gemacht:
                                1. Cookie Main Modal
                                2. Cookie Settings Modal
                         */

                        try {
                            const isConstellationCookieBannerThenCookieSettings = (
                                modals.length === 3
                                && modalCookieMain !== undefined
                                && modalCookieSettings !== undefined
                                && M?.Modal?.getInstance(modalCookieMain)?._nthModalOpened === 1
                                && M?.Modal?.getInstance(modalCookieSettings)?._nthModalOpened === 2
                                && previousModal === modalCookieSettings
                            );

                            const isConstellationCookieAndCookieModals = (
                                etJS_getCookie('fxxl_erforderliche_cookies') === ''
                                && ( previousModal === modalCookieMain || previousModal === modalCookieSettings )
                            );

                            if (
                                !isConstellationCookieAndCookieModals
                                && !isConstellationCookieBannerThenCookieSettings
                            ) {
                                // Only Close every Popup if the constellations above aren't meet
                                modals.forEach((modal) => { modal?.M_Modal?.close(); });
                            }
                        } catch (e) {}

                        var targetId = 'json-result-target' + clickedElement.dataset.jsonHandler;
                        var targetObj = document.getElementById(targetId);
                        if (targetObj) {
                            targetObj.remove();
                        }
                        targetObj = document.createElement('div');
                        var $targetObj = $(targetObj).attr('id', targetId);

                        var $resultHtml = $($.parseHTML(String(response.data || '').trim(), null, true));
                        var $modalElement = $resultHtml.filter('.modal:first');

                        if (!$modalElement.length) {
                            $modalElement = $resultHtml.find('.modal:first');
                        }

                        if ($modalElement.length) {
                            $targetObj.append($resultHtml);
                        } else {
                            var $modalHeaderText = $(document.createElement('div')).addClass('fxxl-modal__header-text').append($clickedElement.attr('title'));
                            var $modalContent = $(document.createElement('div')).addClass('modal-content').addClass('fxxl-modal__content').append($resultHtml);
                            var $modalClose = $(document.createElement('a')).addClass('fxxl-modal__header-close').addClass(' modal-close').append('<svg width="24" height="24"><use href="#sprite_icon_close" xlink:href="#sprite_icon_close"></use></svg>');
                            var $modalHeader = $(document.createElement('div')).addClass('fxxl-modal__header').addClass('modal-header').append($modalHeaderText).append($modalClose);
                            $modalElement = $(document.createElement('div')).addClass('modal').addClass('fxxl-modal').append($modalHeader).append($modalContent);

                            $targetObj.append($modalElement);
                        }

                        $modalElement.addClass('fxxl-modal--mobile-fullscreen');

                        $modalElement.find('.fxxl-modal__header-text').text($clickedElement.data('title'));

                        $(document.body).append($targetObj);
                        if ($modalElement.length) {
                            /**
                             *  rewriteReportPropertyErrorFormular
                             */
                            var $reportPropertyErrorForm = $modalElement.find('.form-pds_report_properties_error_formular_id');
                            if ($reportPropertyErrorForm.length > 0) {
                                rewriteReportPropertyErrorFormular($reportPropertyErrorForm);
                            }
                            /**
                             *  rewriteFxxlWunschArtikelFormular
                             */
                            var $fxxlWunschArtikelFormular = $modalElement.find('.fxxl-wunschartikel-formular-js');
                            if ($fxxlWunschArtikelFormular.length > 0) {
                                /**
                                 * fxxl-wunschartikel-formular-js
                                 */
                                new FxxlWunschArtikelFormular($fxxlWunschArtikelFormular[0]);
                            }

                            $modalElement.each(function () {
                                var modalApi = M.Modal.init(this, {
                                    onOpenStart: function () {
                                        if ($('#fxxl-product-cards-wk-slider-1').length) {
                                            new FxxlSetupSlider2('fxxl-product-cards-wk-slider-1', largViewportSize);
                                            gtmVisibleTzb('#fxxl-product-cards-wk-slider-1');
                                        }
                                        var $productCardsSlider = $modalElement.find('.fxxl-product-cards-slider');
                                        if ($productCardsSlider.length > 0) {
                                            $productCardsSlider.each(function () {
                                                if (isLargeViewport() === true) {
                                                    this.setAttribute("data-remove-margin", "true");
                                                    this.style.paddingTop = '10px';
                                                    this.style.paddingLeft = '10px';
                                                }
                                                var sliderId = this.getAttribute('id');
                                                new FxxlSetupSlider2(sliderId, largViewportSize);
                                            });
                                            $('.fxxl-slider-loader').addClass('fxxl-slider-loader--loaded');
                                        }
                                    },
                                    onCloseEnd: function () {
                                        // Remove element to stop videos on close
                                        if (typeof (this.el) !== undefined && this.el !== null) {
                                            this.el.remove();
                                        }
                                        if ($('#fxxl-product-cards-wk-slider-1').length) {
                                            $('#fxxl-product-cards-wk-slider-1').remove();
                                        }
                                    }
                                });

                                /**
                                 * reCaptcha
                                 */
                                if (typeof (reCaptchaPublicKey) !== 'undefined' && typeof (grecaptcha) !== 'undefined') {
                                    grecaptcha.ready(function () {
                                        $modalElement.find('.js-fxxl-recaptcha-token').each(function () {
                                            new FxxlReCaptchaGetToken(this);
                                        });
                                    });
                                }

                                /**
                                 * Fxxl Captcha
                                 */
                                if (typeof window.fxxlCaptcha !== 'undefined') {
                                    const fxxlCaptchaInputs = document.getElementsByClassName('js-fxxl-captcha-solution');
                                    if (fxxlCaptchaInputs.length > 0) {
                                        Array.prototype.forEach.call(fxxlCaptchaInputs, (element) => {
                                            new FxxlSetupCaptcha(element);
                                        })
                                    }
                                }

                                modalApi.open();
                                this.modalApi = modalApi;
                                $('.fxxl-modal--mobile-fullscreen.fxxl-json-add-to-cart').each(function () {
                                    new FxxlTouchScroller(this, 'top');
                                });

                                var votingElement = $modalElement.find('.fxxl-voting');
                                votingElement.each(function () {
                                    //Second parameter to know that it's in a popup
                                    new FxxlVotingBox($(this), true);
                                });

                                var fxxlAccordion = $modalElement.find('.fxxl-accordion');
                                fxxlAccordion.each(function () {
                                    new FxxlAccordion(this);
                                });
                                /**
                                 * Nur für RMA (Retoure)
                                 */
                                var $contentElement = $modalElement.find('.fxxl-person-rma-address');
                                if ($contentElement.length > 0) {
                                    $contentElement.css('height', (window.innerHeight - $modalHeader.height()) + 'px');
                                    new FxxlTouchScroller($contentElement[0]);
                                }

                                /* ScrollTo */
                                if (scrollTarget) {
                                    const scrollTargetElement = this.querySelector(`#${scrollTarget}`);

                                    function scrollToView() {
                                        scrollTargetElement.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start',
                                            inline: 'start'
                                        });
                                    }

                                    if (scrollTargetElement) {
                                        if (scrollTargetElement?.fxxlAccordion) {
                                            const targetAccordion = scrollTargetElement.fxxlAccordion;
                                            targetAccordion.onOpenedAfterTransitionCallback = scrollToView;
                                            targetAccordion.toggleExtend(true);
                                        } else {
                                            scrollToView();
                                        }
                                    }
                                }

                            });
                        }
                        /* Reinit */
                        setupJsonHandler();
                        setupJsonActionHandler();
                        /**
                         * Text input & TextArea
                         */
                        $modalElement.find('.fxxl-text-input__text, .fxxl-textarea__text').not('[type="radio"],select').each(function () {
                            new FxxlTextInputs($(this));
                        });
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.statusText != '' && parseInt(jqXHR.status) > 400 && parseInt(jqXHR.status) < 500) {
                        M.toast({
                            html: jqXHR.statusText,
                            classes: 'fxxl-toast',
                            displayLength: 2500
                        });
                    } else {
                        console.warn('fxxlJsonHandler', {
                            textStatus: textStatus,
                            jqXHR: jqXHR
                        })
                    }
                },
                complete: function () {
                    if (wait && 'disabled' in clickedElement) {
                        clickedElement.disabled = false;
                    }
                    clickedElement.dataset.lockedByAjaxHandler = 'false';
                    clickedElement.classList.remove('waiting');
                    hideSpinner();
                }
            });
        } else {
            console.error('url or template empty', clickedElement);
            clickedElement.dataset.lockedByAjaxHandler = 'false';
        }
    }
}

function fxxlCallActionJsonHandler(event) {
    event.preventDefault();
    var clickedElement = this;
    var $clickedElement = $(this);
    var wait = $clickedElement.attr('data-wait');
    wait = (wait === '1' || wait === 'true');

    if (clickedElement.dataset.ac_type !== '' && clickedElement.dataset.ac_name !== '') {
        var formResult = true;
        if (clickedElement.tagName == 'FORM'
            && (('form_validation' in clickedElement.dataset) && clickedElement.dataset.form_validation == 'true')
        ) {
            $(this).find(':input').each(function () {
                const elResult = fxxlGetFormValidationFieldResult($(this));
                if (!elResult) {
                    formResult = elResult;
                }
            });
        }
        var beforeJsonResult = true;
        if ('before_json' in clickedElement.dataset) {
            beforeJsonResult = window[clickedElement.dataset.before_json](this);
        }

        if (clickedElement.dataset.lockedByAjaxHandler !== 'true' && beforeJsonResult && formResult) {
            clickedElement.dataset.lockedByAjaxHandler = 'true';
            var formData = null;
            var formMethod = clickedElement.method;

            if (clickedElement.tagName === 'FORM') {
                formData = $clickedElement.serialize();
            } else if (clickedElement.tagName === 'BUTTON') {
                if (clickedElement.form) {
                    formData = $(clickedElement.form).serialize();
                }
            }

            var requestUrl = '/json.php?service=callAction'
                + '&ac_type=' + this.dataset.ac_type
                + '&ac_name=' + this.dataset.ac_name
                + '&praesenz=' + _presence_id;

            if (wait) {
                showSpinner();
                clickedElement.classList.add('waiting');
                if ('disabled' in clickedElement) {
                    clickedElement.disabled = true;
                }
            }

            formMethod = String(formMethod).toUpperCase();
            if (formData !== null && formData.length) {
                formMethod = 'POST';
            }
            if (formMethod !== 'POST') {
                formMethod = 'GET';
            }

            $.ajax({
                dataType: "json",
                url: requestUrl,
                data: formData,
                method: formMethod,
                success: function (result) {
                    if (result.hasOwnProperty('data') && result.data) {
                        var data = result.data;
                        if (data.hasOwnProperty('error_messages') && Object.entries(data.error_messages).length) {
                            Object.values(data.error_messages).forEach(function (errorMessage) {
                                if (data.error_messages.hasOwnProperty('error_301')) {
                                    if (clickedElement.action) {
                                        clickedElement.action = errorMessage;
                                    } else if (clickedElement.dataset.action) {
                                        clickedElement.dataset.action = errorMessage;
                                    } else if (clickedElement.dataset.url) {
                                        clickedElement.dataset.url = errorMessage;
                                    }
                                    if (clickedElement.dataset.template) {
                                        clickedElement.dataset.template = errorMessage;
                                    }
                                    resetJsonHandler(event, clickedElement, wait);
                                } else {
                                    M.toast({
                                        html: errorMessage,
                                        classes: 'fxxl-toast',
                                        displayLength: 2500
                                    });
                                }
                            });
                        } else {
                            resetJsonHandler(event, clickedElement, wait);
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error('fxxlCallJsonActionHandler', {
                        textStatus: textStatus,
                        errorThrown: errorThrown,
                        jqXHR: jqXHR,
                    });
                    location.reload();
                },
                complete: function () {
                    if (wait && 'disabled' in clickedElement) {
                        clickedElement.disabled = false;
                    }
                    clickedElement.dataset.lockedByAjaxHandler = 'false';
                    clickedElement.classList.remove('waiting');
                    hideSpinner();
                }
            });
        }
    } else {
        console.error('action type or action name empty', clickedElement);
        clickedElement.dataset.lockedByAjaxHandler = 'false';
    }
}

function resetJsonHandler(event, clickedElement, wait) {
    if (wait && 'disabled' in clickedElement) {
        clickedElement.disabled = false;
    }
    clickedElement.dataset.lockedByAjaxHandler = 'false';
    clickedElement.classList.remove('waiting');
    hideSpinner();

    if (clickedElement.dataset.template) {
        fxxlJsonHandler(event, clickedElement);
    }
}

function showTrustBadgeSentence() {
    var trusted_badge_obj = $('#fxxl_ts_customEl');

    if (trusted_badge_obj) {
        if (trusted_badge_sentence != '') {
            trusted_badge_obj.append(trusted_badge_sentence);
        }
    }
}

function showTrustBadge(showit) {
    var element = document.querySelector('div[id^="tsbadge"]');
    if (element) {
        if (showit) {
            element.style.display = 'none !important';
        } else {
            element.style.display = null;
        }
    }
}

/**
 * legt den Startpunkt fest ab wann der Scroll To Top Button erscheint
 */
function fxxlInitScrollTopStart() {
    fxxlScrollTopStart = $(window).height() / 3;
    if (!isLargeViewport()) {
        $('#fxxl-scroll_to_top__button').addClass('fxxl-button--textless');
    } else {
        $('#fxxl-scroll_to_top__button').removeClass('fxxl-button--textless');
    }
}

/**
 * hiermit blendet man den Scroll To Top aus falls er sonst über Elementen liegen würde wie dem Menü
 */
function fxxlHideScrollToTop() {
    fxxlScrollTopActivate = false;
    $('#fxxl-scroll_to_top').addClass("fxxl-hidden");
}

/**
 * Hiermit aktiviert man den Scroll To Top Button wieder falls man ihn deaktiviert hat
 */
function fxxlShowScrollToTop() {
    fxxlScrollTopActivate = true;
    $('#js-fxxl-scroll_to_top').removeClass("fxxl-hidden");
}

/**
 * initalisiert die Scroll To Top Funktion
 */
function fxxlScrollToTop() {

    if (site_type == "seite" ||
        site_type == "warengruppe" ||
        (site_type == "artikel" && isLargeViewport()) ||
        (site_type == "person" && isLargeViewport()) ||
        (site_type == "branch" && isLargeViewport())
    ) {

        fxxlInitScrollTopStart();

        new FxxlResizedEvent(fxxlInitScrollTopStart);

        $(window).scroll(function () {
            if ($(this).scrollTop() >= fxxlScrollTopStart && fxxlScrollTopActivate) {
                $('#js-fxxl-scroll_to_top').fadeIn(200);

                if (fxxlTotopTimer !== null) {
                    clearTimeout(fxxlTotopTimer);
                }
                fxxlTotopTimer = setTimeout(function () {
                    $('#js-fxxl-scroll_to_top').fadeOut(300);
                }, 1000);
            } else {
                $('#js-fxxl-scroll_to_top').fadeOut(200);
            }
        });
        $('#fxxl-scroll_to_top__button').click(function () {
            $(document.scrollingElement || document.documentElement).animate({
                scrollTop: 0
            }, 500);
        });
    }
}

/**
 * Zeigt den globalen "Spinner" an
 */
function showSpinner() {
    $('#fxxl-wait').addClass('fxxl-wait--active');
}

/**
 * Versteckt den globalen "Spinner"
 */
function hideSpinner() {
    $('#fxxl-wait').removeClass('fxxl-wait--active').removeClass('fxxl-wait--locked');
}

/**
 * Initialisiert das Element-Rating-Form
 */
function initElementRatingForm() {
    $('.fxxl-element-rating-form').each(function () {
        if (this.dataset.initElementRatingForm !== 'true') {
            this.dataset.initElementRatingForm = 'true';

            var $element = $(this);

            $element.find('button:disabled').prop('disabled', false);
            $element.find('.fxxl-text-input__text, .fxxl-textarea__text').each(function () {
                if (typeof this.fxxlTextInput !== 'object') {
                    new FxxlTextInputs($(this));
                }
            });
            $element.find('textarea').on('keyup change', function () {
                $(this).closest('.fxxl-element-formelement').removeClass('fxxl-element-formelement--has-error');
            });
            $element.find('input[name^="privacyrule_"]').on('change', function () {
                $(this).parent().removeClass('fxxl-element-rating-form__error');
            });

            $element.find('form').on('submit', function (event) {
                var $container = $(this);

                $container.find('.fxxl-element-rating-form__feedback-stars').addClass('fxxl-hidden');
                $container.find('.fxxl-element-rating-form__feedback-fields').addClass('fxxl-hidden');
                $container.find('.fxxl-element-rating-form__feedback-ajax').addClass('fxxl-hidden');
                $container.find('.fxxl-element-rating-form__error').removeClass('fxxl-element-rating-form__error');

                var nErrors = 0;
                var nStars = 0;
                var isValid = true;

                // get checked star value from 'main_stars' and set this value to corresponding hidden input fields
                $('input[name="main_stars"]').each(function () {
                    var selectedStars;
                    if (this.checked) {
                        selectedStars = this.value;
                        $container.find('input[name^="stars_"]').each(function (index) {
                            if ($(this)[0].value === selectedStars) {
                                $(this).prop('checked', true);
                            }
                        });
                    }
                });

                // any stars checked?
                $container.find('input[name^="stars_"]').each(function () {
                    if (this.checked) {
                        nStars += 1;
                    }
                });

                // all fields filled?
                $container.find('input[name="first_name"], input[name="email"], input[name="title"]').each(function () {
                    if ($(this).attr('data-form-validation-result') === 'false') {
                        nErrors += 1;
                    }
                });

                // Comment filled?
                $container.find('textarea[name^="comment["]').each(function () {
                    if ($(this).attr('data-form-validation-result') === 'false') {
                        nErrors += 1;
                    }
                });

                // privacyrules checked?
                $container.find('input[name^="privacyrule_"]').each(function () {
                    if (!this.checked) {
                        nErrors += 1;
                        $(this).parent().addClass('fxxl-element-rating-form__error');
                    }
                });

                if (nStars < 3) {
                    $container.find('.fxxl-element-rating-form__feedback--stars').removeClass('fxxl-hidden');
                    $container.find('.fxxl-element-rating-form__title').addClass('fxxl-element-rating-form__error');
                    isValid = false;
                }

                if (nErrors > 0) {
                    $container.find('.fxxl-element-rating-form__feedback--fields').removeClass('fxxl-hidden');
                    isValid = false;
                }

                // Is important
                $element.find('form')[0].fxxlValidation.valid = isValid;

                if (!isValid) {
                    fxxlSetFormValidationFieldResult($container.find('.fxxl-element-set-rating-stars').first(), false);
                    event.preventDefault();
                    /**
                     * Scroll To Error-Message
                     */
                    if (isLargeViewport() === false) {
                        let ratingFormStarErrorMsg = document.getElementById('fxxl-rating-star-error-msg');
                        let ratingFormFeedbackErrorMsg = document.getElementById('fxxl-rating-form-feedback');

                        if(ratingFormStarErrorMsg.classList.contains('fxxl-element-rating-form__error') === true) {
                            ratingFormStarErrorMsg.scrollIntoView({
                                block: "center",
                                behavior: "smooth"
                            });
                        } else if (ratingFormFeedbackErrorMsg.classList.contains('fxxl-hidden') === false) {
                            ratingFormFeedbackErrorMsg.scrollIntoView({
                                block: "center",
                                behavior: "smooth"
                            });
                        }
                    }

                    gtm.pushOnClick({},'reviewSentError');
                } else {
                    fxxlSetFormValidationFieldResult($container.find('.fxxl-element-set-rating-stars').first(), true);
                    // function in 510_save_and_load_form.js
                    deleteFormFromLocalStorage($container.attr('name'));
                    showSpinner();

                    gtm.pushOnClick({},'reviewSentSuccessfully');
                }
            });
        }
    });
}

/**
 * Initialisiert alle Funktionalitäten von artikel/artikel_probefahrt.tpl
 */
function initArtikelProbefahrt() {
    $('.artikel_filial_probefahrt').each(function () {
        var element = $(this);

        if (this.dataset === undefined) {
            this.dataset = [];
        }

        if (this.dataset.initArtikelProbefahrt !== 'true') {
            this.dataset.initArtikelProbefahrt = 'true';
            element.find('.artikel_filial_probefahrt__form-agb input').each(function () {
                new FxxlFormValidation($(this));
            });
        }
    });
}

/**
 * Initialisiert alle Funktionalitäten von artikel/json_add_customer_to_email_alert_list.tpl
 */
function initJsonAddCustomerToEmailAlertList() {
    $('.fxxl-add-customer-to-email-alert-list').each(function () {
        var $element = $(this);

        if (this.dataset.initJsonAddCustomerToEmailAlertList !== 'true') {
            this.dataset.initJsonAddCustomerToEmailAlertList = 'true';

            $element.find('.fxxl-text-input__text, .fxxl-textarea__text').each(function () {
                if (typeof this.fxxlTextInput !== 'object') {
                    new FxxlTextInputs($(this));
                }
            });

            $element.find('input[name="p_anrede"]').on('change', function () {
                $(this).closest('.fxxl-element-formelement').removeClass('fxxl-element-formelement--has-error');
            });

            $element.find('form').on('submit', function (event) {
                var $container = $(this).closest('.fxxl-add-customer-to-email-alert-list');

                $container.find('.fxxl-add-customer-to-email-alert-list__feedback').addClass('fxxl-hidden');
                $container.find('.fxxl-add-customer-to-email-alert-list__error').removeClass('fxxl-add-customer-to-email-alert-list__error');

                var isValid = true;
                var nErrors = $container.find('.fxxl-text-input__helper--error').length;

                var checkedSalutation = $container.find('input[name="p_anrede"]:checked').length;
                if (!checkedSalutation) {
                    nErrors++;
                    $container.find('input[name="p_anrede"]:first').closest('.fxxl-element-formelement').addClass('fxxl-element-formelement--has-error')
                }

                if (nErrors > 0) {
                    $container.find('.fxxl-add-customer-to-email-alert-list__feedback--fields').removeClass('fxxl-hidden');
                    isValid = false;
                }

                // privacyrules checked?
                $container.find('input[name^="privacyrule_"]').each(function () {
                    if (!this.checked) {
                        isValid = false;
                        $(this).parent().addClass('fxxl-add-customer-to-email-alert-list__error');
                        $container.find('.fxxl-add-customer-to-email-alert-list__feedback--privacy').removeClass('fxxl-hidden');
                    }
                });

                if (!isValid) {
                    event.preventDefault();
                } else {
                    showSpinner();
                }
            });
        }
    });
}

var fxxlFilialeSwitchCheckbox = $('.js-warengruppe-switch-branch-checkbox'),
    fxxlFilialeAddFilterElem = $('.fxxl-warengruppe-branch-filter__detail'),
    fxxlFilialeCurrentFilterElem = $('.fxxl-warengruppe-branch-filter__current'),
    fxxlFilialeSwitchElem = $('.fxxl-warengruppe-branch-filter__switch'),
    fxxlFilialeChngBranchLink = $('.fxxl-warengruppe-branch-filter__change-branch'),
    fxxlFilialeIconLocation = $('.fxxl-warengruppe-branch-filter__icon-location'),
    fxxlFilialeAddFilterElemHideClass = 'fxxl-warengruppe-branch-filter__detail--hide',
    fxxlFilialeCurrentFilterElemHideClass = 'fxxl-warengruppe-branch-filter__current--hide',
    fxxlFilialeSwitchElemHideClass = 'fxxl-warengruppe-branch-filter__switch--hide',
    fxxlFilialeChngBranchLinkHideClass = 'fxxl-warengruppe-branch-filter__change-branch--hide',
    fxxlFilialeIconLocationHideClass = 'fxxl-warengruppe-branch-filter__icon-location--hide';

function fxxlSetInitialWarengruppeBranchFilter() {
    if (FxxlPersonalData !== undefined) {
        if (FxxlPersonalData.branchfilterdata !== undefined
            && FxxlPersonalData.branchfilterdata
            && FxxlPersonalData.branchfilterdata.active !== undefined
            && FxxlPersonalData.branchfilterdata.branch_ort !== undefined) {
            fxxlFilialeCurrentFilterElem.removeClass(fxxlFilialeCurrentFilterElemHideClass);
            fxxlFilialeChngBranchLink.removeClass(fxxlFilialeChngBranchLinkHideClass);
            fxxlFilialeSwitchElem.removeClass(fxxlFilialeSwitchElemHideClass);
            fxxlFilialeIconLocation.removeClass(fxxlFilialeIconLocationHideClass);
            fxxlResetFilialeSwitchName(FxxlPersonalData.branchfilterdata.branch_ort);
        } else {
            fxxlFilialeAddFilterElem.removeClass(fxxlFilialeAddFilterElemHideClass);
            fxxlFilialeCurrentFilterElem.addClass(fxxlFilialeCurrentFilterElemHideClass);
            fxxlFilialeChngBranchLink.addClass(fxxlFilialeChngBranchLinkHideClass);
            fxxlFilialeSwitchElem.addClass(fxxlFilialeSwitchElemHideClass);
            fxxlFilialeIconLocation.removeClass(fxxlFilialeIconLocationHideClass);
        }
    }
    return false;
}

function fxxlGetArtikelStockFromBranchId() {
    var fxxlArticleAvailabilityInfoElement = isLargeViewport() ? $('.fxxl-element-artikel__available') : $('.fxxl-element-artikel__available:not([data-hidden-mobile])'),
        fxxlArticleAvailabilityInfoCLass = 'fxxl-element-artikel__available-info',
        fxxlArticleAvailableBranchClass = '.fxxl-element-artikel__available-branch',
        fxxlArticleUnavilableBranchClass = '.fxxl-element-artikel__available-not-branch',
        branchId;

    if (FxxlPersonalData !== undefined && FxxlPersonalData.branchfilterdata !== null && fxxlArticleAvailabilityInfoElement.length > 0) {
        branchId = parseInt(FxxlPersonalData.branchfilterdata.branchId);

        if (isNaN(branchId) === false) {
            fxxlArticleAvailabilityInfoElement.each(function () {
                var branches = $(this).data('availableonbranch'),
                    branchIds;

                if (branches !== undefined && branches !== null) {
                    branchIds = Object.values(branches);
                    if (branchIds.indexOf(branchId) >= 0) {
                        $(this).find(fxxlArticleUnavilableBranchClass).hide();
                        $(this).find(fxxlArticleAvailableBranchClass).show();
                    } else {
                        $(this).find(fxxlArticleUnavilableBranchClass).show();
                        $(this).find(fxxlArticleAvailableBranchClass).hide();
                    }
                    $(this).show();
                } else {
                    $(this).find(fxxlArticleUnavilableBranchClass).show();
                    $(this).find(fxxlArticleAvailableBranchClass).hide();
                    $(this).show();
                }

                const infoElements = this.getElementsByClassName(fxxlArticleAvailabilityInfoCLass);
                Array.from(infoElements).forEach((info) => {
                    info.innerHTML = info.innerHTML.replace(
                        "###filiale###",
                        FxxlPersonalData.branchfilterdata.branch_ort
                    );
                });
            });
        }
    }
}

function fxxlResetFilialeSwitchName(name) {
    $('.fxxl-warengruppe-branch-filter__current-name').html("&nbsp;" + name);
    $('.fxxl-warengruppe-branch-filter__current-change-name').html(name);
}

function fxxlSetInitialMeineFilialeSettings() {
    var mfiliale = getParameterByName('mfiliale'),
        currentLocation = window.location.href,
        standortUrlKey = null,
        currentStandort = null;

    if (currentLocation.indexOf('/standort.') > -1) {
        currentStandort = currentLocation.split('/standort.');
    }

    if (!mfiliale) {
        mfiliale = getParameterByName('pmfiliale');
    }

    if (mfiliale && currentStandort && currentStandort.length > 1) {
        mfiliale = validateBranchInfo(mfiliale);
        var request = '/json.php?service=getBranch&branch_id=' + mfiliale;

        jQuery.getJSON(request, function (response) {
            fxxlSetFilterCookieForChosenBranch(response.c_branch_id, 'true');
            fxxlResetFilialeSwitchName(response.ort_name);
            fxxlFilialeAddFilterElem.addClass(fxxlFilialeAddFilterElemHideClass);
            fxxlFilialeCurrentFilterElem.removeClass(fxxlFilialeCurrentFilterElemHideClass);
            fxxlFilialeChngBranchLink.removeClass(fxxlFilialeChngBranchLinkHideClass);
            fxxlFilialeSwitchElem.removeClass(fxxlFilialeSwitchElemHideClass);
            fxxlFilialeIconLocation.removeClass(fxxlFilialeIconLocationHideClass);
            fxxlFilialeSwitchCheckbox.prop('checked', true);
            fxxlFilialeSwitchCheckbox.attr('data-value', response.urlkey);
        });
    }

    if (FxxlPersonalData !== undefined && mfiliale === false) {
        if (FxxlPersonalData.branchfilterdata !== undefined
            && FxxlPersonalData.branchfilterdata
            && FxxlPersonalData.branchfilterdata.active !== undefined
            && FxxlPersonalData.branchfilterdata.urlkey !== undefined
            && FxxlPersonalData.branchfilterdata.branch_ort !== undefined
            && FxxlPersonalData.branchfilterdata.branch_link !== undefined) {
            if (currentStandort && currentStandort.length > 1) {
                standortUrlKey = currentStandort[1].split('/')[0];
            }
            if (standortUrlKey && standortUrlKey === FxxlPersonalData.branchfilterdata.urlkey &&
                FxxlPersonalData.branchfilterdata.active === 'true') {
                fxxlFilialeSwitchCheckbox.prop('checked', true);
            }

            var narrowerBranchElem,
                ortValue = FxxlPersonalData.branchfilterdata.urlkey;
            fxxlFilialeSwitchCheckbox.attr('data-value', ortValue);
            if (site_type == "warengruppe" && site_name == "detail") {
                narrowerBranchElem = $("input[data-key='standort'][data-value='" + ortValue + "']");
                if (narrowerBranchElem.length <= 0) {
                    fxxlFilialeSwitchCheckbox.prop('disabled', true);
                }
            }

            if (!(site_type == "branch" && site_name == "detail")) {
                fxxlSetMeineFilialeInHeader(FxxlPersonalData.branchfilterdata.branch_ort, FxxlPersonalData.branchfilterdata.active, FxxlPersonalData.branchfilterdata.branch_link);
            }
        } else {
            if (!(site_type == "branch" && site_name == "detail")) {
                fxxlSetMeineFilialeInHeader("", 'false', "");
            }
        }
    }
    return false;
}

function fxxlSetMeineFilialeInHeader(name, active, link) {
    var filialeElement = $('.js-fxxl-meine-filiale'),
        filialeOnElement = $('.js-fxxl-meine-filiale-icon-on'),
        filialeOffElement = $('.js-header-icon-filialen'),
        filialeName = $('.js-fxxl-meine-filiale-name'),
        filialeIconHideClass = 'fxxl-header__meine-filiale-icon--hide',
        filialeNameHideClass = 'fxxl-header__meine-filiale-name--hide',
        filialeOffIconHideClass = 'fxxl-header__icon-filialen--hide',
        filialeElementHideClass = 'fxxl-header__meine-filiale--hide';
    if (typeof (name) !== undefined && name !== "" && typeof (link) !== undefined && link !== "") {
        filialeOnElement.removeClass(filialeIconHideClass);
        filialeOffElement.addClass(filialeOffIconHideClass);
        filialeName.removeClass(filialeNameHideClass);
        filialeName.html(name);
        filialeElement.removeClass(filialeElementHideClass);
        filialeElement.attr("href", window.location.origin + link)
    } else {
        filialeOnElement.addClass(filialeIconHideClass);
        filialeOffElement.removeClass(filialeOffIconHideClass);
        filialeElement.addClass(filialeElementHideClass);
    }
    fxxlSetupSelectedFilialeMatrix();
}



function fxxlSetWarengruppeBanners() {
    const fxxlWgBanners = document.querySelectorAll('.js-fxxl-wg-banners');
    const fxxlWgBannersLinks = document.querySelectorAll('.js-fxxl-wg-banners-link');
    const fxxlWgBannersImgDesktop = document.querySelectorAll('.js-fxxl-wg-banners-img-desktop');
    const fxxlWgBannersImgMobile = document.querySelectorAll('.js-fxxl-wg-banners-img-mobile');


    if (fxxlWgBanners.length === 0
        || fxxlWgBannersLinks.length === 0
        || fxxlWgBannersImgDesktop.length === 0
        || fxxlWgBannersImgMobile.length === 0) {
        return;
    }

    if (FxxlPersonalData?.wgbannersdata?.items === undefined
        || FxxlPersonalData?.wgbannersdata?.numItems === undefined) {
        return;
    }

    if (FxxlPersonalData.wgbannersdata.numItems == 0) {
        return;
    }


    const bannerPositioningConditions  = [
        { startWidth: 1420, endWidth: 99999, itemCount: 12 },
        { startWidth: 1100, endWidth:  1419, itemCount:  9 },
        { startWidth:  980, endWidth:  1099, itemCount: 12 },
        { startWidth:  800, endWidth:   979, itemCount:  9 },
        { startWidth:  600, endWidth:   799, itemCount: 12 },
        { startWidth:    1, endWidth:   599, itemCount:  6 },
    ];
    const items = document.querySelectorAll('.fxxl-element-artikel');

    Object.keys(FxxlPersonalData.wgbannersdata.items).forEach((key) => {
        const wgBanner = FxxlPersonalData.wgbannersdata.items[key];
        const posIndex = wgBanner.banner_position - 1;

        if (wgBanner.banner_link !== undefined
            && wgBanner.img_desktop_src !== undefined
            && wgBanner.img_mobile_src !== undefined) {
            const banner = $(fxxlWgBanners[posIndex]);

            // Init Banner
            fxxlWgBannersImgDesktop[posIndex].src = wgBanner.img_desktop_src;
            fxxlWgBannersImgMobile[posIndex].src  = wgBanner.img_mobile_src;
            fxxlWgBannersLinks[posIndex].href  = wgBanner.banner_link;

            // Set Banner Function
            function showBanner() {
                const offsetWidth = document.body.offsetWidth;
                const bannerPosition = parseInt(wgBanner.banner_position);

                // Hide Banner
                banner.addClass('fxxl-hidden');

                // Show Banner
                bannerPositioningConditions.forEach((condition) => {
                    if (offsetWidth >= condition.startWidth && offsetWidth <= condition.endWidth) {
                        const bannerPositionRelativeToItems = condition.itemCount * bannerPosition;
                        if (items.length > bannerPositionRelativeToItems) {
                            banner.removeClass('fxxl-hidden');
                        }
                    }
                })
            }

            // Set Banner on Init
            showBanner();

            // Set Banner on Resize Event, based on Window Width
            new FxxlResizedEvent(() => showBanner());
        }
    });
}

function fxxlPrintElement(element) {
    var body = document.body,
        allBodyElements = document.querySelectorAll('body > *'),
        cloneElement = element.cloneNode(true),
        hideClass = 'fxxl-print-hidden',
        bodyClass = 'fxxl-print-body',
        fixElementClass = 'fxxl-print-element',
        logoClass = 'fxxl-print-logo',
        copyrightMainClass = 'fxxl-impressums-and-copyright_copyright',
        copyrightClass = 'fxxl-print-copyright',
        logo = document.getElementsByClassName('fxxl-header__logo-link'),
        copyRight = document.getElementsByClassName(copyrightMainClass),
        i;

    if (document.documentElement !== undefined) {
        document.documentElement.scrollTop = 0;
    } else {
        document.body.scrollTop = 0;
    }

    if (logo.length > 0) {
        logo = logo[0].cloneNode(true);
        logo.classList.add(logoClass);
    } else {
        logo = undefined;
    }

    if (copyRight.length > 0) {
        copyRight = copyRight[0]?.cloneNode(true);
        copyRight?.classList.remove(copyrightMainClass);
        copyRight?.classList.add(copyrightClass);
    } else {
        copyRight = undefined;
    }

    for (i = 0; i < allBodyElements.length; i += 1) {
        allBodyElements[i].classList.add(hideClass);
    }

    cloneElement.classList.add(fixElementClass);

    /* Starts */
    if (logo) {
        body.appendChild(logo);
    }
    if (cloneElement) {
        body.appendChild(cloneElement);
    }
    if (copyRight) {
        body.appendChild(copyRight);
    }
    /* Ends */

    body.classList.add(bodyClass);
    window.print();
    setTimeout(() => {
        body.classList.remove(bodyClass);
        cloneElement?.remove();
        logo?.remove();
        copyRight?.remove();

        for (i = 0; i < allBodyElements.length; i += 1) {
            allBodyElements[i].classList.remove(hideClass);
        }

    }, 600);
}

function fxxlRemoveURLParameter(url, parameter) {
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

/**
 * Convert SVG-Img To SVG-Xml
 * @type {FxxlConvertSVGImgToSVGXml}
 */

var FxxlConvertSVGImgToSVGXml = (function FxxlConvertSVGImgToSVGXml() {

    function FxxlConvertSVGImgToSVGXml(element) {
        this.img = $(element);
        this.imgID = null;
        this.imgClass = null;
        this.imgURL = null;
        this.svg = null;
        this.init();
    }

    FxxlConvertSVGImgToSVGXml.prototype.init = function init() {
        var __this = this;
        this.imgID = this.img.attr('id');
        this.imgClass = this.img.attr('class');
        this.imgURL = this.img.attr('src');

        $.get(this.imgURL, function (data) {
            __this.svg = $(data).find('svg');

            if (typeof __this.imgID !== 'undefined') {
                __this.svg = __this.svg.attr('id', __this.imgID);
            }

            if (typeof __this.imgClass !== 'undefined') {
                __this.svg = __this.svg.attr('class', __this.imgClass);
            }

            __this.svg = __this.svg.removeAttr('xmlns:a');

            if (!__this.svg.attr('viewBox') && __this.svg.attr('height') && __this.svg.attr('width')) {
                __this.svg.attr('viewBox', '0 0 ' + __this.svg.attr('height') + ' ' + __this.svg.attr('width'))
            }

            __this.img.replaceWith(__this.svg);

        }, 'xml');
    };

    return FxxlConvertSVGImgToSVGXml;
}());

var FxxlReCaptchaGetToken = (function FxxlReCaptchaGetToken() {

    function FxxlReCaptchaGetToken(element, callback) {
        this.element = $(element);
        this.callBack = callback;
        this.isNotCallBack = typeof this.callBack === 'undefined';
        this.element.reaptchaObject = this;
        this.reCaptchaAction = this.element.data('recaptcha-action');
        this.reaptchaForm = this.element.parentsUntil('form').parent('form');
        if (grecaptcha !== undefined) {
            this.init();
        }
    }

    FxxlReCaptchaGetToken.prototype.init = function init() {
        var __this = this;
        if (this.reaptchaForm.length > 0 && this.isNotCallBack === true) {
            this.reaptchaForm.on('submit', function () {
                if (__this.reaptchaForm.data('recaptcha') !== 1) {
                    setTimeout(function () {
                        __this.setToken();
                    }, 100);
                    return false;
                }
            });
        }
    };

    FxxlReCaptchaGetToken.prototype.checkValidation = function checkValidation() {
        return this.reaptchaForm.find('[data-form-validation-result="false"]').length === 0;
    };

    FxxlReCaptchaGetToken.prototype.setToken = function setToken() {
        var __this = this,
            ratingButton = null;

        if (this.isNotCallBack === true) {
            ratingButton = this.reaptchaForm.find('.fxxl-element-rating-form__form-row--button-container button');
        }

        if (this.checkValidation() === true) {
            if (this.isNotCallBack === true) {
                showSpinner();
            }
            // reCaptchaPublicKey is global (/srv/www/applicas/dev/customer_fahrradxxl/custom/module/public/fxxl3/html_head.tpl)
            grecaptcha.execute(reCaptchaPublicKey, {action: __this.reCaptchaAction}).then(function (token) {
                __this.element.val(token);

                if (__this.isNotCallBack === true) {
                    __this.reaptchaForm.attr('data-recaptcha', 1);
                    if (ratingButton.length > 0) {
                        ratingButton.click();
                    } else {
                        if (__this.isNotCallBack === true) {
                            __this.reaptchaForm.submit();
                        }
                    }
                } else {
                    __this.callBack();
                }
            });
        }
    };

    return FxxlReCaptchaGetToken;
}());

/**
 * fxxlGetAJAXContent
 * @param url
 * @param callBack
 * @param method
 * @param params
 * @param outputIsJson
 */
function fxxlGetAJAXContent(url, callBack, method, params, outputIsJson, showLoader) {
    var xmlhttp = new XMLHttpRequest(),
        output;

    if (method === undefined || method === null || method === '') {
        method = 'GET';
    }

    if (params === undefined || params === null) {
        params = '';
    }

    if (showLoader === undefined || showLoader === null) {
        showLoader = true;
    }

    if (outputIsJson !== false) {
        outputIsJson = true;
    }

    currentRunningFxxlGetAJAXContent += 1;

    if (showLoader === true) {
        showSpinner();
    }

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === XMLHttpRequest.DONE) {
            if (xmlhttp.status === 200) {
                output = xmlhttp.response;
                if (outputIsJson === true) {
                    output = JSON.parse(output);
                }
                callBack(output);
            }
            currentRunningFxxlGetAJAXContent -= 1;
            if (currentRunningFxxlGetAJAXContent === 0) {
                hideSpinner();
            }
        }
    };

    xmlhttp.open(method, url, true);
    xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xmlhttp.send(params);
}

/**
 * fxxlGetSelectionField
 * @param key
 */
var FxxlCreateSelectFromSelectionField = (function FxxlCreateSelectFromSelectionField() {
    function FxxlCreateSelectFromSelectionField(key, containerElement, elementName, elementClass, multiple, placeholder) {
        this.key = key;
        this.container = containerElement;
        this.elementName = elementName;
        this.elementClass = elementClass;
        this.multiple = multiple;
        this.placeholder = placeholder;
        this.multipleAttr = '';
        this.isArrayName = '';
        this.url = null;
        this.select = '';
        this.selectContainer = null;
        this.options = '';
        this.init();
    }

    FxxlCreateSelectFromSelectionField.prototype.init = function init() {
        this.url = '/json.php?service=getSelectionField&key=' + this.key;
        if (this.multiple === 1) {
            this.multipleAttr = 'multiple';
            this.isArrayName = '[]';
        }
        if (this.placeholder !== undefined && this.placeholder !== null) {
            this.options = '<option value="" hidden disabled selected>' + this.placeholder + '</option>';
        }
        this.create();
    };

    FxxlCreateSelectFromSelectionField.prototype.create = function create() {
        var __this = this, classes, className;

        fxxlGetAJAXContent(this.url, function (data) {
            data.forEach(function (option) {
                __this.options += '<option value="' + option.wert + '">' + option.pos_description + '</option>';
            });
            classes = __this.elementClass.split(' ');
            __this.select = '<select name="' + __this.elementName + __this.isArrayName + '" ' + __this.multipleAttr + '>' + __this.options + '</select>';
            __this.selectContainer = document.createElement('div');
            __this.selectContainer.classList.add('fxxl-select');
            classes.forEach(function (value) {
                __this.selectContainer.classList.add(value);
            });
            __this.selectContainer.innerHTML = __this.select;
            __this.container.appendChild(__this.selectContainer);
            new FxxlSelectForm($(__this.selectContainer));
        }, null, null, true, false);
    };

    return FxxlCreateSelectFromSelectionField;
}());

/**
 * fxxlGetBranchTimes
 * @param ids
 * @param callBack
 */
var fxxlBranchTimesCache = [];

function fxxlGetBranchTimes(ids, callBack) {
    if (Array.isArray(ids) === true) {
        ids = ids.join('_');
    }

    if (typeof fxxlBranchTimesCache[ids] === 'undefined') {
        $.getJSON('/json.php?service=getBranchTime&branches=' + ids, function (data) {
            fxxlBranchTimesCache[ids] = data;
            callBack(data);
        });
    } else {
        callBack(fxxlBranchTimesCache[ids]);
    }
}

function fxxlSetAllDependentWidgetPositions(compareWidgetIsVisible) {
    // Set Position of CCM19 Widget
    const ccm19Widget = document.querySelector('.ccm-settings-summoner');
    if (ccm19Widget !== null) {
        if (compareWidgetIsVisible === true) {
            if (isLargeViewport()) {
                ccm19Widget.style.transform = 'translate3d(-10px, -100px, 0px)';
            } else {
                ccm19Widget.style.transform = 'translate3d(-10px, -75px, 0px)';
            }
        } else {
            ccm19Widget.style.transform = 'translate3d(0px, 0px, 0px)';
        }
    }
}

function fxxlSetInitialComparisonWidgetCounter(onclickCompareProductType)
{
    var fxxlComparisonWidget = $('.js_counter_productcomparelist'),
        activeClass = 'fxxl-comparison-widget__container--active',
        hideClass = 'fxxl-comparison-widget__container--hide',
        showClass = 'fxxl-comparison-widget__container--show';

    if (FxxlPersonalData !== undefined
        && FxxlPersonalData.productcomparelist
    && fxxlComparisonWidget.length > 0) {
        if (FxxlPersonalData.productcomparelist.numItems === 1 && onclickCompareProductType === 'adding') {
            fxxlComparisonWidget.removeClass(hideClass);
            fxxlComparisonWidget.addClass(activeClass);
            fxxlSetAllDependentWidgetPositions(true);
        } else if (FxxlPersonalData.productcomparelist.numItems === 0 && onclickCompareProductType === 'removing') {
            fxxlComparisonWidget.removeClass(activeClass);
            fxxlComparisonWidget.removeClass(showClass);
            fxxlComparisonWidget.addClass(hideClass);
            fxxlSetAllDependentWidgetPositions(false);
        } else if (FxxlPersonalData.productcomparelist.numItems > 0) {
            fxxlComparisonWidget.addClass(showClass);
            fxxlSetAllDependentWidgetPositions(true);
        }
        setBadgeContent('productcomparelist', FxxlPersonalData.productcomparelist.numItems);
    } else {
        fxxlComparisonWidget.removeClass(activeClass);
        fxxlComparisonWidget.removeClass(showClass);
        fxxlSetAllDependentWidgetPositions(false);
    }
}

var FxxlBarAnimation = function FxxlBarAnimation() {
    function FxxlBarAnimation(items, bar, eventNames, callBack) {
        this.items = items;
        this.bar = bar;
        this.eventNames = eventNames;
        this.lastNewX = 0;
        this.lastNewY = 0;
        this.callBack = callBack;
        this.init();
    }

    FxxlBarAnimation.prototype.init = function init() {
        if (typeof this.callBack === 'undefined') {
            this.callBack = function () {
            };
        }
        this.setEvents();
    };

    FxxlBarAnimation.prototype.setEvents = function setEvents() {
        var __this = this;
        Array.prototype.forEach.call(this.items, function (item) {
            __this.eventNames.forEach(function (eventName) {
                item.addEventListener(eventName, function () {
                    __this.setBarPosition(this);
                    __this.callBack(this);
                });
            });
        });
    };

    FxxlBarAnimation.prototype.setBarPosition = function setBarPosition(item) {
        var itemOffset = item.getBoundingClientRect(),
            barOffset = this.bar.getBoundingClientRect(),
            newX,
            newY,
            scale;

        newX = itemOffset.x - barOffset.x + this.lastNewX;
        newY = itemOffset.y - barOffset.y + this.lastNewY + itemOffset.height;
        scale = item.offsetWidth / this.bar.offsetWidth;
        this.bar.style.transform = 'translate3d(' + newX + 'px, ' + newY + 'px, 0) scale(' + scale + ', 1)';
        this.lastNewX = newX;
        this.lastNewY = newY;
    };

    return FxxlBarAnimation;
}();

function fxxlChatActivationButtonVisible(status) {
    var chatOpenButton = $('.fxxl-chat__button--open');

    if (chatOpenButton.length > 0) {
        chatOpenButton.each(function () {
            if (status === true) {
                $(this).removeAttr('disabled');
                $(this).removeClass('fxxl-button--dark');
            } else {
                $(this).addClass('fxxl-button--dark');
            }
        });
    }
}

function fxxlCopyTextToClipboard (copyText, toastText) {
    const tempInput = document.createElement("input");
    tempInput.value = copyText;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); /*For mobile devices*/
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    fxxlCompareToast = M.toast({
        html: toastText,
        displayLength: 3000,
        classes: 'fxxl-toast'
    });
}

function fxxlHideGuuruChatBySelectModal(parentElement) {
    if (typeof parentElement !== 'undefined' && isLargeViewport() === false &&
        typeof window.fxxlMainGuuruChatWidget !== 'undefined') {
        let selectElements = parentElement.querySelectorAll(
            '.fxxl-select select');
        selectElements.forEach((element) => {
            element.fxxlSelectBoxObject.onOpen = () => {
                window.fxxlMainGuuruChatWidget.hide();
            };
            element.fxxlSelectBoxObject.onClose = () => {
                window.fxxlMainGuuruChatWidget.show();
            };
        });
    }
}

function fxxlHideSupportWidgetBySelectModal(parentElement) {
    if (fxxl_support_widget !== null && typeof parentElement !== 'undefined' && isLargeViewport() === false) {
        let selectElements = parentElement.querySelectorAll('.fxxl-select select');
        selectElements.forEach((element) => {
            element.fxxlSelectBoxObject.onOpen = () => {
                fxxl_support_widget.showHideWindow(false, false);
            };
            element.fxxlSelectBoxObject.onClose = () => {
                fxxl_support_widget.showHideWindow(false);
            };
        });
    }
}

function backgroundOverlayAnimation(method, showOnMobile) {
    if (showOnMobile === false && isLargeViewport() === false) {
        return;
    }
    let overlayClass = 'fxxl-background-overlay',
        overlay;

    if (document.getElementsByClassName(overlayClass).length === 0) {
        overlay = document.createElement('a');
        overlay.href = '#';
        overlay.classList.add(overlayClass);
        document.body.append(overlay);
    } else {
        overlay = document.querySelector('.' + overlayClass);
    }

    switch (method){
        case 'start':
            overlay.classList.add('fxxl-background-overlay--visible');
            break;
        case 'stop':
            overlay.classList.remove('fxxl-background-overlay--visible');
            overlay.classList.add('fxxl-background-overlay--hidden');
            break;
        default:
            console.warn('FXXL JS ERROR: Overlay Animation could not be performed | 420_branch.js');
    }
}

function simplifyUmlaut(myString) {
    myString = myString.replace('ä', 'ae');
    myString = myString.replace('ö', 'oe');
    myString = myString.replace('ü', 'ue');
    myString = myString.replace('ß', 'ss');
    return myString;
}

/**
 * Sticky tabs
 */
class FxxlStickyTabs {
    static stickyTabsClass = 'fxxl-tabs--sticky';
    static stickyHeaderClass = 'fxxl-base-header--sticky';
    static stickyTabs = null;
    static stickyHeader = null;

    static init() {
        let tmp = document.getElementsByClassName(this.stickyTabsClass);
        if (tmp.length > 0) {
            this.stickyTabs = tmp[0];
        }

        if (this.stickyTabs !== null) {
            tmp = document.getElementsByClassName(this.stickyHeaderClass);
            if (tmp.length > 0) {
                this.stickyHeader = tmp[0];
            }
        }
    }

    static setTopPosition() {
        this.init();
        let top = 0;
        if (this.stickyHeader !== null) {
            top += this.stickyHeader.offsetHeight;
        }

        if (this.stickyTabs !== null) {
            this.stickyTabs.style.top = `${top}px`;
        }
    }
}

/**
 * Sticky main header
 */
class FxxlStickyMainHeader {

    constructor(callBack) {
        this.mainHeaderTop = 0;
        this.mainHeaderStickyClass = 'fxxl-base-header--sticky';
        this.mainHeader = document.getElementsByClassName('fxxl-base-header')[0];
        this.dynamicHeader = document.getElementsByClassName('js-fxxl-header-main')[0];
        this.mainHeaderIsSticky = false;
        this.dynamicHeaderHeight = 0;
        this.scrollTimeout = null;
        if (typeof callBack !== 'function') {
            this.callBack = () => {};
        } else {
            this.callBack = callBack;
        }
        this.setup();
    }

    setup() {
        // Scroll: Sticky Header Logic
        if (typeof this.mainHeader !== 'undefined' && typeof this.dynamicHeader !== 'undefined') {
            new FxxlResizedEvent(() => {
                if (isLargeViewport() === false) {
                    this.mainHeader.style.height = '';
                }
            });

            // On load
            window.addEventListener('load', () => {
                this.checkStickyHeader();
            });

            // On Scroll
            window.addEventListener('scroll', () => {
                this.checkStickyHeader();
            });
        }
    }

    mainHeaderAddSticky () {
        if (this.mainHeaderIsSticky === false) {
            this.mainHeaderIsSticky = true;
            this.mainHeader.classList.add(this.mainHeaderStickyClass);
            if (isLargeViewport() === true) {
                this.dynamicHeaderHeight = this.dynamicHeader.offsetHeight;
                this.dynamicHeader.style.height = `${this.dynamicHeaderHeight}px`;
            } else {
                this.dynamicHeader.style.height = '';
            }
            this.callBack(true);
        }
    }

    mainHeaderRemoveSticky () {
        if (this.mainHeaderIsSticky === true) {
            this.mainHeaderIsSticky = false;
            this.mainHeader.classList.remove(this.mainHeaderStickyClass);
            if (isLargeViewport() === true) {
                this.dynamicHeaderHeight = this.dynamicHeader.offsetHeight;
                this.dynamicHeader.style.height = `${this.dynamicHeaderHeight}px`;
            } else {
                this.dynamicHeader.style.height = '';
            }
            this.callBack(false);
        }
    }

    manageStickyHead() {
        if (window.scrollY > this.mainHeaderTop) {
            this.mainHeaderAddSticky();
        } else {
            this.mainHeaderRemoveSticky();
        }
    }

    checkStickyHeader() {
        if (isLargeViewport() === false) {
            if (this.scrollTimeout !== null) {
                clearTimeout(this.scrollTimeout);
            }
            this.scrollTimeout = setTimeout(() => {
                this.manageStickyHead();
            }, 250);
        } else {
            this.manageStickyHead();
        }
    }
}

/**
 * Fxxl form submit by JS
 */
class FxxlFormSubmitByJs {
    constructor(form, callback = () => {}, options = {}) {
        const defaultOptions = {useToast: false, showSpinner: true};
        this.options = Object.assign(defaultOptions, options);
        this.showSpinner = this.options.showSpinner;
        this.useToast = this.options.useToast;
        this.callback = callback;
        this.toastObject = null;
        this.method = 'post';
        this.form = form;
        this.action = '';

        // init
        if (typeof this.form !== 'undefined') {
            this.init();
        }
    }

    init() {
        if (typeof this.form.method === 'string') {
            this.method = this.form.method;
        }
        if (typeof this.form.action === 'string') {
            this.action = this.form.action;
        }
        this.setEvent();
    }

    getToastText(type) {
        // Set text
        let toastText = null;
        if (type === 'success') {
            toastText = this.form.getAttribute('data-submit-success-text');
            if (toastText === null) {
                toastText = 'Success';
            }
        } else if (type === 'error') {
            toastText = this.form.getAttribute('data-submit-error-text');
            if (toastText === null) {
                toastText = 'Error';
            }
        }
        return toastText;
    }

    error () {
        const toastText = this.getToastText('error');
        if (toastText !== null) {
            this.toastObject = M.toast({
                html: toastText,
                displayLength: 3000,
                classes: 'fxxl-toast fxxl-toast--error'
            });
        }
    }

    success() {
        const toastText = this.getToastText('success');
        if (toastText !== null) {
            this.toastObject = M.toast({
                html: toastText,
                displayLength: 3000,
                classes: 'fxxl-toast'
            });
        }
    }

    setEvent() {
        // Setup submit function
        this.form.submit = async () => {
            // Show spinner
            if (this.showSpinner) {
                showSpinner();
            }


            // Clean Toast
            if (this.useToast === true && this.toastObject !== null) {
                this.toastObject.dismiss();
            }

            // send form
            const response = await fetch(this.action, {
                'method': this.method,
                'body': new FormData(this.form)
            })

            // Check response
            if (response.status >= 200 && response.status < 300) {
                this.success();
            } else {
                this.error();
            }

            // Call back function
            this.callback();

            // Hide spinner
            if (this.showSpinner) {
                hideSpinner();
            }
        };
    }
}

/**
 * Adding Url Parameter to Any Url
 *  @param {string} url
 *  @param {string} parameterName
 *  @param {string} parameterValue
 */
function appendParameterToUrl(url, parameterName, parameterValue) {
    try {
        let currentUrl = new URL(url);
        currentUrl.searchParams.set(parameterName, parameterValue);
        return currentUrl.href;
    } catch (_) {
        console.warn('FXXL JS Error: Invalid URL ' + url + ' | 400_functions_and_variables.js');
        return url;
    }
}

/**
 * Add Cookie parameter to the external URLs of help center
 * @param {string} url
 * @param {string} cookieConsent
 */
function fxxlGetHelpCenterUrlWithCookieParam(url, cookieConsent) {
    let cParameter = 'fxxlcc',
        cValue = (cookieConsent === 'all') ? 'true' : 'false';

    return appendParameterToUrl(url, cParameter, cValue);
}

/**
 * Add Cookie parameter to existing URLs in Shop
 * @param {string} cookieConsent
 */
function fxxlAddCookieParameterToHelpCenterUrls(cookieConsent) {
    let helpCenterLinkElements = document.querySelectorAll('.fxxl-support-widget-window-box[data-key="helpcenter"], .fxxl-footer__contact-link, .fxxl-help-center-link'),
        cParameter = 'fxxlcc',
        cValue = (cookieConsent === 'all') ? 'true' : 'false';

    [...helpCenterLinkElements].forEach((linkElement) => {
        if (linkElement.href !== 'undefined' && linkElement.href !== '') {
            linkElement.href = appendParameterToUrl(linkElement.href, cParameter, cValue);
        }
    });
}

function setBranchFilterCookie(branchFilterData)
{
    var data,
        active= 'false',
        setNarrowerBranch = false,
        apiSetFilterCookie = '/json.php?service=setBranchFilterCookie',
        switchElem = false;

    if (typeof branchFilterData.active !== 'undefined') {
        active = branchFilterData.active;
        if (active==='true') {
            switchElem = true;
        } else {
            switchElem = false;
        }
    }

    if (typeof branchFilterData.set_narrower_branch !== 'undefined') {
        setNarrowerBranch = branchFilterData.set_narrower_branch;
    }

    if (branchFilterData && branchFilterData.ort && branchFilterData.c_branch_id && branchFilterData.urlkey) {
        data = 'branch_ort=' + branchFilterData.ort +
            '&active=' + active +
            '&branch_id=' + branchFilterData.c_branch_id +
            '&urlkey=' + branchFilterData.urlkey +
            '&branch_link=' + branchFilterData.branch_link;
        fxxlSetMeineFilialeInHeader(branchFilterData.ort, active, branchFilterData.branch_link);
    } else {
        data = 'active=' + active;
    }

    $.ajax({
        url: apiSetFilterCookie,
        type: 'GET',
        data: data,
        dataType: 'json',
        success: function () {
            if (branchFilterData && branchFilterData.urlkey && branchFilterData.active && setNarrowerBranch===true) {
                $('.fxxl-side-modal__header-closebutton').click();
                setBranchInNarrower(branchFilterData.urlkey, switchElem);
            }
        }
    });
    return true;
}

function disableTzbButtonInfo(currentElement)
{
    currentElement.removeClass('fxxl-button--green');
    currentElement.find('.fxxl-button__icon').removeClass('hide');
    currentElement.find('.fxxl-info').addClass('hide');
}

function gtmVisibleTzb(id) {

    var products = [];
    var elements = $(id).find('input[name="product"]');
    if (elements.length) {
        elements.each(function (key) {
            products.push(JSON.parse($(this).val()));
            products[key].list = 'Warenkorb Modal passende Produkte';
        });
    }

    var additional_data = {
        'ecommerce' : {
            'impressions' : products
        }
    }
    gtm.pushOnLoad(additional_data, 'EECproductImpression');
}

/**
 * Setup Side Modal
 */
function setupFxxlSideModal() {
    $('.fxxl-side-modal').each(function () {
        var sideModalContainer;
        new FxxlSideModal($(this));
        sideModalContainer = $(this).find('.fxxl-side-modal__container');
        if (sideModalContainer.length !== 0) {
            new FxxlTouchScroller(sideModalContainer[0], 'top');
        }
    });
}

/**
 * Anchor-Tab
 */
class FxxlAnchorTabs {

    constructor(element) {
        this.element = element;
        this.tabs = null;
        this.contents = [];
        this.srollTimeOutDelay = 250;
        this.scrollTimeOut = null;
        /**
         * Ob Element sichtbar ist
         */
        if (this.element.offsetHeight > 0) {
            this.init();
        }
    }

    init() {
        this.tabs = this.element.querySelectorAll('.tab > a');
        this.tabs.forEach((tab) => {
            const href = tab.getAttribute('href');
            if (href !== null) {
                let content = document.getElementById(href.replace('#', ''));
                if (content !== null) {
                    content.fxxlLinkedTab = tab;
                    this.contents.push(content);
                }
            }
        });
        this.events();
    }

    getCurrentContent() {
        const elementOffsets = this.element.getBoundingClientRect();
        const elementBottom = elementOffsets.top + elementOffsets.height + 20;

        let selectedContent = null;
        let firstContent = null;
        this.contents.forEach((content) => {
            if (firstContent === null) {
                firstContent = content;
            }
            const contentOffset = content.getBoundingClientRect();
            if (contentOffset.top < elementBottom) {
                selectedContent = content;
            }
        });
        return selectedContent ?? firstContent;
    }

    events() {
        window.addEventListener('scroll', () => {
            if (this.scrollTimeOut !== null) {
                clearTimeout(this.scrollTimeOut);
            }
            this.scrollTimeOut = setTimeout(() => {
                let currentContent = this.getCurrentContent();
                if (currentContent !== null) {
                    currentContent.fxxlLinkedTab.fxxlSmoothScrollActive = false;
                    currentContent.fxxlLinkedTab.click();
                    currentContent.fxxlLinkedTab.fxxlSmoothScrollActive = true;
                }
            }, this.srollTimeOutDelay);
        });
    }
}
/**
 * fxxlCustomHtmlElements Class
 */

var fxxlCustomHtmlElements = {
    variables: {
        timeCorrectorTimer: null
    },
    functions: {
        stringToDatetime: function (stringDT) {
            /**
             * dd-mm-YYYY hh:mm:ss
             */
            var regex = /^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/g,
                datMatch = regex.exec(stringDT),
                thisDate = new Date(datMatch[3], parseInt(datMatch[2]) - 1, datMatch[1], datMatch[4], datMatch[5], datMatch[6]),
                userTimezoneOffset = thisDate.getTimezoneOffset();
                userTimezoneOffset *=  60000;

            return Math.round(new Date(thisDate.getTime() - userTimezoneOffset).getTime() / 1000);
        },

        autoTimeCorrector: function () {
            clearInterval(fxxlCustomHtmlElements.variables.timeCorrectorTimer);
            fxxlCustomHtmlElements.variables.timeCorrectorTimer = setInterval(function () {
                fxxlCustomHtmlElements.countdown.attributes.now += 1;
            }, 1000);
        },

        getUniqueID: function () {
            return Math.random().toString(36).slice(2);
        }
    },
    countdown: {
        attributes: {},
        variables: {
            title: '',
            timeStep: 1000,
            totalDays: 0,
            isActive: false
        },

        set: function (element) {
            if (this.getAttrs(element) === true) {
                var comingSoonTitle = null;

                if (typeof this.attributes.coming_soon_title !== 'undefined') {
                    comingSoonTitle = this.attributes.coming_soon_title;
                }

                this.variables.isActive = this.isActive();

                if (this.variables.isActive === true || (comingSoonTitle !== null && this.variables.isActive == -1)) {
                    this.setTitle();
                    this.create(element);
                    if (typeof this.attributes.theme !== 'undefined') {
                        element.addClass(this.attributes.theme);
                    }

                    fxxlCustomHtmlElements.functions.autoTimeCorrector();
                    var thisClass = this;
                    setInterval(function () {
                        thisClass.variables.isActive = thisClass.isActive();
                        thisClass.update(element);
                    }, this.variables.timeStep);
                }
            }
        },

        getAttrs: function (element, needServerDate) {

            needServerDate = (typeof needServerDate !== 'undefined') ? needServerDate : true;

            var attributes = [];
            $.each(element[0].attributes, function () {
                if (this.specified) {
                    if (this.name.toLowerCase() == "start" || this.name.toLowerCase() == "end") {
                        attributes[this.name] = fxxlCustomHtmlElements.functions.stringToDatetime(this.value);
                    } else {
                        attributes[this.name] = this.value;
                    }
                }
            });

            if (needServerDate === true) {
                var thisDate = new Date(parseInt($('html').first().data('timestamp')));
                attributes.now = new Date(thisDate.getTime() - thisDate.getTimezoneOffset()).getTime();
            } else {
                attributes.now = this.attributes.now;
            }

            this.attributes = attributes;
            return true;
        },

        isActive: function () {
            if (this.attributes.now < this.attributes.start) {
                return -1;
            } else if (this.attributes.now > this.attributes.end) {
                return -2;
            } else {
                return true;
            }
        },

        getDistance: function () {

            var fromDate,
                toDate;

            if (this.variables.isActive === true) {
                fromDate = this.attributes.now;
                toDate = this.attributes.end;
            } else {
                fromDate = this.attributes.now;
                toDate = this.attributes.start;
            }

            var Tdistance = toDate - fromDate,
                distance = {
                    days: Math.floor(Tdistance / (60 * 60 * 24)),
                    hours: Math.floor((Tdistance % (60 * 60 * 24)) / (60 * 60)),
                    minutes: Math.floor((Tdistance % (60 * 60)) / (60)),
                    seconds: Math.floor((Tdistance % (60)))
                }

            this.variables.totalDays = Math.floor((this.attributes.end
                - this.attributes.start) / (60 * 60 * 24));

            return distance;
        },

        getCounter: function (style, distance, update) {

            update = (typeof update !== 'undefined') ? update : false;

            var newToValue,
                textTheme = '',
                circleTheme = '',
                separatorTheme = '',
                svg = '',
                title = 'sec',
                currentValue,
                innerIds = {'day_el': 0, 'hour_el': 24, 'min_el': 60, 'sec_el': 60},
                elementSpace_st_1 = -54,
                elementSpace_st_2 = -65,
                _this = this;

            $.each(innerIds, function (innerId, maxValue) {

                if (innerId == 'sec_el') {
                    currentValue = distance.seconds;
                    if (currentValue < 2) {
                        if (typeof _this.attributes.seconds_title !== 'undefined') {
                            title = _this.attributes.seconds_title;
                        } else {
                            title = 'Sekunde';
                        }
                    } else {
                        if (typeof _this.attributes.seconds_plural_title !== 'undefined') {
                            title = _this.attributes.seconds_plural_title;
                        } else {
                            title = 'Sekunden';
                        }
                    }
                } else if (innerId == 'min_el') {
                    currentValue = distance.minutes;
                    if (currentValue < 2) {
                        if (typeof _this.attributes.minutes_title !== 'undefined') {
                            title = _this.attributes.minutes_title;
                        } else {
                            title = 'Minute';
                        }
                    } else {
                        if (typeof _this.attributes.minutes_plural_title !== 'undefined') {
                            title = _this.attributes.minutes_plural_title;
                        } else {
                            title = 'Minuten';
                        }
                    }
                } else if (innerId == 'hour_el') {
                    currentValue = distance.hours;
                    if (currentValue < 2) {
                        if (typeof _this.attributes.hours_title !== 'undefined') {
                            title = _this.attributes.hours_title;
                        } else {
                            title = 'Stunde';
                        }
                    } else {
                        if (typeof _this.attributes.hours_plural_title !== 'undefined') {
                            title = _this.attributes.hours_plural_title;
                        } else {
                            title = 'Stunden';
                        }
                    }
                } else if (innerId == 'day_el') {
                    currentValue = distance.days;
                    if (currentValue < 2) {
                        if (typeof _this.attributes.days_title !== 'undefined') {
                            title = _this.attributes.days_title;
                        } else {
                            title = 'Tag';
                        }
                    } else {
                        if (typeof _this.attributes.days_plural_title !== 'undefined') {
                            title = _this.attributes.days_plural_title;
                        } else {
                            title = 'Tagen';
                        }
                    }
                }

                if (maxValue === 0) {
                    newToValue = (100 / currentValue);

                } else {
                    newToValue = 100 - ((currentValue / maxValue) * 100);
                }

                if (typeof _this.attributes.theme !== 'undefined') {
                    textTheme = ' fxxl-countdown__svg-text--' + _this.attributes.theme;
                    circleTheme = ' fxxl-countdown__svg-circle--' + _this.attributes.theme;
                    separatorTheme = ' fxxl-countdown__svg-separator--' + _this.attributes.theme;
                }

                if (update === false) {
                    if (style === 1) {
                        svg += '<g transform="translate(' + elementSpace_st_1 + ',0)">' +
                            '<path transform="translate(54, 0)" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" ' +
                            'class=\'fxxl-countdown__svg-circle fxxl-countdown__svg-circle--disable' + circleTheme + '\' ' +
                            'stroke-dasharray=\'100, 100\'/>' +
                            '<path transform="translate(54, 0)" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" ' +
                            'data-type="' + innerId + '_number_c" ' +
                            'class=\'fxxl-countdown__svg-circle fxxl-countdown__svg-circle--enable\' ' +
                            'stroke-dasharray=\'' + newToValue + ', 100\'/>' +
                            '<text data-type="' + innerId + '_number_t" class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--number' + textTheme + '\' x="50%" ' +
                            'y="19px" text-anchor="middle" class="small" id="sec">' + currentValue + '</text>' +
                            '<text class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--title' + textTheme + '\' x="50%" ' +
                            'y="25px" text-anchor="middle" class="small">' + title + '</text></g>';
                    } else if (style === 2) {
                        var separator = '';
                        if (innerId != 'sec_el') {
                            separator = '<g class="fxxl-countdown__svg-separator' + separatorTheme + '">' +
                                '<circle r="1.5" cx="90" cy="19"/><circle r="1.5" cx="90" cy="11"/></g>';
                        }

                        svg += '<g transform="translate(' + elementSpace_st_2 + ',0) scale(1.1)"><text data-type="' + innerId + '_number_t" ' +
                            'class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--number fxxl-countdown__svg-text--style-num_' + style + textTheme + '\' x="50%" ' +
                            'y="19px" text-anchor="middle" class="small" id="sec">' + currentValue + '</text>' +
                            '<text class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--title fxxl-countdown__svg-text--style-num_' + style + textTheme + '\' x="50%" ' +
                            'y="25px" text-anchor="middle" class="small">' + title + '</text>' +
                            separator +
                            '</g>';
                    }

                    elementSpace_st_1 += 36;
                    elementSpace_st_2 += 37;
                } else {
                    update.find('[data-type="' + innerId + '_number_c"]').css({'stroke-dasharray': newToValue + ', 100'});
                    update.find('[data-type="' + innerId + '_number_t"]').text(currentValue);
                }
            });

            if (svg != '') {
                return '<svg data-inner-id="test" class=\'fxxl-countdown__svg fxxl-countdown__svg--counter\' viewBox=\'0 0 144 36\' >' + svg + '</svg>';
            }

        },

        setTitle: function () {
            if (this.variables.isActive === true) {
                this.variables.title = this.attributes.title;
            } else {
                this.variables.title = this.attributes.coming_soon_title;
            }
        },

        updateTitle: function (element) {
            this.setTitle();
            element.find('.fxxl-countdown__title').text(this.variables.title);
            element.find('.fxxl-countdown__img').attr('alt', this.variables.title);
        },

        getCircleLayout: function (distance) {
            var loayout,
                bgImg = '',
                hTheme = '',
                imgTheme = '',
                banner = '',
                bannerShortPos = 'left',
                bannerPosition = '',
                counterPosition = '',
                gridDisplay = '',
                heading = '',
                style = '',
                contentId = fxxlCustomHtmlElements.functions.getUniqueID(),
                counter_style = 1,
                titleStyle = '',
                svg,
                link;

            if (typeof this.attributes.href !== 'undefined') {
                link = ' href="' + this.attributes.href + '"';
            }

            if (typeof this.attributes.counter_style !== 'undefined') {
                counter_style = parseInt(this.attributes.counter_style);
            }

            svg = this.getCounter(counter_style, distance);

            if (typeof this.attributes.title_style !== 'undefined') {
                titleStyle = ' style="' + this.attributes.title_style + '"';
            }

            if (typeof this.attributes.text_color !== 'undefined') {
                style += '#' + contentId + ' .fxxl-countdown__svg-text--light { fill: ' + this.attributes.text_color + '; }';
            }

            if (typeof this.attributes.circle_back_ring !== 'undefined') {
                style += '#' + contentId + ' .fxxl-countdown__svg-circle--disable { stroke: ' + this.attributes.circle_back_ring + '; }';
            }

            if (typeof this.attributes.circle_active_ring !== 'undefined') {
                style += '#' + contentId + ' .fxxl-countdown__svg-circle--enable { stroke: ' + this.attributes.circle_active_ring + '; }';
            }

            if (style != '') {
                style = '<style>' + style + '</style>';
            }

            if (typeof this.attributes.theme !== 'undefined') {
                hTheme = ' fxxl-countdown__title--' + this.attributes.theme;
                imgTheme = ' fxxl-countdown__img--' + this.attributes.theme;
            }

            if (typeof this.attributes.bg !== 'undefined') {
                bgImg = '<img class="fxxl-countdown__img fxxl-countdown__img--bg' + imgTheme + '" alt="'
                    + this.variables.title
                    + '" src="' + this.attributes.bg + '">';
            }

            if (typeof this.attributes.banner_position !== 'undefined') {
                bannerShortPos = this.attributes.banner_position;
            }

            if (typeof this.attributes.banner !== 'undefined') {
                bannerPosition = ' fxxl-countdown__banner--' + bannerShortPos;
                counterPosition = ' fxxl-countdown__container--not-' + bannerShortPos;
                gridDisplay = ' fxxl-countdown--grid-' + bannerShortPos;

                banner = '<div class="fxxl-countdown__banner' + bannerPosition + '"><img class="fxxl-countdown__img fxxl-countdown__img--banner" ' +
                    'alt="' + this.variables.title + '" src="' + this.attributes.banner + '"></div>';
            }

            if (this.variables.title != '') {
                heading = '<h3 class="fxxl-countdown__title' + hTheme + '" ' + titleStyle + '>' + this.variables.title + '</h3>';
            }

            loayout = style + '<a class="fxxl-countdown__link fxxl-countdown__link--decoration-none"' + link + '>' + bgImg
                + '<div id="' + contentId + '" class="fxxl-countdown' + gridDisplay
                + ' fxxl-countdown--style-num_' + counter_style + '"><div class="fxxl-countdown__container'
                + counterPosition + '">' + heading + svg + '</div>' +
                banner + '</div></a>';

            return loayout;
        },

        create: function (element) {
            var distance = this.getDistance(),
                layout = this.getCircleLayout(distance);
            element.html(layout);
        },

        update: function (element) {
            this.getAttrs(element, false);
            var distance = this.getDistance();
            this.getCounter(0, distance, element);
            this.updateTitle(element);
        }

    }
};

/**
 * Google Tagmanager JS Lib
 *
 * Filename: 003_gtm.ts
 * Created: 2017-01-20
 *
 * @category  Frontend
 * @package   Global
 * @author    Jörn Schmahl <joern.schmahl@etailer.de>
 * @copyright 2017 etailer Solutions GmbH
 */
/// <reference path="001_et_js.ts" />
/// <reference path="002_et_fc.ts" />
var gtm;
(function (gtm) {
    /**
     * Push Data Layer on Load
     * @param data
     * @param event
     */
    function pushOnLoad(data, event) {
        if (event === void 0) { event = null; }
        if (etJS_empty(event) === false) {
            data['event'] = event;
        }
        if (!(typeof (dataLayer) == 'undefined' || dataLayer === null)) {
            dataLayer.push(data);
        }
    }
    gtm.pushOnLoad = pushOnLoad;
    /**
     * Push Data Layer on Click
     * @param data
     * @param event
     * @param link
     */
    function pushOnClick(data, event, link) {
        if (event === void 0) { event = null; }
        if (link === void 0) { link = null; }
        if (etJS_empty(event) === false) {
            data['event'] = event;
        }
        if (!(typeof (dataLayer) == 'undefined' || dataLayer === null)) {
            if (etJS_empty(link) === false) {
                data['eventCallback'] = function () {
                    window.location = link;
                };
                data['eventTimeout'] = 2000;
            }
            dataLayer.push(data);
        }
    }
    gtm.pushOnClick = pushOnClick;

    /**
     * Push Data Layer if Element is visible
     * @param ele_class
     * @param data
     * @param event
     * @param link
     */
    function pushOnVisible(ele_class, data, event, link) {
        const push_lock_class = "gtm_datalayer_push";
        const ele = document.querySelectorAll('.' + ele_class);

        document.addEventListener('scroll', () => {
            for(let i = 0; i < ele.length; i++) {
                if (isInViewport(ele[i]) && !ele[i].classList.contains(push_lock_class)) {
                    ele[i].classList.add(push_lock_class);
                    pushOnClick(data, event, link);
                }
            }
        });
    }
    gtm.pushOnVisible = pushOnVisible;
})(gtm || (gtm = {}));

function gtmCustomerData(customer) {
    var personalData = {};
    personalData['customer'] = {};

    if (!etJS_empty(customer['user'])) {
        personalData['customer']['user'] = customer['user'];
    }

    if (!etJS_empty(customer['cart'])) {
        personalData['customer']['cart'] = customer['cart'];
    }

    if (!etJS_empty(customer['wishlist'])) {
        personalData['customer']['wishlist'] = customer['wishlist'];
    }

    gtm.pushOnLoad(personalData, 'customerData');
}

function isInViewport (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};
var FxxlReadMore = (function FxxlReadMore() {
    function FxxlReadMore(element) {
        this.element = element[0] ?? element;
        this.tolerance = 20; // %
        this.btnTarget = null;
        this.hasExternalVideos = null;
        this.maxHeight = null;
        this.maxHeightTolerance = null;
        this.height = null;
        this.button = document.createElement('button');
        this.button.className = 'fxxl-read-more__button fxxl-read-more__button--closed';
        this.buttonId = null;
        this.buttonSelector = null;
        this.fixBottomPadding = 40; // Px
        this.isTooShort = false;
        this.containerSize = null;
        this.containerSizeList = {
            xsmall: {
                mobile: 60,
                desktop: 70,
            },
            small: {
                mobile: 70,
                desktop: 100,
            },
            medium: {
                mobile: 250,
                desktop: 350,
            },
            large: {
                mobile: 350,
                desktop: 450,
            },
        };
        this.init();
        this.element.readMoreElement = this;
    }

    FxxlReadMore.prototype.init = function init() {
        if (!this.element.offsetParent) {
            return false;
        }

        this.setContainerSize();

        this.element.style.maxHeight = '';
        this.maxHeight = parseInt(window.getComputedStyle(this.element).maxHeight, 10);
        this.maxHeightTolerance = ((this.tolerance / this.containerSize) + 1) * this.maxHeight;
        this.btnTarget = this.element.dataset.btnTarget;
        this.elementExternalVideos = this.element.querySelectorAll('[data-read-more-has-videos="true"]');
        this.element.style.maxHeight = 'none';
        this.height = this.element.offsetHeight;
        this.buttonId = 'readmore-btn-' + Math.random().toString(36).substr(2, 9);
        this.button.id = this.buttonId;
        if (this.height > this.maxHeightTolerance) {
            this.element.style.maxHeight = '0';
            this.element.style.paddingBottom = this.maxHeight + 'px';
            this.setReadMore();
        } else {
            this.isTooShort = true;
        }
        if (this.elementExternalVideos.length > 0) {
            this.watchVideoLazyLoading();
        }
    };

    FxxlReadMore.prototype.setContainerSize = function setContainerSize() {
        let elementSizeKey = 'small';
        let viewportSizeKey = 'mobile';
        if (this.element.classList.contains('fxxl-read-more--xsmall')) {
            elementSizeKey = 'xsmall';
        } else if (this.element.classList.contains('fxxl-read-more--medium')) {
            elementSizeKey = 'medium';
        } else if (this.element.classList.contains('fxxl-read-more--large')) {
            elementSizeKey = 'large';
        }
        if (isLargeViewport() === true) {
            viewportSizeKey = 'desktop';
        }
        this.containerSize = this.containerSizeList[elementSizeKey][viewportSizeKey];
    };

    FxxlReadMore.prototype.setReadMore = function setReadMore() {
        this.element.classList.add('fxxl-read-more--active');
        if (this.btnTarget === 'self') {
            this.buttonSelector = '#' + this.buttonId;
            this.insetSelfButton();
        } else {
            this.buttonSelector = this.btnTarget;
        }
        document.querySelector(this.buttonSelector).setAttribute('data-read-more-opened', 'false');
        this.setEvents();
    };

    FxxlReadMore.prototype.insetSelfButton = function insetSelfButton() {
        this.element.appendChild(this.button);
    };

    FxxlReadMore.prototype.setEvents = function setEvents() {
        var __this = this;
        document.querySelectorAll(this.buttonSelector).forEach(function(btn) {
            btn.addEventListener('click', function () {
                if (this.getAttribute('data-read-more-opened') === 'false') {
                    __this.open();
                } else {
                    __this.close();
                }
            });
        });
    };

    FxxlReadMore.prototype.watchVideoLazyLoading = function watchVideoLazyLoading() {
        var __this = this,
            lazyMutationObserver = window.MutationObserver || window.WebKitMutationObserver,
            lazyObserver = new lazyMutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.attributeName === 'src' && mutation.target.nodeName === 'IMG') {
                        if (mutation.target.complete) {
                            requestAnimationFrame(function () {
                                __this.setHeight();
                            });
                        } else {
                            mutation.target.addEventListener('load', function () {
                                requestAnimationFrame(function () {
                                    __this.setHeight();
                                });
                            });
                        }
                    }
                });
            });

        lazyObserver.observe(this.elementExternalVideos[0], {attributes: true, subtree: true});
    };

    FxxlReadMore.prototype.setHeight = function setHeight() {
        var liveHeight = this.element.scrollHeight - this.maxHeight;
        if (this.height < liveHeight) {
            this.height = liveHeight;
        }
    };

    FxxlReadMore.prototype.open = function open() {
        this.button.classList.remove('fxxl-read-more__button--closed');
        this.button.classList.add('fxxl-read-more__button--opened');

        var btn = document.querySelector(this.buttonSelector);
        btn.setAttribute('data-read-more-opened', 'true');
        btn.classList.add('fxxl-read-more-opened');

        this.element.style.paddingBottom = (this.height + this.fixBottomPadding) + 'px';
    };

    FxxlReadMore.prototype.close = function close() {
        this.button.classList.remove('fxxl-read-more__button--opened');
        this.button.classList.add('fxxl-read-more__button--closed');

        var btn = document.querySelector(this.buttonSelector);
        btn.setAttribute('data-read-more-opened', 'false');
        btn.classList.remove('fxxl-read-more-opened');

        this.element.style.paddingBottom = this.maxHeight + 'px';
        var pId = btn.getAttribute('data-close-target');
        if (!this.element.classList.contains('fxxl-read-more--xsmall')) {
            var targetElement = document.getElementById(pId);
            window.scrollTo({
                top: targetElement.offsetTop - 111,
                left: 0,
                behavior: 'smooth'
            });
        }
    };

    return FxxlReadMore;
}());

import {FxxlMelibo} from '@fxxl/melibo';

/**
 * Starts: Proxy jQuery-Val Function
 */
var fxxlOrginalJqueryValFunction = $.fn.val;
$.fn.val = function (value) {
    if (value !== undefined) {
        var result = fxxlOrginalJqueryValFunction.apply(this, arguments);
        if ($(this).parent().hasClass('fxxl-select') === true && arguments.length > 0) {
           FxxlCore.eventEmitter('change').emit(null, $(this)[0]);
        }
        return result;
    }
    return fxxlOrginalJqueryValFunction.apply(this);
};

/**
 * Ends: Proxy jQuery-Val Function
 */
var FxxlSelectForm = (function FxxlSelectForm() {
    function FxxlSelectForm(element) {
        var __this = this;
        this.element = element.find('select').first();
        this.lastVersion = null;
        this.selectedValue = null;
        this.touchScrollObject = null;
        this.wrapperActive = false;
        this.stopObserve = false;
        this.isScrolled = false;
        this.wrapper = element;
        this.touchSupported = false;
        this.isMultiple = false;
        this.supportWidget = undefined;
        this.supportWidgetClass = 'fxxl-support-widget';
        this.hiddenClass = 'fxxl-hidden';
        this.multipleClass = 'fxxl-select--multiple';
        this.usedPlaceholderTextClass = 'fxxl-select--default-text';
        this.ignoreEventClass = 'fxxl-select__ignore-event';
        this.overlay = $('<a href="#" class="fxxl-select__backgroundlayer"></a>');
        this.removeButton = $('<a href="#" class="fxxl-select__header-closebutton"><svg width="24" height="24"><use href="#sprite_icon_close" xlink:href="#sprite_icon_close"></use></svg></a>');
        this.selectboxheader = $('<div class="fxxl-select__header"></div>');
        this.selectboxheadertext = '<span class="fxxl-select__header-text">' + this.element.attr('data-selectbox-header') + '</span>';
        this.optionsWithImages = false;
        // Wenn optionsWithImages `false` wird als Display-Element ein Text-Input verwendet. Andernfalls ein Div-Element.
        this.selectDisplayTextInput = $('<input type="text" class="fxxl-select__input browser-default" readonly>');
        this.selectDisplayWithImage = $('<div class="fxxl-select__display"></div>');
        this.selectContainer = $('<div class="fxxl-select__select-container"></div>');
        this.optionsContainer = $('<ul class="fxxl-select__options-container"></ul>');
        this.optionTemplate = $('<li class="fxxl-select__option"></li>');
        this.multiOptionTemplate = $('<label class="fxxl-select__checkbox ' + this.ignoreEventClass + '"><input type="checkbox" class="filled-in ' + this.ignoreEventClass + '"/><span class="' + this.ignoreEventClass + '">---</span></label>');
        this.alternativeLinkTemplate =  $('<div class="fxxl-select__option-alternative-link"><a class="fxxl-json-modal" href="#">alternativen anzeigen</a></div>');
        this.priceTemplate = $('<div class="fxxl-select__option-prices"><div class="fxxl-select__option-price fxxl-price"></div></div>');
        this.priceWithStrikePriceTemplate = $('<div class="fxxl-select__option-prices"><div class="fxxl-select__option-price fxxl-price-with-strike-price"></div><div class="fxxl-select__option-price--strike fxxl-strike-price"></div></div>');
        this.iconClosed = $('<svg width="24" height="24" class="fxxl-select__icon fxxl-select__icon--closed">' +
            '<use href="#sprite_icon_keyboard_arrow_down" xlink:href="#sprite_icon_keyboard_arrow_down">' +
            '</use></svg>');
        this.iconOpened = $('<svg width="24" height="24" class="fxxl-select__icon fxxl-select__icon--opened">' +
            '<use href="#sprite_icon_keyboard_arrow_up" xlink:href="#sprite_icon_keyboard_arrow_up">' +
            '</use></svg>');
        this.optionsContainerChilds = 0;
        this.optionsContainerMaxVisibleChilds = 10;
        this.activeClass = 'fxxl-select--active';
        this.displayClass = 'fxxl-select__backgroundlayer--show';
        this.touchEndEnable = true;
        this.downTime = null;
        this.onOpen = function onOpen() {};
        this.onClose = function onClose() {};
        // weiterentwicklung für wertgarantie
        this.element[0].fxxlSelectBoxObject = this;
        this.clickOutTarget = $('body');

        if ($(this.element).data('show-options') === false) {
            this.showElementByDefault = false;
        } else {
            this.showElementByDefault = true;
        }

        this.supportWidget = document.querySelector(`.${this.supportWidgetClass}`);

        this.setup();

        new FxxlResizedEvent(function () {
            __this.setup();
        });

    }

    // Static member to track the instances of this class
    FxxlSelectForm.selectFields = [];
    // Static member to track the active instances of this class
    FxxlSelectForm.activeSelectFields = new Set();

    FxxlSelectForm.prototype.setup = function setup() {
        if (isLargeViewport() !== this.lastVersion) {
            this.lastVersion = isLargeViewport();
            this.optionsContainer.html('');
            this.init();
        }
    };

    FxxlSelectForm.prototype.init = function init() {
        this.isMultiple = this.element[0].multiple;
        this.optionsWithImages = this.doOptionsHaveImages();
        this.setSelectedInputText();
        this.bindOptions();
        this.updateSelectedOption();
        this.touchSupported = FxxlCore.isTouchDevice();

        // Hide Select
        this.element.css({'display': 'none'});

        const tabindex = this.element.attr('tabindex');

        if (tabindex) {
            this.selectDisplayTextInput.attr('tabindex', tabindex);
        }

        this.wrapper.append(this.selectDisplayTextInput);

        if (this.optionsWithImages) {
            this.selectDisplayTextInput.addClass(this.hiddenClass);
            this.wrapper.append(this.selectDisplayWithImage);
        }

        this.wrapper.append(this.iconClosed)
            .append(this.iconOpened)
            .append(this.selectContainer);

        if (isLargeViewport() === false) {
            this.wrapper.append(this.overlay);

            if (this.isMultiple === true) {
                this.wrapper.addClass(this.multipleClass);
            }
        }

        if (isLargeViewport() === false) {
            if (this.element.attr('data-selectbox-header') !== undefined) {
                this.selectboxheader.html(this.selectboxheadertext);
            } else {
                this.selectboxheader.html('Bitte auswählen');
            }
            this.selectboxheader.append(this.removeButton);
        }

        this.selectContainer.append(this.selectboxheader);
        this.selectContainer.append(this.optionsContainer);

        // Scroll function for Mobile
        this.touchScrollObject = new FxxlTouchScroller(this.optionsContainer[0], 'top');

        FxxlSelectForm.selectFields.push(this);

        this.setEvents();
        this.setupProperties();
        this.checkSelectIsDisabled();
    };

    FxxlSelectForm.prototype.reinit = function reinit() {
        this.selectDisplayTextInput.val('');
        this.selectDisplayWithImage.html('');
        this.optionsContainer.html('');
        this.setSelectedInputText();
        this.bindOptions();
        this.checkSelectIsDisabled();
    };

    FxxlSelectForm.prototype.doOptionsHaveImages = function doOptionsHaveImages() {
        for (const option of this.element[0].querySelectorAll('option')) {
            if (option?.dataset?.imageSrc) {
                return true;
            }
        }
        return false;
    }

    FxxlSelectForm.prototype.checkSelectIsDisabled = function checkSelectIsDisabled() {
        if (this.element.is(':disabled') === true) {
            this.wrapper.addClass('fxxl-select--disabled');
        } else {
            this.wrapper.removeClass('fxxl-select--disabled');
        }
    };

    FxxlSelectForm.prototype.bindOptions = function bindOptions() {
        var __this = this,
            option,
            optionValue,
            optionText,
            optionDisplayElement,
            optionCheckBox,
            alternativeLinkElement,
            alternativeLink,
            priceElement;

        this.element.find('> option').each(function () {
            option = $(this);
            optionText = option.html();
            optionValue = option.attr('value') ?? optionText;
            optionDisplayElement = __this.optionTemplate.clone(true);

            // Set required data-values
            optionDisplayElement.attr('data-value', optionValue);

            // Transfer option-attributes to data-attributes of selectItem
            if (option.attr('hidden') === 'hidden') {
                optionDisplayElement.attr('data-hidden', 'true');
            }
            if (option.attr('disabled') === 'disabled') {
                optionDisplayElement.attr('data-disabled', 'true');
            }
            // Set specified css class (if present)
            if (option.attr('data-css-class')) {
                optionDisplayElement.addClass(option.attr('data-css-class'));
            }
            // Set content of display element
            if (__this.isMultiple !== true) {
                if (option?.attr('data-footnotemark')) {
                    optionText += `<sup>${option.attr('data-footnotemark')}</sup>`;
                }
                if (option?.attr('data-image-src') && optionValue !== '') {
                    let optionContainerClassNames = 'option-container';
                    if (option?.attr('disabled') === 'disabled') {
                        optionContainerClassNames += ' option-container--disabled';
                    }
                    const dataImageSrc = option.attr('data-image-src');
                    optionText = `<div class="${optionContainerClassNames}">
                                      <div>${optionText}</div>
                                      <div><img class="option-container-logo" src="${dataImageSrc}"</div>
                                  </div>`;
                }
                optionDisplayElement.html(optionText);
            } else {
                optionCheckBox = __this.multiOptionTemplate.clone(true);
                optionCheckBox.find('span').html(optionText);
                optionDisplayElement.append(optionCheckBox);
            }
            // Append alternative link or price(s) (if given)
            if (option.attr('data-alternatives-url')) {
                alternativeLinkElement = __this.alternativeLinkTemplate.clone(true);
                alternativeLink = alternativeLinkElement.find('a.fxxl-json-modal');
                alternativeLink.attr('data-json-url', option.attr('data-alternatives-url'));
                alternativeLink.text(option.attr('data-alternatives-link-text'));
                optionDisplayElement.append(alternativeLinkElement);
            } else if (option.attr('data-price')) {
                if (option.attr('data-strike-price')) {
                    priceElement = __this.priceWithStrikePriceTemplate.clone(true);
                    priceElement.find('.fxxl-select__option-price--strike').text(option.attr('data-strike-price'));
                } else {
                    priceElement = __this.priceTemplate.clone(true);
                }
                priceElement.find('.fxxl-select__option-price').text(option.attr('data-price'));
                optionDisplayElement.append(priceElement);
            }
            // Set selected data property if appropriate
            if (__this.selectedValue === optionValue || (__this.isMultiple === true && __this.selectedValue.includes(optionValue))) {
                optionDisplayElement.attr('data-selected', 'true');
            }

            if (optionValue !== '') {
                __this.optionsContainer.append(optionDisplayElement);
            }

            __this.optionsContainerChilds += 1;
        });
    };

    FxxlSelectForm.prototype.updateSelectedOption = function updateSelectedOption() {
        var __this = this,
            item;
        this.stopObserve = true;
        this.optionsContainer.find('.fxxl-select__option').removeAttr('data-selected');
        this.optionsContainer.find('.fxxl-select__option').each(function () {
            item = $(this);
            if (item.attr('data-value') === __this.selectedValue) {
                item.attr('data-selected', 'true');
            }
            if (__this.isMultiple && __this.selectedValue.includes(item.attr('data-value'))) {
                item.attr('data-selected', 'true');
                item.find('input').attr('checked', 'checked');
            }
        });
        this.stopObserve = false;
    };

    FxxlSelectForm.prototype.setSelectedInputText = function setSelectedInputText() {
        var __this = this,
            selectedOption,
            selectedOptionText,
            selectedValue,
            placeholderItem;

        selectedValue = this.element.val();
        if (this.isMultiple === true) {
            selectedOptionText = '';
            $.each(selectedValue, function (key, value) {
                selectedOptionText += ', ' + __this.element.find('option[value="' + value + '"][data-hidden!="true"]').first().text();
            });
            if (selectedOptionText.length > 0) {
                selectedOptionText = selectedOptionText.substr(1);
            }
        } else {
            selectedOption = this.element.find('option[value="' + selectedValue + '"]').first();
            selectedOptionText = selectedOption.text();
        }

        if (selectedValue === null || (this.isMultiple === true && selectedOptionText.length === 0)) {
            placeholderItem = this.element.find('option[selected][disabled]');
            if (placeholderItem.length !== 0) {
                selectedValue = placeholderItem.text();
                selectedOption = placeholderItem;
                selectedOptionText = selectedValue;
            }
            this.wrapper.addClass(this.usedPlaceholderTextClass);
        } else {
            this.wrapper.removeClass(this.usedPlaceholderTextClass);
        }

        if (this.optionsWithImages) {
            this.selectDisplayWithImage.attr('data-selected-text', selectedOptionText);
            this.selectDisplayWithImage.attr('data-selected-value', selectedValue);
            if (selectedOption?.attr('data-image-src')) {
                const dataImageSrc = selectedOption.attr('data-image-src');
                selectedOptionText = `${selectedOptionText} <img src="${dataImageSrc}"/>`;
            }
            this.selectDisplayWithImage.html(selectedOptionText);
        } else {
            this.selectDisplayTextInput.val(selectedOptionText);
            this.selectedValue = selectedValue;
            if (this.isMultiple === false && selectedOption.attr('disabled') === 'disabled') {
                this.selectDisplayTextInput.addClass('fxxl-select__input--placeholder');
            } else {
                this.selectDisplayTextInput.removeClass('fxxl-select__input--placeholder');
            }
        }
        this.updateSelectedOption();
    };

    FxxlSelectForm.prototype.setSelectedValue = function setSelectedValue(value) {
        this.element[0].value = value;
    };

    FxxlSelectForm.prototype.valueSetter = function valueSetter(value) {
        $(this).val(value);
        const form = this.closest('form');
        if (form) {
            FxxlCore.eventEmitter('change').emit({'target': this}, form);
        }
    };

    FxxlSelectForm.prototype.valueGetter = function valueGetter() {
        return $(this).val() ?? '';
    };

    FxxlSelectForm.prototype.setupProperties = function setupProperties() {
        var __this = this;
        Object.defineProperty(this.element[0], 'value', {
            get: __this.valueGetter,
            set: __this.valueSetter
        });
    };

    /*
     * Ändert die Höhe des Select-Containers,
     * sodass eine maximale Menge an Select-Option-Elementen angezeigt werden können.
     *
     * Note, sollte das Select-Element zu nah am Boden der Seite sein, in dem Maß das nichtmal ein Element
     * angezeigt werden kann, wird eine Höhenanpassung ignoriert.
     */
    FxxlSelectForm.prototype.changeMaxHeight = function changeMaxHeight() {
        const __this = this;
        const selectOptionList = __this.optionsContainer;
        const selectOptionChildren = selectOptionList.find('>li[data-hidden!=true]');
        const bodyScrollHeight = document.body.scrollHeight;
        const wrapperDimensions = __this.wrapper?.[0]?.getBoundingClientRect();

        if (wrapperDimensions === undefined || selectOptionChildren?.length === 0) {
            return;
        }

        // Define the height of the select option child
        const optionHeight = selectOptionChildren.last()?.[0]?.clientHeight;

        if (optionHeight === undefined) {
            return;
        }

        // Maximum height of the select option container
        const totalOptionsHeight = __this.optionsContainerChilds * optionHeight;

        // Calculate the space from the Select Input to the bottom of body
        const spaceSelectToBodyBottom = bodyScrollHeight - wrapperDimensions.bottom;

        // Defiine the minimum number of list elements that fit into the space
        let minimumListElements = Math.floor(spaceSelectToBodyBottom / optionHeight);

        // IF: Enough Space: Set the minimum list elements to the length of the select option children
        if (minimumListElements >= selectOptionChildren.length) {
            minimumListElements = selectOptionChildren.length;
        }

        // Set the upper limit of visible list elements (without scrolling)
        // TODO: Is this still wanted?
        if (minimumListElements > __this.optionsContainerMaxVisibleChilds) {
            minimumListElements = __this.optionsContainerMaxVisibleChilds;
        }

        // Set the optimized height
        const optimizedHeight = minimumListElements * optionHeight + 1;

        if (
            optimizedHeight >= optionHeight
            && optimizedHeight <= totalOptionsHeight
        ) {
            __this.selectContainer.css('max-height', optimizedHeight);
        } else {
            __this.selectContainer.removeAttr("style");
        }
    };

    FxxlSelectForm.prototype.hideSupportWidget = function hideSupportWidget() {
        if (this.supportWidget) {
            this.supportWidget?.fxxlSupportWidget.showHideWidget(false);
        }

        if (!isLargeViewport()) {
            FxxlMelibo.hideWidgetIcon();
        }
    }

    FxxlSelectForm.prototype.showSupportWidget = function showSupportWidget() {
        if (this.supportWidget) {
            this.supportWidget?.fxxlSupportWidget.showHideWidget(true);
        }

        if (!isLargeViewport()) {
            FxxlMelibo.showWidgetIcon();
        }
    }

    FxxlSelectForm.prototype.hideSelectBox = function hideSelectBox(delay) {
        var __this = this;

        if (this.wrapperActive) {
            this.overlay.removeClass(this.displayClass);
            this.wrapper.removeClass(this.activeClass);
            this.wrapper.closest('.fxxl-base-card').removeAttr('style');
            this.wrapperActive = false;
            FxxlSelectForm.activeSelectFields.delete(this);
            if (delay === undefined) {
                this.downTime = null;
            } else {
                setTimeout(function () {
                    __this.downTime = null;
                }, delay);
            }
            this.showSupportWidget();
            this.onClose();
        }
    };

    FxxlSelectForm.prototype.showSelectBox = function showSelectBox() {
        var delay = 500, __this = this;

       if (this.showElementByDefault === true) {
           if (isLargeViewport()) {
               this.changeMaxHeight();
           }

           if (this.wrapper.hasClass(this.activeClass) === true && this.downTime !== null && new Date() - this.downTime >= delay) {
               this.hideSelectBox(delay);
           } else if (this.downTime === null) {
               this.wrapper.addClass(this.activeClass);
               this.overlay.addClass(this.displayClass);
               this.wrapperActive = true;
               FxxlSelectForm.activeSelectFields.add(this);
               this.downTime = new Date();
               if (isLargeViewport() === true) {
                   setTimeout(function () {
                       __this.selectDisplayTextInput.focus();
                   }, 50);
               }
               this.hideSupportWidget();
               this.onOpen();
           }
       }
    };

    FxxlSelectForm.prototype.setMultipleValue = function setMultipleValue() {
        var checkoxList = this.optionsContainer.find('input[type="checkbox"]'),
            values = [];

        checkoxList.each(function () {
            if (this.checked === true) {
                values.push($(this).closest('li').data('value'));
            }
        });

        if (this.selectedValue !== values) {
            this.setSelectedValue(values);
            this.updateSelectedOption();
        }
    };

    FxxlSelectForm.prototype.setEvents = function setEvents() {
        var __this = this,
            newValue,
            clickedElement,
            clickedOptionDisplay,
            optionsContainerMouseEvent;

        this.wrapper.on('mousedown touchstart', function (e) {
            __this.touchEndEnable = true;
            if (e.target.tagName === 'LI' || e.target.parentNode === __this.selectboxheader[0].parentNode || e.target === __this.selectboxheader[0].parentNode) {
                return false;
            }

            if (isLargeViewport() === true || __this.touchSupported === false) {
                __this.showSelectBox();
            }
        });

        this.wrapper.on('touchmove', function () {
            __this.touchEndEnable = false;
        });

        this.wrapper.on('mouseleave mouseup touchend', function (e) {
            /* optimized for mobile */

            if (isLargeViewport() === false && (e.type === 'mouseleave' || e.type === 'mouseup')) {
                /* Because of Bug in mobile browser */
                return false;
            }

            if (__this.wrapperActive === false && isLargeViewport() === false && __this.touchEndEnable === true) {
                __this.showSelectBox();
            }

            if (__this.touchEndEnable === true) {
                if (((e.target.parentNode === __this.wrapper[0] || e.target.parentNode === __this.selectContainer[0]) && e.target !== __this.overlay[0] && isLargeViewport() === false) && __this.showElementByDefault === true) {
                   return false;
                }
            }

        });

        this.selectDisplayTextInput.on('focusout', function () {
            if (__this.wrapperActive === true && __this.isMultiple === false) {
                __this.hideSelectBox(50);
                return false;
            }
        });

        this.removeButton.on('click', function () {
            __this.hideSelectBox(50);
            return false;
        });

        this.optionsContainer.on('touchstart', function () {
            __this.isScrolled = false;
        });

        this.overlay.on('click', function () {
            __this.hideSelectBox(50);
            return false;
        });

        if (__this.isMultiple === true) {
            optionsContainerMouseEvent = 'mouseup';
            this.optionsContainer.on('mousedown', function (e) {
                return !isLargeViewport();
            });
        } else {
            optionsContainerMouseEvent = 'mousedown';
        }

        this.optionsContainer.on(optionsContainerMouseEvent + ' touchend', function (e) {
            if (__this.isScrolled === true) {
                return false;
            }

            clickedElement = $(e.target);
            if (!clickedElement.hasClass('fxxl-select__option')) {
                clickedOptionDisplay = clickedElement.closest('.fxxl-select__option');
                if (clickedOptionDisplay) {
                    clickedElement = clickedOptionDisplay;
                }
            }

            if (__this.isMultiple === true) {
                setTimeout(function () {
                    __this.setMultipleValue();
                }, 200);
                return !isLargeViewport();
            } else {
                newValue = clickedElement.data('value');
            }

            if (newValue === undefined) {
                return false;
            }

            if (__this.selectedValue !== newValue) {
                __this.setSelectedValue(newValue);
                __this.updateSelectedOption();
            }

            setTimeout(function () {
                __this.hideSelectBox();
            }, 50);

            return false;
        });

        this.element.on('change', function () {
            __this.setSelectedInputText();
        });

        this.touchScrollObject.onScroll = function () {
            __this.isScrolled = true;
        };

        this.clickOutTarget[0].addEventListener('click', FxxlSelectForm.handleOutClickEvent);

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (__this.stopObserve === false) {
                    if ((mutation.type === 'attributes' && mutation.attributeName === 'disabled') || mutation.type === 'childList') {
                        __this.stopObserve = true;
                        __this.reinit();
                        __this.stopObserve = false;
                    }
                }
            });
        });

        observer.observe(this.element[0], {attributes: true, childList: true, subtree: false});
    };

    FxxlSelectForm.prototype.onOutClick = function onOutClick(event) {
        // Klicks auf das Element selbst zählen nicht als Out-Klicks.
        if (this.wrapper.has(event.target).length > 0) {
            return true;
        }
        this.hideSelectBox();
    }

    FxxlSelectForm.handleOutClickEvent = function (event) {
        // Auf mobil wird das Zuklappen des Modals durch einen Klick auf den Overlay (oder den Schließen-Button)
        // erwirkt.
        if (isLargeViewport() === false) {
            return true;
        }
        if (FxxlSelectForm.activeSelectFields.size === 0) {
            return true;
        }
        if ($(event.target).closest('.fxxl-select').length > 0) {
            return true;
        }
        FxxlSelectForm.selectFields?.forEach((elem) => {
            elem.onOutClick(event);
        });

    }

    return FxxlSelectForm;
}());

/**
 * Text input
 *
 * Filename: 400_text_input.js
 *
 * @category  Applicas
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 * @copyright 2019 Fahrrad XXL
 */

var FxxlTextInputs = (function FxxlTextInputs() {

    function FxxlTextInputs(input) {
        this.input = input;
        this.label = input.parent('label');
        this.container = this.label.parent('div');
        this.form = this.container.closest('form');
        this.updateShowPasswordToggleTime = 2000;
        this.fadeAnimateTime = 250;
        this.enableEventListener = true;
        this.inputTypeChangeTimer = null;
        this.hasErrorTargets = false;
        this.errorTargets = '';
        this.validationDisabled = false;
        this.cypressErrorId = '';

        if (this.input.prop("tagName") === 'TEXTAREA') {
            this.prefix = 'fxxl-textarea';
        } else {
            this.prefix = 'fxxl-text-input';
        }

        this.errorTargets = fxxlGetFormValidationErrorTargets(this.input);

        if (this.errorTargets !== false) {
            this.hasErrorTargets = true;
        }

        this.isShowPasswordToggleActive = this.label.hasClass(this.prefix + '__label--show-password-toggle')
            && this.input.attr('type').toLowerCase() === 'password';

        this.clearTemplate = $('<svg class="' + this.prefix + '__icon ' + this.prefix + '__icon--right" width="40" height="40""><use href="#sprite_icon_close" ' +
            'xlink:href="#sprite_icon_close"></use></svg>');

        this.successTemplate = $('<svg class="' + this.prefix + '__icon ' + this.prefix + '__icon--right ' + this.prefix + '__icon--check" width="40" height="40"">' +
            '<use href="#sprite_icon_check" ' +
            'xlink:href="#sprite_icon_check"></use></svg>');

        this.errorTemplate = $('<svg class="' + this.prefix + '__icon ' + this.prefix + '__icon--right ' + this.prefix + '__icon--error" width="40" height="40"">' +
            '<use href="#sprite_icon_error_outline" ' +
            'xlink:href="#sprite_icon_error_outline"></use></svg>');

        this.showPasswordToggleTemplate = $('<a href="#" class="' + this.prefix + '__show-password-toggle">' +
            '<svg class="' + this.prefix + '__icon ' + this.prefix + '__icon--password-invisible" width="20" height="20"">' +
            '<use href="#sprite_icon_visibility" ' +
            'xlink:href="#sprite_icon_visibility"></use></svg>' +
            '<svg class="' + this.prefix + '__icon ' + this.prefix + '__icon--password-visible" width="20" height="20"">' +
            '<use href="#sprite_icon_visibility_off" ' +
            'xlink:href="#sprite_icon_visibility_off"></use></svg></a>');

        this.helperTemplate = $('<div class="' + this.prefix + '__helper"></div>');

        this.init();

        var that = this;
        input.get(0).fxxlTextInput = that;
        this.container.each(function (index, element) {
            this.fxxlTextInput = that;
        });
        this.input[0].fxxl_form_validation_object = this;
    }

    FxxlTextInputs.prototype.init = function init() {
        var __this = this,
            input = this.input,
            container;

        input.addClass('browser-default');
        container = this.container;

        /**
         * Chrome (maybe BUG)
         */
        setTimeout(function () {
            if (input.is(':-webkit-autofill') === true) {
                container.addClass('' + __this.prefix + '--active');
            }
        }, 100);

        if (input[0].value.trim() !== '') {
            container.addClass('' + this.prefix + '--active');
            this.validator(input);
        }

        this.form.on('submit', function () {
            return __this.validator(input, 'submit');
        });

        this.form[0]?.addEventListener(FxxlCore.getConfig()?.eventNames?.formValidation, () => {
            return __this.validator(input, 'submit');
        });

        input.on('focus change', function () {
            container.addClass(__this.prefix + '--active');
        });

        input.on('blur change', function () {
            if (input.val().trim() === '') {
                container.removeClass(__this.prefix + '--active');
            }
        });

        input.on('change blur', function () {
            if (__this.enableEventListener === false) {
                return false;
            } else {
                __this.validator(input);
            }
        });

        if (this.input[0]?.name !== undefined) {
            this.cypressErrorId = `fxxl-error-${this.input[0]?.name}`;
        }

        this.setupShowPasswordToggle();
    };

    FxxlTextInputs.prototype.setupShowPasswordToggle = function setupShowPasswordToggle() {
        var __this = this,
            showClass = __this.prefix + '__show-password-toggle--show';

        if (this.isShowPasswordToggleActive === true) {
            this.hideRightIcon();
            this.label.append(this.showPasswordToggleTemplate);

            this.showPasswordToggleTemplate.on({
                'mouseover': function () {
                    __this.enableEventListener = false;
                },
                'mouseleave': function () {
                    __this.enableEventListener = true;
                },
                'click': function () {
                    if (__this.showPasswordToggleTemplate.hasClass(showClass) !== true) {
                        __this.showPasswordToggleTemplate.addClass(showClass);
                        __this.changeInputType('text');
                    } else {
                        __this.showPasswordToggleTemplate.removeClass(showClass);
                        __this.changeInputType('password');
                    }
                    return false;
                }
            });
        }
    };

    FxxlTextInputs.prototype.changeInputType = function changeInputType(type) {
        var __this = this;
        __this.input.css({'font-size': '0'});

        if (this.inputTypeChangeTimer !== null) {
            clearTimeout(this.inputTypeChangeTimer);
        }
        this.inputTypeChangeTimer = setTimeout(function () {
            __this.input.attr('type', type);
            setTimeout(function () {
                __this.input.css({'font-size': ''});
            }, 1);
        }, this.fadeAnimateTime);
    };

    FxxlTextInputs.prototype.updateShowPasswordToggle = function updateShowPasswordToggle() {
        var __this = this;

        if (this.isShowPasswordToggleActive === true) {
            this.showPasswordToggleTemplate.fadeOut(this.fadeAnimateTime);
            setTimeout(function () {
                __this.hideRightIcon();
                __this.showPasswordToggleTemplate.fadeIn(__this.fadeAnimateTime);
            }, this.updateShowPasswordToggleTime);
        }
    };

    FxxlTextInputs.prototype.hideRightIcon = function hideRightIcon() {
        this.hideClearIcon();
        this.hideErrorIcon();
        this.hideSuccessIcon();
    };

    FxxlTextInputs.prototype.setValidationEnabled = function setValidationEnabled(enabled) {
        this.input.attr('data-validation-enabled', (enabled ? 'true' : 'false'));
    };

    FxxlTextInputs.prototype.isValid = function isValid() {
        return this.validator(this.input);
    };

    FxxlTextInputs.prototype.validator = function validator(input, phase) {
        var i,
            l,
            validatorTemp = true,
            validationAttr = input.attr('data-validation') || '',
            validationEnabledAttr = input.attr('data-validation-enabled') || '',
            validationErrorFieldAttr = input.attr('data-validation-error-field') || '',
            validationTextAttr = input.attr('data-validation-text') || '',
            validationShowSuccessAttr = input.attr('data-validation-show-success') || 'true',
            validatorErrorField = (validationErrorFieldAttr.length > 0) ? validationErrorFieldAttr.split('|') : [],
            validatorTypes = (validationAttr.length > 0) ? validationAttr.split('|') : [],
            validatorTexts = (validationTextAttr.length > 0) ? validationTextAttr.split('|') : [],
            validationShowSuccess = (validationShowSuccessAttr === 'true');

        if (validationEnabledAttr !== 'false' && validatorTypes.length > 0) {
            l = validatorTypes.length - 1;

            for (i = 0; i <= l; i += 1) {
                validatorTemp = this.validate(validatorTypes[i], phase);
                if (validatorTemp === false) {
                    this.setErrorClass();
                    this.showErrorIcon();
                    this.hideErrors(validatorErrorField);
                    if (validatorErrorField.length > i && validatorErrorField[i].length > 0) {
                        $('.js_element_formerror[data-checkout2-error-field=' + validatorErrorField[i] + ']').each(function (index, value) {
                            var $this = $(this);
                            $this.removeClass('fxxl-hidden');
                            $('.js_element_formerror__server', $this).addClass('fxxl-hidden');
                            $('.js_element_formerror__client', $this).removeClass('fxxl-hidden');
                        });
                    } else if ((validatorTexts.length > i && validatorTexts[i].length > 0) || this.hasErrorTargets === true) {
                        this.showHelper(validatorTexts[i], this.prefix + '__helper--error', i);
                    }
                    break;
                }
            }

            if (validatorTemp === true) {
                this.clearErrorClass();
                this.hideErrors(validatorErrorField);
                if (validationShowSuccess) {
                    this.showSuccessIcon();
                } else {
                    this.clearIcons();
                }
                return true;
            }
            return false;
        }
    };

    FxxlTextInputs.prototype.setErrorClass = function setErrorClass() {
        this.container.addClass(this.prefix + '--error');
    };

    FxxlTextInputs.prototype.clearErrorClass = function clearErrorClass() {
        this.container.removeClass(this.prefix + '--error');
    };

    FxxlTextInputs.prototype.clearIcons = function clearIcons() {
        this.hideClearIcon();
        this.hideSuccessIcon();
        this.hideErrorIcon();
    };

    FxxlTextInputs.prototype.clearInput = function clearInput() {
        this.input.val('');
        this.clearIcons();
    };

    FxxlTextInputs.prototype.showHelper = function showHelper(text, cssClass, index) {
        var target;
        if (this.hasErrorTargets === false) {
            this.helperTemplate.html(text);
            this.helperTemplate.addClass(cssClass);
            this.helperTemplate[0].setAttribute('data-cy', this.cypressErrorId);
            this.label.after(this.helperTemplate);
        } else {
            target = $(this.errorTargets[index]);
            if (target.length > 0) {
                target.show();
            }
        }
    };

    FxxlTextInputs.prototype.hideHelper = function hideHelper(text, cssClass) {
        var target;
        if (this.hasErrorTargets === false) {
            this.helperTemplate.remove();
        } else {
            target = $(this.errorTargets.join(','));
            if (target.length > 0) {
                target.hide();
            }
        }
    };

    FxxlTextInputs.prototype.hideErrors = function hideErrors(errorFields) {
        this.hideHelper();
        $.each(errorFields, function (index, errorField) {
            if (errorField !== '') {
                $('.js_element_formerror[data-checkout2-error-field=' + errorField + ']').addClass('fxxl-hidden');
            }
        })
    };

    FxxlTextInputs.prototype.resetErrors = function resetErrors() {
        var validationErrorFieldAttr = this.input.attr('data-validation-error-field') || '',
            validatorErrorField = (validationErrorFieldAttr.length > 0) ? validationErrorFieldAttr.split('|') : [];
        this.clearErrorClass();
        this.hideErrorIcon();
        this.hideErrors(validatorErrorField);
    };

    FxxlTextInputs.prototype.showClearIcon = function showClearIcon() {
        var __this = this;

        if (this.label.find(this.clearTemplate).length === 0) {
            this.clearIcons();
            this.clearErrorClass();
            this.clearTemplate.on('click', function () {
                __this.clearInput();
            });
            this.label.append(this.clearTemplate);
            this.updateShowPasswordToggle();
        }
    };

    FxxlTextInputs.prototype.hideClearIcon = function hideClearIcon() {
        if (this.label.find(this.clearTemplate).length > 0) {
            this.clearTemplate.remove();
        }
    };

    FxxlTextInputs.prototype.showSuccessIcon = function showSuccessIcon() {
        if (this.label.find(this.successTemplate).length === 0) {
            this.clearIcons();
            this.label.append(this.successTemplate);
            this.updateShowPasswordToggle();
        }
    };

    FxxlTextInputs.prototype.hideSuccessIcon = function hideSuccessIcon() {
        if (this.label.find(this.successTemplate).length > 0) {
            this.successTemplate.remove();
        }
    };

    FxxlTextInputs.prototype.showErrorIcon = function showErrorIcon() {
        if (this.label.find(this.errorTemplate).length === 0) {
            this.clearIcons();
            this.label.append(this.errorTemplate);
            this.updateShowPasswordToggle();
        }
    };

    FxxlTextInputs.prototype.hideErrorIcon = function hideErrorIcon() {
        if (this.label.find(this.errorTemplate).length > 0) {
            this.errorTemplate.remove();
        }
    };

    FxxlTextInputs.prototype.validatekeywordFilter = function validatekeywordFilter(value, keywordGroupsToCheck) {
        var result = true;
        var keywordGroups = {
            deliveryAddressService: ['lasburg', 'paketshop'],
            deliveryStation: ['packstation', 'pakstation', 'paketstation', 'packetstation', 'packstaion'],
            postBranch: ['postfiliale', 'postfilliale', 'paketfiliale']
        };
        value = value.toLowerCase().replace(/ /g, '');
        if (value.length > 0) {
            for (var i = 0; i < keywordGroupsToCheck.length; i++) {
                if (keywordGroups.hasOwnProperty(keywordGroupsToCheck[i])) {
                    var keywords = keywordGroups[keywordGroupsToCheck[i]];
                    for (var j = 0; j < keywords.length; j++) {
                        if (value.indexOf(keywords[j]) !== -1) {
                            result = false;
                        }
                    }
                }
            }
        }
        return result;
    };

    FxxlTextInputs.prototype.validate = function validate(typeValue, phase) {
        var result,
            value = this.input.val(),
            typeSplit = typeValue.split(':'),
            type = typeSplit[0];

        if (this.validationDisabled === true) {
            return true;
        }

        if (type === 'supplement') {
            result = this.validatekeywordFilter(value, ['deliveryAddressService', 'deliveryStation', 'postBranch']);
        } else if (type === 'date' || type === 'date_adult' || type === 'date_yt100') {
            result = true;
            if (phase === 'submit') {
                var parts = {};
                result = false;
                this.input.closest('.js_input_birthday_container').each(function () {
                    var $this = $(this);
                    ['day', 'month', 'year'].forEach(function (part) {
                        var value = $('input.js_input_birthday_' + part, $this).val();
                        var pattern = /^\d+/;
                        if (pattern.test(value)) {
                            parts[part] = parseInt(value);
                        }
                    });
                    if (parts.year && parts.month && parts.day) {
                        var dob = new Date(parts.year, parts.month - 1, parts.day);
                        if (dob.getFullYear() === parts.year && dob.getMonth() + 1 === parts.month && dob.getDate() === parts.day) {
                            result = true;
                            var today = new Date();
                            if (type === 'date_adult') {
                                dob.setFullYear(dob.getFullYear() + 18);
                                if (dob.getTime() > today.getTime()) {
                                    result = false;
                                }
                            }
                            if (type === 'date_yt100') {
                                dob.setFullYear(dob.getFullYear() + 100);
                                if (dob.getTime() <= today.getTime()) {
                                    result = false;
                                }
                            }
                        }
                    }
                });
            }
        } else {
            result = fxxlDoFormValidation(this.input, value, typeValue);
        }
        return result;
    };

    return FxxlTextInputs;
}());

var fxxl_last_search_keyword = '',
    fxxl_searchRequestId = undefined,
    fxxl_transactionId = 0,
    fxxl_desktopSearch = $('#fxxl-header-search-container'),
    fxxl_desktopSearchResults = $('#fxxl-header-search-results'),
    fxxl_desktopSearchResultsLeft = $('#fxxl-header-search-kategorie, #fxxl-header-search-custom, #fxxl-header-search-extern, #fxxl-header-search-blog'),
    fxxl_desktopSearchResultsRight = $('#fxxl-header-search-results-cards'),
    fxxl_desktopSearchField = $('#fxxl-header-search-container-field'),
    fxxl_desktopSearchResultsCustom = $('#fxxl-header-search-custom'),
    fxxl_desktopSearchResultsKategorie = $('#fxxl-header-search-kategorie'),
    fxxl_desktopSearchResultsExtern = $('#fxxl-header-search-extern'),
    fxxl_desktopSearchResultsBlog = $('#fxxl-header-search-blog'),
    fxxl_beratungSearchField = $('.fxxl-content-search__input'),
    tmp_cus,
    tmp_cat,
    tmp_faq,
    maxSearchResultLimit = {
        mobile: {
            category: 0, // ignore - because on mobile horizontal slider has been used.
            helpAndSupport: 3,
            morePages: 3,
            product: 3,
            blog: 3
        },
        desktop: {
            category: 8, // ignore if empty - using default value from PHP code.
            helpAndSupport: 5,
            morePages: 5,
            product: 8,
            blog: 3,
        }
    };

new FxxlElementVersionControl('#fxxl-header-search-container', largViewportSize, function () {
    fxxl_last_search_keyword = '';
    fxxl_desktopSearch = $('#fxxl-header-search-container');
    fxxl_desktopSearchResults = $('#fxxl-header-search-results');
    fxxl_desktopSearchResultsLeft = $('#fxxl-header-search-kategorie, #fxxl-header-search-custom, #fxxl-header-search-extern, #fxxl-header-search-blog');
    fxxl_desktopSearchResultsRight = $('#fxxl-header-search-results-cards');
    fxxl_desktopSearchField = $('#fxxl-header-search-container-field');
    fxxl_desktopSearchResultsCustom = $('#fxxl-header-search-custom');
    fxxl_desktopSearchResultsKategorie = $('#fxxl-header-search-kategorie');
    fxxl_desktopSearchResultsExtern = $('#fxxl-header-search-extern');
    fxxl_desktopSearchResultsBlog = $('#fxxl-header-search-blog');
    fxxl_beratungSearchField = $('.fxxl-content-search__input');
    MainSearchAutocomplete();
    fxxHideMainSearch();
});

function getSearchPreview(searchElement) {
    const search_val = searchElement.val();
    const presenceMapToId = FxxlCore.getConfig().server?.presence?.internal_description_to_id ?? {};
    let searchPresenceId = _presence_id;
    if (_presence === 'karriereportal' && typeof presenceMapToId.fxxl !== 'undefined') {
        searchPresenceId = presenceMapToId.fxxl;
    }

    let requestUrl = '/json.php?service=autocompleteAll&lang=' + _lang + '&praesenz=' + searchPresenceId + '&shop=' + _shop
        + '&term=' + search_val + '&tid=' + (++fxxl_transactionId);

    if (typeof searchElement.data('search') !== 'undefined') {
        searchElement.data('search').forEach(function (element) {
            requestUrl += requestUrl + '&' + element;
        });
    }

    fxxl_last_search_keyword = search_val;

    $.getJSON(requestUrl, function (response, textStatus, jqXHR) {
        // refresh display only if this is the response to the last request
        if (response.transactionId !== fxxl_transactionId) {
            return;
        }

        // kontrollieren, ob alle elemente da und nicht leer sind sind oder mindestens eins da und nicht leer ist...
        let regex;
        if (jqXHR.status === 200) {
            var displayLeft = false;
            var displayRight = false;

            fxxl_desktopSearchResultsLeft.addClass('fxxl-hidden');
            fxxl_desktopSearchResultsRight.addClass('fxxl-hidden');

            regex = new RegExp('(' + RegExp.escape(search_val) + ')', 'gmi');

            /**
             * Starts: Category
             */
            if (searchElement.is(fxxl_desktopSearchField)) {
                fxxl_desktopSearchResultsKategorie.addClass('fxxl-hidden');
                if (response.category.length > 0) {
                    var acc = fxxl_desktopSearchResults.find('#fxxl-header-search-kategorie-results'),
                        isMobileVersion = !isLargeViewport();

                    fxxl_desktopSearchResultsKategorie.attr('data-visibility', 'show');
                    acc.empty();
                    for (i = 0; i < response.category.length; i += 1) {
                        if (isMobileVersion === true) {
                            let category_name = response.category[i].category_only ?? response.category[i].category;
                            acc.append('<div><a class="fxxl-button" href="' + response.category[i].link + '"><span class="fxxl-button__text">' + category_name + '</span></a></div>');
                        } else {
                            tmp_cat = response.category[i].category.replace(regex, '<span class="fxxl-search__text fxxl-search__text--highlight">$1</span>');
                            acc.append('<a class="fxxl-search__link" href="' + response.category[i].link + '">' + tmp_cat + '</a>');
                            /**
                             * Manage number of visible search result
                             */
                            if (maxSearchResultLimit.desktop.category && i === (maxSearchResultLimit.desktop.category - 1)) {
                                break;
                            }
                        }
                    }
                    fxxl_desktopSearchResultsKategorie.removeClass('fxxl-hidden');
                    displayLeft = true;
                    if (isMobileVersion === true && displayLeft === true) {
                        new FxxlBtnSlider1('#' + acc.attr('id'));
                    }
                } else {
                    fxxl_desktopSearchResultsKategorie.attr('data-visibility', 'hide');
                    fxxl_desktopSearchResults.find('#fxxl-header-search-kategorie-results').empty();
                }
            } else {
                fxxl_desktopSearchResultsKategorie.attr('data-visibility', 'hide');
            }
            /** Ends: Category */

            /**
             * Starts: More pages
             */
            let currentElement = fxxl_desktopSearchResultsCustom;
            currentElement.addClass('fxxl-hidden');

            if (response.custom.length > 0) {
                fxxl_desktopSearchResultsCustom.attr('data-visibility', 'show');
                if (searchElement.is(fxxl_beratungSearchField)) {
                    currentElement = $('.fxxl-content-search__result');
                    var accu = currentElement;
                    $('body').on('focusout', function () {
                        if (currentElement.is(':hover') === false) {
                            currentElement.addClass('fxxl-hidden');
                        } else {
                            searchElement.focus();
                        }
                    });
                    fxxl_desktopSearchResultsCustom.attr('data-visibility', 'hide');
                } else {
                    var accu = fxxl_desktopSearchResults.find('#fxxl-header-search-custom-results');
                }
                if (typeof accu !== 'undefined') {
                    accu.empty();
                    let maxVisiblePageLinks;
                    if (isLargeViewport() === false) {
                        maxVisiblePageLinks = Math.min(response.custom.length, maxSearchResultLimit.mobile.morePages);
                    } else {
                        maxVisiblePageLinks = Math.min(response.custom.length, maxSearchResultLimit.desktop.morePages);
                    }
                    for (i = 0; i < maxVisiblePageLinks; i += 1) {
                        tmp_cus = response.custom[i].desc.replace(regex, '<span class="fxxl-search__text fxxl-search__text--highlight">$1</span>');
                        accu.append('<a class="fxxl-search__link" href="' + response.custom[i].link + '">' + tmp_cus + '</a>');
                    }
                }
                currentElement.removeClass('fxxl-hidden');
                displayLeft = true;
            } else {
                fxxl_desktopSearchResultsCustom.attr('data-visibility', 'hide');
            }
            /** Ends: More pages */

            if (searchElement.is(fxxl_desktopSearchField)) {
                /**
                 * Starts: get Product card
                 */
                if (response.productpreview.length > 0) {
                    var acpr = fxxl_desktopSearchResultsRight.find('#fxxl-header-search-cards-results'),
                        cardHtml,
                        cardTitle,
                        maxVisibleProducts;
                    acpr.empty();
                    fxxl_desktopSearchResultsRight.attr('data-visibility', 'show');
                    if (isLargeViewport() === false && maxSearchResultLimit.mobile.product) {
                        maxVisibleProducts = (response.productpreview.length > maxSearchResultLimit.mobile.product) ? maxSearchResultLimit.mobile.product : response.productpreview.length;
                    } else {
                        maxVisibleProducts = response.productpreview.length;
                    }

                    for (var i = 0; i < maxVisibleProducts; i += 1) {
                        if (response.productpreview[i].html !== '') {
                            cardHtml = $(response.productpreview[i].html);
                            cardTitle = cardHtml.find('.fxxl-element-artikel__title');
                            cardTitle.html(cardTitle.html().replace(regex, '<span class="fxxl-search__text fxxl-search__text--highlight">$1</span>'));
                            acpr.append(cardHtml);
                        }
                    }
                    displayRight = true;

                    // markiert die Produkte die auf dem Merkzettel stehen
                    if (typeof FxxlWishlist.productsSetChecked === "function") {
                        FxxlWishlist.productsSetChecked();
                    }
                } else {
                    fxxl_desktopSearchResultsRight.attr('data-visibility', 'hide');
                }
                /** Ends: get Product card */
            }

            // display only columns with results
            if (!displayLeft) {
                fxxl_desktopSearchResultsLeft.addClass('fxxl-hidden');
            } else {
                fxxl_desktopSearchResultsLeft.removeClass('fxxl-hidden');
            }
            if (!displayRight) {
                fxxl_desktopSearchResultsRight.addClass('fxxl-hidden');
            } else {
                fxxl_desktopSearchResultsRight.removeClass('fxxl-hidden');
            }

            if (displayLeft || displayRight) {
                fxxlShowMainSearchResult();
            } else {
                fxxlfxxHideMainSearchResult();
            }
            clearSearchTimeOut(searchElement);
        } else {
            fxxlfxxHideMainSearchResult();
            clearSearchTimeOut(searchElement);
            return true;
        }
    }).fail(function (jqXHR, textStatus, error) {
        fxxlfxxHideMainSearchResult();
        clearSearchTimeOut(searchElement);
    });
}

function fxxlShowMainSearchResult() {
    fxxl_desktopSearchResults.removeClass('fxxl-hidden');
    /** Safari Fix */
    if ($('html').hasClass('ua-ios-safari') === true) {
        fxxlSetContentHeight();
        new FxxlResizedEvent(function () {
            fxxlSetContentHeight();
        });
    }
}

function fxxlSetContentHeight() {
    fxxl_desktopSearchResults.find('.fxxl-search__content').height((window.innerHeight - $('#fxxl-header-search-head').height() - 20) + 'px');
}

function fxxlfxxHideMainSearchResult() {
    fxxl_desktopSearchResults.addClass('fxxl-hidden');
}

function fxxShowMainSearch() {
    fxxlHideMainSearchContainer();
    fxxl_desktopSearch.addClass("fxxl-search--show");
    setTimeout(function () {
        fxxl_desktopSearchField.trigger('focus').trigger('select');
        $('body').addClass('fxxl-fix-body');
    }, 500);
    if (fxxl_desktopSearchField.val() !== '') {
        fxxl_last_search_keyword = '';
        SearchQueue();
    }
    return false;
}

function fxxHideMainSearch() {
    fxxlShowMainSearchContainer();
    fxxl_desktopSearch.removeClass("fxxl-search--show");
    fxxlfxxHideMainSearchResult();
    fxxl_desktopSearchField.val('');
    setTimeout(function () {
        $('body').removeClass('fxxl-fix-body');
    }, 500);
}

function fxxlShowMainSearchContainer() {
    if (isLargeViewport() !== true) {
        $('.fxxl-header-search--mobile').removeClass('fxxl-header-search--mobile-hidden');
    } else {
        $('.fxxl-header-search--desktop').removeClass('fxxl-header-search--desktop-hidden');
    }
}

function fxxlHideMainSearchContainer() {
    if (isLargeViewport() !== true) {
        $('.fxxl-header-search--mobile').addClass('fxxl-header-search--mobile-hidden');
    } else {
        $('.fxxl-header-search--desktop').addClass('fxxl-header-search--desktop-hidden');
    }
}

function MainSearchAutocomplete() {

    let searchBeforeValue = '';

    if(fxxl_desktopSearchField.length > 0 ) {
        searchBeforeValue = fxxl_desktopSearchField.val().trim();
    }

    fxxl_desktopSearchField.on('keyup', function (e) {
        const searchAfterValue = $(this).val().trim();

        if(e.key === 'Enter') {
            fxxHideMainSearch();
            return;
        }

        if (searchAfterValue === searchBeforeValue && searchAfterValue.length >= 3) {
            return;
        }

        searchBeforeValue = searchAfterValue;

        if (searchAfterValue.length < 3) {
            fxxlfxxHideMainSearchResult();
            fxxl_last_search_keyword = '';
            return; // eingabe zu kurz
        }

        SearchQueue($(this));
    });

    fxxl_desktopSearch.on('click', function (e) {
        e.stopPropagation();
    });

    fxxl_desktopSearchField.on('keydown', function (e) {
        if (e.key === 'Escape') {
            fxxHideMainSearch();
        }
    });

    $('#fxxl-header-search-more-cards-results-button').on('click', function () {
        $('#fxxl-header-search-form').trigger( 'submit' );
    });

    /**
     * Beratung suchfeld
     */
    fxxl_beratungSearchField.on('keyup', function (e) {
        const searchVal = $(this).val();

        if (searchVal.length < 3) {
            fxxl_last_search_keyword = '';
            return; // eingabe zu kurz
        } else {
            SearchQueue($(this));
        }
    });

    fxxl_beratungSearchField.on('click',function (e) {
        const searchVal = $(this).val();
        if (searchVal.length >= 3) {
            SearchQueue($(this));
            e.stopPropagation();
        }
    }).on('keydown', function (e) {
        if (e.key === 'Escape') {
            //fxxHideMainSearch();
            $(this).val('');
            $('.fxxl-content-search__result').addClass('fxxl-hidden').empty();
        }
    });
}

function clearSearchTimeOut(searchElement) {
    window.clearTimeout(fxxl_searchRequestId);
    fxxl_searchRequestId = undefined;
    SearchQueue(searchElement);
}

function SearchQueue(searchElement) {
    if (typeof fxxl_searchRequestId === 'undefined' && searchElement.val() !== fxxl_last_search_keyword) {
        fxxl_searchRequestId = window.setTimeout(function () {
            getSearchPreview(searchElement);
        }, 0);
    }
    // Exter Search Zendesk Help-Center
    if (typeof fxxl_searchRequestId === 'undefined'
        && fxxlZendeskHelpCenterSearchActive === true
        && fxxl_desktopSearchResultsExtern.length > 0
        && fxxlZendeskHelpCenterSubDomain !== ''
        && searchElement.is(fxxl_desktopSearchField)
        && searchElement.val().length !== 0) {
            // FXXL Help search
            const fxxlZendeskHelpCenterLocale = FxxlCore.getConfig().server?.presence?.variables?.ZENDESK_HELP_CENTER_LOCALE ?? 'de-de';
            getZendeskHelpCenterSearchResult(searchElement.val(), fxxlZendeskHelpCenterSubDomain, fxxlZendeskHelpCenterLocale);
    } else {
        fxxl_desktopSearchResultsExtern.attr('data-visibility', 'hide');
    }

    if (typeof fxxl_searchRequestId === 'undefined' && searchElement.val().length !== 0 && FxxlBlogSearchStatus && searchElement.is(fxxl_desktopSearchField)) {
        // FXXL Blog search
        getFahrradXXLBlogSearchResult(searchElement.val());
    } else {
        fxxl_desktopSearchResultsBlog.attr('data-visibility', 'hide');
    }

    if (searchElement.is(fxxl_beratungSearchField)) {
        fxxHideMainSearch();
    }
}

function getZendeskHelpCenterSearchResult(searchString, subDomain, locale) {
    const objUrl = new URL('https://' + subDomain + '.zendesk.com');
    objUrl.pathname = '/api/v2/help_center/articles/search.json';
    objUrl.searchParams.set('query', searchString);
    objUrl.searchParams.set('locale', locale);

    let externResultWrapper = document.getElementById('fxxl-header-search-extern') || false,
        externResultTarget = document.getElementById('fxxl-header-search-extern-results') || false,
        regex = new RegExp('(' + RegExp.escape(searchString) + ')', 'gmi'),
        maxVisibleResult = isLargeViewport() ? maxSearchResultLimit.desktop.helpAndSupport : maxSearchResultLimit.mobile.helpAndSupport,
        cookieConsentStatus = (etJS_getCookie('fxxl_optional_cookies') === 'true') ? 'all' : 'required';

    fetch(objUrl.href)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                console.warn('Fetching Zendesk Help-Center Query unsuccessful.');
                return {};
            }
        })
        .then((data) => {
            if(etJS_empty(data) === false && externResultTarget) {
                if (data.results.length > 0) {
                    fxxl_desktopSearchResultsExtern.attr('data-visibility', 'show');
                    maxVisibleResult = (data.results.length > maxVisibleResult) ? maxVisibleResult : data.results.length;
                    externResultTarget.replaceChildren();
                    for (let i = 0; i < maxVisibleResult; ++i) {
                        let hcArticle = data.results[i];
                        let hcArticleLink = document.createElement('a');
                        hcArticleLink.setAttribute('href', fxxlGetHelpCenterUrlWithCookieParam(hcArticle.html_url, cookieConsentStatus));
                        hcArticleLink.setAttribute('class', 'fxxl-search__link');
                        hcArticleLink.setAttribute('target', '_blank');
                        hcArticleLink.innerHTML = hcArticle.title.replace(regex, '<span class="fxxl-search__text fxxl-search__text--highlight">$1</span>');

                        if (isLargeViewport() === false) {
                            let hcArticleWrapper = document.createElement('div');
                            hcArticleWrapper.appendChild(hcArticleLink);
                            externResultTarget.appendChild(hcArticleWrapper);
                        } else {
                            externResultTarget.appendChild(hcArticleLink);
                        }
                    }

                    if (externResultWrapper) {
                        externResultWrapper.classList.remove('fxxl-hidden');
                    }
                    fxxl_desktopSearchResultsLeft.removeClass('fxxl-hidden');
                    fxxl_desktopSearchResults.removeClass('fxxl-hidden');
                } else {
                    externResultTarget.replaceChildren();
                    fxxl_desktopSearchResultsExtern.attr('data-visibility', 'hide');
                }
            }
        })
        .catch((error) => console.warn(error));
}

/**
 * Returns the search query result from FXXL Blog
 * and show it in the search preview on shop.
 *
 * @param {string} searchString - search query text.
 *
 */

function getFahrradXXLBlogSearchResult(searchString) {
    let fxxlDomain = 'https://www.fahrrad-xxl.de/',
        blogAlias = FxxlBlogUrlAlias || 'blog',
        url = fxxlDomain + blogAlias + '/wp-json/wp/v2/search?search=' + encodeURIComponent(searchString),
        blogResultWrapper = document.getElementById('fxxl-header-search-blog') || false,
        blogResultTarget = document.getElementById('fxxl-header-search-blog-results') || false,
        maxVisibleResult = isLargeViewport() ? maxSearchResultLimit.desktop.blog : maxSearchResultLimit.mobile.blog,
        regex = new RegExp('(' + RegExp.escape(searchString) + ')', 'gi');

    fetch(url)
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                console.warn('Fetching Blog Search result unsuccessful.');
                return {};
            }
        })
        .then(data => {
            if (data.length > 0) {
                fxxl_desktopSearchResultsBlog.attr('data-visibility', 'show');
                maxVisibleResult = Math.min(maxVisibleResult, data.length);
                blogResultTarget.replaceChildren();
                for (let i = 0; i < maxVisibleResult; ++i) {
                    let blogArticle = data[i];
                    let blogArticleLink = document.createElement('a');
                    blogArticleLink.setAttribute('href', blogArticle.url);
                    blogArticleLink.setAttribute('class', 'fxxl-search__link');
                    blogArticleLink.setAttribute('target', '_blank');
                    blogArticleLink.innerHTML = blogArticle.title.replace(regex, '<span class="fxxl-search__text fxxl-search__text--highlight">$1</span>');

                    if (isLargeViewport() === false) {
                        let blogArticleWrapper = document.createElement('div');
                        blogArticleWrapper.appendChild(blogArticleLink);
                        blogResultTarget.appendChild(blogArticleWrapper);
                    } else {

                        blogResultTarget.appendChild(blogArticleLink);
                    }
                }

                if (blogResultWrapper) {
                    blogResultWrapper.classList.remove('fxxl-hidden');
                }
                fxxl_desktopSearchResultsLeft.removeClass('fxxl-hidden');
                fxxl_desktopSearchResults.removeClass('fxxl-hidden');
            } else {
                blogResultTarget.replaceChildren();
                fxxl_desktopSearchResultsBlog.attr('data-visibility', 'hide');
            }
        })
        .catch(error => console.warn(error));
}

if (typeof fxxlArtikelBranchInfoFull === 'undefined') {
    var fxxlArtikelBranchInfoFull = true;
}

function fxxlSetupArtikleMatrix(containerElement) {
    var matrixListItems = $('.artikel_filial_matrix-list__item'),
        matrixAddressContainer = $('.artikel_filial_matrix-address__container'),
        matrixAddress = $('.artikel_filial_matrix-address');

    if (typeof containerElement === 'undefined') {
        containerElement = document;
    }
    $('.fxxl-artikel-detail__branch-button, .fxxl-element-artikel__branch-button').on('click', function (event) {
        setMatrixVariantSizes(containerElement, true);
    });

    matrixListItems.on('mouseenter', function () {
        var element = $(this),
            branchId = element.data('matrix-branch-id'),
            activeClass = 'artikel_filial_matrix-list__item--active',
            addressActiveClass = 'artikel_filial_matrix-address__container--active',
            addressShowClass = 'artikel_filial_matrix-address--show';

        if (isLargeViewport() === true) {
            matrixAddress.addClass(addressShowClass);
            matrixListItems.removeClass(activeClass);
            matrixAddressContainer.removeClass(addressActiveClass);
            matrixListItems.filter('[data-matrix-branch-id="' + branchId + '"]').addClass(activeClass);
            matrixAddressContainer.filter('[data-matrix-branch-id="' + branchId + '"]').addClass(addressActiveClass);
        }
    });
}

function setMatrixVariantSizes(containerElement, showSizeSelectorActive) {
    var matrixContainer = $('.artikel_filial_matrix'),
        matrixVariantTitle = $('.artikel_filial_matrix-list__variant-title'),
        matrixTitleInf = $('.artikel_filial_matrix-list__item-inf'),
        matrixSelectedSize = $('.artikel_filial_matrix-list__image-title-size'),
        matrixFilterStr = '',
        varianSelect,
        selectedSize,
        selectedValue;

    varianSelect = $(containerElement).find('.artikel_detail__variantselect .pvd-vs__active .pvd-vs__l2-select > option:selected');
    if (varianSelect.length > 0) {
        selectedSize = varianSelect.text();
        selectedValue = varianSelect.val();
    } else {
        selectedSize = '';
        selectedValue = '';
    }
    if (showSizeSelectorActive === true && selectedValue === '' && (fxxlArtikelBranchInfoFull === false || (isLargeViewport() === false && parseInt(_vwType) === 308 && _vwName === 'detail'))) {
        event.preventDefault();
        event.stopPropagation();
        fxxlProductShowSizeSelector();
        if (isLargeViewport() === true) {
            M.toast({
                html: et.data.pvdVariantSelectionL2Missing,
                classes: 'fxxl-toast fxxl-toast--warning'
            });
        }
    } else {
        // fxxlPVDSelectedVariant is global "dev/customer_fahrradxxl/custom/module/public/fxxl3/assets/js/420_artikel.js"
        if (fxxlPVDSelectedVariant !== 0 && isLargeViewport() === false) {
            matrixFilterStr = '[data-product-id="' + fxxlPVDSelectedVariant + '"]';
        } else {
            matrixFilterStr = '[data-size="' + selectedSize + '"]';
        }
        if (fxxlArtikelBranchInfoFull === false || isLargeViewport() === false) {
            matrixContainer.removeClass('artikel_filial_matrix--full');
            matrixVariantTitle.addClass('fxxl-hidden');
            matrixTitleInf.addClass('fxxl-hidden');
            matrixVariantTitle.filter(matrixFilterStr).removeClass('fxxl-hidden');
            matrixTitleInf.filter(matrixFilterStr).removeClass('fxxl-hidden');
            matrixSelectedSize.text(selectedSize);
        } else {
            matrixContainer.addClass('artikel_filial_matrix--full');
            matrixVariantTitle.removeClass('fxxl-hidden');
            matrixTitleInf.removeClass('fxxl-hidden');
        }
    }
}

function fxxlSetMatrixBranchButtonStatus(element) {
    var allValidStatus = $(element).find('[data-matrix-status-mode="1"]').add('[data-matrix-status-mode="2"]'),
        button;
    if (allValidStatus.length === 0) {
        $('.fxxl-artikel-detail__branch-button').each(function () {
            button = $(this);
            button.addClass('disabled').find('.fxxl-button__text').text(button.data('disabled-text'));
        });
    }
}

function fxxlSetupSelectedFilialeMatrix() {
    var matrixContainer = $('.artikel_filial_matrix');
    if (matrixContainer.length > 0 && FxxlPersonalData.branchfilterdata !== null) {
        matrixContainer.find('.artikel_filial_matrix__text--branch').removeClass('fxxl-hidden');
        matrixContainer.find('.artikel_filial_matrix-list__item[data-branch-id="' + FxxlPersonalData.branchfilterdata.branchId + '"]').addClass('artikel_filial_matrix-list__item--selected');
    }
}

function setProbefahrtMatrixInfo(containerElement) {
    var matrixAvailabilityInfo = $('.fxxl-availability_matrix_info-js'),
        matrixModalTitle = $('.modal-matrix-branch-info-title-js');

    $('.fxxl-artikel-probefahrt-button-js').on('click', function () {
        matrixAvailabilityInfo.removeClass('fxxl-hidden');
        matrixModalTitle.text(et.data.matrixOnlineAvailabilityModalTitle);
        setMatrixVariantSizes(containerElement, true);
    });

    $('.fxxl-matrix-branch-button-js').on('click', function () {
        matrixAvailabilityInfo.addClass('fxxl-hidden');
        matrixModalTitle.text(et.data.matrixBranchInfoModalTitle);
    });
}
$(window).on('load', function () {
    WindowIsLoaded = true;
});

if (typeof window.visualViewport !== 'undefined') {
  window.visualViewport.addEventListener("resize", (event) => {
    fxxlVisualViewportScale = event.target.scale;
  });
}

/**
 *  Beforeunload event
 */
window.addEventListener('beforeunload', function (event)
{
    var validElement = true;
    if (event.target.activeElement.href) {
        if (event.target.activeElement.href.indexOf('mailto:') > -1 || event.target.activeElement.href.indexOf('tel:') > -1) {
            validElement = false;
        }
    }
    if (validElement === true) {
        showSpinner();
    }
});

/**
 *  Pageshow event
 */
window.addEventListener('pageshow', function (event)
{
    if (event.persisted === true) {
        hideSpinner();
    }
});


/**
 *  Info:
 *  Dies ist das neue "Fxxl Ready" ( DOMContentLoaded mit extra Prüfungen )
 */
document.addEventListener(FxxlCore.getConfig().eventNames.ready, () => {
    /* Specific Pages
     * ------------------------------------------------------------------------ */
    /* Init: Accordions ( Not on Product Detail Pages ) */
    if (site_type !== 'artikel') {
        document.querySelectorAll('.fxxl-accordion').forEach((element) => {
            new FxxlAccordion(element);
        });
    }


    /* All Pages
     * ------------------------------------------------------------------------ */
    /* Init: Fxxl Newsletter Popup  */
    document.querySelectorAll('.fxxl-newsletter-popup').forEach((element) => {
        FxxlNewsletterPopup.getInstance(element);
    });

});


/**
 *  Info:
 *  Dies ist das alte "Document Ready" von JQuery.
 *  Wenn möglich das neue "Fxxl Ready" verwenden,( Oben drüber )
 */
$(document).ready(function () {
    documentIsReady = true;
    fxxlLoadPersonalData();
    setupJsonHandler();
    setupJsonActionHandler();
    saveAndLoadForm();

    fxxlCurrentUrl = window.location.href;

    /**
     * Desktop Button
     */
    $('.fxxl-button-dynamic').each(function () {
        var __this = $(this),
            text = __this.text(),
            selectedIcon = __this.data('selected-icon'),
            tempSelectedIcon,
            justDesktopIcon = __this.data('icon-just-on-desktop'),
            iconName = __this.data('icon'),
            toggleIconName = __this.data('toggle-icon'),
            icon = $('<svg width="24" height="24" class="fxxl-button__icon fxxl-button__icon--right fxxl-button-dynamic__icon">' +
                '<use href="#' + iconName + '" xlink:href="#' + iconName + '"></use></svg>'),
            toggleIcon = $('<svg width="24" height="24" class="fxxl-button-dynamic__icon fxxl-button-dynamic__icon--toggle ' +
                'fxxl-button__icon fxxl-button__icon--right">' +
                '<use href="#' + toggleIconName + '" xlink:href="#' + toggleIconName + '"></use></svg>');

        if (isLargeViewport() === true) {
            __this.html('');
            if (iconName !== undefined) {
                __this.prepend(icon);
            }
            if (toggleIconName !== undefined) {
                __this.prepend(toggleIcon);
            }
            __this.append('<span class="fxxl-button__text">' + text + '</span>');
            __this.addClass('fxxl-button');
        } else {
            if (justDesktopIcon === false) {
                __this.append(icon.removeClass('fxxl-button__icon fxxl-button__icon--right'));

                if (toggleIconName !== undefined) {
                    __this.append(toggleIcon.removeClass('fxxl-button__icon fxxl-button__icon--right'));
                }
            }
        }

        __this.on('click', function () {
            if (toggleIconName !== undefined) {
                if (__this.hasClass('fxxl-button-dynamic--toggle') === true) {
                    __this.removeClass('fxxl-button-dynamic--toggle');
                } else {
                    __this.addClass('fxxl-button-dynamic--toggle');
                }
            }
        });

        new FxxlElementObserver(__this[0], function () {
            tempSelectedIcon = __this.attr('data-selected-icon');
            if (tempSelectedIcon !== selectedIcon) {
                selectedIcon = tempSelectedIcon;
                if (selectedIcon === toggleIconName) {
                    __this.addClass('fxxl-button-dynamic--toggle');
                } else {
                    __this.removeClass('fxxl-button-dynamic--toggle');
                }
            }
        });

    });

    /**
     * Multiline Truncation
     */
    setTimeout(function () {
        $('[data-multiline-truncation]').each(function () {
            new FxxlMultilineTruncation($(this));
        });
    }, 1000);

    /**
     * Readmore
     */
    $('.fxxl-read-more').not('html[data-vwtype="artikel"] .fxxl-read-more').each(function () {
        new FxxlReadMore($(this));
    });

    /**
     * Text input & TextArea
     */
    $('.fxxl-text-input__text, .fxxl-textarea__text')
        .not('html[data-vwtype="warenkorb"] .fxxl-text-input__text')
        .not('html[data-vwtype="warenkorb"] .fxxl-textarea__text')
        .not('[type="radio"],select')
        .each(function () {
        new FxxlTextInputs($(this));
    });

    /**
     * Select form
     */
    $('.fxxl-select').each(function () {
        new FxxlSelectForm($(this));
    });

    /**
     * Countdown
     */
    $('.fxxl-countdown').each(function () {
        fxxlCustomHtmlElements.countdown.set($(this));
    });

    /**
     * Create collapsible foot menu
     */
    new FxxlElementVersionControl('#fxxl-footer-menu-container', largViewportSize, function () {
        if (isLargeViewport() !== true) {
            fxxlCreateCollapsibleFootMenu();
        }
    });

    /**
     * Init Materializecss-Js
     */
    const listOfTabs = document.querySelectorAll('.tabs:not(.tabs-not-init-automatic)');
    listOfTabs.forEach((element) => {
        M.Tabs.init(element, {
            onShow: function () {
                if (this.el.classList.contains('fxxl-auto-scroll-to-selected-tab')) {
                    new FxxlAutoScrollToSelectedTab($(this.el))
                }
            }
        });
    });

    $('.modal').modal({
        onOpenStart: function () {
            try {
                let excludeModalsWithClasses = ['fxxl-modal--pvd-vs', 'fxxl-cookie-mainmodal'];
                if (excludeModalsWithClasses.some(e => this.el.classList.contains(e)) === false) {
                    fxxlFixModalZindex(true);
                }
            } catch (e) {
                console.warn(e, 'FXXL JS ERROR: Modal > el ist nicht definiert | 410_base.js');
                fxxlFixModalZindex(true);
            }
        },

        onCloseStart: function () {
            fxxlFixModalZindex(false);
        },
        onOpenEnd: function () {
            /**
             * Bugfix Tooltips on Scrolling
             */
            $('.modal').scroll(function () {
                $('.tooltipped').tooltip('close');
            });
        }
    });

    $('.scrollspy').scrollSpy();

    /**
     * Datapicker
     * @type {string}
     */
    var datepicker_format = 'mmm dd, yyyy',
        datepicker_element_format,
        datePickerMonths = [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember'
        ],
        datePickerMonthsShort = [
            'Jan',
            'Feb',
            'Mär',
            'Apr',
            'Mai',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dez'
        ],
        datePickerWeekdays = [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag'
        ],
        datePickerWeekdaysShort = [
            'Son',
            'Mon',
            'Die',
            'Mit',
            'Don',
            'Fre',
            'Sam'
        ],
        datePickerWeekdaysAbbrev = ['So','Mo','Di','Mi','Do','Fr','Sa'];

    $('.datepicker').each(function () {
        datepicker_element_format = this.getAttribute('data-format');
        if (datepicker_element_format !== null) {
            datepicker_format = datepicker_element_format;
        }
        M.Datepicker.init(this, {
            container: document.body,
            format: datepicker_format,
            defaultDate: new Date(new Date().getFullYear() - 18, 1, 1),
            yearRange: 80,
            autoClose: true,
            i18n: {
                months: datePickerMonths,
                monthsShort: datePickerMonthsShort,
                weekdays: datePickerWeekdays,
                weekdaysShort: datePickerWeekdaysShort,
                weekdaysAbbrev: datePickerWeekdaysAbbrev
            },
        });
    });

    /**
     * Close tooltip on screen swipe.
     */
    var toolTip = $('.tooltipped'),
        toolTipOverlay = $('<div href="#" class="fxxl-tooltip__overlay"></div>'),
        toolTipShowClass = 'fxxl-tooltip__overlay--show',
        toolTipHideClass = 'fxxl-tooltip__overlay--hide',
        toolTipMaterial = 'fxxl-tooltip__material';

    toolTip.tooltip();

    if (isLargeViewport() === false) {
        toolTip.on('touchstart', function () {
            var toolTipInstance = M.Tooltip.getInstance($(this));

            $('body').append(toolTipOverlay);
            toolTipOverlay.removeClass(toolTipHideClass);
            toolTipOverlay.addClass(toolTipShowClass);

            $(toolTipInstance.tooltipEl).addClass(toolTipMaterial);
            toolTipInstance.open();
        });

        toolTipOverlay.on('touchstart', function () {
            $(this).removeClass(toolTipShowClass);
            $(this).addClass(toolTipHideClass);
            toolTip.tooltip('close');
        });
    }

    /**
     * Main Menu
     */
    new FxxlElementVersionControl('.fxxl-menu--main', headerSizeBreakpoint, function () {
        $('.fxxl-menu--main').each(function () {
            if (isOverHeaderSizeBreakpoint() === true) {
                setDesktopMainFlyout($(this));
            } else {
                setMobileMainFlyout($(this));
            }
        });
    });

    /**
     * Sticky Header
     */
    new FxxlStickyMainHeader((isStickyActive) => {
        if (isStickyActive === true) {
            /**
             * Sticky tabs
             */
            setTimeout(() => {
                FxxlStickyTabs.setTopPosition();
            }, 1000);
        }
    });

    /**
     * Auto submit
     */
    $('.fxxl-autosubmit').each(function () {
        var __this = $(this);
        __this.on('change', function () {
            __this.closest('form').submit();
        });
    });

    /**
     *  Main Search Initalisierung
     */
    MainSearchAutocomplete();

    /**
     * für die Darstellung der Trustedshop Bewertung im Footer
     */
    showTrustBadgeSentence();

    /**
     * JS für den Scroll to Top Button
     */
    fxxlScrollToTop();

    /**
     * Setup Product-Whish-List
     */
    const wishlistContainer = document.querySelector('.fxxl-merkliste');
    if (wishlistContainer) {
        window.fxxlWishlist = new FxxlWishlist(wishlistContainer);
    }

    /**
     * Branch-Map
     */
    if (typeof googleMapElements !== 'undefined') {
        if ($(googleMapElements.container).length > 0) {
            setupMap();
        }
    }

    /**
     * Smooth Scroll
     */
    $('.smooth-scroll').each(function () {
        new FxxlSmoothScroll($(this));
    });

    /**
     * Fxxl-Form-Validation
     */
    $('input[type="radio"][data-validation], input[type="checkbox"][data-validation], select[data-validation]').each(function () {
        new FxxlFormValidation($(this));
    });

    /**
     * Element-Product-Vaiant-Select
     */
    $('.fxxl-element-artikel--variant-select').each(function () {
        new FxxlElementProductVariantSelect(this);
    });

    /**
     * Auto scroll to selected tab
     */
    $('.fxxl-auto-scroll-to-selected-tab').each(function () {
        new FxxlAutoScrollToSelectedTab($(this));
    });

    /**
     * Setup Content-Elements
     */
    fxxlSetupContentElements();

    /**
     * Setup Voting
     */
    $('.fxxl-voting').each(function () {
        new FxxlVotingBox($(this));
    });
    /**
     * Setup Multiple-Voting
     */
    $('.fxxl-voting-multiple').each(function () {
        new FxxlMultipleVotingBox($(this));
    });
    /**
     * Fxxl-Marketingspot
     */
    fxxlGetMarketingSpots();

    /**
     * DynamicForm
     */
    if ($('.fxxl-container--formular').length > 0) {
        fxxlSetupDynamicForm();
    }

    /**
     * Contactbot
     */
    $('.fxxl-contactbot').each(function () {
        new FxxlContactBot(this);
    });

    /**
     * Dataupload Form
     */
    $('.fxxl-file-upload').each(function () {
        new FXXLFormDataUpload(this);
    });

    /**
     * Create MultiSelect From Selection Field
     */
    $('.fxxl-create-select-from-selection-field').each(function () {
        new FxxlCreateSelectFromSelectionField(
            this.getAttribute('data-key'),
            this,
            this.getAttribute('data-name'),
            this.getAttribute('data-class'),
            parseInt(this.getAttribute('data-multiple')),
            this.getAttribute('data-placeholder')
        );
    });

    /**
     * reCaptcha
     */
    if (typeof (reCaptchaPublicKey) !== 'undefined' && typeof (grecaptcha) !== 'undefined') {
        grecaptcha.ready(function () {
            $('.js-fxxl-recaptcha-token').each(function () {
                new FxxlReCaptchaGetToken(this);
            });
        });
    }

    /**
     * Rahmenhöhenechner
     */
    $('.frame-size-calculator').each(function () {
        new FxxlFrameSizeCalculator($(this));
    });

    /**
     * SVG Convert
     */
    $('.fxxl-svgimg-to-svgxml').each(function () {
        new FxxlConvertSVGImgToSVGXml(this);
    });

    /**
     * Set Matrix Button Status
     */
    $('.artikel_filial_matrix').each(function () {
        fxxlSetMatrixBranchButtonStatus(this);
    });

    /**
     * Setup Narrower check-icon color
     */
    $('.fxxl-narrower-color__icon--check, .fxxl-element-artikel__variant-colors-mobile-icon--check').each(function () {
        fxxlSetInvertColor(this, "color", "fill");
    });

    /**
     * Setup Additional-Attributes
     */
    $('.fxxl-element-artikel-additional-attributes').each(function () {
        new FxxlAdditionalAttributes(this);
    });

    /**
     * Setup Branch-Inventory
     */
    $('.fxxl-modal--matrix').each(function () {
        new FxxlSetupArtikleBranchInventory(this);
    });

    /**
     * Support Widget
     */
    $('.fxxl-support-widget-window').each(function () {
        new FxxlTouchScroller(this);
    });

    $('.fxxl-cookie-aktivieren, .fxxl-cookie-banner-open').on('click', function () {
        $('.fxxl-cookie-mainmodal').modal('open');
        return false;
    });

    /**
     * Setup Collapsible and Expandable elements
     * */

    $('.collapsible').each(function () {
        M.Collapsible.init(this, {});
    });

    $('.collapsible.expandable').each(function () {
        M.Collapsible.init(this, {
            accordion: false
        });
    });

    /**
     * News and Events pages
     */
    fxxlSetupClickEventsForTerminKacheln();

    /**
     *  Fxxl Slider Modal Events neu initiieren
     */
    $('.fxxl-tabs').on('click', function () {
        if ($('.fxxl-content-page__tab.active').find('div.fxxl-slider-modal').length > 0) {
            $('.fxxl-base-card__image-link--modal').each(function () {
                fxxlSetupSliderModal($(this));
            });
        }
    });

    /**
     * Fxxl anchore tabs
     */
    $('.fxxl-tabs--anchor').each(function () {
        new FxxlAnchorTabs(this);
    });

    /**
     * Fxxl Form submit by Js
     */
    $('.fxxl-merkliste__list .fxxl-element-artikel-cart-button__list-item > form').each(function () {
        new FxxlFormSubmitByJs(this, () => {
            // Update prsonal json
            fxxlLoadPersonalData()
        }, {
            useToast: true
        });
    });

    /**
     * Lazyload Module
     */
    fxxlLazyloadModule();
});
(function () {
    var ec = $('#element_cookie_banner');
    const cookieExpireDays = 365;
    if (ec && localStorage && consentBannerVisible === false) {
        var lsv = localStorage.getItem('element_cookie_banner');
        if (!lsv) {
            ec.addClass('element_cookie_banner--visible');
            var ecbs = $('.element_cookie_banner__button_x');
            for (var i = 0, len = ecbs.length; i < len; i++) {
                var ecb = ecbs[i];
                if (ecb) {
                    ecb.addEventListener('click', function () {
                        localStorage.setItem('element_cookie_banner', Date.now());
                        ec.removeClass('element_cookie_banner--visible');
                    });
                }
            }
        }
    }

    var cookieAgreed = etJS_getCookie('fxxl_erforderliche_cookies');

    if (typeof fxxlConsentCookies === 'undefined') {
        fxxlConsentCookies = [];
    }

    var mainCookieModal = $('.fxxl-cookie-mainmodal'),
        cookieAcceptAll = $('.fxxl-cookie-mainmodal__button--acceptall'),
        cookieAcceptSelected = $('.element_cookie_banner__button-acceptselected'),
        cookieAllSelected = $('.element_cookie_banner__button-selectall'),
        modalCookieSettingButton = $('.fxxl-cookie-mainmodal__setting'),
        cookieModal = $('.fxxl-cookie-modal'),
        cookieAccordion = $('.fxxl-cookie-modal-accordion'),
        cookieSwitchInputs = $('.fxxl-cookie-switch-input'),
        pageContentLink = $('.fxxl-pagecontent-link'),
        pageContentDescription,
        pageContentTitle,
        pageContentUrl,
        pageContentTarget,
        pageContentModal = $('.fxxl-modal-pagesubelement'),
        pageContentModalHeaderText = $('.fxxl-modal-pagesubelement__header-text'),
        pageContent = $('.fxxl-modal-pagesubelement__content'),
        modalOptions,
        mainModalDelay,
        offsetTopValue,
        firstTimeDelay = 500,
        storageKey = 'fxxlFirstVisitConsentBanner',
        standbyOverlay = $('<div data-cy="cookie_banner_overlay" style="position: fixed;left:0;top:0;width: 100%;height: 100%;z-index: 10000;"></div>');

    if (consentBannerDelay !== undefined && consentBannerDelay !== null) {
        mainModalDelay = parseInt(consentBannerDelay);
    } else {
        mainModalDelay = 1000;
    }

    modalOptions = {dismissible: false};

    function openMainModal(delay) {
        modalOptions.preventScrolling = false;
        mainCookieModal.modal(modalOptions);
        setTimeout(function () {
            mainCookieModal.modal('open');
        }, delay);
    }

    function fxxlIsRedirectedFromOtherLanguage() {
        const redirectFromOtherLanguage = getParameterByName('redirected_from_other_language');

        if (redirectFromOtherLanguage !== false) {
            cookieAgreed = true;
            etJS_setCookie('fxxl_erforderliche_cookies', 'true', cookieExpireDays);
            if (parseInt(redirectFromOtherLanguage) === 1) {
                etJS_setCookie('fxxl_optional_cookies', 'true', cookieExpireDays);
                fxxlAddCookieParameterToHelpCenterUrls('all');
            } else {
                fxxlAddCookieParameterToHelpCenterUrls('required');
            }

            // Remove redirected_from_other_language from URL
            const currentURL = new URL(window.location.href);
            currentURL.searchParams.delete('redirected_from_other_language');
            window.history.replaceState({}, document.title, currentURL.toString());

            // Set Storage: Selected Shop Suggestion Language
            FxxlShopSuggestion.setStorageSelectedSuggestedCountry();
        }
    }

    $(document).ready(function () {
        if (consentBannerVisible === true) {

            // check if redirected from other language
            fxxlIsRedirectedFromOtherLanguage();

            if (cookieAgreed === '') {
                setupStandbyOverlay();
            } else {
                if (etJS_getCookie('fxxl_optional_cookies') === 'true') {
                    fxxlAddCookieParameterToHelpCenterUrls('all');
                } else {
                    fxxlAddCookieParameterToHelpCenterUrls('required');
                }

                // For User that already set their Cookies
                if (!FxxlShopSuggestion.isSetStorageSelectedSuggestedCountry()) {
                    FxxlShopSuggestion.setStorageSelectedSuggestedCountry();
                }
            }
        }
    });

    cookieAcceptAll.on('click', function () {
        cookieSwitchInputs.each(function () {
            $(this).prop('checked', true);
        });
        setConsentCookie();
    });

    function setupStandbyOverlay() {
        var eventType = 'mouseover';
        if (localStorage.getItem(storageKey) !== '1') {
            $('body').append(standbyOverlay);
            if ('ontouchstart' in document.documentElement) {
                eventType = 'touchstart';
            }
            standbyOverlay.on(eventType, function () {
                standbyOverlay.unbind();
                openMainModal(firstTimeDelay);
                setTimeout(function () {
                    standbyOverlay.remove();
                }, firstTimeDelay);
                localStorage.setItem(storageKey, '1');
            });
        } else {
            openMainModal(mainModalDelay);
        }
    }

    function getCookieSwitchStatus() {
        var acceptedCookies = [];

        cookieSwitchInputs.each(function () {
            if ($(this).is(':checked')) {
                acceptedCookies.push($(this).prop('name'));
            }
        });

        return acceptedCookies;
    }

    function setConsentCookie() {
        var cookieValueToSet,
            cookieValueToDelete,
            acceptedCookies,
            cookieConsent = 'required';

        acceptedCookies = getCookieSwitchStatus();

        if (Object.keys(fxxlConsentCookies).length > 0) {
            $.each(fxxlConsentCookies, function (cookieName, cookieInfo) {
                if (acceptedCookies.indexOf(cookieInfo.group) > -1) {
                    // set cookie
                    cookieValueToSet = true;
                    etJS_setCookie(cookieName, cookieValueToSet, cookieExpireDays);
                } else {
                    // delete cookie
                    cookieValueToDelete = false;
                    etJS_deleteCookie(cookieName, cookieValueToDelete);
                }
            });
        }
        // on accept add ABTasty and load GTM
        if (etJS_getCookie('fxxl_optional_cookies') === 'true') {
            cookieConsent = 'all';
            if (fxxl_support_widget !== null) {
                fxxl_support_widget.showHideCookieBox(false);
            }

            if (typeof window.fxxlMainGuuruChatWidget !== 'undefined') {
                window.fxxlMainGuuruChatWidget.init();
            }

            if (fxxlZendeskMessenger !== undefined) {
                fxxlZendeskMessenger.init();
            }

            if (typeof addZendeskChatLibrary !== 'undefined') {
                addZendeskChatLibrary();
            }

            if (typeof addABTastyToHeader !== 'undefined') {
                addABTastyToHeader();
            }

            if (typeof addCriteoToHeader !== 'undefined') {
                addCriteoToHeader();
            }

            if (typeof fxxlGtmDataLayerInit !== 'undefined') {
                fxxlGtmDataLayerInit();
            }

            if (typeof fxxlGtmInit !== 'undefined') {
                fxxlGtmInit();
            }
        }

        //on accept load Personal Data
        if (etJS_getCookie('fxxl_erforderliche_cookies') === 'true') {
            fxxlLoadPersonalData();
        }

        fxxlAddCookieParameterToHelpCenterUrls(cookieConsent);

        mainCookieModal.modal('close');

        // shop suggestion
        let device = 'mobile';
        if (isLargeViewport()) {
            device = 'desktop';
        }
        new FxxlShopSuggestion(device);
    }

    modalCookieSettingButton.on('click', function () {
        if (isLargeViewport() === false) {
            modalOptions.preventScrolling = true;
        }
        cookieModal.modal(modalOptions);
        cookieModal.modal('open');
        cookieAccordion.each(function () {
            // extra line added to fxxl_accordion and setContentSize because of max-height = 0
            this.fxxlAccordion.setContentSize();
        });
    });

    cookieAcceptSelected.on('click', function () {
        setConsentCookie();
    });

    cookieAllSelected.on('click', function () {
        cookieSwitchInputs.each(function () {
            if ($(this).is(':not(:disabled)')) {
                $(this).prop('checked', true);
            }
        });
        setConsentCookie();
    });

    pageContentLink.on('click', function () {
        pageContentDescription = $(this).data('desc');
        pageContentTitle = $(this).data('title');
        pageContentTarget = $(this).data('target');
        pageContentUrl = '/json.php?service=getPageSubElementData&page_name=' + pageContentDescription;
        pageContentModalHeaderText.html('');
        pageContent.html('');

        if (isLargeViewport()) {
            offsetTopValue = 120;
        } else {
            offsetTopValue = 50;
        }

        fxxlGetAJAXContent(pageContentUrl, function (response) {
            if (pageContentTitle !== null) {
                pageContentModalHeaderText.html(pageContentTitle);
            }
            if (response !== '') {
                pageContent.html(response.content);
                if (isLargeViewport() === false) {
                    modalOptions.preventScrolling = true;
                }
                pageContentModal.modal(modalOptions);
                pageContentModal.modal('open');
                if (pageContentTarget !== undefined) {
                    pageContentModal.show().scrollTop(0);
                    setTimeout(function () {
                        pageContentModal.animate(
                            {
                                scrollTop: $('#' + pageContentTarget).offset().top - (offsetTopValue)
                            },
                            250,
                            'easeOutCirc'
                        );
                    }, 200);
                } else {
                    pageContentModal.show().scrollTop(0);
                }
            }
        });

    });
})();
/**
 * * ElementProduct - Variant Selector
 *
 * Filename: 410_element_artikel_variant_selection.js
 *
 * @category  Applicas
 * @package   Slider
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 *            Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2019 Fahrrad XXL
 */

const FxxlElementProductVariantSelect = (function FxxlElementProductVariantSelect()
{
    function FxxlElementProductVariantSelect(element)
    {
        this.element = element;
        this.selectElement = null;
        this.selectedIndex = null;
        this.linkElement = null;
        this.articleBaseUrl = null;
        this.buttonItems = null;
        this.priceItems = null;
        this.priceFromItems = null;
        this.articleNumberItems = null;
        this.imageItems = null;
        this.compareItem = null;
        this.initSelectValue = false;
        this.preselectedColorVariantId = null;
        this.productOsz = null;
        this.productSoldOut = false;
        this.productLowestPriceVariantId = null;
        this.linkElementSelector = '.fxxl-element-artikel__link';
        this.buttonItemSelector = '.fxxl-element-artikel-cart-button__list-item';
        this.priceItemsSelector = '.fxxl-element-artikel__price-content';
        this.priceFromItemsSelector = '.fxxl-element-artikel__price-from';
        this.articleNumberItemsSelector = '.fxxl-element-artikel-productnumber__list-item';
        this.imageItemsSelector = '.fxxl-element-artikel__image--variant-select';
        this.selectSelector = '.fxxl-element-artikel__variant-select select';
        this.compareInputSelector = '.js-fxxl-compare-checkbox';
        this.init();
    }

    FxxlElementProductVariantSelect.prototype.init = function init()
    {
        this.selectElement = this.element.querySelector(this.selectSelector);
        if (this.selectElement === null) return;

        this.linkElement = this.element.querySelector(this.linkElementSelector);
        this.buttonItems = this.element.querySelectorAll(this.buttonItemSelector);
        this.priceItems = this.element.querySelectorAll(this.priceItemsSelector);
        this.priceFromItems = this.element.querySelectorAll(this.priceFromItemsSelector);
        this.articleNumberItems = this.element.querySelectorAll(this.articleNumberItemsSelector);
        this.imageItems = this.element.querySelectorAll(this.imageItemsSelector);
        this.compareItem = this.element.querySelector(this.compareInputSelector);
        this.selectedIndex = this.selectElement.selectedIndex;
        this.articleBaseUrl = this.linkElement.href;
        this.productOsz = (this.selectElement.dataset.productOsz === 'true');
        this.productLowestPriceVariantId = this.selectElement.dataset.productLowestPriceVariantId;
        this.productSoldOut = this.selectElement.disabled;

        this.preselectedColorVariantId = this.onInitGetPreselectColorVariantId();
        this.initSelectValue = this.onInitGetSelectValue();

        if (this.initSelectValue !== '') {
            if (this.preselectedColorVariantId !== null && !this.hasVariantBeenSelected()) {
                this.showImage(this.preselectedColorVariantId);
            } else {
                this.showImage(this.initSelectValue);
            }
            this.updateLink(this.initSelectValue);
            this.showItemOrLowestPrice(this.initSelectValue);
            this.showArticleNumber(this.initSelectValue);
            this.updateCompareCheckbox(this.initSelectValue);
            this.showAddButton(this.initSelectValue);
            this.events();
        } else {
            // Handle Products without a selected variant
            this.showArticleNumber(this.element.dataset.productId);
            this.updateLink(this.element.dataset.productId);
        }
    };

    FxxlElementProductVariantSelect.prototype.events = function events()
    {
        const __this = this;
        this.selectElement.addEventListener('change', function () {
            __this.showImage(this.value);
            __this.updateLink(this.value);
            __this.showPrice(this.value);
            __this.updateOptions(this.selectedIndex);
            __this.showArticleNumber(this.value);
            __this.updateCompareCheckbox(this.value);
            __this.showAddButton(this.value);
        }, false);
    };

    FxxlElementProductVariantSelect.prototype.onInitGetSelectValue = function onInitGetSelectValue()
    {
        let selectValue = this.selectElement.value;

        if (this.selectElement.options.length > 1) {
            if (!this.hasVariantBeenSelected()) {
                if (this.productOsz) {
                    selectValue = this.preselectedColorVariantId;
                    this.selectElement.value = this.preselectedColorVariantId;
                } else {
                    if (this.selectElement.options.length > 1) {
                        selectValue = this.selectElement.options[1].value;
                    }
                }
            }

            if (selectValue === '' || selectValue === null) {
                selectValue = this.selectElement.options[1].value;
            }
        }

        return selectValue;
    }

    FxxlElementProductVariantSelect.prototype.onInitGetPreselectColorVariantId = function onInitGetPreselectColorVariantId()
    {
        const preselectedColor = this.selectElement.dataset.preselectedColor;
        let selectValue = null;

        if (preselectedColor) {
            const selectedColorOption = Array.from(this.selectElement).find(item => {
                return item.dataset.color === preselectedColor
            });
            selectValue = (selectedColorOption) ? selectedColorOption.value : null;
        }

        return selectValue;
    }

    FxxlElementProductVariantSelect.prototype.showElementItem = function showElementItem(elementItems, elementClass, displayStyle, id)
    {
        let i;
        const lastIndex = elementItems.length - 1;
        const selectedElement = this.element.querySelector(elementClass + '[data-variant="' + id + '"]');

        for (i = 0; i <= lastIndex; i += 1) {
            elementItems[i].style.display = 'none';
        }

        if (selectedElement !== null) {
            selectedElement.style.display = displayStyle;
        }
    }

    FxxlElementProductVariantSelect.prototype.showAddButton = function showAddButton(id)
    {
        this.showElementItem(this.buttonItems, this.buttonItemSelector, 'block',  id);
    };

    FxxlElementProductVariantSelect.prototype.showPrice = function showPrice(id)
    {
        this.setVisibilityOfPriceFrom(id);
        this.showElementItem(this.priceItems, this.priceItemsSelector, 'flex',  id);
    };

    FxxlElementProductVariantSelect.prototype.showArticleNumber = function showArticleNumber(id)
    {
        let displayId = id;

        if (!this.hasVariantBeenSelected()) {
            const productId = id.split('-')[0];
            displayId = `${productId}-${productId}`;
        }

        this.showElementItem(this.articleNumberItems, this.articleNumberItemsSelector, 'block',  displayId);
    }

    FxxlElementProductVariantSelect.prototype.showImage = function showImage(id)
    {
        this.showElementItem(this.imageItems, this.imageItemsSelector, 'block',  id);
    }

    FxxlElementProductVariantSelect.prototype.updateCompareCheckbox = function updateCompareCheckbox(id)
    {
        if (this.hasVariantBeenSelected()) {
            this.compareItem.dataset.variantId = id.split('-')[1];
        } else {
            this.compareItem.dataset.variantId = this.compareItem.dataset.productId;

            const preselectedColor = this.selectElement.dataset.preselectedColor;
            if (preselectedColor !== null) {
                this.compareItem.dataset.preselectedColor = preselectedColor;
            }
        }
    }

    FxxlElementProductVariantSelect.prototype.updateOptions = function updateOptions(index)
    {
        this.selectElement.options[this.selectedIndex].removeAttribute('selected');
        this.selectElement.options[index].setAttribute('selected', '');
        this.selectedIndex = index;
    }

    FxxlElementProductVariantSelect.prototype.updateLink = function updateLink(id)
    {
        if (this.hasVariantBeenSelected()) {
            const variantId = id.split('-')[1];
            this.linkElement.href = `${this.articleBaseUrl}?varid=${variantId}`;
        } else if (this.initSelectValue !== '') {
            const id = (this.preselectedColorVariantId) ? this.preselectedColorVariantId : this.initSelectValue;

            Array.from(this.selectElement.options).forEach(option => {
                if (option.value === id) {
                    this.linkElement.href = `${this.articleBaseUrl}#selected_color_${option.dataset.color}`;
                }
            });
        }
    }

    FxxlElementProductVariantSelect.prototype.hasVariantBeenSelected = function hasVariantBeenSelected()
    {
        return this.selectElement.value !== '' && this.selectElement.value !== null;
    }

    /**
     * Setzt die Sichtbarkeit des "ab "-Textes am Preis.
     *
     * Anmerkung: Der "ab "-Text wird im Template nur dann eingefügt, wenn das Produkt
     * auch verschiedene Preise hat. Hier müssen wir also nur prüfen, ob (mittlerweile)
     * eine Variantenauswahl getroffen wurde.
     */
    FxxlElementProductVariantSelect.prototype.setVisibilityOfPriceFrom = function setVisibilityOfPriceFrom()
    {
        if (this.hasVariantBeenSelected()) {
            this.priceFromItems?.forEach(fromElement => fromElement.classList.add('fxxl-hidden'));
        } else {
            this.priceFromItems?.forEach(fromElement => fromElement.classList.remove('fxxl-hidden'));
        }
    }

    FxxlElementProductVariantSelect.prototype.showItemOrLowestPrice = function showItemOrLowestPrice(id)
    {
        if (this.hasVariantBeenSelected()) {
            this.showPrice(id);
        } else {
            const newId = this.productLowestPriceVariantId || id;
            this.showPrice(newId);
        }
    }

    return FxxlElementProductVariantSelect;
}());

/**
 * * ElementProduct
 *
 * Filename: 410_element_artikel.js
 *
 * @category  Applicas
 * @package   Slider
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 *            Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2019 Fahrrad XXL
 */


class FxxlElementProduct {

    constructor() {}


    /*
     * Static / Public Methods
     * ------------------------------------------------------------------------
     */

    /**
     * @param {Object} element ( Classname: fxxl-element-artikel )
     * @param {String} color ( Example: Peppermint )
     */
    static updateWishlistPreselectedColor(element, color = '') {
        const isElementProduct = element?.classList.contains('fxxl-element-artikel');

        if (!isElementProduct) {
            console.warn('Warn: FxxlElementProduct.updateWishlistPreselectedColor');
            return;
        }

        const wishlistButton = element.querySelector('.js-fxxl-artikel__wishlist');
        if (wishlistButton) {
            wishlistButton.dataset.preselectedColor = color;
        }
    }

    /**
     * @param {Object} element ( Classname: fxxl-button )
     */
    static addToWarenkorb(element) {
        const productId = element?.dataset?.productId;

        if (productId === undefined) {
            console.warn('Warn: FxxlElementProduct.addToWarenkorb');
            return;
        }

        const select = document.querySelector(`#variant-select-${productId}`);

        if (!select) {
            console.warn('Warn: FxxlElementProduct.addToWarenkorb - Missing Element');
            return;
        }

        if (select.value !== '') {
            showSpinner();
            element.parentNode.submit();
        } else {
            FxxlElementProduct.showSizeSelector(select);
            // event is implicitly passed if this function is invoked via a HTML onclick-attributegit
            event?.stopPropagation();
            if (isLargeViewport() === true) {
                M.toast({
                    html: et.data.fxxlElementArtikelVarianteNotSelectedMsg,
                    classes: 'fxxl-toast fxxl-toast--warning'
                });
            }
        }
    }

    /**
     * @param {Object} element ( Classnames: fxxl-button fxxl-element-artikel__branch-button )
     */
    static showBranchMatrix(element) {
        const event = window.event;
        const select = document.querySelector(`#variant-select-${element?.dataset?.productId}`);

        if (!select) {
            console.warn('Warn: FxxlElementProduct.showBranchMatrix - Missing Element');
            return;
        }

        if (select.value === '') {
            event.stopPropagation();

            FxxlElementProduct.showSizeSelector(select);
            if (isLargeViewport() === true) {
                M.toast({
                    html: et.data.fxxlElementArtikelVarianteNotSelectedMsg,
                    classes: 'fxxl-toast fxxl-toast--warning'
                });
            }
        }
    }

    /**
     * @param {Object} element ( Idname: variant-select-${productId}, Tag: select )
     */
    static showSizeSelector(element) {
        const selectContainer = element.parentNode.closest('.fxxl-select');

        if (selectContainer === null) {
            console.warn('Warn: FxxlElementProduct.showSizeSelector - Missing Element');
            return;
        }

        if (isLargeViewport() === true) {
            const mousedownEvent = new Event('mousedown');
            selectContainer.dispatchEvent(mousedownEvent);
        } else {
            const touchEvent = new Event('touchend');
            selectContainer.dispatchEvent(touchEvent);
        }
    }
}

document.addEventListener(FxxlCore.getConfig().eventNames.ready, () => {

    // TODO: VanillaJs Umsetzung durch Event Delegation
    $(document).on('click', '.gtm__artikel--click', function () {
        const gtmList = google_tag_manager["GTM-5RB34F"]?.dataLayer.get('ecommerce.click.actionField.list');
        const clickedElementData = {
            data: {
                artikelnr:  this?.dataset?.artikelnr,
                list_name: gtmList
            }
        };

        if (gtmList) {
            localStorage.setItem('clicked_artikel_data', JSON.stringify(clickedElementData));
        }
    });
});
function setDesktopMainFlyout(menu) {
    var bar = $('<div class="fxxl-menu__bar"></div>'),
        menuItem,
        menuItemPosition,
        keyframeId,
        keyframe = null,
        lastKeyframes,
        currentX,
        transitionOrigin,
        lastX = null;

    menu.append(bar);

    menu.find('.fxxl-menu__item--main').each(function () {
        var thisMainItem = $(this);
        if (thisMainItem.find('.fxxl-menu__link--sub-3').length === 0) {
            thisMainItem.find('.fxxl-menu__item--sub-2').addClass('fxxl-menu__item--without-any-item');
        }
    });

    /**
     * create read more link
     */
    menu.find('.fxxl-menu__item--sub-2').each(function () {
        var sub2 = $(this),
            moreLink = '';
        if (sub2.find('li').length > 1) {
            moreLink = sub2.find('li').first().find('a').attr('href');
            sub2.append('<li class="fxxl-menu__item fxxl-menu__item--sub-3">' +
                '<a class="fxxl-menu__link fxxl-menu__link--sub-3 fxxl-hidden-small" href="' + moreLink + '">...mehr</a></li>');
        }
    });

    menu.find('.fxxl-menu__item--main').on('mouseenter', function (e) {
        menuItem = this.querySelector('a');

        menuItemPosition = menuItem.getBoundingClientRect();
        lastKeyframes = $('#' + keyframeId);
        if (lastKeyframes.length !== 0) {
            lastKeyframes.remove();
        }

        currentX = menuItemPosition.left;

        if (lastX === null) {
            lastX = currentX - 100;
        }

        if (lastX < currentX) {
            transitionOrigin = 'center right';
        } else {
            transitionOrigin = 'center left';
        }

        keyframeId = 'menu_bar_' + generateRandomId();
        keyframe = $('<style id="' + keyframeId + '">@keyframes ' + keyframeId + '{' +
            '0% {transform: translate(' + lastX + 'px, 0) scale(1, 1); opacity: 1;}' +
            '50% {transform: translate(' + currentX + 'px, 0) scale(1.5, 1); opacity: 1;}' +
            '100% {transform: translate(' + currentX + 'px, 0) scale(1, 1); opacity: 1;}' +
            '}' +
            '@keyframes main-menu-bar-hide {' +
            '0% {transform: translate(' + currentX + 'px, 0) scale(1, 1); opacity: 1;}' +
            '50% {transform: translate(' + currentX + 'px, 0) scale(1, 1); opacity: 1;}' +
            '100% {transform: translate(' + currentX + 'px, 0) scale(1, 1); opacity: 0;}' +
            '}'
            + '</style>');

        bar.before(keyframe);
        bar.css({
            'animation': keyframeId + ' 0.25s 1 ease-out forwards',
            'width': menuItemPosition.width + 'px',
            'transform-origin': transitionOrigin
        });

        lastX = currentX;
    }).on('mouseenter', function () {
        menu.find('.fxxl-menu__item--main').addClass('fxxl-menu__item--gray');
    }).on('mouseleave', function () {
        menu.find('.fxxl-menu__item--main').removeClass('fxxl-menu__item--gray');
    });

    menu.on('mouseleave', function () {
        lastX = null;
        bar.css({
            'animation': 'main-menu-bar-hide 0.5s 1 ease-out forwards'
        });
    });
}



/**
 * Mobile menu footer. We define this globally so as to make it possible to attach things like the "logout"
 * link.
 */
let fxxlMobileMenuFooterBranch = '';

if (window?.fxxl_config_from_php?.shop?.fxxl_shop_branches_active === 1) {
    fxxlMobileMenuFooterBranch =  '<a class="fxxl-side-menu__link fxxl-side-menu__link--icon" data-uid="-1" href="' + $('.js-fxxl-branches').first().attr('href') + '"><svg class="fxxl-side-menu__icon" name="Filiale auswählen" ><use xlink:href="#sprite_icon_location_on" /></svg>Filiale auswählen</a>';
}

// Todo: Das muss später noch einmal angepasst werden, damit es dynamisch funktioniert und nicht so fest codiert ist.
let jobsLink;
if (window?._presence !== undefined && _presence === 'fxxl_at') {
    jobsLink = '';
} else {
    jobsLink = '<a class="fxxl-side-menu__link fxxl-side-menu__link--icon" data-uid="-1" href="' + $('.js-fxxl-jobs').first().attr('href') + '"><svg class="fxxl-side-menu__icon" name="XXL Jobs" ><use xlink:href="#sprite_icon_work" /></svg>XXL Jobs</a>';
}
// ********************************************************************************************************************

var fxxlMobileMenuFooter = $('<li class="fxxl-side-menu__item fxxl-side-menu__item--footer">'
    + '<div><hr class="fxxl-side-menu__separator"></div>'
    + '<a class="fxxl-side-menu__link fxxl-side-menu__link--icon" data-uid="-1" href="' + $('.js-fxxl-login').first().attr('href') + '"><svg class="fxxl-side-menu__icon" name="Mein Konto" ><use xlink:href="#sprite_icon_person" /></svg>Mein Konto</a>'
    + fxxlMobileMenuFooterBranch
    + jobsLink
    + '<div><hr class="fxxl-side-menu__separator fxxl-side-menu__separator--footer"></div>'
    + '<div class="fxxl-side-menu__content fxxl-side-menu__content--footer">' + $('.fxxl-menu__item--mobile-footer').html() + '</div>'
    + '</li>')[0];


function setMobileMainFlyout(menu) {
    var linkId,
        menuModalBg = $('<div class="fxxl-side-menu__modal-bg"></div>'),
        subMenuList = $('<li class="fxxl-side-menu__item"></li>'),
        linkToAllTemplate = $('<li><a data-uid="-1" class="fxxl-side-menu__link fxxl-side-menu__link--sub"></a></li>'),
        subLink = $('<a class="fxxl-side-menu__link"></a>'),
        subMenuContainer = $('<ul class="fxxl-side-menu fxxl-side-menu--main"></ul>'),
        mainMenuTitle = $('<li class="fxxl-side-menu__item fxxl-side-menu__item--title fxxl-side-menu__item--main-title"></li>'),
        subMenuTitle = $('<li class="fxxl-side-menu__item fxxl-side-menu__item--title"></li>'),
        menuCloseButton = $('<a class="fxxl-side-menu__close-button" href="#"><svg width="24" height="24"><use href="#sprite_icon_close"></use></svg></a>').on('click', () => {
            fxxlHideMainFlyout();
            return false;
        }),
        subMenuContent = $('<ul  class="fxxl-side-menu__list"></ul>'),
        item,
        link,
        linkVwId,
        parentLink,
        parentId,
        subMenu,
        subMenuClone,
        subMenuContentTemp,
        subMenuContentTemp2,
        subMenuContentTemp3,
        pid,
        uid,
        lastSelectedSubContentPid = -1,
        linkVwTypeId,
        lvlItems,
        targetSubContent,
        activeToMove = false,
        startTouchX,
        startTouchY,
        mouseDirection = null,
        classMatch,
        linkClass = 'fxxl-side-menu__link--sub',
        tmpLinkClass,
        /**
         * Setup Link
         * @param linkClone
         * @param link
         * @param uid
         * @param pid
         * @param linkVwId
         * @param linkVwTypeId
         */
        setupLink = function setupLink(linkClone, link, uid, pid, linkVwId, linkVwTypeId) {
            linkClone.attr('href', link.attr('href'))
                .attr('data-uid', uid)
                .attr('data-pid', pid)
                .attr('data-vwid', linkVwId)
                .attr('data-vwtype-id', linkVwTypeId)
                .text(link.text());
        };

    /**
     * Starts: level 1
     */
    subMenuContentTemp = subMenuContent.clone(true, true);

    // Add Title
    subMenuContentTemp.append(
        mainMenuTitle.clone(true).append(
            $('<span class="fxxl-side-menu__link fxxl-side-menu__link--title fxxl-side-menu__link--main-title fxxl-side-menu__link--main">Men&uuml;</span>')
        ).append(menuCloseButton.clone(true))
    );

    menu.find('.fxxl-menu__item--main').each(function () {
        item = $(this);
        link = item.find('>a').first();
        linkVwId = link.attr('data-vwid');
        linkVwTypeId = link.attr('data-vwtype-id');
        subMenu = item.find('ul.fxxl-menu__item--sub');
        subMenuClone = subLink.clone(true, true);

        linkId = -1;
        if (subMenu.length > 0) {
            linkId = Math.random().toString(36).substr(2, 9);
            link.attr('data-uid', linkId);
        }

        setupLink(subMenuClone, link, linkId, 0, linkVwId, linkVwTypeId);
        var subMenuListClone = subMenuList.clone(true, true);
        if (item.hasClass('fxxl-hidden-small')) {
            subMenuListClone.addClass('fxxl-hidden-small');
        }
        subMenuContentTemp.append(subMenuListClone.append(subMenuClone));
    });
    subMenuContentTemp.attr('data-pid', 0);
    subMenuContentTemp.addClass('fxxl-side-menu__list--main');
    /**
     * Ends: Level 1
     */

    subMenuContainer.append(subMenuContentTemp);

    /**
     * Starts: level 2 + 3
     */
    menu.find('.fxxl-menu__item--sub').each(function () {
        subMenuContentTemp2 = subMenuContent.clone(true, true);
        parentLink = $(this).prev('.fxxl-menu__link--main');
        parentId = parentLink.data('uid');

        // Add Title
        subMenuContentTemp2.append(subMenuTitle.clone(true)
            .append(subLink.clone(true).text(parentLink.text())
                .attr('href', parentLink.attr('href'))
                .addClass('fxxl-side-menu__link--title fxxl-side-menu__link--sub')
                .attr('data-uid', '0').attr('data-pid', '0'))
            .append(menuCloseButton.clone(true))
        );


        const fxxlHauptmenuMobileKategoriePrefix = FxxlCore.getConfig()
            .server?.translate_text?.menu?.mobile?.fxxl_hauptmenu_mobile_kategorie_prefix ?? '';
            // Add link to all
        subMenuContentTemp2.append(
            subMenuList.clone(true, true).append(
                linkToAllTemplate.clone(true).find('>a')
                    .text(replaceCategoryPrefix(parentLink.text(), fxxlHauptmenuMobileKategoriePrefix))
                    .attr('href', parentLink.attr('href'))
                    .attr('data-vwid', parentLink.attr('data-vwid'))
                    .attr('data-vwtype-id', parentLink.attr('data-vwtype-id'))
            )
        );

        $(this).find('.fxxl-menu__item--sub-2').each(function () {
            linkId = Math.random().toString(36).substr(2, 9);
            subMenuContentTemp3 = subMenuContent.clone(true, true);
            item = $(this);
            subMenuClone = subLink.clone(true, true);
            link = item.find('.fxxl-menu__link--sub-title-2').first();
            linkVwId = link.attr('data-vwid');
            linkVwTypeId = link.attr('data-vwtype-id');
            lvlItems = item.find('.fxxl-menu__link--sub-3');
            if (lvlItems.length === 0) {
                linkId = -1;
            }

            // Additional Highlight-Class (z.B: fxxl-menu__link--highlight-black)
            classMatch = /(^|\s)(fxxl-menu__link--highlight-[a-z]+)($|\s)/g.exec(link.attr('class'));
            if (classMatch !== null) {
                tmpLinkClass = linkClass + ' ' + classMatch[2];
            } else {
                tmpLinkClass = linkClass;
            }

            setupLink(subMenuClone, link.clone(true, true), linkId, parentId, linkVwId, linkVwTypeId);
            subMenuClone.addClass(tmpLinkClass);

            var subMenuListClone = subMenuList.clone(true, true);
            if (item.parent('li').hasClass('fxxl-hidden-small')) {
                subMenuListClone.addClass('fxxl-hidden-small');
            }

            if (subMenuClone.text().length > 0) {
                subMenuContentTemp2.append(subMenuListClone.append(subMenuClone));
            }

            // Add Title
            subMenuContentTemp3.append(subMenuTitle.clone(true)
                .append(subLink.clone(true).text(link.text())
                    .attr('href', link.attr('href'))
                    .addClass('fxxl-side-menu__link--title fxxl-side-menu__link--sub')
                    .attr('data-uid', parentId).attr('data-pid', '0'))
                .append(menuCloseButton.clone(true))
            );

            // Add link to all
            subMenuContentTemp3.append(
                subMenuList.clone(true, true).append(
                    linkToAllTemplate.clone(true).find('>a')
                        .text(replaceCategoryPrefix(link.text(), fxxlHauptmenuMobileKategoriePrefix))
                        .attr('href', link.attr('href'))
                        .attr('data-vwid', link.attr('data-vwid'))
                        .attr('data-vwtype-id', link.attr('data-vwtype-id'))
                )
            );

            lvlItems.each(function () {
                subMenuClone = subLink.clone(true, true);
                var subMenuListClone = subMenuList.clone(true, true),
                    lvlItemVwId = $(this).attr('data-vwid'),
                    lvlItemVwTypeId = $(this).attr('data-vwtype-id');
                if ($(this).closest('li').hasClass('fxxl-hidden-small')) {
                    subMenuListClone.addClass('fxxl-hidden-small');
                }
                setupLink(subMenuClone, $(this).clone(true, true), -1, linkId, lvlItemVwId, lvlItemVwTypeId);
                subMenuClone.addClass('fxxl-side-menu__link--sub');
                subMenuContentTemp3.append(subMenuListClone.append(subMenuClone));
            });
            subMenuContentTemp3.attr('data-pid', linkId);
            subMenuContainer.append(subMenuContentTemp3.clone(true));
        });

        subMenuContentTemp2.attr('data-pid', parentId);
        subMenuContainer.append(subMenuContentTemp2.clone(true));
    });
    /**
     * Ends: level 2 + 3
     */

    // Add Modal Background
    menu.append(menuModalBg);

    menu.find('.fxxl-menu__list').detach();
    menu.append(subMenuContainer);

    /**
     * Set Events
     */
    menu.find('.fxxl-menu__button').on('click', function () {
        fxxlShowMainFlyout();
        return false;
    });

    menuModalBg.on('click', function () {
        fxxlHideMainFlyout();
    });

    /**
     * Setup Scroller
     */
    menu.find('.fxxl-side-menu__list').each(function () {
        new FxxlTouchScroller(this);
    });

    // Speichert, welche Menüs den Footer attached haben, damit das nur jeweils
    // einmal geschieht.
    var hasFooter = [];

    function fxxlShowMainFlyout() {
        $('body').addClass('fxxl-fix-body-in-place');
        // 0 ist die listId des Hauptmenüs
        const listId = 0;
        targetSubContent = $('.fxxl-side-menu__list[data-pid="' + listId + '"]').first();
        if (!hasFooter.includes(listId)) {
            targetSubContent[0].append(fxxlMobileMenuFooter.cloneNode(true));
            hasFooter.push(listId);
            fxxlAddCookieParameterToHelpCenterUrls((etJS_getCookie('fxxl_optional_cookies') === 'true') ? 'all' : 'required');
        }
        fxxlSetShowClass(targetSubContent);
        menu.find('.fxxl-side-menu--main').css({'visibility': 'visible'});
        menuModalBg.addClass('fxxl-side-menu__modal-bg--show');
        fxxlHideScrollToTop();
    }

    function fxxlHideMainFlyout() {
        $('body').removeClass('fxxl-fix-body-in-place');
        $('.fxxl-side-menu__list').removeClass('fxxl-side-menu__list--show')
        menu.find('.fxxl-side-menu--main').css({'visibility': 'hidden'});
        menuModalBg.removeClass('fxxl-side-menu__modal-bg--show');
        fxxlShowScrollToTop();
        lastSelectedSubContentPid = -1;
    }

    function fxxlSetShowClass(element) {
        element.addClass('fxxl-side-menu__list--show').css({'transform' : '', 'max-height' : window.innerHeight + 'px'});
    }

    menu.find('.fxxl-side-menu__link').not('.fxxl-side-menu__link--main').on('click', function () {
        item = $(this);
        uid = item.data('uid');
        pid = item.data('pid');

        if (uid === -1) {
            return true;
        }

        if (lastSelectedSubContentPid !== uid) {
            lastSelectedSubContentPid = uid;
            targetSubContent = $('.fxxl-side-menu__list[data-pid="' + uid + '"]').first();
            if (!hasFooter.includes(uid)) {
                targetSubContent[0].append(fxxlMobileMenuFooter.cloneNode(true));
                hasFooter.push(uid);
                fxxlAddCookieParameterToHelpCenterUrls((etJS_getCookie('fxxl_optional_cookies') === 'true') ? 'all' : 'required');
            }
            $('.fxxl-side-menu__list').removeClass('fxxl-side-menu__list--show');
            setTimeout(function () {
                fxxlSetShowClass(targetSubContent);
            }, 150);
        }

        return false;
    });

    /**
     * Close Flyout with swap
     */
    menu.on('touchstart', function (e) {
        activeToMove = true;
        startTouchX = e.touches[0].pageX;
        startTouchY = e.touches[0].pageY;
        mouseDirection = null;
    });

    menu.on('touchend', function (e) {
        activeToMove = false;
        if (mouseDirection === true) {
            var newTranslateX = e.changedTouches[0].pageX - startTouchX;
            if (newTranslateX <= -50) {
                $('.fxxl-side-menu__list--main').css({
                    'transition': 'transform 0.15s',
                    'transform': 'translate3d(-100%, 0, 0)'
                });
                setTimeout(function () {
                    fxxlHideMainFlyout();
                    $('.fxxl-side-menu__list--main').css({'transition': ''});
                }, 150);
            } else {
                $('.fxxl-side-menu__list--main').css({
                    'transition': 'transform 0.15s',
                    'transform': 'translate3d(0, 0, 0)'
                });
            }
        }
    });

    menu.on('touchmove', function (e) {
        if (activeToMove === true) {
            var deltaX = Math.abs(startTouchX - e.touches[0].pageX),
                deltaY = Math.abs(startTouchY - e.touches[0].pageY),
                newTranslateX;

            if (mouseDirection === null) {
                mouseDirection = deltaX > deltaY;
            }

            if (mouseDirection === true) {
                newTranslateX = e.touches[0].pageX - startTouchX;
                if (newTranslateX < 0) {
                    $('.fxxl-side-menu__list--main').css({
                        'transition': '',
                        'transform': 'translate3d(' + newTranslateX + 'px, 0, 0)'
                    });
                } else {
                    startTouchX = e.touches[0].pageX;
                }
            }
        }
    });
}

function replaceCategoryPrefix(linkText, fxxlHauptmenuMobileKategoriePrefix) {
    if (fxxlHauptmenuMobileKategoriePrefix.includes('###CATEGORY###')) {
        return fxxlHauptmenuMobileKategoriePrefix.replace("###CATEGORY###", linkText);
    }

    return linkText;
}

/**
 * Content Page Side Navigation - Mobile only
 */
    var mobileMenuAccordionId = 'fxxl-content-page-nav-accordion',
        mobileMenuAccordionObj = $('#' + mobileMenuAccordionId);

    if (mobileMenuAccordionObj.length > 0) {
        var mobileMenuAccordionHead = $('.fxxl-content-page-navigation-accordion__head'),
            mobileMenuAccordionContent = $('.fxxl-content-page-navigation-accordion__content'),
            collapsibleMenuList = mobileMenuAccordionContent.find('.collapsible > li'),
            activeCollapsibleList = mobileMenuAccordionContent.find('.collapsible > li.active'),
            accordionActiveClass = 'fxxl-accordion--active',
            accordionInactiveClass = 'fxxl-accordion--deactivated',
            headerHeight;

        function fxxlShowHideMobileMenuAccordion() {
            if (isLargeViewport() === false) {
                mobileMenuAccordionObj.removeAttr('data-extended');
                mobileMenuAccordionObj.data('extended', 0);

                mobileMenuAccordionHead.on('click', function (){
                    if ($(this).parent().hasClass('fxxl-accordion--deactivated')) {
                        headerHeight = $('.fxxl-base-header')[0].clientHeight;
                        if ($(this).parent().hasClass(accordionActiveClass) === false && activeCollapsibleList.length === 1) {
                            setTimeout(function () {
                                $('html, body').animate(
                                    {
                                        scrollTop: activeCollapsibleList.offset().top - headerHeight
                                    },
                                    250,
                                    'easeOutCirc'
                                );
                            },250);
                        }
                        // removes browser scroll history
                        if ('scrollRestoration' in history) {
                            history.scrollRestoration = 'manual';
                        }
                    }
                });
            }
        }

        fxxlShowHideMobileMenuAccordion();

        new FxxlResizedEvent(function () {
            fxxlShowHideMobileMenuAccordion();
        });

        collapsibleMenuList.on('click', function () {
            if (mobileMenuAccordionContent.attr('style')) {
                mobileMenuAccordionContent.removeAttr('style');
            }
        });
    }

var FXXLFormDataUpload = (function FXXLFormDataUpload()
{
    'use strict';

    function FXXLFormDataUpload(datauploadform)
    {
        var __this = this;
        this.dataUploadFormContainer = $(datauploadform);
        this.dataUploadFormContainerClass = this.dataUploadFormContainer[0].classList;
        this.dataUploadContainer = $('.fxxl-file-upload__dragdrop-container', this.dataUploadFormContainer);
        this.dataUploadValidationErrorContainer = this.dataUploadContainer.attr('data-validation-error-target');
        this.formId = this.dataUploadContainer.attr('data-fid');
        this.fieldIndex = this.dataUploadContainer.attr('data-index');
        this.dataUploadFormDarkBackground = 'fxxl-file-upload__dragdrop-container--dark';
        this.dataUploadFormValidationError = 'fxxl-file-upload__dragdrop-container--error';
        this.dataUploadFormInputClass = '.fxxl-file-upload__dragdrop-container-input';
        this.formInputName = $(this.dataUploadFormInputClass, this.dataUploadFormContainer).attr('name');
        this.dataUploadErrorContainer = $(this.dataUploadFormInputClass, this.dataUploadFormContainer).attr('data-validation-error-targets').split('|')[0];
        this.dataUploadNewInput = $('<input type="file" class="fxxl-file-upload__dragdrop-container-input fxxl-hidden">');
        this.dataUploadInputBaseName = 'fxxl_fileupload_input_' + this.formId + '-';
        this.dataUploadDefaultInput = $("#" + this.dataUploadInputBaseName + '0', this.dataUploadFormContainer);
        this.defaultInputRequired = this.dataUploadDefaultInput.attr('data-required');
        this.dataUploadDisplayContrainer = this.dataUploadFormContainer.find('.fxxl-file-upload__show-files');
        this.dataLabelContainer = $('<div class="fxxl-file-upload__files-label"></div>');
        this.dataLabelContainerClass = '.fxxl-file-upload__files-label';
        this.dataLabelClass = 'fxxl-file-upload__files-name';
        this.dataImagePreviewClass = 'fxxl-file-upload__files-image-preview';
        this.dataImagePreiviewContainer = 'fxxl-file-upload__files-image-wrapper';
        this.imageIcon = '<svg width="24" height="24" class="fxxl-icon fxxl-svg-fix"><use href="#sprite_icon_image" xlink:href="#sprite_icon_image"></use></svg>';
        this.pdfIcon = '<svg width="24" height="24" class="fxxl-icon fxxl-svg-fix"><use href="#sprite_icon_pdf" xlink:href="#sprite_icon_pdf"></use></svg>';
        this.deleteIcon = '<svg width="24" height="24" class="fxxl-icon fxxl-icon--gray fxxl-svg-fix"><use href="#sprite_icon_delete" xlink:href="#sprite_icon_delete"></use></svg>';
        this.fileDeleteFromList = '.fxxl-file-upload__files--delete';
        this.uploadedFilesDetails = null;
        this.maxNumberOfAllowedFiles = 0;
        this.maxFileReachedErrorClass = '.fxxl-input-validation-filecount-error-' + this.formId;

        if (typeof this.dataUploadDefaultInput.attr('data-max-file-count') !== undefined) {
            this.maxNumberOfAllowedFiles = $(this.dataUploadFormInputClass , this.dataUploadFormContainer).attr('data-max-file-count');
        }

        if (this.defaultInputRequired === '1') {
            this.inputRequired = true;
        } else {
            this.inputRequired = false;
        }

        this.validationTest = new FxxlFormValidation($(this.dataUploadDefaultInput));
        if ($(this.dataUploadDefaultInput).prop('disabled') === true) {
            __this.validationTest.validationDisabled = true;
        }

        this.setEvents();
    }

    FXXLFormDataUpload.prototype.setEvents = function setEvents()
    {
        var __this = this,
            inputTargetIndex,
            inputFile,
            mainForm;

        /**
         * Select Data Manually
         */
        $(this.dataUploadContainer).on('mousedown', function (e){
            if (e.which === 1) { // mouseleft click
                if (__this.checkMaxAllowedFile() === true) {
                    return false;
                }
                inputTargetIndex = $(this).attr('data-index');
                inputFile = $('#' + __this.dataUploadInputBaseName + inputTargetIndex , this.dataUploadFormContainer);
                inputFile.prop('disabled', false);
                __this.validationTest.validationDisabled = false;
                inputFile.trigger('click');
            }
        });

        mainForm = this.dataUploadDefaultInput.parents('form:first');

        mainForm.on('submit', function (){
            var validationResult;

            $(__this.dataUploadValidationErrorContainer, this.dataUploadFormContainer).css('display', 'none');
            if (__this.inputRequired === false) {
                //$('.fxxl-file-upload__error-text').css('display', 'none');
            }
            validationResult = __this.checkInputShowHideError();

            if (validationResult === false) {
                fxxlSetFormValidationFieldResult(__this.dataUploadFormContainer, false);
            } else {
                fxxlSetFormValidationFieldResult(__this.dataUploadFormContainer, true);
            }
            return validationResult;
        });

        this.dataUploadDefaultInput.on('change', function (){
            inputTargetIndex = $(this).data('index');
            if (__this.inputRequired === false) {
                $(this).prop('disabled', false);
            }
            __this.uploadedFilesDetails = this.files;

            if (__this.validationTest.test() === true) {
                __this.displayData(__this.uploadedFilesDetails, inputTargetIndex);
                __this.createNewInputField(inputTargetIndex);
                __this.checkInputShowHideError();
                $(__this.dataUploadContainer).removeClass(__this.dataUploadFormValidationError);
            } else {
                $(this).val("");
                __this.checkInputShowHideError();
                $(__this.dataUploadContainer).addClass(__this.dataUploadFormValidationError);
            }
        });

        /**
         * Drag & Drop Data
         */
        this.dataUploadFormContainer.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (e.type === 'dragover' || e.type === 'dragenter') {
                __this.dataUploadContainer.addClass(__this.dataUploadFormDarkBackground);
            }

            if (e.type === 'dragleave' || e.type === 'dragend' || e.type === 'drop') {
                __this.dataUploadContainer.removeClass(__this.dataUploadFormDarkBackground);
            }

            if (e.type === 'drop') {
                var dt = e.originalEvent.dataTransfer,
                    droppedFiles = dt.files,
                    inputCount,
                    newInputIndex,
                    newInput,
                    dT;

                if (__this.isAdvancedUpload()) {
                    // for modern browsers
                    $.each(droppedFiles, function(key, file) {
                        inputCount = $(__this.dataUploadFormInputClass, this.dataUploadFormContainer).length;

                        if (__this.checkMaxAllowedFile() === true) {
                            return false;
                        }
                        dT = new DataTransfer();
                        dT.items.add(e.originalEvent.dataTransfer.files[key]);

                        newInputIndex = $(__this.dataUploadFormInputClass+':last', this.dataUploadFormContainer).attr('data-index');
                        newInput = $('input#fxxl_fileupload_input_' + this.formId + '-' + newInputIndex, this.dataUploadFormContainer);
                        newInput.prop('disabled', false);

                        if (newInput.val() === '') {
                            newInput.prop('files', dT.files);
                            newInput.trigger('change');
                        }

                    });
                }
            }
        });
    };

    FXXLFormDataUpload.prototype.checkInputShowHideError = function checkInputShowHideError()
    {
        var __this = this,
            validity = false;

        $(__this.dataUploadFormInputClass, this.dataUploadFormContainer).each(function (key, element) {

            if($(element).val() === '' && $(element).is(':disabled') === false && $(element).attr("data-required") === "1") {
                $(__this.dataUploadErrorContainer, this.dataUploadFormContainer).css('display', 'block');
                $(__this.dataUploadContainer).addClass(__this.dataUploadFormValidationError);
                validity = false;
                return validity;
            } else if ($(element).val() === '' && $(element).is(':disabled') === true && $(__this.dataUploadFormInputClass, this.dataUploadFormContainer).length == 1 && __this.inputRequired === true) {
                $(element).prop('disabled', 'false');
                $(__this.dataUploadErrorContainer, this.dataUploadFormContainer).css('display', 'block');
                $(__this.dataUploadContainer).addClass(__this.dataUploadFormValidationError);
                validity = false;
                return validity;
            } else {
                //$(__this.dataUploadErrorContainer).css('display', 'none');
                $(__this.dataUploadContainer).removeClass(__this.dataUploadFormValidationError);
                validity = true;
            }
        });

        return validity;
    };

    FXXLFormDataUpload.prototype.createNewInputField = function createNewInputField(inputTargetIndex)
    {
        var __this = this,
            newInput,
            dataIndex = parseInt(inputTargetIndex) + 1,
            validationTest,
            initialInput = $('#' + __this.dataUploadInputBaseName + inputTargetIndex, this.dataUploadFormContainer);

        newInput = this.dataUploadNewInput.clone();
        newInput.attr({
            'data-index': dataIndex,
            'name': this.formInputName,
            'id': this.dataUploadInputBaseName + dataIndex,
            'data-validation': initialInput.attr('data-validation'),
            'data-required': 0,
            'data-validation-error-targets': initialInput.attr('data-validation-error-targets'),
            'data-valid-type': initialInput.attr('data-valid-type'),
            'data-max-file-size': initialInput.attr('data-max-file-size'),
            'data-max-file-count': initialInput.attr('data-max-file-count')
        }).prop({
            'disabled': true,
        });

        this.dataUploadContainer.append(newInput);
        this.dataUploadContainer.attr('data-index', dataIndex);

        validationTest = new FxxlFormValidation($(newInput));
        validationTest.validationDisabled = true;

        $(newInput).on('change', function () {
            validationTest.validationDisabled = false;
            if (validationTest.test() === true) {
                __this.displayData(this.files, dataIndex);
                __this.createNewInputField(dataIndex);
                __this.checkInputShowHideError();
                $(__this.dataUploadContainer, this.dataUploadFormContainer).removeClass(__this.dataUploadFormValidationError);
            } else {
                validationTest.validationDisabled = true;
                $(this).val('');
                $(this).prop('disabled', true);
                __this.checkInputShowHideError();
                $(__this.dataUploadContainer, this.dataUploadFormContainer).addClass(__this.dataUploadFormValidationError);
            }
        });
    };

    FXXLFormDataUpload.prototype.isAdvancedUpload = function isAdvancedUpload()
    {
        var div = document.createElement('div');
        return ( ( 'draggable' in div ) || ( 'ondragstart' in div && 'ondrop' in div ) ) && 'FormData' in window && 'FileReader' in window;
    };

    FXXLFormDataUpload.prototype.displayData = function displayData(files, fileIndex)
    {
        var __this = this,
            dataLabel,
            dataDetails,
            dataImgPreview,
            fileNameLabel,
            fName,
            deleteIcon,
            fType,
            contentPreview;

        $.each(files, function () {
            fType = this.type.split('/').pop();

            if (this.name.length > 30) {
                if (isLargeViewport()) {
                    fName = this.name.substring(0,30) + '...';
                } else {
                    fName = this.name.substring(0,20) + '...';
                }
            } else {
                fName = this.name;
            }
            dataLabel = __this.dataLabelContainer.clone();
            dataLabel.attr('data-index', fileIndex);
            fileNameLabel ='<span class="' + __this.dataLabelClass + '">'+ fName +'</span>';
            deleteIcon = '<span class="fxxl-file-upload__files--delete" data-index="' + fileIndex +'" data-name="'+ fName + '">' + __this.deleteIcon + '</span>';
            dataImgPreview = '<div class="' + __this.dataImagePreiviewContainer + '"><img src="#" alt="reviewuploadimage" class="' + __this.dataImagePreviewClass + '"></div>';
            if (fType === 'pdf') {
                contentPreview = __this.pdfIcon;
            } else {
                contentPreview = dataImgPreview;
            }
            dataDetails = deleteIcon + contentPreview + fileNameLabel;
            dataLabel.append(dataDetails);
            __this.readImageURLForPreview(dataLabel, files);
            __this.dataUploadDisplayContrainer.append(dataLabel);

            /**
             * create events for delete
             */
            $(__this.fileDeleteFromList + '[data-index=' + fileIndex + ']', this.dataUploadFormContainer).on('click', function () {
                __this.dataUploadFormContainer.find('input[data-index="' + fileIndex + '"]').remove();
                $(this).parent(__this.dataLabelContainerClass).remove();
                $(__this.dataUploadFormInputClass, this.dataUploadFormContainer).each(function (index) {
                    if ($(this).attr('data-index') !== '0' && __this.inputRequired === true) {
                        $(this).attr('data-required', '1');
                        return false;
                    }
                });
                __this.checkInputShowHideError();
                $(__this.dataUploadValidationErrorContainer, this.dataUploadFormContainer).css('display', 'none');
            });
        });

    };

    FXXLFormDataUpload.prototype.readImageURLForPreview = function readImageURLForPreview(dataLabel, files)
    {
        var reader = new FileReader(),
            __this = this;

        reader.onload = function (e) {
            $(dataLabel, this.dataUploadFormContainer).find('.' + __this.dataImagePreviewClass).attr('src', e.target.result);
        }

        reader.readAsDataURL(files[0]);
    };

    FXXLFormDataUpload.prototype.checkMaxAllowedFile = function checkMaxAllowedFile()
    {
        var __this = this;
        if (this.maxNumberOfAllowedFiles > 0) {
            if ($(this.dataUploadFormInputClass, this.dataUploadFormContainer).length > this.maxNumberOfAllowedFiles) {
                $(this.maxFileReachedErrorClass, this.dataUploadFormContainer).css('display', 'block');
                setTimeout(function () {
                    $(__this.maxFileReachedErrorClass, this.dataUploadFormContainer).css('display', 'none');
                }, 2000);
                return true
            }
        }
        return false;
    };

    return FXXLFormDataUpload;
}());

function initRatenkaufTable(){
    $('.js_ratenkauf_table').each(function () {
        var $this_table = $(this);
        var index = 0;
        var ratenkauf_angebote = $this_table.data('ratenkauf_angebote');
        var anzahlraten_init = parseInt($this_table.attr('data-anzahlraten_init'));
        if (anzahlraten_init > 0) {
            for (var _counter = 0; _counter < ratenkauf_angebote.length; _counter++) {
                if (ratenkauf_angebote[_counter].anzahlraten == anzahlraten_init) {
                    index = _counter;
                }
            }
        }

        function showAngebot() {
            $('.js_ratenkauf_table_anzahlraten', $this_table).text(ratenkauf_angebote[index].anzahlraten);
            $('.js_ratenkauf_table_anzahlraten_minus_1', $this_table).text(ratenkauf_angebote[index].anzahlraten - 1);
            $('.js_ratenkauf_table_betragrate_text', $this_table).text(ratenkauf_angebote[index].betragrate_text);
            $('.js_ratenkauf_table_betragschlussrate_text', $this_table).text(ratenkauf_angebote[index].betragschlussrate_text);
            $('.js_ratenkauf_table_effektivzins_text', $this_table).text(ratenkauf_angebote[index].effektivzins_text);
            $('.js_ratenkauf_table_gesamtbetrag_text', $this_table).text(ratenkauf_angebote[index].gesamtbetrag_text);
            $('.js_ratenkauf_table_ratenaufschlag_text', $this_table).text(ratenkauf_angebote[index].ratenaufschlag_text);

            FxxlCheckout4Total.setTotalTextForPayment($this_table.data('payment_id'), ratenkauf_angebote[index].gesamtbetrag_text);

            $('.js_ratenkauf_table_anzahlraten_text_fill', $this_table).each(function (i) {
                var $this = $(this);
                var text = $this.data('texttemplate');
                if (text) {
                    text = text.replace('##anzahlraten##', ratenkauf_angebote[index].anzahlraten);
                }
                $this.text(text);
            });

            $('.js_ratenkauf_table__selectbutton', $this_table).removeClass('ratenkauf_table__selectbutton--selected');
            $('.js_ratenkauf_table__selectbutton[data-itemindex=' + index + ']', $this_table).addClass('ratenkauf_table__selectbutton--selected');

            $('.js_ratenkauf_table_input_anzahlraten', $this_table).val(ratenkauf_angebote[index].anzahlraten);
        }
        if (ratenkauf_angebote && ratenkauf_angebote.length > 0) {
            showAngebot();
            $('.js_ratenkauf_table__selectbutton[data-itemindex]', $this_table).click(function (event) {
                event.preventDefault();
                index = $(this).data('itemindex');
                showAngebot();
            });
        }
    });
}
/**
 * Countdown
 *
 * Filename: 410_fxxl_custom_html_elements.js
 *
 * @category  Applicas
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 * @copyright 2019 onlinekauf Internet Service GmbH
 */

var fxxlCustomHtmlElements = {
    variables: {
        timeCorrectorTimer: null
    },
    functions: {
        stringToDatetime: function (stringDT) {
            /**
             * dd-mm-YYYY hh:mm:ss
             */
            var regex = /^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})$/g,
                datMatch = regex.exec(stringDT);
            return Math.round(new Date(datMatch[3], parseInt(datMatch[2]) - 1, datMatch[1], datMatch[4], datMatch[5], datMatch[6]).getTime() / 1000);
        },

        autoTimeCorrector: function () {
            clearInterval(fxxlCustomHtmlElements.variables.timeCorrectorTimer);
            fxxlCustomHtmlElements.variables.timeCorrectorTimer = setInterval(function () {
                fxxlCustomHtmlElements.countdown.attributes.now += 1;
            }, 1000);
        },

        getUniqueID: function () {
            return Math.random().toString(36).slice(2);
        }
    },
    countdown: {
        attributes: {},
        variables: {
            title: '',
            timeStep: 1000,
            totalDays: 0,
            isActive: false
        },

        set: function (element) {
            if (this.getAttrs(element) === true) {
                var comingSoonTitle = null;

                if (typeof this.attributes.coming_soon_title !== 'undefined') {
                    comingSoonTitle = this.attributes.coming_soon_title;
                }

                this.variables.isActive = this.isActive();

                if (this.variables.isActive === true || (comingSoonTitle !== null && this.variables.isActive == -1)) {
                    this.setTitle();
                    this.create(element);
                    if (typeof this.attributes.theme !== 'undefined') {
                        element.addClass(this.attributes.theme);
                    }

                    fxxlCustomHtmlElements.functions.autoTimeCorrector();
                    var thisClass = this;
                    setInterval(function () {
                        thisClass.variables.isActive = thisClass.isActive();
                        thisClass.update(element);
                    }, this.variables.timeStep);
                }
            }
        },

        getAttrs: function (element, needServerDate) {

            needServerDate = (typeof needServerDate !== 'undefined') ? needServerDate : true;

            var attributes = [];
            $.each(element[0].attributes, function () {
                if (this.specified) {
                    if (this.name.toLowerCase() == "start" || this.name.toLowerCase() == "end") {
                        attributes[this.name] = fxxlCustomHtmlElements.functions.stringToDatetime(this.value);
                    } else {
                        attributes[this.name] = this.value;
                    }
                }
            });

            if (needServerDate === true) {
                attributes.now =
                    parseInt($('html').first().data('timestamp'));
            } else {
                attributes.now = this.attributes.now;
            }

            this.attributes = attributes;
            return true;
        },

        isActive: function () {
            if (this.attributes.now < this.attributes.start) {
                return -1;
            } else if (this.attributes.now > this.attributes.end) {
                return -2;
            } else {
                return true;
            }
        },

        getDistance: function () {

            var fromDate,
                toDate;

            if (this.variables.isActive === true) {
                fromDate = this.attributes.now;
                toDate = this.attributes.end;
            } else {
                fromDate = this.attributes.now;
                toDate = this.attributes.start;
            }

            var Tdistance = toDate - fromDate,
                distance = {
                    days: Math.floor(Tdistance / (60 * 60 * 24)),
                    hours: Math.floor((Tdistance % (60 * 60 * 24)) / (60 * 60)),
                    minutes: Math.floor((Tdistance % (60 * 60)) / (60)),
                    seconds: Math.floor((Tdistance % (60)))
                }

            this.variables.totalDays = Math.floor((this.attributes.end
                - this.attributes.start) / (60 * 60 * 24));

            return distance;
        },

        getCounter: function (style, distance, update) {

            update = (typeof update !== 'undefined') ? update : false;

            var newToValue,
                textTheme = '',
                circleTheme = '',
                separatorTheme = '',
                svg = '',
                title = 'sec',
                currentValue,
                innerIds = {'day_el': 0, 'hour_el': 24, 'min_el': 60, 'sec_el': 60},
                elementSpace_st_1 = -54,
                elementSpace_st_2 = -65,
                _this = this;

            $.each(innerIds, function (innerId, maxValue) {

                if (innerId == 'sec_el') {
                    title = 'Seconds';
                    currentValue = distance.seconds;
                } else if (innerId == 'min_el') {
                    title = 'Minutes';
                    currentValue = distance.minutes;
                } else if (innerId == 'hour_el') {
                    title = 'Hours';
                    currentValue = distance.hours;
                } else if (innerId == 'day_el') {
                    title = 'Days';
                    currentValue = distance.days;
                }

                if (maxValue === 0) {
                    newToValue = (100 / currentValue);

                } else {
                    newToValue = 100 - ((currentValue / maxValue) * 100);
                }

                if (typeof _this.attributes.theme !== 'undefined') {
                    textTheme = ' fxxl-countdown__svg-text--' + _this.attributes.theme;
                    circleTheme = ' fxxl-countdown__svg-circle--' + _this.attributes.theme;
                    separatorTheme = ' fxxl-countdown__svg-separator--' + _this.attributes.theme;
                }

                if (update === false) {
                    if (style === 1) {
                        svg += '<g transform="translate(' + elementSpace_st_1 + ',0)">' +
                            '<path transform="translate(54, 0)" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" ' +
                            'class=\'fxxl-countdown__svg-circle fxxl-countdown__svg-circle--disable' + circleTheme + '\' ' +
                            'stroke-dasharray=\'100, 100\'/>' +
                            '<path transform="translate(54, 0)" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" ' +
                            'data-type="' + innerId + '_number_c" ' +
                            'class=\'fxxl-countdown__svg-circle fxxl-countdown__svg-circle--enable\' ' +
                            'stroke-dasharray=\'' + newToValue + ', 100\'/>' +
                            '<text data-type="' + innerId + '_number_t" class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--number' + textTheme + '\' x="50%" ' +
                            'y="19px" text-anchor="middle" class="small" id="sec">' + currentValue + '</text>' +
                            '<text class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--title' + textTheme + '\' x="50%" ' +
                            'y="25px" text-anchor="middle" class="small">' + title + '</text></g>';
                    } else if (style === 2) {
                        var separator = '';
                        if (innerId != 'sec_el') {
                            separator = '<g class="fxxl-countdown__svg-separator' + separatorTheme + '">' +
                                '<circle r="1.5" cx="90" cy="19"/><circle r="1.5" cx="90" cy="11"/></g>';
                        }

                        svg += '<g transform="translate(' + elementSpace_st_2 + ',0) scale(1.1)"><text data-type="' + innerId + '_number_t" ' +
                            'class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--number fxxl-countdown__svg-text--style-num_' + style + textTheme + '\' x="50%" ' +
                            'y="19px" text-anchor="middle" class="small" id="sec">' + currentValue + '</text>' +
                            '<text class=\'fxxl-countdown__svg-text fxxl-countdown__svg-text--title fxxl-countdown__svg-text--style-num_' + style + textTheme + '\' x="50%" ' +
                            'y="25px" text-anchor="middle" class="small">' + title + '</text>' +
                            separator +
                            '</g>';
                    }

                    elementSpace_st_1 += 36;
                    elementSpace_st_2 += 37;
                } else {
                    update.find('[data-type="' + innerId + '_number_c"]').css({'stroke-dasharray': newToValue + ', 100'});
                    update.find('[data-type="' + innerId + '_number_t"]').text(currentValue);
                }
            });

            if (svg != '') {
                return '<svg data-inner-id="test" class=\'fxxl-countdown__svg fxxl-countdown__svg--counter\' viewBox=\'0 0 144 36\' >' + svg + '</svg>';
            }

        },

        setTitle: function() {
            if (this.variables.isActive === true) {
                this.variables.title = this.attributes.title;
            } else {
                this.variables.title = this.attributes.coming_soon_title;
            }
        },

        updateTitle: function(element) {
            this.setTitle();
            element.find('.fxxl-countdown__title').text(this.variables.title);
            element.find('.fxxl-countdown__img').attr('alt', this.variables.title);
        },

        getCircleLayout: function (distance) {
            var loayout,
                bgImg = '',
                hTheme = '',
                imgTheme = '',
                banner = '',
                bannerShortPos = 'left',
                bannerPosition = '',
                counterPosition = '',
                gridDisplay = '',
                heading = '',
                style = '',
                contentId = fxxlCustomHtmlElements.functions.getUniqueID(),
                counter_style = 1,
                titleStyle = '',
                svg,
                link;

                if (typeof this.attributes.href !== 'undefined') {
                link = ' href="' + this.attributes.href + '"';
            }

            if (typeof this.attributes.counter_style !== 'undefined') {
                counter_style = parseInt(this.attributes.counter_style);
            }

            svg = this.getCounter(counter_style, distance);

            if (typeof this.attributes.title_style !== 'undefined') {
                titleStyle = ' style="' + this.attributes.title_style + '"';
            }

            if (typeof this.attributes.text_color !== 'undefined') {
                style += '#' + contentId + ' .fxxl-countdown__svg-text--light { fill: ' + this.attributes.text_color + '; }';
            }

            if (typeof this.attributes.circle_back_ring !== 'undefined') {
                style += '#' + contentId + ' .fxxl-countdown__svg-circle--disable { stroke: ' + this.attributes.circle_back_ring + '; }';
            }

            if (typeof this.attributes.circle_active_ring !== 'undefined') {
                style += '#' + contentId + ' .fxxl-countdown__svg-circle--enable { stroke: ' + this.attributes.circle_active_ring + '; }';
            }

            if (style != '') {
                style = '<style>' + style + '</style>';
            }

            if (typeof this.attributes.theme !== 'undefined') {
                hTheme = ' fxxl-countdown__title--' + this.attributes.theme;
                imgTheme = ' fxxl-countdown__img--' + this.attributes.theme;
            }

            if (typeof this.attributes.bg !== 'undefined') {
                bgImg = '<img class="fxxl-countdown__img fxxl-countdown__img--bg' + imgTheme + '" alt="'
                    + this.variables.title
                    + '" src="' + this.attributes.bg + '">';
            }

            if (typeof this.attributes.banner_position !== 'undefined') {
                bannerShortPos = this.attributes.banner_position;
            }

            if (typeof this.attributes.banner !== 'undefined') {
                bannerPosition = ' fxxl-countdown__banner--' + bannerShortPos;
                counterPosition = ' fxxl-countdown__container--not-' + bannerShortPos;
                gridDisplay = ' fxxl-countdown--grid-' + bannerShortPos;

                banner = '<div class="fxxl-countdown__banner' + bannerPosition + '"><img class="fxxl-countdown__img fxxl-countdown__img--banner" ' +
                    'alt="' + this.variables.title + '" src="' + this.attributes.banner + '"></div>';
            }

            if (this.variables.title != '') {
                heading = '<h3 class="fxxl-countdown__title' + hTheme + '" ' + titleStyle + '>' + this.variables.title + '</h3>';
            }

            loayout = style + '<a class="fxxl-countdown__link fxxl-countdown__link--decoration-none"' + link + '>' + bgImg
                + '<div id="' + contentId + '" class="fxxl-countdown' + gridDisplay
                + ' fxxl-countdown--style-num_' + counter_style + '"><div class="fxxl-countdown__container'
                + counterPosition + '">' + heading + svg + '</div>' +
                banner + '</div></a>';

            return loayout;
        },

        create: function (element) {
            var distance = this.getDistance(),
                layout = this.getCircleLayout(distance);
            element.html(layout);
        },

        update: function (element) {
            this.getAttrs(element, false);
            var distance = this.getDistance();
            this.getCounter(0, distance, element);
            this.updateTitle(element);
        }

    }
};

var FxxlSetupMarketingSpots = function FxxlSetupMarketingSpots() {
    function FxxlSetupMarketingSpots(element) {
        this.element = element;
        this.containerCountdownClass = 'fxxl-marketingspot-popup__container--countdown';
        this.closeButtonClass = 'fxxl-marketingspot-popup__button--close';
        this.countdownTitleClass = 'fxxl-marketingspot-popup-countdown__title';
        this.counterNumberClass = 'fxxl-marketingspot-popup-countdown__counter-box-number';
        this.counterTitleClass = 'fxxl-marketingspot-popup-countdown__counter-box-title';
        this.countdownContainerClass = 'fxxl-marketingspot-popup-countdown';
        this.countdownContainer = null;
        this.countdownTitle = null;
        this.closeButton = null;
        this.countdownTitleForward = null;
        this.countdownTitleBackward = null;
        this.counterDays = [];
        this.counterHours = [];
        this.counterMinutes = [];
        this.counterSeconds = [];
        this.toStart = 0;
        this.toEnd = 0;
        this.countdownTimer = null;
        this.time = [];
        this.lastTime = [];
        this.hasCountdown = false;
        this.init();
    }

    FxxlSetupMarketingSpots.prototype.init = function init() {
        this.hasCountdown = this.setHasCountdown();
        this.closeButton = this.element.getElementsByClassName(this.closeButtonClass)[0];
        if (this.hasCountdown === true) {
            this.countdownContainer = this.element.getElementsByClassName(this.countdownContainerClass)[0];
            this.countdownTitle = this.element.getElementsByClassName(this.countdownTitleClass)[0];
            this.countdownTitleForward = this.element.getAttribute('data-countdown-title-forward');
            this.countdownTitleBackward = this.element.getAttribute('data-countdown-title-backward');
            this.counterDays.number = this.element.getElementsByClassName(this.counterNumberClass + '--days')[0];
            this.counterDays.title = this.element.getElementsByClassName(this.counterTitleClass + '--days')[0];
            this.counterDays.titleText = this.counterDays.title.getAttribute('data-title');
            this.counterDays.titleTextPlural = this.counterDays.title.getAttribute('data-title-plural');
            this.counterHours.number = this.element.getElementsByClassName(this.counterNumberClass + '--hours')[0];
            this.counterHours.title = this.element.getElementsByClassName(this.counterTitleClass + '--hours')[0];
            this.counterHours.titleText = this.counterHours.title.getAttribute('data-title');
            this.counterHours.titleTextPlural = this.counterHours.title.getAttribute('data-title-plural');
            this.counterMinutes.number = this.element.getElementsByClassName(this.counterNumberClass + '--minutes')[0];
            this.counterMinutes.title = this.element.getElementsByClassName(this.counterTitleClass + '--minutes')[0];
            this.counterMinutes.titleText = this.counterMinutes.title.getAttribute('data-title');
            this.counterMinutes.titleTextPlural = this.counterMinutes.title.getAttribute('data-title-plural');
            this.counterSeconds.number = this.element.getElementsByClassName(this.counterNumberClass + '--seconds')[0];
            this.counterSeconds.title = this.element.getElementsByClassName(this.counterTitleClass + '--seconds')[0];
            this.counterSeconds.titleText = this.counterSeconds.title.getAttribute('data-title');
            this.counterSeconds.titleTextPlural = this.counterSeconds.title.getAttribute('data-title-plural');
        }
        this.setup();
    };

    FxxlSetupMarketingSpots.prototype.setHasCountdown = function setHasCountdown() {
        return this.element.className.indexOf(this.containerCountdownClass) !== -1;
    };

    FxxlSetupMarketingSpots.prototype.setup = function setup() {
        if (this.hasCountdown === true) {
            this.countdownSetup();
            this.showCountdown();
        }
        this.events();
    };

    FxxlSetupMarketingSpots.prototype.countdownSetup = function setup() {
        var __this = this;
        this.toStart = this.element.getAttribute('data-to-start');
        this.toEnd = this.element.getAttribute('data-to-end');
        this.startCountdown();
        this.setCountdownTitle();

        this.countdownTimer = setInterval(function () {
            __this.startCountdown();
            __this.setCountdownTitle();
        }, 1000);
    };

    FxxlSetupMarketingSpots.prototype.startCountdown = function startCountdown() {
        var distance;

        if (this.toStart > 0) {
            distance = this.toStart;
        } else if (this.toEnd > 0) {
            distance = this.toEnd;
        } else {
            distance = 0;
            clearInterval(this.countdownTimer);
        }

        this.toStart -= 1;
        this.toEnd -= 1;

        this.time.days = Math.floor(distance / (60 * 60 * 24));
        this.time.hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
        this.time.minutes = Math.floor((distance % (60 * 60)) / 60);
        this.time.seconds = Math.floor(distance % 60);
        this.setCountdown();
    };

    FxxlSetupMarketingSpots.prototype.setCountdown = function setCountdown() {
        var title;
        // Days
        if (this.lastTime.days === undefined || this.lastTime.days !== this.time.days) {
            this.lastTime.days = this.time.days;
            this.counterDays.number.innerHTML = ('0' + this.time.days).slice(-2);
            if (this.time.days > 1) {
                this.counterDays.title.innerHTML = this.counterDays.titleTextPlural;
            } else {
                this.counterDays.title.innerHTML = this.counterDays.titleText;
            }
        }
        // Hours
        if (this.lastTime.hours === undefined || this.lastTime.hours !== this.time.hours) {
            this.lastTime.hours = this.time.hours;
            this.counterHours.number.innerHTML = ('0' + this.time.hours).slice(-2);
            if (this.time.hours > 1) {
                this.counterHours.title.innerHTML = this.counterHours.titleTextPlural;
            } else {
                this.counterHours.title.innerHTML = this.counterHours.titleText;
            }
        }
        // Minutes
        if (this.lastTime.minutes === undefined || this.lastTime.minutes !== this.time.minutes) {
            this.lastTime.minutes = this.time.minutes;
            this.counterMinutes.number.innerHTML = ('0' + this.time.minutes).slice(-2);
            if (this.time.minutes > 1) {
                this.counterMinutes.title.innerHTML = this.counterMinutes.titleTextPlural;
            } else {
                this.counterMinutes.title.innerHTML = this.counterMinutes.titleText;
            }
        }
        // Seconds
        this.counterSeconds.number.innerHTML = ('0' + this.time.seconds).slice(-2);
        if (this.time.seconds > 1) {
            title = this.counterSeconds.titleTextPlural;
        } else {
            title = this.counterSeconds.titleText;
        }
        if (this.lastTime.seconds_title === undefined || this.lastTime.seconds_title !== title) {
            this.lastTime.seconds_title = title;
            this.counterSeconds.title.innerHTML = title;
        }
    };

    FxxlSetupMarketingSpots.prototype.setCountdownTitle = function setCountdownTitle() {
        if (this.toStart > 0 && this.countdownTitle.innerHTML !== this.countdownTitleForward) {
            this.countdownTitle.innerHTML = this.countdownTitleForward;
        } else if (this.toStart <= 0 && this.countdownTitle.innerHTML !== this.countdownTitleBackward) {
            this.countdownTitle.innerHTML = this.countdownTitleBackward;
        }
    };

    FxxlSetupMarketingSpots.prototype.showCountdown = function showCountdown() {
        var __this = this;
        setTimeout(function () {
            __this.countdownContainer.style.opacity = '1';
        }, 1000);
    };

    FxxlSetupMarketingSpots.prototype.events = function events() {
        var __this = this,
            closeButton,
            key = 'marketingspot__' + this.element.getAttribute('data-id');

        this.closeButton.addEventListener('click', function () {
            closeButton = this;
            __this.element.style.display = 'none';
            new FxxlStorageWithExpiry(key).set(1, (86400 * 1000)); // 1 Day
        });
    };

    return FxxlSetupMarketingSpots;
}();

function fxxlGetMarketingSpots()
{
    var marketingSpotPlaceholder = $('#fxxl-marketingspot-placeholder'),
        marketingSpotWithCountdown = marketingSpotPlaceholder.find('.fxxl-marketingspot-popup__container--countdown'),
        countDownMarketingSpotId = '',
        tmpMarketingSpot;

    if (marketingSpotPlaceholder.length > 0) {
        if (marketingSpotWithCountdown.length > 0) {
            marketingSpotWithCountdown.each(function () {
                countDownMarketingSpotId += '_' + $(this).data('id');
            });
            if (countDownMarketingSpotId.length > 0) {
                countDownMarketingSpotId = countDownMarketingSpotId.substr(1);
            }
            $.get('/json.php?service=getMarketingSpotTimes&ids=' + countDownMarketingSpotId, function (data) {
                $.each(data, function (index, value) {
                    if (typeof value.c_marketingspot_id === 'string' || typeof value.c_marketingspot_id === 'number') {
                        tmpMarketingSpot = marketingSpotWithCountdown.filter('[data-id="' + value.c_marketingspot_id + '"]');
                        tmpMarketingSpot.attr('data-to-start', value.to_start_unix).attr('data-to-end', value.to_end_unix);
                    }
                });
                fxxlInitMarketingSpots(marketingSpotPlaceholder);
            });
        } else {
            fxxlInitMarketingSpots(marketingSpotPlaceholder);
        }
    }
}

function fxxlInitMarketingSpots(container)
{
    container.find('.fxxl-marketingspot-popup__container').each(function () {
        new FxxlSetupMarketingSpots(this);
    });
}
var skill;
var intervalControlChatContainer = false;
var pollEndpoint = "/json.php?service=getChannels";
var widgetConfig ;

/**
 * Live Chat wird geladen
 */
function addWidgetScript() {
    var script = document.createElement("script");
    script.id = "Microsoft_Omnichannel_LCWidget";
    configWidget();
    var keys = Object.keys(widgetConfig);

    for (var i = 0; i < keys.length; i++) {
        var attr = document.createAttribute(keys[i]);
        attr.value = widgetConfig[keys[i]];
        script.setAttributeNode(attr);
    }
    document.head.appendChild(script);
}

/**
 * Sendet ein Request ans Backend.
 * Der Response enthält die verfügbaren Agent
 *
 * @param channel
 * @returns {boolean}
 */
function pollChatPresence(channel) {
    try {
        $.ajax({
            url: pollEndpoint,
            dataType: 'json',
            success: function(result) {

                if (Array.isArray(result) === false) {
                    loadChatWidget(channel, result);
                }
                canRepeatPollChatPresence(channel);
            }
        });
    } catch (error) {
        return false;
    }
}

$(document).ready(function() {

    var showChat = $('#showChat');
    var isChowChatContainer = sessionStorage.hasOwnProperty('isChowChatContainer');

    /**
     * Prüft ob für die Seite der LiveChat angezeigt werden soll
     */
    if (showChat.length) {
        sessionStorage.setItem('channel', showChat.data('channel'));
        sessionStorage.setItem('dataAppId', showChat.data('appId'));
        sessionStorage.setItem('dataOrgId', showChat.data('orgId'));
        sessionStorage.setItem('dataOrgUrl', showChat.data('orgUrl'));

        pollChatPresence(sessionStorage.getItem('channel'));
    }

    /**
     * Wenn die Seite gewechselt wurde und der Live Chat zuvor geöffnet war soll der Live Chat wieder angezeigt werden
     */
    if (isChowChatContainer) {
        if (sessionStorage.getItem('isChowChatContainer') === 'true') {
            pollChatPresence(sessionStorage.getItem('channel'));
        }
    }
});

function configWidget()
{
    widgetConfig = {
        "src": "https://oc-cdn-public-eur.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js",
        "data-app-id": sessionStorage.getItem('dataAppId'),
        "data-org-id": sessionStorage.getItem('dataOrgId'),
        "data-org-url": sessionStorage.getItem('dataOrgUrl')
    };
}

/**
 * Beim öffnen muss auch der Skill (Warenkorb oder Warengruppe) an AX gesendet werden
 */
window.addEventListener("lcw:ready", function handleLivechatReadyEvent(){
    Microsoft.Omnichannel.LiveChatWidget.SDK.setContextProvider(function() {
        return {'category' : skill };
    });
});

/**
 * Live Chat wird geladen wenn verfügbare Agent online sind
 * und das Widget Script noch nicht geladen wurde
 *
 * @param channel
 * @param result
 */
function loadChatWidget(channel, result)
{
    var availableAgentFor = result.data.availableAgentFor;
    var hasAgents = availableAgentFor.length > 0;

    var script = document.querySelector("#Microsoft_Omnichannel_LCWidget");
    if (script == null && hasAgents && availableAgentFor.indexOf(channel) !== -1) {

        skill = channel;
        addWidgetScript();

    } else {
        var widget = document.querySelector("#oclw-chat");
        if (widget != null) {
            var display = hasAgents ? "" : "none";
            widget.style.display = display;
        }
    }
}

/**
 * Prüft ob die aktuelle Seite für einen neuen poolChatPresence bereit ist.
 * nach erfolgreichen Aufruf von pollChatPresence wird wieder die Funktion canRepeatPollChatPresence
 * somit wird ein Interval erzeugt.
 * @param channel
 */
function canRepeatPollChatPresence(channel)
{
    var showChat = $('#showChat');

    if (showChat.length) {
        window.setTimeout(pollChatPresence, 5000, channel);
    }

    intervalControlChatContainer = window.setInterval(controlChatContainer, 500);
}


/**
 * Überwachen des ChatContainer (aller 0,5 sec)
 * Wenn für die aktuelle Seite kein Chat zurverfügung gestellt werden soll
 * muss der ChatContainer (#chat) entfernt werden.
 */
function controlChatContainer()
{
    if ($('#chatContainer').length) {
         sessionStorage.setItem('isChowChatContainer', true);
    } else {
        sessionStorage.setItem('isChowChatContainer', false);
        var showChat = $('#showChat');
        if (showChat.length === 0) {
            $('#chat').remove();
            clearInterval(intervalControlChatContainer);
        }
    }
}
/**
 * Multiline Truncation
 *
 * Filename: 410_fxxl_multiline_truncation.js
 *
 * @category  Applicas
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 * @copyright 2019 onlinekauf Internet Service GmbH
 */

var FxxlMultilineTruncation = (function FxxlMultilineTruncation() {
    function FxxlMultilineTruncation(element) {
        this.element = element;
        this.init();
    }

    FxxlMultilineTruncation.prototype.init = function init() {

        if (this.element.attr('data-multiline-truncation-done') === 'true') {
            return false;
        }

        var __element = this.element,
            lineNum = __element.data('multiline-truncation'),
            lineHeight = parseInt(__element.css('line-height')),
            clone = this.getClone(),
            thisHeight = clone.height(),
            maxHeight,
            text = clone.text().trim(),
            maxLoop = 100,
            tempCounter = 0,
            step = 3;

        if (typeof __element.data('multiline-truncation-large') === 'number' && isLargeViewport() === true) {
            lineNum = __element.data('multiline-truncation-large');
        }

        maxHeight = lineHeight * lineNum;

        if (thisHeight > maxHeight) {
            do {
                text = text.substring(0, text.length - step);
                clone.text(text);
                tempCounter += 1;
                step = Math.ceil((clone.height() / maxHeight) * 6);
            } while (clone.height() > (maxHeight + 1) && tempCounter < maxLoop);
            text = text.substring(0, text.length - 3) + '...';
            __element.text(text);
        }
        clone.remove();
        __element.attr('data-multiline-truncation-done', 'true');
    };

    FxxlMultilineTruncation.prototype.getClone = function getHeight() {
        var clone = this.element.clone(),
            parentTemp = this.element,
            maxLoop = 100,
            tempCounter = 0;

        clone.appendTo('body');

        do {
            parentTemp = parentTemp.parent();
            tempCounter += 1;
        } while (parentTemp.width() <= 0 && tempCounter < maxLoop);

        clone.css({
            'position': 'absolute',
            'visibility': 'hidden',
            'display': 'block',
            'width': parentTemp.width() + 'px'
        });
        return clone;
    };

    return FxxlMultilineTruncation;
}());
/**
 * Slider / Touch slider
 *
 * Filename: 410_fxxl_touch_slider.js
 *
 * @category  Applicas
 * @package   Slider
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 * @copyright 2019 onlinekauf Internet Service GmbH
 */
var FxxlTouchSlider = (function () {
    'use strict';

    /*jslint browser:true */

    function FxxlTouchSlider(query) {
        this.active = false;
        this.isMoved = false;
        if (typeof query !== 'undefined') {
            this.query = query;
        } else {
            this.query = null;
        }
        this.query = query;
        this.originalElement = null;
        this.mouseEventTarget = null;
        this.element = null;
        this.container = null;
        this.containerWidth = null;
        this.generalUniqId = this.generateId();
        this.containerId = 'fxxl_ts_container_' + this.generalUniqId;
        this.align = 'horizontal'; // or vertical
        this.moveEffect = 'scroll'; // scroll or fade or fullFade
        this.lightBoxMoveEffect = 'scroll'; // scroll or fade or fullFade
        this.isTwoFingersDetected = false;
        this.endlessLoop = false;
        this.isHorizontal = true;
        this.playIsRunning = false;
        this.playTimer = null;
        this.playIndex = null;
        this.isFirstItemCloned = false;
        this.playSpeed = 5000; // ms
        this.clickSpeed = 200;
        this.fadeEffectSpeed = 0.5;
        this.clickAndMoveTolerance = 20;
        this.items = null;
        this.activeScrollingMode = false;
        this.nextIndex = 0;
        this.extraItemClass = '';
        this.extraElementClass = '';
        this.allItems = null;
        this.itemGap = 5;
        this.fullWidthItem = false;
        this.fullItemQuantity = 1;
        this.autoPositionCorrector = false;
        this.autoPositionCorrectorTransitionSpeed = 0.15;
        this.unselectableItem = true;
        this.isTouch = false;
        this.lastMouseX = 0;
        this.mouseWheelTimer = null;
        this.ActiveMouseWheel = true;
        this.mouseMoveList = [];
        this.mousedown = [];
        this.mousedown.time = 0;
        this.mousedown.x = 0;
        this.mousedown.y = 0;
        this.mouseDownEvent = null;
        this.mouseup = [];
        this.mouseup.time = 0;
        this.mouseup.x = 0;
        this.mouseup.y = 0;
        this.lastMouseDirection = null;
        this.lastScrollDirection = false;
        this.isScrollCorrectable = true;
        this.scrollCorrectorTimer = null;
        this.stopScrollAnimate = false;
        this.moveSensitive = 1;
        this.swipeable = true;
        this.direction = 1;
        this.currentXPosition = 0;
        this.currentYPosition = 0;
        this.lastXPosition = 0;
        this.lastYPosition = 0;
        this.lastGotoIndex = 0;
        this.goToAlign = null;
        this.lastGoToAlign = null;
        this.transitionSpeed = 0;
        this.lightBoxTransitionSpeed = 0.2;
        this.effectTransitionSpeed = 0.15;
        this.nextPrevTransitionSpeed = 0.5;
        this.pushActive = false;
        this.minPushSpeed = 1.5;
        this.maxPushSpeed = 4;
        this.pushSpeedBooster = 0.7;
        this.pushAlsNextPrev = false;
        this.lastSpeed = 0;
        this.isPrevActive = true;
        this.prevOffset = 0;
        this.lastItemOffset = 0;
        this.isNextActive = true;
        this.nextOffset = 0;
        this.firstItemOffset = 0;
        this.cubicBezier = 'cubic-bezier(0.6, 0.78, 0.23, 1.29)';
        this.timingLinear = 'linear';
        this.changeTimer = null;
        this.marginLeft = null;
        this.marginRight = null;
        this.marginTop = null;
        this.marginBottom = null;
        this.updateTimer = null;
        this.animationIsRun = false;
        this.joinedLightBox = false;
        this.lightBoxCreated = false;
        this.lightBoxContainer = null;
        this.lightBoxDataClass = null;
        this.lightBoxModalActive = false;
        this.lightBoxModalBackground = null;
        this.CanSetActiveThumbnailClass = true;
        this.isLightBoxGoToActive = true;
        this.lightBoxModalBackgroundId = 'fxxl_ts_light_box_modal_bg_' + this.generalUniqId;
        this.extraLightBoxItemClass = '';
        this.disableLightBoxModal = false;
        this.zoomContainer = null;
        this.zoomItem = null;
        this.zoomScale = 2;
        this.isZoomable = false;
        this.sliderCssClass = 'fxxl-touch-slider';
        this.sliderContainerCssClass = 'fxxl-touch-slider__container';
        this.sliderHorizontalCssClass = 'fxxl-touch-slider--horizontal';
        this.sliderVerticalCssClass = 'fxxl-touch-slider--vertical';
        this.sliderJoinedLightBoxCssClass = 'fxxl-touch-slider--joined-light-box';
        this.sliderScrollModeCssClass = 'fxxl-touch-slider--scroll-mode';
        this.sliderThumbnailLightBoxCssClass = 'fxxl-touch-slider--thumbnails-light-box-modal';
        this.sliderLightBoxContainerCssClass = 'fxxl-touch-slider--light-box-container';
        this.sliderBaseLightBoxCssClass = 'fxxl-touch-slider--base-light-box-modal';
        this.sliderLightBoxBgCssClass = 'fxxl-touch-slider__light-box-modal-bg';
        this.sliderLightBoxBgActiveCssClass = 'fxxl-touch-slider__light-box-modal-bg--active';
        this.sliderLightBoxItemActiveCssClass = 'fxxl-touch-slider__light-box-item';
        this.sliderScrollerContainerCssClass = 'fxxl-touch-slider__scroller-container';
        this.sliderScrollerContainerHorizontalCssClass = 'fxxl-touch-slider__scroller-container--horizontal';
        this.sliderScrollerContainerVerticalCssClass = 'fxxl-touch-slider__scroller-container--vertical';
        this.sliderScrollerContainerAutoSnapCssClass = 'fxxl-touch-slider__scroller-container--autosnap';
        this.sliderScrollerContainerFullHeightCssClass = 'fxxl-touch-slider__scroller-container--fullheight';
        this.sliderScrollerContainerDisableCssClass = 'fxxl-touch-slider__scroller-container--disable';
        this.activeSliderScrollerContainerFull = false;
        this.itemCssClass = 'fxxl-touch-slider__item';
        this.itemMarginCssClass = 'fxxl-touch-slider__item--margin';
        this.itemUnselectableCssClass = 'fxxl-touch-slider__item--unselectable';
        this.itemFullCssClass = 'fxxl-touch-slider__item--full';
        this.itemThumbnailActiveCssClass = 'fxxl-touch-slider__item--active-thumbnails';
        this.itemThumbnailCssClass = 'fxxl-touch-slider__item--thumbnails';
        this.itemFadeCssClass = 'fxxl-touch-slider__item--fade';
        this.itemZoomLayerCssClass = 'fxxl-touch-slider__zoom-layer';
        this.itemZoomLayerActiveCssClass = 'fxxl-touch-slider__zoom-layer--active';
        this.zoomContainerCssClass = 'fxxl-touch-slider__zoom-container';
        this.zoomContainerActiveCssClass = 'fxxl-touch-slider__zoom-container--active';
        this.zoomItemCssClass = 'fxxl-touch-slider__zoom-item';
        this.blankImage = '';
        this.blankImageData = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        this.clickDetected = true;
        this.swapDisableByPinchZoom = false;
        this.swapDisablePinchZoomLimit = 1.2;
        this.pinchZoomIcon = '<div class="fxxl-touch-slider__pinchzoom"><img alt="pinch zoom" src="/custom/module/public/fxxl3/assets/img/icons/pinch_zoom.svg"></div>';
        this.pinchZoomIconShowClass = 'fxxl-touch-slider__pinchzoom--show';
        this.pinchZoomIconElement = null;
        this.pinchZoomIconLifeTime = 3; // Sec
        this.pinchZoomLevel = 0;
        this.validItemContentTypes = ['max-content'];
        // Events
        this.onInit = function onInit() {
            return true;
        };
        this.onChanged = function onChanged() {
            return true;
        };
        this.onMouseDown = function onMouseDown() {
            return true;
        };
        this.onMouseUp = function onMouseUp() {
            return true;
        };
        this.onMouseMoved = function onMouseMoved() {
            return true;
        };
        this.onGoingTo = function onGoingTo(value) {
            return value;
        };
        this.onGoToEnd = function onGoToEnd(value) {
            return value;
        };
        this.onPrev = function onPrev() {
            return true;
        };
        this.onNext = function onNext() {
            return true;
        };
        this.onLightBoxModalShow = function onLightBoxModalShow() {
            return true;
        };
        this.onLightBoxModalCloseStarted = function onLightBoxModalCloseStarted() {
            return true;
        };
        this.onLightBoxModalClosed = function onLightBoxModalClosed() {
            return true;
        };
        this.onLightBoxItemClicked = function onLightBoxItemClicked() {
            return true;
        };
        this.onPlay = function onPlay() {
            return true;
        };
        this.onStop = function onStop() {
            return true;
        };
        this.onZoomLayerClick = function onZoomLayerClick() {
            return true;
        };
        this.onScroll = function onScroll() {
            return true;
        };
    }

    FxxlTouchSlider.prototype.update = function update(lastGoTo) {
        var thisClass = this;
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(function () {
            if (thisClass.fullWidthItem === true) {
                thisClass.setFullWidthItem();
            }
            if (lastGoTo === undefined || lastGoTo !== true) {
                thisClass.goTo(0, 'left');
            } else {
                thisClass.goTo(thisClass.lastGotoIndex, thisClass.lastGotoAlign);
            }
            if (thisClass.joinedLightBox === true) {
                thisClass.checkLightBoxGoToActive();
                thisClass.lightBoxDataClass.update();
            }
        }, 500);
    };

    FxxlTouchSlider.prototype.init = function init() {
        var i, l, classes, classI, classL, itemContentType;

        this.currentXPosition = 0;
        this.currentYPosition = 0;
        this.lastXPosition = 0;
        this.lastYPosition = 0;

        if (this.query instanceof HTMLElement) {
            this.element = this.query;
        } else {
            this.element = document.querySelector(this.query);
        }

        if (this.originalElement === null) {
            this.originalElement = this.element.cloneNode(true);
        } else {
            this.element.innerHTML = this.originalElement.innerHTML;
        }

        if (this.element.id === '') {
            this.elementId = 'fxxl_ts_container_' + this.generalUniqId;
        } else {
            this.elementId = this.element.id;
        }

        if (this.lightBoxContainer !== null) {
            this.joinedLightBox = true;
        }

        this.element.id = this.elementId;
        this.isTouch = this.isTouchDevice();
        this.container = document.createElement('div');
        this.element.classList.add(this.sliderCssClass);
        this.container.id = this.containerId;
        this.container.className = this.sliderContainerCssClass;
        this.container.setAttribute('draggable', 'false');

        // Blank Image
        this.blankImage = document.createElement('img');
        this.blankImage.src = this.blankImageData;
        this.blankImage.style.maxHeight = '100%';
        this.blankImage.alt = 'blank';

        if (this.align === 'horizontal') {
            this.container.classList.add(this.sliderHorizontalCssClass);
            this.isHorizontal = true;
            if (this.goToAlign === null) {
                this.goToAlign = 'left';
                this.lastGoToAlign = 'left';
            }
        } else {
            this.container.classList.add(this.sliderVerticalCssClass);
            this.isHorizontal = false;
            if (this.goToAlign === null) {
                this.goToAlign = 'top';
                this.lastGoToAlign = 'top';
            }
        }

        if (this.extraElementClass !== '') {
            classes = this.extraElementClass.split(' ');
            classL = classes.length - 1;

            for (classI = 0; classI <= classL; classI += 1) {
                this.element.classList.add(classes[classI]);
            }
        }

        // Margin-Left-Element
        if (this.marginLeft !== null) {
            this.addMarginElement('left', this.marginLeft);
        }

        // Margin-Right-Element
        if (this.marginRight !== null) {
            this.addMarginElement('right', this.marginRight);
        }

        // Margin-Top-Element
        if (this.marginTop !== null) {
            this.addMarginElement('top', this.marginTop);
        }

        // Margin-Bottom-Element
        if (this.marginBottom !== null) {
            this.addMarginElement('bottom', this.marginBottom);
        }

        this.items = this.getItems();
        this.allItems = this.element.getElementsByTagName('*');
        l = this.allItems.length - 1;
        for (i = 0; i <= l; i += 1) {
            this.allItems[i].setAttribute('draggable', 'false');
        }

        itemContentType = this.element.getAttribute('data-item-content-type');

        l = this.items.length - 1;
        for (i = 0; i <= l; i += 1) {
            this.items[i].classList.add(this.itemCssClass);

            if (itemContentType !== null && this.validItemContentTypes.includes(itemContentType)) {
                this.items[i].classList.add(this.itemCssClass + '--' + itemContentType);
            }

            if (this.fullWidthItem === true) {
                this.items[i].classList.add(this.itemFullCssClass)
            }
            if (this.extraItemClass !== '') {
                classes = this.extraItemClass.split(' ');
                classL = classes.length - 1;

                for (classI = 0; classI <= classL; classI += 1) {
                    if (classes[classI] !== '') {
                        this.items[i].classList.add(classes[classI]);
                    }
                }
            }
            if (this.unselectableItem === true) {
                this.items[i].classList.add(this.itemUnselectableCssClass);
            }
            if (i !== 0) {
                if (this.isHorizontal === true) {
                    this.items[i].style.marginLeft = this.itemGap + 'px';
                } else {
                    this.items[i].style.marginTop = this.itemGap + 'px';
                }
            }
            if (this.joinedLightBox === true) {
                this.items[i].classList.add(this.itemThumbnailCssClass);
            }
            this.container.appendChild(this.items[i]);
        }

        if (this.fullWidthItem === true) {
            this.setFullWidthItem();
        }

        this.setEvents();
        this.element.appendChild(this.container);
        if (this.joinedLightBox === true) {
            this.element.classList.add(this.sliderJoinedLightBoxCssClass);
            this.setupLightBoxData();
            this.lightBoxCreated = true;
        }

        this.setContainerSize();

        if (this.isTouch !== true) {
            /**
             * Deaktivieret den Scrolling mode, wenn es sich nicht um ein Touchgerät handelt
             */

            this.activeScrollingMode = false;
        }

        if (this.activeScrollingMode === true) {
            this.setupScrollingMode();
        }
        this.onInit();
        this.element.fxxlSlider = this;
    };

    FxxlTouchSlider.prototype.addMarginElement = function addMarginElement(side, value) {
        var marginElement, tempImg, firstItem, valueWithUnit;

        marginElement = document.createElement('div');
        marginElement.setAttribute('draggable', 'false');
        marginElement.classList.add(this.itemCssClass);
        marginElement.classList.add(this.itemMarginCssClass);
        marginElement.classList.add(this.itemUnselectableCssClass);
        tempImg = this.blankImage.cloneNode(false);

        if (typeof value === 'number') {
            valueWithUnit = value + 'px';
        } else {
            valueWithUnit = value;
        }

        if (side === 'left' || side === 'right') {
            tempImg.style.width = valueWithUnit;
        } else {
            tempImg.style.height = valueWithUnit;
        }

        marginElement.appendChild(tempImg);
        if (side === 'left' || side === 'top') {
            firstItem = (this.element.querySelector('#' + this.elementId + '>*:not([data-slider="notItem"]):not([data-slider="lightBoxData"])'));
            this.element.insertBefore(marginElement, firstItem);
        } else {
            this.element.appendChild(marginElement);
        }
    };

    FxxlTouchSlider.prototype.setupScrollingMode = function setupScrollingMode() {
        var thisCLass = this,
            lastActiveIndex,
            setActiveIndexPosTimer = null;
        this.container.classList.add(this.sliderScrollerContainerCssClass);

        if (this.isHorizontal === true) {
            this.container.classList.add(this.sliderScrollerContainerHorizontalCssClass);
        } else {
            this.container.classList.add(this.sliderScrollerContainerVerticalCssClass);
        }

        if (this.activeSliderScrollerContainerFull === true) {
            this.container.classList.add(this.sliderScrollerContainerFullHeightCssClass);
        }

        this.element.classList.add(this.sliderScrollModeCssClass);

        this.updateScrollingMode();

        this.container.addEventListener('scroll', function (e) {
            if (thisCLass.scrollCorrectorTimer !== null) {
                clearTimeout(thisCLass.scrollCorrectorTimer);
            }

            if (setActiveIndexPosTimer !== null) {
                clearTimeout(setActiveIndexPosTimer);
            }

            if (thisCLass.isMoved === false && thisCLass.isScrollCorrectable === true) {
                thisCLass.scrollCorrectorTimer = setTimeout(function () {
                    lastActiveIndex = thisCLass.getActiveIndex(true);
                    thisCLass.isScrollCorrectable = false;
                    thisCLass.onChanged(lastActiveIndex);
                }, 70);
            }
            thisCLass.onScroll(e);
        }, false);
    };

    FxxlTouchSlider.prototype.updateScrollingMode = function updateScrollingMode() {
        if (this.autoPositionCorrector === true) {
            this.container.classList.add(this.sliderScrollerContainerAutoSnapCssClass);
        }
    };

    FxxlTouchSlider.prototype.setContainerSize = function setContainerSize(doAnyway, justReturn) {
        var i,
            l,
            containerWidth = 0,
            isIE = document.querySelector('html.ua-ie11') !== null;

        if ((isIE === true && this.isHorizontal === true) || (doAnyway === true)) {
            l = this.items.length - 1;
            for (i = 0; i <= l; i += 1) {
                containerWidth += this.outerWidth(this.items[i]);
            }
            if (justReturn !== true) {
                this.container.style.minWidth = containerWidth + 'px';
            }
        }
        return containerWidth;
    };

    FxxlTouchSlider.prototype.outerWidth = function outerWidth(el) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
    };

    FxxlTouchSlider.prototype.getItems = function getItems(isContainer) {
        if (isContainer === true) {
            return this.container.querySelectorAll('.' + this.itemCssClass);
        } else {
            return this.element.querySelectorAll('#' + this.elementId + '>*:not([data-slider="notItem"]):not([data-slider="lightBoxData"])');
        }
    };

    FxxlTouchSlider.prototype.setupLightBoxData = function setupLightBoxData() {
        if (this.lightBoxCreated === false) {
            this.lightBoxModalBackground = document.createElement('div');
            this.lightBoxModalBackground.id = this.lightBoxModalBackgroundId;
            this.lightBoxModalBackground.className = this.sliderLightBoxBgCssClass;
            document.body.appendChild(this.lightBoxModalBackground);
            this.lightBoxDataClass = new FxxlTouchSlider(this.lightBoxContainer);
            if (isLargeViewport()) {
                this.lightBoxDataClass.itemGap = 3;
            } else {
                this.lightBoxDataClass.itemGap = 15;
            }
            this.lightBoxDataClass.fullWidthItem = true;
            this.lightBoxDataClass.autoPositionCorrector = true;
            this.lightBoxDataClass.extraElementClass = this.sliderLightBoxContainerCssClass;
            this.lightBoxDataClass.extraItemClass = this.sliderLightBoxItemActiveCssClass + ' ' + this.extraLightBoxItemClass;
            this.lightBoxDataClass.transitionSpeed = this.lightBoxTransitionSpeed;
            this.lightBoxDataClass.ActiveMouseWheel = this.ActiveMouseWheel;
            this.lightBoxDataClass.moveEffect = this.lightBoxMoveEffect;
            this.lightBoxDataClass.pushAlsNextPrev = this.pushAlsNextPrev;
            this.lightBoxDataClass.activeScrollingMode = this.activeScrollingMode;
            this.lightBoxDataClass.activeSliderScrollerContainerFull = this.activeSliderScrollerContainerFull;
            this.lightBoxDataClass.init();
            this.isLightBoxGoToActive = this.checkLightBoxGoToActive();
            this.setActiveThumbnailClass(0);
        } else {
            this.lightBoxDataClass.setFullWidthItem();
        }
        this.setLightBoxEvents();
    };

    FxxlTouchSlider.prototype.checkLightBoxGoToActive = function checkLightBoxGoToActive() {
        var elementWidth = this.lightBoxDataClass.element.getBoundingClientRect().width,
            containerWidth = this.lightBoxDataClass.container.getBoundingClientRect().width;
        if (elementWidth < containerWidth) {
            return true;
        }
        return false;
    };

    FxxlTouchSlider.prototype.setItemClickEvent = function setItemClickEvent(index) {
        var thisClass = this;
        this.items[index].addEventListener('click', function () {
            if (thisClass.isRealClick() === true) {
                if (thisClass.isLightBoxGoToActive === true) {
                    if (index !== thisClass.lastGotoIndex) {
                        thisClass.isLightBoxGoToActive = false;
                        thisClass.goTo(index);
                    }
                }
                thisClass.lightBoxDataClass.goTo(index);
                thisClass.setActiveThumbnailClass(index);
                thisClass.CanSetActiveThumbnailClass = false;
            }
        });

        this.items[index].addEventListener('mousedown', function () {
            thisClass.lightBoxDataClass.isMoved = false;
        });
    };

    FxxlTouchSlider.prototype.setLightBoxItemClickEvent = function setLightBoxItemClickEvent(index) {
        var thisClass = this;
        this.lightBoxDataClass.items[index].addEventListener('click', function () {
            if (thisClass.onLightBoxItemClicked(this) === false) {
                return false;
            }
            if (thisClass.isRealClick() === true) {
                if (thisClass.lightBoxModalActive === false) {
                    thisClass.showLightBoxModal(true);
                }
            }
        });
    };

    FxxlTouchSlider.prototype.setLightBoxEvents = function setLightBoxEvents() {
        var i,
            l,
            thisClass = this;
        l = this.items.length - 1;

        for (i = 0; i <= l; i += 1) {
            this.setItemClickEvent(i);
        }

        l = this.lightBoxDataClass.items.length - 1;
        for (i = 0; i <= l; i += 1) {
            this.setLightBoxItemClickEvent(i);
        }

        this.lightBoxDataClass.onChanged = function onChanged(index) {
            if (index === undefined) {
                index = thisClass.lightBoxDataClass.getActiveIndex(true);
            }
            if (thisClass.isLightBoxGoToActive === true) {
                if (index !== thisClass.lastGotoIndex) {
                    thisClass.goTo(index);
                }
            } else {
                thisClass.isLightBoxGoToActive = true;
            }
            if (thisClass.CanSetActiveThumbnailClass === true) {
                thisClass.setActiveThumbnailClass(index);
            } else {
                thisClass.CanSetActiveThumbnailClass = true;
            }
        };
    };

    FxxlTouchSlider.prototype.showLightBoxModal = function showLightBoxModal(active) {

        if (this.disableLightBoxModal === true) {
            return false;
        }

        this.onLightBoxModalCloseStarted();

        var index = this.lightBoxDataClass.getActiveIndex(),
            temFadeEffectSpeed = this.lightBoxDataClass.fadeEffectSpeed;

        this.lightBoxModalActive = active;
        if (active === true) {
            this.lightBoxModalBackground.classList.add(this.sliderLightBoxBgActiveCssClass);
            this.element.classList.add(this.sliderThumbnailLightBoxCssClass);
            this.lightBoxDataClass.element.classList.add(this.sliderBaseLightBoxCssClass);
            this.element.style.maxWidth = this.container.getBoundingClientRect().width + 'px';
        } else {
            this.lightBoxModalBackground.classList.remove(this.sliderLightBoxBgActiveCssClass);
            this.element.classList.remove(this.sliderThumbnailLightBoxCssClass);
            this.lightBoxDataClass.element.classList.remove(this.sliderBaseLightBoxCssClass);
            this.element.style.maxWidth = '';
        }

        this.lightBoxDataClass.fadeEffectSpeed = 0;
        this.lightBoxDataClass.setFullWidthItem();
        this.lightBoxDataClass.goTo(index, null, '0');
        this.goTo(index, null, '0');
        this.checkLimitedMovement();
        if (active === true) {
            this.onLightBoxModalShow();
        } else {
            this.onLightBoxModalClosed();
        }
        this.lightBoxDataClass.fadeEffectSpeed = temFadeEffectSpeed;
    };

    FxxlTouchSlider.prototype.setActiveThumbnailClass = function setActiveThumbnailClass(index) {
        var i,
            l;

        l = this.items.length - 1;
        for (i = 0; i <= l; i += 1) {
            this.items[i].classList.remove(this.itemThumbnailActiveCssClass);
        }
        this.items[index].classList.add(this.itemThumbnailActiveCssClass);
    };

    FxxlTouchSlider.prototype.setFullWidthItem = function setFullWidthItem() {
        var i,
            l,
            w = this.element.getBoundingClientRect().width,
            newW = 0;

        l = this.items.length - 1;
        for (i = 0; i <= l; i += 1) {
            newW = w / this.fullItemQuantity;
            if (newW > 0) {
                this.items[i].style.width = newW + 'px';
            }
        }
    };

    FxxlTouchSlider.prototype.checkPrevNextActive = function checkPrevNextActive() {
        var containerOffsets = this.container.getBoundingClientRect(),
            elementOffsets = this.element.getBoundingClientRect();

        if (this.isHorizontal === true) {
            if (this.lastXPosition < -10) {
                this.isNextActive = true;
            } else {
                this.isNextActive = false;
            }
            if (this.lastXPosition - 10 > elementOffsets.width - containerOffsets.width) {
                this.isPrevActive = true;
            } else {
                this.isPrevActive = false;
            }
        } else {
            if (this.lastYPosition < -10) {
                this.isNextActive = true;
            } else {
                this.isNextActive = false;
            }
            if (this.lastYPosition - 10 > elementOffsets.height - containerOffsets.height) {
                this.isPrevActive = true;
            } else {
                this.isPrevActive = false;
            }
        }
    };

    FxxlTouchSlider.prototype.prev = function prev(speed, timing) {
        if (this.animationIsRun === true) {
            return false;
        }

        if (timing === undefined || timing === null) {
            timing = this.cubicBezier;
        }

        if (speed === undefined || speed === null) {
            speed = this.nextPrevTransitionSpeed;
        }

        try {
            this.animationIsRun = true;
            this.nextIndex = this.getActiveIndex() + 1;
            var elementOffsets = this.element.getBoundingClientRect(),
                lastItem = this.getLastItem(),
                lastItemOffsets = lastItem.getBoundingClientRect(),
                containerOffsets = this.container.getBoundingClientRect(),
                fixLeft,
                fixTop,
                newX = null,
                newY,
                minX,
                minY,
                thisClass = this,
                scaleValues = this.getScaleValues();

            if (this.isHorizontal === true) {
                fixLeft = elementOffsets.right - lastItemOffsets.left;
                if (lastItem.nextSibling !== null || lastItemOffsets.width > fixLeft) {
                    newX = this.lastXPosition - ((elementOffsets.width - fixLeft) / scaleValues.scaleX);
                    newY = 0;
                    minX = elementOffsets.width - containerOffsets.width;
                    if (newX < minX) {
                        newX = minX;
                    }
                    newX += this.prevOffset;
                    this.currentXPosition = newX;
                    this.lastXPosition = newX;
                }
            } else {
                fixTop = (elementOffsets.bottom - lastItemOffsets.top);
                if (lastItem.nextSibling !== null || lastItemOffsets.height > fixTop) {
                    newY = this.lastYPosition - ((elementOffsets.height - fixTop) / scaleValues.scaleY);
                    newX = 0;
                    minY = elementOffsets.height - containerOffsets.height;
                    if (newY < minY) {
                        newY = minY;
                    }
                    newY += this.prevOffset;
                    this.currentYPosition = newY;
                    this.lastYPosition = newY;
                }
            }

            this.setTransition(speed, timing);
            this.setTranslate(newX, newY);
            setTimeout(function () {
                thisClass.animationIsRun = false;
                thisClass.checkPrevNextActive(thisClass);
                thisClass.onPrev();
            }, (speed) * 1000);
            return true;
        } catch (err) {
            this.animationIsRun = false;
            return false;
        }
    };

    FxxlTouchSlider.prototype.next = function next(speed, timing) {
        if (this.animationIsRun === true) {
            return false;
        }

        if (timing === undefined || timing === null) {
            timing = this.cubicBezier;
        }

        if (speed === undefined || speed === null) {
            speed = this.nextPrevTransitionSpeed;
        }

        try {
            this.animationIsRun = true;
            this.nextIndex = this.getActiveIndex() - 1;
            var elementOffsets = this.element.getBoundingClientRect(),
                firstItem = this.getFirstItem(),
                firstItemOffsets = firstItem.getBoundingClientRect(),
                fixLeft,
                fixTop,
                newX = null,
                newY,
                thisClass = this,
                scaleValues = this.getScaleValues();

            if (this.isHorizontal === true) {
                fixLeft = elementOffsets.left - firstItemOffsets.left;
                if (firstItem.previousSibling !== null || fixLeft > 0) {
                    newX = this.lastXPosition + ((elementOffsets.width - (firstItemOffsets.width - fixLeft)) / scaleValues.scaleX);
                    newY = 0;
                    if (newX > 0) {
                        newX = 0;
                    }
                    newX += this.nextOffset;
                    this.currentXPosition = newX;
                    this.lastXPosition = newX;
                }
            } else {
                fixTop = Math.abs(elementOffsets.top - firstItemOffsets.top);
                if (firstItem.previousSibling !== null || fixTop > 0) {
                    newY = this.lastYPosition + ((elementOffsets.height - (firstItemOffsets.height - fixTop)) / scaleValues.scaleY);
                    newX = 0;
                    if (newY > 0) {
                        newY = 0;
                    }
                    newY += this.nextOffset;
                    this.currentYPosition = newY;
                    this.lastYPosition = newY;
                }
            }
            this.setTransition(speed, timing);
            this.setTranslate(newX, newY);
            setTimeout(function () {
                thisClass.animationIsRun = false;
                thisClass.checkPrevNextActive(thisClass);
                thisClass.onNext();
            }, (speed) * 1000);
            return true;
        } catch (err) {
            this.animationIsRun = false;
            return false;
        }
    };

    FxxlTouchSlider.prototype.nextPrevFullScreen = function nextPrevFullScreen(direction, onChangedActive) {
        var nextIndex = this.getActiveIndex() + direction,
            lastMoveEffect = this.moveEffect;

        if (onChangedActive === undefined) {
            onChangedActive = true;
        }

        this.stop();
        if (nextIndex === this.items.length) {
            nextIndex = 0;
        } else if (nextIndex === -1) {
            nextIndex = this.items.length - 1;
        }
        this.moveEffect = 'fade';
        this.goTo(nextIndex, undefined, undefined, onChangedActive);
        this.moveEffect = lastMoveEffect;
    };

    FxxlTouchSlider.prototype.goTo = function goTo(index, align, speedSec, onChangedActive) {
        if (this.getActiveIndex() === index || (index < 0 || index > this.items.length - 1) || typeof this.items[index] !== 'object' || this.isMovable() === false) {
            this.onGoToEnd(index);
            return false;
        }

        if (onChangedActive === undefined) {
            onChangedActive = true;
        }

        if (this.animationIsRun === true) {
            return false;
        }
        if (speedSec === undefined || speedSec === null) {
            speedSec = this.nextPrevTransitionSpeed;
        }
        if (align === undefined || align === null) {
            align = this.goToAlign;
        }

        if (index === this.items.length - 1 && this.isFirstItemCloned === true) {
            this.onGoingTo(0);
        } else {
            this.onGoingTo(index);
        }

        this.animationIsRun = true;
        this.nextIndex = index;

        if (this.isTouch === true) {
            this.stopScrollAnimate = true;
        }

        if (this.activeScrollingMode !== true) {
            return this.goToNormal(index, align, speedSec, onChangedActive);
        } else {
            return this.goToScroll(index, align, speedSec, onChangedActive);
        }
    };

    FxxlTouchSlider.prototype.getScaleValues = function getScaleValues()
    {
        return {'scaleX': this.element.getBoundingClientRect().width / this.element.offsetWidth, 'scaleY': this.element.getBoundingClientRect().height / this.element.offsetHeight};
    };

    FxxlTouchSlider.prototype.goToNormal = function goToNormal(index, align, speedSec, onChangedActive) {
        var itemOffsets = this.items[index].getBoundingClientRect(),
            elementOffsets = this.element.getBoundingClientRect(),
            containerOffsets = this.container.getBoundingClientRect(),
            newX = 0,
            newY = 0,
            thisClass = this,
            scaleValues = this.getScaleValues();

        this.setTransition(speedSec);
        setTimeout(function () {
            thisClass.animationIsRun = false;
            thisClass.onGoToEnd(index);
        }, speedSec * 1000);

        if (this.isHorizontal === true) {
            newY = 0;
            if (align === 'left') {
                newX = ((elementOffsets.left - itemOffsets.left) / scaleValues.scaleX) + this.lastXPosition;
            } else if (align === 'right') {
                newX = ((elementOffsets.right - itemOffsets.right) / scaleValues.scaleX) + this.lastXPosition;
            } else if (align === 'center') {
                newX = (((elementOffsets.width / 2) + elementOffsets.left) -
                    (itemOffsets.left + (itemOffsets.width / 2)) / scaleValues.scaleX) + this.lastXPosition;
            } else {
                return false;
            }
            if (newX > 0) {
                newX = 0;
            } else if (((containerOffsets.right / scaleValues.scaleX) - (this.lastXPosition - newX)) < (elementOffsets.right / scaleValues.scaleX)) {
                newX = this.lastXPosition + ((elementOffsets.right - containerOffsets.right) / scaleValues.scaleX);
            }
        } else {
            newX = 0;
            if (align === 'top') {
                newY = ((elementOffsets.top - itemOffsets.top) / scaleValues.scaleY) + this.lastYPosition;
            } else if (align === 'bottom') {
                newY = ((elementOffsets.bottom - itemOffsets.bottom) / scaleValues.scaleY) + this.lastYPosition;
            } else if (align === 'center') {
                newY = (((elementOffsets.height / 2) + elementOffsets.top) -
                    (itemOffsets.top + (itemOffsets.height / 2)) / scaleValues.scaleY) + this.lastYPosition;
            } else {
                return false;
            }
            if (newY > 0) {
                newY = 0;
            } else if (((containerOffsets.bottom / scaleValues.scaleY) - (this.lastYPosition - newY)) < (elementOffsets.bottom / scaleValues.scaleY)) {
                newY = this.lastYPosition + ((elementOffsets.bottom - containerOffsets.bottom) / scaleValues.scaleY);
            }
        }

        this.setTranslate(newX, newY, onChangedActive);
        this.currentXPosition = newX;
        this.lastXPosition = newX;
        this.currentYPosition = newY;
        this.lastYPosition = newY;
        this.lastGotoIndex = index;
        this.lastGotoAlign = align;
        return true;
    };

    FxxlTouchSlider.prototype.goToScroll = function goToScroll(index, align, speedSec) {
        var itemOffsets = this.items[index].getBoundingClientRect(),
            elementOffsets = this.container.getBoundingClientRect(),
            newX = 0,
            newY = 0,
            thisClass = this;

        if (this.isHorizontal === true) {
            newY = 0;
            if (align === 'left') {
                newX = (elementOffsets.left - itemOffsets.left);
            } else if (align === 'right') {
                newX = (elementOffsets.right - itemOffsets.right);
            } else if (align === 'center') {
                newX = ((elementOffsets.width / 2) + elementOffsets.left) - (itemOffsets.left + (itemOffsets.width / 2));
            } else {
                return false;
            }
        } else {
            newX = 0;
            if (align === 'top') {
                newY = (elementOffsets.top - itemOffsets.top);
            } else if (align === 'bottom') {
                newY = (elementOffsets.bottom - itemOffsets.bottom);
            } else if (align === 'center') {
                newY = ((elementOffsets.height / 2) + elementOffsets.top) -
                    (itemOffsets.top + (itemOffsets.height / 2));
            } else {
                return false;
            }
        }

        this.goToScrollAnimate((newX * -1), (newY * -1), speedSec, function () {
            thisClass.animationIsRun = false;
        });
        return true;
    };

    FxxlTouchSlider.prototype.goToScrollAnimate = function goToScrollAnimate(scrollLeft, scrollTop, speedSec, callBack) {
        var i,
            thisClass = this,
            startLeftScroll = thisClass.container.scrollLeft,
            timeStep,
            direction = 1,
            animateFunc = function (scroll, time) {
                setTimeout(function () {
                    if (thisClass.stopScrollAnimate === true) {
                        thisClass.container.scrollLeft = scroll;
                    }
                }, time);

            },
            stepScroll = function (t, b, c, d) {
                return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
            };


        if (scrollLeft === 0 && scrollTop === 0) {
            callBack();
            return false;
        }

        speedSec *= 1000;
        timeStep = speedSec / 200;

        if (speedSec === 0) {
            animateFunc(startLeftScroll + scrollLeft, 0);
        } else {
            if (scrollLeft < 0) {
                direction = -1;
            }
            for (i = 0; i <= speedSec; i += timeStep) {
                animateFunc(startLeftScroll + (stepScroll(i, 0, Math.abs(scrollLeft), speedSec) * direction), i);
            }
        }

        setTimeout(function () {
            callBack();
        }, speedSec);
    };

    FxxlTouchSlider.prototype.play = function play(speed, align) {
        var thisClass = this,
            playCounter = 0;

        if (this.playIsRunning === true) {
            return false;
        }

        if (align === undefined) {
            align = this.lastGoToAlign;
        }

        if (speed === undefined) {
            speed = this.playSpeed;
        }

        if (this.isTouch === true) {
            this.stopScrollAnimate = true;
        }

        this.playIsRunning = true;
        this.playTimer = setInterval(function () {

            if (thisClass.isMovable() === false) {
                thisClass.stop();
                return false;
            }

            if (thisClass.playIndex === null) {
                thisClass.playIndex = thisClass.getActiveIndex();
                if (thisClass.activeScrollingMode === true) {
                    thisClass.playIndex += 1;
                }
            } else {
                thisClass.playIndex += 1;
            }

            if (thisClass.playIndex > thisClass.items.length - 1) {
                thisClass.playIndex = 0;
                if (thisClass.isFirstItemCloned === true) {
                    thisClass.playIndex += 1;
                    thisClass.removedClonedFirstItem();
                    thisClass.isFirstItemCloned = false;
                    thisClass.goTo(0, null, 0);
                }
            } else if (thisClass.moveEffect === 'scroll'
                && thisClass.playIndex === thisClass.items.length - 1
                && thisClass.isFirstItemCloned === false
                && thisClass.endlessLoop === true) {
                thisClass.appendClonedFirstItem();
                thisClass.isFirstItemCloned = true;
            }

            if (playCounter === 0 && thisClass.playIndex === 0) {
                thisClass.playIndex = 1;
            }

            setTimeout(function () {
                thisClass.goTo(thisClass.playIndex, align);
                thisClass.onPlay();
                playCounter += 1;
            }, 10);
        }, speed);
    };

    FxxlTouchSlider.prototype.appendClonedFirstItem = function appendClonedFirstItem() {
        this.container.appendChild(this.items[0].cloneNode(true));
        this.items = this.getItems(true);
        this.container.style.minWidth = '';
    };

    FxxlTouchSlider.prototype.removedClonedFirstItem = function removedClonedFirstItem() {
        var item = this.items[this.items.length - 1];
        item.parentNode.removeChild(item);
        this.items = this.getItems(true);
    };

    FxxlTouchSlider.prototype.stop = function stop() {
        if (this.playIsRunning === false) {
            return false;
        }

        if (this.isTouch === true) {
            this.stopScrollAnimate = false;
        }

        this.playIsRunning = false;
        clearInterval(this.playTimer);

        if (this.isFirstItemCloned === true) {
            if (this.getActiveIndex() === this.items.length - 1) {
                this.goTo(0, null, 0);
            }
            this.removedClonedFirstItem();
            this.isFirstItemCloned = false;
        }

        this.onStop();
    };

    FxxlTouchSlider.prototype.getActiveIndex = function getActiveIndex(getWithTolerance, reverse) {
        var elementOffsets = this.element.getBoundingClientRect(),
            selectedWithTolerance = {},
            calculatedValue,
            itemOffsets,
            activeIndex = null,
            i,
            l = this.items.length - 1;

        if (typeof reverse === 'undefined') {
            reverse = false;
        }

        for (i = 0; i <= l; i += 1) {
            itemOffsets = this.items[i].getBoundingClientRect();
            if (this.isHorizontal === true) {
               if (reverse === false) {
                   if ((itemOffsets.left - this.itemGap - 10) < elementOffsets.left && (itemOffsets.left + this.itemGap + 10) > elementOffsets.left) {
                       activeIndex = i;
                       break;
                   }
               } else {
                   if ((itemOffsets.right - this.itemGap - 10) < elementOffsets.right && (itemOffsets.right + this.itemGap + 10) > elementOffsets.right) {
                       activeIndex = i;
                       break;
                   }
               }
            } else {
                if ((itemOffsets.top - this.itemGap - 10) < elementOffsets.top && (itemOffsets.top + this.itemGap + 10) > elementOffsets.top) {
                    activeIndex = i;
                    break;
                }
            }
        }

        if (getWithTolerance === true && activeIndex === null) {
            selectedWithTolerance.value = 1000000;
            for (i = 0; i <= l; i += 1) {
                itemOffsets = this.items[i].getBoundingClientRect();
                if (this.isHorizontal === true) {
                    if (reverse === false) {
                        calculatedValue = Math.abs(itemOffsets.left - elementOffsets.left);
                    } else {
                        calculatedValue = Math.abs(itemOffsets.right - elementOffsets.right);
                    }
                } else {
                    calculatedValue = Math.abs(itemOffsets.top - elementOffsets.top);
                }
                if (calculatedValue < selectedWithTolerance.value) {
                    selectedWithTolerance.value = calculatedValue;
                    selectedWithTolerance.index = i;
                }
            }
            activeIndex = selectedWithTolerance.index;
        }

        if (activeIndex > l - 1 && this.isFirstItemCloned === true) {
            activeIndex = 0;
        }

        return activeIndex;
    };

    FxxlTouchSlider.prototype.getFirstItem = function getFirstItem() {
        var elementOffsets = this.element.getBoundingClientRect(),
            itemOffsets,
            firstElement = null,
            i,
            l = this.items.length - 1;

        for (i = 0; i <= l; i += 1) {
            itemOffsets = this.items[i].getBoundingClientRect();
            if (this.isHorizontal === true) {
                if (itemOffsets.left < elementOffsets.left && itemOffsets.right > elementOffsets.left) {
                    firstElement = this.getFixedFirstItem(i);
                } else if (itemOffsets.right + (this.itemGap + 10) > elementOffsets.left && itemOffsets.left < elementOffsets.left) {
                    firstElement = this.getFixedFirstItem(i);
                }
            } else {
                if (itemOffsets.top < elementOffsets.top && itemOffsets.bottom > elementOffsets.top) {
                    firstElement = this.getFixedFirstItem(i);
                } else if (itemOffsets.top - (this.itemGap + 10) < elementOffsets.top && itemOffsets.bottom > elementOffsets.top) {
                    firstElement = this.getFixedFirstItem(i);
                }
            }
        }
        return firstElement;
    };

    FxxlTouchSlider.prototype.getFixedFirstItem = function getFixedFirstItem(index) {
        var newIndex = index + this.firstItemOffset, firstItem;
        if (typeof this.items[newIndex] !== 'undefined') {
            firstItem = this.items[newIndex];
        } else {
            firstItem = this.items[index];
        }
        return firstItem;
    };

    FxxlTouchSlider.prototype.getLastItem = function getLastItem() {
        var elementOffsets = this.element.getBoundingClientRect(),
            itemOffsets,
            lastElement = null,
            i,
            l = this.items.length - 1;

        for (i = 0; i <= l; i += 1) {
            itemOffsets = this.items[i].getBoundingClientRect();
            if (this.isHorizontal === true) {
                if (itemOffsets.left < elementOffsets.right && itemOffsets.right > elementOffsets.right) {
                    lastElement = this.getFixedLastItem(i);
                } else if (itemOffsets.left - (this.itemGap + 10) < elementOffsets.right && itemOffsets.right > elementOffsets.right) {
                    lastElement = this.getFixedLastItem(i);
                }
            } else {
                if (itemOffsets.bottom > elementOffsets.bottom && itemOffsets.top < elementOffsets.bottom) {
                    lastElement = this.getFixedLastItem(i);
                } else if (itemOffsets.bottom + (this.itemGap + 10) > elementOffsets.bottom && itemOffsets.top < elementOffsets.bottom) {
                    lastElement = this.getFixedLastItem(i);
                }
            }
        }
        return lastElement;
    };

    FxxlTouchSlider.prototype.getFixedLastItem = function getFixedLastItem(index) {
        var newIndex = index - this.lastItemOffset, lastItem;
        if (typeof this.items[newIndex] !== 'undefined') {
            lastItem = this.items[newIndex];
        } else {
            lastItem = this.items[index];
        }
        return lastItem;
    };

    FxxlTouchSlider.prototype.hasClass = function hasClass(elem, cls) {
        var str = ' ' + elem.className + ' ',
            testCls = ' ' + cls + ' ';
        return (str.indexOf(testCls) !== -1);
    };

    FxxlTouchSlider.prototype.generateId = function generateId() {
        return '_' + Math.random().toString(36).substr(2, 9);
    };

    FxxlTouchSlider.prototype.setTransition = function setTransition(speed, timing) {
        if (speed === 0) {
            this.container.style.transition = 'none';
        } else {
            if (timing === undefined) {
                timing = 'ease-out';
            }
            this.container.style.transition = 'transform ' + speed + 's ' + timing;
        }
        this.lastSpeed = speed;
    };

    FxxlTouchSlider.prototype.setTranslate = function setTranslate(x, y, onChangedActive) {
        var elementOffsets = this.element.getBoundingClientRect(),
            containerOffsets = this.container.getBoundingClientRect(),
            diff;

        if (this.activeScrollingMode === true) {
            this.setScroll(x, y);
            return true;
        }

        if (onChangedActive === undefined) {
            onChangedActive = true;
        }

        if (this.isHorizontal === true && this.animationIsRun === false) {
            if (x > 10) {
                x /= Math.sqrt(x) / 3;
            } else if (Math.abs(x) + elementOffsets.width > containerOffsets.width) {
                diff = Math.abs(x) + elementOffsets.width - containerOffsets.width;
                if (diff > 10) {
                    x += diff - (diff / (Math.sqrt(diff) / 3));
                }
            }
        } else {
            if (y > 10) {
                y /= Math.sqrt(y) / 3;
            } else if (containerOffsets.height - Math.abs(y) < elementOffsets.height) {
                diff = elementOffsets.height - (containerOffsets.height - Math.abs(y));
                if (diff > 10) {
                    y += diff - (diff / (Math.sqrt(diff) / 3));
                }
            }
        }

        if (this.isHorizontal === true) {
            y = 0;
        } else {
            x = 0;
        }

        if (this.moveEffect === 'scroll') {
            this.scrollEffect(x, y, onChangedActive);
        } else if ((this.moveEffect === 'fade' || this.moveEffect === 'fullFade') && this.animationIsRun === true) {
            this.fadeEffect(x, y, onChangedActive);
        } else {
            this.scrollEffect(x, y, onChangedActive);
        }
    };

    FxxlTouchSlider.prototype.setScroll = function setScroll(x, y) {

        this.container.scrollLeft = x * -1;
        this.container.scrollTop = y * -1;
    };

    FxxlTouchSlider.prototype.scrollEffect = function scrollEffect(x, y, onChangedActive) {
        var thisClass = this,
            currentIndex;

        if (onChangedActive === undefined) {
            onChangedActive = true;
        }

        this.container.style.transform = 'translate3d(' + x + 'px,' + y + 'px, 0)';
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(function () {
            thisClass.checkPrevNextActive();
            currentIndex = thisClass.getActiveIndex();
            if (currentIndex !== null || thisClass.fullWidthItem !== true) {
                if (onChangedActive === true) {
                    thisClass.onChanged(currentIndex);
                }
            }
        }, (this.lastSpeed * 1000) + 200);
    };

    FxxlTouchSlider.prototype.fadeEffect = function fadeEffect(x, y, onChangedActive) {
        var thisClass = this,
            nextItem,
            leftFix,
            i,
            l,
            tempItems;

        if (onChangedActive === undefined) {
            onChangedActive = true;
        }

        if (this.nextIndex === 0) {
            leftFix = 0;
        } else {
            leftFix = this.itemGap;
        }
        this.container.style.transition = 'opacity ' + this.fadeEffectSpeed + 's';
        this.container.style.opacity = 0;
        nextItem = this.items[this.nextIndex].cloneNode(true);
        nextItem.style.position = 'absolute';
        nextItem.style.top = this.container.getBoundingClientRect().top - this.element.getBoundingClientRect().top + 'px';
        nextItem.style.left = ((leftFix) * -1) + 'px';
        nextItem.style.opacity = 0;
        nextItem.style.transition = 'opacity ' + this.fadeEffectSpeed + 's';
        nextItem.setAttribute('data-temp-element', 'true');
        nextItem.classList.add(this.itemFadeCssClass);

        if (this.moveEffect !== 'fade') {
            nextItem.style.display = 'none';
        }

        this.element.appendChild(nextItem);

        setTimeout(function () {
            nextItem.style.opacity = 1;
        }, 10);

        setTimeout(function () {
            var currentIndex;

            thisClass.container.style.transform = 'translate3d(' + x + 'px,' + y + 'px, 0)';
            thisClass.container.style.opacity = 1;

            //clearTimeout(thisClass.changeTimer);
            thisClass.changeTimer = setTimeout(function () {
                thisClass.removeFadeContent();

                thisClass.checkPrevNextActive();
                currentIndex = thisClass.getActiveIndex();
                if (thisClass.getActiveIndex() !== null || thisClass.fullWidthItem !== true) {
                    if (onChangedActive === true) {
                        thisClass.onChanged(currentIndex);
                    }
                }
            }, (thisClass.fadeEffectSpeed * 1000) + 200);
        }, this.fadeEffectSpeed * 1000);
    };

    FxxlTouchSlider.prototype.removeFadeContent = function removeFadeContent() {
        var thisClass = this,
            tempItems = thisClass.element.querySelectorAll('[data-temp-element="true"]'),
            i,
            l = tempItems.length - 1;

        for (i = 0; i <= l; i += 1) {
            if (tempItems[0].parentNode !== null) {
                tempItems[0].parentNode.removeChild(tempItems[0]);
            }
        }
    };

    FxxlTouchSlider.prototype.doAutoPositionCorrector = function doAutoPositionCorrector() {
        var elementOffsets = this.element.getBoundingClientRect(),
            firstItem = this.getFirstItem(),
            firstItemOffsets,
            newX = 0,
            newY = 0;

        if (firstItem !== null) {
            firstItemOffsets = firstItem.getBoundingClientRect();

            if (this.isHorizontal === true) {
                if (Math.abs(this.mousedown.x - this.mouseup.x) < this.itemGap) {
                    return false;
                }
                if (elementOffsets.left - firstItemOffsets.left < (firstItemOffsets.width / 2)) {
                    newX = this.lastXPosition + (elementOffsets.left - firstItemOffsets.left);
                } else {
                    newX = this.lastXPosition -
                        (firstItemOffsets.width - (elementOffsets.left - firstItemOffsets.left)) - this.itemGap;
                }
            } else {
                if (Math.abs(this.mousedown.y - this.mouseup.y) < this.itemGap) {
                    return false;
                }
                if (elementOffsets.top - firstItemOffsets.top < (firstItemOffsets.height / 2)) {
                    newY = this.lastYPosition + (elementOffsets.top - firstItemOffsets.top);
                } else {
                    newY = this.lastYPosition -
                        (firstItemOffsets.height - (elementOffsets.top - firstItemOffsets.top)) - this.itemGap;
                }
            }
            this.lastXPosition = newX;
            this.lastYPosition = newY;
            this.setTransition(this.autoPositionCorrectorTransitionSpeed, 'linear');
            this.setTranslate(newX, newY);
        }
    };

    FxxlTouchSlider.prototype.isRealClick = function isRealClick() {
        var acceptableMove = ((Math.abs(this.mousedown.x - this.mouseup.x) > this.clickAndMoveTolerance && this.isHorizontal === true)
            || (Math.abs(this.mousedown.y - this.mouseup.y) > this.clickAndMoveTolerance && this.isHorizontal === false)),
            lightBoxAcceptableMove;

        this.clickDetected = true;

        if (this.mouseup.time - this.mousedown.time > this.clickSpeed) {
            this.clickDetected = false;
        } else if ((this.isMoved === true && acceptableMove === true) || (this.isMoved === true && this.activeScrollingMode === true)) {
            this.clickDetected = false;
        } else if (this.lightBoxDataClass !== null) {
            lightBoxAcceptableMove = ((Math.abs(this.lightBoxDataClass.mousedown.x - this.lightBoxDataClass.mouseup.x) > this.clickAndMoveTolerance && this.lightBoxDataClass.isHorizontal === true)
                || (Math.abs(this.lightBoxDataClass.mousedown.y - this.lightBoxDataClass.mouseup.y) > this.clickAndMoveTolerance && this.lightBoxDataClass.isHorizontal === false));

            if (this.lightBoxDataClass.isMoved === true && lightBoxAcceptableMove === true) {
                this.clickDetected = false;
            }
        }
        return this.clickDetected;
    };

    FxxlTouchSlider.prototype.ignoreElement = function ignoreElement(element) {
        var result = false;
        if (element.tagName === 'INPUT') {
            result = true;
        }
        return result;
    };

    FxxlTouchSlider.prototype.setEvents = function setEvents() {

        var thisClass = this,
            selectedMouseEventTarget,
            touchEndTimer = null;

        if (this.mouseEventTarget instanceof HTMLElement === false) {
            selectedMouseEventTarget = this.container;
        } else {
            selectedMouseEventTarget = this.mouseEventTarget;
        }

        if (this.isTouch !== true) {
            selectedMouseEventTarget.addEventListener('click', function (e) {
                if (thisClass.isTouch === false || (thisClass.isTouch === true && thisClass.isTwoFingersDetected === false)) {
                    if (e.target.classList.contains(thisClass.itemZoomLayerActiveCssClass) === true) {
                        thisClass.onZoomLayerClick(e.target.elementIndex);
                        e.preventDefault();
                    }
                    if (thisClass.isRealClick() === false) {
                        e.preventDefault();
                    }
                }
            });

            selectedMouseEventTarget.addEventListener('mousedown', function (e) {
                if (thisClass.ignoreElement(e.target) === false) {
                    thisClass.mouseDown(e);
                    e.preventDefault();
                }
            });

            document.addEventListener('mouseup', function (e) {
                var active = thisClass.active;
                if (thisClass.ignoreElement(e.target) === false) {
                    thisClass.mouseUp(e);
                    if (active === true) {
                        e.preventDefault();
                    }
                }
            });

            document.addEventListener('mousemove', function (e) {
                var active = thisClass.active;
                thisClass.mouseMove(e);
                if (active === true) {
                    e.preventDefault();
                }
            });

            this.element.addEventListener('mousemove', function (e) {
                if (e.target.classList.contains(thisClass.itemZoomLayerActiveCssClass) === true
                    && thisClass.zoomContainer !== null) {
                    thisClass.setZoomPositions(e);
                }
            });

            this.element.addEventListener('wheel', function (e) {
                if (thisClass.ActiveMouseWheel === true) {
                    if (thisClass.isMovable() === true) {
                        thisClass.mouseWheel(e);
                        e.preventDefault();
                    }
                }
            });
        } else {
            selectedMouseEventTarget.addEventListener('touchstart', function (e) {
                if (touchEndTimer !== null) {
                    clearTimeout(touchEndTimer);
                    touchEndTimer = null;
                }

                if (e.touches.length > 1) {
                    thisClass.isTwoFingersDetected = true;
                }

                if (thisClass.ignoreElement(e.touches[0].target) === false && thisClass.isTwoFingersDetected === false) {
                    thisClass.mouseDown(e.touches[0]);
                }
            });

            selectedMouseEventTarget.addEventListener('touchend', function (e) {
                if (thisClass.isTwoFingersDetected === false) {
                    thisClass.mouseUp(e.changedTouches[e.changedTouches.length - 1]);
                } else {
                    touchEndTimer = setTimeout(function () {
                        if (e.touches.length === 0) {
                            thisClass.isTwoFingersDetected = false;
                            thisClass.mouseUpSetVars();
                        }
                    }, 500);
                }
            });

            selectedMouseEventTarget.addEventListener('touchmove', function (e) {
                if (thisClass.isTwoFingersDetected === false) {
                    if (thisClass.activeScrollingMode === true && thisClass.swapDisableByPinchZoom === true) {
                        if (fxxlVisualViewportScale > thisClass.swapDisablePinchZoomLimit) {
                            thisClass.container.classList.add(thisClass.sliderScrollerContainerDisableCssClass)
                        } else {
                            thisClass.container.classList.remove(thisClass.sliderScrollerContainerDisableCssClass)
                        }
                    } else if (thisClass.getMouseDirection(e.touches[0]) === true && thisClass.activeScrollingMode !== true
                        && e.touches.length === 1 && (thisClass.swapDisableByPinchZoom !== true || fxxlVisualViewportScale < 1.2)) {
                        thisClass.mouseMove(e.touches[0]);
                        e.preventDefault();
                    }
                }
            });
        }

        /**
         * IE Fix
         */
        window.addEventListener('load', function () {
            setTimeout(function () {
                thisClass.setContainerSize();
            }, 500);
        });
    };

    FxxlTouchSlider.prototype.getMouseDirection = function getMouseDirection(e) {
        if (this.lastMouseDirection !== null) {
            return this.lastMouseDirection;
        } else {
            var deltaX, deltaY;
            deltaX = Math.abs(this.mousedown.x - e.pageX);
            deltaY = Math.abs(this.mousedown.y - e.pageY);
            if (this.isHorizontal === true) {
                this.lastMouseDirection = deltaX > deltaY;
            } else {
                this.lastMouseDirection = deltaY > deltaX;
            }
        }
        return this.lastMouseDirection;
    };

    FxxlTouchSlider.prototype.mouseWheel = function mouseWheel(e) {
        if (this.animationIsRun === true) {
            return false;
        }
        var thisClass = this;
        if (e.deltaY < 0) {
            this.next();
        } else {
            this.prev();
        }
        clearTimeout(this.mouseWheelTimer);
        this.mouseWheelTimer = setTimeout(function () {
            thisClass.checkLimitedMovement();
        }, this.transitionSpeed * 1000);
    };

    FxxlTouchSlider.prototype.mouseDown = function mouseDown(e) {
        if (e.target.tagName === 'INPUT') {
            return false;
        }
        if (this.isTouch !== true) {
            e = e || window.event;
            if (e.which !== 1) {
                return false;
            }
        }

        this.removeFadeContent();
        this.onMouseDown();
        this.lastScrollDirection = null;
        this.isScrollCorrectable = true;
        this.stopScrollAnimate = false;
        this.active = true;
        this.isMoved = false;
        this.pushActive = false;
        this.mouseMoveList = [];
        this.mousedown.time = new Date();
        this.mouseDownEvent = e;
        this.mousedown.x = e.pageX;
        this.mousedown.y = e.pageY;
        this.setTransition(this.transitionSpeed);
    };

    FxxlTouchSlider.prototype.mouseUpSetVars = function mouseUpSetVars() {
        this.playIndex = null;
        this.lastMouseDirection = null;
        this.stopScrollAnimate = true;
        this.onMouseUp();
        this.active = false;
        this.mouseup.time = new Date();
    };

    FxxlTouchSlider.prototype.mouseUp = function mouseUp(e) {
        var thisClass = this,
            overLimit,
            fastPushDetectSpeed;

        if (this.active === true) {
            this.mouseUpSetVars();
            this.mouseup.x = e.pageX;
            this.mouseup.y = e.pageY;

            fastPushDetectSpeed = (this.transitionSpeed * 1000) + 50;

            if (this.isRealClick() === false && this.swipeable === true) {
                this.lastXPosition = this.currentXPosition;
                this.lastYPosition = this.currentYPosition;

                setTimeout(function () {
                    overLimit = thisClass.checkLimitedMovement();
                    if (overLimit === false) {
                        thisClass.detectFastPush();
                    }
                }, fastPushDetectSpeed);
            }
        }
    };

    FxxlTouchSlider.prototype.mouseMove = function mouseMove(e) {
        if (this.active === true && this.swipeable === true) {
            this.stop();
            this.onMouseMoved();
            this.isMoved = true;
            if (this.activeScrollingMode !== true) {
                this.moveAnalyse(e);
            }
        }
    };

    FxxlTouchSlider.prototype.isTouchDevice = function isTouchDevice() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    };

    FxxlTouchSlider.prototype.isMovable = function isMovable() {
        if (this.isHorizontal === true) {
            if (this.activeScrollingMode !== true) {
                return this.element.getBoundingClientRect().width < this.container.getBoundingClientRect().width;
            } else {
                if (this.containerWidth === null) {
                    this.containerWidth = this.setContainerSize(true, true);
                }
                return this.element.getBoundingClientRect().width < this.containerWidth;
            }

        } else {
            return this.element.getBoundingClientRect().height < this.container.getBoundingClientRect().height;
        }
    };

    FxxlTouchSlider.prototype.moveAnalyse = function moveAnalyse(e) {
        if (this.isMovable() === false) {
            return false;
        }

        var a, b, changed = false;

        this.mouseMoveList.push({date: new Date().getTime(), x: e.pageX, y: e.pageY});

        if (this.isHorizontal === true) {
            a = Math.round((e.pageX / this.moveSensitive)) * this.moveSensitive;
            b = Math.round((this.mousedown.x / this.moveSensitive)) * this.moveSensitive;
            if (this.lastMouseX === 0) {
                this.lastMouseX = b;
            }
            if (a !== this.lastMouseX) {
                this.lastMouseX = a;
                changed = true;
            }
        } else {
            a = Math.round((e.pageY / this.moveSensitive)) * this.moveSensitive;
            b = Math.round((this.mousedown.y / this.moveSensitive)) * this.moveSensitive;
            if (this.lastMouseY === 0) {
                this.lastMouseY = b;
            }
            if (a !== this.lastMouseY) {
                this.lastMouseY = a;
                changed = true;
            }
        }

        if (changed === true) {
            this.doMove(e.pageX, e.pageY, this.direction);
        }
    };

    FxxlTouchSlider.prototype.doMove = function doMove(x, y, direction) {
        var elementOffsets = this.element.getBoundingClientRect(),
            containerOffsets = this.container.getBoundingClientRect();

        if (containerOffsets.width < elementOffsets.width && this.isHorizontal === true) {
            return false;
        }

        if (this.isHorizontal === true) {
            this.currentXPosition = ((x - this.mousedown.x) * direction);
            this.currentXPosition += this.lastXPosition;
            this.setTranslate(this.currentXPosition, 0);
        } else {
            this.currentYPosition = ((y - this.mousedown.y) * direction);
            this.currentYPosition += this.lastYPosition;
            this.setTranslate(0, this.currentYPosition);
        }
    };

    FxxlTouchSlider.prototype.speedCalculator = function speedCalculator(deltaValue, deltaTime) {
        var speed = Math.abs(deltaValue / deltaTime);
        speed *= this.pushSpeedBooster;
        if (this.mouseup.time - this.mousedown.time < 300) {
            if (speed < this.minPushSpeed) {
                speed = this.minPushSpeed;
            }
        }
        if (speed > this.maxPushSpeed) {
            speed = this.maxPushSpeed;
        }
        return speed;
    };

    FxxlTouchSlider.prototype.setPushAnimation = function setPushAnimation(speed, direction) {
        var thisClass = this,
            timerSpeed = 41,
            moveStep = 10,
            value,
            overLimitTolerance = 10,
            elementOffsets = this.element.getBoundingClientRect(),
            containerOffsets = this.container.getBoundingClientRect(),
            overLimit = false;

        if (containerOffsets.left > overLimitTolerance || (containerOffsets.right + overLimitTolerance) < elementOffsets.right) {
            overLimit = true;
        }

        setTimeout(function () {
            if (overLimit === false && speed > 0 && thisClass.pushActive === true) {
                thisClass.setPushAnimation(speed - 0.1, direction);
            } else {
                setTimeout(function () {
                    if (thisClass.checkLimitedMovement() === false) {
                        if (thisClass.autoPositionCorrector === true) {
                            thisClass.doAutoPositionCorrector();
                        }
                    }
                }, speed * 0.05 * 1000);
            }

            if (thisClass.pushActive === true) {
                if (direction === true) {
                    value = Math.pow(speed, 2) * (moveStep * -1);
                } else {
                    value = Math.pow(speed, 2) * moveStep;
                }

                if (thisClass.isHorizontal === true) {
                    if (isNaN(value) === false) {
                        thisClass.lastXPosition += value;
                        thisClass.setTranslate(thisClass.lastXPosition, 0);
                    }
                } else {
                    if (isNaN(value) === false) {
                        thisClass.lastYPosition += value;
                        thisClass.setTranslate(0, thisClass.lastYPosition);
                    }
                }
            }

        }, timerSpeed);
    };

    FxxlTouchSlider.prototype.getMoveInfo = function getMoveInfo() {
        var i,
            l = this.mouseMoveList.length - 1,
            output = [];

        output.firstTime = null;
        output.lastTime = null;
        output.firstX = null;
        output.firstY = null;
        output.lastX = null;
        output.lastY = null;

        for (i = l; i >= 0; i -= 1) {
            if (output.lastX === null) {
                output.lastX = this.mouseMoveList[i].x;
                output.lastY = this.mouseMoveList[i].y;
                output.lastTime = this.mouseMoveList[i].date;
            }

            if (i < l) {
                if (output.firstTime === null) {
                    output.firstTime = this.mouseMoveList[i + 1].date;
                    output.firstX = this.mouseMoveList[i + 1].x;
                    output.firstY = this.mouseMoveList[i + 1].y;
                } else if (output.firstTime - this.mouseMoveList[i].date < 50) {
                    output.firstTime = this.mouseMoveList[i + 1].date;
                    output.firstX = this.mouseMoveList[i + 1].x;
                    output.firstY = this.mouseMoveList[i + 1].y;
                }
            }
        }
        return output;
    };

    FxxlTouchSlider.prototype.detectFastPush = function detectFastPush() {
        if (this.activeScrollingMode === true) {
            return false;
        }
        var moveInfo = this.getMoveInfo(),
            deltaX = moveInfo.lastX - moveInfo.firstX,
            deltaY = moveInfo.lastY - moveInfo.firstY,
            deltaTime = moveInfo.lastTime - moveInfo.firstTime,
            speed,
            direction,
            goPrevNextSpeed;

        if (this.isHorizontal === true) {
            direction = this.mouseup.x < this.mousedown.x;
            speed = this.speedCalculator(deltaX, deltaTime);

        } else {
            direction = this.mouseup.y < this.mousedown.y;
            speed = this.speedCalculator(deltaY, deltaTime);
        }

        if (this.isTouch === true) {
            goPrevNextSpeed = 0.3 - (speed / 10);
            if (goPrevNextSpeed < 0.1) {
                goPrevNextSpeed = 0.1;
            }
        } else {
            goPrevNextSpeed = null;
        }

        if (speed < 0.1) {
            if (this.autoPositionCorrector === true) {
                this.doAutoPositionCorrector();
            }
            return false;
        }

        this.pushActive = true;
        if (this.pushAlsNextPrev === false) {
            if (speed < this.minPushSpeed) {
                if (this.autoPositionCorrector === true) {
                    this.doAutoPositionCorrector();
                } else {
                    this.setPushAnimation(speed, direction);
                }
            } else {
                this.setPushAnimation(speed, direction);
            }
        } else {
            if (this.isTouch === false || (this.isTouch === true && this.isTwoFingersDetected === false)) {
                if (direction === true) {
                    this.prev(goPrevNextSpeed, this.timingLinear);
                } else {
                    this.next(goPrevNextSpeed, this.timingLinear);
                }
            }
        }
        return true;
    };

    FxxlTouchSlider.prototype.checkLimitedMovement = function checkLimitedMovement() {
        if (this.activeScrollingMode === true) {
            return false;
        }
        var elementOffsets = this.element.getBoundingClientRect(),
            containerOffsets = this.container.getBoundingClientRect(),
            checkX,
            checkY,
            result = false;

        if (this.isHorizontal === true) {
            if (containerOffsets.width < elementOffsets.width) {
                return result;
            }

            checkX = elementOffsets.right - (containerOffsets.right);
            if (checkX > 0) {
                this.fixPosition(containerOffsets.left + checkX - elementOffsets.left, 0);
                result = true;
            }

            checkX = elementOffsets.left - containerOffsets.left + 1;
            if (checkX < 0) {
                this.fixPosition(0, 0);
                result = true;
            }
        } else {
            if (containerOffsets.height < elementOffsets.height) {
                return result;
            }

            checkY = elementOffsets.top - (containerOffsets.top);
            if (checkY < 0) {
                this.fixPosition(0, 0);
                result = true;
            }

            checkY = elementOffsets.bottom - (containerOffsets.bottom + this.itemGap);
            if (checkY > 0) {
                this.fixPosition(0, (containerOffsets.top + checkY - elementOffsets.top));
                result = true;
            }
        }

        return result;
    };

    FxxlTouchSlider.prototype.fixPosition = function fixPosition(x, y) {
        this.lastXPosition = x;
        this.lastYPosition = y;
        this.setTransition(this.effectTransitionSpeed * 3, this.cubicBezier);
        this.setTranslate(x, y);
    };

    FxxlTouchSlider.prototype.createZoomLayer = function createZoomLayer() {
        var i, l, zoomLayerItems, zoomLayerItem;
        l = this.items.length - 1;
        for (i = 0; i <= l; i += 1) {
            zoomLayerItems = this.items[i].getElementsByClassName(this.itemZoomLayerCssClass);
            if (zoomLayerItems.length === 0) {
                zoomLayerItem = document.createElement('div');
                zoomLayerItem.classList.add(this.itemZoomLayerCssClass);
                this.items[i].appendChild(zoomLayerItem);
            } else {
                zoomLayerItem = zoomLayerItems[0];
            }
            zoomLayerItem.elementIndex = i;
            zoomLayerItem.classList.add(this.itemZoomLayerActiveCssClass);
        }
        this.isZoomable = true;
        return this;
    };

    FxxlTouchSlider.prototype.removeZoomLayer = function removeZoomLayer() {
        var i, l, zoomLayerItems, zoomLayerItem;
        l = this.items.length - 1;
        for (i = 0; i <= l; i += 1) {
            zoomLayerItems = this.items[i].getElementsByClassName(this.itemZoomLayerCssClass);
            if (zoomLayerItems.length !== 0) {
                zoomLayerItem = zoomLayerItems[0];
                zoomLayerItem.classList.remove(this.itemZoomLayerActiveCssClass);
            }
        }
        this.isZoomable = false;
        return this;
    };

    FxxlTouchSlider.prototype.stopZoom = function stopZoom(itemIndex) {
        var zoomContainers;
        zoomContainers = this.element.getElementsByClassName(this.zoomContainerCssClass);
        while (zoomContainers.length > 0) {
            zoomContainers[0].parentElement.removeChild(zoomContainers[0]);
        }
        this.zoomContainer = null;
        this.zoomItem = null;
        return this;
    };

    FxxlTouchSlider.prototype.startZoom = function startZoom(itemIndex) {
        var thisClass = this;

        if (this.isZoomable === false) {
            return this;
        }

        if (this.zoomContainer !== null) {
            this.stopZoom();
        }

        this.zoomContainer = document.createElement('div');
        this.zoomContainer.classList.add(this.zoomContainerCssClass);
        this.zoomItem = this.items[itemIndex].cloneNode(true);
        this.zoomItem.classList.add(this.zoomItemCssClass);
        this.zoomItem.style.transform = 'scale(' + this.zoomScale + ')';
        this.zoomContainer.appendChild(this.zoomItem);
        this.zoomContainer.elementIndex = itemIndex;
        this.items[itemIndex].appendChild(this.zoomContainer);

        this.setZoomPositions();
        setTimeout(function () {
            thisClass.zoomContainer.classList.add(thisClass.zoomContainerActiveCssClass);
        }, 150);
        return this;
    };

    FxxlTouchSlider.prototype.setZoomPositions = function setZoomPositions(event) {
        var containerOffsets, newX, newY, newItemX, newItemY, fixValue, xPos, yPos, limitX, limitY, borderLimit = 10;

        containerOffsets = this.items[this.zoomContainer.elementIndex].getBoundingClientRect();

        if (event === undefined) {
            xPos = containerOffsets.left + (containerOffsets.width / 2);
            yPos = containerOffsets.top + (containerOffsets.height / 2);
        } else {
            xPos = event.clientX;
            yPos = event.clientY;
        }

        fixValue = (this.zoomContainer.offsetWidth / 2);

        newX = (xPos - containerOffsets.left);
        newY = (yPos - containerOffsets.top);
        newItemX = (newX * this.zoomScale * -1) + fixValue;
        newItemY = (newY * this.zoomScale * -1) + fixValue;
        newX -= fixValue;
        newY -= fixValue;
        limitX = newX + fixValue;
        limitY = newY + fixValue;

        if (limitX <= borderLimit || limitY <= borderLimit
            || (limitX + borderLimit) > containerOffsets.width || (limitY + borderLimit) > containerOffsets.height) {
            this.zoomContainer.classList.remove(this.zoomContainerActiveCssClass);
        } else {
            this.zoomContainer.classList.add(this.zoomContainerActiveCssClass);
        }

        this.zoomContainer.style.transform = 'translate3d(' + newX + 'px, ' + newY + 'px, 0)';
        this.zoomItem.style.transform = 'translate3d(' + newItemX + 'px, ' + newItemY + 'px, 0) scale(' + this.zoomScale + ')';
        return this;
    };

    FxxlTouchSlider.prototype.showPinchZoomIcon = function showPinchZoomIcon() {
        var thisClass = this;
        if (this.pinchZoomIconElement === null) {
            this.pinchZoomIconElement = new DOMParser().parseFromString(this.pinchZoomIcon, "text/html").firstChild.getElementsByTagName('div')[0];
            this.container.appendChild(this.pinchZoomIconElement);
        }
        requestAnimationFrame(function() {
            thisClass.pinchZoomIconElement.classList.add(thisClass.pinchZoomIconShowClass);
        });
        setTimeout(function () {
            thisClass.pinchZoomIconElement.classList.remove(thisClass.pinchZoomIconShowClass);
        }, thisClass.pinchZoomIconLifeTime * 1000);
    };

    return FxxlTouchSlider;
}());
/**
 * Slider / Touch slider
 *
 * Filename: 410_sliders.js
 *
 * @category  Applicas
 * @package   Slider
 * @author    Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 * @copyright 2019 onlinekauf Internet Service GmbH
 */

const generalSliderSetup = function () {

    /**
     * Disable Loaders
     */
    $('.fxxl-slider-loader').addClass('fxxl-slider-loader--loaded');

    /**
     * Container v2
     */
    if (isLargeViewport() === false) {
        $('.fxxl-content-page__container--v2').each(function () {
            var containerV2Slider = new FxxlTouchSlider(this);
            containerV2Slider.itemGap = 15;
            containerV2Slider.lightBoxMoveEffect = 'scroll';
            containerV2Slider.activeScrollingMode = true;
            containerV2Slider.marginLeft = 1;
            containerV2Slider.marginRight = 1;
            containerV2Slider.init();
            this.classList.add('fxxl-content-page__container--show');
        });
    }

    /**
     * Main Slider (Slider1)
     */
    var mainSliders = document.querySelectorAll('.js-fxxl-slider1'),
        mainSliderIndex,
        mainSliderLength = mainSliders.length - 1,
        mainSliderElement;

    for (mainSliderIndex = 0; mainSliderIndex <= mainSliderLength; mainSliderIndex += 1) {
        mainSliderElement = mainSliders[mainSliderIndex];
        new FxxlSetupSlider1(mainSliderElement.getAttribute('data-cnt'), largViewportSize);
    }

    /**
     * Top category
     */
    var sliders2Selectors = [
        '.js-fxxl-slider-event',
        '.js-fxxl-slider-modal',
        '.js-fxxl-current-topics',
        '.js-fxxl-slider',
        '.js-fxxl-filialen-slider',
        '.js-fxxl-top-sales-slider',
        '.js-fxxl-xxl-beratung',
        '.js-fxxl-product-cards-slider',
        '.js-fxxl-icon-cards-slider',
        ],
        sliders2 = document.querySelectorAll(sliders2Selectors.join(', ')),
        slider2Index,
        slider2Length = sliders2.length - 1,
        slider2Id;

    for (slider2Index = 0; slider2Index <= slider2Length; slider2Index += 1) {
        slider2Id = sliders2[slider2Index].id;
        new FxxlSetupSlider2(slider2Id, largViewportSize);
    }

    document.querySelectorAll('.fxxl-products-recently-viewed-slider').forEach(element => {
        new FxxlSetupRecentlyViewedSlider(element);
    });

    /**
     * USP slider
     */
    var uspSlider = document.querySelectorAll('.fxxl-usp-slider'),
        uspSliderIndex,
        uspSliderLength = uspSlider.length - 1;

    for (uspSliderIndex = 0; uspSliderIndex <= uspSliderLength; uspSliderIndex += 1) {
        var fxxlUspSlider = new FxxlTouchSlider('#' + uspSlider[uspSliderIndex].id);
        fxxlUspSlider.itemGap = 15;
        fxxlUspSlider.autoPositionCorrector = true;
        fxxlUspSlider.ActiveMouseWheel = false;
        if (isLargeViewport() === false) {
            fxxlUspSlider.pushAlsNextPrev = true;
            fxxlUspSlider.endlessLoop = true;
        }
        fxxlUspSlider.init();
        fxxlUspSlider.play(2000);

        /* new FxxlResizedEvent(function () {
             fxxlUspSlider.init();
         }); */
    }

    /**
     * Logo slider
     */
    var logoSlider = document.querySelectorAll('.fxxl-logo-slider'),
        logoSliderIndex,
        logoSliderLength = logoSlider.length - 1;

    for (logoSliderIndex = 0; logoSliderIndex <= logoSliderLength; logoSliderIndex += 1) {
        var fxxlLogoSlider = new FxxlTouchSlider('#' + logoSlider[logoSliderIndex].id);
        fxxlLogoSlider.itemGap = 30;
        fxxlLogoSlider.ActiveMouseWheel = false;
        fxxlLogoSlider.init();

        if (isLargeViewport() === false) {
            fxxlLogoSlider.goTo(0, 'left', 0);
        }

        /* new FxxlResizedEvent(function () {
            fxxlLogoSlider.init();
        }); */
    }

    /**
     * Videos slider
     */
    var videoSlider = document.querySelectorAll('.js-fxxl-videos-slider'),
        videoSliderIndex,
        videoSliderLength = videoSlider.length - 1;

    for (videoSliderIndex = 0; videoSliderIndex <= videoSliderLength; videoSliderIndex += 1) {
        new FxxlSetupVideoSlider(videoSlider[videoSliderIndex].getAttribute('data-cnt'), largViewportSize);
    }

    /**
     * Slider-Simple
     */
    $('.fxxl-subelement-displayblock-slider-simple').each(function () {
        new FxxlSliderSimple(this.id);
    });
};

var FxxlSetupVideoSlider = (function FxxlSetupVideoSlider() {

    function FxxlSetupVideoSlider(id, largViewportSize) {
        var __this = this,
            visibleEventDone = false,
            videoSliderParentElement;
        this.id = id;
        this.largViewportSize = largViewportSize;
        this.fxxlVideosSlider = new FxxlTouchSlider();
        this.fxxlSecondVideosSlider = new FxxlTouchSlider();

        videoSliderParentElement = $('#fxxl-main-videos-slider-' + __this.id).parent();

        if (videoSliderParentElement.is(':visible') === false) {
            new FxxlElementObserver(videoSliderParentElement[0], function (data) {
                if (data[0].attributeName === 'style' && visibleEventDone === false) {
                    if (videoSliderParentElement.is(':visible') !== false) {
                        visibleEventDone = true;
                        __this.setup();
                    }
                }
            });
        } else {
            __this.setup();
        }
    }

    FxxlSetupVideoSlider.prototype.setup = function setup() {
        var __this = this;
        new FxxlElementVersionControl('#fxxl-main-videos-slider-' + __this.id, __this.largViewportSize, function (val) {
            if (val === 1) {
                $('#fxxl-videos-beratung-slider-' + __this.id).removeClass('fxxl-slider-loader');
            }
            __this.fxxlVideosSlider.originalElement = null;
            __this.fxxlSecondVideosSlider.originalElement = null;
            __this.init(val);
        });
    };

    FxxlSetupVideoSlider.prototype.init = function init(val) {
        var __this = this,
            visibleEventDone = false,
            baseSliderContainer = $('#fxxl-main-videos-slider-' + __this.id),
            fxxlVideosSlider;

        fxxlVideosSlider = this.fxxlVideosSlider;
        fxxlVideosSlider.query = '#fxxl-videos-beratung-slider-' + __this.id;
        fxxlVideosSlider.itemGap = 15;
        fxxlVideosSlider.ActiveMouseWheel = false;
        if (isLargeViewport() !== true) {
            fxxlVideosSlider.activeScrollingMode = true;
            fxxlVideosSlider.fullWidthItem = false;
            fxxlVideosSlider.autoPositionCorrector = false;
            fxxlVideosSlider.moveEffect = 'scroll';
            fxxlVideosSlider.swipeable = true;
            fxxlVideosSlider.init();
            fxxlVideosSlider.goTo(0, 'left', 0);
        } else {
            fxxlVideosSlider.activeScrollingMode = false;
            fxxlVideosSlider.fullWidthItem = true;
            fxxlVideosSlider.autoPositionCorrector = true;
            fxxlVideosSlider.moveEffect = 'fade';
            fxxlVideosSlider.swipeable = false;
            fxxlVideosSlider.init();

            $(window).on('load', function () {
                __this.secondSlider(fxxlVideosSlider);
            });

            if (val === 1) {
                __this.secondSlider(fxxlVideosSlider);
            } else if (WindowIsLoaded === true) {
                __this.secondSlider(fxxlVideosSlider);
            }
        }

        if (isLargeViewport() === false) {
            new FxxlElementObserver(baseSliderContainer[0], function (data) {
                if (data[0].attributeName === 'style' && visibleEventDone === false) {
                    if (baseSliderContainer.is(':visible') !== false) {
                        visibleEventDone = true;
                        fxxlVideosSlider.init();
                        if (isLargeViewport() !== true) {
                            fxxlVideosSlider.goTo(0, 'left', 0);
                        }
                    }
                }
            });
        }

        new FxxlResizedEvent(function () {
            if (baseSliderContainer.is(':visible') === false) {
                visibleEventDone = false;
            } else {
                //fxxlVideosSlider.init();
                fxxlVideosSlider.setFullWidthItem();
                if (isLargeViewport() !== true) {
                    fxxlVideosSlider.goTo(0, 'left', 0);
                }
            }
        });
    };

    FxxlSetupVideoSlider.prototype.secondSlider = function secondSlider(slider) {
        var __this = this,
            template = $(slider.originalElement.cloneNode(true)),
            container = $('#fxxl-second-videos-beratung-slider-container-' + __this.id),
            fxxlSecondVideosSlider,
            i,
            l,
            paddingTop = parseInt(container.css('padding-top')),
            fixHeight = slider.element.getBoundingClientRect().height - paddingTop,
            visibleEventDone = false,
            baseSliderContainer = $('#fxxl-main-videos-slider-' + __this.id);

        template.attr('id', 'fxxl-second-videos-beratung-slider-' + __this.id);
        template.removeClass('fxxl-slider-loader');
        template.addClass('fxxl-videos-beratung-slider--second');
        template.find('.fxxl-videos-beratung-slider__title-text').attr('data-multiline-truncation', 3);
        template.height(fixHeight);
        container.append(template);
        fxxlSecondVideosSlider = this.fxxlSecondVideosSlider;
        fxxlSecondVideosSlider.query = '#fxxl-second-videos-beratung-slider-' + __this.id;
        fxxlSecondVideosSlider.itemGap = 15;
        fxxlSecondVideosSlider.align = 'vertical';
        fxxlSecondVideosSlider.onInit = function () {
            l = fxxlSecondVideosSlider.allItems.length - 1;
            for (i = 0; i <= l; i += 1) {
                fxxlSecondVideosSlider.allItems[i].removeAttribute('onclick');
            }
            __this.setVideoSliderEvents(slider, fxxlSecondVideosSlider);

            /**
             * Set multiline truncation
             */
            $(fxxlSecondVideosSlider.container).find('[data-multiline-truncation]').each(function () {
                new FxxlMultilineTruncation($(this));
            });
        };

        fxxlSecondVideosSlider.init();

        new FxxlElementObserver(baseSliderContainer[0], function (data) {
            if (data[0].attributeName === 'style' && visibleEventDone === false) {
                if (baseSliderContainer.is(':visible') !== false && $(fxxlSecondVideosSlider.query).length > 0) {
                    visibleEventDone = true;
                    slider.init();
                    fixHeight = slider.element.getBoundingClientRect().height - paddingTop;
                    fxxlSecondVideosSlider.element.style.height = fixHeight + 'px';
                    fxxlSecondVideosSlider.init();
                    if (isLargeViewport() !== true) {
                        slider.goTo(0, 'left', 0);
                    }
                }
            }
        });

        new FxxlResizedEvent(function () {
            if (isLargeViewport() === true) {
                if (baseSliderContainer.is(':visible') === false) {
                    visibleEventDone = false;
                } else {
                    fixHeight = slider.element.getBoundingClientRect().height - paddingTop;
                    fxxlSecondVideosSlider.element.style.height = fixHeight + 'px';
                    //fxxlSecondVideosSlider.init();
                }
            }
        });
    };

    FxxlSetupVideoSlider.prototype.setVideoSliderEvents = function setVideoSliderEvents(slider1, slider2) {
        $(slider2.items).on('click', function () {
            slider1.goTo($(this).index());
            slider2.goTo($(this).index());
        });
    };

    return FxxlSetupVideoSlider;
}());

/**
 * Setup Slider 1
 */
var FxxlSetupSlider1 = (function () {

    function FxxlSetupSlider1(id, largViewportSize) {
        this.id = id;
        this.largViewportSize = largViewportSize;
        this.init();
    }

    FxxlSetupSlider1.prototype.init = function init() {
        var __this = this,
            allowToChange = true,
            fxxlMainSliderImages = new FxxlTouchSlider(),
            fadeNavBarTimer = null;

        new FxxlElementVersionControl('#fxxl-main-slider__item-' + __this.id, __this.largViewportSize, function (val) {

            if (val === 1) {
                $('#fxxl-main-slider__item-' + __this.id).removeClass('fxxl-slider-loader');
            }

            var sliderNavContainer = document.getElementById('fxxl-main-slider__titles-nav-' + __this.id),
                sliderContainer = document.getElementById('fxxl-main-slider__item-' + __this.id),
                allNavs = sliderNavContainer.querySelectorAll('figure');

            fxxlMainSliderImages.query = '#fxxl-main-slider__images-' + __this.id;
            fxxlMainSliderImages.itemGap = 3;
            fxxlMainSliderImages.fullWidthItem = true;
            fxxlMainSliderImages.autoPositionCorrector = false;
            fxxlMainSliderImages.ActiveMouseWheel = false;

            if (isLargeViewport() === false) {
                fxxlMainSliderImages.moveEffect = 'scroll';
                fxxlMainSliderImages.endlessLoop = true;
                fxxlMainSliderImages.mouseEventTarget = sliderContainer;
                fxxlMainSliderImages.pushAlsNextPrev = true;
                fxxlMainSliderImages.cubicBezier = '';
                fxxlMainSliderImages.activeScrollingMode = true;
            } else {
                fxxlMainSliderImages.moveEffect = 'fade';
                fxxlMainSliderImages.pushAlsNextPrev = false;
                setNavEvents();
            }

            fxxlMainSliderImages.init();
            fxxlMainSliderImages.play(5000);

            changeActiveNav(0);

            fxxlMainSliderImages.onGoingTo = function onGoingTo(index) {
                changeActiveNav(index);
            };

            fxxlMainSliderImages.onMouseDown = function onMouseDown() {
                fxxlMainSliderImages.stop();
                fxxlMainSliderImages.autoPositionCorrector = true;
                fxxlMainSliderImages.updateScrollingMode();
                var index = fxxlMainSliderImages.getActiveIndex();
                changeActiveNav(index);
            };

            if (isLargeViewport() === true) {
                fxxlMainSliderImages.onMouseMoved = function onMouseMoved() {
                    fxxlHideNavAndTitle();
                };
                fxxlMainSliderImages.onChanged = function onchanged() {
                    var index = fxxlMainSliderImages.getActiveIndex();
                    allowToChange = true;
                    changeActiveNav(index);
                    setTimeout(function () {
                        fxxlShowNavAndTitle();
                    }, 100);
                };
            } else {
                fxxlMainSliderImages.onChanged = function onchanged(index) {
                    allowToChange = true;
                    changeActiveNav(index);
                };
            }

            function fxxlHideNavAndTitle(justNav) {
                sliderNavContainer.style.transition = 'opacity 0.15s';
                sliderNavContainer.style.opacity = '0';
            }

            function fxxlShowNavAndTitle(justNav) {
                sliderNavContainer.style.opacity = '1';
            }

            function setNavEvents() {
                var i,
                    l = allNavs.length - 1,
                    index;

                for (i = 0; i <= l; i += 1) {
                    $(allNavs[i]).on('click', function () {
                        if (allowToChange === true) {
                            index = $(this).index();
                            fxxlMainSliderImages.stop();
                            fxxlMainSliderImages.goTo(index);
                            allowToChange = false;
                        }
                    });
                }
            }

            function changeActiveNav(index) {
                var i,
                    l = allNavs.length - 1,
                    item = sliderNavContainer.querySelector('figure:nth-of-type(' + (index + 1) + ')');

                for (i = 0; i <= l; i += 1) {
                    allNavs[i].classList.remove('fxxl-main-slider__titles-nav-item--active');
                }

                if (item === null) {
                    item = sliderNavContainer.querySelector('figure:nth-of-type(1)')
                }

                item?.classList.add('fxxl-main-slider__titles-nav-item--active');
            }

            $('#fxxl-main-slider-navigation-button-next-' + __this.id).on('click', function () {
                fxxlMainSliderImages.nextPrevFullScreen(1, false);
                return false;
            });

            $('#fxxl-main-slider-navigation-button-prev-' + __this.id).on('click', function () {
                fxxlMainSliderImages.nextPrevFullScreen(-1, false);
                return false;
            });

            new FxxlResizedEvent(function () {
                fxxlMainSliderImages.setFullWidthItem();
            });
        });
    };

    return FxxlSetupSlider1;
}());

/**
 * Setup Slider 2
 * @param id
 */
var FxxlSetupSlider2 = (function FxxlSetupSlider2() {
    function FxxlSetupSlider2(id, largViewportSize) {

        var __this = this;
        this.visibleEventDone = false;
        this.id = id;
        this.largViewportSize = largViewportSize;
        this.fxxlTempSlider = new FxxlTouchSlider();

        new FxxlElementVersionControl('#' + __this.id, __this.largViewportSize, function (val) {
            var elem = $('#' + __this.id);
            __this.fxxlTempSlider.query = '#' + __this.id;

            if (val === 1) {
                elem.removeClass('fxxl-slider-loader');
            }

            if (elem.hasClass('js-fxxl-top-category') === true && isLargeViewport() === false) {
            } else {
                __this.init();
            }

            /**
             * Slider-Modal
             */
            $('.fxxl-base-card__image-link--modal').each(function () {
                fxxlSetupSliderModal($(this));
            });
        });
    }

    FxxlSetupSlider2.prototype.init = function init() {
        var __this = this, onInitFunction, tempSlider = document.getElementById(__this.id);

        this.handleBranchAvailabilityText(tempSlider);

        this.fxxlTempSlider.itemGap = 15;

        if (isLargeViewport() === true) {
            if (!tempSlider.getAttribute('data-remove-margin')) {
                this.fxxlTempSlider.marginLeft = 'calc(5.5vw - ' + this.fxxlTempSlider.itemGap + 'px)';
            }
            this.fxxlTempSlider.activeScrollingMode = false;
        } else {
            this.fxxlTempSlider.marginLeft = 1;
            this.fxxlTempSlider.activeScrollingMode = true;
        }
        this.fxxlTempSlider.ActiveMouseWheel = false;

        onInitFunction = function () {
            if (isLargeViewport() !== true) {
                __this.fxxlTempSlider.goTo(0, 'left', 0);
            }
            setTimeout(function () {
                __this.setTempSliderNav();
            }, 1500);

            $('#' + __this.id + '-nav-next').on('click', function () {
                __this.fxxlTempSlider.next();
                __this.hideTempSliderNav();
                return false;
            });

            $('#' + __this.id + '-nav-prev').on('click', function () {
                __this.fxxlTempSlider.prev();
                __this.hideTempSliderNav();
                return false;
            });

            /**
             * Set multiline truncation
             */
            $(__this.fxxlTempSlider.container).find('[data-multiline-truncation]').each(function () {
                new FxxlMultilineTruncation($(this));
            });

            /**
             * fxxlLoadPersonalDataTimer
             */
            if (WindowIsLoaded === true) {
                clearTimeout(fxxlLoadPersonalDataTimer);
                fxxlLoadPersonalDataTimer = setTimeout(function () {
                    FxxlWishlist.productsSetChecked();
                }, 200);
            }
        };

        this.fxxlTempSlider.onMouseMoved = function () {
            __this.hideTempSliderNav();
        };

        this.fxxlTempSlider.onChanged = function () {
            __this.setTempSliderNav();
        };

        this.fxxlTempSlider.onInit = function () {
            onInitFunction();
        };

        this.fxxlTempSlider.init();

        new FxxlElementObserver(this.fxxlTempSlider.element.parentElement, function (data) {
            if (data[0].attributeName === 'style' && __this.visibleEventDone === false) {
                if ($(__this.fxxlTempSlider.element.parentElement).is(':visible') !== false) {
                    __this.visibleEventDone = true;
                    __this.fxxlTempSlider.init();
                }
            }
        });

        new FxxlResizedEvent(function () {
            if ($(__this.fxxlTempSlider.element.parentElement).is(':visible') === false) {
                __this.visibleEventDone = false;
            } else {
                //__this.fxxlTempSlider.init();
                onInitFunction();
            }
        });

        $(window).on('load', function () {
            setTimeout(function () {
                __this.setTempSliderNav();
            }, 250);
        });
    };

    FxxlSetupSlider2.prototype.hideTempSliderNav = function hideTempSliderNav() {
        $('#' + this.id + '-nav-next,#' + this.id + '-nav-prev').removeClass('fxxl-slider-nav--show');
    };

    FxxlSetupSlider2.prototype.setTempSliderNav = function setTempSliderNav() {
        if (isLargeViewport() !== true) {
            return false;
        }

        var buttonPositions = new FxxlSetupNextPrevButton(this.fxxlTempSlider);
        if (this.fxxlTempSlider.isPrevActive === true) {
            $('#' + this.id + '-nav-prev').css({
                'left': buttonPositions.prev.left + 'px',
                'top': buttonPositions.prev.top + 'px'
            }).addClass('fxxl-slider-nav--show');
        }
        if (this.fxxlTempSlider.isNextActive === true) {
            $('#' + this.id + '-nav-next').css({
                'left': buttonPositions.next.left + 'px',
                'top': buttonPositions.next.top + 'px'
            }).addClass('fxxl-slider-nav--show');
        }
    };

    FxxlSetupSlider2.prototype.handleBranchAvailabilityText = function handleBranchAvailabilityText(slider)
    {
        if (slider === undefined || slider.classList.contains('js-fxxl-product-cards-slider') === false) {
            return;
        }

        let hideBranchAvailabilityText = false;
        const articleClass = 'fxxl-element-artikel';
        const articleAvailableClass = 'fxxl-element-artikel__available';
        const articleAvailableHideClass = 'fxxl-element-artikel__available--hidden';
        const articleElements = slider.getElementsByClassName(articleClass);

        if (articleElements.length === 0) {
            return;
        }

        hideBranchAvailabilityText = !Array.from(articleElements).every(element => element.dataset.isTzb === 'false');

        if (hideBranchAvailabilityText) {
            Array.from(articleElements).forEach((articleElement) => {
                const availableElement = articleElement.getElementsByClassName(articleAvailableClass);
                if (availableElement.length > 0) {
                    if (!availableElement[0].classList.contains(articleAvailableHideClass)) {
                        availableElement[0].classList.add(articleAvailableHideClass);
                    }
                }
            });
        }
    };

    return FxxlSetupSlider2;
}());

/**
 * fxxlBtnSlider1
 * @param fxxlBtnSlider1ID
 */
var FxxlBtnSlider1 = (function FxxlBtnSlider1() {

    function FxxlBtnSlider1(fxxlBtnSlider1ID) {
        var itemHtml;
        new FxxlElementVersionControl(fxxlBtnSlider1ID, largViewportSize, function (val) {
            if (isLargeViewport() !== true) {
                if (val === 0 && documentIsReady === false) {
                    $(fxxlBtnSlider1ID).addClass('fxxl-slider-loader');
                }
                $(fxxlBtnSlider1ID).css({'visibility': 'visible'});
                $(fxxlBtnSlider1ID).find('.fxxl-btn-slider-1__item').each(function () {
                    $(this).addClass('fxxl-button');
                    itemHtml = $(this).html();
                    $(this).html('<div class="fxxl-button__text">' + itemHtml + '</div>');
                });
                var fxxlWarengruppeCategorySlider = new FxxlTouchSlider(fxxlBtnSlider1ID);
                fxxlWarengruppeCategorySlider.itemGap = 10;
                fxxlWarengruppeCategorySlider.ActiveMouseWheel = false;
                fxxlWarengruppeCategorySlider.marginLeft = 1;
                fxxlWarengruppeCategorySlider.activeScrollingMode = true;
                fxxlWarengruppeCategorySlider.init();
            }
        });
    }

    return FxxlBtnSlider1;
}());

/**
 * FxxlSliderSimple
 * @param FxxlSliderSimpleID
 */
var FxxlSliderSimple = (function FxxlBtnSlider1() {

    function FxxlBtnSlider1(FxxlSliderSimpleID) {
        new FxxlElementVersionControl('#' + FxxlSliderSimpleID, largViewportSize, function (val) {
            var jQueryObject = $('#' + FxxlSliderSimpleID),
                degree360Btn = jQueryObject.find('.fxxl-subelement-displayblock-slider-simple-inf__container-degree360'),
                butttonText,
                fxxlBranchPageSlider,
                activeGoTo = true,
                navList = $('.fxxl-subelement-displayblock-slider-simple-nav > div'),
                changedSlide = function (index) {
                    navList.removeClass('fxxl-subelement-displayblock-slider-simple-nav__item--active')
                        .eq(index).addClass('fxxl-subelement-displayblock-slider-simple-nav__item--active');
                };

            fxxlBranchPageSlider = new FxxlTouchSlider(jQueryObject.find('.fxxl-subelement-displayblock-slider-simple-images')[0]);

            if (isLargeViewport() === true) {
                if (degree360Btn.length > 0) {
                    butttonText = degree360Btn.removeClass('fxxl-button').addClass('smooth-scroll fxxl-subelement-displayblock-slider-simple-inf__container').find('.fxxl-button__text').html();
                    degree360Btn.html('<div class="fxxl-subelement-displayblock-slider-simple-inf__container">' +
                        '<svg class="fxxl-svg-fix fxxl-subelement-displayblock-slider-simple-inf__container-icon" width="24" height="24">' +
                        '<use href="#sprite_icon_360" xlink:href="#sprite_icon_360"></use></svg>' +
                        '<span>' + butttonText + '</span></div>');
                }

                new FxxlSmoothScroll(degree360Btn);

                navList.on('click', function () {
                    if (activeGoTo === true) {
                        fxxlBranchPageSlider.stop();
                        fxxlBranchPageSlider.goTo($(this).index());
                    }
                });
                fxxlBranchPageSlider.pushAlsNextPrev = false;
                fxxlBranchPageSlider.moveEffect = 'fade';
            } else {
                fxxlBranchPageSlider.pushAlsNextPrev = true;
                fxxlBranchPageSlider.moveEffect = 'scroll';
            }

            fxxlBranchPageSlider.itemGap = 10;
            fxxlBranchPageSlider.endlessLoop = true;
            fxxlBranchPageSlider.ActiveMouseWheel = false;
            fxxlBranchPageSlider.autoPositionCorrector = true;
            fxxlBranchPageSlider.fullWidthItem = true;
            fxxlBranchPageSlider.init();
            if (fxxlBranchPageSlider.items.length > 1) {
                fxxlBranchPageSlider.play(3000);
            }

            fxxlBranchPageSlider.onGoingTo = function (index) {
                activeGoTo = false;
                changedSlide(index);
            };

            fxxlBranchPageSlider.onChanged = function (index) {
                activeGoTo = true;
                changedSlide(index);
            };

            navList.first().addClass('fxxl-subelement-displayblock-slider-simple-nav__item--active');

            new FxxlResizedEvent(function () {
                fxxlBranchPageSlider.setFullWidthItem();
            });

        });
    }

    return FxxlBtnSlider1;
}());

/**
 * Content-Menu-Box
 * @param object
 */
function fxxlSetupContentMenuBoxSlider(object) {
    var fxxlContentMenuBoxSlider = new FxxlTouchSlider(object);
    fxxlContentMenuBoxSlider.itemGap = 15;
    fxxlContentMenuBoxSlider.ActiveMouseWheel = false;
    fxxlContentMenuBoxSlider.activeScrollingMode = true;
    fxxlContentMenuBoxSlider.init();
    fxxlContentMenuBoxSlider.goTo(0, 'left', 0);

}

/**
 * Slider mit "Kürzlich angesehenen Produkten" werden per Ajax geladen, serverseitig wird lediglich
 * ein DIV eingefügt, das durch diese Funktion ersetzt wird, falls es (genug) kürzlich angesehene Produkte
 * gibt.
 */
var FxxlSetupRecentlyViewedSlider = (function FxxlSetupRecentlyViewedSlider() {
    function FxxlSetupRecentlyViewedSlider(element) {
        this.domElement = element;
        this.domParent = element.parentElement;
        this.fetchRecentlyViewedProductsSlider();
    }

    FxxlSetupRecentlyViewedSlider.prototype.fetchRecentlyViewedProductsSlider = function fetchRecentlyViewedProductsSlider() {
        var params = new URLSearchParams({
            'service': 'getRecentlyViewedProductsSlider',
            'min': this.domElement.dataset.min,
            'max': this.domElement.dataset.max,
            'headline': this.domElement.dataset.headline,
            'without_artikel': this.domElement.dataset.withoutArtikel,
        });
        fxxlGetAJAXContent(`/json.php?${params}`, (data) => {
            if (data.slider_html) {
                this.domElement.outerHTML = data.slider_html;
                this.sliderElement = this.domParent.querySelector('.fxxl-recently-viewed-products-slider');
                new FxxlSetupSlider2(this.sliderElement.id, largViewportSize);
                this.domParent.querySelector('.fxxl-slider-loader').classList.add('fxxl-slider-loader--loaded');
                FxxlWishlist.productsSetChecked();
            }
        }, null, null, null, false);
    };

    return FxxlSetupRecentlyViewedSlider;
})();


/*
 * Fix via hotfix/35256.
 * TODO: Durch Funktion im Core ersetzen
 */
if (document.readyState !== 'complete' && document.readyState !== 'interactive') {
    document.addEventListener('DOMContentLoaded', function () {
        generalSliderSetup();
    });
} else {
    generalSliderSetup();
}

$(document).ready(() => {
    /**
     * Warengruppe-Category
     */
    $('.fxxl-btn-slider-1').each(function () {
        new FxxlBtnSlider1('#' + $(this).attr('id'));
    });
});
/**
 * Zendesk Widget : Zopim Chat
 */
var fxxlZopimChat = {};

function initZopimChat() {
    zE('webWidget', 'hide');
    var counterLimit = 60,
        isGuuruChatOpened = false,
        waitForZopim = setInterval(function () {
            if (window.$zopim === undefined || window.$zopim.livechat === undefined || $zopim.livechat.departments.getAllDepartments().length === 0) {
                if (counterLimit === 0) {
                    clearInterval(waitForZopim);
                }
                counterLimit--;
                return;
            }

            $zopim(function() {
                $zopim.livechat.hideAll();
            });

            fxxlZopimChat = new FXXLSetupZopimChat();

            if (typeof window.fxxlMainGuuruChatWidget !== 'undefined') {
                isGuuruChatOpened = window.fxxlMainGuuruChatWidget.isChatOpened();
            }

            // When Guuru-Chat is not opened
            if (isGuuruChatOpened === true) {
                fxxlZopimChat.active = false;
                fxxlZopimChat.hideChatWidget();
                if (typeof window.fxxlMainGuuruChatWidget !== 'undefined') {
                    window.fxxlMainGuuruChatWidget.correctorCallback = function() {
                        window.fxxlMainGuuruChatWidget.hide();
                        fxxlZopimChat.active = true;
                        fxxlZopimChat.showChatWidget();
                    };
                }
            } else if (typeof window.fxxlMainGuuruChatWidget !== 'undefined') {
                setTimeout(() => {
                    if (window.fxxlMainGuuruChatWidget.isZendeskChatOnline() === true) {
                        window.fxxlMainGuuruChatWidget.hide();
                    }
                }, 1000);
            }
            clearInterval(waitForZopim);
        }, 1000);
}

var FXXLSetupZopimChat = (function FXXLSetupZopimChat()
{
    'use strict';

    function FXXLSetupZopimChat()
    {
        this.userIsChatting = $zopim.livechat.isChatting();
        this.chatWindowOpen = false;
        this.chatWindowClose = true;
        this.chatDepartments = null;
        this.onlineDepartments = [];
        this.offlineDepartments = [];
        this.userData = null;
        this.webSdkLoaded = false;
        this.maxChatQueueLimit = 2;
        this.chatWidgetFrame = $('#launcher');
        this.warenkorbAccordion = $('#element-cart-accordion-1');
        this.bottomOffsetMax = '185px';
        this.bottomOffsetMin = '40px';
        this.active = true;

        if (zendeskChatDelay !== undefined) {
            this.chatPopupDelay = zendeskChatDelay;
        } else {
            this.chatPopupDelay = 30;
        }

        if (zendeskDefaultChatGroup !== undefined && zendeskDefaultChatGroup !== null) {
            this.defaultChatGroup = zendeskDefaultChatGroup;
        } else {
            this.defaultChatGroup = 'webshop';
        }

        if (zendeskChatQueueLimit !== 0) {
            this.maxChatQueueLimit = zendeskChatQueueLimit;
        }

        if (this.userIsChatting === false) {
            this.hideChatWidget();
        }

        if (zendeskWebSdkKey !== '') {
            zChat.init({
                account_key: zendeskWebSdkKey,
            });
            this.webSdkLoaded = true;
        }

        this.init();
    }

    FXXLSetupZopimChat.prototype.init = function init() {
        var __this = this;

        zE(function() {
            zE.setLocale('de');
        });

        __this.checkAllDepartments();

        setTimeout(function () {
            __this.decideVisibility();
        }, 250);

        if (this.warenkorbAccordion.length > 0 && this.chatWidgetFrame.length > 0 && isLargeViewport() === false) {
            __this.changeChatOffset();
        }

        __this.initEvents();
    };

    FXXLSetupZopimChat.prototype.decideVisibility = function decideVisibility() {
        var __this = this,
            previousPageUrl = document.referrer,
            currentPageUrl = document.URL,
            branchReference = previousPageUrl.indexOf('standort.'),
            branchPageReference = currentPageUrl.indexOf('filiale/'),
            branchNames,
            branchName,
            urlKeys,
            branchIndex,
            branchPageName,
            enabledBranches = [];

        if (this.webSdkLoaded === true) {
            if (zChat.getQueuePosition() > this.maxChatQueueLimit) {
                this.hideChatWidget();
                return;
            }
        }

        if (this.onlineDepartments.length === 0) {
            if ($zopim.livechat.isChatting() === false) {
                this.hideChatWidget();
            }
        } else {
            setTimeout(function () {
                if (branchReference > -1) {
                    branchNames = previousPageUrl.split('standort.').pop().split('/')[0].split('_');
                    branchNames.forEach(function (filiale) {
                        branchName = __this.onlineDepartments.find(function (branch) {
                            return branch.toLowerCase().includes(filiale);
                        });

                        if (branchName !== undefined) {
                            enabledBranches.push(branchName);
                        }
                    });

                    if (enabledBranches.length > 0) {
                        __this.updateDepartmentSettings(enabledBranches, enabledBranches[0]);
                        if (__this.active === true) {
                            __this.showChatWidget();
                        }
                    } else {
                        __this.setDefaultChatGroup();
                    }
                }

                if (branchPageReference > -1 && pageViewName === 'detail') {
                    // "branch" & branch.urlkey => used from global variable
                    if (typeof branch !== 'undefined' && typeof branch.urlkey !== 'undefined') {
                        branchName = branch.urlkey.toLowerCase();
                    } else {
                        urlKeys = currentPageUrl.split('/');
                        branchIndex = urlKeys.indexOf('filiale');
                        branchName = urlKeys[branchIndex + 1];
                    }

                    branchPageName = __this.onlineDepartments.find(function (branch) {
                        if (branch.toLowerCase().includes(branchName) === true) {
                            return branch;
                        }
                    });

                    if (branchPageName !== undefined) {
                        __this.updateDepartmentSettings([branchPageName], branchPageName);
                        if (__this.active === true) {
                            __this.showChatWidget();
                        }
                    } else {
                        __this.setDefaultChatGroup();
                    }
                }

                if (branchReference === -1 && branchPageReference === -1) {
                    __this.setDefaultChatGroup();
                }
                __this.updateCookieSettings();
            }, __this.chatPopupDelay * 1000);
        }
    };

    FXXLSetupZopimChat.prototype.setDefaultChatGroup = function setDefaultChatGroup() {
        var __this = this,
            branchName;

        branchName = this.onlineDepartments.find(function (branch) {
            if (branch.toLowerCase().includes(__this.defaultChatGroup.toLowerCase()) === true) {
                return branch;
            }
        });

        if (branchName !== undefined) {
            this.updateDepartmentSettings([branchName], branchName);
            if (__this.active === true) {
                this.showChatWidget();
            }
        } else {
            this.hideChatWidget();
        }

    };

    FXXLSetupZopimChat.prototype.updateCookieSettings = function updateCookieSettings() {
        if (etJS_getCookie('fxxl_optional_cookies') === 'true') {
            zE('webWidget', 'updateSettings', {
                cookies: true
            });
        } else {
            zE('webWidget', 'updateSettings', {
                cookies: false
            });
        }
    };

    FXXLSetupZopimChat.prototype.checkAllDepartments = function checkAllDepartments() {
        var __this = this;

        this.onlineDepartments = [];
        this.offlineDepartments = [];

        $zopim(function() {
            __this.chatDepartments = $zopim.livechat.departments.getAllDepartments();
            __this.chatDepartments.forEach(function (department) {
                if (department.status === 'online') {
                    __this.onlineDepartments.push(department.name);
                } else {
                    __this.offlineDepartments.push(department.name);
                }
            });
        });
    };

    FXXLSetupZopimChat.prototype.initEvents = function initEvents() {
        var __this = this;

        zE('webWidget:on', 'open', function() {
            __this.chatWindowOpen = true;
            __this.chatWindowClose = false;
            __this.prefillUserData();
            __this.showHideFxxlChatButton(false);
        });

        zE('webWidget:on', 'chat:departmentStatus', function(dept) {
            var index;

            if (dept.status === 'offline') {
                index = __this.onlineDepartments.indexOf(dept.name);
                if (index > -1) {
                    __this.onlineDepartments.splice(index, 1);
                    __this.offlineDepartments.push(dept.name);
                }
            }

            if (dept.status === 'online') {
                index = __this.offlineDepartments.indexOf(dept.name);
                if (index > -1) {
                    __this.offlineDepartments.splice(index, 1);
                    __this.onlineDepartments.push(dept.name);
                }
            }
        });

        zE('webWidget:on', 'chat:status', function () {
            setTimeout(function () {
                __this.decideVisibility();
            }, 250);
        });

        zE('webWidget:on', 'chat:end', function() {
            setTimeout(function () {
                __this.decideVisibility();
            }, 300);
        });

        zE('webWidget:on', 'close', function() {
            __this.chatWindowOpen = false;
            __this.chatWindowClose = true;
            __this.showHideFxxlChatButton(true);
            if (isLargeViewport() === false) {
                __this.changeChatOffset();
            }
        });

        if (this.warenkorbAccordion.length > 0 && this.chatWidgetFrame.length > 0 && isLargeViewport() === false) {
            // For on scroll changes
            let stickyAccordion = document.getElementById('element-cart-accordion-1');
            const mObserver = new MutationObserver(function (event) {
                if (stickyAccordion.classList.contains('fxxl-accordion--active')) {
                    __this.chatWidgetFrame.css({
                        'bottom' : __this.bottomOffsetMax
                    });
                } else {
                    __this.chatWidgetFrame.css({
                        'bottom' : __this.bottomOffsetMin
                    });
                }
            });

            mObserver.observe(stickyAccordion, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false
            });
        }
    };

    FXXLSetupZopimChat.prototype.changeChatOffset = function changeChatOffset() {
        let __this = this;

        if (this.warenkorbAccordion.hasClass('fxxl-accordion--active') === true) {
            this.chatWidgetFrame.css({
                'bottom': __this.bottomOffsetMax
            });
        } else {
            this.chatWidgetFrame.css({
                'bottom': __this.bottomOffsetMin
            });
        }
    };

    FXXLSetupZopimChat.prototype.updateDepartmentSettings = function updateDepartmentSettings(enabledBranches, selectedBranch) {

        zE('webWidget', 'updateSettings', {
            webWidget: {
                chat: {
                    departments: {
                        enabled: enabledBranches,
                        select: selectedBranch
                    },
                    suppress: false
                }
            }
        });
    };

    FXXLSetupZopimChat.prototype.prefillUserData = function prefillUserData() {
        if (FxxlPersonalData !== undefined) {
            if (FxxlPersonalData.user !== undefined) {
                this.userData = FxxlPersonalData.user;

                zE('webWidget', 'prefill', {
                    name: {
                        value: this.userData.firstName,
                        readOnly: false
                    },
                    email: {
                        value: this.userData.Email,
                        readOnly: false
                    }
                });
            }
        }
    };

    FXXLSetupZopimChat.prototype.hideChatWidget = function hideChatWidget() {
        $zopim(function() {
            $zopim.livechat.button.hide();
        });
        this.showHideFxxlChatButton(false);
    };

    FXXLSetupZopimChat.prototype.showChatWidget = function showChatWidget() {
        if (fxxl_support_widget === null) {
            $zopim(function() {
                $zopim.livechat.button.show();
            });
        } else {
            fxxl_support_widget.setupZChat();
        }
        this.showHideFxxlChatButton(true);
    };

    FXXLSetupZopimChat.prototype.showHideFxxlChatButton = function showHideFxxlChatButton(status) {
        fxxlChatActivationButtonVisible(status);
    };

    return FXXLSetupZopimChat;
}());
window.fxxlBranchMap = undefined;
window.fxxlBranchesMarkerData = {};
window.fxxlBranchAllMarkers = [];
window.fxxlBranchInfoWindows = [];
window.map_click_event = [];
window.fxxlBranchMapLoaded = false;
window.fxxlIconSetting = [];
window.fxxlBranchMaoInfowindow = null;
window.fxxlBranchMapStartZoom = 6;
window.fxxlBranchMapLoadedFunction = function() {};

function setupMap() {
    fxxlBranchesMarkerData = {
        '0': {
            default: '/custom/module/public/fxxl3/assets/img/mapsmarker.svg',
            active: '/custom/module/public/fxxl3/assets/img/mapsmarker-active.svg'
        },
        '1': {
            default: '/custom/module/public/fxxl3/assets/img/mapsmarker_cube.svg',
            active: '/custom/module/public/fxxl3/assets/img/mapsmarker_cube-active.svg'
        },
        '1000': {
            default: '/custom/module/public/fxxl3/assets/img/marker-serviceparter-01b.svg',
            active: '/custom/module/public/fxxl3/assets/img/marker-serviceparter-02b.svg'
        },
        location: '/custom/module/public/fxxl3/assets/img/mapsmarker_mylocation.png'
    };

    const $googleMapElements = $(googleMapElements.img);
    if ($googleMapElements.length > 0) {
        $googleMapElements.on('mousedown click', function (e) {
            // click is for Mobile
            loadBranchMap(e);
        });
    } else {
        loadBranchMap();
    }
}

function loadBranchMap(e) {
    if (fxxlBranchMapLoaded === false) {
        if (e !== undefined) {
            map_click_event = e;
        } else {
            map_click_event.clientX = 0;
            map_click_event.clientY = 0;
        }
        $('body').append('<script src="https://maps.googleapis.com/maps/api/js?key=' + googleMapElements.ApiKey + '&libraries=geometry,places&callback=initMap" async defer><//script>');
        fxxlBranchMapLoaded = true;
        showSpinner();
    }
}

function showGoogleMap() {
    $(googleMapElements.img).addClass('fxxl-branch-change__image-intro--hidden');
    setTimeout(function () {
        jQuery(document.elementFromPoint(map_click_event.clientX, map_click_event.clientY)).focus().trigger('click');
    }, 500);
}

function initMap()
{
    /**
     * Setup Branches Status
     */
    // Data ist in der branch_map erstellt
    var branchIds = [];
    data.forEach(function (branch) {
        branchIds.push(branch.c_branch_id);
    });
    fxxlGetBranchTimes(branchIds, function (timesData) {
        loadMap(timesData);
    });
}

function loadMap(timesData)
{
    var input = document.getElementById(googleMapElements.searchInputID),
        autocomplete;

    const branchCategories = FxxlCore.getConfig().server.branch.category_name_to_value;

    fxxlIconSetting.scaledSize = new google.maps.Size(32, 42);
    fxxlIconSetting.origin = new google.maps.Point(0, 0);
    fxxlIconSetting.anchor = new google.maps.Point(32, 42);
    fxxlIconSetting.myLocationScaledSize = new google.maps.Size(24, 32);
    fxxlIconSetting.myLocationAnchor = new google.maps.Point(24, 32);

    fxxlBranchMap = new google.maps.Map(document.getElementById(googleMapElements.mapId), {
        center: {lat: parseFloat(51.5370234), lng: parseFloat(9.8568132)},
        zoom: fxxlBranchMapStartZoom,
        mapTypeControl: false
    });

    var myoverlay = new google.maps.OverlayView();
    myoverlay.draw = function () {
        this.getPanes().markerLayer.id = 'fxxl-branch-markerLayer';
    };
    myoverlay.setMap(fxxlBranchMap);

    fxxlBranchMap.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    google.maps.event.addListenerOnce(fxxlBranchMap, 'tilesloaded', function () {
        showGoogleMap();
        hideSpinner();
        fxxlBranchMapLoadedFunction();
    });

    $('#' + googleMapElements.mapId).css({'height': $(googleMapElements.img).height() + 'px'});

    autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});
    autocomplete.bindTo('bounds', fxxlBranchMap);

    autocomplete.addListener('place_changed', function () {
        var bounds = new google.maps.LatLngBounds(),
            place = autocomplete.getPlace(),
            distance = 6300 * 1000,
            nearest_marker = -1,
            new_distance,
            i,
            marker,
            info;

        for (i = 0; i < fxxlBranchAllMarkers.length; i += 1) {
            new_distance = google.maps.geometry.spherical.computeDistanceBetween(place.geometry.location, fxxlBranchAllMarkers[i].position);
            if (new_distance < distance) {
                distance = new_distance;
                nearest_marker = i;
            }
        }

        if (nearest_marker >= 0) {
            marker = new google.maps.Marker({
                position: place.geometry.location,
                map: fxxlBranchMap,
                optimized: false
            });
            bounds.extend(place.geometry.location);
            bounds.extend(fxxlBranchAllMarkers[nearest_marker].position);
            fxxlBranchMap.fitBounds(bounds);
        }
    });

    var i,
        latLng,
        infowindow,
        marker,
        branchTypeMarker,
        infoBox,
        infoContent,
        status,
        statusClass,
        branchItemId,
        branchListContainer,
        info,
        kontaktData,
        visitUrl,
        visitTarget = '_self',
        isServicePartner = false,
        buttonIcon = '<svg width="24" height="24" class="fxxl-button__icon fxxl-button__icon--right">'
            + '<use href="#sprite_icon_keyboard_arrow_right" xlink:href="#sprite_icon_keyboard_arrow_right"></use></svg>';

    for (i = 0; i < data.length; i++) {
        let markerIndex = (data[i].hasOwnProperty('branch_type')) ? data[i]['branch_type'] : 0;

        // Set marker for servicepartner
        if (site_type === 'branch' && site_name === 'servicepartner') {
            isServicePartner = true;
            markerIndex = 1000;
        }

        branchTypeMarker = fxxlBranchesMarkerData[markerIndex] ?? fxxlBranchesMarkerData[0];

        latLng = new google.maps.LatLng(parseFloat(data[i].geo_lat), parseFloat(data[i].geo_long));
        marker = new google.maps.Marker({
            position: latLng,
            map: fxxlBranchMap,
            title: data[i].branch_name,
            icon: {
                url: branchTypeMarker.default,
                scaledSize: fxxlIconSetting.scaledSize,
                origin: fxxlIconSetting.origin,
                anchor: fxxlIconSetting.anchor
            },
            optimized: false,
            branchType: data[i]['branch_type']
        });

        if (timesData[data[i].c_branch_id].is_open === 1) {
            status = map_texts.status_open;
            statusClass = 'fxxl-branch-map-infowindow__status--open';
        } else {
            status = map_texts.status_close;
            statusClass = 'fxxl-branch-map-infowindow__status--close';
        }

        infoBox = $('<div class="fxxl-branch-map-infowindow"></div>');

        info = '<div class="fxxl-branch-map-infowindow__info-title">' + data[i].branch_name + '</div>';

        let navigation = '<div class="fxxl-branch-map-infowindow__nav">';
        if (data[i].fxxl_branch_category !== branchCategories.coming_soon && isServicePartner === false) {
            navigation += '<a class="fxxl-button" href="' + data[i].products_url + '">' + buttonIcon + '<span class="fxxl-button__text">' + map_texts.visit_products_btn + '</span></a>';
        }

        if (isServicePartner) {
            visitUrl = data[i]?.fxxl_service_partner_link ?? '';
            visitTarget = '_blank';
        } else {
            visitUrl = data[i].url;
        }

        navigation += '<a class="fxxl-button" target="' + visitTarget + '" href="' + visitUrl + '">' + buttonIcon + '<span class="fxxl-button__text">' + map_texts.visit_page_btn + '</span></a>';
        navigation += '</div>';

        let openingTimesTitle = '';
        if (data[i].fxxl_branch_category !== branchCategories.coming_soon) {
            openingTimesTitle = map_texts.open_time_title;
        } else {
            openingTimesTitle = map_texts.coming_soon_title;
        }
        infoBox.append('<div class="fxxl-branch-map-infowindow__image-container">' + data[i].image +
            '<div class="fxxl-branch-map-infowindow__status ' + statusClass + '">' + status + '</div></div>')
            .append('<div class="fxxl-branch-map-infowindow__info">' + info + '</div>')
            .append(navigation);

        let phoneInfo = '';
        if (data[i].header_phone) {
            phoneInfo = fxxlBranchGetInfoContent('sprite_icon_local_phone', data[i].header_phone, 'gtm__branch-map-infowindow__phone')
        }
        infoBox.find('.fxxl-branch-map-infowindow__info')
            .append(fxxlBranchGetInfoContent('sprite_icon_location_on', data[i].strasse + '<br>' + data[i].plz + ' ' + data[i].ort_name, 'gtm__branch-map-infowindow__street'))
            .append(fxxlBranchGetInfoContent('sprite_icon_access_time', openingTimesTitle + '<br>' + data[i].header_name, 'gtm__branch-map-infowindow__time'))
                .append(phoneInfo);

        if (data[i].header_link) {
            var phoneKontakt = infoBox.find(".gtm__branch-map-infowindow__phone");
            phoneKontakt.hide();
            phoneKontakt.after("<div class='fxxl-branch-map-infowindow__info-content gtm__branch-map-infowindow__link'>" +
                "<div class='fxxl-branch-map-infowindow__info-content-icon'>" +
                    "<svg width='20' height='20'><use href='#sprite_icon_info' xlink:href='#sprite_icon_info'></use></svg>" +
                "</div>" +
                "<a class='fxxl-branch-map-infowindow__info-content-link' href='" + data[i].header_link + "'>" + et.data.hilfe_kontakt_by_the_branch + "</a>" +
                "</div>");
        }

        infoContent = infoBox[0].outerHTML;

        branchItemId = data[i].c_branch_id + '-' + data[i].b_lagerort_id;

        infowindow = new google.maps.InfoWindow({
            content: infoContent,
            // Change offset of Info-Window
            pixelOffset: new google.maps.Size(0, 0)
        });

        google.maps.event.addListener(infowindow, 'closeclick', function () {
            fxxlBranchSetAllMakersIcon();
        });

        fxxlBranchInfoWindows.push(infowindow);
        fxxlBranchAllMarkers.push(marker);
        google.maps.event.addListener(marker, 'click', (function (marker, infoContent, infowindow, branchItemId, branchTypeMarker) {
            return function () {
                fxxlBranchCloseAllInfoWindows();
                fxxlBranchSetAllMakersIcon();

                if (isLargeViewport() === true) {
                    infowindow.setContent(infoContent);
                    fxxlBranchSetCenter(fxxlBranchMap.center.lng(), marker.position.lng(), fxxlBranchMap.zoom, marker, infowindow);
                } else {
                    fxxlBranchMap.panTo(marker.getPosition());
                    if (fxxlBranchListSlider !== undefined) {
                        branchListContainer = $('.fxxl-branch-list-container').first();
                        $('html, body').animate({'scrollTop': (branchListContainer.offset().top - 80) + 'px'}, 250, 'easeOutCirc');
                        fxxlBranchListSlider.goTo($('[data-branch-item="' + branchItemId + '"]').index(), 'center');
                    }
                }

                marker.setIcon({
                    url: branchTypeMarker.active,
                    scaledSize: fxxlIconSetting.scaledSize,
                    origin: fxxlIconSetting.origin,
                    anchor: fxxlIconSetting.anchor
                });

                fxxlBranchMaoInfowindow = infowindow;

                google.maps.event.addListener(fxxlBranchMap, 'click', function () {
                    fxxlBranchSetAllMakersIcon();
                    infowindow.close();
                });
            };
        })(marker, infoContent, infowindow, branchItemId, branchTypeMarker));
    }
}

function fxxlBranchSetCenter(lng1, lng2, zoom, marker, infowindow) {
    /**
     * Move Marker & infowindow to center when required
     * @type {number}
     */
    var difflon = (lng1 - lng2) * (Math.PI / 180),
        difference = (Math.abs(difflon) * 100),
        tempDiff,
        differenceWithZoom;
    if (fxxlBranchMapStartZoom !== zoom) {
        if (fxxlBranchMapStartZoom < zoom) {
            tempDiff = (Math.pow(zoom - fxxlBranchMapStartZoom, 2));
            if (tempDiff === 1) {
                tempDiff = 2;
            }
            differenceWithZoom = difference * tempDiff;
        } else {
            tempDiff = (Math.pow(fxxlBranchMapStartZoom - zoom, 2));
            if (tempDiff === 1) {
                tempDiff = 2;
            }
            differenceWithZoom = difference / tempDiff;
        }
    } else {
        differenceWithZoom = difference;
    }
    if (differenceWithZoom > 8) {
        infowindow.setOptions({disableAutoPan: true});
        infowindow.open(fxxlBranchMap, marker);
        fxxlBranchMap.panTo(infowindow.getPosition());
        fxxlBranchMap.panBy(0, -150);
    } else {
        infowindow.setOptions({disableAutoPan: false});
        infowindow.open(fxxlBranchMap, marker);
    }
}

function fxxlBranchCloseAllInfoWindows() {
    var i;
    for (i = 0; i < fxxlBranchInfoWindows.length; i++) {
        fxxlBranchInfoWindows[i].close();
    }
}

function fxxlBranchSetAllMakersIcon() {
    var i;
    for (i = 0; i < fxxlBranchAllMarkers.length; i += 1) {
        let markerDataIndex = (fxxlBranchAllMarkers[i].hasOwnProperty('branchType')) ? fxxlBranchAllMarkers[i]['branchType'] : 0;

        if (site_type === 'branch' && site_name === 'servicepartner') {
            markerDataIndex = 1000;
        }

        const branchTypeMarker = fxxlBranchesMarkerData[markerDataIndex] ?? fxxlBranchesMarkerData[0];
        fxxlBranchAllMarkers[i].setIcon({
            url: branchTypeMarker.default,
            scaledSize: fxxlIconSetting.scaledSize,
            origin: fxxlIconSetting.origin,
            anchor: fxxlIconSetting.anchor
        });
    }
}

function fxxlBranchGetInfoContent(icon, text, klasse) {
    return '<div class="' + klasse + '">' +
    '<div class="fxxl-branch-map-infowindow__info-content">' +
        '<div class="fxxl-branch-map-infowindow__info-content-icon">' +
        '<svg width="20" height="20">' +
        '<use href="#' + icon + '" xlink:href="#' + icon + '"></use>' +
        '</svg>' +
        '</div>' +
        '<div class="fxxl-branch-map-infowindow__info-content-text">' +
        text +
        '</div></div></div>';
}
/**
 * Filial-Info
 */
loadFilialInfo();
var mobil = false;

function loadFilialInfo() {
    var jBranchInfo = jQuery(".branch_info");

    if (jBranchInfo.length > 0) {
        var close = jBranchInfo.find(".close");
        close.on("click tap", function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            jBranchInfo.removeClass("active");
        });
        setFilialInfo(jBranchInfo);
    }
}

function setFilialInfo(jBranchInfo) {
    var delayShowInfo = 0;
    var delayCloseInfo = 20000;
    var myInterval = 0;

    if (mobil) {
        delayShowInfo = 0;
        delayCloseInfo = 20000;
    }

    function showBranchInfo(jBranchInfo) {
        getBranchInfo(jBranchInfo);
    }

    function closeBranchInfo(jBranchInfo) {
        jBranchInfo.removeClass("active");
    }

    function starProgram(jBranchInfo) {
        if (myInterval > 0) {
            clearInterval(myInterval);
        }

        myInterval = setTimeout(function (jBranchInfo) {
            showBranchInfo(jBranchInfo);
        }, delayShowInfo, jBranchInfo);

        myInterval = setTimeout(function (jBranchInfo) {
            closeBranchInfo(jBranchInfo);
        }, delayCloseInfo, jBranchInfo);
    }

    starProgram(jBranchInfo);
}

function getBranchInfo(jBranchInfo) {
    var filiale = getParameterByName('filiale');

    if (!filiale) {
        filiale = getParameterByName('pmfiliale');
    }

    if (filiale) {
        filiale = validateBranchInfo(filiale);
        jQuery('[id^=tsbadgeResponsiveTop]').attr("style", "display: none !important");
        var request = '/json.php?service=getBranch&branch_id=' + filiale;
        var jImage = jBranchInfo.find(".branch_image");
        var jAdresseName = jBranchInfo.find(".adresse_name");
        var jCompanyName = jBranchInfo.find(".company_name");
        var jStrasse = jBranchInfo.find(".strasse");
        var jZip = jBranchInfo.find(".zip");
        var jCity = jBranchInfo.find(".city");
        var jHeaderName = jBranchInfo.find(".header_name");
        var jHeaderPhone = jBranchInfo.find(".header_phone");
        var jHeaderPhoneContainer = jBranchInfo.find(".header_phone_container_js");
        var jHeaderLink = jBranchInfo.find(".header_link");
        var jBranchNameLogo = jBranchInfo.find(".branch_name_logo");

        jQuery.getJSON(request, function (response) {

            jBranchInfo.on("click", function (event) {
                event.preventDefault;
                var url = response.branchAlias;
                document.location.href = location.protocol + '//' + location.host + "/" + url;
            });

            jImage.attr('src', ' /is.php?id=' + response.teaser_m_medium_id);
            jCompanyName.html(response.adresse_name);
            jAdresseName.html("Besuche unsere Filiale!");
            jStrasse.html(response.strasse);
            jZip.html(response.plz);
            jCity.html(response.ort_name);
            jHeaderName.html(response.header_name);
            if (response.header_link) {
                jHeaderLink.attr("href", response.header_link)
                jHeaderPhoneContainer.hide();
            } else {
                jHeaderPhone.html(response.header_phone);
                jHeaderLink.hide();
            }
            jBranchNameLogo.attr('src', ' /is.php?id=' + response.logo_m_medium_id);
            jBranchInfo.addClass("active");
        });
    }
}

function validateBranchInfo(filialeId) {
    switch (filialeId) {
        case '001_DDS':
            return 1;
            break;
        case '005_HH':
            return 2;
            break;
        case '006_MS':
            return 3;
            break;
        case '002_1':
            return 4;
            break;
        case '001_HAL':
            return 5;
            break;
        case '008_GE':
            return 7;
            break;
        case '004_SA':
            return 9;
            break;
        case '111_MK':
            return 10;
            break;
        case '001_CHE':
            return 11;
            break;
        case '111_KO':
            return 12;
            break;
        case '111_MZ':
            return 13;
            break;
        case '007_LH':
            return 14;
            break;
        case '009_ES':
            return 15;
            break;
        case '008_BO':
            return 16;
            break;
        case '111_GH':
            return 19;
            break;
        case '888_GH':
            return 19;
            break;
        case '001_DDN':
            return 8;
            break;
        default:
            return 0;
    }
}

/**
 * Current Branch Filter Cookie
 */
if (site_type === 'branch' && site_name === 'detail') {
    var branchInfoStatusItems,
        branchInfoStatusGeneralClass = 'fxxl-subelement-displayblock-slider-simple-inf__container-status',
        branchInfoStatusOpenClass = 'fxxl-subelement-displayblock-slider-simple-inf__container-status--open',
        branchInfoStatusCloseClass = 'fxxl-subelement-displayblock-slider-simple-inf__container-status--close',
        branchMapInfoStatusItems,
        branchMapInfoStatusGeneralClass = 'fxxl-subelement-displayblock-google-map__contact-container-status',
        branchMapInfoStatusOpenClass = 'fxxl-subelement-displayblock-google-map__contact-container-status--open',
        branchMapInfoStatusCloseClass = 'fxxl-subelement-displayblock-google-map__contact-container-status--close',
        infoText = '',
        is_open = 1;

    fxxlSetFilterCookieForChosenBranch(site_vwid, 'true');

    /**
     * Setup Branches Status
     */
    fxxlGetBranchTimes(site_vwid, function (timesData) {
        is_open = timesData[site_vwid].is_open;
        infoText = timesData[site_vwid].status;

        branchInfoStatusItems = document.getElementsByClassName(branchInfoStatusGeneralClass);
        Object.keys(branchInfoStatusItems).forEach(function (key) {
            branchInfoStatusItems[key].innerHTML = infoText;
            if (is_open === 1) {
                branchInfoStatusItems[key].classList.remove(branchInfoStatusCloseClass);
                branchInfoStatusItems[key].classList.add(branchInfoStatusOpenClass);
            } else {
                branchInfoStatusItems[key].classList.remove(branchInfoStatusOpenClass);
                branchInfoStatusItems[key].classList.add(branchInfoStatusCloseClass);
            }
        });

        branchMapInfoStatusItems = document.getElementsByClassName(branchMapInfoStatusGeneralClass);
        Object.keys(branchMapInfoStatusItems).forEach(function (key) {
            branchMapInfoStatusItems[key].innerHTML = infoText;
            if (is_open === 1) {
                branchMapInfoStatusItems[key].classList.remove(branchMapInfoStatusCloseClass);
                branchMapInfoStatusItems[key].classList.add(branchMapInfoStatusOpenClass);
            } else {
                branchMapInfoStatusItems[key].classList.remove(branchMapInfoStatusOpenClass);
                branchMapInfoStatusItems[key].classList.add(branchMapInfoStatusCloseClass);
            }
        });
    });


    /**
     * Zendesk Chat Operation auf der Filialle Siete
     */
    if(window.location.hash) {
        let hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
        let urlParameters = {};
        hash.split('&').forEach(item => {
            urlParameters[item.split('=')[0]] = decodeURIComponent(item.split('=')[1]);
        });

        if ('openzendeskchat' in urlParameters && urlParameters.openzendeskchat === 'true') {
            if (fxxl_support_widget !== null) {
                let counterLimit = 60;

                let waitForZendeskChat = setInterval(function () {
                    if (fxxl_support_widget.zChatSetuped === true) {
                        clearInterval(waitForZendeskChat);
                        if (Object.keys(fxxlZopimChat).length > 0) {
                            zE('webWidget', 'chat:addTags', `Artikel: ${urlParameters.query_artnum} | Größe: ${urlParameters.groesse} | Farbe: ${urlParameters.farbe}`);
                            //zE('webWidget', 'chat:send', `Artikel: ${urlParameters.query_artnum} | Größe: ${urlParameters.groesse} | Farbe: ${urlParameters.farbe}`);
                            backgroundOverlayAnimation('start', true);
                            fxxl_support_widget.showzChatWindow();
                            document.addEventListener("mousemove", function() {
                                backgroundOverlayAnimation('stop', true);
                            }, {once : true});
                        }

                    } else {
                        if (counterLimit === 0) {
                            clearInterval(waitForZendeskChat);
                        }
                        counterLimit--;
                    }
                }, 1000);
            }
        } else {
            console.warn('FXXL JS ERROR: URL Parameter not found | 420_branch.js');
        }
    }
}
function fxxlSetFilterCookieForChosenBranch(branchId, active)
{
    var url = '/json.php?service=getBranch' + '&branch_id=' + branchId,
        branchCookieData = null;
    $.get(url, function (data) {
        if (data && data.fxxl_branch_category !== FxxlCore.getConfig().server.branch.category_name_to_value.coming_soon) {
            branchCookieData = {
                'c_branch_id': branchId,
                'ort': data.ort,
                'active': active,
                'set_narrower_branch': false,
                'urlkey': data.urlkey,
                'branch_link' : data.branchLink
            };
            setBranchFilterCookie(branchCookieData);
            return data;
        } else {
            return false;
        }
    });
}

$(window).on('load', function() {
    /**
     * Sea Mobile Popup Branch
     **/
    fxxlSetSeaMobileBranchPopup();
});

function fxxlSetSeaMobileBranchPopup()
{
    var filialeParam = getParameterByName('pmfiliale'),
        sea_branch_popup_mobile = $('.js_branch_popup_sea'),
        wg_aside_elem = $('.warengruppe-aside'),
        filiale, linkToBranch;

    if (filialeParam && sea_branch_popup_mobile.length > 0 && wg_aside_elem.length > 0) {
        filiale = validateBranchInfo(filialeParam);
        if (filiale > 0) {
            linkToBranch = sea_branch_popup_mobile.find('.sea_branch_link_js');
            $('#sea_branch_info_close_js').on('click', function () {
                sea_branch_popup_mobile.addClass('branch_popup_sea--hidden');
            });

            var request = '/json.php?service=getBranch&branch_id=' + filiale;
            jQuery.getJSON(request, function (response) {
                var url = location.protocol + '//' + location.host + '/' + response.branchAlias;
                linkToBranch.attr('href', url);
                sea_branch_popup_mobile.removeClass('branch_popup_sea--hidden');
                sea_branch_popup_mobile.addClass('branch_popup_sea--show');
                sea_branch_popup_mobile.insertBefore(wg_aside_elem);
            });
        }
    }
}
function fxxlCreateCollapsibleFootMenu() {
    var menuButton = $('#fxxl-footer-menu-button'),
        menuContainer = $('#fxxl-footer-menu-container');
    /**
     * Create Menu
     */
    $('.fxxl-footer__menu').each(function () {
        var container = $(this),
            collapsible = $('<ul class="collapsible"></ul>'),
            blockItem,
            collapsibleItem,
            collapsibleHeader,
            collapsibleBody,
            icon;

        menuButton.removeAttr('style');

        container.find('.fxxl-footer__menu-block').each(function () {
            blockItem = $(this);
            icon = $('<div class="collapsible__icon-container"><img class="collapsible__header-icon collapsible__header-icon--closed" ' +
                'src="/custom/module/public/fxxl3/assets/img/icons/chevron-down.svg" alt="open">' +
                '<img class="collapsible__header-icon collapsible__header-icon--opened" ' +
                'src="/custom/module/public/fxxl3/assets/img/icons/chevron-up.svg" alt="close">' +
                '</div>');

            const menuBlockItems = document.querySelectorAll('.fxxl-footer__menu-block-items');
            menuBlockItems.forEach(function(item) {
                item.classList.remove('fxxl-footer__menu-block-items--with-icon');
            });

            collapsibleItem = $('<li></li>');
            collapsibleHeader = $('<div class="collapsible-header"><div class="fxxl-container"></div></div>');
            collapsibleBody = $('<div class="collapsible-body"><div class="fxxl-container"></div></div>');
            collapsibleBody.find('>div').append(blockItem);
            collapsibleHeader.find('>div').append(collapsibleBody.find('img').first().prop('outerHTML'));
            collapsibleHeader.find('>div').append(collapsibleBody.find('strong').first().html());
            collapsibleHeader.append(icon);
            collapsibleBody.find('strong').first().remove();
            collapsibleBody.find('img').first().remove();

            collapsibleItem.append(collapsibleHeader);
            collapsibleItem.append(collapsibleBody);
            collapsible.append(collapsibleItem);
        });

        container.html('');
        container.append(collapsible);
    });

    /**
     * Collapsible
     */
    $('.fxxl-footer__menu .collapsible').collapsible();

    /**
     * Set Event
     */
    menuButton.on('click', function () {
        var button = $(this),
            animationSpeed = 0.25,
            cubicBezier = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

        button.css({
            'overflow': 'hidden', 'transition': 'padding ' + animationSpeed + 's ' + cubicBezier + ', ' +
                'opacity ' + animationSpeed + 's ' + cubicBezier
        });
        menuContainer.css({
            'display': 'block', 'overflow': 'hidden', 'height': 'auto', 'max-height': '0',
            'transition': 'max-height ' + (animationSpeed * 2) + 's ' + cubicBezier
        });

        setTimeout(function () {
            button.css({'padding': '0', 'opacity': '0'});
            menuContainer.css({'max-height': '1000px'});
        }, 10);

        return false;
    });
}

var FxxlFrameSizeCalculator = function FxxlFrameSizeCalculator() {
    function FxxlFrameSizeCalculator(element) {
        this.element = element;
        this.stepLengthElement = null;
        this.stepLengthSelector = '.frame-size-calculator__input-field';
        this.linkTextElement = null;
        this.linkTextSelector = '.fxxl-button__text';
        this.imageElement = null;
        this.imageSelector = '.frame-size-calculator__image';
        this.imageActiveClass = 'frame-size-calculator__image--active';
        this.errorElement = null;
        this.errorSelector = '.frame-size-calculator__error';
        this.errorActiveClass = 'frame-size-calculator__error--active';
        this.linkElement = null;
        this.linkSelector = '.frame-size-calculator__link';
        this.linkResultClass = 'frame-size-calculator__link-result';
        this.resultEtlement = null;
        this.resultSelector = '.frame-size-calculator__result';
        this.resultActiveClass = 'frame-size-calculator__result--active';
        this.resultSizeClass = 'frame-size-calculator__result-size';
        this.defaultResultText = '';
        this.elementType = null;
        this.elementAuxType = null;
        this.elementSplitedType = null;
        this.sortByValue = "?o=docscore";
        this.defaultResultTextUnit = 'cm';
        this.viewId = 0;
        this.lastResult = null;
        this.detectedSize = null;
        this.lastValidation = false;
        this.init();
    }

    FxxlFrameSizeCalculator.prototype.init = function init() {
        this.stepLengthElement = this.element.find(this.stepLengthSelector).find('input');
        this.linkTextElement = this.element.find(this.linkTextSelector);
        this.linkElement = this.element.find(this.linkSelector);
        this.imageElement = this.element.find(this.imageSelector);
        this.errorElement = this.element.find(this.errorSelector);
        this.resultEtlement = this.element.find(this.resultSelector);
        this.defaultResultText = this.resultEtlement.data('text');
        this.linkTextElement = this.linkElement.find(this.linkTextSelector);
        this.elementType = this.element.data('type');
        this.elementAuxType = this.elementType.split("_")[0];
        this.viewId = this.element.data('vw-id');
        this.setCalculatorType();
        this.events();

        if (this.stepLengthElement.val().trim().length > 0) {
            this.check();
        }
    };

    FxxlFrameSizeCalculator.prototype.events = function events() {
        var __this = this;
        this.stepLengthElement.on('input', function () {
           __this.stepLengthElement[0].fxxl_form_validation_object.isValid();
            __this.check();
        });

        this.element.on('submit', function () {
            if (__this.lastValidation === false) {
                return false;
            }
        });
    };

    FxxlFrameSizeCalculator.prototype.check = function check() {
        var linkAction;
        if (this.elementSplitedType === "koerpergroesse") {
            this.lastResult = this.getFrameSize(this.elementType, parseInt(this.stepLengthElement.val()));
        } else {
            this.lastResult = this.getFrameSize(this.elementAuxType, parseInt(this.stepLengthElement.val()));
        }

        if (this.lastResult !== false) {
            linkAction = this.element.attr('action');
            if (this.elementSplitedType === "rahmengroessen") {
                this.detectedSize = ( this.lastResult - 2) + ' - ' + ( this.lastResult + 2);
                if (linkAction.indexOf("strahmenhoehe") === -1) {
                    linkAction = linkAction.replace("rahmenhoehe", "strahmenhoehe");
                }
                linkAction = linkAction.split(".").slice(0, -1).join('.') + "." + ( this.lastResult + 2) + "-cm_" + ( this.lastResult + 1) + "-cm_" + this.lastResult + "-cm_" + (this.lastResult - 1) + "-cm_" + (this.lastResult - 2) + "-cm/" + this.sortByValue;
                this.element.attr("action", linkAction);
            } else if (this.elementSplitedType === "koerpergroesse") {
                this.detectedSize = this.lastResult + " Zoll";
                linkAction = linkAction.replace("rahmenhoehe", "radgroesse").split(".").slice(0, -1).join('.') + "." + this.lastResult + "-zoll/";
                this.element.attr("action", linkAction);
            }

            this.getArticleStock( this.lastResult, this.getName(linkAction));
            this.lastValidation = true;
        } else {
            this.notFoundResult();
            this.lastValidation = false;
        }
    };

    FxxlFrameSizeCalculator.prototype.setCalculatorType = function setCalculatorType() {
        if (this.elementType.split("koerpergroesse").length === 1) {
            this.elementSplitedType = "rahmengroessen";
        } else {
            this.elementSplitedType = "koerpergroesse";
        }
    };

    FxxlFrameSizeCalculator.prototype.getName = function getName(url) {
        var result = url.split("/");
        if (result[(result.length - 4)] === "rennraeder") {
            result = result[(result.length - 3)];
        }
        result = result[(result.length - 3)];
        return this.converUmlaut(result);
    };

    FxxlFrameSizeCalculator.prototype.converUmlaut = function converUmlaut(text) {
        return text.replace("ae", "ä").replace("oe", "ö").replace("ue", "ü");
    };

    FxxlFrameSizeCalculator.prototype.getArticleStock = function getArticleStock(frameSize, name) {
        var __this = this,
            request = '/json.php?service=getArticleStock&framesize='
                + frameSize + '&name=' + name + '&calculatorType=' + this.elementSplitedType + '&vw_id=' + this.viewId;
        $.getJSON(request, function (response) {
                if (parseInt(response.numAricleFounded) > 0) {
                    __this.foundResult();
                } else {
                    __this.notFoundResult();
                }
            }
        );
    };

    FxxlFrameSizeCalculator.prototype.foundResult = function foundResult() {
        this.imageElement.addClass(this.imageActiveClass);
        this.linkElement.prop('disabled', false);
        this.errorElement.removeClass(this.errorActiveClass);
        this.resultEtlement.html(this.defaultResultText + ' <span class="' + this.resultSizeClass + '">' + this.detectedSize  + ' '
            + this.defaultResultTextUnit + '</span>')
            .addClass(this.resultActiveClass);
    };

    FxxlFrameSizeCalculator.prototype.notFoundResult = function notFoundResult() {
        this.resultEtlement.removeClass(this.resultActiveClass);
        this.linkElement.prop('disabled', true);
        if (this.stepLengthElement.val().trim().length > 0) {
            this.errorElement.addClass(this.errorActiveClass);
        } else {
            this.errorElement.removeClass(this.errorActiveClass);
        }
    };

    FxxlFrameSizeCalculator.prototype.getFrameSize = function getFrameSize(bikeType, size) {
        var jugendrad = [];
        jugendrad[45] = 26;
        jugendrad[46] = 26;
        jugendrad[47] = 27;
        jugendrad[48] = 27;
        jugendrad[49] = 28;
        jugendrad[50] = 28;
        jugendrad[51] = 29;
        jugendrad[52] = 30;
        jugendrad[53] = 30;
        jugendrad[54] = 31;
        jugendrad[55] = 31;
        jugendrad[56] = 32;
        jugendrad[57] = 32;
        jugendrad[58] = 33;
        jugendrad[59] = 34;
        jugendrad[60] = 34;
        jugendrad[61] = 35;
        jugendrad[62] = 35;
        jugendrad[63] = 36;
        jugendrad[64] = 36;
        jugendrad[65] = 37;
        jugendrad[66] = 37;
        jugendrad[67] = 38;
        jugendrad[68] = 39;
        jugendrad[69] = 39;
        jugendrad[70] = 40;
        jugendrad[71] = 40;
        jugendrad[72] = 41;
        jugendrad[73] = 41;
        jugendrad[74] = 42;
        jugendrad[75] = 43;
        jugendrad[76] = 43;
        jugendrad[77] = 44;
        jugendrad[78] = 44;
        jugendrad[79] = 45;
        jugendrad[80] = 45;
        jugendrad[81] = 46;
        jugendrad[82] = 47;
        jugendrad[83] = 47;
        jugendrad[84] = 48;
        jugendrad[85] = 48;
        jugendrad[86] = 49;
        jugendrad[87] = 49;
        jugendrad[88] = 50;
        jugendrad[89] = 51;
        jugendrad[90] = 51;
        jugendrad[91] = 52;
        jugendrad[92] = 52;
        jugendrad[93] = 53;
        jugendrad[94] = 53;
        jugendrad[95] = 54;
        jugendrad[96] = 55;
        jugendrad[97] = 55;
        jugendrad[98] = 56;
        jugendrad[99] = 56;
        jugendrad[100] = 57;
        jugendrad[101] = 57;
        jugendrad[102] = 58;
        jugendrad[103] = 59;
        jugendrad[104] = 59;
        jugendrad[105] = 60;
        jugendrad[106] = 60;
        jugendrad[107] = 61;
        jugendrad[108] = 61;
        jugendrad[109] = 62;
        jugendrad[110] = 62;
        jugendrad[111] = 63;
        jugendrad[112] = 64;
        jugendrad[113] = 64;
        jugendrad[114] = 65;
        jugendrad[115] = 65;
        jugendrad[116] = 66;
        jugendrad[117] = 66;
        jugendrad[118] = 67;
        jugendrad[119] = 68;
        jugendrad[120] = 68;

        var rennradCyclocross = [];
        rennradCyclocross[50] = 33;
        rennradCyclocross[51] = 34;
        rennradCyclocross[52] = 35;
        rennradCyclocross[53] = 35;
        rennradCyclocross[54] = 36;
        rennradCyclocross[55] = 37;
        rennradCyclocross[56] = 37;
        rennradCyclocross[57] = 38;
        rennradCyclocross[58] = 39;
        rennradCyclocross[59] = 39;
        rennradCyclocross[60] = 40;
        rennradCyclocross[61] = 41;
        rennradCyclocross[62] = 41;
        rennradCyclocross[63] = 42;
        rennradCyclocross[64] = 43;
        rennradCyclocross[65] = 43;
        rennradCyclocross[66] = 44;
        rennradCyclocross[67] = 45;
        rennradCyclocross[68] = 45;
        rennradCyclocross[69] = 46;
        rennradCyclocross[70] = 47;
        rennradCyclocross[71] = 47;
        rennradCyclocross[72] = 48;
        rennradCyclocross[73] = 48;
        rennradCyclocross[74] = 49;
        rennradCyclocross[75] = 50;
        rennradCyclocross[76] = 51;
        rennradCyclocross[77] = 51;
        rennradCyclocross[78] = 52;
        rennradCyclocross[79] = 53;
        rennradCyclocross[80] = 53;
        rennradCyclocross[81] = 54;
        rennradCyclocross[82] = 55;
        rennradCyclocross[83] = 55;
        rennradCyclocross[84] = 56;
        rennradCyclocross[85] = 57;
        rennradCyclocross[86] = 57;
        rennradCyclocross[87] = 58;
        rennradCyclocross[88] = 59;
        rennradCyclocross[89] = 59;
        rennradCyclocross[90] = 60;
        rennradCyclocross[91] = 61;
        rennradCyclocross[92] = 61;
        rennradCyclocross[93] = 62;
        rennradCyclocross[94] = 63;
        rennradCyclocross[95] = 63;
        rennradCyclocross[96] = 64;
        rennradCyclocross[97] = 65;
        rennradCyclocross[98] = 65;
        rennradCyclocross[99] = 66;
        rennradCyclocross[100] = 67;
        rennradCyclocross[101] = 67;
        rennradCyclocross[102] = 68;
        rennradCyclocross[103] = 68;
        rennradCyclocross[104] = 69;
        rennradCyclocross[105] = 70;
        rennradCyclocross[106] = 70;
        rennradCyclocross[107] = 71;
        rennradCyclocross[108] = 72;
        rennradCyclocross[109] = 72;
        rennradCyclocross[110] = 73;
        rennradCyclocross[111] = 74;
        rennradCyclocross[112] = 74;
        rennradCyclocross[113] = 75;
        rennradCyclocross[114] = 76;
        rennradCyclocross[115] = 76;
        rennradCyclocross[116] = 77;
        rennradCyclocross[117] = 78;
        rennradCyclocross[118] = 78;
        rennradCyclocross[119] = 79;
        rennradCyclocross[120] = 80;

        var triathlonrad = [];
        triathlonrad[50] = 29;
        triathlonrad[51] = 30;
        triathlonrad[52] = 31;
        triathlonrad[53] = 31;
        triathlonrad[54] = 32;
        triathlonrad[55] = 33;
        triathlonrad[56] = 33;
        triathlonrad[57] = 34;
        triathlonrad[58] = 35;
        triathlonrad[59] = 35;
        triathlonrad[60] = 36;
        triathlonrad[61] = 37;
        triathlonrad[62] = 37;
        triathlonrad[63] = 38;
        triathlonrad[64] = 38;
        triathlonrad[65] = 39;
        triathlonrad[66] = 40;
        triathlonrad[67] = 41;
        triathlonrad[68] = 41;
        triathlonrad[69] = 42;
        triathlonrad[70] = 43;
        triathlonrad[71] = 43;
        triathlonrad[72] = 44;
        triathlonrad[73] = 44;
        triathlonrad[74] = 45;
        triathlonrad[75] = 46;
        triathlonrad[76] = 47;
        triathlonrad[77] = 47;
        triathlonrad[78] = 48;
        triathlonrad[79] = 49;
        triathlonrad[80] = 49;
        triathlonrad[81] = 50;
        triathlonrad[82] = 51;
        triathlonrad[83] = 51;
        triathlonrad[84] = 52;
        triathlonrad[85] = 53;
        triathlonrad[86] = 53;
        triathlonrad[87] = 54;
        triathlonrad[88] = 55;
        triathlonrad[89] = 55;
        triathlonrad[90] = 56;
        triathlonrad[91] = 57;
        triathlonrad[92] = 57;
        triathlonrad[93] = 58;
        triathlonrad[94] = 59;
        triathlonrad[95] = 59;
        triathlonrad[96] = 60;
        triathlonrad[97] = 61;
        triathlonrad[98] = 61;
        triathlonrad[99] = 62;
        triathlonrad[100] = 63;
        triathlonrad[101] = 63;
        triathlonrad[102] = 64;
        triathlonrad[103] = 65;
        triathlonrad[104] = 65;
        triathlonrad[105] = 66;
        triathlonrad[106] = 67;
        triathlonrad[107] = 68;
        triathlonrad[108] = 68;
        triathlonrad[109] = 69;
        triathlonrad[110] = 70;
        triathlonrad[111] = 70;
        triathlonrad[112] = 71;
        triathlonrad[113] = 72;
        triathlonrad[114] = 72;
        triathlonrad[115] = 73;
        triathlonrad[116] = 74;
        triathlonrad[117] = 74;
        triathlonrad[118] = 75;
        triathlonrad[119] = 76;
        triathlonrad[120] = 76;

        var hardtail = [];
        hardtail[50] = 29;
        hardtail[51] = 29;
        hardtail[52] = 30;
        hardtail[53] = 30;
        hardtail[54] = 31;
        hardtail[55] = 31;
        hardtail[56] = 32;
        hardtail[57] = 32;
        hardtail[58] = 33;
        hardtail[59] = 34;
        hardtail[60] = 34;
        hardtail[61] = 35;
        hardtail[62] = 35;
        hardtail[63] = 36;
        hardtail[64] = 36;
        hardtail[65] = 37;
        hardtail[66] = 37;
        hardtail[67] = 38;
        hardtail[68] = 39;
        hardtail[69] = 39;
        hardtail[70] = 40;
        hardtail[71] = 40;
        hardtail[72] = 41;
        hardtail[73] = 41;
        hardtail[74] = 42;
        hardtail[75] = 43;
        hardtail[76] = 43;
        hardtail[77] = 44;
        hardtail[78] = 44;
        hardtail[79] = 45;
        hardtail[80] = 45;
        hardtail[81] = 46;
        hardtail[82] = 47;
        hardtail[83] = 47;
        hardtail[84] = 48;
        hardtail[85] = 48;
        hardtail[86] = 49;
        hardtail[87] = 49;
        hardtail[88] = 50;
        hardtail[89] = 51;
        hardtail[90] = 51;
        hardtail[91] = 52;
        hardtail[92] = 52;
        hardtail[93] = 53;
        hardtail[94] = 53;
        hardtail[95] = 54;
        hardtail[96] = 55;
        hardtail[97] = 55;
        hardtail[98] = 56;
        hardtail[99] = 56;
        hardtail[100] = 57;
        hardtail[101] = 57;
        hardtail[102] = 58;
        hardtail[103] = 59;
        hardtail[104] = 59;
        hardtail[105] = 60;
        hardtail[106] = 60;
        hardtail[107] = 61;
        hardtail[108] = 61;
        hardtail[109] = 62;
        hardtail[110] = 62;
        hardtail[111] = 63;
        hardtail[112] = 64;
        hardtail[113] = 64;
        hardtail[114] = 65;
        hardtail[115] = 65;
        hardtail[116] = 66;
        hardtail[117] = 66;
        hardtail[118] = 67;
        hardtail[119] = 68;
        hardtail[120] = 68;

        var fully = [];
        fully[50] = 28;
        fully[51] = 29;
        fully[52] = 29;
        fully[53] = 30;
        fully[54] = 31;
        fully[55] = 31;
        fully[56] = 32;
        fully[57] = 32;
        fully[58] = 33;
        fully[59] = 33;
        fully[60] = 34;
        fully[61] = 34;
        fully[62] = 35;
        fully[63] = 36;
        fully[64] = 36;
        fully[65] = 37;
        fully[66] = 37;
        fully[67] = 38;
        fully[68] = 38;
        fully[69] = 39;
        fully[70] = 40;
        fully[71] = 40;
        fully[72] = 41;
        fully[73] = 41;
        fully[74] = 42;
        fully[75] = 42;
        fully[76] = 43;
        fully[77] = 44;
        fully[78] = 44;
        fully[79] = 45;
        fully[80] = 45;
        fully[81] = 46;
        fully[82] = 46;
        fully[83] = 47;
        fully[84] = 47;
        fully[85] = 48;
        fully[86] = 49;
        fully[87] = 49;
        fully[88] = 50;
        fully[89] = 50;
        fully[90] = 51;
        fully[91] = 51;
        fully[92] = 52;
        fully[93] = 53;
        fully[94] = 53;
        fully[95] = 54;
        fully[96] = 55;
        fully[97] = 55;
        fully[98] = 56;
        fully[99] = 56;
        fully[100] = 57;
        fully[101] = 57;
        fully[102] = 58;
        fully[103] = 59;
        fully[104] = 59;
        fully[105] = 60;
        fully[106] = 60;
        fully[107] = 61;
        fully[108] = 61;
        fully[109] = 62;
        fully[110] = 62;
        fully[111] = 63;
        fully[112] = 64;
        fully[113] = 64;
        fully[114] = 65;
        fully[115] = 65;
        fully[116] = 66;
        fully[117] = 66;
        fully[118] = 67;
        fully[119] = 68;
        fully[120] = 68;

        var fitnessCrossbike = [];
        fitnessCrossbike[50] = 31;
        fitnessCrossbike[51] = 31;
        fitnessCrossbike[52] = 32;
        fitnessCrossbike[53] = 33;
        fitnessCrossbike[54] = 33;
        fitnessCrossbike[55] = 34;
        fitnessCrossbike[56] = 34;
        fitnessCrossbike[57] = 35;
        fitnessCrossbike[58] = 36;
        fitnessCrossbike[59] = 36;
        fitnessCrossbike[60] = 37;
        fitnessCrossbike[61] = 38;
        fitnessCrossbike[62] = 38;
        fitnessCrossbike[63] = 39;
        fitnessCrossbike[64] = 39;
        fitnessCrossbike[65] = 40;
        fitnessCrossbike[66] = 41;
        fitnessCrossbike[67] = 41;
        fitnessCrossbike[68] = 42;
        fitnessCrossbike[69] = 42;
        fitnessCrossbike[70] = 43;
        fitnessCrossbike[71] = 44;
        fitnessCrossbike[72] = 44;
        fitnessCrossbike[73] = 45;
        fitnessCrossbike[74] = 46;
        fitnessCrossbike[75] = 46;
        fitnessCrossbike[76] = 47;
        fitnessCrossbike[77] = 47;
        fitnessCrossbike[78] = 48;
        fitnessCrossbike[79] = 49;
        fitnessCrossbike[80] = 49;
        fitnessCrossbike[81] = 50;
        fitnessCrossbike[82] = 50;
        fitnessCrossbike[83] = 51;
        fitnessCrossbike[84] = 52;
        fitnessCrossbike[85] = 52;
        fitnessCrossbike[86] = 53;
        fitnessCrossbike[87] = 54;
        fitnessCrossbike[88] = 54;
        fitnessCrossbike[89] = 55;
        fitnessCrossbike[90] = 55;
        fitnessCrossbike[91] = 56;
        fitnessCrossbike[92] = 57;
        fitnessCrossbike[93] = 57;
        fitnessCrossbike[94] = 58;
        fitnessCrossbike[95] = 58;
        fitnessCrossbike[96] = 59;
        fitnessCrossbike[97] = 60;
        fitnessCrossbike[98] = 60;
        fitnessCrossbike[99] = 61;
        fitnessCrossbike[100] = 62;
        fitnessCrossbike[101] = 62;
        fitnessCrossbike[102] = 63;
        fitnessCrossbike[103] = 63;
        fitnessCrossbike[104] = 64;
        fitnessCrossbike[105] = 65;
        fitnessCrossbike[106] = 65;
        fitnessCrossbike[107] = 66;
        fitnessCrossbike[108] = 66;
        fitnessCrossbike[109] = 67;
        fitnessCrossbike[110] = 68;
        fitnessCrossbike[111] = 68;
        fitnessCrossbike[112] = 69;
        fitnessCrossbike[113] = 69;
        fitnessCrossbike[114] = 70;
        fitnessCrossbike[115] = 71;
        fitnessCrossbike[116] = 71;
        fitnessCrossbike[117] = 72;
        fitnessCrossbike[118] = 73;
        fitnessCrossbike[119] = 73;
        fitnessCrossbike[120] = 74;

        var trekkingbite = [];
        trekkingbite[50] = 33;
        trekkingbite[51] = 33;
        trekkingbite[52] = 34;
        trekkingbite[53] = 34;
        trekkingbite[54] = 35;
        trekkingbite[55] = 36;
        trekkingbite[56] = 36;
        trekkingbite[57] = 37;
        trekkingbite[58] = 38;
        trekkingbite[59] = 38;
        trekkingbite[60] = 39;
        trekkingbite[61] = 40;
        trekkingbite[62] = 40;
        trekkingbite[63] = 41;
        trekkingbite[64] = 42;
        trekkingbite[65] = 42;
        trekkingbite[66] = 43;
        trekkingbite[67] = 44;
        trekkingbite[68] = 44;
        trekkingbite[69] = 45;
        trekkingbite[70] = 46;
        trekkingbite[71] = 46;
        trekkingbite[72] = 47;
        trekkingbite[73] = 47;
        trekkingbite[74] = 48;
        trekkingbite[75] = 49;
        trekkingbite[76] = 49;
        trekkingbite[77] = 50;
        trekkingbite[78] = 51;
        trekkingbite[79] = 51;
        trekkingbite[80] = 52;
        trekkingbite[81] = 53;
        trekkingbite[82] = 53;
        trekkingbite[83] = 54;
        trekkingbite[84] = 55;
        trekkingbite[85] = 55;
        trekkingbite[86] = 56;
        trekkingbite[87] = 57;
        trekkingbite[88] = 57;
        trekkingbite[89] = 58;
        trekkingbite[90] = 59;
        trekkingbite[91] = 59;
        trekkingbite[92] = 60;
        trekkingbite[93] = 60;
        trekkingbite[94] = 61;
        trekkingbite[95] = 62;
        trekkingbite[96] = 62;
        trekkingbite[97] = 63;
        trekkingbite[98] = 64;
        trekkingbite[99] = 64;
        trekkingbite[100] = 65;
        trekkingbite[101] = 66;
        trekkingbite[102] = 66;
        trekkingbite[103] = 67;
        trekkingbite[104] = 68;
        trekkingbite[105] = 68;
        trekkingbite[106] = 69;
        trekkingbite[107] = 70;
        trekkingbite[108] = 70;
        trekkingbite[109] = 71;
        trekkingbite[110] = 72;
        trekkingbite[111] = 72;
        trekkingbite[112] = 73;
        trekkingbite[113] = 73;
        trekkingbite[114] = 74;
        trekkingbite[115] = 75;
        trekkingbite[116] = 75;
        trekkingbite[117] = 76;
        trekkingbite[118] = 77;
        trekkingbite[119] = 77;
        trekkingbite[120] = 78;

        var cityBike = [];
        cityBike[50] = 33;
        cityBike[51] = 33;
        cityBike[52] = 34;
        cityBike[53] = 34;
        cityBike[54] = 35;
        cityBike[55] = 36;
        cityBike[56] = 36;
        cityBike[57] = 37;
        cityBike[58] = 38;
        cityBike[59] = 38;
        cityBike[60] = 39;
        cityBike[61] = 40;
        cityBike[62] = 40;
        cityBike[63] = 41;
        cityBike[64] = 42;
        cityBike[65] = 42;
        cityBike[66] = 43;
        cityBike[67] = 44;
        cityBike[68] = 44;
        cityBike[69] = 45;
        cityBike[70] = 46;
        cityBike[71] = 46;
        cityBike[72] = 47;
        cityBike[73] = 47;
        cityBike[74] = 48;
        cityBike[75] = 49;
        cityBike[76] = 49;
        cityBike[77] = 50;
        cityBike[78] = 51;
        cityBike[79] = 51;
        cityBike[80] = 52;
        cityBike[81] = 53;
        cityBike[82] = 53;
        cityBike[83] = 54;
        cityBike[84] = 55;
        cityBike[85] = 55;
        cityBike[86] = 56;
        cityBike[87] = 57;
        cityBike[88] = 57;
        cityBike[89] = 58;
        cityBike[90] = 59;
        cityBike[91] = 59;
        cityBike[92] = 60;
        cityBike[93] = 60;
        cityBike[94] = 61;
        cityBike[95] = 62;
        cityBike[96] = 62;
        cityBike[97] = 63;
        cityBike[98] = 64;
        cityBike[99] = 64;
        cityBike[100] = 65;
        cityBike[101] = 66;
        cityBike[102] = 66;
        cityBike[103] = 67;
        cityBike[104] = 68;
        cityBike[105] = 68;
        cityBike[106] = 69;
        cityBike[107] = 70;
        cityBike[108] = 70;
        cityBike[109] = 71;
        cityBike[110] = 72;
        cityBike[111] = 72;
        cityBike[112] = 73;
        cityBike[113] = 73;
        cityBike[114] = 74;
        cityBike[115] = 75;
        cityBike[116] = 75;
        cityBike[117] = 76;
        cityBike[118] = 77;
        cityBike[119] = 77;
        cityBike[120] = 78;

        var singlespeedBikeFixie = [];
        singlespeedBikeFixie[50] = 33;
        singlespeedBikeFixie[51] = 34;
        singlespeedBikeFixie[52] = 35;
        singlespeedBikeFixie[53] = 35;
        singlespeedBikeFixie[54] = 36;
        singlespeedBikeFixie[55] = 37;
        singlespeedBikeFixie[56] = 37;
        singlespeedBikeFixie[57] = 38;
        singlespeedBikeFixie[58] = 39;
        singlespeedBikeFixie[59] = 39;
        singlespeedBikeFixie[60] = 40;
        singlespeedBikeFixie[61] = 41;
        singlespeedBikeFixie[62] = 41;
        singlespeedBikeFixie[63] = 42;
        singlespeedBikeFixie[64] = 43;
        singlespeedBikeFixie[65] = 43;
        singlespeedBikeFixie[66] = 44;
        singlespeedBikeFixie[67] = 45;
        singlespeedBikeFixie[68] = 45;
        singlespeedBikeFixie[69] = 46;
        singlespeedBikeFixie[70] = 47;
        singlespeedBikeFixie[71] = 47;
        singlespeedBikeFixie[72] = 48;
        singlespeedBikeFixie[73] = 48;
        singlespeedBikeFixie[74] = 49;
        singlespeedBikeFixie[75] = 50;
        singlespeedBikeFixie[76] = 51;
        singlespeedBikeFixie[77] = 51;
        singlespeedBikeFixie[78] = 52;
        singlespeedBikeFixie[79] = 53;
        singlespeedBikeFixie[80] = 53;
        singlespeedBikeFixie[81] = 54;
        singlespeedBikeFixie[82] = 55;
        singlespeedBikeFixie[83] = 55;
        singlespeedBikeFixie[84] = 56;
        singlespeedBikeFixie[85] = 57;
        singlespeedBikeFixie[86] = 57;
        singlespeedBikeFixie[87] = 58;
        singlespeedBikeFixie[88] = 59;
        singlespeedBikeFixie[89] = 59;
        singlespeedBikeFixie[90] = 60;
        singlespeedBikeFixie[91] = 61;
        singlespeedBikeFixie[92] = 61;
        singlespeedBikeFixie[93] = 62;
        singlespeedBikeFixie[94] = 63;
        singlespeedBikeFixie[95] = 63;
        singlespeedBikeFixie[96] = 64;
        singlespeedBikeFixie[97] = 65;
        singlespeedBikeFixie[98] = 65;
        singlespeedBikeFixie[99] = 66;
        singlespeedBikeFixie[100] = 67;
        singlespeedBikeFixie[101] = 67;
        singlespeedBikeFixie[102] = 68;
        singlespeedBikeFixie[103] = 68;
        singlespeedBikeFixie[104] = 69;
        singlespeedBikeFixie[105] = 70;
        singlespeedBikeFixie[106] = 70;
        singlespeedBikeFixie[107] = 71;
        singlespeedBikeFixie[108] = 72;
        singlespeedBikeFixie[109] = 72;
        singlespeedBikeFixie[110] = 73;
        singlespeedBikeFixie[111] = 74;
        singlespeedBikeFixie[112] = 74;
        singlespeedBikeFixie[113] = 75;
        singlespeedBikeFixie[114] = 76;
        singlespeedBikeFixie[115] = 76;
        singlespeedBikeFixie[116] = 77;
        singlespeedBikeFixie[117] = 78;
        singlespeedBikeFixie[118] = 78;
        singlespeedBikeFixie[119] = 79;
        singlespeedBikeFixie[120] = 80;

        var kinderfahrraeder = [];
        kinderfahrraeder[95] = 12;
        kinderfahrraeder[96] = 12;
        kinderfahrraeder[97] = 12;
        kinderfahrraeder[98] = 12;
        kinderfahrraeder[99] = 12;
        kinderfahrraeder[100] = 14;
        kinderfahrraeder[101] = 14;
        kinderfahrraeder[102] = 14;
        kinderfahrraeder[103] = 14;
        kinderfahrraeder[104] = 14;
        kinderfahrraeder[105] = 16;
        kinderfahrraeder[106] = 16;
        kinderfahrraeder[107] = 16;
        kinderfahrraeder[108] = 16;
        kinderfahrraeder[109] = 16;
        kinderfahrraeder[110] = 18;
        kinderfahrraeder[111] = 18;
        kinderfahrraeder[112] = 18;
        kinderfahrraeder[113] = 18;
        kinderfahrraeder[114] = 18;
        kinderfahrraeder[115] = 18;
        kinderfahrraeder[116] = 18;
        kinderfahrraeder[117] = 18;
        kinderfahrraeder[118] = 18;
        kinderfahrraeder[119] = 18;
        kinderfahrraeder[120] = 20;
        kinderfahrraeder[121] = 20;
        kinderfahrraeder[122] = 20;
        kinderfahrraeder[123] = 20;
        kinderfahrraeder[124] = 20;
        kinderfahrraeder[125] = 20;
        kinderfahrraeder[126] = 20;
        kinderfahrraeder[127] = 20;
        kinderfahrraeder[128] = 20;
        kinderfahrraeder[129] = 20;
        kinderfahrraeder[130] = 20;
        kinderfahrraeder[131] = 20;
        kinderfahrraeder[132] = 20;
        kinderfahrraeder[133] = 20;
        kinderfahrraeder[134] = 20;
        kinderfahrraeder[135] = 24;
        kinderfahrraeder[136] = 24;
        kinderfahrraeder[137] = 24;
        kinderfahrraeder[138] = 24;
        kinderfahrraeder[139] = 24;

        var result = "";
        switch (bikeType) {
            case "jugendrad":
                result = jugendrad[size];
                break;

            case "rennradCyclocross":
                result = rennradCyclocross[size];
                break;

            case "triathlonrad":
                result = triathlonrad[size];
                break;

            case "hardtail":
                result = hardtail[size];
                break;

            case "fully":
                result = fully[size];
                break;

            case "fitnessCrossbike":
                result = fitnessCrossbike[size];
                break;

            case "trekkingbite":
                result = trekkingbite[size];
                break;

            case "cityBike":
                result = cityBike[size];
                break;

            case "singlespeedBikeFixie":
                result = singlespeedBikeFixie[size];
                break;

            case "koerpergroesse_kinderfahrraeder":
                result = kinderfahrraeder[size];
                break;

            default:
                result = false;
        }
        if (result === undefined) {
            return false;
        } else {
            return result;
        }
    };

    return FxxlFrameSizeCalculator;
}();
var fxxlArtikelBranchInventoryLastObject = null,
    fxxlArtikelBranchInventoryApiUrl = '/json.php?service=branchInventoryActions&',
    fxxlArtikelBranchInventoryApiTabParm = 'tab=',
    fxxlArtikelBranchInventoryApiOrtParm = 'ort=',
    fxxlArtikelBranchInventoryMainMapInited = false;

fxxlSetupArtikleMatrix();

var FxxlSetupArtikleBranchInventory = function FxxlSetupArtikleBranchInventory() {
    function FxxlSetupArtikleBranchInventory(element) {
        this.element = element;
        this.tablClass = 'fxxl-branch-availability-tabs';
        this.inventoryTabId = '';
        this.matrixTabId = '';
        this.inventoryTabCookieId = 'fxxl_branch_availability_inventory';
        this.matrixTabCookieId = 'fxxl_branch_availability_matrix';
        this.branchInventoryClass = 'fxxl-branch-inventory';
        this.tabElement = null;
        this.inventoryTabElement = null;
        this.matrixTabElement = null;
        this.artikelBranchInventoryElements = null;
        this.isEventCreated = false;
        this.branchInventoryFirstInited = false;
        this.branchActiveSelectTabAutomatic = true;
        this.branchInventoryTabInstance = undefined;
        this.init();
    }

    FxxlSetupArtikleBranchInventory.prototype.init = function init() {
        var temp = this.element.getElementsByClassName(this.tablClass);
        if (temp.length > 0) {
            this.tabElement = temp[0];
        }

        if (this.tabElement !== null) {
            this.inventoryTabElement = this.tabElement.querySelector('li:nth-of-type(1) > a');
            this.matrixTabElement = this.tabElement.querySelector('li:nth-of-type(2) > a');
            this.inventoryTabId = this.inventoryTabElement.getAttribute('href').replace(/#/, '');
            this.matrixTabId = this.matrixTabElement.getAttribute('href').replace(/#/, '');
            this.artikelBranchInventoryElements = this.element.getElementsByClassName(this.branchInventoryClass);
            this.setupBranchInventories();
            this.setWatcher();
            this.registerVariantChangedListener();
        }
    };

    FxxlSetupArtikleBranchInventory.prototype.setupBranchInventories = function setupBranchInventories() {
        var __this = this;
        this.branchInventoryTabInstance = M.Tabs.getInstance(this.tabElement);
        Array.prototype.forEach.call(this.artikelBranchInventoryElements, function (element) {
            element.fxxlBranchInventoryObject = new FxxlBranchInventorySetup(element, __this.branchInventoryTabInstance);
        });
    };

    FxxlSetupArtikleBranchInventory.prototype.setupAfterShow = function setupAfterShow() {
        Array.prototype.forEach.call(this.artikelBranchInventoryElements, function (element) {
            element.fxxlBranchInventoryObject.setupAfterShow();
        });
    };

    FxxlSetupArtikleBranchInventory.prototype.setWatcher = function setWatcher() {
        var __this = this,
            branchInventoryLastClickedTabLink = '',
            observer = new window.MutationObserver(function () {
                if (__this.element.classList.contains('open') === true) {
                    if (typeof FxxlPersonalData !== 'undefined') {
                        if (typeof FxxlPersonalData.branchInventory !== 'undefined') {
                            if (FxxlPersonalData.branchInventory.tab === __this.matrixTabCookieId && isLargeViewport() === true && __this.branchActiveSelectTabAutomatic === true) {
                                __this.branchInventoryTabInstance.select(__this.matrixTabId);
                            } else {
                                __this.setupAfterShow();
                                if (__this.branchActiveSelectTabAutomatic === true) {
                                    __this.branchInventoryTabInstance.select(__this.inventoryTabId);
                                }
                                __this.branchInventoryFirstInited = true;
                            }
                        }

                        setTimeout(function () {
                            requestAnimationFrame(function () {
                                __this.branchInventoryTabInstance.updateTabIndicator();
                            });
                        }, 200);
                    }

                    if (__this.isEventCreated === false) {
                        __this.isEventCreated = true;
                        __this.inventoryTabElement.addEventListener('click', function (e) {
                            if (__this.branchInventoryFirstInited === false) {
                                __this.branchInventoryFirstInited = true;
                                __this.setupAfterShow();
                            }
                            if (branchInventoryLastClickedTabLink !== e.target.href) {
                                branchInventoryLastClickedTabLink = e.target.href;
                                FxxlPersonalData.branchInventory.tab = __this.inventoryTabCookieId;
                                fetch(fxxlArtikelBranchInventoryApiUrl + fxxlArtikelBranchInventoryApiTabParm + __this.inventoryTabCookieId).then();
                            }
                        });

                        __this.matrixTabElement.addEventListener('click', function (e) {
                            if (branchInventoryLastClickedTabLink !== e.target.href) {
                                branchInventoryLastClickedTabLink = e.target.href;
                                FxxlPersonalData.branchInventory.tab = __this.matrixTabCookieId;
                                fetch(fxxlArtikelBranchInventoryApiUrl + fxxlArtikelBranchInventoryApiTabParm + __this.matrixTabCookieId).then();
                            }
                        });
                    }
                    __this.branchActiveSelectTabAutomatic = false;
                }
            });
        observer.observe(this.element, {attributes: true, childList: false, attributeFilter: ['class']});
    };

    FxxlSetupArtikleBranchInventory.prototype.registerVariantChangedListener = function registerVariantChangedListener() {
        const pdsVariantSelector = document.querySelector('.pvd-vs');
        if (pdsVariantSelector !== null) {
            // PDS: Variantenselektor
            pdsVariantSelector.addEventListener('fxxl-variant-selector_changed', (e) => {
                this.onVariantSelectionHasChanged();
            });
        } else {
            // Produktvergleich, Merkliste: Select-Feld
            const mainProductId = this.artikelBranchInventoryElements[0]?.dataset?.mainId;
            if (typeof mainProductId === 'string') {
                document.getElementById('variant-select-' + mainProductId)?.addEventListener('change', (e) => {
                    this.onVariantSelectionHasChanged();
                });
            }
        }
    }

    FxxlSetupArtikleBranchInventory.prototype.onVariantSelectionHasChanged = function onVariantSelectionHasChanged() {
        this.branchInventoryTabInstance.select(this.inventoryTabId);
    }

    return FxxlSetupArtikleBranchInventory;
}();

var FxxlBranchInventorySetup = function FxxlBranchInventorySetup() {
    function FxxlBranchInventorySetup(element, tabInstance) {
        this.element = element;
        this.tabInstance = tabInstance;
        this.colorContainer = null;
        this.colorItems = null;
        this.colorBar = null;
        this.colorTitle = null;
        this.hiddenClass = 'fxxl-hidden';
        this.branchInventoryMobileClass = 'fxxl-branch-inventory--mobile';
        this.branchInventoryDesktopClass = 'fxxl-branch-inventory--desktop';
        this.colorContainerClass = 'fxxl-branch-inventory-content--color';
        this.colorContainerClass = 'fxxl-branch-inventory-content--color';
        this.contentItemsClass = 'fxxl-branch-inventory-content__item';
        this.contentItemsHideClass = 'fxxl-branch-inventory-content__item--hide';
        this.contentBarClass = 'fxxl-branch-inventory-content__bar';
        this.contentBarShowClass = 'fxxl-branch-inventory-content__bar--show';
        this.contentTitleClass = 'fxxl-branch-inventory-content__title';
        this.contentTitleSeparatorClass = 'fxxl-branch-inventory-content__title__separator';
        this.contentTitleSuffixClass = 'fxxl-branch-inventory-content__title__suffix';
        this.sizeContainer = null;
        this.sizeItems = null;
        this.sizeBar = null;
        this.sizeContainerClass = 'fxxl-branch-inventory-content--size';
        this.colorBarObject = null;
        this.sizeBarObject = null;
        this.defaultColorItem = null;
        this.defaultSizeItem = null;
        this.linkElement = null;
        this.linkClass = 'fxxl-branch-inventory-link';
        this.resultElement = null;
        this.resultClass = 'fxxl-branch-inventory__result';
        this.resultShowClass = 'fxxl-branch-inventory__result--show';
        this.searchInputElement = null;
        this.searchInputClass = 'fxxl-branch-inventory-content__search';
        this.searchButtonElement = null;
        this.searchButtonClass = 'fxxl-branch-inventory-content__search-button';
        this.mapElement = null;
        this.mapClass = 'fxxl-branch-inventory__map';
        this.apiUrl = '/json.php?service=findNearestBranches&limit=100';
        this.mapIconSetting = [];
        this.map = null;
        this.mapMarkersIcon = [];
        this.branchShowClass = 'fxxl-branch-inventory--show';
        this.branchItemElements = null;
        this.branchItemClass = 'fxxl-branch-inventory-item';
        this.branchListElement = null;
        this.branchListClass = 'fxxl-branch-inventory-branches__content';
        this.branchListTitleElement = null;
        this.branchListTitleClass = 'fxxl-branch-inventory-branches__title';
        this.branchListSmallTitleClass = 'fxxl-branch-inventory-branches__title--small';
        this.branchErrorElement = null;
        this.branchErrorClass = 'fxxl-branch-inventory-content__error';
        this.branchErrorShowClass = 'fxxl-branch-inventory-content__error--show';
        this.branchBlockElement = null;
        this.branchBlockClass = 'fxxl-branch-inventory-block--template';
        this.branchBlockFadeOutClass = 'fxxl-branch-inventory-block--fadeOut';
        this.branchBlockAvailableContentClass = 'fxxl-branch-inventory-block__content--available';
        this.branchBlockInquiryContentClass = 'fxxl-branch-inventory-block__content--inquiry';
        this.branchBlockFormInquiryContentClass = 'fxxl-branch-inventory-block__info--inquiry';
        this.branchBlockChatInquiryContentClass = 'fxxl-branch-inventory-block__info--openchat';
        this.branchBlockNotAvailableContentClass = 'fxxl-branch-inventory-block__content--not-available';
        this.branchBlockTelIconClass = 'fxxl-branch-inventory-block__contact-icon--tel';
        this.branchBlockInfoIconClass = 'fxxl-branch-inventory-block__contact-icon--info';
        this.branchBlockContactContentClass = 'fxxl-branch-inventory-block__content--contact';
        this.branchBlockSizeSelectorClass = '.pvd-vs__active select.pvd-vs__l2-select';
        this.branchBlockColorSelectorClass = '.pvd-vs__slider > .pvd-vs__active';
        this.branchItemStatusAvailableClass = 'fxxl-branch-inventory-item__status--available';
        this.branchItemStatusInquiryClass = 'fxxl-branch-inventory-item__status--inquiry';
        this.branchItemStatusNotAvailableClass = 'fxxl-branch-inventory-item__status--not-available';
        this.branchItemAvailableClass = 'fxxl-branch-inventory-item--available';
        this.branchItemInquiryClass = 'fxxl-branch-inventory-item--inquiry';
        this.branchItemNotAvailableClass = 'fxxl-branch-inventory-item--not-available';
        this.branchItemLinkClass = 'fxxl-branch-inventory-item__status-link';
        this.minAvailableLimit = 0;
        this.maxAvailableLimit = 0;
        this.branchDistanceData = null;
        this.lastSelectedMarkerPosition = null;
        this.lastSelectedMarker = null;
        this.allMarkers = [];
        this.isMobileVersion = true;
        this.mainProductId = 0;
        this.mainProductNumber = '';
        this.lastSelectedFirstSizeItem = null;
        this.fxxlArtikelBranchInventoryVariantListColors = null;
        this.fxxlArtikelBranchInventoryVariantListSizes = null;
        this.fxxlArtikelBranchInventoryVariantStatuses = null;
        this.fxxlArtikelBranchInventoryVariantStockes = null;
        this.fxxlArtikelBranchInventoryBranchInfos = null;
        this.fxxlArtikelBranchInventoryVariantInquiryUrls = null;
        this.fxxlArtikelBranchInventoryName = null;
        this.mapInited = false;
        /**
         * Global-Variable in fxxl_branch_inventory.tpl
         */
        if (typeof fxxlArtikelBranchInventoryVariantListColors !== 'undefined'
            && typeof fxxlArtikelBranchInventoryVariantListSizes !== 'undefined'
            && typeof fxxlArtikelBranchInventoryMapApiKey !== 'undefined'
            && typeof fxxlArtikelBranchInventoryVariantStatuses !== 'undefined'
            && typeof fxxlArtikelBranchInventoryName !== 'undefined'
            && typeof fxxlArtikelBranchInventoryMaxAvailableLimit !== 'undefined'
            && typeof fxxlArtikelBranchInventoryVariantInquiryUrls !== 'undefined'
            && typeof fxxlArtikelBranchInventoryContactHelpText !== 'undefined'
            && typeof fxxlArtikelBranchInventoryBranchInfos !== 'undefined'
            && typeof fxxlArtikelBranchInventoryVariantStockes !== 'undefined') {
            this.init();
            if (this.element.classList.contains(this.branchInventoryDesktopClass) === true) {
                this.isMobileVersion = false;
                this.initDesktopVersion();
            }
        }
    }

    FxxlBranchInventorySetup.prototype.init = function init() {
        var temp;
        this.branchItemElements = this.element.getElementsByClassName(this.branchItemClass);
        this.mainProductId = this.element.getAttribute('data-main-id');
        this.mainProductNumber = this.element.getAttribute('data-art-num');

        this.fxxlArtikelBranchInventoryVariantListColors = fxxlArtikelBranchInventoryVariantListColors[this.mainProductId];
        this.fxxlArtikelBranchInventoryVariantListSizes = fxxlArtikelBranchInventoryVariantListSizes[this.mainProductId];
        this.fxxlArtikelBranchInventoryVariantStatuses = fxxlArtikelBranchInventoryVariantStatuses[this.mainProductId];
        this.fxxlArtikelBranchInventoryVariantStockes = fxxlArtikelBranchInventoryVariantStockes[this.mainProductId];
        this.fxxlArtikelBranchInventoryBranchInfos = fxxlArtikelBranchInventoryBranchInfos[this.mainProductId];
        this.fxxlArtikelBranchInventoryVariantInquiryUrls = fxxlArtikelBranchInventoryVariantInquiryUrls[this.mainProductId];
        this.fxxlArtikelBranchInventoryName = fxxlArtikelBranchInventoryName[this.mainProductId];

        temp = fxxlArtikelBranchInventoryMaxAvailableLimit.split('-');
        if (temp.length === 2) {
            this.minAvailableLimit = parseInt(temp[0]);
            this.maxAvailableLimit = parseInt(temp[1]);
        }
    };

    FxxlBranchInventorySetup.prototype.searchMyBranch = function searchMyBranch() {
        var branchId,
            branchPlz,
            branchOrt,
            ort = '';
        if (typeof FxxlPersonalData !== 'undefined' && this.searchInputElement.value.trim().length === 0) {
            if (FxxlPersonalData.branchInventory !== null) {
                if (typeof FxxlPersonalData.branchInventory.ort !== 'undefined') {
                    ort = FxxlPersonalData.branchInventory.ort;
                }
            }
            if (FxxlPersonalData.branchfilterdata !== null) {
                if (typeof FxxlPersonalData.branchfilterdata.branchId !== 'undefined' && ort === '') {
                    branchId = FxxlPersonalData.branchfilterdata.branchId;
                    branchOrt = FxxlPersonalData.branchfilterdata.branch_ort;
                    if (typeof this.fxxlArtikelBranchInventoryBranchInfos[branchId] !== 'undefined') {
                        branchPlz = this.fxxlArtikelBranchInventoryBranchInfos[branchId].plz;
                        ort = branchOrt + ' ' + branchPlz;
                    }
                }
            }
        }

        if (ort !== '') {
            this.searchInputElement.value = ort;
            this.searchInputElement.focus();
            this.searchButtonElement.click();
        }
    };

    FxxlBranchInventorySetup.prototype.initDesktopVersion = function initDesktopVersion() {
        var temp;
        this.searchInputElement = this.element.querySelector('.' + this.searchInputClass + ' input');
        temp = this.element.getElementsByClassName(this.searchButtonClass);
        if (temp.length > 0) {
            this.searchButtonElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.mapClass);
        if (temp.length > 0) {
            this.mapElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.branchBlockClass);
        if (temp.length > 0) {
            this.branchBlockElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.branchListClass);
        if (temp.length > 0) {
            this.branchListElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.branchListTitleClass);
        if (temp.length > 0) {
            this.branchListTitleElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.branchErrorClass);
        if (temp.length > 0) {
            this.branchErrorElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.resultClass);
        if (temp.length > 0) {
            this.resultElement = temp[0];
        }
        temp = this.element.getElementsByClassName(this.linkClass);
        if (temp.length > 0) {
            this.linkElement = temp[0];
        }

        this.initColorContainer();
        this.initSizeContainer();
        this.setupMapIcons();
        this.setEvents();
    };

    FxxlBranchInventorySetup.prototype.setupMobileList = function setupMobileList() {
        var __this = this,
            statusText,
            branchId,
            status,
            branchStokes,
            linkElement,
            filialeLinkElement,
            linkContainer,
            variantId = this.getDefaultSizeVariantId();

        if (variantId !== null && variantId !== null) {

            Array.prototype.forEach.call(this.branchItemElements, function (item) {
                branchId = item.getAttribute('data-id');
                branchStokes = __this.getBranchStock(branchId, variantId);
                status = __this.getStatus(variantId, branchId);

                if (status === 1) {
                    item.classList.remove(__this.branchItemInquiryClass, __this.branchItemNotAvailableClass);
                    item.classList.add(__this.branchItemAvailableClass);
                    item.querySelector('.' + __this.branchItemStatusAvailableClass).classList.remove(__this.hiddenClass);
                    item.querySelector('.' + __this.branchItemStatusInquiryClass).classList.add(__this.hiddenClass);
                    item.querySelector('.' + __this.branchItemStatusNotAvailableClass).classList.add(__this.hiddenClass);
                } else if (status === 2) {
                    item.classList.remove(__this.branchItemAvailableClass, __this.branchItemNotAvailableClass);
                    item.classList.add(__this.branchItemInquiryClass);
                    item.querySelector('.' + __this.branchItemStatusInquiryClass).classList.remove(__this.hiddenClass);
                    item.querySelector('.' + __this.branchItemStatusAvailableClass).classList.add(__this.hiddenClass);
                    item.querySelector('.' + __this.branchItemStatusNotAvailableClass).classList.add(__this.hiddenClass);
                } else {
                    item.classList.remove(__this.branchItemInquiryClass, __this.branchItemAvailableClass);
                    item.classList.add(__this.branchItemNotAvailableClass);
                    item.querySelector('.' + __this.branchItemStatusNotAvailableClass).classList.remove(__this.hiddenClass);
                    item.querySelector('.' + __this.branchItemStatusAvailableClass).classList.add(__this.hiddenClass);
                    item.querySelector('.' + __this.branchItemStatusInquiryClass).classList.add(__this.hiddenClass);
                }

                if (status === 1) {
                    if (branchStokes < __this.maxAvailableLimit) {
                        statusText = fxxlArtikelBranchInventoryAvailableLimitText;
                        statusText = statusText.replace(/###stockes###/, branchStokes);
                    } else {
                        statusText = fxxlArtikelBranchInventoryAvailableText;
                    }
                    item.innerHTML = item.innerHTML.replace(/###status-text###/g, statusText);
                } else if (status === 2) {
                    linkElement = document.createElement('a');
                    linkElement.href = __this.getInquiryLink(variantId, branchId);
                    linkElement.classList.add('ajax', 'fxxl-branch-inventory-item__status-text', 'fxxl-branch-inventory-item__status--openform');
                    linkElement.setAttribute('data-branch-id', branchId);
                    linkElement.setAttribute('data-template', 'artikel/json_artikel_probefahrt');
                    linkElement.innerHTML = fxxlArtikelBranchInventoryInquiryMobileText;
                    linkContainer = item.querySelector('.' + __this.branchItemLinkClass);
                    linkContainer.innerHTML = '';
                    linkContainer.appendChild(linkElement.cloneNode(true));

                    // Link zur Filiale siete und zendeskchat popup
                    filialeLinkElement = document.createElement('a');
                    filialeLinkElement.href = __this.getFilialeLink(variantId, branchId);
                    filialeLinkElement.classList.add('fxxl-hidden', 'fxxl-branch-inventory-item__status--openchat');
                    filialeLinkElement.setAttribute('data-art-num', __this.mainProductNumber);
                    filialeLinkElement.setAttribute('data-branch-id', branchId);
                    filialeLinkElement.setAttribute('data-branch-code', fxxlBranchUrlKeys[branchId]);
                    filialeLinkElement.setAttribute('target', '_blank');
                    filialeLinkElement.innerHTML = fxxlArtikelBranchInventoryChatInquiryText;
                    linkContainer.appendChild(filialeLinkElement.cloneNode(true));
                    __this.decideInquiryType({}, branchId);
                }
            });
            setupJsonHandler(this.element);
            this.element.classList.add(this.branchShowClass);
        }
    };

    FxxlBranchInventorySetup.prototype.getInquiryLink = function getInquiryLink(variantId, branchId) {
        var link = '';
        if (typeof this.fxxlArtikelBranchInventoryVariantInquiryUrls[variantId] !== 'undefined') {
            if (typeof this.fxxlArtikelBranchInventoryVariantInquiryUrls[variantId][branchId] !== 'undefined') {
                link = this.fxxlArtikelBranchInventoryVariantInquiryUrls[variantId][branchId];
            }
        }
        return link;
    };

    FxxlBranchInventorySetup.prototype.getFilialeLink = function getFilialeLink(variantId, branchId) {
        var link = '',
            fragment;

        fragment = '#openzendeskchat=true&query_artnum=' + this.mainProductNumber;

        if (typeof this.fxxlArtikelBranchInventoryVariantListSizes[variantId] !== 'undefined') {
            fragment += '&groesse=' + this.fxxlArtikelBranchInventoryVariantListSizes[variantId];
        }

        if (typeof this.fxxlArtikelBranchInventoryVariantListColors[variantId] !== 'undefined') {
            fragment += '&farbe=' + this.fxxlArtikelBranchInventoryVariantListColors[variantId];
        }

        link = fxxlBranchUrls[branchId] + fragment;
        return link;
    };

    FxxlBranchInventorySetup.prototype.decideInquiryType = function decideInquiryType(item = {}, branchId = 0) {
        if (typeof window.fxxlZopimChat !== 'undefined') {
            if (this.isMobileVersion === false) {
                if (fxxlZopimChat.active === true && this.isBranchOperatorOnline(branchId) === true) {
                    item.querySelector('.' + this.branchBlockChatInquiryContentClass).classList.remove(this.hiddenClass);
                    item.querySelector('.' + this.branchBlockFormInquiryContentClass).classList.add(this.hiddenClass);
                } else {
                    item.querySelector('.' + this.branchBlockFormInquiryContentClass).classList.remove(this.hiddenClass);
                    item.querySelector('.' + this.branchBlockChatInquiryContentClass).classList.add(this.hiddenClass);
                }
            } else {
                let formQuery = '.fxxl-branch-inventory-item__status--openform[data-branch-id="' + branchId + '"';
                let chatQuery = '.fxxl-branch-inventory-item__status--openchat[data-branch-id="' + branchId + '"';

                if (fxxlZopimChat.active === true && this.isBranchOperatorOnline(branchId) === true) {
                    document.querySelector(formQuery).classList.add(this.hiddenClass);
                    document.querySelector(chatQuery).classList.remove(this.hiddenClass);
                } else {
                    document.querySelector(formQuery).classList.remove(this.hiddenClass);
                    document.querySelector(chatQuery).classList.add(this.hiddenClass);
                }
            }
        }
    };

    FxxlBranchInventorySetup.prototype.isBranchOperatorOnline = function isBranchOperatorOnline(branchId) {
        let branchNameInLowerCase = fxxlBranchUrlKeys[branchId].toLowerCase().replace('-', ' ');
        let result = false;

        fxxlZopimChat.onlineDepartments.forEach(element => {
            let filialeName = simplifyUmlaut(element.toLowerCase());
            if (branchNameInLowerCase.trim() === filialeName.replace('filiale ', '').replace('-', ' ').trim()) {
                result = true;
            }
        });

        return result;
    };

    FxxlBranchInventorySetup.prototype.getStatus = function getStatus(variantId, branchId) {
        var branchStokes,
            status = 3;
        if (typeof this.fxxlArtikelBranchInventoryVariantStatuses[variantId] !== 'undefined') {
            if (typeof this.fxxlArtikelBranchInventoryVariantStatuses[variantId][branchId] !== 'undefined') {
                status = this.fxxlArtikelBranchInventoryVariantStatuses[variantId][branchId];
            }
        }
        branchStokes = this.getBranchStock(branchId, variantId);
        return this.statusCorrector(status, branchStokes);
    };

    FxxlBranchInventorySetup.prototype.setupMapIcons = function setupMapIcons() {
        this.mapMarkersIcon.fxxl = {
            '1': {
                default: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/fxxl-1.png',
                active: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/fxxl-1-active.png',
            },
            '2': {
                default: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/fxxl-2.png',
                active: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/fxxl-2-active.png',
            },
            '3': {
                default: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/fxxl-3.png',
                active: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/fxxl-3-active.png',
            },
        };
        this.mapMarkersIcon.cube = {
            '1': {
                default: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/cube-1.svg',
                active: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/cube git-1-active.svg',
            },
            '2': {
                default: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/cube-2.svg',
                active: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/cube-2-active.svg',
            },
            '3': {
                default: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/cube-3.svg',
                active: '/custom/module/public/fxxl3/assets/img/map_branch_inventory/cube-3-active.svg',
            },
        };
    };

    FxxlBranchInventorySetup.prototype.setEvents = function setEvents() {
        var __this = this;
        this.searchButtonElement.addEventListener('click', function () {
            __this.search(__this.searchInputElement.value);
            setTimeout(function () {
                gtm.pushOnClick({element: this.searchButtonClass}, 'branch-inventory-search--click');
            }, 2000);
        });

        this.searchInputElement.addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
                __this.search(__this.searchInputElement.value);
                setTimeout(function () {
                    gtm.pushOnClick({element:this.searchInputClass},'branch-inventory-search--click');
                }, 2000);
            }
        });
    };

    FxxlBranchInventorySetup.prototype.initSizeContainer = function initSizeContainer() {
        this.sizeContainer = this.element.getElementsByClassName(this.sizeContainerClass);
        if (this.sizeContainer.length > 0) {
            this.sizeContainer = this.sizeContainer[0];
            this.sizeItems = this.sizeContainer.getElementsByClassName(this.contentItemsClass);
            this.sizeBar = this.sizeContainer.getElementsByClassName(this.contentBarClass);
            if (this.sizeItems.length > 0 && this.sizeBar.length > 0) {
                this.sizeBar = this.sizeBar[0];
                this.setupSizeContainer();
            } else {
                this.sizeBar = null;
            }
        } else {
            this.sizeContainer = null;
        }
    };

    FxxlBranchInventorySetup.prototype.initColorContainer = function initColorContainer() {
        this.colorContainer = this.element.getElementsByClassName(this.colorContainerClass);

        if (this.colorContainer.length > 0) {
            this.colorContainer = this.colorContainer[0];
            this.colorItems = this.colorContainer.getElementsByClassName(this.contentItemsClass);
            this.colorBar = this.colorContainer.getElementsByClassName(this.contentBarClass);
            this.colorTitle = this.colorContainer.getElementsByClassName(this.contentTitleClass);
            if (this.colorItems.length > 0 && this.colorBar.length > 0 && this.colorTitle.length > 0) {
                this.colorBar = this.colorBar[0];
                this.colorTitle = this.colorTitle[0];
                this.setupColorContainer();
            } else {
                this.colorBar = null;
                this.colorTitle = null;
            }
        } else {
            this.colorContainer = null;
        }
    };

    FxxlBranchInventorySetup.prototype.setupSizeContainer = function setupSizeContainer() {
        var __this = this;
        this.sizeBarObject = new FxxlBarAnimation(this.sizeItems, this.sizeBar, ['click'], function (item) {
            __this.lastSelectedFirstSizeItem = item;
            __this.inactiveItems(__this.sizeItems);
            item.fxxlBranchInventoryItemActive = true;
            __this.setSearchListTitle();
            if (__this.mapInited === true) {
                __this.setupMap();
            }
        });
    };

    FxxlBranchInventorySetup.prototype.setupColorContainer = function setupColorContainer() {
        var __this = this;
        this.colorBarObject = new FxxlBarAnimation(this.colorItems, this.colorBar, ['click'], function (item) {
            __this.setTitle(item, __this.colorTitle, 'color');
            __this.inactiveItems(__this.colorItems);
            item.fxxlBranchInventoryItemActive = true;
            __this.sizeCleanUp();
            __this.setSearchListTitle();

            if (__this.mapInited === true) {
                __this.setupMap();
            }
        });
    };

    FxxlBranchInventorySetup.prototype.setSearchListTitle = function setSearchListTitle() {
        var activeColor = this.getActiveItem(this.colorItems),
            activeSize = this.getActiveItem(this.sizeItems),
            title = this.fxxlArtikelBranchInventoryName;
        title += '<div class="' + this.branchListSmallTitleClass + '">' + activeColor.getAttribute('data-title') + ' | ' + activeSize.getAttribute('data-title') + '</div>';
        this.branchListTitleElement.innerHTML = title;
    };

    FxxlBranchInventorySetup.prototype.inactiveItems = function inactiveItems(items) {
        Array.prototype.forEach.call(items, function (item) {
            item.fxxlBranchInventoryItemActive = false;
        });
    };

    FxxlBranchInventorySetup.prototype.getActiveItem = function getActiveItem(items) {
        var activeItem = null;
        Array.prototype.forEach.call(items, function (item) {
            if (item.fxxlBranchInventoryItemActive === true) {
                activeItem = item;
            }
        });
        return activeItem;
    };

    FxxlBranchInventorySetup.prototype.getDefaultColor = function getDefaultColor() {
        var __this = this,
            activeColorElement = document.querySelector(this.branchBlockColorSelectorClass),
            variantId = null,
            selectedItem = null;

        if (activeColorElement !== null) {
            variantId = activeColorElement.getAttribute('data-pid');
        }

        if (variantId === null) {
            variantId = this.getColorVariantIdVersion2();
        }

        if (variantId !== null) {
            variantId = parseInt(variantId);
            Object.keys(this.fxxlArtikelBranchInventoryVariantListColors).forEach(function (id) {
                var value = __this.fxxlArtikelBranchInventoryVariantListColors[id];
                id = parseInt(id);
                if (id === variantId) {
                    Array.prototype.forEach.call(__this.colorItems, function (item) {
                        if (item.getAttribute('data-title') === value) {
                            selectedItem = item;
                            return true;
                        }
                    });
                    return true;
                }
            });
        }
        return selectedItem;
    };

    FxxlBranchInventorySetup.prototype.getColorVariantIdVersion2 = function getColorVariantIdVersion2() {
        var temp,
            variantId = null,
            variantSelectElement = document.getElementById('variant-select-' + this.mainProductId);

        if (variantSelectElement !== null) {
            temp = variantSelectElement.value.split('-');
            if (temp.length === 2) {
                variantId = temp[1];
            }
        }
        return variantId;
    };

    FxxlBranchInventorySetup.prototype.getDefaultSizeVariantId = function getDefaultSizeVariantId() {
        var activeSizeElement = document.querySelector(this.branchBlockSizeSelectorClass),
            variantId = null;
        if (activeSizeElement !== null) {
            variantId = activeSizeElement.value;
        }
        if (variantId === null) {
            variantId = this.getColorVariantIdVersion2();
        }
        return variantId;
    };

    FxxlBranchInventorySetup.prototype.getDefaultSize = function getDefaultSize() {
        var __this = this,
            activeSizeElement = document.querySelector(this.branchBlockSizeSelectorClass),
            variantId = null,
            selectedItem = null;

        if (activeSizeElement !== null) {
            variantId = activeSizeElement.value;
        }

        if (variantId === null) {
            variantId = this.getColorVariantIdVersion2();
        }

        if (variantId !== null) {
            variantId = parseInt(variantId);
            Object.keys(this.fxxlArtikelBranchInventoryVariantListSizes).forEach(function (id) {
                var value = __this.fxxlArtikelBranchInventoryVariantListSizes[id];
                id = parseInt(id);
                if (id === variantId) {
                    Array.prototype.forEach.call(__this.sizeItems, function (item) {
                        if (item.getAttribute('data-title') === value) {
                            selectedItem = item;
                            return true;
                        }
                    });
                    return true;
                }
            });
        }
        return selectedItem;
    };

    FxxlBranchInventorySetup.prototype.setDefaultBarPosition = function setDefaultBarPosition() {
        this.lastSelectedFirstSizeItem = null;
        if (this.colorItems.length > 0 && this.colorBar !== null && this.colorTitle !== null) {
            this.defaultColorItem = this.getDefaultColor();
            if (this.defaultColorItem === null) {
                this.defaultColorItem = this.colorItems[0];
            }
            this.setTitle(this.defaultColorItem, this.colorTitle, 'color');
            this.defaultColorItem.fxxlBranchInventoryItemActive = true;
        }
        if (this.sizeItems.length > 0 && this.sizeBar !== null) {
            this.defaultSizeItem = this.getDefaultSize();
            if (this.defaultSizeItem === null) {
                this.defaultSizeItem = this.sizeItems[0];
            } else {
                this.lastSelectedFirstSizeItem = this.defaultSizeItem;
            }
            this.defaultSizeItem.fxxlBranchInventoryItemActive = true;
        }

        if (this.defaultSizeItem !== null) {
            this.sizeBarObject.setBarPosition(this.defaultSizeItem);
        }
        if (this.defaultColorItem !== null) {
            this.colorBarObject.setBarPosition(this.defaultColorItem);
        }
        this.sizeCleanUp();
        this.setSearchListTitle();

        if (this.mapInited === true) {
            this.setupMap();
        }
    };

    FxxlBranchInventorySetup.prototype.getMatchVariant = function getMatchVariant(activeSizeItem) {
        var __this = this,
            activeColorItem = this.getActiveItem(this.colorItems),
            size,
            color,
            selectedVariantId = 0;

        if (typeof activeSizeItem === 'undefined') {
            activeSizeItem = this.getActiveItem(this.sizeItems);
        }

        if (activeSizeItem !== null && activeColorItem !== null) {
            size = activeSizeItem.getAttribute('data-title');
            color = activeColorItem.getAttribute('data-title');

            Object.keys(this.fxxlArtikelBranchInventoryVariantListColors).forEach(function (colorVariantId) {
                var colorValue = __this.fxxlArtikelBranchInventoryVariantListColors[colorVariantId];
                if (colorValue === color) {
                    Object.keys(__this.fxxlArtikelBranchInventoryVariantListSizes).forEach(function (sizeVariantId) {
                        var sizeValue = __this.fxxlArtikelBranchInventoryVariantListSizes[sizeVariantId];
                        if (sizeValue === size && sizeVariantId === colorVariantId) {
                            selectedVariantId = parseInt(sizeVariantId);
                        }
                    });
                }
            });
        }

        return selectedVariantId;
    };

    FxxlBranchInventorySetup.prototype.sizeCleanUp = function sizeCleanUp() {
        var __this = this,
            resetBarPosition = false,
            updatedSize = false,
            firstItemBackup = null,
            firstSizeItem = null;

        Array.prototype.forEach.call(this.sizeItems, function (item) {
            if (__this.getMatchVariant(item) !== 0) {
                updatedSize = true;
                item.classList.remove(__this.contentItemsHideClass);
                if (firstItemBackup === null) {
                    firstItemBackup = item;
                }
                if (firstSizeItem === null) {
                    if (__this.lastSelectedFirstSizeItem !== null) {
                        if (__this.lastSelectedFirstSizeItem.getAttribute('data-title') === item.getAttribute('data-title')) {
                            firstSizeItem = item;
                        }
                    }
                }
            } else {
                item.classList.add(__this.contentItemsHideClass);
                if (item.fxxlBranchInventoryItemActive === true) {
                    item.fxxlBranchInventoryItemActive = false;
                    resetBarPosition = true;
                }
            }
        });

        if (updatedSize === true && firstSizeItem === null) {
            firstSizeItem = firstItemBackup;
        }
        if (resetBarPosition === true && firstSizeItem !== null) {
            firstSizeItem.fxxlBranchInventoryItemActive = true;
        }
        if (updatedSize === true) {
            this.sizeBarObject.setBarPosition(firstSizeItem);
        }
    };

    FxxlBranchInventorySetup.prototype.setTitle = function setTitle(item, titleElement, titleType) {
        var prefix = titleElement.getAttribute('data-title-prefix'),
            shoptitle = item.getAttribute('data-shop-title'),
            title = item.getAttribute('data-title'),
            elementSeparator = null,
            elementSuffix = null;

        titleElement.innerText = prefix + ' ' + shoptitle;

        if (titleType === 'color') {
            elementSeparator = document.createElement('span');
            elementSeparator.classList.add(this.contentTitleSeparatorClass);
            elementSeparator.innerText = ' | ';

            elementSuffix = document.createElement('span');
            elementSuffix.classList.add(this.contentTitleSuffixClass);
            elementSuffix.innerText = title;

            titleElement.appendChild(elementSeparator);
            titleElement.appendChild(elementSuffix);
        }
    };

    FxxlBranchInventorySetup.prototype.barVisibility = function barVisibility(visible) {
        var __this = this,
            activeSize;

        if (visible === true) {
            activeSize = this.getActiveItem(this.sizeItems);
            if (activeSize !== null) {
                setTimeout(function () {
                    __this.sizeBarObject.setBarPosition(activeSize);
                    __this.colorBar.classList.add(__this.contentBarShowClass);
                    __this.sizeBar.classList.add(__this.contentBarShowClass);
                }, 500);
            }
        } else {
            this.colorBar.classList.remove(this.contentBarShowClass);
            this.sizeBar.classList.remove(this.contentBarShowClass);
        }
    };

    FxxlBranchInventorySetup.prototype.setupAfterShow = function setupAfterShow() {
        var __this = this;
        if (this.isMobileVersion === false) {
            this.barVisibility(false);
        } else {
            this.element.classList.remove(__this.branchShowClass);
        }
        setTimeout(function () {
            if (__this.isMobileVersion === false) {
                __this.inactiveItems(__this.colorItems);
                __this.inactiveItems(__this.sizeItems);
                __this.setDefaultBarPosition();
                __this.barVisibility(true);
                __this.searchMyBranch();
            } else {
                __this.setupMobileList();
            }
        }, 200);
    };

    FxxlBranchInventorySetup.prototype.search = function search(address, lat, lng) {
        var url,
            __this = this;
        if (lat !== undefined && lng !== undefined) {
            url = this.apiUrl + '&lat=' + lat + '&lng=' + lng;
            this.lastAddress = '';
        } else if (address !== undefined) {
            if (address === this.lastAddress) {
                return false;
            }
            url = this.apiUrl + '&address=' + address;
            this.lastAddress = address;
        }

        $.get(url, function (data) {
            if (data.length !== undefined) {
                __this.branchDistanceData = data;
                __this.lastSelectedMarker = null;
                __this.showResult();
                __this.setupMap();
                __this.scrollToTop('auto');
                __this.hideError();
            } else {
                __this.showError();
                console.warn('Address-Error:', data);
            }
        });

        $.get(fxxlArtikelBranchInventoryApiUrl + fxxlArtikelBranchInventoryApiOrtParm + address);
        return true;
    };

    FxxlBranchInventorySetup.prototype.showResult = function showResult() {
        this.resultElement.classList.add(this.resultShowClass);
    };

    FxxlBranchInventorySetup.prototype.showError = function showError() {
        this.branchErrorElement.classList.add(this.branchErrorShowClass);
    };

    FxxlBranchInventorySetup.prototype.hideError = function hideError() {
        this.branchErrorElement.classList.remove(this.branchErrorShowClass);
    };

    FxxlBranchInventorySetup.prototype.clearBranchBlocks = function clearBranchBlocks() {
        this.branchListElement.innerText = '';
    };

    FxxlBranchInventorySetup.prototype.statusCorrector = function statusCorrector(status, stockes) {
        status = parseInt(status);
        stockes = parseInt(stockes);
        if (status === 1 && stockes > this.minAvailableLimit) {
            status = 1;
        } else if (status === 2 || (status === 1 && stockes < this.minAvailableLimit)) {
            status = 2;
        } else {
            status = 3;
        }
        return status;
    };

    FxxlBranchInventorySetup.prototype.createBranchBlock = function createBranchBlock(branch, selectedVariant, status) {
        var branchStokes = this.getBranchStock(branch.c_branch_id, selectedVariant),
            branchBlockClone = this.branchBlockElement.cloneNode(true),
            branchBlockCloneHtml = '',
            availableText,
            address,
            contactLink,
            wrap;
        branchBlockClone.classList.add('gtm__branch-inventory-block-map-result');
        branchBlockClone.classList.remove(this.branchBlockClass);
        contactLink = document.createElement('a');
        contactLink.target = '_blank';

        if (branch.header_link.length > 3) {
            branchBlockClone.querySelector('.' + this.branchBlockTelIconClass).remove();
        } else {
            branchBlockClone.querySelector('.' + this.branchBlockInfoIconClass).remove();
        }

        if (status === 1) {
            // STARTS: Remove other statuses
            branchBlockClone.querySelector('.' + this.branchBlockInquiryContentClass).remove();
            branchBlockClone.querySelector('.' + this.branchBlockNotAvailableContentClass).remove();
            // ENDS: Remove other statuses
            if (branchStokes < this.maxAvailableLimit) {
                availableText = fxxlArtikelBranchInventoryAvailableLimitText;
                availableText = availableText.replace(/###stockes###/, branchStokes);
            } else {
                availableText = fxxlArtikelBranchInventoryAvailableText;
            }
            branchBlockCloneHtml = branchBlockClone.innerHTML;
            branchBlockCloneHtml = branchBlockCloneHtml.replace(/###status-text###/, availableText);
        } else if (status === 2) {
            // STARTS: Remove other statuses
            branchBlockClone.querySelector('.' + this.branchBlockAvailableContentClass).remove();
            branchBlockClone.querySelector('.' + this.branchBlockNotAvailableContentClass).remove();
            this.decideInquiryType(branchBlockClone, branch.c_branch_id);
            // ENDS: Remove other statuses
        } else {
            // STARTS: Remove other statuses
            branchBlockClone.querySelector('.' + this.branchBlockAvailableContentClass).remove();
            branchBlockClone.querySelector('.' + this.branchBlockInquiryContentClass).remove();
            branchBlockClone.querySelector('.' + this.branchBlockContactContentClass).remove();
            // ENDS: Remove other statuses
        }

        if (branchBlockCloneHtml.length === 0) {
            branchBlockCloneHtml = branchBlockClone.innerHTML;
        }

        address = branch.strasse + '<br>' + branch.plz + ' ' + branch.ort;

        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###id###/, branch.c_branch_id);
        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###distance###/, parseFloat(branch.distance).toFixed(1));
        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###ort###/, branch.ort);
        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###inquiry-url###/, this.getInquiryLink(selectedVariant, branch.c_branch_id));
        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###filiale-url###/, this.getFilialeLink(selectedVariant, branch.c_branch_id));
        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###branch-code###/, branch.urlkey);
        branchBlockCloneHtml = branchBlockCloneHtml.replace(/###address###/, address);

        if (branch.header_link.length > 3) {
            contactLink.href = branch.header_link;
            contactLink.innerHTML = fxxlArtikelBranchInventoryContactHelpText;
        } else if (branch.header_phone) {
            contactLink.href = 'tel:' + branch.header_phone.replace(/\s/g, '');
            contactLink.innerText = branch.header_phone;
        } else {
            contactLink = undefined;
        }
        if (typeof contactLink !== 'undefined') {
            wrap = document.createElement('div');
            wrap.appendChild(contactLink.cloneNode(true));
            branchBlockCloneHtml = branchBlockCloneHtml.replace(/###contact###/, wrap.innerHTML);
            branchBlockClone.innerHTML = branchBlockCloneHtml;
        } else {
            branchBlockCloneHtml = branchBlockCloneHtml.replace(/###contact###/, '');
            branchBlockClone.innerHTML = branchBlockCloneHtml;
            const telElement = branchBlockClone?.querySelector('.fxxl-branch-inventory-block__contact-icon--tel');
            if (telElement) {
                telElement.style.display = 'none';
            }
        }

        this.branchListElement.appendChild(branchBlockClone);
    };

    FxxlBranchInventorySetup.prototype.getBranchStock = function getBranchStock(branchId, selectedVariant) {
        var stockes = 0;

        if (typeof selectedVariant === 'undefined') {
            selectedVariant = this.getMatchVariant();
        }

        if (typeof this.fxxlArtikelBranchInventoryVariantStockes[selectedVariant] !== 'undefined') {
            if (typeof this.fxxlArtikelBranchInventoryVariantStockes[selectedVariant][branchId] !== 'undefined') {
                stockes = this.fxxlArtikelBranchInventoryVariantStockes[selectedVariant][branchId];
            }
        }
        return stockes;
    };

    FxxlBranchInventorySetup.prototype.setupMap = function setupMap() {
        var scriptElement, headElement;
        if (fxxlArtikelBranchInventoryMainMapInited === false) {
            fxxlArtikelBranchInventoryLastObject = this;
            scriptElement = document.createElement('script');
            scriptElement.src = 'https://maps.googleapis.com/maps/api/js?key='
                + fxxlArtikelBranchInventoryMapApiKey + '&libraries=geometry,places&callback=fxxlBranchInventoryMapInit';
            headElement = document.getElementsByTagName('head');
            if (headElement.length > 0) {
                headElement = headElement[0];
                headElement.appendChild(scriptElement);
            }
        } else {
            this.mapInit();
        }
    };

    FxxlBranchInventorySetup.prototype.fixLinkTemplate = function fixLinkTemplate(element) {
        element.innerHTML = element.innerHTML.replace(/\sdata-temp-template/g, ' data-template');
    };

    FxxlBranchInventorySetup.prototype.zoomMarker = function zoomMarker(marker, delay) {
        var __this = this,
            defaultZoom = 8,
            lngOffset = 1,
            originalPosition = {lat: marker.getPosition().lat(), lng: marker.getPosition().lng()};

        if (typeof delay === 'undefined') {
            delay = 0;
        }

        if (JSON.stringify(this.lastSelectedMarkerPosition) !== JSON.stringify(originalPosition)) {
            this.lastSelectedMarkerPosition = originalPosition;
            setTimeout(function () {
                if (__this.map.getZoom() === defaultZoom) {
                    defaultZoom -= 1;
                    lngOffset = 2;
                }
                __this.map.setZoom(defaultZoom);
                __this.map.panTo({lat: marker.getPosition().lat(), lng: marker.getPosition().lng() - lngOffset});
            }, delay);
        }
    };

    FxxlBranchInventorySetup.prototype.setActiveMarkerIcon = function setActiveMarkerIcon(marker, behavior) {
        if (typeof behavior === 'undefined') {
            behavior = 'smooth';
        }

        this.allMarkers.forEach(function (object) {
            object.marker.setIcon(object.marker.defaultIcon);
        });
        marker.setIcon(marker.activeIcon);
        this.scrollToBlock(marker.branch_id, behavior);
    };

    FxxlBranchInventorySetup.prototype.scrollToTop = function scrollToTop(behavior) {
        if (typeof behavior === 'undefined') {
            behavior = 'smooth';
        }

        this.branchListElement.scrollTo({
            top: 0,
            behavior: behavior
        });
    };

    FxxlBranchInventorySetup.prototype.scrollToBlock = function scrollToBlock(branchId, behavior) {
        var __this = this,
            blockTitle = this.branchListElement.querySelector('[data-id="' + branchId + '"]'),
            block = blockTitle.parentElement,
            position = parseInt(block.offsetTop) - 60;

        if (typeof behavior === 'undefined') {
            behavior = 'smooth';
        }

        this.branchListElement.scrollTo({
            top: position,
            behavior: behavior
        });

        setTimeout(function () {
            __this.flashBlock(block);
        }, Math.abs(this.branchListElement.scrollTop - position) / 2);
    };

    FxxlBranchInventorySetup.prototype.flashBlock = function flashBlock(block) {
        var __this = this, delay = 250;
        block.classList.add(this.branchBlockFadeOutClass);
        setTimeout(function () {
            block.classList.remove(__this.branchBlockFadeOutClass);
        }, delay);
    };

    FxxlBranchInventorySetup.prototype.getCachedMarker = function getCachedMarker(branchId) {
        var marker = null;
        this.allMarkers.forEach(function (object) {
            if (object.id === branchId) {
                marker = object.marker;
            }
        });
        return marker;
    };

    FxxlBranchInventorySetup.prototype.mapInit = function mapInit() {
        var __this = this,
            selectedVariant = 0,
            status,
            latLng,
            firstMarker = null,
            marker,
            iconUrl,
            activeIconUrl,
            icon,
            activeIcon;

        selectedVariant = this.getMatchVariant();

        if (this.mapElement !== null && selectedVariant > 0 && this.isMobileVersion === false) {
            if (this.map === null) {
                this.map = new google.maps.Map(this.mapElement, {
                    center: {lat: parseFloat(51.5370234), lng: parseFloat(4)},
                    zoom: 5.4,
                    mapTypeControl: false
                });

                this.mapIconSetting.scaledSize = new google.maps.Size(32, 42);
                this.mapIconSetting.origin = new google.maps.Point(0, 0);
                this.mapIconSetting.anchor = new google.maps.Point(32, 42);
                this.mapIconSetting.myLocationScaledSize = new google.maps.Size(24, 32);
                this.mapIconSetting.myLocationAnchor = new google.maps.Point(24, 32);
            }

            this.clearBranchBlocks();

            Object.keys(this.branchDistanceData).forEach(function (key) {
                var data = __this.branchDistanceData[key];
                status = __this.getStatus(selectedVariant, data.c_branch_id);
                iconUrl = __this.mapMarkersIcon[data.branchType][status]['default'];
                activeIconUrl = __this.mapMarkersIcon[data.branchType][status]['active'];
                marker = __this.getCachedMarker(data.c_branch_id);
                icon = {
                    url: iconUrl,
                    scaledSize: __this.mapIconSetting.scaledSize,
                    origin: __this.mapIconSetting.origin,
                    anchor: __this.mapIconSetting.anchor
                };
                activeIcon = {
                    url: activeIconUrl,
                    scaledSize: __this.mapIconSetting.scaledSize,
                    origin: __this.mapIconSetting.origin,
                    anchor: __this.mapIconSetting.anchor
                };
                if (marker === null) {
                    latLng = new google.maps.LatLng(parseFloat(data.geo_lat), parseFloat(data.geo_long));
                    marker = new google.maps.Marker({
                        position: latLng,
                        map: __this.map,
                        title: data.branch_name,
                        icon: icon,
                        optimized: false
                    });

                    marker.branch_id = data.c_branch_id;
                    marker.defaultIcon = icon;
                    marker.activeIcon = activeIcon;

                    marker.addListener('click', function () {
                        __this.setActiveMarkerIcon(this);
                        __this.lastSelectedMarker = this;
                    });
                    __this.allMarkers.push({"id": data.c_branch_id, "marker": marker});
                } else {
                    marker.setIcon(icon);
                    marker.defaultIcon = icon;
                    marker.activeIcon = activeIcon;
                }

                if (firstMarker === null) {
                    firstMarker = marker;
                }

                __this.createBranchBlock(data, selectedVariant, status);
            });

            if (__this.lastSelectedMarker !== null) {
                __this.setActiveMarkerIcon(__this.lastSelectedMarker, 'auto');
            }

            this.zoomMarker(firstMarker, 1000);
            this.fixLinkTemplate(this.branchListElement);
            setupJsonHandler(this.branchListElement);
        }
        if (typeof this.tabInstance !== 'undefined') {
            if (typeof this.tabInstance.updatedAfterMapInit === 'undefined') {
                this.tabInstance.updateTabIndicator();
                this.tabInstance.updatedAfterMapInit = true;
            }
        }
    };

    return FxxlBranchInventorySetup;
}();

function fxxlBranchInventoryMapInit() {
    fxxlArtikelBranchInventoryMainMapInited = true;
    if (fxxlArtikelBranchInventoryLastObject !== null) {
        fxxlArtikelBranchInventoryLastObject.mapInited = true;
        fxxlArtikelBranchInventoryLastObject.mapInit();
    }
}
function fxxlSetupContentElements() {
    setupContentMenuBox();
    setupContentTable();
}

/**
 * Menu-Box
 */
function setupContentMenuBox() {
    if ($('.fxxl-content-page-menu-box__list').length > 0) {
        new FxxlElementVersionControl('.fxxl-content-page-menu-box__list', largViewportSize, function () {
            $('.fxxl-content-page-menu-box').each(function () {
                var menuBoxList = $(this).find('.fxxl-content-page-menu-box__list');

                if (isLargeViewport() === false) {
                    fxxlSetupContentMenuBoxSlider(menuBoxList[0]);
                }
            });
        });
    }
}

/**
 * Table
 */
function setupContentTable() {
    var container,
        scroller,
        columns;

    $('.fxxl-content-page-table__container').each(function () {
        container = $(this);
        new FxxlTouchScroller(this, 'left');

        if ($('html.ua-ie11').length > 0) {
            columns = container.parent('.fxxl-content-page-table').data('columns');
            scroller = container.find('.fxxl-content-page-table__scroller');
            scroller.css({'-ms-grid-columns': 'max-content (1fr)[' + (columns - 1) + ']'});
        }
    });
}
/**
 * Merkzettel
 *
 * Filename: 450_merkliste.js
 *
 * @category  Applicas
 * @package   Slider
 * @author    Kevin Topf <k.topf@fahrrad-xxl.de>
 *            Shervin Mirostovar <s.mirostovar@fahrrad-xxl.de>
 *            Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2022 Fahrrad XXL
 */


import FxxlEffects from '@fxxl/effects';


const FXXL_WISHLIST_REQUEST_ACTION_ADD_ITEM      = 'addItem';
const FXXL_WISHLIST_REQUEST_ACTION_REMOVE_ITEM   = 'removeItem';
const FXXL_WISHLIST_REQUEST_ACTION_UPDATE_ITEM   = 'updateItem';

class FxxlWishlist {

    constructor(wishlistContainer) {
        // Classnames & Ids
        this.shareLinkElementClass = 'fxxl-merkliste__link--share';
        this.printLinkElementClass = 'fxxl-merkliste__link--print';

        // Variables
        this.container = wishlistContainer;

        // Init
        this.shareLinks = this.container.querySelectorAll(`.${this.shareLinkElementClass}`);
        this.printLink = this.container.querySelector(`.${this.printLinkElementClass}`);
        this.setupShareLink();
        this.setupPrintLink();

        // Other
        this.updateWishlistItemOnSelectChange();
        fxxlHideGuuruChatBySelectModal(wishlistContainer);
        fxxlHideSupportWidgetBySelectModal(wishlistContainer);
    }

    /*
     * Private Methods
     * ------------------------------------------------------------------------
     */

    setupShareLink() {
        if (this.shareLinks.length === 0) {
            return;
        }

        this.shareLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                // Update Share Links
                FxxlWishlist.updateShareLinks();

                // Get Toast Text
                const linkTextElement = link.querySelector('.fxxl-merkliste__link-text');
                let linkSharetext = 'Merkzettel Teilen';

                if (linkTextElement?.dataset?.shareText !== undefined) {
                    linkSharetext = linkTextElement.dataset.shareText;
                }

                // Execute Copy Event
                if (navigator.share !== undefined) {
                    navigator.share({
                        title: document.title,
                        text: linkSharetext,
                        url: link.href
                    }).then().catch(function (error) {
                        console.log('Error sharing:', error);
                    });
                } else {
                    // fxxlShareLinkCopyDoneText kommt von: "/public/fxxl3/merkliste/merkliste_detail.tpl"
                    fxxlCopyTextToClipboard(link.href, fxxlShareLinkCopyDoneText);
                }
            });
        });
    }

    setupPrintLink() {
        if (!this.printLink) {
            return;
        }

        this.printLink.addEventListener('click', () => fxxlPrintElement(this.container));
    }

    updateWishlistItemOnSelectChange() {
        const selectsSelector = '.fxxl-element-artikel__variant-select select';
        const selects = document.querySelectorAll(selectsSelector);
        let requestUrl = '/json.php?service=updateMerklisteItem';

        // OnStart: Give every Select a "previous-value" attribute
        Array.from(selects).forEach(function (select) {
            select.dataset.previousValue = select.value;
        });

        // OnChange
        Array.from(selects).forEach(function (select) {
            select.addEventListener('change', (el) => {
                let previousValue = select.dataset.previousValue;

                if (select.options.length > 1) {
                    if (previousValue === 'null' || previousValue === '') {
                        previousValue = select.options[1].value;
                    }

                    const oldId = previousValue.split('-')[1];
                    const variantId = select.value.split('-')[1];

                    select.dataset.previousValue = select.value;
                    fetch(requestUrl + `&old_id=${oldId}&new_id=${variantId}`);

                    // Update Share Links
                    FxxlWishlist.updateShareLinks();
                }
            });
        });
    }



    /*
     * Static / Public Methods
     * ------------------------------------------------------------------------
     */

    /**
     * @param {Object} param
     * @param {Function} callback
     */
    static sendRequest(param, callback = null) {
        const { productId, action, variantId = null, oldId = null, preselectedColor = '', unique = null } = param;

        if (productId === undefined || action === undefined) {
            console.warn('Error: ', 'FxxlWishlist.sendRequest');
            return;
        }

        const requestBase = '/json.php';
        const requestParams = new URLSearchParams();

        switch (action) {
            case FXXL_WISHLIST_REQUEST_ACTION_ADD_ITEM:
                requestParams.append('service', 'moveItemToMerkliste');
                requestParams.append('ac_id', variantId);
                requestParams.append('ac_color', preselectedColor);
                requestParams.append('ac_unique', unique);
                requestParams.append('shop', _shop);
                break;
            case FXXL_WISHLIST_REQUEST_ACTION_REMOVE_ITEM:
                requestParams.append('service', 'removeMerkliste');
                requestParams.append('ac_id', FxxlPersonalData.wishlist.Items[productId]);
                requestParams.append('ac_unique', unique);
                break;
            case FXXL_WISHLIST_REQUEST_ACTION_UPDATE_ITEM:
                requestParams.append('service', 'updateMerklisteItem');
                requestParams.append('old_id', oldId);
                requestParams.append('new_id', variantId);
                break;
            default:
                console.warn('Error: ', 'FxxlWishlist.sendRequest()');
                break;
        }

        // Fetch & Handle Request
        fetch(`${requestBase}?${requestParams.toString()}`)
            .then((response) => response.json())
            .then((response) => FxxlWishlist.handleResponseSuccess(response, callback))
            .catch((error) => console.warn('Error:', 'FxxlWishlist.sendRequest', error) );
    }

    /**
     * @param {Object} response
     * @param {Function} callback
     */
    static handleResponseSuccess(response, callback) {
        let callBackArg = (response !== -1) ? response : false;
        typeof callback == "function" && callback(callBackArg);
    }


    /**
     * @param {Object} element
     */
    static toggleItem(element) {
        const productId = element?.dataset?.productId;
        const action = (element.checked) ? FXXL_WISHLIST_REQUEST_ACTION_ADD_ITEM : FXXL_WISHLIST_REQUEST_ACTION_REMOVE_ITEM;

        // This can happen if a Product wasn't inserted into the DB
        if (action === FXXL_WISHLIST_REQUEST_ACTION_REMOVE_ITEM) {
            if (!FxxlPersonalData?.wishlist?.Items) {
                console.warn('Warn: ', 'FxxlWishlist.toggleItem');
                return;
            }
        }

        this.sendRequest({
            productId: productId,
            variantId: element?.dataset?.variantId,
            preselectedColor: element?.dataset?.preselectedColor,
            unique: element?.dataset?.unique,
            action: action
        }, (response) => {
            if (!response) {
                return;
            }

            FxxlPersonalData.wishlist = response;
            setBadgeContent('wishlist', response.numItems);

            if (response.data) {
                M.toast({html: response.data, classes: 'fxxl-toast fxcl-button-dynamics', displayLength: 1000 });
            }

            // GTM: Send Datalayer Push
            if (element.checked && element?.dataset?.variantId && additional_data) {
                let clickedElementData = additional_data[element?.dataset?.variantId];

                // Check for Xref Entries
                if (!clickedElementData) {
                    clickedElementData = additional_data?.xref?.[element?.dataset?.variantId];
                }

                if (clickedElementData) {
                    gtm.pushOnClick(clickedElementData, 'add_to_wishlist');
                }
            }

            if (response.code === 200) {
                if (element.checked) {
                    if (document?.documentElement?.dataset?.vwtype === 'merkliste') {
                        window.location.reload();
                    }
                } else {
                    FxxlWishlist.setProductWishlistStatusOnWholePage(response.productId, element.checked);
                    if (document?.documentElement?.dataset?.vwtype === 'merkliste') {
                        FxxlWishlist.removeItemOnWishlistPage(productId);
                    }
                }
            }
        });
    }

    /**
     * @param {Object} element ( Classname: fxxl-element-artikel__favorite-button )
     */
    static removeItem(element) {
        const productId = element?.dataset?.productId;
        const wishList = FxxlPersonalData?.wishlist;

        if (!productId) {
            console.warn('Error: ', 'FxxlWishlist.removeItem');
            return;
        }

        if (!wishList) {
            element.style.fill = '#dfdfdf';
            element.style.pointerEvents = 'none';
            return;
        }

        const elementProduct = element.closest('.fxxl-element-artikel');
        const onWishlist = site_type === 'merkliste' && site_name === 'detail';
        const isSharedWishlist = getURLParam("share", window.location.href) !== null;

        // IF: Event comes from Wishlist and Wishlist is a shared Wishlist
        if (onWishlist && isSharedWishlist)  {
            FxxlWishlist.removeItemOnWishlistPage(productId, elementProduct);
            return;
        }

        this.sendRequest({
            productId: productId,
            unique: element?.dataset?.unique,
            action: FXXL_WISHLIST_REQUEST_ACTION_REMOVE_ITEM
        }, (response) => {
            if (!response) {
                return;
            }

            FxxlPersonalData.wishlist = response;
            setBadgeContent('wishlist', response.numItems);
            FxxlWishlist.removeItemOnWishlistPage(productId, elementProduct);
        });
    }

    /**
     * @param {Number} productId
     * @param {Object} element
     */
    static removeItemOnWishlistPage(productId, element = null) {
        const onWishlist = site_type === 'merkliste' && site_name === 'detail';
        if (!onWishlist) {
            return;
        }

        if (element === null) {
            const elementSelector = `.fxxl-merkliste__list .fxxl-element-artikel[data-product-id="${productId}"]`;
            element = document.querySelector(elementSelector);
        }

        if (element) {
            FxxlEffects.fadeOutElement(element, () => {
                element.remove();
                FxxlWishlist.setProductWishlistStatusOnWholePage(productId, false);
                FxxlWishlist.setBadgeCount();
                FxxlWishlist.removeWishlistHint();
                FxxlWishlist.showWishlistEmpty();
                FxxlWishlist.updateShareLinks();
            });
        }
    }

    /**
     * @param {Number} productId
     * @param {Boolean} status
     */
    static setProductWishlistStatusOnWholePage(productId, status) {
        // Da ein Produkt auf einer Seite mehrmals auftauchen kann,
        // in Suchen, auf PDS, soll jedes Product, mit der selben Id, auf der gesamten Seite geupdated werden.

        const wishlistInputSelectorString = `.js-fxxl-artikel__wishlist[data-product-id="${productId}"]`;
        const wishlistInputs = document.querySelectorAll(wishlistInputSelectorString);

        wishlistInputs.forEach(input => input.checked = status);
    }

    static setBadgeCount() {
        const items = document.querySelectorAll('.fxxl-merkliste__list .fxxl-element-artikel');
        const badgeCount = document.querySelector('.fxxl-merkliste__title-inf');

        if (badgeCount) {
            badgeCount.textContent = items.length;
        }
    }

    static removeWishlistHint() {
        const items = document.querySelectorAll('.fxxl-merkliste__list .fxxl-element-artikel');
        const hint = document.querySelector('.fxxl-merkliste__hint');

        if (hint && items.length === 0) {
            hint.remove();
        }
    }

    static showWishlistEmpty() {
        const container = document.querySelector('.fxxl-merkliste__list');
        const items = container.querySelectorAll('.fxxl-element-artikel');

        if (items.length === 0) {
            const emptyText = document.querySelector('.fxxl-merkliste__text--empty');
            const toolbar = document.querySelector('.fxxl-merkliste__tools');

            if (container?.style) {
                container.style.display = 'none';
            }
            if (toolbar?.style) {
                toolbar.style.display = 'none';
            }
            emptyText?.classList?.remove('fxxl-hidden');
        }
    }

    static productsSetChecked() {
        if (FxxlPersonalData?.wishlist?.Items) {
            Object.keys(FxxlPersonalData.wishlist.Items).forEach((id) => {
                const element = document.querySelector(`.js-fxxl-artikel__wishlist[data-product-id="${id}"]`);
                if (element) {
                    element.checked = true;
                }
            });
        }
        if (window?.FxxlCompare?.setConfigWishlistCompareButton !== undefined) {
            window.FxxlCompare.setConfigWishlistCompareButton();
        } else {
            window.addEventListener('compare_load', (event) => {
                event?.detail?.FxxlCompare?.setConfigWishlistCompareButton();
            });
        }
    }

    static updateShareLinks() {
        const onWishlist = site_type === 'merkliste' && site_name === 'detail';
        if (!onWishlist) {
            return;
        }

        const container = document.querySelector('.fxxl-merkliste__list');
        const itemsSelects = container.querySelectorAll('[id^=variant-select-]');
        const shareLinks = document.querySelectorAll(`.fxxl-merkliste__link--share`);

        // Gather Item Data
        let itemsData = Array.from(itemsSelects, (item) => {
            const productId = item.id.split('-')[2];

            return {
                productId: (item.value !== "") ? item.value.split('-')[1] : productId,
                preselectedColor: item.dataset.preselectedColor || ''
            };
        });

        // Create new Link-Hash
        // This is also taking care of chars like accent grave (`) or accent aigu (´)
        // Explanation: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
        const linkHash = btoa(
            encodeURIComponent(JSON.stringify(itemsData))
                .replace(/%([0-9A-F]{2})/g, (match, p1) => {
                    return String.fromCharCode('0x' + p1);
                })
        );

        // Update all Links
        shareLinks.forEach(link => link.href = `${window.location.origin}/merkliste/?share=${linkHash}`);
    }
}

/**
 * Auto Generated Anchor Navigation Menu
 */

if (site_type === 'seite' && site_name === 'detail') {
    let pageAnchorNavigationMenue = document.querySelectorAll('.fxxl-content-page-navigation-anchor'),
        menuDataAttr = 'data-anchor-menue-titel';

    if (isLargeViewport() === true) {
        // Anchor Navigation only for desktop
        if (pageAnchorNavigationMenue.length > 0) {
            let pageContentElementsWithDataAttr =  document.querySelectorAll(`[id][${menuDataAttr}]`),
                menuItemNodeClasses = 'fxxl-content-page-navigation__link smooth-scroll',
                menuItemParentNode = document.querySelector('.fxxl-content-page-navigation-anchor__list'),
                anchorMenuAccordion = document.querySelector('.fxxl-content-page-navigation-anchor__title'),
                listItemNode,
                menuItemNode,
                menuItemNodeId,
                menuText;

            if (pageContentElementsWithDataAttr.length > 0) {
                pageContentElementsWithDataAttr.forEach((element) => {
                    menuText = document.createTextNode(element.getAttribute(menuDataAttr));
                    menuItemNodeId = '#' + element.getAttribute('id');
                    menuItemNode = document.createElement('a');
                    menuItemNode.setAttribute('href', menuItemNodeId);
                    menuItemNode.setAttribute('class', menuItemNodeClasses);
                    menuItemNode.appendChild(menuText);
                    listItemNode = document.createElement('li');
                    listItemNode.appendChild(menuItemNode);
                    menuItemParentNode.appendChild(listItemNode);
                });

                anchorMenuAccordion.parentElement.style.pointerEvents = 'none';
            }
        }

        /**
         * Sticky Side-Bar Beratungsseite
         */

        const sideBarMenu = document.querySelector('[data-sticky="true"]');

        if (sideBarMenu) {
            const baseContainer = document.querySelector('.fxxl-base-container');
            const baseHeader = document.querySelector('.fxxl-base-header');
            const bottomOffset = 150;
            const windowHeight = window.innerHeight;

            let stickyTopPosition,
                sidebarMenuHeight,
                delay = 100,
                currentPosition = window.scrollY,
                topForSticky;

            setTimeout(function () {
                sideBarMenu.fxxlAccordion.setContentSize();
                sidebarMenuHeight = sideBarMenu.offsetHeight;
                if (sidebarMenuHeight > windowHeight) {
                    stickyTopPosition = `${windowHeight - sideBarMenu.offsetHeight - bottomOffset}px`;
                } else {
                    stickyTopPosition = baseHeader.offsetHeight - 30 + 'px';
                }

                baseContainer.style.overflow = 'unset';
                sideBarMenu.style = `
                        position: sticky;
                        top: ${stickyTopPosition};
                        transition: top 0.1s linear;
                        will-change: top;
                    `;
                topForSticky = parseInt(stickyTopPosition.replace('px', ''));
            }, delay);

            let menuItem = sideBarMenu.querySelectorAll('.collapsible-header');
            for (let i = 0; i < menuItem.length; i++) {
                menuItem[i].addEventListener('click', () => {
                    setTimeout(() => {
                        if (sideBarMenu.offsetHeight + 150 < windowHeight) {
                            // sideBarMenu.style.top = '0px';
                            topForSticky = 0;
                        } else {
                            // sideBarMenu.style.top = `${window.innerHeight - sideBarMenu.offsetHeight - bottomOffset}px`;
                            topForSticky = window.innerHeight - sideBarMenu.offsetHeight - bottomOffset;
                        }
                    }, 300);
                });
            }

            window.addEventListener('scroll', function (event) {
                let maxTop = 110;
                let minTop = parseInt(sideBarMenu.style.top.replace('px', ''));

                if (window.scrollY < currentPosition) {
                    requestAnimationFrame(function () {
                        if (minTop <= (maxTop + 15)) {
                            let newMinTop = minTop + 30;
                            sideBarMenu.style.top = newMinTop + 'px';
                        }
                    });
                } else {
                    requestAnimationFrame(function () {
                        if (minTop > topForSticky) {
                            let newMinTop = minTop - 30;
                            sideBarMenu.style.top = newMinTop + 'px';
                        }
                    });
                }
                currentPosition = window.scrollY
            });
        }
    }
}
function fxxlChangeNewsAndEventsFilial(element) {
  window.location.href = element.value;
}
function fxxlSetupClickEventsForTerminKacheln() {
    // Event-Kacheln sollen klickbar sein, aber nur auf mobil.
    // Beim Klick führen sie den Benutzer dorthin, wo auch der Link hinter dem Bild der Kachel zeigt:
    function handleClickEvents(event) {
        window.location.href = event.currentTarget.querySelector('.fxxl-termin-list-item__image-link').href;
    }
    new FxxlElementVersionControl('.fxxl-termin-list-item', largViewportSize, function () {
        if (isLargeViewport() !== true) {
            document.querySelectorAll('.fxxl-termin-list-item').forEach( function (element) {
                element.addEventListener('click', handleClickEvents);
            });
        } else {
            document.querySelectorAll('.fxxl-termin-list-item').forEach( function (element) {
                element.removeEventListener('click', handleClickEvents);
        });
        }
    });
}
var FxxlVotingBox = (function FxxlVotingBox() {
    function FxxlVotingBox(element, insidePopup) {
        this.element = element;
        this.likeButton = null;
        this.dislikeButton = null;
        this.selectedVote = null;
        this.selectedIndex = null;
        this.modal = null;
        this.modalBackground = null;
        this.body = null;
        this.closeButton = null;
        this.confirm = null;
        this.boxElements = null;
        this.request = null;
        this.input = null;
        this.votingId = null;
        this.insidePopup = insidePopup;
        this.init();
    }

    FxxlVotingBox.prototype.init = function init() {
        this.body = $('body');
        this.votingId = this.element.data('voting-id');
        this.likeButton = this.element.find('.fxxl-voting__button--like');
        this.dislikeButton = this.element.find('.fxxl-voting__button--dislike');
        this.modal = this.element.find('.fxxl-voting__feedback');
        this.confirm = this.element.find('.fxxl-voting__confirm');
        this.input = this.element.find('.fxxl-voting__feedback-input textarea');
        this.boxElements = this.element.find('.fxxl-voting__box, .fxxl-voting__title');
        this.closeButton = this.element.find('.fxxl-voting__button--close, .fxxl-voting__button--feedback' +
            ', .fxxl-voting__button--cancel');
        this.modalBackground = $('<div class="fxxl-voting__feedback-bg"></div>');
        this.request = '/json.php?service=callAction&' + this.element.data('action').split("?")[1];
        this.body.append(this.modalBackground);
        this.events();
        this.setVoteCount();
        new FxxlTouchScroller(this.element[0]);
        if (typeof this.insidePopup === 'undefined') {
            this.insidePopup = false;
        }
    };

    FxxlVotingBox.prototype.events = function events() {
        var __this = this;
        this.likeButton.on('click', function () {
            __this.selectedIndex = $(this).data('index');
            __this.selectedVote = $(this).data('value');
            __this.showModal();
        });
        this.dislikeButton.on('click', function () {
            __this.selectedIndex = $(this).data('index');
            __this.selectedVote = $(this).data('value');
            __this.showModal();
        });
        this.closeButton.on('click', function (e) {
            __this.hideModal(e);
        });
        this.modalBackground.on('click', function () {
            __this.hideModal();
        });
        this.element.keyup(function (e) {
            if (e.which === 27) {
                __this.hideModal();
            }
        });
    };

    FxxlVotingBox.prototype.showModal = function showModal() {
        var __this = this;
        this.modalBackground.show();
        this.modal.show();

        setTimeout(function () {
            __this.modalBackground.addClass('fxxl-voting__feedback-bg--show');
            __this.modal.addClass('fxxl-voting__feedback--show');
            if (__this.insidePopup) {
                __this.modal[0].scrollIntoView(false);
            }

        }, 10);
    };

    FxxlVotingBox.prototype.hideModal = function showModal(e) {
        var __this = this,
            sendFeedback = false;
        this.modalBackground.removeClass('fxxl-voting__feedback-bg--show');
        this.modal.removeClass('fxxl-voting__feedback--show');
        this.confirm.css({'display': 'flex'});

        if (e !== undefined && e.currentTarget.className.indexOf('fxxl-voting__button--feedback') > -1) {
            sendFeedback = true;
        }

        if (sendFeedback === false) {
            this.input.val('');
        }

        setTimeout(function () {
            __this.modalBackground.hide();
            __this.modal.hide();
            if (isLargeViewport() === false) {
                __this.boxElements.hide();
            } else {
                __this.boxElements.addClass('fxxl-voting--hide');
            }
            __this.confirm.addClass('fxxl-voting__confirm--show');
            if (__this.insidePopup) {
                __this.element[0].scrollIntoView(false);
            }
        }, 250);

        this.sendVote();
    };

    FxxlVotingBox.prototype.sendVote = function sendVote() {
        var voteData = {};
        voteData['voting_' + (this.selectedIndex + 1)] = this.selectedVote;
        voteData['voting_text'] = this.input.val();
        $.post(this.request, voteData, function () {
        });
    };

    FxxlVotingBox.prototype.setVoteCount = function setVoteCount() {
        var __this = this;
        $.get('/json.php?service=getVotingCount&voting_id=' + this.votingId, function (data) {
            $.each(data, function (key, value) {
                __this.element.find('.fxxl-voting__button[data-value="' + key + '"] > .fxxl-voting__button-inf').text(value);
            });
        });
    };
    return FxxlVotingBox;
}());

var FxxlMultipleVotingBox = (function FxxlMultipleVotingBox() {
    function FxxlMultipleVotingBox(element) {
        this.element = element;
        this.request = null;
        this.sendButton = null;
        this.radioName = null;
        this.radioElements = null;
        this.confirmContent = null;
        this.content = null;
        this.errorElement = null;
        this.body = null;
        this.closeButton = null;
        this.input = null;
        this.selectedValue = '';
        this.selectedText = '';
        this.modalBackground = $('<div class="fxxl-voting__feedback-bg"></div>');
        this.modal = this.element.find('.fxxl-voting__feedback');
        this.init();
    }

    FxxlMultipleVotingBox.prototype.init = function init() {
        this.request = '/json.php?service=callAction&' + this.element.data('action').split("?")[1];
        this.sendButton = this.element.find('.fxxl-voting-multiple__button');
        this.radioName = this.element.data('radio-name');
        this.radioElements = $('[name="' + this.radioName + '"]');
        this.content = this.element.find('.fxxl-voting-multiple__content');
        this.confirmContent = this.element.find('.fxxl-voting-multiple__confirm');
        this.errorElement = this.element.find('.fxxl-voting-multiple__error');
        this.input = this.element.find('.fxxl-voting__feedback-input textarea');
        this.closeButton = this.element.find('.fxxl-voting__button--close, .fxxl-voting__button--feedback' +
            ', .fxxl-voting__button--cancel');
        this.body = $('body');
        this.body.append(this.modalBackground);
        this.events();
    };

    FxxlMultipleVotingBox.prototype.events = function events() {
        var __this = this,
            radio;

        this.sendButton.on('click', function () {
            radio = __this.radioElements.filter(':checked');
            if (radio.length > 0) {
                __this.errorElement.removeClass('fxxl-voting-multiple__error--show');
                __this.selectedValue = radio.attr('value');
                __this.selectedText = radio.data('text');
                //__this.sendVote(selectedValue, selectedText);
                __this.showModal();
            } else {
                __this.errorElement.addClass('fxxl-voting-multiple__error--show');
            }
        });

        this.radioElements.on('change', function () {
            __this.errorElement.removeClass('fxxl-voting-multiple__error--show');
        });

        this.closeButton.on('click', function (e) {
            __this.hideModal(e);
        });
        this.modalBackground.on('click', function () {
            __this.hideModal();
        });
    };

    FxxlMultipleVotingBox.prototype.sendVote = function sendVote() {
        var voteData = {};
        voteData['voting_1'] = this.selectedValue;
        voteData['voting_text'] = this.input.val();
        $.post(this.request, voteData, function () {
        });
        this.content.addClass('fxxl-voting-multiple__content--hidden');
        this.confirmContent.addClass('fxxl-voting-multiple__confirm--show');
    };

    FxxlMultipleVotingBox.prototype.showModal = function showModal() {
        var __this = this;
        this.modalBackground.show();
        this.modal.show();

        setTimeout(function () {
            __this.modalBackground.addClass('fxxl-voting__feedback-bg--show');
            __this.modal.addClass('fxxl-voting__feedback--show');
        }, 10);
    };

    FxxlMultipleVotingBox.prototype.hideModal = function showModal(e) {
        var __this = this,
            sendFeedback = false;
        this.modalBackground.removeClass('fxxl-voting__feedback-bg--show');

        if (e !== undefined && e.currentTarget.className.indexOf('fxxl-voting__button--feedback') > -1) {
            sendFeedback = true;
        }

        if (sendFeedback === false) {
            this.input.val('');
        }

        setTimeout(function () {
            __this.modalBackground.hide();
            __this.modal.hide();
        }, 250);

        this.sendVote();
    };

    return FxxlMultipleVotingBox;
}());
$(document).ready(function() {
    fxxlSetupSelectFieldModal();

    /**
     * Verschiebt das Lebel nach oben und öffnet die Selectbox (Desktop)
     */
    $(document).on('click', '.fxxl-select-field .fxxl-select__input, .fxxl-select-field .fxxl-select-field_label', function () {

        var fxxlSelectField = $(this).closest('.fxxl-select-field');
        addClassForLabel(fxxlSelectField);
        fxxlSelectField.find('input').trigger('mousedown');
    });

    /**
     * Verschiebt das Lebel zum Ursprung und Prüft ob das SelectFeld Validiert wird
     */
    $(document).on('blur', '.fxxl-select-field .fxxl-select__input',  function () {

        var fxxlSelectField = $(this).closest('.fxxl-select-field');
        removeClassForLabel(fxxlSelectField);
        validateSelectField(fxxlSelectField);
    });

    /**
     * Nach Auswal des Eintrags aus der Liste wird der Wert für das Selectfeld gesetzt (Desktop)
     */
    $(document).on('change', '.fxxl-select-field .fxxl-select__input',  function () {

        var currentElement = $(this);
        var fxxlSelectField = currentElement.closest('.fxxl-select-field');
        var text = currentElement.val();
        var options = fxxlSelectField.find('option');

        options.removeAttr('selected');
        options.each(function () {

            var option = $(this);

            if (option.text() === text) {
                option.attr("selected", true);

                return false;
            }
        });
    });

    /**
     * Nach Auswal des Eintrags im Modal wird der Wert für das Selectfeld gesetzt (Mobile)
     */
    $(document).on('click', '.fxxl-select-field-modal .fxxl-modal__content_item', function() {

        var currentElement = $(this);
        var fxxlSelectField = currentElement.closest('.fxxl-select-field');

        $('.fxxl-select-field-modal .fxxl-modal__content_item').removeClass('fxxl-modal__content_item_active');
        currentElement.addClass('fxxl-modal__content_item_active');

        var text = currentElement.find('.fxxl-modal__content_item_text').text();
        var options = fxxlSelectField.find('option');

        options.removeAttr('selected');
        options.each(function () {

            var option = $(this);

            if (option.text() === text) {
                option.attr("selected", true);

                fxxlSelectField.find('.fxxl-select-field_modal-trigger_value').text(text);

                return false;
            }
        });

        M.Modal.getInstance(fxxlSelectField.find('.modal')).close();
    });
});

function addClassForLabel(fxxlSelectField) {

    fxxlSelectField.find('.fxxl-select-field_label').addClass('fxxl-select-field_label_active');
    fxxlSelectField.find('.fxxl-select-field_modal-trigger_label').addClass('fxxl-select-field_modal-trigger_label_active');
}

function removeClassForLabel(fxxlSelectField) {

    if (fxxlSelectField.find('option:selected').text() === '') {
        fxxlSelectField.find('.fxxl-select-field_label').removeClass('fxxl-select-field_label_active');
        fxxlSelectField.find('.fxxl-select-field_modal-trigger_label').removeClass('fxxl-select-field_modal-trigger_label_active')
   }
}

function validateSelectField(fxxlSelectField) {

    var id = fxxlSelectField.find('select').attr('id');
    document.getElementById(id).fxxl_form_validation_object.test();
}

function fxxlSetupSelectFieldModal() {
    var fxxlSelectFieldModal = $('.fxxl-select-field-modal');

    var selectFieldModal = M.Modal.init(fxxlSelectFieldModal,
        {
            onOpenStart: function () {
                // Verschiebt das Lebel nach oben
                addClassForLabel($('#' + $(this).attr('id')).closest('.fxxl-select-field'));
            },
            onCloseStart: function () {
                // Verschiebt das Lebel zum Ursprung und Prüft ob das SelectFeld Validiert wird
                var fxxlSelectField = $('#' + this.id).closest('.fxxl-select-field');
                removeClassForLabel(fxxlSelectField);
                validateSelectField(fxxlSelectField);

            }
        });
}
var rowOrderNr;
var rowEmailSubject;
var rowFiliale;
var rowSubject;

function fxxlInitDynamicForm() {
    rowOrderNr = $('.fxxl-contactForm-orderNumber').closest('.row');
    rowEmailSubject = $('.fxxl-contactForm_emailSubject').closest('.row');
    rowFiliale = $('.fxxl-contactForm-filiale').closest('.row');
    rowSubject = $('.fxxl-contactForm-subject').closest('.row');
}

function fxxlSetupDynamicForm() {
    fxxlInitDynamicForm();

    /**
     *  Im Formular Service/Kontakt müssen die Felder E-Mail Betreff und Auftragsnummer ausgeblendet werden
     */
    hideKontaktFields();

    rowFiliale.hide();

    /**
     * Wechsel des Kontaktformulars für Online anfragen und Filial anfragen
     */
    $('.dynamicForm').find('.fxxl-contactForm-filialeOnline').on('change', function() {

        if ($(this).val() === 'Filiale') {

            rowFiliale.show();

        } else {

            rowFiliale.hide();
            initFiliale();
        }
    });

    /**
     * Zeige Filialinfos an (Desktop)
     */
    rowFiliale.find('.fxxl-select__input').on('change', function () {

        var currentElement = $(this);
        var value = currentElement.val();

        if (value !== '') {
            var options = currentElement.closest('.fxxl-select-field').find('option');

            showFiliale(options, value);
        }
    });

    /**
     * Zeige Filialinfos an (Mobile)
     */
    $(document).on('click', '#row_6 .fxxl-modal__content_item', function() {

        var currentElement = $(this);

        var value = currentElement.text();
        var options = currentElement.closest('.fxxl-select-field').find('option');

        showFiliale(options, value);
    });

    /**
     * Blendet ein zusätzliches Eingabefeld ein (Desktop)
     */
    rowSubject.find('.fxxl-select__input').on('change', function () {

        hideKontaktFields();
        showInputFieldRow55($(this).val());
    });

    /**
     * Blendet ein zusätzliches Eingabefeld ein (Mobile)
     */
    rowSubject.find('.fxxl-modal__content_item').on('click', function () {

        hideKontaktFields();
        showInputFieldRow55($(this).text());

    });
}

function hideKontaktFields()
{
    rowOrderNr.hide();
    rowEmailSubject.hide();
}

function showInputFieldRow55(value)
{
    if (value !== '' && value !== 'Beratung' && value !== 'Sonstiges') {
        rowOrderNr.show().addClass('fxxl-text-input--active');
    }
}

function showFiliale(options, value)
{
    options.each(function () {

        var option = $(this);
        if (option.text() === value) {
            value = $(this).val();
            return false;
        }
    });

    $('#form-branch-data .branch-infos').addClass('hide'); // Alle Filialen ausblenden
    $('#branch-infos-' + value).removeClass('hide');

    var dynamicForm = $('.dynamicForm');
    dynamicForm.removeClass('l12');
    dynamicForm.addClass('l6');
}

function initFiliale() {

    $('#form-branch-data .branch-infos').addClass('hide'); // Alle Filialen ausblenden

    var dynamicForm = $('.dynamicForm');
    dynamicForm.addClass('l12');
    dynamicForm.removeClass('l6');

    rowFiliale.find('option').removeAttr('selected');
    rowFiliale.find('option:first-child').attr("selected", true);
    rowFiliale.find('input').val('');
    rowFiliale.find('.fxxl-select-field_modal-trigger_value').text('');
    rowFiliale.find('.fxxl-select-field_label').removeClass('fxxl-select-field_label_active');
    rowFiliale.find('.fxxl-select-field_modal-trigger_label').removeClass('fxxl-select-field_modal-trigger_label_active')
}

function rewriteReportPropertyErrorFormular(reportPropertyErrorForm)
{
    var validity,
        recaptchaElement,
        fxxlCaptchaElement,
        submitFunction;
    reportPropertyErrorForm.on('submit', function () {
        validity = checkValidityOfRewrittenFormular(reportPropertyErrorForm);
        recaptchaElement = $('.form-pds_report_properties_error_formular_id .js-fxxl-recaptcha-token');
        fxxlCaptchaElement = $('.form-pds_report_properties_error_formular_id .js-fxxl-captcha-solution');
        if (validity === true) {
            submitFunction = () => {
                $.ajax({
                    url: $(this).prop('action'),
                    data: $(this).serialize(),
                    method: 'POST',
                    success: function () {
                        $('.modal.open').modal('close');
                        hideSpinner();
                        if (recaptchaElement.length > 0) {
                            new FxxlReCaptchaGetToken(recaptchaElement[0], function () {
                                M.toast({
                                    html: et.data.propertyErrorReportedWithSuccess,
                                    classes: 'fxxl-toast fxxl-toast--success'
                                });
                            }).setToken();
                        } else if (fxxlCaptchaElement.length > 0) {
                            M.toast({
                                html: et.data.propertyErrorReportedWithSuccess,
                                classes: 'fxxl-toast fxxl-toast--success'
                            });
                        } else {
                            M.toast({
                                html: et.data.propertyErrorReCaptchaFailed,
                                classes: 'fxxl-toast fxxl-toast--error'
                            });
                        }
                    }
                });
            };

            if (fxxlCaptchaElement.length > 0) {
                new FxxlSetupCaptcha(fxxlCaptchaElement[0], submitFunction);
            } else {
                submitFunction();
            }
        }

        return false;
    });
}

function checkValidityOfRewrittenFormular(formularForm)
{
    var validity = true;
    formularForm.find('input[type="radio"][data-validation],' +
        ' input[type="checkbox"][data-validation], ' +
        'select[data-validation], ' +
        'input[type="text"][data-validation], ' +
        'textarea[data-validation]').each(function () {
            var validationTest = new FxxlFormValidation($(this));
            if (validationTest.test() === false) {
                validity = false;
                return false;
            }
        });
    return validity;
}

var FxxlWunschArtikelFormular = function FxxlWunschArtikelFormular()
{
    function FxxlWunschArtikelFormular(element)
    {
        this.element = element;
        this.formularLink = $(element).find('.fxxl-wunschartikel-formular-link-js').first();
        this.artikelNr = element.getAttribute('data-artikelnr');
        this.productDescription = element.getAttribute('data-product_description');
        this.productFarbe = element.getAttribute('data-product_farbe');
        this.productRahmenhoehe = element.getAttribute('data-product_rahmenhoehe');
        this.productRahmenform = element.getAttribute('data-product_rahmenform');
        this.branchName = element.getAttribute('data-branch_name');
        this.formularContainerClass = 'fxxl-wunschartikel__formular';
        this.itemInfClass = 'fxxl-wunschartikel-item__inf';
        this.getFormularApiUrl = '/json.php?service=getViewContent&template=formular%2Fformular_detail';
        this.init();
    }

    FxxlWunschArtikelFormular.prototype.init = function init()
    {
        this.getFormularApiUrl += '&praesenz=' + _presence_id + '&templateset=' + _templateset;
        this.bindData();
    };

    FxxlWunschArtikelFormular.prototype.bindData = function bindData()
    {
        var __this = this,
            formular_link,
            itemElement = document.createElement('div'),
            itemInfElement = document.createElement('div');

        itemInfElement.classList.add(this.itemInfClass);
        formular_link = this.formularLink.attr('href');
        fxxlGetAJAXContent(this.getFormularApiUrl + '&url=' + formular_link, function (response) {
            __this.bindFormular(response, itemInfElement);
        });

        itemElement.appendChild(itemInfElement);
        this.element.appendChild(itemElement);

    };

    FxxlWunschArtikelFormular.prototype.bindFormular = function bindFormular(response, element)
    {
        var formularContainer = document.createElement('div'),
            $form,
            __this = this;
        formularContainer.classList.add(this.formularContainerClass);
        formularContainer.innerHTML = response.data;
        element.appendChild(formularContainer);

        $(element).find('.js-fxxl-wunschartikel_artikel_nr').each(function () {
            $(this).val(__this.artikelNr);
        });
        $(element).find('.js-fxxl-wunschartikel_product_description').each(function () {
            $(this).val(__this.productDescription);
        });
        $(element).find('.js-fxxl-wunschartikel_product_farbe').each(function () {
             $(this).val(__this.productFarbe);
        });
        $(element).find('.js-fxxl-wunschartikel_product_rahmenhoehe').each(function () {
             $(this).val(__this.productRahmenhoehe);
        });
        $(element).find('.js-fxxl-wunschartikel_product_rahmenform').each(function () {
             $(this).val(__this.productRahmenform);
        });
        $(element).find('.js-fxxl-wunschartikel_branch_name').each(function () {
            $(this).val(__this.branchName);
        });

        $(element).find('.fxxl-text-input__text, .fxxl-textarea__text').not('[type="radio"],select').each(function () {
            new FxxlTextInputs($(this));
        });

        /**
         * Select form
         */
        $(element).find('.fxxl-select').each(function () {
            new FxxlSelectForm($(this));
        });
        /**
         * Rewrite FxxlWunschArtikelFormular
         */
        $form = $(element).find('form.dynamicForm');
        if ($form.length > 0) {
            this.rewriteFxxlWunschArtikelFormular($form);
        }
    };

    FxxlWunschArtikelFormular.prototype.rewriteFxxlWunschArtikelFormular = function rewriteFxxlWunschArtikelFormular(form)
    {
        var validity,
            recaptchaElement =  $(form).find('.js-fxxl-recaptcha-token'),
            fxxlCaptchaElement =  $(form).find('.js-fxxl-captcha-solution'),
            submitFunction;
        if (recaptchaElement.length > 0) {
            if (typeof (reCaptchaPublicKey) !== 'undefined' && typeof (grecaptcha) !== 'undefined') {
                grecaptcha.ready(function () {
                    new FxxlReCaptchaGetToken(recaptchaElement[0]);
                });
            }
        }

        form.on('submit', function () {
            validity = checkValidityOfRewrittenFormular(form);
            if (validity === true) {
                submitFunction = () => {
                    $.ajax({
                        url: $(this).prop('action'),
                        data: $(this).serialize(),
                        method: 'POST',
                        success: function () {
                            $('.modal.open').modal('close');
                            hideSpinner();
                            if (recaptchaElement.length > 0) {
                                new FxxlReCaptchaGetToken(recaptchaElement[0], function () {
                                    M.toast({
                                        html: et.data.fxxlWunschArtikelFormularWithSuccess,
                                        classes: 'fxxl-toast fxxl-toast--success'
                                    });
                                }).setToken();
                            } else if (fxxlCaptchaElement.length > 0) {
                                M.toast({
                                    html: et.data.fxxlWunschArtikelFormularWithSuccess,
                                    classes: 'fxxl-toast fxxl-toast--success'
                                });
                            } else {
                                M.toast({
                                    html: et.data.fxxlWunschArtikelFormularFailed,
                                    classes: 'fxxl-toast fxxl-toast--error'
                                });
                            }
                        }
                    });
                };

                if (fxxlCaptchaElement.length > 0) {
                    new FxxlSetupCaptcha(fxxlCaptchaElement[0], submitFunction);
                } else {
                    submitFunction();
                }
            }

            return false;
        });
    }

    return FxxlWunschArtikelFormular;
}();
function saveAndLoadForm() {

    if (etJS_getCookie('fxxl_optional_cookies') !== 'true') {
        if (window.localStorage.hasOwnProperty('saveForm')) {
            window.localStorage.removeItem('saveForm');
        }
    }

    let cacheFormName = [];
    let dynamicForm;
    const dynamicFormObserver = new MutationObserver( function( mutations, observer ) {

        dynamicForm = $('form.dynamicForm');
        if (dynamicForm.length) {
            dynamicForm.each(function() {

                let form = $(this);
                let formName = form.attr('name');
                if (cacheFormName.indexOf(formName) === -1 ) {
                    cacheFormName.push(formName);
                    loadAndSaveDataForm(form);
                    form.on('submit', function() {
                        deleteFormFromLocalStorage(formName);
                    })
                }
            });
        } else {
            cacheFormName = [];
        }
    });

    dynamicFormObserver.observe( document, {
        childList: true,
        subtree: true,
    });

    let ratingForm = $('form.fxxl-element-rating-form__form');
    if (ratingForm.length) {
        loadAndSaveDataForm(ratingForm);
    }
}

function getSaveForm()
{
    let saveForm = {}
    try {
        if (window.localStorage.hasOwnProperty('saveForm')) {
            saveForm = JSON.parse(window.localStorage.getItem('saveForm'));
        }
    } catch (error) {}

    return saveForm;
}

function deleteFormFromLocalStorage(formName)
{
    let saveForm = getSaveForm();
    if (saveForm instanceof Object) {
        delete saveForm[formName];
        window.localStorage.setItem('saveForm', JSON.stringify(saveForm));
    }
}

function loadAndSaveDataForm(form)
{
    let formName = form.attr('name');
    if (formName) {
        let saveForm = getSaveForm();
        if (saveForm instanceof Object && saveForm.hasOwnProperty(formName)) {
            let formFields = saveForm[formName];
            if (formFields instanceof Array) {
                formFields.forEach(function(item) {
                    if (item['value'] !== '') {
                        let field = form.find('[name="' + item['name'] + '"]');
                        if (field.length) {
                            if (item['name'] === 'main_stars') {
                                let mainStars = field.filter('[value="' + item['value'] + '"]');
                                if (mainStars.length) {
                                    mainStars.click();
                                }
                            } else {
                                field.val(item['value'])
                                if (field.is('select')) {
                                    let label = field.closest('.fxxl-select-field').find('.fxxl-select-field_label')
                                    label.addClass('fxxl-select-field_label_active');
                                } else {
                                    field.change();
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    // nur einmal das Event 'change' an das Element hängen
    let fields = form.find('input[type!="file"], select, textarea').not('[name^="privacyrule"]');
    if (fields.length) {
        let firstField = fields.first();
        if (!firstField.data('hasChangeEvent')) {
            fields.on('change', saveValues).data('hasChangeEvent', true);

        }
    }
}

function saveValues()
{
    let form = $(this).closest('form');
    if (form.length) {
        let formName = form.attr('name');
        if (formName !== undefined) {
            let saveForm = getSaveForm();
            if (saveForm instanceof Object) {
                saveForm[formName] = form.find(':not([type="hidden"])').serializeArray();
                window.localStorage.setItem('saveForm', JSON.stringify(saveForm));
            }
        }
    }
}

// General
FxxlCore.externalUseableObject('rot47', rot47);
FxxlCore.externalUseableObject('getParameterByName', new FxxlCore().getParameterByName);
FxxlCore.externalUseableObject('initRatenkaufTable', initRatenkaufTable);
FxxlCore.externalUseableObject('isLargeViewport', isLargeViewport);
FxxlCore.externalUseableObject('FxxlElementVersionControl', FxxlElementVersionControl);
FxxlCore.externalUseableObject('FxxlTouchSlider', FxxlTouchSlider);
FxxlCore.externalUseableObject('FxxlResizedEvent', FxxlResizedEvent);
FxxlCore.externalUseableObject('getURLParam', getURLParam);
FxxlCore.externalUseableObject('fxxlSetInitialComparisonWidgetCounter', fxxlSetInitialComparisonWidgetCounter);
FxxlCore.externalUseableObject('FxxlWishlist', FxxlWishlist);
FxxlCore.externalUseableObject('FxxlSelectForm', FxxlSelectForm);
FxxlCore.externalUseableObject('FxxlElementProduct', FxxlElementProduct);
FxxlCore.externalUseableObject('FxxlTextInputs', FxxlTextInputs);
FxxlCore.externalUseableObject('FxxlSmoothGoToScrollPosition', FxxlSmoothGoToScrollPosition);
FxxlCore.externalUseableObject('setBranchFilterCookie', setBranchFilterCookie);
FxxlCore.externalUseableObject('FxxlTouchScroller', FxxlTouchScroller);
FxxlCore.externalUseableObject('fxxlRemoveURLParameter', fxxlRemoveURLParameter);
FxxlCore.externalUseableObject('fxxlGetAJAXContent', fxxlGetAJAXContent);
FxxlCore.externalUseableObject('fxxlActiveValidationTest', fxxlActiveValidationTest);
FxxlCore.externalUseableObject('FxxlReadMore', FxxlReadMore);
FxxlCore.externalUseableObject('openYoutubeModal', openYoutubeModal);
FxxlCore.externalUseableObject('FxxlCompare', FxxlCompare);
FxxlCore.externalUseableObject('setBadgeContent', setBadgeContent);
FxxlCore.externalUseableObject('initArtikelProbefahrt', initArtikelProbefahrt);
FxxlCore.externalUseableObject('fxxlDecodeURI', fxxlDecodeURI);
FxxlCore.externalUseableObject('loadAndSaveDataForm', loadAndSaveDataForm);
FxxlCore.externalUseableObject('showSpinner', showSpinner);
FxxlCore.externalUseableObject('hideSpinner', hideSpinner);
FxxlCore.externalUseableObject('FxxlFormValidation', FxxlFormValidation);
FxxlCore.externalUseableObject('FxxlAutoScrollToSelectedTab', FxxlAutoScrollToSelectedTab);
FxxlCore.externalUseableObject('fxxlGetBranchTimes', fxxlGetBranchTimes);
FxxlCore.externalUseableObject('fxxlHideGuuruChatBySelectModal', fxxlHideGuuruChatBySelectModal);
FxxlCore.externalUseableObject('fxxlHideSupportWidgetBySelectModal', fxxlHideSupportWidgetBySelectModal);
FxxlCore.externalUseableObject('fxxlHideScrollToTop', fxxlHideScrollToTop);
FxxlCore.externalUseableObject('fxxlGoBack', fxxlGoBack);
FxxlCore.externalUseableObject('FxxlSetupNextPrevButton', FxxlSetupNextPrevButton);
FxxlCore.externalUseableObject('fxxlShowScrollToTop', fxxlShowScrollToTop);
FxxlCore.externalUseableObject('fxxlPrintElement', fxxlPrintElement);
FxxlCore.externalUseableObject('fxxlCopyTextToClipboard', fxxlCopyTextToClipboard);
FxxlCore.externalUseableObject('disableTzbButtonInfo', disableTzbButtonInfo);
FxxlCore.externalUseableObject('fxxlHeaderNotificationClose', fxxlHeaderNotificationClose);
FxxlCore.externalUseableObject('FxxlSetupSlider2', FxxlSetupSlider2);
FxxlCore.externalUseableObject('setupFxxlSideModal', setupFxxlSideModal);
FxxlCore.externalUseableObject('FxxlSmoothScrollToElement', FxxlSmoothScrollToElement);
FxxlCore.externalUseableObject('FXXLIsElementVisible', FXXLIsElementVisible);
FxxlCore.externalUseableObject('FxxlNewsletterPopup', FxxlNewsletterPopup);

// Map
FxxlCore.externalUseableObject('initMap', initMap);

// jQuery
FxxlCore.externalUseableObject('jQuery', jQuery);
FxxlCore.externalUseableObject('$', jQuery);

// GTM
FxxlCore.externalUseableObject('gtm', gtm);
FxxlCore.externalUseableObject('FxxlGTM', FxxlGTM);
FxxlCore.externalUseableObject('etJS_getCookie', etJS_getCookie);
FxxlCore.externalUseableObject('etJS_empty', etJS_empty);
FxxlCore.externalUseableObject('etJS_setCookie', etJS_setCookie);
FxxlCore.externalUseableObject('gtmVisibleTzb', gtmVisibleTzb);

// Search
FxxlCore.externalUseableObject('fxxShowMainSearch', fxxShowMainSearch);
FxxlCore.externalUseableObject('fxxHideMainSearch', fxxHideMainSearch);

// PDS
FxxlCore.externalUseableObject('initElementRatingForm', initElementRatingForm);
FxxlCore.externalUseableObject('setProbefahrtMatrixInfo', setProbefahrtMatrixInfo);
FxxlCore.externalUseableObject('FxxlRatenRechnerData', FxxlRatenRechnerData);
FxxlCore.externalUseableObject('fxxlBranchInventoryMapInit', fxxlBranchInventoryMapInit);

// Map
FxxlCore.externalUseableObject('initMap', initMap);
FxxlCore.externalUseableObject('fxxlBranchMap', fxxlBranchMap);
FxxlCore.externalUseableObject('fxxlBranchMapLoadedFunction', fxxlBranchMapLoadedFunction);
FxxlCore.externalUseableObject('loadBranchMap', loadBranchMap);
FxxlCore.externalUseableObject('fxxlBranchSetAllMakersIcon', fxxlBranchSetAllMakersIcon);
